var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __publicField = (obj, key2, value) => {
  __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
  return value;
};
import { Comment, Fragment, Text, isVNode, defineComponent, reactive, getCurrentInstance, onMounted, onUpdated, onUnmounted, watch, inject, computed, unref, createVNode, provide, Transition, Teleport, ref, TransitionGroup, render, h as h$1, nextTick, watchEffect, withDirectives, resolveDirective, onBeforeUnmount, cloneVNode, toRef, withModifiers, vShow, onBeforeMount, createTextVNode, isRef, toRefs, shallowRef, toRaw, mergeProps, resolveComponent, openBlock, createBlock, withCtx, createElementBlock, renderList, createCommentVNode, createElementVNode, toDisplayString, renderSlot, createApp } from "vue";
import { filenameSuffix } from "@yunxi/helper";
var antDesign = "";
const CodeToText = {
  11e4: "\u5317\u4EAC\u5E02",
  110100: "\u5317\u4EAC\u5E02",
  110101: "\u4E1C\u57CE\u533A",
  110102: "\u897F\u57CE\u533A",
  110105: "\u671D\u9633\u533A",
  110106: "\u4E30\u53F0\u533A",
  110107: "\u77F3\u666F\u5C71\u533A",
  110108: "\u6D77\u6DC0\u533A",
  110109: "\u95E8\u5934\u6C9F\u533A",
  110111: "\u623F\u5C71\u533A",
  110112: "\u901A\u5DDE\u533A",
  110113: "\u987A\u4E49\u533A",
  110114: "\u660C\u5E73\u533A",
  110115: "\u5927\u5174\u533A",
  110116: "\u6000\u67D4\u533A",
  110117: "\u5E73\u8C37\u533A",
  110118: "\u5BC6\u4E91\u533A",
  110119: "\u5EF6\u5E86\u533A",
  12e4: "\u5929\u6D25\u5E02",
  120100: "\u5929\u6D25\u5E02",
  120101: "\u548C\u5E73\u533A",
  120102: "\u6CB3\u4E1C\u533A",
  120103: "\u6CB3\u897F\u533A",
  120104: "\u5357\u5F00\u533A",
  120105: "\u6CB3\u5317\u533A",
  120106: "\u7EA2\u6865\u533A",
  120110: "\u4E1C\u4E3D\u533A",
  120111: "\u897F\u9752\u533A",
  120112: "\u6D25\u5357\u533A",
  120113: "\u5317\u8FB0\u533A",
  120114: "\u6B66\u6E05\u533A",
  120115: "\u5B9D\u577B\u533A",
  120116: "\u6EE8\u6D77\u65B0\u533A",
  120117: "\u5B81\u6CB3\u533A",
  120118: "\u9759\u6D77\u533A",
  120119: "\u84DF\u5DDE\u533A",
  13e4: "\u6CB3\u5317\u7701",
  130100: "\u77F3\u5BB6\u5E84\u5E02",
  130101: "\u5E02\u8F96\u533A",
  130102: "\u957F\u5B89\u533A",
  130104: "\u6865\u897F\u533A",
  130105: "\u65B0\u534E\u533A",
  130107: "\u4E95\u9649\u77FF\u533A",
  130108: "\u88D5\u534E\u533A",
  130109: "\u85C1\u57CE\u533A",
  130110: "\u9E7F\u6CC9\u533A",
  130111: "\u683E\u57CE\u533A",
  130121: "\u4E95\u9649\u53BF",
  130123: "\u6B63\u5B9A\u53BF",
  130125: "\u884C\u5510\u53BF",
  130126: "\u7075\u5BFF\u53BF",
  130127: "\u9AD8\u9091\u53BF",
  130128: "\u6DF1\u6CFD\u53BF",
  130129: "\u8D5E\u7687\u53BF",
  130130: "\u65E0\u6781\u53BF",
  130131: "\u5E73\u5C71\u53BF",
  130132: "\u5143\u6C0F\u53BF",
  130133: "\u8D75\u53BF",
  130171: "\u77F3\u5BB6\u5E84\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  130172: "\u77F3\u5BB6\u5E84\u5FAA\u73AF\u5316\u5DE5\u56ED\u533A",
  130181: "\u8F9B\u96C6\u5E02",
  130183: "\u664B\u5DDE\u5E02",
  130184: "\u65B0\u4E50\u5E02",
  130200: "\u5510\u5C71\u5E02",
  130201: "\u5E02\u8F96\u533A",
  130202: "\u8DEF\u5357\u533A",
  130203: "\u8DEF\u5317\u533A",
  130204: "\u53E4\u51B6\u533A",
  130205: "\u5F00\u5E73\u533A",
  130207: "\u4E30\u5357\u533A",
  130208: "\u4E30\u6DA6\u533A",
  130209: "\u66F9\u5983\u7538\u533A",
  130224: "\u6EE6\u5357\u53BF",
  130225: "\u4E50\u4EAD\u53BF",
  130227: "\u8FC1\u897F\u53BF",
  130229: "\u7389\u7530\u53BF",
  130271: "\u6CB3\u5317\u5510\u5C71\u82A6\u53F0\u7ECF\u6D4E\u5F00\u53D1\u533A",
  130272: "\u5510\u5C71\u5E02\u6C49\u6CBD\u7BA1\u7406\u533A",
  130273: "\u5510\u5C71\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  130274: "\u6CB3\u5317\u5510\u5C71\u6D77\u6E2F\u7ECF\u6D4E\u5F00\u53D1\u533A",
  130281: "\u9075\u5316\u5E02",
  130283: "\u8FC1\u5B89\u5E02",
  130284: "\u6EE6\u5DDE\u5E02",
  130300: "\u79E6\u7687\u5C9B\u5E02",
  130301: "\u5E02\u8F96\u533A",
  130302: "\u6D77\u6E2F\u533A",
  130303: "\u5C71\u6D77\u5173\u533A",
  130304: "\u5317\u6234\u6CB3\u533A",
  130306: "\u629A\u5B81\u533A",
  130321: "\u9752\u9F99\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  130322: "\u660C\u9ECE\u53BF",
  130324: "\u5362\u9F99\u53BF",
  130371: "\u79E6\u7687\u5C9B\u5E02\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  130372: "\u5317\u6234\u6CB3\u65B0\u533A",
  130400: "\u90AF\u90F8\u5E02",
  130401: "\u5E02\u8F96\u533A",
  130402: "\u90AF\u5C71\u533A",
  130403: "\u4E1B\u53F0\u533A",
  130404: "\u590D\u5174\u533A",
  130406: "\u5CF0\u5CF0\u77FF\u533A",
  130407: "\u80A5\u4E61\u533A",
  130408: "\u6C38\u5E74\u533A",
  130423: "\u4E34\u6F33\u53BF",
  130424: "\u6210\u5B89\u53BF",
  130425: "\u5927\u540D\u53BF",
  130426: "\u6D89\u53BF",
  130427: "\u78C1\u53BF",
  130430: "\u90B1\u53BF",
  130431: "\u9E21\u6CFD\u53BF",
  130432: "\u5E7F\u5E73\u53BF",
  130433: "\u9986\u9676\u53BF",
  130434: "\u9B4F\u53BF",
  130435: "\u66F2\u5468\u53BF",
  130471: "\u90AF\u90F8\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  130473: "\u90AF\u90F8\u5180\u5357\u65B0\u533A",
  130481: "\u6B66\u5B89\u5E02",
  130500: "\u90A2\u53F0\u5E02",
  130501: "\u5E02\u8F96\u533A",
  130502: "\u6865\u4E1C\u533A",
  130503: "\u6865\u897F\u533A",
  130521: "\u90A2\u53F0\u53BF",
  130522: "\u4E34\u57CE\u53BF",
  130523: "\u5185\u4E18\u53BF",
  130524: "\u67CF\u4E61\u53BF",
  130525: "\u9686\u5C27\u53BF",
  130526: "\u4EFB\u53BF",
  130527: "\u5357\u548C\u53BF",
  130528: "\u5B81\u664B\u53BF",
  130529: "\u5DE8\u9E7F\u53BF",
  130530: "\u65B0\u6CB3\u53BF",
  130531: "\u5E7F\u5B97\u53BF",
  130532: "\u5E73\u4E61\u53BF",
  130533: "\u5A01\u53BF",
  130534: "\u6E05\u6CB3\u53BF",
  130535: "\u4E34\u897F\u53BF",
  130571: "\u6CB3\u5317\u90A2\u53F0\u7ECF\u6D4E\u5F00\u53D1\u533A",
  130581: "\u5357\u5BAB\u5E02",
  130582: "\u6C99\u6CB3\u5E02",
  130600: "\u4FDD\u5B9A\u5E02",
  130601: "\u5E02\u8F96\u533A",
  130602: "\u7ADE\u79C0\u533A",
  130606: "\u83B2\u6C60\u533A",
  130607: "\u6EE1\u57CE\u533A",
  130608: "\u6E05\u82D1\u533A",
  130609: "\u5F90\u6C34\u533A",
  130623: "\u6D9E\u6C34\u53BF",
  130624: "\u961C\u5E73\u53BF",
  130626: "\u5B9A\u5174\u53BF",
  130627: "\u5510\u53BF",
  130628: "\u9AD8\u9633\u53BF",
  130629: "\u5BB9\u57CE\u53BF",
  130630: "\u6D9E\u6E90\u53BF",
  130631: "\u671B\u90FD\u53BF",
  130632: "\u5B89\u65B0\u53BF",
  130633: "\u6613\u53BF",
  130634: "\u66F2\u9633\u53BF",
  130635: "\u8821\u53BF",
  130636: "\u987A\u5E73\u53BF",
  130637: "\u535A\u91CE\u53BF",
  130638: "\u96C4\u53BF",
  130671: "\u4FDD\u5B9A\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  130672: "\u4FDD\u5B9A\u767D\u6C9F\u65B0\u57CE",
  130681: "\u6DBF\u5DDE\u5E02",
  130682: "\u5B9A\u5DDE\u5E02",
  130683: "\u5B89\u56FD\u5E02",
  130684: "\u9AD8\u7891\u5E97\u5E02",
  130700: "\u5F20\u5BB6\u53E3\u5E02",
  130701: "\u5E02\u8F96\u533A",
  130702: "\u6865\u4E1C\u533A",
  130703: "\u6865\u897F\u533A",
  130705: "\u5BA3\u5316\u533A",
  130706: "\u4E0B\u82B1\u56ED\u533A",
  130708: "\u4E07\u5168\u533A",
  130709: "\u5D07\u793C\u533A",
  130722: "\u5F20\u5317\u53BF",
  130723: "\u5EB7\u4FDD\u53BF",
  130724: "\u6CBD\u6E90\u53BF",
  130725: "\u5C1A\u4E49\u53BF",
  130726: "\u851A\u53BF",
  130727: "\u9633\u539F\u53BF",
  130728: "\u6000\u5B89\u53BF",
  130730: "\u6000\u6765\u53BF",
  130731: "\u6DBF\u9E7F\u53BF",
  130732: "\u8D64\u57CE\u53BF",
  130771: "\u5F20\u5BB6\u53E3\u7ECF\u6D4E\u5F00\u53D1\u533A",
  130772: "\u5F20\u5BB6\u53E3\u5E02\u5BDF\u5317\u7BA1\u7406\u533A",
  130773: "\u5F20\u5BB6\u53E3\u5E02\u585E\u5317\u7BA1\u7406\u533A",
  130800: "\u627F\u5FB7\u5E02",
  130801: "\u5E02\u8F96\u533A",
  130802: "\u53CC\u6865\u533A",
  130803: "\u53CC\u6EE6\u533A",
  130804: "\u9E70\u624B\u8425\u5B50\u77FF\u533A",
  130821: "\u627F\u5FB7\u53BF",
  130822: "\u5174\u9686\u53BF",
  130824: "\u6EE6\u5E73\u53BF",
  130825: "\u9686\u5316\u53BF",
  130826: "\u4E30\u5B81\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  130827: "\u5BBD\u57CE\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  130828: "\u56F4\u573A\u6EE1\u65CF\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  130871: "\u627F\u5FB7\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  130881: "\u5E73\u6CC9\u5E02",
  130900: "\u6CA7\u5DDE\u5E02",
  130901: "\u5E02\u8F96\u533A",
  130902: "\u65B0\u534E\u533A",
  130903: "\u8FD0\u6CB3\u533A",
  130921: "\u6CA7\u53BF",
  130922: "\u9752\u53BF",
  130923: "\u4E1C\u5149\u53BF",
  130924: "\u6D77\u5174\u53BF",
  130925: "\u76D0\u5C71\u53BF",
  130926: "\u8083\u5B81\u53BF",
  130927: "\u5357\u76AE\u53BF",
  130928: "\u5434\u6865\u53BF",
  130929: "\u732E\u53BF",
  130930: "\u5B5F\u6751\u56DE\u65CF\u81EA\u6CBB\u53BF",
  130971: "\u6CB3\u5317\u6CA7\u5DDE\u7ECF\u6D4E\u5F00\u53D1\u533A",
  130972: "\u6CA7\u5DDE\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  130973: "\u6CA7\u5DDE\u6E24\u6D77\u65B0\u533A",
  130981: "\u6CCA\u5934\u5E02",
  130982: "\u4EFB\u4E18\u5E02",
  130983: "\u9EC4\u9A85\u5E02",
  130984: "\u6CB3\u95F4\u5E02",
  131e3: "\u5ECA\u574A\u5E02",
  131001: "\u5E02\u8F96\u533A",
  131002: "\u5B89\u6B21\u533A",
  131003: "\u5E7F\u9633\u533A",
  131022: "\u56FA\u5B89\u53BF",
  131023: "\u6C38\u6E05\u53BF",
  131024: "\u9999\u6CB3\u53BF",
  131025: "\u5927\u57CE\u53BF",
  131026: "\u6587\u5B89\u53BF",
  131028: "\u5927\u5382\u56DE\u65CF\u81EA\u6CBB\u53BF",
  131071: "\u5ECA\u574A\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  131081: "\u9738\u5DDE\u5E02",
  131082: "\u4E09\u6CB3\u5E02",
  131100: "\u8861\u6C34\u5E02",
  131101: "\u5E02\u8F96\u533A",
  131102: "\u6843\u57CE\u533A",
  131103: "\u5180\u5DDE\u533A",
  131121: "\u67A3\u5F3A\u53BF",
  131122: "\u6B66\u9091\u53BF",
  131123: "\u6B66\u5F3A\u53BF",
  131124: "\u9976\u9633\u53BF",
  131125: "\u5B89\u5E73\u53BF",
  131126: "\u6545\u57CE\u53BF",
  131127: "\u666F\u53BF",
  131128: "\u961C\u57CE\u53BF",
  131171: "\u6CB3\u5317\u8861\u6C34\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  131172: "\u8861\u6C34\u6EE8\u6E56\u65B0\u533A",
  131182: "\u6DF1\u5DDE\u5E02",
  14e4: "\u5C71\u897F\u7701",
  140100: "\u592A\u539F\u5E02",
  140101: "\u5E02\u8F96\u533A",
  140105: "\u5C0F\u5E97\u533A",
  140106: "\u8FCE\u6CFD\u533A",
  140107: "\u674F\u82B1\u5CAD\u533A",
  140108: "\u5C16\u8349\u576A\u533A",
  140109: "\u4E07\u67CF\u6797\u533A",
  140110: "\u664B\u6E90\u533A",
  140121: "\u6E05\u5F90\u53BF",
  140122: "\u9633\u66F2\u53BF",
  140123: "\u5A04\u70E6\u53BF",
  140171: "\u5C71\u897F\u8F6C\u578B\u7EFC\u5408\u6539\u9769\u793A\u8303\u533A",
  140181: "\u53E4\u4EA4\u5E02",
  140200: "\u5927\u540C\u5E02",
  140201: "\u5E02\u8F96\u533A",
  140212: "\u65B0\u8363\u533A",
  140213: "\u5E73\u57CE\u533A",
  140214: "\u4E91\u5188\u533A",
  140215: "\u4E91\u5DDE\u533A",
  140221: "\u9633\u9AD8\u53BF",
  140222: "\u5929\u9547\u53BF",
  140223: "\u5E7F\u7075\u53BF",
  140224: "\u7075\u4E18\u53BF",
  140225: "\u6D51\u6E90\u53BF",
  140226: "\u5DE6\u4E91\u53BF",
  140271: "\u5C71\u897F\u5927\u540C\u7ECF\u6D4E\u5F00\u53D1\u533A",
  140300: "\u9633\u6CC9\u5E02",
  140301: "\u5E02\u8F96\u533A",
  140302: "\u57CE\u533A",
  140303: "\u77FF\u533A",
  140311: "\u90CA\u533A",
  140321: "\u5E73\u5B9A\u53BF",
  140322: "\u76C2\u53BF",
  140400: "\u957F\u6CBB\u5E02",
  140401: "\u5E02\u8F96\u533A",
  140403: "\u6F5E\u5DDE\u533A",
  140404: "\u4E0A\u515A\u533A",
  140405: "\u5C6F\u7559\u533A",
  140406: "\u6F5E\u57CE\u533A",
  140423: "\u8944\u57A3\u53BF",
  140425: "\u5E73\u987A\u53BF",
  140426: "\u9ECE\u57CE\u53BF",
  140427: "\u58F6\u5173\u53BF",
  140428: "\u957F\u5B50\u53BF",
  140429: "\u6B66\u4E61\u53BF",
  140430: "\u6C81\u53BF",
  140431: "\u6C81\u6E90\u53BF",
  140471: "\u5C71\u897F\u957F\u6CBB\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A",
  140500: "\u664B\u57CE\u5E02",
  140501: "\u5E02\u8F96\u533A",
  140502: "\u57CE\u533A",
  140521: "\u6C81\u6C34\u53BF",
  140522: "\u9633\u57CE\u53BF",
  140524: "\u9675\u5DDD\u53BF",
  140525: "\u6CFD\u5DDE\u53BF",
  140581: "\u9AD8\u5E73\u5E02",
  140600: "\u6714\u5DDE\u5E02",
  140601: "\u5E02\u8F96\u533A",
  140602: "\u6714\u57CE\u533A",
  140603: "\u5E73\u9C81\u533A",
  140621: "\u5C71\u9634\u53BF",
  140622: "\u5E94\u53BF",
  140623: "\u53F3\u7389\u53BF",
  140671: "\u5C71\u897F\u6714\u5DDE\u7ECF\u6D4E\u5F00\u53D1\u533A",
  140681: "\u6000\u4EC1\u5E02",
  140700: "\u664B\u4E2D\u5E02",
  140701: "\u5E02\u8F96\u533A",
  140702: "\u6986\u6B21\u533A",
  140721: "\u6986\u793E\u53BF",
  140722: "\u5DE6\u6743\u53BF",
  140723: "\u548C\u987A\u53BF",
  140724: "\u6614\u9633\u53BF",
  140725: "\u5BFF\u9633\u53BF",
  140726: "\u592A\u8C37\u53BF",
  140727: "\u7941\u53BF",
  140728: "\u5E73\u9065\u53BF",
  140729: "\u7075\u77F3\u53BF",
  140781: "\u4ECB\u4F11\u5E02",
  140800: "\u8FD0\u57CE\u5E02",
  140801: "\u5E02\u8F96\u533A",
  140802: "\u76D0\u6E56\u533A",
  140821: "\u4E34\u7317\u53BF",
  140822: "\u4E07\u8363\u53BF",
  140823: "\u95FB\u559C\u53BF",
  140824: "\u7A37\u5C71\u53BF",
  140825: "\u65B0\u7EDB\u53BF",
  140826: "\u7EDB\u53BF",
  140827: "\u57A3\u66F2\u53BF",
  140828: "\u590F\u53BF",
  140829: "\u5E73\u9646\u53BF",
  140830: "\u82AE\u57CE\u53BF",
  140881: "\u6C38\u6D4E\u5E02",
  140882: "\u6CB3\u6D25\u5E02",
  140900: "\u5FFB\u5DDE\u5E02",
  140901: "\u5E02\u8F96\u533A",
  140902: "\u5FFB\u5E9C\u533A",
  140921: "\u5B9A\u8944\u53BF",
  140922: "\u4E94\u53F0\u53BF",
  140923: "\u4EE3\u53BF",
  140924: "\u7E41\u5CD9\u53BF",
  140925: "\u5B81\u6B66\u53BF",
  140926: "\u9759\u4E50\u53BF",
  140927: "\u795E\u6C60\u53BF",
  140928: "\u4E94\u5BE8\u53BF",
  140929: "\u5CA2\u5C9A\u53BF",
  140930: "\u6CB3\u66F2\u53BF",
  140931: "\u4FDD\u5FB7\u53BF",
  140932: "\u504F\u5173\u53BF",
  140971: "\u4E94\u53F0\u5C71\u98CE\u666F\u540D\u80DC\u533A",
  140981: "\u539F\u5E73\u5E02",
  141e3: "\u4E34\u6C7E\u5E02",
  141001: "\u5E02\u8F96\u533A",
  141002: "\u5C27\u90FD\u533A",
  141021: "\u66F2\u6C83\u53BF",
  141022: "\u7FFC\u57CE\u53BF",
  141023: "\u8944\u6C7E\u53BF",
  141024: "\u6D2A\u6D1E\u53BF",
  141025: "\u53E4\u53BF",
  141026: "\u5B89\u6CFD\u53BF",
  141027: "\u6D6E\u5C71\u53BF",
  141028: "\u5409\u53BF",
  141029: "\u4E61\u5B81\u53BF",
  141030: "\u5927\u5B81\u53BF",
  141031: "\u96B0\u53BF",
  141032: "\u6C38\u548C\u53BF",
  141033: "\u84B2\u53BF",
  141034: "\u6C7E\u897F\u53BF",
  141081: "\u4FAF\u9A6C\u5E02",
  141082: "\u970D\u5DDE\u5E02",
  141100: "\u5415\u6881\u5E02",
  141101: "\u5E02\u8F96\u533A",
  141102: "\u79BB\u77F3\u533A",
  141121: "\u6587\u6C34\u53BF",
  141122: "\u4EA4\u57CE\u53BF",
  141123: "\u5174\u53BF",
  141124: "\u4E34\u53BF",
  141125: "\u67F3\u6797\u53BF",
  141126: "\u77F3\u697C\u53BF",
  141127: "\u5C9A\u53BF",
  141128: "\u65B9\u5C71\u53BF",
  141129: "\u4E2D\u9633\u53BF",
  141130: "\u4EA4\u53E3\u53BF",
  141181: "\u5B5D\u4E49\u5E02",
  141182: "\u6C7E\u9633\u5E02",
  15e4: "\u5185\u8499\u53E4\u81EA\u6CBB\u533A",
  150100: "\u547C\u548C\u6D69\u7279\u5E02",
  150101: "\u5E02\u8F96\u533A",
  150102: "\u65B0\u57CE\u533A",
  150103: "\u56DE\u6C11\u533A",
  150104: "\u7389\u6CC9\u533A",
  150105: "\u8D5B\u7F55\u533A",
  150121: "\u571F\u9ED8\u7279\u5DE6\u65D7",
  150122: "\u6258\u514B\u6258\u53BF",
  150123: "\u548C\u6797\u683C\u5C14\u53BF",
  150124: "\u6E05\u6C34\u6CB3\u53BF",
  150125: "\u6B66\u5DDD\u53BF",
  150171: "\u547C\u548C\u6D69\u7279\u91D1\u6D77\u5DE5\u4E1A\u56ED\u533A",
  150172: "\u547C\u548C\u6D69\u7279\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  150200: "\u5305\u5934\u5E02",
  150201: "\u5E02\u8F96\u533A",
  150202: "\u4E1C\u6CB3\u533A",
  150203: "\u6606\u90FD\u4ED1\u533A",
  150204: "\u9752\u5C71\u533A",
  150205: "\u77F3\u62D0\u533A",
  150206: "\u767D\u4E91\u9102\u535A\u77FF\u533A",
  150207: "\u4E5D\u539F\u533A",
  150221: "\u571F\u9ED8\u7279\u53F3\u65D7",
  150222: "\u56FA\u9633\u53BF",
  150223: "\u8FBE\u5C14\u7F55\u8302\u660E\u5B89\u8054\u5408\u65D7",
  150271: "\u5305\u5934\u7A00\u571F\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  150300: "\u4E4C\u6D77\u5E02",
  150301: "\u5E02\u8F96\u533A",
  150302: "\u6D77\u52C3\u6E7E\u533A",
  150303: "\u6D77\u5357\u533A",
  150304: "\u4E4C\u8FBE\u533A",
  150400: "\u8D64\u5CF0\u5E02",
  150401: "\u5E02\u8F96\u533A",
  150402: "\u7EA2\u5C71\u533A",
  150403: "\u5143\u5B9D\u5C71\u533A",
  150404: "\u677E\u5C71\u533A",
  150421: "\u963F\u9C81\u79D1\u5C14\u6C81\u65D7",
  150422: "\u5DF4\u6797\u5DE6\u65D7",
  150423: "\u5DF4\u6797\u53F3\u65D7",
  150424: "\u6797\u897F\u53BF",
  150425: "\u514B\u4EC0\u514B\u817E\u65D7",
  150426: "\u7FC1\u725B\u7279\u65D7",
  150428: "\u5580\u5587\u6C81\u65D7",
  150429: "\u5B81\u57CE\u53BF",
  150430: "\u6556\u6C49\u65D7",
  150500: "\u901A\u8FBD\u5E02",
  150501: "\u5E02\u8F96\u533A",
  150502: "\u79D1\u5C14\u6C81\u533A",
  150521: "\u79D1\u5C14\u6C81\u5DE6\u7FFC\u4E2D\u65D7",
  150522: "\u79D1\u5C14\u6C81\u5DE6\u7FFC\u540E\u65D7",
  150523: "\u5F00\u9C81\u53BF",
  150524: "\u5E93\u4F26\u65D7",
  150525: "\u5948\u66FC\u65D7",
  150526: "\u624E\u9C81\u7279\u65D7",
  150571: "\u901A\u8FBD\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  150581: "\u970D\u6797\u90ED\u52D2\u5E02",
  150600: "\u9102\u5C14\u591A\u65AF\u5E02",
  150601: "\u5E02\u8F96\u533A",
  150602: "\u4E1C\u80DC\u533A",
  150603: "\u5EB7\u5DF4\u4EC0\u533A",
  150621: "\u8FBE\u62C9\u7279\u65D7",
  150622: "\u51C6\u683C\u5C14\u65D7",
  150623: "\u9102\u6258\u514B\u524D\u65D7",
  150624: "\u9102\u6258\u514B\u65D7",
  150625: "\u676D\u9526\u65D7",
  150626: "\u4E4C\u5BA1\u65D7",
  150627: "\u4F0A\u91D1\u970D\u6D1B\u65D7",
  150700: "\u547C\u4F26\u8D1D\u5C14\u5E02",
  150701: "\u5E02\u8F96\u533A",
  150702: "\u6D77\u62C9\u5C14\u533A",
  150703: "\u624E\u8D49\u8BFA\u5C14\u533A",
  150721: "\u963F\u8363\u65D7",
  150722: "\u83AB\u529B\u8FBE\u74E6\u8FBE\u65A1\u5C14\u65CF\u81EA\u6CBB\u65D7",
  150723: "\u9102\u4F26\u6625\u81EA\u6CBB\u65D7",
  150724: "\u9102\u6E29\u514B\u65CF\u81EA\u6CBB\u65D7",
  150725: "\u9648\u5DF4\u5C14\u864E\u65D7",
  150726: "\u65B0\u5DF4\u5C14\u864E\u5DE6\u65D7",
  150727: "\u65B0\u5DF4\u5C14\u864E\u53F3\u65D7",
  150781: "\u6EE1\u6D32\u91CC\u5E02",
  150782: "\u7259\u514B\u77F3\u5E02",
  150783: "\u624E\u5170\u5C6F\u5E02",
  150784: "\u989D\u5C14\u53E4\u7EB3\u5E02",
  150785: "\u6839\u6CB3\u5E02",
  150800: "\u5DF4\u5F66\u6DD6\u5C14\u5E02",
  150801: "\u5E02\u8F96\u533A",
  150802: "\u4E34\u6CB3\u533A",
  150821: "\u4E94\u539F\u53BF",
  150822: "\u78F4\u53E3\u53BF",
  150823: "\u4E4C\u62C9\u7279\u524D\u65D7",
  150824: "\u4E4C\u62C9\u7279\u4E2D\u65D7",
  150825: "\u4E4C\u62C9\u7279\u540E\u65D7",
  150826: "\u676D\u9526\u540E\u65D7",
  150900: "\u4E4C\u5170\u5BDF\u5E03\u5E02",
  150901: "\u5E02\u8F96\u533A",
  150902: "\u96C6\u5B81\u533A",
  150921: "\u5353\u8D44\u53BF",
  150922: "\u5316\u5FB7\u53BF",
  150923: "\u5546\u90FD\u53BF",
  150924: "\u5174\u548C\u53BF",
  150925: "\u51C9\u57CE\u53BF",
  150926: "\u5BDF\u54C8\u5C14\u53F3\u7FFC\u524D\u65D7",
  150927: "\u5BDF\u54C8\u5C14\u53F3\u7FFC\u4E2D\u65D7",
  150928: "\u5BDF\u54C8\u5C14\u53F3\u7FFC\u540E\u65D7",
  150929: "\u56DB\u5B50\u738B\u65D7",
  150981: "\u4E30\u9547\u5E02",
  152200: "\u5174\u5B89\u76DF",
  152201: "\u4E4C\u5170\u6D69\u7279\u5E02",
  152202: "\u963F\u5C14\u5C71\u5E02",
  152221: "\u79D1\u5C14\u6C81\u53F3\u7FFC\u524D\u65D7",
  152222: "\u79D1\u5C14\u6C81\u53F3\u7FFC\u4E2D\u65D7",
  152223: "\u624E\u8D49\u7279\u65D7",
  152224: "\u7A81\u6CC9\u53BF",
  152500: "\u9521\u6797\u90ED\u52D2\u76DF",
  152501: "\u4E8C\u8FDE\u6D69\u7279\u5E02",
  152502: "\u9521\u6797\u6D69\u7279\u5E02",
  152522: "\u963F\u5DF4\u560E\u65D7",
  152523: "\u82CF\u5C3C\u7279\u5DE6\u65D7",
  152524: "\u82CF\u5C3C\u7279\u53F3\u65D7",
  152525: "\u4E1C\u4E4C\u73E0\u7A46\u6C81\u65D7",
  152526: "\u897F\u4E4C\u73E0\u7A46\u6C81\u65D7",
  152527: "\u592A\u4EC6\u5BFA\u65D7",
  152528: "\u9576\u9EC4\u65D7",
  152529: "\u6B63\u9576\u767D\u65D7",
  152530: "\u6B63\u84DD\u65D7",
  152531: "\u591A\u4F26\u53BF",
  152571: "\u4E4C\u62C9\u76D6\u7BA1\u59D4\u4F1A",
  152900: "\u963F\u62C9\u5584\u76DF",
  152921: "\u963F\u62C9\u5584\u5DE6\u65D7",
  152922: "\u963F\u62C9\u5584\u53F3\u65D7",
  152923: "\u989D\u6D4E\u7EB3\u65D7",
  152971: "\u5185\u8499\u53E4\u963F\u62C9\u5584\u7ECF\u6D4E\u5F00\u53D1\u533A",
  21e4: "\u8FBD\u5B81\u7701",
  210100: "\u6C88\u9633\u5E02",
  210101: "\u5E02\u8F96\u533A",
  210102: "\u548C\u5E73\u533A",
  210103: "\u6C88\u6CB3\u533A",
  210104: "\u5927\u4E1C\u533A",
  210105: "\u7687\u59D1\u533A",
  210106: "\u94C1\u897F\u533A",
  210111: "\u82CF\u5BB6\u5C6F\u533A",
  210112: "\u6D51\u5357\u533A",
  210113: "\u6C88\u5317\u65B0\u533A",
  210114: "\u4E8E\u6D2A\u533A",
  210115: "\u8FBD\u4E2D\u533A",
  210123: "\u5EB7\u5E73\u53BF",
  210124: "\u6CD5\u5E93\u53BF",
  210181: "\u65B0\u6C11\u5E02",
  210200: "\u5927\u8FDE\u5E02",
  210201: "\u5E02\u8F96\u533A",
  210202: "\u4E2D\u5C71\u533A",
  210203: "\u897F\u5C97\u533A",
  210204: "\u6C99\u6CB3\u53E3\u533A",
  210211: "\u7518\u4E95\u5B50\u533A",
  210212: "\u65C5\u987A\u53E3\u533A",
  210213: "\u91D1\u5DDE\u533A",
  210214: "\u666E\u5170\u5E97\u533A",
  210224: "\u957F\u6D77\u53BF",
  210281: "\u74E6\u623F\u5E97\u5E02",
  210283: "\u5E84\u6CB3\u5E02",
  210300: "\u978D\u5C71\u5E02",
  210301: "\u5E02\u8F96\u533A",
  210302: "\u94C1\u4E1C\u533A",
  210303: "\u94C1\u897F\u533A",
  210304: "\u7ACB\u5C71\u533A",
  210311: "\u5343\u5C71\u533A",
  210321: "\u53F0\u5B89\u53BF",
  210323: "\u5CAB\u5CA9\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  210381: "\u6D77\u57CE\u5E02",
  210400: "\u629A\u987A\u5E02",
  210401: "\u5E02\u8F96\u533A",
  210402: "\u65B0\u629A\u533A",
  210403: "\u4E1C\u6D32\u533A",
  210404: "\u671B\u82B1\u533A",
  210411: "\u987A\u57CE\u533A",
  210421: "\u629A\u987A\u53BF",
  210422: "\u65B0\u5BBE\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  210423: "\u6E05\u539F\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  210500: "\u672C\u6EAA\u5E02",
  210501: "\u5E02\u8F96\u533A",
  210502: "\u5E73\u5C71\u533A",
  210503: "\u6EAA\u6E56\u533A",
  210504: "\u660E\u5C71\u533A",
  210505: "\u5357\u82AC\u533A",
  210521: "\u672C\u6EAA\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  210522: "\u6853\u4EC1\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  210600: "\u4E39\u4E1C\u5E02",
  210601: "\u5E02\u8F96\u533A",
  210602: "\u5143\u5B9D\u533A",
  210603: "\u632F\u5174\u533A",
  210604: "\u632F\u5B89\u533A",
  210624: "\u5BBD\u7538\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  210681: "\u4E1C\u6E2F\u5E02",
  210682: "\u51E4\u57CE\u5E02",
  210700: "\u9526\u5DDE\u5E02",
  210701: "\u5E02\u8F96\u533A",
  210702: "\u53E4\u5854\u533A",
  210703: "\u51CC\u6CB3\u533A",
  210711: "\u592A\u548C\u533A",
  210726: "\u9ED1\u5C71\u53BF",
  210727: "\u4E49\u53BF",
  210781: "\u51CC\u6D77\u5E02",
  210782: "\u5317\u9547\u5E02",
  210800: "\u8425\u53E3\u5E02",
  210801: "\u5E02\u8F96\u533A",
  210802: "\u7AD9\u524D\u533A",
  210803: "\u897F\u5E02\u533A",
  210804: "\u9C85\u9C7C\u5708\u533A",
  210811: "\u8001\u8FB9\u533A",
  210881: "\u76D6\u5DDE\u5E02",
  210882: "\u5927\u77F3\u6865\u5E02",
  210900: "\u961C\u65B0\u5E02",
  210901: "\u5E02\u8F96\u533A",
  210902: "\u6D77\u5DDE\u533A",
  210903: "\u65B0\u90B1\u533A",
  210904: "\u592A\u5E73\u533A",
  210905: "\u6E05\u6CB3\u95E8\u533A",
  210911: "\u7EC6\u6CB3\u533A",
  210921: "\u961C\u65B0\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  210922: "\u5F70\u6B66\u53BF",
  211e3: "\u8FBD\u9633\u5E02",
  211001: "\u5E02\u8F96\u533A",
  211002: "\u767D\u5854\u533A",
  211003: "\u6587\u5723\u533A",
  211004: "\u5B8F\u4F1F\u533A",
  211005: "\u5F13\u957F\u5CAD\u533A",
  211011: "\u592A\u5B50\u6CB3\u533A",
  211021: "\u8FBD\u9633\u53BF",
  211081: "\u706F\u5854\u5E02",
  211100: "\u76D8\u9526\u5E02",
  211101: "\u5E02\u8F96\u533A",
  211102: "\u53CC\u53F0\u5B50\u533A",
  211103: "\u5174\u9686\u53F0\u533A",
  211104: "\u5927\u6D3C\u533A",
  211122: "\u76D8\u5C71\u53BF",
  211200: "\u94C1\u5CAD\u5E02",
  211201: "\u5E02\u8F96\u533A",
  211202: "\u94F6\u5DDE\u533A",
  211204: "\u6E05\u6CB3\u533A",
  211221: "\u94C1\u5CAD\u53BF",
  211223: "\u897F\u4E30\u53BF",
  211224: "\u660C\u56FE\u53BF",
  211281: "\u8C03\u5175\u5C71\u5E02",
  211282: "\u5F00\u539F\u5E02",
  211300: "\u671D\u9633\u5E02",
  211301: "\u5E02\u8F96\u533A",
  211302: "\u53CC\u5854\u533A",
  211303: "\u9F99\u57CE\u533A",
  211321: "\u671D\u9633\u53BF",
  211322: "\u5EFA\u5E73\u53BF",
  211324: "\u5580\u5587\u6C81\u5DE6\u7FFC\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  211381: "\u5317\u7968\u5E02",
  211382: "\u51CC\u6E90\u5E02",
  211400: "\u846B\u82A6\u5C9B\u5E02",
  211401: "\u5E02\u8F96\u533A",
  211402: "\u8FDE\u5C71\u533A",
  211403: "\u9F99\u6E2F\u533A",
  211404: "\u5357\u7968\u533A",
  211421: "\u7EE5\u4E2D\u53BF",
  211422: "\u5EFA\u660C\u53BF",
  211481: "\u5174\u57CE\u5E02",
  22e4: "\u5409\u6797\u7701",
  220100: "\u957F\u6625\u5E02",
  220101: "\u5E02\u8F96\u533A",
  220102: "\u5357\u5173\u533A",
  220103: "\u5BBD\u57CE\u533A",
  220104: "\u671D\u9633\u533A",
  220105: "\u4E8C\u9053\u533A",
  220106: "\u7EFF\u56ED\u533A",
  220112: "\u53CC\u9633\u533A",
  220113: "\u4E5D\u53F0\u533A",
  220122: "\u519C\u5B89\u53BF",
  220171: "\u957F\u6625\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  220172: "\u957F\u6625\u51C0\u6708\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  220173: "\u957F\u6625\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  220174: "\u957F\u6625\u6C7D\u8F66\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  220182: "\u6986\u6811\u5E02",
  220183: "\u5FB7\u60E0\u5E02",
  220200: "\u5409\u6797\u5E02",
  220201: "\u5E02\u8F96\u533A",
  220202: "\u660C\u9091\u533A",
  220203: "\u9F99\u6F6D\u533A",
  220204: "\u8239\u8425\u533A",
  220211: "\u4E30\u6EE1\u533A",
  220221: "\u6C38\u5409\u53BF",
  220271: "\u5409\u6797\u7ECF\u6D4E\u5F00\u53D1\u533A",
  220272: "\u5409\u6797\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  220273: "\u5409\u6797\u4E2D\u56FD\u65B0\u52A0\u5761\u98DF\u54C1\u533A",
  220281: "\u86DF\u6CB3\u5E02",
  220282: "\u6866\u7538\u5E02",
  220283: "\u8212\u5170\u5E02",
  220284: "\u78D0\u77F3\u5E02",
  220300: "\u56DB\u5E73\u5E02",
  220301: "\u5E02\u8F96\u533A",
  220302: "\u94C1\u897F\u533A",
  220303: "\u94C1\u4E1C\u533A",
  220322: "\u68A8\u6811\u53BF",
  220323: "\u4F0A\u901A\u6EE1\u65CF\u81EA\u6CBB\u53BF",
  220381: "\u516C\u4E3B\u5CAD\u5E02",
  220382: "\u53CC\u8FBD\u5E02",
  220400: "\u8FBD\u6E90\u5E02",
  220401: "\u5E02\u8F96\u533A",
  220402: "\u9F99\u5C71\u533A",
  220403: "\u897F\u5B89\u533A",
  220421: "\u4E1C\u4E30\u53BF",
  220422: "\u4E1C\u8FBD\u53BF",
  220500: "\u901A\u5316\u5E02",
  220501: "\u5E02\u8F96\u533A",
  220502: "\u4E1C\u660C\u533A",
  220503: "\u4E8C\u9053\u6C5F\u533A",
  220521: "\u901A\u5316\u53BF",
  220523: "\u8F89\u5357\u53BF",
  220524: "\u67F3\u6CB3\u53BF",
  220581: "\u6885\u6CB3\u53E3\u5E02",
  220582: "\u96C6\u5B89\u5E02",
  220600: "\u767D\u5C71\u5E02",
  220601: "\u5E02\u8F96\u533A",
  220602: "\u6D51\u6C5F\u533A",
  220605: "\u6C5F\u6E90\u533A",
  220621: "\u629A\u677E\u53BF",
  220622: "\u9756\u5B87\u53BF",
  220623: "\u957F\u767D\u671D\u9C9C\u65CF\u81EA\u6CBB\u53BF",
  220681: "\u4E34\u6C5F\u5E02",
  220700: "\u677E\u539F\u5E02",
  220701: "\u5E02\u8F96\u533A",
  220702: "\u5B81\u6C5F\u533A",
  220721: "\u524D\u90ED\u5C14\u7F57\u65AF\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  220722: "\u957F\u5CAD\u53BF",
  220723: "\u4E7E\u5B89\u53BF",
  220771: "\u5409\u6797\u677E\u539F\u7ECF\u6D4E\u5F00\u53D1\u533A",
  220781: "\u6276\u4F59\u5E02",
  220800: "\u767D\u57CE\u5E02",
  220801: "\u5E02\u8F96\u533A",
  220802: "\u6D2E\u5317\u533A",
  220821: "\u9547\u8D49\u53BF",
  220822: "\u901A\u6986\u53BF",
  220871: "\u5409\u6797\u767D\u57CE\u7ECF\u6D4E\u5F00\u53D1\u533A",
  220881: "\u6D2E\u5357\u5E02",
  220882: "\u5927\u5B89\u5E02",
  222400: "\u5EF6\u8FB9\u671D\u9C9C\u65CF\u81EA\u6CBB\u5DDE",
  222401: "\u5EF6\u5409\u5E02",
  222402: "\u56FE\u4EEC\u5E02",
  222403: "\u6566\u5316\u5E02",
  222404: "\u73F2\u6625\u5E02",
  222405: "\u9F99\u4E95\u5E02",
  222406: "\u548C\u9F99\u5E02",
  222424: "\u6C6A\u6E05\u53BF",
  222426: "\u5B89\u56FE\u53BF",
  23e4: "\u9ED1\u9F99\u6C5F\u7701",
  230100: "\u54C8\u5C14\u6EE8\u5E02",
  230101: "\u5E02\u8F96\u533A",
  230102: "\u9053\u91CC\u533A",
  230103: "\u5357\u5C97\u533A",
  230104: "\u9053\u5916\u533A",
  230108: "\u5E73\u623F\u533A",
  230109: "\u677E\u5317\u533A",
  230110: "\u9999\u574A\u533A",
  230111: "\u547C\u5170\u533A",
  230112: "\u963F\u57CE\u533A",
  230113: "\u53CC\u57CE\u533A",
  230123: "\u4F9D\u5170\u53BF",
  230124: "\u65B9\u6B63\u53BF",
  230125: "\u5BBE\u53BF",
  230126: "\u5DF4\u5F66\u53BF",
  230127: "\u6728\u5170\u53BF",
  230128: "\u901A\u6CB3\u53BF",
  230129: "\u5EF6\u5BFF\u53BF",
  230183: "\u5C1A\u5FD7\u5E02",
  230184: "\u4E94\u5E38\u5E02",
  230200: "\u9F50\u9F50\u54C8\u5C14\u5E02",
  230201: "\u5E02\u8F96\u533A",
  230202: "\u9F99\u6C99\u533A",
  230203: "\u5EFA\u534E\u533A",
  230204: "\u94C1\u950B\u533A",
  230205: "\u6602\u6602\u6EAA\u533A",
  230206: "\u5BCC\u62C9\u5C14\u57FA\u533A",
  230207: "\u78BE\u5B50\u5C71\u533A",
  230208: "\u6885\u91CC\u65AF\u8FBE\u65A1\u5C14\u65CF\u533A",
  230221: "\u9F99\u6C5F\u53BF",
  230223: "\u4F9D\u5B89\u53BF",
  230224: "\u6CF0\u6765\u53BF",
  230225: "\u7518\u5357\u53BF",
  230227: "\u5BCC\u88D5\u53BF",
  230229: "\u514B\u5C71\u53BF",
  230230: "\u514B\u4E1C\u53BF",
  230231: "\u62DC\u6CC9\u53BF",
  230281: "\u8BB7\u6CB3\u5E02",
  230300: "\u9E21\u897F\u5E02",
  230301: "\u5E02\u8F96\u533A",
  230302: "\u9E21\u51A0\u533A",
  230303: "\u6052\u5C71\u533A",
  230304: "\u6EF4\u9053\u533A",
  230305: "\u68A8\u6811\u533A",
  230306: "\u57CE\u5B50\u6CB3\u533A",
  230307: "\u9EBB\u5C71\u533A",
  230321: "\u9E21\u4E1C\u53BF",
  230381: "\u864E\u6797\u5E02",
  230382: "\u5BC6\u5C71\u5E02",
  230400: "\u9E64\u5C97\u5E02",
  230401: "\u5E02\u8F96\u533A",
  230402: "\u5411\u9633\u533A",
  230403: "\u5DE5\u519C\u533A",
  230404: "\u5357\u5C71\u533A",
  230405: "\u5174\u5B89\u533A",
  230406: "\u4E1C\u5C71\u533A",
  230407: "\u5174\u5C71\u533A",
  230421: "\u841D\u5317\u53BF",
  230422: "\u7EE5\u6EE8\u53BF",
  230500: "\u53CC\u9E2D\u5C71\u5E02",
  230501: "\u5E02\u8F96\u533A",
  230502: "\u5C16\u5C71\u533A",
  230503: "\u5CAD\u4E1C\u533A",
  230505: "\u56DB\u65B9\u53F0\u533A",
  230506: "\u5B9D\u5C71\u533A",
  230521: "\u96C6\u8D24\u53BF",
  230522: "\u53CB\u8C0A\u53BF",
  230523: "\u5B9D\u6E05\u53BF",
  230524: "\u9976\u6CB3\u53BF",
  230600: "\u5927\u5E86\u5E02",
  230601: "\u5E02\u8F96\u533A",
  230602: "\u8428\u5C14\u56FE\u533A",
  230603: "\u9F99\u51E4\u533A",
  230604: "\u8BA9\u80E1\u8DEF\u533A",
  230605: "\u7EA2\u5C97\u533A",
  230606: "\u5927\u540C\u533A",
  230621: "\u8087\u5DDE\u53BF",
  230622: "\u8087\u6E90\u53BF",
  230623: "\u6797\u7538\u53BF",
  230624: "\u675C\u5C14\u4F2F\u7279\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  230671: "\u5927\u5E86\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  230700: "\u4F0A\u6625\u5E02",
  230701: "\u5E02\u8F96\u533A",
  230717: "\u4F0A\u7F8E\u533A",
  230718: "\u4E4C\u7FE0\u533A",
  230719: "\u53CB\u597D\u533A",
  230722: "\u5609\u836B\u53BF",
  230723: "\u6C64\u65FA\u53BF",
  230724: "\u4E30\u6797\u53BF",
  230725: "\u5927\u7B90\u5C71\u53BF",
  230726: "\u5357\u5C94\u53BF",
  230751: "\u91D1\u6797\u533A",
  230781: "\u94C1\u529B\u5E02",
  230800: "\u4F73\u6728\u65AF\u5E02",
  230801: "\u5E02\u8F96\u533A",
  230803: "\u5411\u9633\u533A",
  230804: "\u524D\u8FDB\u533A",
  230805: "\u4E1C\u98CE\u533A",
  230811: "\u90CA\u533A",
  230822: "\u6866\u5357\u53BF",
  230826: "\u6866\u5DDD\u53BF",
  230828: "\u6C64\u539F\u53BF",
  230881: "\u540C\u6C5F\u5E02",
  230882: "\u5BCC\u9526\u5E02",
  230883: "\u629A\u8FDC\u5E02",
  230900: "\u4E03\u53F0\u6CB3\u5E02",
  230901: "\u5E02\u8F96\u533A",
  230902: "\u65B0\u5174\u533A",
  230903: "\u6843\u5C71\u533A",
  230904: "\u8304\u5B50\u6CB3\u533A",
  230921: "\u52C3\u5229\u53BF",
  231e3: "\u7261\u4E39\u6C5F\u5E02",
  231001: "\u5E02\u8F96\u533A",
  231002: "\u4E1C\u5B89\u533A",
  231003: "\u9633\u660E\u533A",
  231004: "\u7231\u6C11\u533A",
  231005: "\u897F\u5B89\u533A",
  231025: "\u6797\u53E3\u53BF",
  231071: "\u7261\u4E39\u6C5F\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  231081: "\u7EE5\u82AC\u6CB3\u5E02",
  231083: "\u6D77\u6797\u5E02",
  231084: "\u5B81\u5B89\u5E02",
  231085: "\u7A46\u68F1\u5E02",
  231086: "\u4E1C\u5B81\u5E02",
  231100: "\u9ED1\u6CB3\u5E02",
  231101: "\u5E02\u8F96\u533A",
  231102: "\u7231\u8F89\u533A",
  231123: "\u900A\u514B\u53BF",
  231124: "\u5B59\u5434\u53BF",
  231181: "\u5317\u5B89\u5E02",
  231182: "\u4E94\u5927\u8FDE\u6C60\u5E02",
  231183: "\u5AE9\u6C5F\u5E02",
  231200: "\u7EE5\u5316\u5E02",
  231201: "\u5E02\u8F96\u533A",
  231202: "\u5317\u6797\u533A",
  231221: "\u671B\u594E\u53BF",
  231222: "\u5170\u897F\u53BF",
  231223: "\u9752\u5188\u53BF",
  231224: "\u5E86\u5B89\u53BF",
  231225: "\u660E\u6C34\u53BF",
  231226: "\u7EE5\u68F1\u53BF",
  231281: "\u5B89\u8FBE\u5E02",
  231282: "\u8087\u4E1C\u5E02",
  231283: "\u6D77\u4F26\u5E02",
  232700: "\u5927\u5174\u5B89\u5CAD\u5730\u533A",
  232701: "\u6F20\u6CB3\u5E02",
  232721: "\u547C\u739B\u53BF",
  232722: "\u5854\u6CB3\u53BF",
  232761: "\u52A0\u683C\u8FBE\u5947\u533A",
  232762: "\u677E\u5CAD\u533A",
  232763: "\u65B0\u6797\u533A",
  232764: "\u547C\u4E2D\u533A",
  31e4: "\u4E0A\u6D77\u5E02",
  310100: "\u4E0A\u6D77\u5E02",
  310101: "\u9EC4\u6D66\u533A",
  310104: "\u5F90\u6C47\u533A",
  310105: "\u957F\u5B81\u533A",
  310106: "\u9759\u5B89\u533A",
  310107: "\u666E\u9640\u533A",
  310109: "\u8679\u53E3\u533A",
  310110: "\u6768\u6D66\u533A",
  310112: "\u95F5\u884C\u533A",
  310113: "\u5B9D\u5C71\u533A",
  310114: "\u5609\u5B9A\u533A",
  310115: "\u6D66\u4E1C\u65B0\u533A",
  310116: "\u91D1\u5C71\u533A",
  310117: "\u677E\u6C5F\u533A",
  310118: "\u9752\u6D66\u533A",
  310120: "\u5949\u8D24\u533A",
  310151: "\u5D07\u660E\u533A",
  32e4: "\u6C5F\u82CF\u7701",
  320100: "\u5357\u4EAC\u5E02",
  320101: "\u5E02\u8F96\u533A",
  320102: "\u7384\u6B66\u533A",
  320104: "\u79E6\u6DEE\u533A",
  320105: "\u5EFA\u90BA\u533A",
  320106: "\u9F13\u697C\u533A",
  320111: "\u6D66\u53E3\u533A",
  320113: "\u6816\u971E\u533A",
  320114: "\u96E8\u82B1\u53F0\u533A",
  320115: "\u6C5F\u5B81\u533A",
  320116: "\u516D\u5408\u533A",
  320117: "\u6EA7\u6C34\u533A",
  320118: "\u9AD8\u6DF3\u533A",
  320200: "\u65E0\u9521\u5E02",
  320201: "\u5E02\u8F96\u533A",
  320205: "\u9521\u5C71\u533A",
  320206: "\u60E0\u5C71\u533A",
  320211: "\u6EE8\u6E56\u533A",
  320213: "\u6881\u6EAA\u533A",
  320214: "\u65B0\u5434\u533A",
  320281: "\u6C5F\u9634\u5E02",
  320282: "\u5B9C\u5174\u5E02",
  320300: "\u5F90\u5DDE\u5E02",
  320301: "\u5E02\u8F96\u533A",
  320302: "\u9F13\u697C\u533A",
  320303: "\u4E91\u9F99\u533A",
  320305: "\u8D3E\u6C6A\u533A",
  320311: "\u6CC9\u5C71\u533A",
  320312: "\u94DC\u5C71\u533A",
  320321: "\u4E30\u53BF",
  320322: "\u6C9B\u53BF",
  320324: "\u7762\u5B81\u53BF",
  320371: "\u5F90\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  320381: "\u65B0\u6C82\u5E02",
  320382: "\u90B3\u5DDE\u5E02",
  320400: "\u5E38\u5DDE\u5E02",
  320401: "\u5E02\u8F96\u533A",
  320402: "\u5929\u5B81\u533A",
  320404: "\u949F\u697C\u533A",
  320411: "\u65B0\u5317\u533A",
  320412: "\u6B66\u8FDB\u533A",
  320413: "\u91D1\u575B\u533A",
  320481: "\u6EA7\u9633\u5E02",
  320500: "\u82CF\u5DDE\u5E02",
  320501: "\u5E02\u8F96\u533A",
  320505: "\u864E\u4E18\u533A",
  320506: "\u5434\u4E2D\u533A",
  320507: "\u76F8\u57CE\u533A",
  320508: "\u59D1\u82CF\u533A",
  320509: "\u5434\u6C5F\u533A",
  320571: "\u82CF\u5DDE\u5DE5\u4E1A\u56ED\u533A",
  320581: "\u5E38\u719F\u5E02",
  320582: "\u5F20\u5BB6\u6E2F\u5E02",
  320583: "\u6606\u5C71\u5E02",
  320585: "\u592A\u4ED3\u5E02",
  320600: "\u5357\u901A\u5E02",
  320601: "\u5E02\u8F96\u533A",
  320602: "\u5D07\u5DDD\u533A",
  320611: "\u6E2F\u95F8\u533A",
  320612: "\u901A\u5DDE\u533A",
  320623: "\u5982\u4E1C\u53BF",
  320671: "\u5357\u901A\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  320681: "\u542F\u4E1C\u5E02",
  320682: "\u5982\u768B\u5E02",
  320684: "\u6D77\u95E8\u5E02",
  320685: "\u6D77\u5B89\u5E02",
  320700: "\u8FDE\u4E91\u6E2F\u5E02",
  320701: "\u5E02\u8F96\u533A",
  320703: "\u8FDE\u4E91\u533A",
  320706: "\u6D77\u5DDE\u533A",
  320707: "\u8D63\u6986\u533A",
  320722: "\u4E1C\u6D77\u53BF",
  320723: "\u704C\u4E91\u53BF",
  320724: "\u704C\u5357\u53BF",
  320771: "\u8FDE\u4E91\u6E2F\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  320772: "\u8FDE\u4E91\u6E2F\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  320800: "\u6DEE\u5B89\u5E02",
  320801: "\u5E02\u8F96\u533A",
  320803: "\u6DEE\u5B89\u533A",
  320804: "\u6DEE\u9634\u533A",
  320812: "\u6E05\u6C5F\u6D66\u533A",
  320813: "\u6D2A\u6CFD\u533A",
  320826: "\u6D9F\u6C34\u53BF",
  320830: "\u76F1\u7719\u53BF",
  320831: "\u91D1\u6E56\u53BF",
  320871: "\u6DEE\u5B89\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  320900: "\u76D0\u57CE\u5E02",
  320901: "\u5E02\u8F96\u533A",
  320902: "\u4EAD\u6E56\u533A",
  320903: "\u76D0\u90FD\u533A",
  320904: "\u5927\u4E30\u533A",
  320921: "\u54CD\u6C34\u53BF",
  320922: "\u6EE8\u6D77\u53BF",
  320923: "\u961C\u5B81\u53BF",
  320924: "\u5C04\u9633\u53BF",
  320925: "\u5EFA\u6E56\u53BF",
  320971: "\u76D0\u57CE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  320981: "\u4E1C\u53F0\u5E02",
  321e3: "\u626C\u5DDE\u5E02",
  321001: "\u5E02\u8F96\u533A",
  321002: "\u5E7F\u9675\u533A",
  321003: "\u9097\u6C5F\u533A",
  321012: "\u6C5F\u90FD\u533A",
  321023: "\u5B9D\u5E94\u53BF",
  321071: "\u626C\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  321081: "\u4EEA\u5F81\u5E02",
  321084: "\u9AD8\u90AE\u5E02",
  321100: "\u9547\u6C5F\u5E02",
  321101: "\u5E02\u8F96\u533A",
  321102: "\u4EAC\u53E3\u533A",
  321111: "\u6DA6\u5DDE\u533A",
  321112: "\u4E39\u5F92\u533A",
  321171: "\u9547\u6C5F\u65B0\u533A",
  321181: "\u4E39\u9633\u5E02",
  321182: "\u626C\u4E2D\u5E02",
  321183: "\u53E5\u5BB9\u5E02",
  321200: "\u6CF0\u5DDE\u5E02",
  321201: "\u5E02\u8F96\u533A",
  321202: "\u6D77\u9675\u533A",
  321203: "\u9AD8\u6E2F\u533A",
  321204: "\u59DC\u5830\u533A",
  321271: "\u6CF0\u5DDE\u533B\u836F\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  321281: "\u5174\u5316\u5E02",
  321282: "\u9756\u6C5F\u5E02",
  321283: "\u6CF0\u5174\u5E02",
  321300: "\u5BBF\u8FC1\u5E02",
  321301: "\u5E02\u8F96\u533A",
  321302: "\u5BBF\u57CE\u533A",
  321311: "\u5BBF\u8C6B\u533A",
  321322: "\u6CAD\u9633\u53BF",
  321323: "\u6CD7\u9633\u53BF",
  321324: "\u6CD7\u6D2A\u53BF",
  321371: "\u5BBF\u8FC1\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  33e4: "\u6D59\u6C5F\u7701",
  330100: "\u676D\u5DDE\u5E02",
  330101: "\u5E02\u8F96\u533A",
  330102: "\u4E0A\u57CE\u533A",
  330103: "\u4E0B\u57CE\u533A",
  330104: "\u6C5F\u5E72\u533A",
  330105: "\u62F1\u5885\u533A",
  330106: "\u897F\u6E56\u533A",
  330108: "\u6EE8\u6C5F\u533A",
  330109: "\u8427\u5C71\u533A",
  330110: "\u4F59\u676D\u533A",
  330111: "\u5BCC\u9633\u533A",
  330112: "\u4E34\u5B89\u533A",
  330113: "\u4E34\u5E73\u533A",
  330114: "\u94B1\u5858\u533A",
  330122: "\u6850\u5E90\u53BF",
  330127: "\u6DF3\u5B89\u53BF",
  330182: "\u5EFA\u5FB7\u5E02",
  330200: "\u5B81\u6CE2\u5E02",
  330201: "\u5E02\u8F96\u533A",
  330203: "\u6D77\u66D9\u533A",
  330205: "\u6C5F\u5317\u533A",
  330206: "\u5317\u4ED1\u533A",
  330211: "\u9547\u6D77\u533A",
  330212: "\u911E\u5DDE\u533A",
  330213: "\u5949\u5316\u533A",
  330225: "\u8C61\u5C71\u53BF",
  330226: "\u5B81\u6D77\u53BF",
  330281: "\u4F59\u59DA\u5E02",
  330282: "\u6148\u6EAA\u5E02",
  330300: "\u6E29\u5DDE\u5E02",
  330301: "\u5E02\u8F96\u533A",
  330302: "\u9E7F\u57CE\u533A",
  330303: "\u9F99\u6E7E\u533A",
  330304: "\u74EF\u6D77\u533A",
  330305: "\u6D1E\u5934\u533A",
  330324: "\u6C38\u5609\u53BF",
  330326: "\u5E73\u9633\u53BF",
  330327: "\u82CD\u5357\u53BF",
  330328: "\u6587\u6210\u53BF",
  330329: "\u6CF0\u987A\u53BF",
  330371: "\u6E29\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  330381: "\u745E\u5B89\u5E02",
  330382: "\u4E50\u6E05\u5E02",
  330383: "\u9F99\u6E2F\u5E02",
  330400: "\u5609\u5174\u5E02",
  330401: "\u5E02\u8F96\u533A",
  330402: "\u5357\u6E56\u533A",
  330411: "\u79C0\u6D32\u533A",
  330421: "\u5609\u5584\u53BF",
  330424: "\u6D77\u76D0\u53BF",
  330481: "\u6D77\u5B81\u5E02",
  330482: "\u5E73\u6E56\u5E02",
  330483: "\u6850\u4E61\u5E02",
  330500: "\u6E56\u5DDE\u5E02",
  330501: "\u5E02\u8F96\u533A",
  330502: "\u5434\u5174\u533A",
  330503: "\u5357\u6D54\u533A",
  330521: "\u5FB7\u6E05\u53BF",
  330522: "\u957F\u5174\u53BF",
  330523: "\u5B89\u5409\u53BF",
  330600: "\u7ECD\u5174\u5E02",
  330601: "\u5E02\u8F96\u533A",
  330602: "\u8D8A\u57CE\u533A",
  330603: "\u67EF\u6865\u533A",
  330604: "\u4E0A\u865E\u533A",
  330624: "\u65B0\u660C\u53BF",
  330681: "\u8BF8\u66A8\u5E02",
  330683: "\u5D4A\u5DDE\u5E02",
  330700: "\u91D1\u534E\u5E02",
  330701: "\u5E02\u8F96\u533A",
  330702: "\u5A7A\u57CE\u533A",
  330703: "\u91D1\u4E1C\u533A",
  330723: "\u6B66\u4E49\u53BF",
  330726: "\u6D66\u6C5F\u53BF",
  330727: "\u78D0\u5B89\u53BF",
  330781: "\u5170\u6EAA\u5E02",
  330782: "\u4E49\u4E4C\u5E02",
  330783: "\u4E1C\u9633\u5E02",
  330784: "\u6C38\u5EB7\u5E02",
  330800: "\u8862\u5DDE\u5E02",
  330801: "\u5E02\u8F96\u533A",
  330802: "\u67EF\u57CE\u533A",
  330803: "\u8862\u6C5F\u533A",
  330822: "\u5E38\u5C71\u53BF",
  330824: "\u5F00\u5316\u53BF",
  330825: "\u9F99\u6E38\u53BF",
  330881: "\u6C5F\u5C71\u5E02",
  330900: "\u821F\u5C71\u5E02",
  330901: "\u5E02\u8F96\u533A",
  330902: "\u5B9A\u6D77\u533A",
  330903: "\u666E\u9640\u533A",
  330921: "\u5CB1\u5C71\u53BF",
  330922: "\u5D4A\u6CD7\u53BF",
  331e3: "\u53F0\u5DDE\u5E02",
  331001: "\u5E02\u8F96\u533A",
  331002: "\u6912\u6C5F\u533A",
  331003: "\u9EC4\u5CA9\u533A",
  331004: "\u8DEF\u6865\u533A",
  331022: "\u4E09\u95E8\u53BF",
  331023: "\u5929\u53F0\u53BF",
  331024: "\u4ED9\u5C45\u53BF",
  331081: "\u6E29\u5CAD\u5E02",
  331082: "\u4E34\u6D77\u5E02",
  331083: "\u7389\u73AF\u5E02",
  331100: "\u4E3D\u6C34\u5E02",
  331101: "\u5E02\u8F96\u533A",
  331102: "\u83B2\u90FD\u533A",
  331121: "\u9752\u7530\u53BF",
  331122: "\u7F19\u4E91\u53BF",
  331123: "\u9042\u660C\u53BF",
  331124: "\u677E\u9633\u53BF",
  331125: "\u4E91\u548C\u53BF",
  331126: "\u5E86\u5143\u53BF",
  331127: "\u666F\u5B81\u7572\u65CF\u81EA\u6CBB\u53BF",
  331181: "\u9F99\u6CC9\u5E02",
  34e4: "\u5B89\u5FBD\u7701",
  340100: "\u5408\u80A5\u5E02",
  340101: "\u5E02\u8F96\u533A",
  340102: "\u7476\u6D77\u533A",
  340103: "\u5E90\u9633\u533A",
  340104: "\u8700\u5C71\u533A",
  340111: "\u5305\u6CB3\u533A",
  340121: "\u957F\u4E30\u53BF",
  340122: "\u80A5\u4E1C\u53BF",
  340123: "\u80A5\u897F\u53BF",
  340124: "\u5E90\u6C5F\u53BF",
  340171: "\u5408\u80A5\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  340172: "\u5408\u80A5\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  340173: "\u5408\u80A5\u65B0\u7AD9\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  340181: "\u5DE2\u6E56\u5E02",
  340200: "\u829C\u6E56\u5E02",
  340201: "\u5E02\u8F96\u533A",
  340202: "\u955C\u6E56\u533A",
  340203: "\u5F0B\u6C5F\u533A",
  340207: "\u9E20\u6C5F\u533A",
  340208: "\u4E09\u5C71\u533A",
  340221: "\u829C\u6E56\u53BF",
  340222: "\u7E41\u660C\u53BF",
  340223: "\u5357\u9675\u53BF",
  340225: "\u65E0\u4E3A\u53BF",
  340271: "\u829C\u6E56\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  340272: "\u5B89\u5FBD\u829C\u6E56\u957F\u6C5F\u5927\u6865\u7ECF\u6D4E\u5F00\u53D1\u533A",
  340300: "\u868C\u57E0\u5E02",
  340301: "\u5E02\u8F96\u533A",
  340302: "\u9F99\u5B50\u6E56\u533A",
  340303: "\u868C\u5C71\u533A",
  340304: "\u79B9\u4F1A\u533A",
  340311: "\u6DEE\u4E0A\u533A",
  340321: "\u6000\u8FDC\u53BF",
  340322: "\u4E94\u6CB3\u53BF",
  340323: "\u56FA\u9547\u53BF",
  340371: "\u868C\u57E0\u5E02\u9AD8\u65B0\u6280\u672F\u5F00\u53D1\u533A",
  340372: "\u868C\u57E0\u5E02\u7ECF\u6D4E\u5F00\u53D1\u533A",
  340400: "\u6DEE\u5357\u5E02",
  340401: "\u5E02\u8F96\u533A",
  340402: "\u5927\u901A\u533A",
  340403: "\u7530\u5BB6\u5EB5\u533A",
  340404: "\u8C22\u5BB6\u96C6\u533A",
  340405: "\u516B\u516C\u5C71\u533A",
  340406: "\u6F58\u96C6\u533A",
  340421: "\u51E4\u53F0\u53BF",
  340422: "\u5BFF\u53BF",
  340500: "\u9A6C\u978D\u5C71\u5E02",
  340501: "\u5E02\u8F96\u533A",
  340503: "\u82B1\u5C71\u533A",
  340504: "\u96E8\u5C71\u533A",
  340506: "\u535A\u671B\u533A",
  340521: "\u5F53\u6D82\u53BF",
  340522: "\u542B\u5C71\u53BF",
  340523: "\u548C\u53BF",
  340600: "\u6DEE\u5317\u5E02",
  340601: "\u5E02\u8F96\u533A",
  340602: "\u675C\u96C6\u533A",
  340603: "\u76F8\u5C71\u533A",
  340604: "\u70C8\u5C71\u533A",
  340621: "\u6FC9\u6EAA\u53BF",
  340700: "\u94DC\u9675\u5E02",
  340701: "\u5E02\u8F96\u533A",
  340705: "\u94DC\u5B98\u533A",
  340706: "\u4E49\u5B89\u533A",
  340711: "\u90CA\u533A",
  340722: "\u679E\u9633\u53BF",
  340800: "\u5B89\u5E86\u5E02",
  340801: "\u5E02\u8F96\u533A",
  340802: "\u8FCE\u6C5F\u533A",
  340803: "\u5927\u89C2\u533A",
  340811: "\u5B9C\u79C0\u533A",
  340822: "\u6000\u5B81\u53BF",
  340825: "\u592A\u6E56\u53BF",
  340826: "\u5BBF\u677E\u53BF",
  340827: "\u671B\u6C5F\u53BF",
  340828: "\u5CB3\u897F\u53BF",
  340871: "\u5B89\u5FBD\u5B89\u5E86\u7ECF\u6D4E\u5F00\u53D1\u533A",
  340881: "\u6850\u57CE\u5E02",
  340882: "\u6F5C\u5C71\u5E02",
  341e3: "\u9EC4\u5C71\u5E02",
  341001: "\u5E02\u8F96\u533A",
  341002: "\u5C6F\u6EAA\u533A",
  341003: "\u9EC4\u5C71\u533A",
  341004: "\u5FBD\u5DDE\u533A",
  341021: "\u6B59\u53BF",
  341022: "\u4F11\u5B81\u53BF",
  341023: "\u9EDF\u53BF",
  341024: "\u7941\u95E8\u53BF",
  341100: "\u6EC1\u5DDE\u5E02",
  341101: "\u5E02\u8F96\u533A",
  341102: "\u7405\u740A\u533A",
  341103: "\u5357\u8C2F\u533A",
  341122: "\u6765\u5B89\u53BF",
  341124: "\u5168\u6912\u53BF",
  341125: "\u5B9A\u8FDC\u53BF",
  341126: "\u51E4\u9633\u53BF",
  341171: "\u82CF\u6EC1\u73B0\u4EE3\u4EA7\u4E1A\u56ED",
  341172: "\u6EC1\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  341181: "\u5929\u957F\u5E02",
  341182: "\u660E\u5149\u5E02",
  341200: "\u961C\u9633\u5E02",
  341201: "\u5E02\u8F96\u533A",
  341202: "\u988D\u5DDE\u533A",
  341203: "\u988D\u4E1C\u533A",
  341204: "\u988D\u6CC9\u533A",
  341221: "\u4E34\u6CC9\u53BF",
  341222: "\u592A\u548C\u53BF",
  341225: "\u961C\u5357\u53BF",
  341226: "\u988D\u4E0A\u53BF",
  341271: "\u961C\u9633\u5408\u80A5\u73B0\u4EE3\u4EA7\u4E1A\u56ED\u533A",
  341272: "\u961C\u9633\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  341282: "\u754C\u9996\u5E02",
  341300: "\u5BBF\u5DDE\u5E02",
  341301: "\u5E02\u8F96\u533A",
  341302: "\u57C7\u6865\u533A",
  341321: "\u7800\u5C71\u53BF",
  341322: "\u8427\u53BF",
  341323: "\u7075\u74A7\u53BF",
  341324: "\u6CD7\u53BF",
  341371: "\u5BBF\u5DDE\u9A6C\u978D\u5C71\u73B0\u4EE3\u4EA7\u4E1A\u56ED\u533A",
  341372: "\u5BBF\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  341500: "\u516D\u5B89\u5E02",
  341501: "\u5E02\u8F96\u533A",
  341502: "\u91D1\u5B89\u533A",
  341503: "\u88D5\u5B89\u533A",
  341504: "\u53F6\u96C6\u533A",
  341522: "\u970D\u90B1\u53BF",
  341523: "\u8212\u57CE\u53BF",
  341524: "\u91D1\u5BE8\u53BF",
  341525: "\u970D\u5C71\u53BF",
  341600: "\u4EB3\u5DDE\u5E02",
  341601: "\u5E02\u8F96\u533A",
  341602: "\u8C2F\u57CE\u533A",
  341621: "\u6DA1\u9633\u53BF",
  341622: "\u8499\u57CE\u53BF",
  341623: "\u5229\u8F9B\u53BF",
  341700: "\u6C60\u5DDE\u5E02",
  341701: "\u5E02\u8F96\u533A",
  341702: "\u8D35\u6C60\u533A",
  341721: "\u4E1C\u81F3\u53BF",
  341722: "\u77F3\u53F0\u53BF",
  341723: "\u9752\u9633\u53BF",
  341800: "\u5BA3\u57CE\u5E02",
  341801: "\u5E02\u8F96\u533A",
  341802: "\u5BA3\u5DDE\u533A",
  341821: "\u90CE\u6EAA\u53BF",
  341823: "\u6CFE\u53BF",
  341824: "\u7EE9\u6EAA\u53BF",
  341825: "\u65CC\u5FB7\u53BF",
  341871: "\u5BA3\u57CE\u5E02\u7ECF\u6D4E\u5F00\u53D1\u533A",
  341881: "\u5B81\u56FD\u5E02",
  341882: "\u5E7F\u5FB7\u5E02",
  35e4: "\u798F\u5EFA\u7701",
  350100: "\u798F\u5DDE\u5E02",
  350101: "\u5E02\u8F96\u533A",
  350102: "\u9F13\u697C\u533A",
  350103: "\u53F0\u6C5F\u533A",
  350104: "\u4ED3\u5C71\u533A",
  350105: "\u9A6C\u5C3E\u533A",
  350111: "\u664B\u5B89\u533A",
  350112: "\u957F\u4E50\u533A",
  350121: "\u95FD\u4FAF\u53BF",
  350122: "\u8FDE\u6C5F\u53BF",
  350123: "\u7F57\u6E90\u53BF",
  350124: "\u95FD\u6E05\u53BF",
  350125: "\u6C38\u6CF0\u53BF",
  350128: "\u5E73\u6F6D\u53BF",
  350181: "\u798F\u6E05\u5E02",
  350200: "\u53A6\u95E8\u5E02",
  350201: "\u5E02\u8F96\u533A",
  350203: "\u601D\u660E\u533A",
  350205: "\u6D77\u6CA7\u533A",
  350206: "\u6E56\u91CC\u533A",
  350211: "\u96C6\u7F8E\u533A",
  350212: "\u540C\u5B89\u533A",
  350213: "\u7FD4\u5B89\u533A",
  350300: "\u8386\u7530\u5E02",
  350301: "\u5E02\u8F96\u533A",
  350302: "\u57CE\u53A2\u533A",
  350303: "\u6DB5\u6C5F\u533A",
  350304: "\u8354\u57CE\u533A",
  350305: "\u79C0\u5C7F\u533A",
  350322: "\u4ED9\u6E38\u53BF",
  350400: "\u4E09\u660E\u5E02",
  350401: "\u5E02\u8F96\u533A",
  350402: "\u6885\u5217\u533A",
  350403: "\u4E09\u5143\u533A",
  350421: "\u660E\u6EAA\u53BF",
  350423: "\u6E05\u6D41\u53BF",
  350424: "\u5B81\u5316\u53BF",
  350425: "\u5927\u7530\u53BF",
  350426: "\u5C24\u6EAA\u53BF",
  350427: "\u6C99\u53BF",
  350428: "\u5C06\u4E50\u53BF",
  350429: "\u6CF0\u5B81\u53BF",
  350430: "\u5EFA\u5B81\u53BF",
  350481: "\u6C38\u5B89\u5E02",
  350500: "\u6CC9\u5DDE\u5E02",
  350501: "\u5E02\u8F96\u533A",
  350502: "\u9CA4\u57CE\u533A",
  350503: "\u4E30\u6CFD\u533A",
  350504: "\u6D1B\u6C5F\u533A",
  350505: "\u6CC9\u6E2F\u533A",
  350521: "\u60E0\u5B89\u53BF",
  350524: "\u5B89\u6EAA\u53BF",
  350525: "\u6C38\u6625\u53BF",
  350526: "\u5FB7\u5316\u53BF",
  350527: "\u91D1\u95E8\u53BF",
  350581: "\u77F3\u72EE\u5E02",
  350582: "\u664B\u6C5F\u5E02",
  350583: "\u5357\u5B89\u5E02",
  350600: "\u6F33\u5DDE\u5E02",
  350601: "\u5E02\u8F96\u533A",
  350602: "\u8297\u57CE\u533A",
  350603: "\u9F99\u6587\u533A",
  350622: "\u4E91\u9704\u53BF",
  350623: "\u6F33\u6D66\u53BF",
  350624: "\u8BCF\u5B89\u53BF",
  350625: "\u957F\u6CF0\u53BF",
  350626: "\u4E1C\u5C71\u53BF",
  350627: "\u5357\u9756\u53BF",
  350628: "\u5E73\u548C\u53BF",
  350629: "\u534E\u5B89\u53BF",
  350681: "\u9F99\u6D77\u5E02",
  350700: "\u5357\u5E73\u5E02",
  350701: "\u5E02\u8F96\u533A",
  350702: "\u5EF6\u5E73\u533A",
  350703: "\u5EFA\u9633\u533A",
  350721: "\u987A\u660C\u53BF",
  350722: "\u6D66\u57CE\u53BF",
  350723: "\u5149\u6CFD\u53BF",
  350724: "\u677E\u6EAA\u53BF",
  350725: "\u653F\u548C\u53BF",
  350781: "\u90B5\u6B66\u5E02",
  350782: "\u6B66\u5937\u5C71\u5E02",
  350783: "\u5EFA\u74EF\u5E02",
  350800: "\u9F99\u5CA9\u5E02",
  350801: "\u5E02\u8F96\u533A",
  350802: "\u65B0\u7F57\u533A",
  350803: "\u6C38\u5B9A\u533A",
  350821: "\u957F\u6C40\u53BF",
  350823: "\u4E0A\u676D\u53BF",
  350824: "\u6B66\u5E73\u53BF",
  350825: "\u8FDE\u57CE\u53BF",
  350881: "\u6F33\u5E73\u5E02",
  350900: "\u5B81\u5FB7\u5E02",
  350901: "\u5E02\u8F96\u533A",
  350902: "\u8549\u57CE\u533A",
  350921: "\u971E\u6D66\u53BF",
  350922: "\u53E4\u7530\u53BF",
  350923: "\u5C4F\u5357\u53BF",
  350924: "\u5BFF\u5B81\u53BF",
  350925: "\u5468\u5B81\u53BF",
  350926: "\u67D8\u8363\u53BF",
  350981: "\u798F\u5B89\u5E02",
  350982: "\u798F\u9F0E\u5E02",
  36e4: "\u6C5F\u897F\u7701",
  360100: "\u5357\u660C\u5E02",
  360101: "\u5E02\u8F96\u533A",
  360102: "\u4E1C\u6E56\u533A",
  360103: "\u897F\u6E56\u533A",
  360104: "\u9752\u4E91\u8C31\u533A",
  360105: "\u6E7E\u91CC\u533A",
  360111: "\u9752\u5C71\u6E56\u533A",
  360112: "\u65B0\u5EFA\u533A",
  360121: "\u5357\u660C\u53BF",
  360123: "\u5B89\u4E49\u53BF",
  360124: "\u8FDB\u8D24\u53BF",
  360200: "\u666F\u5FB7\u9547\u5E02",
  360201: "\u5E02\u8F96\u533A",
  360202: "\u660C\u6C5F\u533A",
  360203: "\u73E0\u5C71\u533A",
  360222: "\u6D6E\u6881\u53BF",
  360281: "\u4E50\u5E73\u5E02",
  360300: "\u840D\u4E61\u5E02",
  360301: "\u5E02\u8F96\u533A",
  360302: "\u5B89\u6E90\u533A",
  360313: "\u6E58\u4E1C\u533A",
  360321: "\u83B2\u82B1\u53BF",
  360322: "\u4E0A\u6817\u53BF",
  360323: "\u82A6\u6EAA\u53BF",
  360400: "\u4E5D\u6C5F\u5E02",
  360401: "\u5E02\u8F96\u533A",
  360402: "\u6FC2\u6EAA\u533A",
  360403: "\u6D54\u9633\u533A",
  360404: "\u67F4\u6851\u533A",
  360423: "\u6B66\u5B81\u53BF",
  360424: "\u4FEE\u6C34\u53BF",
  360425: "\u6C38\u4FEE\u53BF",
  360426: "\u5FB7\u5B89\u53BF",
  360428: "\u90FD\u660C\u53BF",
  360429: "\u6E56\u53E3\u53BF",
  360430: "\u5F6D\u6CFD\u53BF",
  360481: "\u745E\u660C\u5E02",
  360482: "\u5171\u9752\u57CE\u5E02",
  360483: "\u5E90\u5C71\u5E02",
  360500: "\u65B0\u4F59\u5E02",
  360501: "\u5E02\u8F96\u533A",
  360502: "\u6E1D\u6C34\u533A",
  360521: "\u5206\u5B9C\u53BF",
  360600: "\u9E70\u6F6D\u5E02",
  360601: "\u5E02\u8F96\u533A",
  360602: "\u6708\u6E56\u533A",
  360603: "\u4F59\u6C5F\u533A",
  360681: "\u8D35\u6EAA\u5E02",
  360700: "\u8D63\u5DDE\u5E02",
  360701: "\u5E02\u8F96\u533A",
  360702: "\u7AE0\u8D21\u533A",
  360703: "\u5357\u5EB7\u533A",
  360704: "\u8D63\u53BF\u533A",
  360722: "\u4FE1\u4E30\u53BF",
  360723: "\u5927\u4F59\u53BF",
  360724: "\u4E0A\u72B9\u53BF",
  360725: "\u5D07\u4E49\u53BF",
  360726: "\u5B89\u8FDC\u53BF",
  360727: "\u9F99\u5357\u53BF",
  360728: "\u5B9A\u5357\u53BF",
  360729: "\u5168\u5357\u53BF",
  360730: "\u5B81\u90FD\u53BF",
  360731: "\u4E8E\u90FD\u53BF",
  360732: "\u5174\u56FD\u53BF",
  360733: "\u4F1A\u660C\u53BF",
  360734: "\u5BFB\u4E4C\u53BF",
  360735: "\u77F3\u57CE\u53BF",
  360781: "\u745E\u91D1\u5E02",
  360800: "\u5409\u5B89\u5E02",
  360801: "\u5E02\u8F96\u533A",
  360802: "\u5409\u5DDE\u533A",
  360803: "\u9752\u539F\u533A",
  360821: "\u5409\u5B89\u53BF",
  360822: "\u5409\u6C34\u53BF",
  360823: "\u5CE1\u6C5F\u53BF",
  360824: "\u65B0\u5E72\u53BF",
  360825: "\u6C38\u4E30\u53BF",
  360826: "\u6CF0\u548C\u53BF",
  360827: "\u9042\u5DDD\u53BF",
  360828: "\u4E07\u5B89\u53BF",
  360829: "\u5B89\u798F\u53BF",
  360830: "\u6C38\u65B0\u53BF",
  360881: "\u4E95\u5188\u5C71\u5E02",
  360900: "\u5B9C\u6625\u5E02",
  360901: "\u5E02\u8F96\u533A",
  360902: "\u8881\u5DDE\u533A",
  360921: "\u5949\u65B0\u53BF",
  360922: "\u4E07\u8F7D\u53BF",
  360923: "\u4E0A\u9AD8\u53BF",
  360924: "\u5B9C\u4E30\u53BF",
  360925: "\u9756\u5B89\u53BF",
  360926: "\u94DC\u9F13\u53BF",
  360981: "\u4E30\u57CE\u5E02",
  360982: "\u6A1F\u6811\u5E02",
  360983: "\u9AD8\u5B89\u5E02",
  361e3: "\u629A\u5DDE\u5E02",
  361001: "\u5E02\u8F96\u533A",
  361002: "\u4E34\u5DDD\u533A",
  361003: "\u4E1C\u4E61\u533A",
  361021: "\u5357\u57CE\u53BF",
  361022: "\u9ECE\u5DDD\u53BF",
  361023: "\u5357\u4E30\u53BF",
  361024: "\u5D07\u4EC1\u53BF",
  361025: "\u4E50\u5B89\u53BF",
  361026: "\u5B9C\u9EC4\u53BF",
  361027: "\u91D1\u6EAA\u53BF",
  361028: "\u8D44\u6EAA\u53BF",
  361030: "\u5E7F\u660C\u53BF",
  361100: "\u4E0A\u9976\u5E02",
  361101: "\u5E02\u8F96\u533A",
  361102: "\u4FE1\u5DDE\u533A",
  361103: "\u5E7F\u4E30\u533A",
  361104: "\u5E7F\u4FE1\u533A",
  361123: "\u7389\u5C71\u53BF",
  361124: "\u94C5\u5C71\u53BF",
  361125: "\u6A2A\u5CF0\u53BF",
  361126: "\u5F0B\u9633\u53BF",
  361127: "\u4F59\u5E72\u53BF",
  361128: "\u9131\u9633\u53BF",
  361129: "\u4E07\u5E74\u53BF",
  361130: "\u5A7A\u6E90\u53BF",
  361181: "\u5FB7\u5174\u5E02",
  37e4: "\u5C71\u4E1C\u7701",
  370100: "\u6D4E\u5357\u5E02",
  370101: "\u5E02\u8F96\u533A",
  370102: "\u5386\u4E0B\u533A",
  370103: "\u5E02\u4E2D\u533A",
  370104: "\u69D0\u836B\u533A",
  370105: "\u5929\u6865\u533A",
  370112: "\u5386\u57CE\u533A",
  370113: "\u957F\u6E05\u533A",
  370114: "\u7AE0\u4E18\u533A",
  370115: "\u6D4E\u9633\u533A",
  370116: "\u83B1\u829C\u533A",
  370117: "\u94A2\u57CE\u533A",
  370124: "\u5E73\u9634\u53BF",
  370126: "\u5546\u6CB3\u53BF",
  370171: "\u6D4E\u5357\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  370200: "\u9752\u5C9B\u5E02",
  370201: "\u5E02\u8F96\u533A",
  370202: "\u5E02\u5357\u533A",
  370203: "\u5E02\u5317\u533A",
  370211: "\u9EC4\u5C9B\u533A",
  370212: "\u5D02\u5C71\u533A",
  370213: "\u674E\u6CA7\u533A",
  370214: "\u57CE\u9633\u533A",
  370215: "\u5373\u58A8\u533A",
  370271: "\u9752\u5C9B\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  370281: "\u80F6\u5DDE\u5E02",
  370283: "\u5E73\u5EA6\u5E02",
  370285: "\u83B1\u897F\u5E02",
  370300: "\u6DC4\u535A\u5E02",
  370301: "\u5E02\u8F96\u533A",
  370302: "\u6DC4\u5DDD\u533A",
  370303: "\u5F20\u5E97\u533A",
  370304: "\u535A\u5C71\u533A",
  370305: "\u4E34\u6DC4\u533A",
  370306: "\u5468\u6751\u533A",
  370321: "\u6853\u53F0\u53BF",
  370322: "\u9AD8\u9752\u53BF",
  370323: "\u6C82\u6E90\u53BF",
  370400: "\u67A3\u5E84\u5E02",
  370401: "\u5E02\u8F96\u533A",
  370402: "\u5E02\u4E2D\u533A",
  370403: "\u859B\u57CE\u533A",
  370404: "\u5CC4\u57CE\u533A",
  370405: "\u53F0\u513F\u5E84\u533A",
  370406: "\u5C71\u4EAD\u533A",
  370481: "\u6ED5\u5DDE\u5E02",
  370500: "\u4E1C\u8425\u5E02",
  370501: "\u5E02\u8F96\u533A",
  370502: "\u4E1C\u8425\u533A",
  370503: "\u6CB3\u53E3\u533A",
  370505: "\u57A6\u5229\u533A",
  370522: "\u5229\u6D25\u53BF",
  370523: "\u5E7F\u9976\u53BF",
  370571: "\u4E1C\u8425\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  370572: "\u4E1C\u8425\u6E2F\u7ECF\u6D4E\u5F00\u53D1\u533A",
  370600: "\u70DF\u53F0\u5E02",
  370601: "\u5E02\u8F96\u533A",
  370602: "\u829D\u7F58\u533A",
  370611: "\u798F\u5C71\u533A",
  370612: "\u725F\u5E73\u533A",
  370613: "\u83B1\u5C71\u533A",
  370634: "\u957F\u5C9B\u53BF",
  370671: "\u70DF\u53F0\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  370672: "\u70DF\u53F0\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  370681: "\u9F99\u53E3\u5E02",
  370682: "\u83B1\u9633\u5E02",
  370683: "\u83B1\u5DDE\u5E02",
  370684: "\u84EC\u83B1\u5E02",
  370685: "\u62DB\u8FDC\u5E02",
  370686: "\u6816\u971E\u5E02",
  370687: "\u6D77\u9633\u5E02",
  370700: "\u6F4D\u574A\u5E02",
  370701: "\u5E02\u8F96\u533A",
  370702: "\u6F4D\u57CE\u533A",
  370703: "\u5BD2\u4EAD\u533A",
  370704: "\u574A\u5B50\u533A",
  370705: "\u594E\u6587\u533A",
  370724: "\u4E34\u6710\u53BF",
  370725: "\u660C\u4E50\u53BF",
  370772: "\u6F4D\u574A\u6EE8\u6D77\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  370781: "\u9752\u5DDE\u5E02",
  370782: "\u8BF8\u57CE\u5E02",
  370783: "\u5BFF\u5149\u5E02",
  370784: "\u5B89\u4E18\u5E02",
  370785: "\u9AD8\u5BC6\u5E02",
  370786: "\u660C\u9091\u5E02",
  370800: "\u6D4E\u5B81\u5E02",
  370801: "\u5E02\u8F96\u533A",
  370811: "\u4EFB\u57CE\u533A",
  370812: "\u5156\u5DDE\u533A",
  370826: "\u5FAE\u5C71\u53BF",
  370827: "\u9C7C\u53F0\u53BF",
  370828: "\u91D1\u4E61\u53BF",
  370829: "\u5609\u7965\u53BF",
  370830: "\u6C76\u4E0A\u53BF",
  370831: "\u6CD7\u6C34\u53BF",
  370832: "\u6881\u5C71\u53BF",
  370871: "\u6D4E\u5B81\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  370881: "\u66F2\u961C\u5E02",
  370883: "\u90B9\u57CE\u5E02",
  370900: "\u6CF0\u5B89\u5E02",
  370901: "\u5E02\u8F96\u533A",
  370902: "\u6CF0\u5C71\u533A",
  370911: "\u5CB1\u5CB3\u533A",
  370921: "\u5B81\u9633\u53BF",
  370923: "\u4E1C\u5E73\u53BF",
  370982: "\u65B0\u6CF0\u5E02",
  370983: "\u80A5\u57CE\u5E02",
  371e3: "\u5A01\u6D77\u5E02",
  371001: "\u5E02\u8F96\u533A",
  371002: "\u73AF\u7FE0\u533A",
  371003: "\u6587\u767B\u533A",
  371071: "\u5A01\u6D77\u706B\u70AC\u9AD8\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  371072: "\u5A01\u6D77\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  371073: "\u5A01\u6D77\u4E34\u6E2F\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  371082: "\u8363\u6210\u5E02",
  371083: "\u4E73\u5C71\u5E02",
  371100: "\u65E5\u7167\u5E02",
  371101: "\u5E02\u8F96\u533A",
  371102: "\u4E1C\u6E2F\u533A",
  371103: "\u5C9A\u5C71\u533A",
  371121: "\u4E94\u83B2\u53BF",
  371122: "\u8392\u53BF",
  371171: "\u65E5\u7167\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  371300: "\u4E34\u6C82\u5E02",
  371301: "\u5E02\u8F96\u533A",
  371302: "\u5170\u5C71\u533A",
  371311: "\u7F57\u5E84\u533A",
  371312: "\u6CB3\u4E1C\u533A",
  371321: "\u6C82\u5357\u53BF",
  371322: "\u90EF\u57CE\u53BF",
  371323: "\u6C82\u6C34\u53BF",
  371324: "\u5170\u9675\u53BF",
  371325: "\u8D39\u53BF",
  371326: "\u5E73\u9091\u53BF",
  371327: "\u8392\u5357\u53BF",
  371328: "\u8499\u9634\u53BF",
  371329: "\u4E34\u6CAD\u53BF",
  371371: "\u4E34\u6C82\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  371372: "\u4E34\u6C82\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  371373: "\u4E34\u6C82\u4E34\u6E2F\u7ECF\u6D4E\u5F00\u53D1\u533A",
  371400: "\u5FB7\u5DDE\u5E02",
  371401: "\u5E02\u8F96\u533A",
  371402: "\u5FB7\u57CE\u533A",
  371403: "\u9675\u57CE\u533A",
  371422: "\u5B81\u6D25\u53BF",
  371423: "\u5E86\u4E91\u53BF",
  371424: "\u4E34\u9091\u53BF",
  371425: "\u9F50\u6CB3\u53BF",
  371426: "\u5E73\u539F\u53BF",
  371427: "\u590F\u6D25\u53BF",
  371428: "\u6B66\u57CE\u53BF",
  371471: "\u5FB7\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  371472: "\u5FB7\u5DDE\u8FD0\u6CB3\u7ECF\u6D4E\u5F00\u53D1\u533A",
  371481: "\u4E50\u9675\u5E02",
  371482: "\u79B9\u57CE\u5E02",
  371500: "\u804A\u57CE\u5E02",
  371501: "\u5E02\u8F96\u533A",
  371502: "\u4E1C\u660C\u5E9C\u533A",
  371503: "\u830C\u5E73\u533A",
  371521: "\u9633\u8C37\u53BF",
  371522: "\u8398\u53BF",
  371524: "\u4E1C\u963F\u53BF",
  371525: "\u51A0\u53BF",
  371526: "\u9AD8\u5510\u53BF",
  371581: "\u4E34\u6E05\u5E02",
  371600: "\u6EE8\u5DDE\u5E02",
  371601: "\u5E02\u8F96\u533A",
  371602: "\u6EE8\u57CE\u533A",
  371603: "\u6CBE\u5316\u533A",
  371621: "\u60E0\u6C11\u53BF",
  371622: "\u9633\u4FE1\u53BF",
  371623: "\u65E0\u68E3\u53BF",
  371625: "\u535A\u5174\u53BF",
  371681: "\u90B9\u5E73\u5E02",
  371700: "\u83CF\u6CFD\u5E02",
  371701: "\u5E02\u8F96\u533A",
  371702: "\u7261\u4E39\u533A",
  371703: "\u5B9A\u9676\u533A",
  371721: "\u66F9\u53BF",
  371722: "\u5355\u53BF",
  371723: "\u6210\u6B66\u53BF",
  371724: "\u5DE8\u91CE\u53BF",
  371725: "\u90D3\u57CE\u53BF",
  371726: "\u9104\u57CE\u53BF",
  371728: "\u4E1C\u660E\u53BF",
  371771: "\u83CF\u6CFD\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  371772: "\u83CF\u6CFD\u9AD8\u65B0\u6280\u672F\u5F00\u53D1\u533A",
  41e4: "\u6CB3\u5357\u7701",
  410100: "\u90D1\u5DDE\u5E02",
  410101: "\u5E02\u8F96\u533A",
  410102: "\u4E2D\u539F\u533A",
  410103: "\u4E8C\u4E03\u533A",
  410104: "\u7BA1\u57CE\u56DE\u65CF\u533A",
  410105: "\u91D1\u6C34\u533A",
  410106: "\u4E0A\u8857\u533A",
  410108: "\u60E0\u6D4E\u533A",
  410122: "\u4E2D\u725F\u53BF",
  410171: "\u90D1\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  410172: "\u90D1\u5DDE\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  410173: "\u90D1\u5DDE\u822A\u7A7A\u6E2F\u7ECF\u6D4E\u7EFC\u5408\u5B9E\u9A8C\u533A",
  410181: "\u5DE9\u4E49\u5E02",
  410182: "\u8365\u9633\u5E02",
  410183: "\u65B0\u5BC6\u5E02",
  410184: "\u65B0\u90D1\u5E02",
  410185: "\u767B\u5C01\u5E02",
  410200: "\u5F00\u5C01\u5E02",
  410201: "\u5E02\u8F96\u533A",
  410202: "\u9F99\u4EAD\u533A",
  410203: "\u987A\u6CB3\u56DE\u65CF\u533A",
  410204: "\u9F13\u697C\u533A",
  410205: "\u79B9\u738B\u53F0\u533A",
  410212: "\u7965\u7B26\u533A",
  410221: "\u675E\u53BF",
  410222: "\u901A\u8BB8\u53BF",
  410223: "\u5C09\u6C0F\u53BF",
  410225: "\u5170\u8003\u53BF",
  410300: "\u6D1B\u9633\u5E02",
  410301: "\u5E02\u8F96\u533A",
  410302: "\u8001\u57CE\u533A",
  410303: "\u897F\u5DE5\u533A",
  410304: "\u700D\u6CB3\u56DE\u65CF\u533A",
  410305: "\u6DA7\u897F\u533A",
  410306: "\u5409\u5229\u533A",
  410311: "\u6D1B\u9F99\u533A",
  410322: "\u5B5F\u6D25\u53BF",
  410323: "\u65B0\u5B89\u53BF",
  410324: "\u683E\u5DDD\u53BF",
  410325: "\u5D69\u53BF",
  410326: "\u6C5D\u9633\u53BF",
  410327: "\u5B9C\u9633\u53BF",
  410328: "\u6D1B\u5B81\u53BF",
  410329: "\u4F0A\u5DDD\u53BF",
  410371: "\u6D1B\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  410381: "\u5043\u5E08\u5E02",
  410400: "\u5E73\u9876\u5C71\u5E02",
  410401: "\u5E02\u8F96\u533A",
  410402: "\u65B0\u534E\u533A",
  410403: "\u536B\u4E1C\u533A",
  410404: "\u77F3\u9F99\u533A",
  410411: "\u6E5B\u6CB3\u533A",
  410421: "\u5B9D\u4E30\u53BF",
  410422: "\u53F6\u53BF",
  410423: "\u9C81\u5C71\u53BF",
  410425: "\u90CF\u53BF",
  410471: "\u5E73\u9876\u5C71\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  410472: "\u5E73\u9876\u5C71\u5E02\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A",
  410481: "\u821E\u94A2\u5E02",
  410482: "\u6C5D\u5DDE\u5E02",
  410500: "\u5B89\u9633\u5E02",
  410501: "\u5E02\u8F96\u533A",
  410502: "\u6587\u5CF0\u533A",
  410503: "\u5317\u5173\u533A",
  410505: "\u6BB7\u90FD\u533A",
  410506: "\u9F99\u5B89\u533A",
  410522: "\u5B89\u9633\u53BF",
  410523: "\u6C64\u9634\u53BF",
  410526: "\u6ED1\u53BF",
  410527: "\u5185\u9EC4\u53BF",
  410571: "\u5B89\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  410581: "\u6797\u5DDE\u5E02",
  410600: "\u9E64\u58C1\u5E02",
  410601: "\u5E02\u8F96\u533A",
  410602: "\u9E64\u5C71\u533A",
  410603: "\u5C71\u57CE\u533A",
  410611: "\u6DC7\u6EE8\u533A",
  410621: "\u6D5A\u53BF",
  410622: "\u6DC7\u53BF",
  410671: "\u9E64\u58C1\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  410700: "\u65B0\u4E61\u5E02",
  410701: "\u5E02\u8F96\u533A",
  410702: "\u7EA2\u65D7\u533A",
  410703: "\u536B\u6EE8\u533A",
  410704: "\u51E4\u6CC9\u533A",
  410711: "\u7267\u91CE\u533A",
  410721: "\u65B0\u4E61\u53BF",
  410724: "\u83B7\u5609\u53BF",
  410725: "\u539F\u9633\u53BF",
  410726: "\u5EF6\u6D25\u53BF",
  410727: "\u5C01\u4E18\u53BF",
  410771: "\u65B0\u4E61\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  410772: "\u65B0\u4E61\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  410773: "\u65B0\u4E61\u5E02\u5E73\u539F\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A",
  410781: "\u536B\u8F89\u5E02",
  410782: "\u8F89\u53BF\u5E02",
  410783: "\u957F\u57A3\u5E02",
  410800: "\u7126\u4F5C\u5E02",
  410801: "\u5E02\u8F96\u533A",
  410802: "\u89E3\u653E\u533A",
  410803: "\u4E2D\u7AD9\u533A",
  410804: "\u9A6C\u6751\u533A",
  410811: "\u5C71\u9633\u533A",
  410821: "\u4FEE\u6B66\u53BF",
  410822: "\u535A\u7231\u53BF",
  410823: "\u6B66\u965F\u53BF",
  410825: "\u6E29\u53BF",
  410871: "\u7126\u4F5C\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A",
  410882: "\u6C81\u9633\u5E02",
  410883: "\u5B5F\u5DDE\u5E02",
  410900: "\u6FEE\u9633\u5E02",
  410901: "\u5E02\u8F96\u533A",
  410902: "\u534E\u9F99\u533A",
  410922: "\u6E05\u4E30\u53BF",
  410923: "\u5357\u4E50\u53BF",
  410926: "\u8303\u53BF",
  410927: "\u53F0\u524D\u53BF",
  410928: "\u6FEE\u9633\u53BF",
  410971: "\u6CB3\u5357\u6FEE\u9633\u5DE5\u4E1A\u56ED\u533A",
  410972: "\u6FEE\u9633\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  411e3: "\u8BB8\u660C\u5E02",
  411001: "\u5E02\u8F96\u533A",
  411002: "\u9B4F\u90FD\u533A",
  411003: "\u5EFA\u5B89\u533A",
  411024: "\u9122\u9675\u53BF",
  411025: "\u8944\u57CE\u53BF",
  411071: "\u8BB8\u660C\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  411081: "\u79B9\u5DDE\u5E02",
  411082: "\u957F\u845B\u5E02",
  411100: "\u6F2F\u6CB3\u5E02",
  411101: "\u5E02\u8F96\u533A",
  411102: "\u6E90\u6C47\u533A",
  411103: "\u90FE\u57CE\u533A",
  411104: "\u53EC\u9675\u533A",
  411121: "\u821E\u9633\u53BF",
  411122: "\u4E34\u988D\u53BF",
  411171: "\u6F2F\u6CB3\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  411200: "\u4E09\u95E8\u5CE1\u5E02",
  411201: "\u5E02\u8F96\u533A",
  411202: "\u6E56\u6EE8\u533A",
  411203: "\u9655\u5DDE\u533A",
  411221: "\u6E11\u6C60\u53BF",
  411224: "\u5362\u6C0F\u53BF",
  411271: "\u6CB3\u5357\u4E09\u95E8\u5CE1\u7ECF\u6D4E\u5F00\u53D1\u533A",
  411281: "\u4E49\u9A6C\u5E02",
  411282: "\u7075\u5B9D\u5E02",
  411300: "\u5357\u9633\u5E02",
  411301: "\u5E02\u8F96\u533A",
  411302: "\u5B9B\u57CE\u533A",
  411303: "\u5367\u9F99\u533A",
  411321: "\u5357\u53EC\u53BF",
  411322: "\u65B9\u57CE\u53BF",
  411323: "\u897F\u5CE1\u53BF",
  411324: "\u9547\u5E73\u53BF",
  411325: "\u5185\u4E61\u53BF",
  411326: "\u6DC5\u5DDD\u53BF",
  411327: "\u793E\u65D7\u53BF",
  411328: "\u5510\u6CB3\u53BF",
  411329: "\u65B0\u91CE\u53BF",
  411330: "\u6850\u67CF\u53BF",
  411371: "\u5357\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  411372: "\u5357\u9633\u5E02\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A",
  411381: "\u9093\u5DDE\u5E02",
  411400: "\u5546\u4E18\u5E02",
  411401: "\u5E02\u8F96\u533A",
  411402: "\u6881\u56ED\u533A",
  411403: "\u7762\u9633\u533A",
  411421: "\u6C11\u6743\u53BF",
  411422: "\u7762\u53BF",
  411423: "\u5B81\u9675\u53BF",
  411424: "\u67D8\u57CE\u53BF",
  411425: "\u865E\u57CE\u53BF",
  411426: "\u590F\u9091\u53BF",
  411471: "\u8C6B\u4E1C\u7EFC\u5408\u7269\u6D41\u4EA7\u4E1A\u805A\u96C6\u533A",
  411472: "\u6CB3\u5357\u5546\u4E18\u7ECF\u6D4E\u5F00\u53D1\u533A",
  411481: "\u6C38\u57CE\u5E02",
  411500: "\u4FE1\u9633\u5E02",
  411501: "\u5E02\u8F96\u533A",
  411502: "\u6D49\u6CB3\u533A",
  411503: "\u5E73\u6865\u533A",
  411521: "\u7F57\u5C71\u53BF",
  411522: "\u5149\u5C71\u53BF",
  411523: "\u65B0\u53BF",
  411524: "\u5546\u57CE\u53BF",
  411525: "\u56FA\u59CB\u53BF",
  411526: "\u6F62\u5DDD\u53BF",
  411527: "\u6DEE\u6EE8\u53BF",
  411528: "\u606F\u53BF",
  411571: "\u4FE1\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A",
  411600: "\u5468\u53E3\u5E02",
  411601: "\u5E02\u8F96\u533A",
  411602: "\u5DDD\u6C47\u533A",
  411603: "\u6DEE\u9633\u533A",
  411621: "\u6276\u6C9F\u53BF",
  411622: "\u897F\u534E\u53BF",
  411623: "\u5546\u6C34\u53BF",
  411624: "\u6C88\u4E18\u53BF",
  411625: "\u90F8\u57CE\u53BF",
  411627: "\u592A\u5EB7\u53BF",
  411628: "\u9E7F\u9091\u53BF",
  411671: "\u6CB3\u5357\u5468\u53E3\u7ECF\u6D4E\u5F00\u53D1\u533A",
  411681: "\u9879\u57CE\u5E02",
  411700: "\u9A7B\u9A6C\u5E97\u5E02",
  411701: "\u5E02\u8F96\u533A",
  411702: "\u9A7F\u57CE\u533A",
  411721: "\u897F\u5E73\u53BF",
  411722: "\u4E0A\u8521\u53BF",
  411723: "\u5E73\u8206\u53BF",
  411724: "\u6B63\u9633\u53BF",
  411725: "\u786E\u5C71\u53BF",
  411726: "\u6CCC\u9633\u53BF",
  411727: "\u6C5D\u5357\u53BF",
  411728: "\u9042\u5E73\u53BF",
  411729: "\u65B0\u8521\u53BF",
  411771: "\u6CB3\u5357\u9A7B\u9A6C\u5E97\u7ECF\u6D4E\u5F00\u53D1\u533A",
  419e3: "\u7701\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
  419001: "\u6D4E\u6E90\u5E02",
  42e4: "\u6E56\u5317\u7701",
  420100: "\u6B66\u6C49\u5E02",
  420101: "\u5E02\u8F96\u533A",
  420102: "\u6C5F\u5CB8\u533A",
  420103: "\u6C5F\u6C49\u533A",
  420104: "\u785A\u53E3\u533A",
  420105: "\u6C49\u9633\u533A",
  420106: "\u6B66\u660C\u533A",
  420107: "\u9752\u5C71\u533A",
  420111: "\u6D2A\u5C71\u533A",
  420112: "\u4E1C\u897F\u6E56\u533A",
  420113: "\u6C49\u5357\u533A",
  420114: "\u8521\u7538\u533A",
  420115: "\u6C5F\u590F\u533A",
  420116: "\u9EC4\u9642\u533A",
  420117: "\u65B0\u6D32\u533A",
  420200: "\u9EC4\u77F3\u5E02",
  420201: "\u5E02\u8F96\u533A",
  420202: "\u9EC4\u77F3\u6E2F\u533A",
  420203: "\u897F\u585E\u5C71\u533A",
  420204: "\u4E0B\u9646\u533A",
  420205: "\u94C1\u5C71\u533A",
  420222: "\u9633\u65B0\u53BF",
  420281: "\u5927\u51B6\u5E02",
  420300: "\u5341\u5830\u5E02",
  420301: "\u5E02\u8F96\u533A",
  420302: "\u8305\u7BAD\u533A",
  420303: "\u5F20\u6E7E\u533A",
  420304: "\u90E7\u9633\u533A",
  420322: "\u90E7\u897F\u53BF",
  420323: "\u7AF9\u5C71\u53BF",
  420324: "\u7AF9\u6EAA\u53BF",
  420325: "\u623F\u53BF",
  420381: "\u4E39\u6C5F\u53E3\u5E02",
  420500: "\u5B9C\u660C\u5E02",
  420501: "\u5E02\u8F96\u533A",
  420502: "\u897F\u9675\u533A",
  420503: "\u4F0D\u5BB6\u5C97\u533A",
  420504: "\u70B9\u519B\u533A",
  420505: "\u7307\u4EAD\u533A",
  420506: "\u5937\u9675\u533A",
  420525: "\u8FDC\u5B89\u53BF",
  420526: "\u5174\u5C71\u53BF",
  420527: "\u79ED\u5F52\u53BF",
  420528: "\u957F\u9633\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF",
  420529: "\u4E94\u5CF0\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF",
  420581: "\u5B9C\u90FD\u5E02",
  420582: "\u5F53\u9633\u5E02",
  420583: "\u679D\u6C5F\u5E02",
  420600: "\u8944\u9633\u5E02",
  420601: "\u5E02\u8F96\u533A",
  420602: "\u8944\u57CE\u533A",
  420606: "\u6A0A\u57CE\u533A",
  420607: "\u8944\u5DDE\u533A",
  420624: "\u5357\u6F33\u53BF",
  420625: "\u8C37\u57CE\u53BF",
  420626: "\u4FDD\u5EB7\u53BF",
  420682: "\u8001\u6CB3\u53E3\u5E02",
  420683: "\u67A3\u9633\u5E02",
  420684: "\u5B9C\u57CE\u5E02",
  420700: "\u9102\u5DDE\u5E02",
  420701: "\u5E02\u8F96\u533A",
  420702: "\u6881\u5B50\u6E56\u533A",
  420703: "\u534E\u5BB9\u533A",
  420704: "\u9102\u57CE\u533A",
  420800: "\u8346\u95E8\u5E02",
  420801: "\u5E02\u8F96\u533A",
  420802: "\u4E1C\u5B9D\u533A",
  420804: "\u6387\u5200\u533A",
  420822: "\u6C99\u6D0B\u53BF",
  420881: "\u949F\u7965\u5E02",
  420882: "\u4EAC\u5C71\u5E02",
  420900: "\u5B5D\u611F\u5E02",
  420901: "\u5E02\u8F96\u533A",
  420902: "\u5B5D\u5357\u533A",
  420921: "\u5B5D\u660C\u53BF",
  420922: "\u5927\u609F\u53BF",
  420923: "\u4E91\u68A6\u53BF",
  420981: "\u5E94\u57CE\u5E02",
  420982: "\u5B89\u9646\u5E02",
  420984: "\u6C49\u5DDD\u5E02",
  421e3: "\u8346\u5DDE\u5E02",
  421001: "\u5E02\u8F96\u533A",
  421002: "\u6C99\u5E02\u533A",
  421003: "\u8346\u5DDE\u533A",
  421022: "\u516C\u5B89\u53BF",
  421023: "\u76D1\u5229\u53BF",
  421024: "\u6C5F\u9675\u53BF",
  421071: "\u8346\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  421081: "\u77F3\u9996\u5E02",
  421083: "\u6D2A\u6E56\u5E02",
  421087: "\u677E\u6ECB\u5E02",
  421100: "\u9EC4\u5188\u5E02",
  421101: "\u5E02\u8F96\u533A",
  421102: "\u9EC4\u5DDE\u533A",
  421121: "\u56E2\u98CE\u53BF",
  421122: "\u7EA2\u5B89\u53BF",
  421123: "\u7F57\u7530\u53BF",
  421124: "\u82F1\u5C71\u53BF",
  421125: "\u6D60\u6C34\u53BF",
  421126: "\u8572\u6625\u53BF",
  421127: "\u9EC4\u6885\u53BF",
  421171: "\u9F99\u611F\u6E56\u7BA1\u7406\u533A",
  421181: "\u9EBB\u57CE\u5E02",
  421182: "\u6B66\u7A74\u5E02",
  421200: "\u54B8\u5B81\u5E02",
  421201: "\u5E02\u8F96\u533A",
  421202: "\u54B8\u5B89\u533A",
  421221: "\u5609\u9C7C\u53BF",
  421222: "\u901A\u57CE\u53BF",
  421223: "\u5D07\u9633\u53BF",
  421224: "\u901A\u5C71\u53BF",
  421281: "\u8D64\u58C1\u5E02",
  421300: "\u968F\u5DDE\u5E02",
  421301: "\u5E02\u8F96\u533A",
  421303: "\u66FE\u90FD\u533A",
  421321: "\u968F\u53BF",
  421381: "\u5E7F\u6C34\u5E02",
  422800: "\u6069\u65BD\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
  422801: "\u6069\u65BD\u5E02",
  422802: "\u5229\u5DDD\u5E02",
  422822: "\u5EFA\u59CB\u53BF",
  422823: "\u5DF4\u4E1C\u53BF",
  422825: "\u5BA3\u6069\u53BF",
  422826: "\u54B8\u4E30\u53BF",
  422827: "\u6765\u51E4\u53BF",
  422828: "\u9E64\u5CF0\u53BF",
  429e3: "\u7701\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
  429004: "\u4ED9\u6843\u5E02",
  429005: "\u6F5C\u6C5F\u5E02",
  429006: "\u5929\u95E8\u5E02",
  429021: "\u795E\u519C\u67B6\u6797\u533A",
  43e4: "\u6E56\u5357\u7701",
  430100: "\u957F\u6C99\u5E02",
  430101: "\u5E02\u8F96\u533A",
  430102: "\u8299\u84C9\u533A",
  430103: "\u5929\u5FC3\u533A",
  430104: "\u5CB3\u9E93\u533A",
  430105: "\u5F00\u798F\u533A",
  430111: "\u96E8\u82B1\u533A",
  430112: "\u671B\u57CE\u533A",
  430121: "\u957F\u6C99\u53BF",
  430181: "\u6D4F\u9633\u5E02",
  430182: "\u5B81\u4E61\u5E02",
  430200: "\u682A\u6D32\u5E02",
  430201: "\u5E02\u8F96\u533A",
  430202: "\u8377\u5858\u533A",
  430203: "\u82A6\u6DDE\u533A",
  430204: "\u77F3\u5CF0\u533A",
  430211: "\u5929\u5143\u533A",
  430212: "\u6E0C\u53E3\u533A",
  430223: "\u6538\u53BF",
  430224: "\u8336\u9675\u53BF",
  430225: "\u708E\u9675\u53BF",
  430271: "\u4E91\u9F99\u793A\u8303\u533A",
  430281: "\u91B4\u9675\u5E02",
  430300: "\u6E58\u6F6D\u5E02",
  430301: "\u5E02\u8F96\u533A",
  430302: "\u96E8\u6E56\u533A",
  430304: "\u5CB3\u5858\u533A",
  430321: "\u6E58\u6F6D\u53BF",
  430371: "\u6E56\u5357\u6E58\u6F6D\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A",
  430372: "\u6E58\u6F6D\u662D\u5C71\u793A\u8303\u533A",
  430373: "\u6E58\u6F6D\u4E5D\u534E\u793A\u8303\u533A",
  430381: "\u6E58\u4E61\u5E02",
  430382: "\u97F6\u5C71\u5E02",
  430400: "\u8861\u9633\u5E02",
  430401: "\u5E02\u8F96\u533A",
  430405: "\u73E0\u6656\u533A",
  430406: "\u96C1\u5CF0\u533A",
  430407: "\u77F3\u9F13\u533A",
  430408: "\u84B8\u6E58\u533A",
  430412: "\u5357\u5CB3\u533A",
  430421: "\u8861\u9633\u53BF",
  430422: "\u8861\u5357\u53BF",
  430423: "\u8861\u5C71\u53BF",
  430424: "\u8861\u4E1C\u53BF",
  430426: "\u7941\u4E1C\u53BF",
  430471: "\u8861\u9633\u7EFC\u5408\u4FDD\u7A0E\u533A",
  430472: "\u6E56\u5357\u8861\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A",
  430473: "\u6E56\u5357\u8861\u9633\u677E\u6728\u7ECF\u6D4E\u5F00\u53D1\u533A",
  430481: "\u8012\u9633\u5E02",
  430482: "\u5E38\u5B81\u5E02",
  430500: "\u90B5\u9633\u5E02",
  430501: "\u5E02\u8F96\u533A",
  430502: "\u53CC\u6E05\u533A",
  430503: "\u5927\u7965\u533A",
  430511: "\u5317\u5854\u533A",
  430522: "\u65B0\u90B5\u53BF",
  430523: "\u90B5\u9633\u53BF",
  430524: "\u9686\u56DE\u53BF",
  430525: "\u6D1E\u53E3\u53BF",
  430527: "\u7EE5\u5B81\u53BF",
  430528: "\u65B0\u5B81\u53BF",
  430529: "\u57CE\u6B65\u82D7\u65CF\u81EA\u6CBB\u53BF",
  430581: "\u6B66\u5188\u5E02",
  430582: "\u90B5\u4E1C\u5E02",
  430600: "\u5CB3\u9633\u5E02",
  430601: "\u5E02\u8F96\u533A",
  430602: "\u5CB3\u9633\u697C\u533A",
  430603: "\u4E91\u6EAA\u533A",
  430611: "\u541B\u5C71\u533A",
  430621: "\u5CB3\u9633\u53BF",
  430623: "\u534E\u5BB9\u53BF",
  430624: "\u6E58\u9634\u53BF",
  430626: "\u5E73\u6C5F\u53BF",
  430671: "\u5CB3\u9633\u5E02\u5C48\u539F\u7BA1\u7406\u533A",
  430681: "\u6C68\u7F57\u5E02",
  430682: "\u4E34\u6E58\u5E02",
  430700: "\u5E38\u5FB7\u5E02",
  430701: "\u5E02\u8F96\u533A",
  430702: "\u6B66\u9675\u533A",
  430703: "\u9F0E\u57CE\u533A",
  430721: "\u5B89\u4E61\u53BF",
  430722: "\u6C49\u5BFF\u53BF",
  430723: "\u6FA7\u53BF",
  430724: "\u4E34\u6FA7\u53BF",
  430725: "\u6843\u6E90\u53BF",
  430726: "\u77F3\u95E8\u53BF",
  430771: "\u5E38\u5FB7\u5E02\u897F\u6D1E\u5EAD\u7BA1\u7406\u533A",
  430781: "\u6D25\u5E02\u5E02",
  430800: "\u5F20\u5BB6\u754C\u5E02",
  430801: "\u5E02\u8F96\u533A",
  430802: "\u6C38\u5B9A\u533A",
  430811: "\u6B66\u9675\u6E90\u533A",
  430821: "\u6148\u5229\u53BF",
  430822: "\u6851\u690D\u53BF",
  430900: "\u76CA\u9633\u5E02",
  430901: "\u5E02\u8F96\u533A",
  430902: "\u8D44\u9633\u533A",
  430903: "\u8D6B\u5C71\u533A",
  430921: "\u5357\u53BF",
  430922: "\u6843\u6C5F\u53BF",
  430923: "\u5B89\u5316\u53BF",
  430971: "\u76CA\u9633\u5E02\u5927\u901A\u6E56\u7BA1\u7406\u533A",
  430972: "\u6E56\u5357\u76CA\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A",
  430981: "\u6C85\u6C5F\u5E02",
  431e3: "\u90F4\u5DDE\u5E02",
  431001: "\u5E02\u8F96\u533A",
  431002: "\u5317\u6E56\u533A",
  431003: "\u82CF\u4ED9\u533A",
  431021: "\u6842\u9633\u53BF",
  431022: "\u5B9C\u7AE0\u53BF",
  431023: "\u6C38\u5174\u53BF",
  431024: "\u5609\u79BE\u53BF",
  431025: "\u4E34\u6B66\u53BF",
  431026: "\u6C5D\u57CE\u53BF",
  431027: "\u6842\u4E1C\u53BF",
  431028: "\u5B89\u4EC1\u53BF",
  431081: "\u8D44\u5174\u5E02",
  431100: "\u6C38\u5DDE\u5E02",
  431101: "\u5E02\u8F96\u533A",
  431102: "\u96F6\u9675\u533A",
  431103: "\u51B7\u6C34\u6EE9\u533A",
  431121: "\u7941\u9633\u53BF",
  431122: "\u4E1C\u5B89\u53BF",
  431123: "\u53CC\u724C\u53BF",
  431124: "\u9053\u53BF",
  431125: "\u6C5F\u6C38\u53BF",
  431126: "\u5B81\u8FDC\u53BF",
  431127: "\u84DD\u5C71\u53BF",
  431128: "\u65B0\u7530\u53BF",
  431129: "\u6C5F\u534E\u7476\u65CF\u81EA\u6CBB\u53BF",
  431171: "\u6C38\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  431172: "\u6C38\u5DDE\u5E02\u91D1\u6D1E\u7BA1\u7406\u533A",
  431173: "\u6C38\u5DDE\u5E02\u56DE\u9F99\u5729\u7BA1\u7406\u533A",
  431200: "\u6000\u5316\u5E02",
  431201: "\u5E02\u8F96\u533A",
  431202: "\u9E64\u57CE\u533A",
  431221: "\u4E2D\u65B9\u53BF",
  431222: "\u6C85\u9675\u53BF",
  431223: "\u8FB0\u6EAA\u53BF",
  431224: "\u6E86\u6D66\u53BF",
  431225: "\u4F1A\u540C\u53BF",
  431226: "\u9EBB\u9633\u82D7\u65CF\u81EA\u6CBB\u53BF",
  431227: "\u65B0\u6643\u4F97\u65CF\u81EA\u6CBB\u53BF",
  431228: "\u82B7\u6C5F\u4F97\u65CF\u81EA\u6CBB\u53BF",
  431229: "\u9756\u5DDE\u82D7\u65CF\u4F97\u65CF\u81EA\u6CBB\u53BF",
  431230: "\u901A\u9053\u4F97\u65CF\u81EA\u6CBB\u53BF",
  431271: "\u6000\u5316\u5E02\u6D2A\u6C5F\u7BA1\u7406\u533A",
  431281: "\u6D2A\u6C5F\u5E02",
  431300: "\u5A04\u5E95\u5E02",
  431301: "\u5E02\u8F96\u533A",
  431302: "\u5A04\u661F\u533A",
  431321: "\u53CC\u5CF0\u53BF",
  431322: "\u65B0\u5316\u53BF",
  431381: "\u51B7\u6C34\u6C5F\u5E02",
  431382: "\u6D9F\u6E90\u5E02",
  433100: "\u6E58\u897F\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
  433101: "\u5409\u9996\u5E02",
  433122: "\u6CF8\u6EAA\u53BF",
  433123: "\u51E4\u51F0\u53BF",
  433124: "\u82B1\u57A3\u53BF",
  433125: "\u4FDD\u9756\u53BF",
  433126: "\u53E4\u4E08\u53BF",
  433127: "\u6C38\u987A\u53BF",
  433130: "\u9F99\u5C71\u53BF",
  433173: "\u6E56\u5357\u6C38\u987A\u7ECF\u6D4E\u5F00\u53D1\u533A",
  44e4: "\u5E7F\u4E1C\u7701",
  440100: "\u5E7F\u5DDE\u5E02",
  440101: "\u5E02\u8F96\u533A",
  440103: "\u8354\u6E7E\u533A",
  440104: "\u8D8A\u79C0\u533A",
  440105: "\u6D77\u73E0\u533A",
  440106: "\u5929\u6CB3\u533A",
  440111: "\u767D\u4E91\u533A",
  440112: "\u9EC4\u57D4\u533A",
  440113: "\u756A\u79BA\u533A",
  440114: "\u82B1\u90FD\u533A",
  440115: "\u5357\u6C99\u533A",
  440117: "\u4ECE\u5316\u533A",
  440118: "\u589E\u57CE\u533A",
  440200: "\u97F6\u5173\u5E02",
  440201: "\u5E02\u8F96\u533A",
  440203: "\u6B66\u6C5F\u533A",
  440204: "\u6D48\u6C5F\u533A",
  440205: "\u66F2\u6C5F\u533A",
  440222: "\u59CB\u5174\u53BF",
  440224: "\u4EC1\u5316\u53BF",
  440229: "\u7FC1\u6E90\u53BF",
  440232: "\u4E73\u6E90\u7476\u65CF\u81EA\u6CBB\u53BF",
  440233: "\u65B0\u4E30\u53BF",
  440281: "\u4E50\u660C\u5E02",
  440282: "\u5357\u96C4\u5E02",
  440300: "\u6DF1\u5733\u5E02",
  440301: "\u5E02\u8F96\u533A",
  440303: "\u7F57\u6E56\u533A",
  440304: "\u798F\u7530\u533A",
  440305: "\u5357\u5C71\u533A",
  440306: "\u5B9D\u5B89\u533A",
  440307: "\u9F99\u5C97\u533A",
  440308: "\u76D0\u7530\u533A",
  440309: "\u9F99\u534E\u533A",
  440310: "\u576A\u5C71\u533A",
  440311: "\u5149\u660E\u533A",
  440400: "\u73E0\u6D77\u5E02",
  440401: "\u5E02\u8F96\u533A",
  440402: "\u9999\u6D32\u533A",
  440403: "\u6597\u95E8\u533A",
  440404: "\u91D1\u6E7E\u533A",
  440500: "\u6C55\u5934\u5E02",
  440501: "\u5E02\u8F96\u533A",
  440507: "\u9F99\u6E56\u533A",
  440511: "\u91D1\u5E73\u533A",
  440512: "\u6FE0\u6C5F\u533A",
  440513: "\u6F6E\u9633\u533A",
  440514: "\u6F6E\u5357\u533A",
  440515: "\u6F84\u6D77\u533A",
  440523: "\u5357\u6FB3\u53BF",
  440600: "\u4F5B\u5C71\u5E02",
  440601: "\u5E02\u8F96\u533A",
  440604: "\u7985\u57CE\u533A",
  440605: "\u5357\u6D77\u533A",
  440606: "\u987A\u5FB7\u533A",
  440607: "\u4E09\u6C34\u533A",
  440608: "\u9AD8\u660E\u533A",
  440700: "\u6C5F\u95E8\u5E02",
  440701: "\u5E02\u8F96\u533A",
  440703: "\u84EC\u6C5F\u533A",
  440704: "\u6C5F\u6D77\u533A",
  440705: "\u65B0\u4F1A\u533A",
  440781: "\u53F0\u5C71\u5E02",
  440783: "\u5F00\u5E73\u5E02",
  440784: "\u9E64\u5C71\u5E02",
  440785: "\u6069\u5E73\u5E02",
  440800: "\u6E5B\u6C5F\u5E02",
  440801: "\u5E02\u8F96\u533A",
  440802: "\u8D64\u574E\u533A",
  440803: "\u971E\u5C71\u533A",
  440804: "\u5761\u5934\u533A",
  440811: "\u9EBB\u7AE0\u533A",
  440823: "\u9042\u6EAA\u53BF",
  440825: "\u5F90\u95FB\u53BF",
  440881: "\u5EC9\u6C5F\u5E02",
  440882: "\u96F7\u5DDE\u5E02",
  440883: "\u5434\u5DDD\u5E02",
  440900: "\u8302\u540D\u5E02",
  440901: "\u5E02\u8F96\u533A",
  440902: "\u8302\u5357\u533A",
  440904: "\u7535\u767D\u533A",
  440981: "\u9AD8\u5DDE\u5E02",
  440982: "\u5316\u5DDE\u5E02",
  440983: "\u4FE1\u5B9C\u5E02",
  441200: "\u8087\u5E86\u5E02",
  441201: "\u5E02\u8F96\u533A",
  441202: "\u7AEF\u5DDE\u533A",
  441203: "\u9F0E\u6E56\u533A",
  441204: "\u9AD8\u8981\u533A",
  441223: "\u5E7F\u5B81\u53BF",
  441224: "\u6000\u96C6\u53BF",
  441225: "\u5C01\u5F00\u53BF",
  441226: "\u5FB7\u5E86\u53BF",
  441284: "\u56DB\u4F1A\u5E02",
  441300: "\u60E0\u5DDE\u5E02",
  441301: "\u5E02\u8F96\u533A",
  441302: "\u60E0\u57CE\u533A",
  441303: "\u60E0\u9633\u533A",
  441322: "\u535A\u7F57\u53BF",
  441323: "\u60E0\u4E1C\u53BF",
  441324: "\u9F99\u95E8\u53BF",
  441400: "\u6885\u5DDE\u5E02",
  441401: "\u5E02\u8F96\u533A",
  441402: "\u6885\u6C5F\u533A",
  441403: "\u6885\u53BF\u533A",
  441422: "\u5927\u57D4\u53BF",
  441423: "\u4E30\u987A\u53BF",
  441424: "\u4E94\u534E\u53BF",
  441426: "\u5E73\u8FDC\u53BF",
  441427: "\u8549\u5CAD\u53BF",
  441481: "\u5174\u5B81\u5E02",
  441500: "\u6C55\u5C3E\u5E02",
  441501: "\u5E02\u8F96\u533A",
  441502: "\u57CE\u533A",
  441521: "\u6D77\u4E30\u53BF",
  441523: "\u9646\u6CB3\u53BF",
  441581: "\u9646\u4E30\u5E02",
  441600: "\u6CB3\u6E90\u5E02",
  441601: "\u5E02\u8F96\u533A",
  441602: "\u6E90\u57CE\u533A",
  441621: "\u7D2B\u91D1\u53BF",
  441622: "\u9F99\u5DDD\u53BF",
  441623: "\u8FDE\u5E73\u53BF",
  441624: "\u548C\u5E73\u53BF",
  441625: "\u4E1C\u6E90\u53BF",
  441700: "\u9633\u6C5F\u5E02",
  441701: "\u5E02\u8F96\u533A",
  441702: "\u6C5F\u57CE\u533A",
  441704: "\u9633\u4E1C\u533A",
  441721: "\u9633\u897F\u53BF",
  441781: "\u9633\u6625\u5E02",
  441800: "\u6E05\u8FDC\u5E02",
  441801: "\u5E02\u8F96\u533A",
  441802: "\u6E05\u57CE\u533A",
  441803: "\u6E05\u65B0\u533A",
  441821: "\u4F5B\u5188\u53BF",
  441823: "\u9633\u5C71\u53BF",
  441825: "\u8FDE\u5C71\u58EE\u65CF\u7476\u65CF\u81EA\u6CBB\u53BF",
  441826: "\u8FDE\u5357\u7476\u65CF\u81EA\u6CBB\u53BF",
  441881: "\u82F1\u5FB7\u5E02",
  441882: "\u8FDE\u5DDE\u5E02",
  441900: "\u4E1C\u839E\u5E02",
  442e3: "\u4E2D\u5C71\u5E02",
  445100: "\u6F6E\u5DDE\u5E02",
  445101: "\u5E02\u8F96\u533A",
  445102: "\u6E58\u6865\u533A",
  445103: "\u6F6E\u5B89\u533A",
  445122: "\u9976\u5E73\u53BF",
  445200: "\u63ED\u9633\u5E02",
  445201: "\u5E02\u8F96\u533A",
  445202: "\u6995\u57CE\u533A",
  445203: "\u63ED\u4E1C\u533A",
  445222: "\u63ED\u897F\u53BF",
  445224: "\u60E0\u6765\u53BF",
  445281: "\u666E\u5B81\u5E02",
  445300: "\u4E91\u6D6E\u5E02",
  445301: "\u5E02\u8F96\u533A",
  445302: "\u4E91\u57CE\u533A",
  445303: "\u4E91\u5B89\u533A",
  445321: "\u65B0\u5174\u53BF",
  445322: "\u90C1\u5357\u53BF",
  445381: "\u7F57\u5B9A\u5E02",
  45e4: "\u5E7F\u897F\u58EE\u65CF\u81EA\u6CBB\u533A",
  450100: "\u5357\u5B81\u5E02",
  450101: "\u5E02\u8F96\u533A",
  450102: "\u5174\u5B81\u533A",
  450103: "\u9752\u79C0\u533A",
  450105: "\u6C5F\u5357\u533A",
  450107: "\u897F\u4E61\u5858\u533A",
  450108: "\u826F\u5E86\u533A",
  450109: "\u9095\u5B81\u533A",
  450110: "\u6B66\u9E23\u533A",
  450123: "\u9686\u5B89\u53BF",
  450124: "\u9A6C\u5C71\u53BF",
  450125: "\u4E0A\u6797\u53BF",
  450126: "\u5BBE\u9633\u53BF",
  450127: "\u6A2A\u53BF",
  450200: "\u67F3\u5DDE\u5E02",
  450201: "\u5E02\u8F96\u533A",
  450202: "\u57CE\u4E2D\u533A",
  450203: "\u9C7C\u5CF0\u533A",
  450204: "\u67F3\u5357\u533A",
  450205: "\u67F3\u5317\u533A",
  450206: "\u67F3\u6C5F\u533A",
  450222: "\u67F3\u57CE\u53BF",
  450223: "\u9E7F\u5BE8\u53BF",
  450224: "\u878D\u5B89\u53BF",
  450225: "\u878D\u6C34\u82D7\u65CF\u81EA\u6CBB\u53BF",
  450226: "\u4E09\u6C5F\u4F97\u65CF\u81EA\u6CBB\u53BF",
  450300: "\u6842\u6797\u5E02",
  450301: "\u5E02\u8F96\u533A",
  450302: "\u79C0\u5CF0\u533A",
  450303: "\u53E0\u5F69\u533A",
  450304: "\u8C61\u5C71\u533A",
  450305: "\u4E03\u661F\u533A",
  450311: "\u96C1\u5C71\u533A",
  450312: "\u4E34\u6842\u533A",
  450321: "\u9633\u6714\u53BF",
  450323: "\u7075\u5DDD\u53BF",
  450324: "\u5168\u5DDE\u53BF",
  450325: "\u5174\u5B89\u53BF",
  450326: "\u6C38\u798F\u53BF",
  450327: "\u704C\u9633\u53BF",
  450328: "\u9F99\u80DC\u5404\u65CF\u81EA\u6CBB\u53BF",
  450329: "\u8D44\u6E90\u53BF",
  450330: "\u5E73\u4E50\u53BF",
  450332: "\u606D\u57CE\u7476\u65CF\u81EA\u6CBB\u53BF",
  450381: "\u8354\u6D66\u5E02",
  450400: "\u68A7\u5DDE\u5E02",
  450401: "\u5E02\u8F96\u533A",
  450403: "\u4E07\u79C0\u533A",
  450405: "\u957F\u6D32\u533A",
  450406: "\u9F99\u5729\u533A",
  450421: "\u82CD\u68A7\u53BF",
  450422: "\u85E4\u53BF",
  450423: "\u8499\u5C71\u53BF",
  450481: "\u5C91\u6EAA\u5E02",
  450500: "\u5317\u6D77\u5E02",
  450501: "\u5E02\u8F96\u533A",
  450502: "\u6D77\u57CE\u533A",
  450503: "\u94F6\u6D77\u533A",
  450512: "\u94C1\u5C71\u6E2F\u533A",
  450521: "\u5408\u6D66\u53BF",
  450600: "\u9632\u57CE\u6E2F\u5E02",
  450601: "\u5E02\u8F96\u533A",
  450602: "\u6E2F\u53E3\u533A",
  450603: "\u9632\u57CE\u533A",
  450621: "\u4E0A\u601D\u53BF",
  450681: "\u4E1C\u5174\u5E02",
  450700: "\u94A6\u5DDE\u5E02",
  450701: "\u5E02\u8F96\u533A",
  450702: "\u94A6\u5357\u533A",
  450703: "\u94A6\u5317\u533A",
  450721: "\u7075\u5C71\u53BF",
  450722: "\u6D66\u5317\u53BF",
  450800: "\u8D35\u6E2F\u5E02",
  450801: "\u5E02\u8F96\u533A",
  450802: "\u6E2F\u5317\u533A",
  450803: "\u6E2F\u5357\u533A",
  450804: "\u8983\u5858\u533A",
  450821: "\u5E73\u5357\u53BF",
  450881: "\u6842\u5E73\u5E02",
  450900: "\u7389\u6797\u5E02",
  450901: "\u5E02\u8F96\u533A",
  450902: "\u7389\u5DDE\u533A",
  450903: "\u798F\u7EF5\u533A",
  450921: "\u5BB9\u53BF",
  450922: "\u9646\u5DDD\u53BF",
  450923: "\u535A\u767D\u53BF",
  450924: "\u5174\u4E1A\u53BF",
  450981: "\u5317\u6D41\u5E02",
  451e3: "\u767E\u8272\u5E02",
  451001: "\u5E02\u8F96\u533A",
  451002: "\u53F3\u6C5F\u533A",
  451003: "\u7530\u9633\u533A",
  451022: "\u7530\u4E1C\u53BF",
  451023: "\u5E73\u679C\u53BF",
  451024: "\u5FB7\u4FDD\u53BF",
  451026: "\u90A3\u5761\u53BF",
  451027: "\u51CC\u4E91\u53BF",
  451028: "\u4E50\u4E1A\u53BF",
  451029: "\u7530\u6797\u53BF",
  451030: "\u897F\u6797\u53BF",
  451031: "\u9686\u6797\u5404\u65CF\u81EA\u6CBB\u53BF",
  451081: "\u9756\u897F\u5E02",
  451100: "\u8D3A\u5DDE\u5E02",
  451101: "\u5E02\u8F96\u533A",
  451102: "\u516B\u6B65\u533A",
  451103: "\u5E73\u6842\u533A",
  451121: "\u662D\u5E73\u53BF",
  451122: "\u949F\u5C71\u53BF",
  451123: "\u5BCC\u5DDD\u7476\u65CF\u81EA\u6CBB\u53BF",
  451200: "\u6CB3\u6C60\u5E02",
  451201: "\u5E02\u8F96\u533A",
  451202: "\u91D1\u57CE\u6C5F\u533A",
  451203: "\u5B9C\u5DDE\u533A",
  451221: "\u5357\u4E39\u53BF",
  451222: "\u5929\u5CE8\u53BF",
  451223: "\u51E4\u5C71\u53BF",
  451224: "\u4E1C\u5170\u53BF",
  451225: "\u7F57\u57CE\u4EEB\u4F6C\u65CF\u81EA\u6CBB\u53BF",
  451226: "\u73AF\u6C5F\u6BDB\u5357\u65CF\u81EA\u6CBB\u53BF",
  451227: "\u5DF4\u9A6C\u7476\u65CF\u81EA\u6CBB\u53BF",
  451228: "\u90FD\u5B89\u7476\u65CF\u81EA\u6CBB\u53BF",
  451229: "\u5927\u5316\u7476\u65CF\u81EA\u6CBB\u53BF",
  451300: "\u6765\u5BBE\u5E02",
  451301: "\u5E02\u8F96\u533A",
  451302: "\u5174\u5BBE\u533A",
  451321: "\u5FFB\u57CE\u53BF",
  451322: "\u8C61\u5DDE\u53BF",
  451323: "\u6B66\u5BA3\u53BF",
  451324: "\u91D1\u79C0\u7476\u65CF\u81EA\u6CBB\u53BF",
  451381: "\u5408\u5C71\u5E02",
  451400: "\u5D07\u5DE6\u5E02",
  451401: "\u5E02\u8F96\u533A",
  451402: "\u6C5F\u5DDE\u533A",
  451421: "\u6276\u7EE5\u53BF",
  451422: "\u5B81\u660E\u53BF",
  451423: "\u9F99\u5DDE\u53BF",
  451424: "\u5927\u65B0\u53BF",
  451425: "\u5929\u7B49\u53BF",
  451481: "\u51ED\u7965\u5E02",
  46e4: "\u6D77\u5357\u7701",
  460100: "\u6D77\u53E3\u5E02",
  460101: "\u5E02\u8F96\u533A",
  460105: "\u79C0\u82F1\u533A",
  460106: "\u9F99\u534E\u533A",
  460107: "\u743C\u5C71\u533A",
  460108: "\u7F8E\u5170\u533A",
  460200: "\u4E09\u4E9A\u5E02",
  460201: "\u5E02\u8F96\u533A",
  460202: "\u6D77\u68E0\u533A",
  460203: "\u5409\u9633\u533A",
  460204: "\u5929\u6DAF\u533A",
  460205: "\u5D16\u5DDE\u533A",
  460300: "\u4E09\u6C99\u5E02",
  460321: "\u897F\u6C99\u7FA4\u5C9B",
  460322: "\u5357\u6C99\u7FA4\u5C9B",
  460323: "\u4E2D\u6C99\u7FA4\u5C9B\u7684\u5C9B\u7901\u53CA\u5176\u6D77\u57DF",
  460400: "\u510B\u5DDE\u5E02",
  469e3: "\u7701\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
  469001: "\u4E94\u6307\u5C71\u5E02",
  469002: "\u743C\u6D77\u5E02",
  469005: "\u6587\u660C\u5E02",
  469006: "\u4E07\u5B81\u5E02",
  469007: "\u4E1C\u65B9\u5E02",
  469021: "\u5B9A\u5B89\u53BF",
  469022: "\u5C6F\u660C\u53BF",
  469023: "\u6F84\u8FC8\u53BF",
  469024: "\u4E34\u9AD8\u53BF",
  469025: "\u767D\u6C99\u9ECE\u65CF\u81EA\u6CBB\u53BF",
  469026: "\u660C\u6C5F\u9ECE\u65CF\u81EA\u6CBB\u53BF",
  469027: "\u4E50\u4E1C\u9ECE\u65CF\u81EA\u6CBB\u53BF",
  469028: "\u9675\u6C34\u9ECE\u65CF\u81EA\u6CBB\u53BF",
  469029: "\u4FDD\u4EAD\u9ECE\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  469030: "\u743C\u4E2D\u9ECE\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  5e5: "\u91CD\u5E86\u5E02",
  500100: "\u91CD\u5E86\u5E02",
  500101: "\u4E07\u5DDE\u533A",
  500102: "\u6DAA\u9675\u533A",
  500103: "\u6E1D\u4E2D\u533A",
  500104: "\u5927\u6E21\u53E3\u533A",
  500105: "\u6C5F\u5317\u533A",
  500106: "\u6C99\u576A\u575D\u533A",
  500107: "\u4E5D\u9F99\u5761\u533A",
  500108: "\u5357\u5CB8\u533A",
  500109: "\u5317\u789A\u533A",
  500110: "\u7DA6\u6C5F\u533A",
  500111: "\u5927\u8DB3\u533A",
  500112: "\u6E1D\u5317\u533A",
  500113: "\u5DF4\u5357\u533A",
  500114: "\u9ED4\u6C5F\u533A",
  500115: "\u957F\u5BFF\u533A",
  500116: "\u6C5F\u6D25\u533A",
  500117: "\u5408\u5DDD\u533A",
  500118: "\u6C38\u5DDD\u533A",
  500119: "\u5357\u5DDD\u533A",
  500120: "\u74A7\u5C71\u533A",
  500151: "\u94DC\u6881\u533A",
  500152: "\u6F7C\u5357\u533A",
  500153: "\u8363\u660C\u533A",
  500154: "\u5F00\u5DDE\u533A",
  500155: "\u6881\u5E73\u533A",
  500156: "\u6B66\u9686\u533A",
  500200: "\u53BF",
  500229: "\u57CE\u53E3\u53BF",
  500230: "\u4E30\u90FD\u53BF",
  500231: "\u57AB\u6C5F\u53BF",
  500233: "\u5FE0\u53BF",
  500235: "\u4E91\u9633\u53BF",
  500236: "\u5949\u8282\u53BF",
  500237: "\u5DEB\u5C71\u53BF",
  500238: "\u5DEB\u6EAA\u53BF",
  500240: "\u77F3\u67F1\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF",
  500241: "\u79C0\u5C71\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  500242: "\u9149\u9633\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  500243: "\u5F6D\u6C34\u82D7\u65CF\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF",
  51e4: "\u56DB\u5DDD\u7701",
  510100: "\u6210\u90FD\u5E02",
  510101: "\u5E02\u8F96\u533A",
  510104: "\u9526\u6C5F\u533A",
  510105: "\u9752\u7F8A\u533A",
  510106: "\u91D1\u725B\u533A",
  510107: "\u6B66\u4FAF\u533A",
  510108: "\u6210\u534E\u533A",
  510112: "\u9F99\u6CC9\u9A7F\u533A",
  510113: "\u9752\u767D\u6C5F\u533A",
  510114: "\u65B0\u90FD\u533A",
  510115: "\u6E29\u6C5F\u533A",
  510116: "\u53CC\u6D41\u533A",
  510117: "\u90EB\u90FD\u533A",
  510121: "\u91D1\u5802\u53BF",
  510129: "\u5927\u9091\u53BF",
  510131: "\u84B2\u6C5F\u53BF",
  510132: "\u65B0\u6D25\u53BF",
  510181: "\u90FD\u6C5F\u5830\u5E02",
  510182: "\u5F6D\u5DDE\u5E02",
  510183: "\u909B\u5D03\u5E02",
  510184: "\u5D07\u5DDE\u5E02",
  510185: "\u7B80\u9633\u5E02",
  510300: "\u81EA\u8D21\u5E02",
  510301: "\u5E02\u8F96\u533A",
  510302: "\u81EA\u6D41\u4E95\u533A",
  510303: "\u8D21\u4E95\u533A",
  510304: "\u5927\u5B89\u533A",
  510311: "\u6CBF\u6EE9\u533A",
  510321: "\u8363\u53BF",
  510322: "\u5BCC\u987A\u53BF",
  510400: "\u6500\u679D\u82B1\u5E02",
  510401: "\u5E02\u8F96\u533A",
  510402: "\u4E1C\u533A",
  510403: "\u897F\u533A",
  510411: "\u4EC1\u548C\u533A",
  510421: "\u7C73\u6613\u53BF",
  510422: "\u76D0\u8FB9\u53BF",
  510500: "\u6CF8\u5DDE\u5E02",
  510501: "\u5E02\u8F96\u533A",
  510502: "\u6C5F\u9633\u533A",
  510503: "\u7EB3\u6EAA\u533A",
  510504: "\u9F99\u9A6C\u6F6D\u533A",
  510521: "\u6CF8\u53BF",
  510522: "\u5408\u6C5F\u53BF",
  510524: "\u53D9\u6C38\u53BF",
  510525: "\u53E4\u853A\u53BF",
  510600: "\u5FB7\u9633\u5E02",
  510601: "\u5E02\u8F96\u533A",
  510603: "\u65CC\u9633\u533A",
  510604: "\u7F57\u6C5F\u533A",
  510623: "\u4E2D\u6C5F\u53BF",
  510681: "\u5E7F\u6C49\u5E02",
  510682: "\u4EC0\u90A1\u5E02",
  510683: "\u7EF5\u7AF9\u5E02",
  510700: "\u7EF5\u9633\u5E02",
  510701: "\u5E02\u8F96\u533A",
  510703: "\u6DAA\u57CE\u533A",
  510704: "\u6E38\u4ED9\u533A",
  510705: "\u5B89\u5DDE\u533A",
  510722: "\u4E09\u53F0\u53BF",
  510723: "\u76D0\u4EAD\u53BF",
  510725: "\u6893\u6F7C\u53BF",
  510726: "\u5317\u5DDD\u7F8C\u65CF\u81EA\u6CBB\u53BF",
  510727: "\u5E73\u6B66\u53BF",
  510781: "\u6C5F\u6CB9\u5E02",
  510800: "\u5E7F\u5143\u5E02",
  510801: "\u5E02\u8F96\u533A",
  510802: "\u5229\u5DDE\u533A",
  510811: "\u662D\u5316\u533A",
  510812: "\u671D\u5929\u533A",
  510821: "\u65FA\u82CD\u53BF",
  510822: "\u9752\u5DDD\u53BF",
  510823: "\u5251\u9601\u53BF",
  510824: "\u82CD\u6EAA\u53BF",
  510900: "\u9042\u5B81\u5E02",
  510901: "\u5E02\u8F96\u533A",
  510903: "\u8239\u5C71\u533A",
  510904: "\u5B89\u5C45\u533A",
  510921: "\u84EC\u6EAA\u53BF",
  510923: "\u5927\u82F1\u53BF",
  510981: "\u5C04\u6D2A\u5E02",
  511e3: "\u5185\u6C5F\u5E02",
  511001: "\u5E02\u8F96\u533A",
  511002: "\u5E02\u4E2D\u533A",
  511011: "\u4E1C\u5174\u533A",
  511024: "\u5A01\u8FDC\u53BF",
  511025: "\u8D44\u4E2D\u53BF",
  511071: "\u5185\u6C5F\u7ECF\u6D4E\u5F00\u53D1\u533A",
  511083: "\u9686\u660C\u5E02",
  511100: "\u4E50\u5C71\u5E02",
  511101: "\u5E02\u8F96\u533A",
  511102: "\u5E02\u4E2D\u533A",
  511111: "\u6C99\u6E7E\u533A",
  511112: "\u4E94\u901A\u6865\u533A",
  511113: "\u91D1\u53E3\u6CB3\u533A",
  511123: "\u728D\u4E3A\u53BF",
  511124: "\u4E95\u7814\u53BF",
  511126: "\u5939\u6C5F\u53BF",
  511129: "\u6C90\u5DDD\u53BF",
  511132: "\u5CE8\u8FB9\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  511133: "\u9A6C\u8FB9\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  511181: "\u5CE8\u7709\u5C71\u5E02",
  511300: "\u5357\u5145\u5E02",
  511301: "\u5E02\u8F96\u533A",
  511302: "\u987A\u5E86\u533A",
  511303: "\u9AD8\u576A\u533A",
  511304: "\u5609\u9675\u533A",
  511321: "\u5357\u90E8\u53BF",
  511322: "\u8425\u5C71\u53BF",
  511323: "\u84EC\u5B89\u53BF",
  511324: "\u4EEA\u9647\u53BF",
  511325: "\u897F\u5145\u53BF",
  511381: "\u9606\u4E2D\u5E02",
  511400: "\u7709\u5C71\u5E02",
  511401: "\u5E02\u8F96\u533A",
  511402: "\u4E1C\u5761\u533A",
  511403: "\u5F6D\u5C71\u533A",
  511421: "\u4EC1\u5BFF\u53BF",
  511423: "\u6D2A\u96C5\u53BF",
  511424: "\u4E39\u68F1\u53BF",
  511425: "\u9752\u795E\u53BF",
  511500: "\u5B9C\u5BBE\u5E02",
  511501: "\u5E02\u8F96\u533A",
  511502: "\u7FE0\u5C4F\u533A",
  511503: "\u5357\u6EAA\u533A",
  511504: "\u53D9\u5DDE\u533A",
  511523: "\u6C5F\u5B89\u53BF",
  511524: "\u957F\u5B81\u53BF",
  511525: "\u9AD8\u53BF",
  511526: "\u73D9\u53BF",
  511527: "\u7B60\u8FDE\u53BF",
  511528: "\u5174\u6587\u53BF",
  511529: "\u5C4F\u5C71\u53BF",
  511600: "\u5E7F\u5B89\u5E02",
  511601: "\u5E02\u8F96\u533A",
  511602: "\u5E7F\u5B89\u533A",
  511603: "\u524D\u950B\u533A",
  511621: "\u5CB3\u6C60\u53BF",
  511622: "\u6B66\u80DC\u53BF",
  511623: "\u90BB\u6C34\u53BF",
  511681: "\u534E\u84E5\u5E02",
  511700: "\u8FBE\u5DDE\u5E02",
  511701: "\u5E02\u8F96\u533A",
  511702: "\u901A\u5DDD\u533A",
  511703: "\u8FBE\u5DDD\u533A",
  511722: "\u5BA3\u6C49\u53BF",
  511723: "\u5F00\u6C5F\u53BF",
  511724: "\u5927\u7AF9\u53BF",
  511725: "\u6E20\u53BF",
  511771: "\u8FBE\u5DDE\u7ECF\u6D4E\u5F00\u53D1\u533A",
  511781: "\u4E07\u6E90\u5E02",
  511800: "\u96C5\u5B89\u5E02",
  511801: "\u5E02\u8F96\u533A",
  511802: "\u96E8\u57CE\u533A",
  511803: "\u540D\u5C71\u533A",
  511822: "\u8365\u7ECF\u53BF",
  511823: "\u6C49\u6E90\u53BF",
  511824: "\u77F3\u68C9\u53BF",
  511825: "\u5929\u5168\u53BF",
  511826: "\u82A6\u5C71\u53BF",
  511827: "\u5B9D\u5174\u53BF",
  511900: "\u5DF4\u4E2D\u5E02",
  511901: "\u5E02\u8F96\u533A",
  511902: "\u5DF4\u5DDE\u533A",
  511903: "\u6069\u9633\u533A",
  511921: "\u901A\u6C5F\u53BF",
  511922: "\u5357\u6C5F\u53BF",
  511923: "\u5E73\u660C\u53BF",
  511971: "\u5DF4\u4E2D\u7ECF\u6D4E\u5F00\u53D1\u533A",
  512e3: "\u8D44\u9633\u5E02",
  512001: "\u5E02\u8F96\u533A",
  512002: "\u96C1\u6C5F\u533A",
  512021: "\u5B89\u5CB3\u53BF",
  512022: "\u4E50\u81F3\u53BF",
  513200: "\u963F\u575D\u85CF\u65CF\u7F8C\u65CF\u81EA\u6CBB\u5DDE",
  513201: "\u9A6C\u5C14\u5EB7\u5E02",
  513221: "\u6C76\u5DDD\u53BF",
  513222: "\u7406\u53BF",
  513223: "\u8302\u53BF",
  513224: "\u677E\u6F58\u53BF",
  513225: "\u4E5D\u5BE8\u6C9F\u53BF",
  513226: "\u91D1\u5DDD\u53BF",
  513227: "\u5C0F\u91D1\u53BF",
  513228: "\u9ED1\u6C34\u53BF",
  513230: "\u58E4\u5858\u53BF",
  513231: "\u963F\u575D\u53BF",
  513232: "\u82E5\u5C14\u76D6\u53BF",
  513233: "\u7EA2\u539F\u53BF",
  513300: "\u7518\u5B5C\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  513301: "\u5EB7\u5B9A\u5E02",
  513322: "\u6CF8\u5B9A\u53BF",
  513323: "\u4E39\u5DF4\u53BF",
  513324: "\u4E5D\u9F99\u53BF",
  513325: "\u96C5\u6C5F\u53BF",
  513326: "\u9053\u5B5A\u53BF",
  513327: "\u7089\u970D\u53BF",
  513328: "\u7518\u5B5C\u53BF",
  513329: "\u65B0\u9F99\u53BF",
  513330: "\u5FB7\u683C\u53BF",
  513331: "\u767D\u7389\u53BF",
  513332: "\u77F3\u6E20\u53BF",
  513333: "\u8272\u8FBE\u53BF",
  513334: "\u7406\u5858\u53BF",
  513335: "\u5DF4\u5858\u53BF",
  513336: "\u4E61\u57CE\u53BF",
  513337: "\u7A3B\u57CE\u53BF",
  513338: "\u5F97\u8363\u53BF",
  513400: "\u51C9\u5C71\u5F5D\u65CF\u81EA\u6CBB\u5DDE",
  513401: "\u897F\u660C\u5E02",
  513422: "\u6728\u91CC\u85CF\u65CF\u81EA\u6CBB\u53BF",
  513423: "\u76D0\u6E90\u53BF",
  513424: "\u5FB7\u660C\u53BF",
  513425: "\u4F1A\u7406\u53BF",
  513426: "\u4F1A\u4E1C\u53BF",
  513427: "\u5B81\u5357\u53BF",
  513428: "\u666E\u683C\u53BF",
  513429: "\u5E03\u62D6\u53BF",
  513430: "\u91D1\u9633\u53BF",
  513431: "\u662D\u89C9\u53BF",
  513432: "\u559C\u5FB7\u53BF",
  513433: "\u5195\u5B81\u53BF",
  513434: "\u8D8A\u897F\u53BF",
  513435: "\u7518\u6D1B\u53BF",
  513436: "\u7F8E\u59D1\u53BF",
  513437: "\u96F7\u6CE2\u53BF",
  52e4: "\u8D35\u5DDE\u7701",
  520100: "\u8D35\u9633\u5E02",
  520101: "\u5E02\u8F96\u533A",
  520102: "\u5357\u660E\u533A",
  520103: "\u4E91\u5CA9\u533A",
  520111: "\u82B1\u6EAA\u533A",
  520112: "\u4E4C\u5F53\u533A",
  520113: "\u767D\u4E91\u533A",
  520115: "\u89C2\u5C71\u6E56\u533A",
  520121: "\u5F00\u9633\u53BF",
  520122: "\u606F\u70FD\u53BF",
  520123: "\u4FEE\u6587\u53BF",
  520181: "\u6E05\u9547\u5E02",
  520200: "\u516D\u76D8\u6C34\u5E02",
  520201: "\u949F\u5C71\u533A",
  520203: "\u516D\u679D\u7279\u533A",
  520221: "\u6C34\u57CE\u53BF",
  520281: "\u76D8\u5DDE\u5E02",
  520300: "\u9075\u4E49\u5E02",
  520301: "\u5E02\u8F96\u533A",
  520302: "\u7EA2\u82B1\u5C97\u533A",
  520303: "\u6C47\u5DDD\u533A",
  520304: "\u64AD\u5DDE\u533A",
  520322: "\u6850\u6893\u53BF",
  520323: "\u7EE5\u9633\u53BF",
  520324: "\u6B63\u5B89\u53BF",
  520325: "\u9053\u771F\u4EE1\u4F6C\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  520326: "\u52A1\u5DDD\u4EE1\u4F6C\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  520327: "\u51E4\u5188\u53BF",
  520328: "\u6E44\u6F6D\u53BF",
  520329: "\u4F59\u5E86\u53BF",
  520330: "\u4E60\u6C34\u53BF",
  520381: "\u8D64\u6C34\u5E02",
  520382: "\u4EC1\u6000\u5E02",
  520400: "\u5B89\u987A\u5E02",
  520401: "\u5E02\u8F96\u533A",
  520402: "\u897F\u79C0\u533A",
  520403: "\u5E73\u575D\u533A",
  520422: "\u666E\u5B9A\u53BF",
  520423: "\u9547\u5B81\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  520424: "\u5173\u5CAD\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  520425: "\u7D2B\u4E91\u82D7\u65CF\u5E03\u4F9D\u65CF\u81EA\u6CBB\u53BF",
  520500: "\u6BD5\u8282\u5E02",
  520501: "\u5E02\u8F96\u533A",
  520502: "\u4E03\u661F\u5173\u533A",
  520521: "\u5927\u65B9\u53BF",
  520522: "\u9ED4\u897F\u53BF",
  520523: "\u91D1\u6C99\u53BF",
  520524: "\u7EC7\u91D1\u53BF",
  520525: "\u7EB3\u96CD\u53BF",
  520526: "\u5A01\u5B81\u5F5D\u65CF\u56DE\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  520527: "\u8D6B\u7AE0\u53BF",
  520600: "\u94DC\u4EC1\u5E02",
  520601: "\u5E02\u8F96\u533A",
  520602: "\u78A7\u6C5F\u533A",
  520603: "\u4E07\u5C71\u533A",
  520621: "\u6C5F\u53E3\u53BF",
  520622: "\u7389\u5C4F\u4F97\u65CF\u81EA\u6CBB\u53BF",
  520623: "\u77F3\u9621\u53BF",
  520624: "\u601D\u5357\u53BF",
  520625: "\u5370\u6C5F\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  520626: "\u5FB7\u6C5F\u53BF",
  520627: "\u6CBF\u6CB3\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF",
  520628: "\u677E\u6843\u82D7\u65CF\u81EA\u6CBB\u53BF",
  522300: "\u9ED4\u897F\u5357\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
  522301: "\u5174\u4E49\u5E02",
  522302: "\u5174\u4EC1\u5E02",
  522323: "\u666E\u5B89\u53BF",
  522324: "\u6674\u9686\u53BF",
  522325: "\u8D1E\u4E30\u53BF",
  522326: "\u671B\u8C1F\u53BF",
  522327: "\u518C\u4EA8\u53BF",
  522328: "\u5B89\u9F99\u53BF",
  522600: "\u9ED4\u4E1C\u5357\u82D7\u65CF\u4F97\u65CF\u81EA\u6CBB\u5DDE",
  522601: "\u51EF\u91CC\u5E02",
  522622: "\u9EC4\u5E73\u53BF",
  522623: "\u65BD\u79C9\u53BF",
  522624: "\u4E09\u7A57\u53BF",
  522625: "\u9547\u8FDC\u53BF",
  522626: "\u5C91\u5DE9\u53BF",
  522627: "\u5929\u67F1\u53BF",
  522628: "\u9526\u5C4F\u53BF",
  522629: "\u5251\u6CB3\u53BF",
  522630: "\u53F0\u6C5F\u53BF",
  522631: "\u9ECE\u5E73\u53BF",
  522632: "\u6995\u6C5F\u53BF",
  522633: "\u4ECE\u6C5F\u53BF",
  522634: "\u96F7\u5C71\u53BF",
  522635: "\u9EBB\u6C5F\u53BF",
  522636: "\u4E39\u5BE8\u53BF",
  522700: "\u9ED4\u5357\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
  522701: "\u90FD\u5300\u5E02",
  522702: "\u798F\u6CC9\u5E02",
  522722: "\u8354\u6CE2\u53BF",
  522723: "\u8D35\u5B9A\u53BF",
  522725: "\u74EE\u5B89\u53BF",
  522726: "\u72EC\u5C71\u53BF",
  522727: "\u5E73\u5858\u53BF",
  522728: "\u7F57\u7538\u53BF",
  522729: "\u957F\u987A\u53BF",
  522730: "\u9F99\u91CC\u53BF",
  522731: "\u60E0\u6C34\u53BF",
  522732: "\u4E09\u90FD\u6C34\u65CF\u81EA\u6CBB\u53BF",
  53e4: "\u4E91\u5357\u7701",
  530100: "\u6606\u660E\u5E02",
  530101: "\u5E02\u8F96\u533A",
  530102: "\u4E94\u534E\u533A",
  530103: "\u76D8\u9F99\u533A",
  530111: "\u5B98\u6E21\u533A",
  530112: "\u897F\u5C71\u533A",
  530113: "\u4E1C\u5DDD\u533A",
  530114: "\u5448\u8D21\u533A",
  530115: "\u664B\u5B81\u533A",
  530124: "\u5BCC\u6C11\u53BF",
  530125: "\u5B9C\u826F\u53BF",
  530126: "\u77F3\u6797\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530127: "\u5D69\u660E\u53BF",
  530128: "\u7984\u529D\u5F5D\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF",
  530129: "\u5BFB\u7538\u56DE\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530181: "\u5B89\u5B81\u5E02",
  530300: "\u66F2\u9756\u5E02",
  530301: "\u5E02\u8F96\u533A",
  530302: "\u9E92\u9E9F\u533A",
  530303: "\u6CBE\u76CA\u533A",
  530304: "\u9A6C\u9F99\u533A",
  530322: "\u9646\u826F\u53BF",
  530323: "\u5E08\u5B97\u53BF",
  530324: "\u7F57\u5E73\u53BF",
  530325: "\u5BCC\u6E90\u53BF",
  530326: "\u4F1A\u6CFD\u53BF",
  530381: "\u5BA3\u5A01\u5E02",
  530400: "\u7389\u6EAA\u5E02",
  530401: "\u5E02\u8F96\u533A",
  530402: "\u7EA2\u5854\u533A",
  530403: "\u6C5F\u5DDD\u533A",
  530422: "\u6F84\u6C5F\u53BF",
  530423: "\u901A\u6D77\u53BF",
  530424: "\u534E\u5B81\u53BF",
  530425: "\u6613\u95E8\u53BF",
  530426: "\u5CE8\u5C71\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530427: "\u65B0\u5E73\u5F5D\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF",
  530428: "\u5143\u6C5F\u54C8\u5C3C\u65CF\u5F5D\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF",
  530500: "\u4FDD\u5C71\u5E02",
  530501: "\u5E02\u8F96\u533A",
  530502: "\u9686\u9633\u533A",
  530521: "\u65BD\u7538\u53BF",
  530523: "\u9F99\u9675\u53BF",
  530524: "\u660C\u5B81\u53BF",
  530581: "\u817E\u51B2\u5E02",
  530600: "\u662D\u901A\u5E02",
  530601: "\u5E02\u8F96\u533A",
  530602: "\u662D\u9633\u533A",
  530621: "\u9C81\u7538\u53BF",
  530622: "\u5DE7\u5BB6\u53BF",
  530623: "\u76D0\u6D25\u53BF",
  530624: "\u5927\u5173\u53BF",
  530625: "\u6C38\u5584\u53BF",
  530626: "\u7EE5\u6C5F\u53BF",
  530627: "\u9547\u96C4\u53BF",
  530628: "\u5F5D\u826F\u53BF",
  530629: "\u5A01\u4FE1\u53BF",
  530681: "\u6C34\u5BCC\u5E02",
  530700: "\u4E3D\u6C5F\u5E02",
  530701: "\u5E02\u8F96\u533A",
  530702: "\u53E4\u57CE\u533A",
  530721: "\u7389\u9F99\u7EB3\u897F\u65CF\u81EA\u6CBB\u53BF",
  530722: "\u6C38\u80DC\u53BF",
  530723: "\u534E\u576A\u53BF",
  530724: "\u5B81\u8497\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530800: "\u666E\u6D31\u5E02",
  530801: "\u5E02\u8F96\u533A",
  530802: "\u601D\u8305\u533A",
  530821: "\u5B81\u6D31\u54C8\u5C3C\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530822: "\u58A8\u6C5F\u54C8\u5C3C\u65CF\u81EA\u6CBB\u53BF",
  530823: "\u666F\u4E1C\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530824: "\u666F\u8C37\u50A3\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530825: "\u9547\u6C85\u5F5D\u65CF\u54C8\u5C3C\u65CF\u62C9\u795C\u65CF\u81EA\u6CBB\u53BF",
  530826: "\u6C5F\u57CE\u54C8\u5C3C\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  530827: "\u5B5F\u8FDE\u50A3\u65CF\u62C9\u795C\u65CF\u4F64\u65CF\u81EA\u6CBB\u53BF",
  530828: "\u6F9C\u6CA7\u62C9\u795C\u65CF\u81EA\u6CBB\u53BF",
  530829: "\u897F\u76DF\u4F64\u65CF\u81EA\u6CBB\u53BF",
  530900: "\u4E34\u6CA7\u5E02",
  530901: "\u5E02\u8F96\u533A",
  530902: "\u4E34\u7FD4\u533A",
  530921: "\u51E4\u5E86\u53BF",
  530922: "\u4E91\u53BF",
  530923: "\u6C38\u5FB7\u53BF",
  530924: "\u9547\u5EB7\u53BF",
  530925: "\u53CC\u6C5F\u62C9\u795C\u65CF\u4F64\u65CF\u5E03\u6717\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF",
  530926: "\u803F\u9A6C\u50A3\u65CF\u4F64\u65CF\u81EA\u6CBB\u53BF",
  530927: "\u6CA7\u6E90\u4F64\u65CF\u81EA\u6CBB\u53BF",
  532300: "\u695A\u96C4\u5F5D\u65CF\u81EA\u6CBB\u5DDE",
  532301: "\u695A\u96C4\u5E02",
  532322: "\u53CC\u67CF\u53BF",
  532323: "\u725F\u5B9A\u53BF",
  532324: "\u5357\u534E\u53BF",
  532325: "\u59DA\u5B89\u53BF",
  532326: "\u5927\u59DA\u53BF",
  532327: "\u6C38\u4EC1\u53BF",
  532328: "\u5143\u8C0B\u53BF",
  532329: "\u6B66\u5B9A\u53BF",
  532331: "\u7984\u4E30\u53BF",
  532500: "\u7EA2\u6CB3\u54C8\u5C3C\u65CF\u5F5D\u65CF\u81EA\u6CBB\u5DDE",
  532501: "\u4E2A\u65E7\u5E02",
  532502: "\u5F00\u8FDC\u5E02",
  532503: "\u8499\u81EA\u5E02",
  532504: "\u5F25\u52D2\u5E02",
  532523: "\u5C4F\u8FB9\u82D7\u65CF\u81EA\u6CBB\u53BF",
  532524: "\u5EFA\u6C34\u53BF",
  532525: "\u77F3\u5C4F\u53BF",
  532527: "\u6CF8\u897F\u53BF",
  532528: "\u5143\u9633\u53BF",
  532529: "\u7EA2\u6CB3\u53BF",
  532530: "\u91D1\u5E73\u82D7\u65CF\u7476\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF",
  532531: "\u7EFF\u6625\u53BF",
  532532: "\u6CB3\u53E3\u7476\u65CF\u81EA\u6CBB\u53BF",
  532600: "\u6587\u5C71\u58EE\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
  532601: "\u6587\u5C71\u5E02",
  532622: "\u781A\u5C71\u53BF",
  532623: "\u897F\u7574\u53BF",
  532624: "\u9EBB\u6817\u5761\u53BF",
  532625: "\u9A6C\u5173\u53BF",
  532626: "\u4E18\u5317\u53BF",
  532627: "\u5E7F\u5357\u53BF",
  532628: "\u5BCC\u5B81\u53BF",
  532800: "\u897F\u53CC\u7248\u7EB3\u50A3\u65CF\u81EA\u6CBB\u5DDE",
  532801: "\u666F\u6D2A\u5E02",
  532822: "\u52D0\u6D77\u53BF",
  532823: "\u52D0\u814A\u53BF",
  532900: "\u5927\u7406\u767D\u65CF\u81EA\u6CBB\u5DDE",
  532901: "\u5927\u7406\u5E02",
  532922: "\u6F3E\u6FDE\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  532923: "\u7965\u4E91\u53BF",
  532924: "\u5BBE\u5DDD\u53BF",
  532925: "\u5F25\u6E21\u53BF",
  532926: "\u5357\u6DA7\u5F5D\u65CF\u81EA\u6CBB\u53BF",
  532927: "\u5DCD\u5C71\u5F5D\u65CF\u56DE\u65CF\u81EA\u6CBB\u53BF",
  532928: "\u6C38\u5E73\u53BF",
  532929: "\u4E91\u9F99\u53BF",
  532930: "\u6D31\u6E90\u53BF",
  532931: "\u5251\u5DDD\u53BF",
  532932: "\u9E64\u5E86\u53BF",
  533100: "\u5FB7\u5B8F\u50A3\u65CF\u666F\u9887\u65CF\u81EA\u6CBB\u5DDE",
  533102: "\u745E\u4E3D\u5E02",
  533103: "\u8292\u5E02",
  533122: "\u6881\u6CB3\u53BF",
  533123: "\u76C8\u6C5F\u53BF",
  533124: "\u9647\u5DDD\u53BF",
  533300: "\u6012\u6C5F\u5088\u50F3\u65CF\u81EA\u6CBB\u5DDE",
  533301: "\u6CF8\u6C34\u5E02",
  533323: "\u798F\u8D21\u53BF",
  533324: "\u8D21\u5C71\u72EC\u9F99\u65CF\u6012\u65CF\u81EA\u6CBB\u53BF",
  533325: "\u5170\u576A\u767D\u65CF\u666E\u7C73\u65CF\u81EA\u6CBB\u53BF",
  533400: "\u8FEA\u5E86\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  533401: "\u9999\u683C\u91CC\u62C9\u5E02",
  533422: "\u5FB7\u94A6\u53BF",
  533423: "\u7EF4\u897F\u5088\u50F3\u65CF\u81EA\u6CBB\u53BF",
  54e4: "\u897F\u85CF\u81EA\u6CBB\u533A",
  540100: "\u62C9\u8428\u5E02",
  540101: "\u5E02\u8F96\u533A",
  540102: "\u57CE\u5173\u533A",
  540103: "\u5806\u9F99\u5FB7\u5E86\u533A",
  540104: "\u8FBE\u5B5C\u533A",
  540121: "\u6797\u5468\u53BF",
  540122: "\u5F53\u96C4\u53BF",
  540123: "\u5C3C\u6728\u53BF",
  540124: "\u66F2\u6C34\u53BF",
  540127: "\u58A8\u7AF9\u5DE5\u5361\u53BF",
  540171: "\u683C\u5C14\u6728\u85CF\u9752\u5DE5\u4E1A\u56ED\u533A",
  540172: "\u62C9\u8428\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  540173: "\u897F\u85CF\u6587\u5316\u65C5\u6E38\u521B\u610F\u56ED\u533A",
  540174: "\u8FBE\u5B5C\u5DE5\u4E1A\u56ED\u533A",
  540200: "\u65E5\u5580\u5219\u5E02",
  540202: "\u6851\u73E0\u5B5C\u533A",
  540221: "\u5357\u6728\u6797\u53BF",
  540222: "\u6C5F\u5B5C\u53BF",
  540223: "\u5B9A\u65E5\u53BF",
  540224: "\u8428\u8FE6\u53BF",
  540225: "\u62C9\u5B5C\u53BF",
  540226: "\u6602\u4EC1\u53BF",
  540227: "\u8C22\u901A\u95E8\u53BF",
  540228: "\u767D\u6717\u53BF",
  540229: "\u4EC1\u5E03\u53BF",
  540230: "\u5EB7\u9A6C\u53BF",
  540231: "\u5B9A\u7ED3\u53BF",
  540232: "\u4EF2\u5DF4\u53BF",
  540233: "\u4E9A\u4E1C\u53BF",
  540234: "\u5409\u9686\u53BF",
  540235: "\u8042\u62C9\u6728\u53BF",
  540236: "\u8428\u560E\u53BF",
  540237: "\u5C97\u5DF4\u53BF",
  540300: "\u660C\u90FD\u5E02",
  540302: "\u5361\u82E5\u533A",
  540321: "\u6C5F\u8FBE\u53BF",
  540322: "\u8D21\u89C9\u53BF",
  540323: "\u7C7B\u4E4C\u9F50\u53BF",
  540324: "\u4E01\u9752\u53BF",
  540325: "\u5BDF\u96C5\u53BF",
  540326: "\u516B\u5BBF\u53BF",
  540327: "\u5DE6\u8D21\u53BF",
  540328: "\u8292\u5EB7\u53BF",
  540329: "\u6D1B\u9686\u53BF",
  540330: "\u8FB9\u575D\u53BF",
  540400: "\u6797\u829D\u5E02",
  540402: "\u5DF4\u5B9C\u533A",
  540421: "\u5DE5\u5E03\u6C5F\u8FBE\u53BF",
  540422: "\u7C73\u6797\u53BF",
  540423: "\u58A8\u8131\u53BF",
  540424: "\u6CE2\u5BC6\u53BF",
  540425: "\u5BDF\u9685\u53BF",
  540426: "\u6717\u53BF",
  540500: "\u5C71\u5357\u5E02",
  540501: "\u5E02\u8F96\u533A",
  540502: "\u4E43\u4E1C\u533A",
  540521: "\u624E\u56CA\u53BF",
  540522: "\u8D21\u560E\u53BF",
  540523: "\u6851\u65E5\u53BF",
  540524: "\u743C\u7ED3\u53BF",
  540525: "\u66F2\u677E\u53BF",
  540526: "\u63AA\u7F8E\u53BF",
  540527: "\u6D1B\u624E\u53BF",
  540528: "\u52A0\u67E5\u53BF",
  540529: "\u9686\u5B50\u53BF",
  540530: "\u9519\u90A3\u53BF",
  540531: "\u6D6A\u5361\u5B50\u53BF",
  540600: "\u90A3\u66F2\u5E02",
  540602: "\u8272\u5C3C\u533A",
  540621: "\u5609\u9ECE\u53BF",
  540622: "\u6BD4\u5982\u53BF",
  540623: "\u8042\u8363\u53BF",
  540624: "\u5B89\u591A\u53BF",
  540625: "\u7533\u624E\u53BF",
  540626: "\u7D22\u53BF",
  540627: "\u73ED\u6208\u53BF",
  540628: "\u5DF4\u9752\u53BF",
  540629: "\u5C3C\u739B\u53BF",
  540630: "\u53CC\u6E56\u53BF",
  542500: "\u963F\u91CC\u5730\u533A",
  542521: "\u666E\u5170\u53BF",
  542522: "\u672D\u8FBE\u53BF",
  542523: "\u5676\u5C14\u53BF",
  542524: "\u65E5\u571F\u53BF",
  542525: "\u9769\u5409\u53BF",
  542526: "\u6539\u5219\u53BF",
  542527: "\u63AA\u52E4\u53BF",
  61e4: "\u9655\u897F\u7701",
  610100: "\u897F\u5B89\u5E02",
  610101: "\u5E02\u8F96\u533A",
  610102: "\u65B0\u57CE\u533A",
  610103: "\u7891\u6797\u533A",
  610104: "\u83B2\u6E56\u533A",
  610111: "\u705E\u6865\u533A",
  610112: "\u672A\u592E\u533A",
  610113: "\u96C1\u5854\u533A",
  610114: "\u960E\u826F\u533A",
  610115: "\u4E34\u6F7C\u533A",
  610116: "\u957F\u5B89\u533A",
  610117: "\u9AD8\u9675\u533A",
  610118: "\u9120\u9091\u533A",
  610122: "\u84DD\u7530\u53BF",
  610124: "\u5468\u81F3\u53BF",
  610200: "\u94DC\u5DDD\u5E02",
  610201: "\u5E02\u8F96\u533A",
  610202: "\u738B\u76CA\u533A",
  610203: "\u5370\u53F0\u533A",
  610204: "\u8000\u5DDE\u533A",
  610222: "\u5B9C\u541B\u53BF",
  610300: "\u5B9D\u9E21\u5E02",
  610301: "\u5E02\u8F96\u533A",
  610302: "\u6E2D\u6EE8\u533A",
  610303: "\u91D1\u53F0\u533A",
  610304: "\u9648\u4ED3\u533A",
  610322: "\u51E4\u7FD4\u53BF",
  610323: "\u5C90\u5C71\u53BF",
  610324: "\u6276\u98CE\u53BF",
  610326: "\u7709\u53BF",
  610327: "\u9647\u53BF",
  610328: "\u5343\u9633\u53BF",
  610329: "\u9E9F\u6E38\u53BF",
  610330: "\u51E4\u53BF",
  610331: "\u592A\u767D\u53BF",
  610400: "\u54B8\u9633\u5E02",
  610401: "\u5E02\u8F96\u533A",
  610402: "\u79E6\u90FD\u533A",
  610403: "\u6768\u9675\u533A",
  610404: "\u6E2D\u57CE\u533A",
  610422: "\u4E09\u539F\u53BF",
  610423: "\u6CFE\u9633\u53BF",
  610424: "\u4E7E\u53BF",
  610425: "\u793C\u6CC9\u53BF",
  610426: "\u6C38\u5BFF\u53BF",
  610428: "\u957F\u6B66\u53BF",
  610429: "\u65EC\u9091\u53BF",
  610430: "\u6DF3\u5316\u53BF",
  610431: "\u6B66\u529F\u53BF",
  610481: "\u5174\u5E73\u5E02",
  610482: "\u5F6C\u5DDE\u5E02",
  610500: "\u6E2D\u5357\u5E02",
  610501: "\u5E02\u8F96\u533A",
  610502: "\u4E34\u6E2D\u533A",
  610503: "\u534E\u5DDE\u533A",
  610522: "\u6F7C\u5173\u53BF",
  610523: "\u5927\u8354\u53BF",
  610524: "\u5408\u9633\u53BF",
  610525: "\u6F84\u57CE\u53BF",
  610526: "\u84B2\u57CE\u53BF",
  610527: "\u767D\u6C34\u53BF",
  610528: "\u5BCC\u5E73\u53BF",
  610581: "\u97E9\u57CE\u5E02",
  610582: "\u534E\u9634\u5E02",
  610600: "\u5EF6\u5B89\u5E02",
  610601: "\u5E02\u8F96\u533A",
  610602: "\u5B9D\u5854\u533A",
  610603: "\u5B89\u585E\u533A",
  610621: "\u5EF6\u957F\u53BF",
  610622: "\u5EF6\u5DDD\u53BF",
  610625: "\u5FD7\u4E39\u53BF",
  610626: "\u5434\u8D77\u53BF",
  610627: "\u7518\u6CC9\u53BF",
  610628: "\u5BCC\u53BF",
  610629: "\u6D1B\u5DDD\u53BF",
  610630: "\u5B9C\u5DDD\u53BF",
  610631: "\u9EC4\u9F99\u53BF",
  610632: "\u9EC4\u9675\u53BF",
  610681: "\u5B50\u957F\u5E02",
  610700: "\u6C49\u4E2D\u5E02",
  610701: "\u5E02\u8F96\u533A",
  610702: "\u6C49\u53F0\u533A",
  610703: "\u5357\u90D1\u533A",
  610722: "\u57CE\u56FA\u53BF",
  610723: "\u6D0B\u53BF",
  610724: "\u897F\u4E61\u53BF",
  610725: "\u52C9\u53BF",
  610726: "\u5B81\u5F3A\u53BF",
  610727: "\u7565\u9633\u53BF",
  610728: "\u9547\u5DF4\u53BF",
  610729: "\u7559\u575D\u53BF",
  610730: "\u4F5B\u576A\u53BF",
  610800: "\u6986\u6797\u5E02",
  610801: "\u5E02\u8F96\u533A",
  610802: "\u6986\u9633\u533A",
  610803: "\u6A2A\u5C71\u533A",
  610822: "\u5E9C\u8C37\u53BF",
  610824: "\u9756\u8FB9\u53BF",
  610825: "\u5B9A\u8FB9\u53BF",
  610826: "\u7EE5\u5FB7\u53BF",
  610827: "\u7C73\u8102\u53BF",
  610828: "\u4F73\u53BF",
  610829: "\u5434\u5821\u53BF",
  610830: "\u6E05\u6DA7\u53BF",
  610831: "\u5B50\u6D32\u53BF",
  610881: "\u795E\u6728\u5E02",
  610900: "\u5B89\u5EB7\u5E02",
  610901: "\u5E02\u8F96\u533A",
  610902: "\u6C49\u6EE8\u533A",
  610921: "\u6C49\u9634\u53BF",
  610922: "\u77F3\u6CC9\u53BF",
  610923: "\u5B81\u9655\u53BF",
  610924: "\u7D2B\u9633\u53BF",
  610925: "\u5C9A\u768B\u53BF",
  610926: "\u5E73\u5229\u53BF",
  610927: "\u9547\u576A\u53BF",
  610928: "\u65EC\u9633\u53BF",
  610929: "\u767D\u6CB3\u53BF",
  611e3: "\u5546\u6D1B\u5E02",
  611001: "\u5E02\u8F96\u533A",
  611002: "\u5546\u5DDE\u533A",
  611021: "\u6D1B\u5357\u53BF",
  611022: "\u4E39\u51E4\u53BF",
  611023: "\u5546\u5357\u53BF",
  611024: "\u5C71\u9633\u53BF",
  611025: "\u9547\u5B89\u53BF",
  611026: "\u67DE\u6C34\u53BF",
  62e4: "\u7518\u8083\u7701",
  620100: "\u5170\u5DDE\u5E02",
  620101: "\u5E02\u8F96\u533A",
  620102: "\u57CE\u5173\u533A",
  620103: "\u4E03\u91CC\u6CB3\u533A",
  620104: "\u897F\u56FA\u533A",
  620105: "\u5B89\u5B81\u533A",
  620111: "\u7EA2\u53E4\u533A",
  620121: "\u6C38\u767B\u53BF",
  620122: "\u768B\u5170\u53BF",
  620123: "\u6986\u4E2D\u53BF",
  620171: "\u5170\u5DDE\u65B0\u533A",
  620200: "\u5609\u5CEA\u5173\u5E02",
  620201: "\u5E02\u8F96\u533A",
  620300: "\u91D1\u660C\u5E02",
  620301: "\u5E02\u8F96\u533A",
  620302: "\u91D1\u5DDD\u533A",
  620321: "\u6C38\u660C\u53BF",
  620400: "\u767D\u94F6\u5E02",
  620401: "\u5E02\u8F96\u533A",
  620402: "\u767D\u94F6\u533A",
  620403: "\u5E73\u5DDD\u533A",
  620421: "\u9756\u8FDC\u53BF",
  620422: "\u4F1A\u5B81\u53BF",
  620423: "\u666F\u6CF0\u53BF",
  620500: "\u5929\u6C34\u5E02",
  620501: "\u5E02\u8F96\u533A",
  620502: "\u79E6\u5DDE\u533A",
  620503: "\u9EA6\u79EF\u533A",
  620521: "\u6E05\u6C34\u53BF",
  620522: "\u79E6\u5B89\u53BF",
  620523: "\u7518\u8C37\u53BF",
  620524: "\u6B66\u5C71\u53BF",
  620525: "\u5F20\u5BB6\u5DDD\u56DE\u65CF\u81EA\u6CBB\u53BF",
  620600: "\u6B66\u5A01\u5E02",
  620601: "\u5E02\u8F96\u533A",
  620602: "\u51C9\u5DDE\u533A",
  620621: "\u6C11\u52E4\u53BF",
  620622: "\u53E4\u6D6A\u53BF",
  620623: "\u5929\u795D\u85CF\u65CF\u81EA\u6CBB\u53BF",
  620700: "\u5F20\u6396\u5E02",
  620701: "\u5E02\u8F96\u533A",
  620702: "\u7518\u5DDE\u533A",
  620721: "\u8083\u5357\u88D5\u56FA\u65CF\u81EA\u6CBB\u53BF",
  620722: "\u6C11\u4E50\u53BF",
  620723: "\u4E34\u6CFD\u53BF",
  620724: "\u9AD8\u53F0\u53BF",
  620725: "\u5C71\u4E39\u53BF",
  620800: "\u5E73\u51C9\u5E02",
  620801: "\u5E02\u8F96\u533A",
  620802: "\u5D06\u5CD2\u533A",
  620821: "\u6CFE\u5DDD\u53BF",
  620822: "\u7075\u53F0\u53BF",
  620823: "\u5D07\u4FE1\u53BF",
  620825: "\u5E84\u6D6A\u53BF",
  620826: "\u9759\u5B81\u53BF",
  620881: "\u534E\u4EAD\u5E02",
  620900: "\u9152\u6CC9\u5E02",
  620901: "\u5E02\u8F96\u533A",
  620902: "\u8083\u5DDE\u533A",
  620921: "\u91D1\u5854\u53BF",
  620922: "\u74DC\u5DDE\u53BF",
  620923: "\u8083\u5317\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  620924: "\u963F\u514B\u585E\u54C8\u8428\u514B\u65CF\u81EA\u6CBB\u53BF",
  620981: "\u7389\u95E8\u5E02",
  620982: "\u6566\u714C\u5E02",
  621e3: "\u5E86\u9633\u5E02",
  621001: "\u5E02\u8F96\u533A",
  621002: "\u897F\u5CF0\u533A",
  621021: "\u5E86\u57CE\u53BF",
  621022: "\u73AF\u53BF",
  621023: "\u534E\u6C60\u53BF",
  621024: "\u5408\u6C34\u53BF",
  621025: "\u6B63\u5B81\u53BF",
  621026: "\u5B81\u53BF",
  621027: "\u9547\u539F\u53BF",
  621100: "\u5B9A\u897F\u5E02",
  621101: "\u5E02\u8F96\u533A",
  621102: "\u5B89\u5B9A\u533A",
  621121: "\u901A\u6E2D\u53BF",
  621122: "\u9647\u897F\u53BF",
  621123: "\u6E2D\u6E90\u53BF",
  621124: "\u4E34\u6D2E\u53BF",
  621125: "\u6F33\u53BF",
  621126: "\u5CB7\u53BF",
  621200: "\u9647\u5357\u5E02",
  621201: "\u5E02\u8F96\u533A",
  621202: "\u6B66\u90FD\u533A",
  621221: "\u6210\u53BF",
  621222: "\u6587\u53BF",
  621223: "\u5B95\u660C\u53BF",
  621224: "\u5EB7\u53BF",
  621225: "\u897F\u548C\u53BF",
  621226: "\u793C\u53BF",
  621227: "\u5FBD\u53BF",
  621228: "\u4E24\u5F53\u53BF",
  622900: "\u4E34\u590F\u56DE\u65CF\u81EA\u6CBB\u5DDE",
  622901: "\u4E34\u590F\u5E02",
  622921: "\u4E34\u590F\u53BF",
  622922: "\u5EB7\u4E50\u53BF",
  622923: "\u6C38\u9756\u53BF",
  622924: "\u5E7F\u6CB3\u53BF",
  622925: "\u548C\u653F\u53BF",
  622926: "\u4E1C\u4E61\u65CF\u81EA\u6CBB\u53BF",
  622927: "\u79EF\u77F3\u5C71\u4FDD\u5B89\u65CF\u4E1C\u4E61\u65CF\u6492\u62C9\u65CF\u81EA\u6CBB\u53BF",
  623e3: "\u7518\u5357\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  623001: "\u5408\u4F5C\u5E02",
  623021: "\u4E34\u6F6D\u53BF",
  623022: "\u5353\u5C3C\u53BF",
  623023: "\u821F\u66F2\u53BF",
  623024: "\u8FED\u90E8\u53BF",
  623025: "\u739B\u66F2\u53BF",
  623026: "\u788C\u66F2\u53BF",
  623027: "\u590F\u6CB3\u53BF",
  63e4: "\u9752\u6D77\u7701",
  630100: "\u897F\u5B81\u5E02",
  630101: "\u5E02\u8F96\u533A",
  630102: "\u57CE\u4E1C\u533A",
  630103: "\u57CE\u4E2D\u533A",
  630104: "\u57CE\u897F\u533A",
  630105: "\u57CE\u5317\u533A",
  630121: "\u5927\u901A\u56DE\u65CF\u571F\u65CF\u81EA\u6CBB\u53BF",
  630122: "\u6E5F\u4E2D\u53BF",
  630123: "\u6E5F\u6E90\u53BF",
  630200: "\u6D77\u4E1C\u5E02",
  630202: "\u4E50\u90FD\u533A",
  630203: "\u5E73\u5B89\u533A",
  630222: "\u6C11\u548C\u56DE\u65CF\u571F\u65CF\u81EA\u6CBB\u53BF",
  630223: "\u4E92\u52A9\u571F\u65CF\u81EA\u6CBB\u53BF",
  630224: "\u5316\u9686\u56DE\u65CF\u81EA\u6CBB\u53BF",
  630225: "\u5FAA\u5316\u6492\u62C9\u65CF\u81EA\u6CBB\u53BF",
  632200: "\u6D77\u5317\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  632221: "\u95E8\u6E90\u56DE\u65CF\u81EA\u6CBB\u53BF",
  632222: "\u7941\u8FDE\u53BF",
  632223: "\u6D77\u664F\u53BF",
  632224: "\u521A\u5BDF\u53BF",
  632300: "\u9EC4\u5357\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  632321: "\u540C\u4EC1\u53BF",
  632322: "\u5C16\u624E\u53BF",
  632323: "\u6CFD\u5E93\u53BF",
  632324: "\u6CB3\u5357\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF",
  632500: "\u6D77\u5357\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  632521: "\u5171\u548C\u53BF",
  632522: "\u540C\u5FB7\u53BF",
  632523: "\u8D35\u5FB7\u53BF",
  632524: "\u5174\u6D77\u53BF",
  632525: "\u8D35\u5357\u53BF",
  632600: "\u679C\u6D1B\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  632621: "\u739B\u6C81\u53BF",
  632622: "\u73ED\u739B\u53BF",
  632623: "\u7518\u5FB7\u53BF",
  632624: "\u8FBE\u65E5\u53BF",
  632625: "\u4E45\u6CBB\u53BF",
  632626: "\u739B\u591A\u53BF",
  632700: "\u7389\u6811\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  632701: "\u7389\u6811\u5E02",
  632722: "\u6742\u591A\u53BF",
  632723: "\u79F0\u591A\u53BF",
  632724: "\u6CBB\u591A\u53BF",
  632725: "\u56CA\u8C26\u53BF",
  632726: "\u66F2\u9EBB\u83B1\u53BF",
  632800: "\u6D77\u897F\u8499\u53E4\u65CF\u85CF\u65CF\u81EA\u6CBB\u5DDE",
  632801: "\u683C\u5C14\u6728\u5E02",
  632802: "\u5FB7\u4EE4\u54C8\u5E02",
  632803: "\u832B\u5D16\u5E02",
  632821: "\u4E4C\u5170\u53BF",
  632822: "\u90FD\u5170\u53BF",
  632823: "\u5929\u5CFB\u53BF",
  632857: "\u5927\u67F4\u65E6\u884C\u653F\u59D4\u5458\u4F1A",
  64e4: "\u5B81\u590F\u56DE\u65CF\u81EA\u6CBB\u533A",
  640100: "\u94F6\u5DDD\u5E02",
  640101: "\u5E02\u8F96\u533A",
  640104: "\u5174\u5E86\u533A",
  640105: "\u897F\u590F\u533A",
  640106: "\u91D1\u51E4\u533A",
  640121: "\u6C38\u5B81\u53BF",
  640122: "\u8D3A\u5170\u53BF",
  640181: "\u7075\u6B66\u5E02",
  640200: "\u77F3\u5634\u5C71\u5E02",
  640201: "\u5E02\u8F96\u533A",
  640202: "\u5927\u6B66\u53E3\u533A",
  640205: "\u60E0\u519C\u533A",
  640221: "\u5E73\u7F57\u53BF",
  640300: "\u5434\u5FE0\u5E02",
  640301: "\u5E02\u8F96\u533A",
  640302: "\u5229\u901A\u533A",
  640303: "\u7EA2\u5BFA\u5821\u533A",
  640323: "\u76D0\u6C60\u53BF",
  640324: "\u540C\u5FC3\u53BF",
  640381: "\u9752\u94DC\u5CE1\u5E02",
  640400: "\u56FA\u539F\u5E02",
  640401: "\u5E02\u8F96\u533A",
  640402: "\u539F\u5DDE\u533A",
  640422: "\u897F\u5409\u53BF",
  640423: "\u9686\u5FB7\u53BF",
  640424: "\u6CFE\u6E90\u53BF",
  640425: "\u5F6D\u9633\u53BF",
  640500: "\u4E2D\u536B\u5E02",
  640501: "\u5E02\u8F96\u533A",
  640502: "\u6C99\u5761\u5934\u533A",
  640521: "\u4E2D\u5B81\u53BF",
  640522: "\u6D77\u539F\u53BF",
  65e4: "\u65B0\u7586\u7EF4\u543E\u5C14\u81EA\u6CBB\u533A",
  650100: "\u4E4C\u9C81\u6728\u9F50\u5E02",
  650101: "\u5E02\u8F96\u533A",
  650102: "\u5929\u5C71\u533A",
  650103: "\u6C99\u4F9D\u5DF4\u514B\u533A",
  650104: "\u65B0\u5E02\u533A",
  650105: "\u6C34\u78E8\u6C9F\u533A",
  650106: "\u5934\u5C6F\u6CB3\u533A",
  650107: "\u8FBE\u5742\u57CE\u533A",
  650109: "\u7C73\u4E1C\u533A",
  650121: "\u4E4C\u9C81\u6728\u9F50\u53BF",
  650200: "\u514B\u62C9\u739B\u4F9D\u5E02",
  650201: "\u5E02\u8F96\u533A",
  650202: "\u72EC\u5C71\u5B50\u533A",
  650203: "\u514B\u62C9\u739B\u4F9D\u533A",
  650204: "\u767D\u78B1\u6EE9\u533A",
  650205: "\u4E4C\u5C14\u79BE\u533A",
  650400: "\u5410\u9C81\u756A\u5E02",
  650402: "\u9AD8\u660C\u533A",
  650421: "\u912F\u5584\u53BF",
  650422: "\u6258\u514B\u900A\u53BF",
  650500: "\u54C8\u5BC6\u5E02",
  650502: "\u4F0A\u5DDE\u533A",
  650521: "\u5DF4\u91CC\u5764\u54C8\u8428\u514B\u81EA\u6CBB\u53BF",
  650522: "\u4F0A\u543E\u53BF",
  652300: "\u660C\u5409\u56DE\u65CF\u81EA\u6CBB\u5DDE",
  652301: "\u660C\u5409\u5E02",
  652302: "\u961C\u5EB7\u5E02",
  652323: "\u547C\u56FE\u58C1\u53BF",
  652324: "\u739B\u7EB3\u65AF\u53BF",
  652325: "\u5947\u53F0\u53BF",
  652327: "\u5409\u6728\u8428\u5C14\u53BF",
  652328: "\u6728\u5792\u54C8\u8428\u514B\u81EA\u6CBB\u53BF",
  652700: "\u535A\u5C14\u5854\u62C9\u8499\u53E4\u81EA\u6CBB\u5DDE",
  652701: "\u535A\u4E50\u5E02",
  652702: "\u963F\u62C9\u5C71\u53E3\u5E02",
  652722: "\u7CBE\u6CB3\u53BF",
  652723: "\u6E29\u6CC9\u53BF",
  652800: "\u5DF4\u97F3\u90ED\u695E\u8499\u53E4\u81EA\u6CBB\u5DDE",
  652801: "\u5E93\u5C14\u52D2\u5E02",
  652822: "\u8F6E\u53F0\u53BF",
  652823: "\u5C09\u7281\u53BF",
  652824: "\u82E5\u7F8C\u53BF",
  652825: "\u4E14\u672B\u53BF",
  652826: "\u7109\u8006\u56DE\u65CF\u81EA\u6CBB\u53BF",
  652827: "\u548C\u9759\u53BF",
  652828: "\u548C\u7855\u53BF",
  652829: "\u535A\u6E56\u53BF",
  652871: "\u5E93\u5C14\u52D2\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A",
  652900: "\u963F\u514B\u82CF\u5730\u533A",
  652901: "\u963F\u514B\u82CF\u5E02",
  652922: "\u6E29\u5BBF\u53BF",
  652923: "\u5E93\u8F66\u53BF",
  652924: "\u6C99\u96C5\u53BF",
  652925: "\u65B0\u548C\u53BF",
  652926: "\u62DC\u57CE\u53BF",
  652927: "\u4E4C\u4EC0\u53BF",
  652928: "\u963F\u74E6\u63D0\u53BF",
  652929: "\u67EF\u576A\u53BF",
  653e3: "\u514B\u5B5C\u52D2\u82CF\u67EF\u5C14\u514B\u5B5C\u81EA\u6CBB\u5DDE",
  653001: "\u963F\u56FE\u4EC0\u5E02",
  653022: "\u963F\u514B\u9676\u53BF",
  653023: "\u963F\u5408\u5947\u53BF",
  653024: "\u4E4C\u6070\u53BF",
  653100: "\u5580\u4EC0\u5730\u533A",
  653101: "\u5580\u4EC0\u5E02",
  653121: "\u758F\u9644\u53BF",
  653122: "\u758F\u52D2\u53BF",
  653123: "\u82F1\u5409\u6C99\u53BF",
  653124: "\u6CFD\u666E\u53BF",
  653125: "\u838E\u8F66\u53BF",
  653126: "\u53F6\u57CE\u53BF",
  653127: "\u9EA6\u76D6\u63D0\u53BF",
  653128: "\u5CB3\u666E\u6E56\u53BF",
  653129: "\u4F3D\u5E08\u53BF",
  653130: "\u5DF4\u695A\u53BF",
  653131: "\u5854\u4EC0\u5E93\u5C14\u5E72\u5854\u5409\u514B\u81EA\u6CBB\u53BF",
  653200: "\u548C\u7530\u5730\u533A",
  653201: "\u548C\u7530\u5E02",
  653221: "\u548C\u7530\u53BF",
  653222: "\u58A8\u7389\u53BF",
  653223: "\u76AE\u5C71\u53BF",
  653224: "\u6D1B\u6D66\u53BF",
  653225: "\u7B56\u52D2\u53BF",
  653226: "\u4E8E\u7530\u53BF",
  653227: "\u6C11\u4E30\u53BF",
  654e3: "\u4F0A\u7281\u54C8\u8428\u514B\u81EA\u6CBB\u5DDE",
  654002: "\u4F0A\u5B81\u5E02",
  654003: "\u594E\u5C6F\u5E02",
  654004: "\u970D\u5C14\u679C\u65AF\u5E02",
  654021: "\u4F0A\u5B81\u53BF",
  654022: "\u5BDF\u5E03\u67E5\u5C14\u9521\u4F2F\u81EA\u6CBB\u53BF",
  654023: "\u970D\u57CE\u53BF",
  654024: "\u5DE9\u7559\u53BF",
  654025: "\u65B0\u6E90\u53BF",
  654026: "\u662D\u82CF\u53BF",
  654027: "\u7279\u514B\u65AF\u53BF",
  654028: "\u5C3C\u52D2\u514B\u53BF",
  654200: "\u5854\u57CE\u5730\u533A",
  654201: "\u5854\u57CE\u5E02",
  654202: "\u4E4C\u82CF\u5E02",
  654221: "\u989D\u654F\u53BF",
  654223: "\u6C99\u6E7E\u53BF",
  654224: "\u6258\u91CC\u53BF",
  654225: "\u88D5\u6C11\u53BF",
  654226: "\u548C\u5E03\u514B\u8D5B\u5C14\u8499\u53E4\u81EA\u6CBB\u53BF",
  654300: "\u963F\u52D2\u6CF0\u5730\u533A",
  654301: "\u963F\u52D2\u6CF0\u5E02",
  654321: "\u5E03\u5C14\u6D25\u53BF",
  654322: "\u5BCC\u8574\u53BF",
  654323: "\u798F\u6D77\u53BF",
  654324: "\u54C8\u5DF4\u6CB3\u53BF",
  654325: "\u9752\u6CB3\u53BF",
  654326: "\u5409\u6728\u4E43\u53BF",
  659e3: "\u81EA\u6CBB\u533A\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
  659001: "\u77F3\u6CB3\u5B50\u5E02",
  659002: "\u963F\u62C9\u5C14\u5E02",
  659003: "\u56FE\u6728\u8212\u514B\u5E02",
  659004: "\u4E94\u5BB6\u6E20\u5E02",
  659006: "\u94C1\u95E8\u5173\u5E02",
  71e4: "\u53F0\u6E7E\u7701",
  710100: "\u53F0\u5317\u5E02",
  710101: "\u5185\u6E56\u533A",
  710102: "\u5357\u6E2F\u533A",
  710103: "\u4E2D\u6B63\u533A",
  710104: "\u677E\u5C71\u533A",
  710105: "\u4FE1\u4E49\u533A",
  710106: "\u5927\u5B89\u533A",
  710107: "\u4E2D\u5C71\u533A",
  710108: "\u6587\u5C71\u533A",
  710109: "\u5927\u540C\u533A",
  710110: "\u4E07\u534E\u533A",
  710111: "\u58EB\u6797\u533A",
  710112: "\u5317\u6295\u533A",
  710200: "\u9AD8\u96C4\u5E02",
  710201: "\u65B0\u5174\u533A",
  710202: "\u524D\u91D1\u533A",
  710203: "\u82A9\u96C5\u533A",
  710204: "\u76D0\u57D5\u533A",
  710205: "\u9F13\u5C71\u533A",
  710206: "\u65D7\u6D25\u533A",
  710207: "\u524D\u9547\u533A",
  710208: "\u4E09\u6C11\u533A",
  710209: "\u5DE6\u8425\u533A",
  710210: "\u6960\u6893\u533A",
  710211: "\u5C0F\u6E2F\u533A",
  710300: "\u57FA\u9686\u5E02",
  710301: "\u4E2D\u533A",
  710302: "\u4E1C\u533A",
  710303: "\u5357\u533A",
  710304: "\u897F\u533A",
  710305: "\u5317\u533A",
  710306: "\u5317\u5C6F\u533A",
  710307: "\u897F\u5C6F\u533A",
  710308: "\u5357\u5C6F\u533A",
  710400: "\u53F0\u4E2D\u5E02",
  710500: "\u53F0\u5357\u5E02",
  710501: "\u4E2D\u897F\u533A",
  710502: "\u4E1C\u533A",
  710503: "\u5357\u533A",
  710504: "\u5317\u533A",
  710505: "\u5B89\u5E73\u533A",
  710506: "\u5B89\u5357\u533A",
  710600: "\u65B0\u7AF9\u5E02",
  710601: "\u4E1C\u533A",
  710602: "\u5317\u533A",
  710603: "\u9999\u5C71\u533A",
  710700: "\u5609\u4E49\u5E02",
  710701: "\u4E1C\u533A",
  710702: "\u897F\u533A",
  81e4: "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A",
  810001: "\u4E2D\u897F\u5340",
  810002: "\u7063\u4ED4\u5340",
  810003: "\u6771\u5340",
  810004: "\u5357\u5340",
  810005: "\u6CB9\u5C16\u65FA\u5340",
  810006: "\u6DF1\u6C34\u57D7\u5340",
  810007: "\u4E5D\u9F8D\u57CE\u5340",
  810008: "\u9EC3\u5927\u4ED9\u5340",
  810009: "\u89C0\u5858\u5340",
  810010: "\u8343\u7063\u5340",
  810011: "\u5C6F\u9580\u5340",
  810012: "\u5143\u6717\u5340",
  810013: "\u5317\u5340",
  810014: "\u5927\u57D4\u5340",
  810015: "\u897F\u8CA2\u5340",
  810016: "\u6C99\u7530\u5340",
  810017: "\u8475\u9752\u5340",
  810018: "\u96E2\u5CF6\u5340",
  82e4: "\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A",
  820001: "\u82B1\u5730\u746A\u5802\u5340",
  820002: "\u82B1\u738B\u5802\u5340",
  820003: "\u671B\u5FB7\u5802\u5340",
  820004: "\u5927\u5802\u5340",
  820005: "\u98A8\u9806\u5802\u5340",
  820006: "\u5609\u6A21\u5802\u5340",
  820007: "\u8DEF\u6C39\u586B\u6D77\u5340",
  820008: "\u8056\u65B9\u6FDF\u5404\u5802\u5340",
  441900003: "\u4E1C\u57CE\u8857\u9053",
  441900004: "\u5357\u57CE\u8857\u9053",
  441900005: "\u4E07\u6C5F\u8857\u9053",
  441900006: "\u839E\u57CE\u8857\u9053",
  441900101: "\u77F3\u78A3\u9547",
  441900102: "\u77F3\u9F99\u9547",
  441900103: "\u8336\u5C71\u9547",
  441900104: "\u77F3\u6392\u9547",
  441900105: "\u4F01\u77F3\u9547",
  441900106: "\u6A2A\u6CA5\u9547",
  441900107: "\u6865\u5934\u9547",
  441900108: "\u8C22\u5C97\u9547",
  441900109: "\u4E1C\u5751\u9547",
  441900110: "\u5E38\u5E73\u9547",
  441900111: "\u5BEE\u6B65\u9547",
  441900112: "\u6A1F\u6728\u5934\u9547",
  441900113: "\u5927\u6717\u9547",
  441900114: "\u9EC4\u6C5F\u9547",
  441900115: "\u6E05\u6EAA\u9547",
  441900116: "\u5858\u53A6\u9547",
  441900117: "\u51E4\u5C97\u9547",
  441900118: "\u5927\u5CAD\u5C71\u9547",
  441900119: "\u957F\u5B89\u9547",
  441900121: "\u864E\u95E8\u9547",
  441900122: "\u539A\u8857\u9547",
  441900123: "\u6C99\u7530\u9547",
  441900124: "\u9053\u6ED8\u9547",
  441900125: "\u6D2A\u6885\u9547",
  441900126: "\u9EBB\u6D8C\u9547",
  441900127: "\u671B\u725B\u58A9\u9547",
  441900128: "\u4E2D\u5802\u9547",
  441900129: "\u9AD8\u57D7\u9547",
  441900401: "\u677E\u5C71\u6E56",
  441900402: "\u4E1C\u839E\u6E2F",
  441900403: "\u4E1C\u839E\u751F\u6001\u56ED",
  442000001: "\u77F3\u5C90\u8857\u9053",
  442000002: "\u4E1C\u533A\u8857\u9053",
  442000003: "\u4E2D\u5C71\u6E2F\u8857\u9053",
  442000004: "\u897F\u533A\u8857\u9053",
  442000005: "\u5357\u533A\u8857\u9053",
  442000006: "\u4E94\u6842\u5C71\u8857\u9053",
  442000100: "\u5C0F\u6984\u9547",
  442000101: "\u9EC4\u5703\u9547",
  442000102: "\u6C11\u4F17\u9547",
  442000103: "\u4E1C\u51E4\u9547",
  442000104: "\u4E1C\u5347\u9547",
  442000105: "\u53E4\u9547\u9547",
  442000106: "\u6C99\u6EAA\u9547",
  442000107: "\u5766\u6D32\u9547",
  442000108: "\u6E2F\u53E3\u9547",
  442000109: "\u4E09\u89D2\u9547",
  442000110: "\u6A2A\u680F\u9547",
  442000111: "\u5357\u5934\u9547",
  442000112: "\u961C\u6C99\u9547",
  442000113: "\u5357\u6717\u9547",
  442000114: "\u4E09\u4E61\u9547",
  442000115: "\u677F\u8299\u9547",
  442000116: "\u5927\u6D8C\u9547",
  442000117: "\u795E\u6E7E\u9547",
  460400100: "\u90A3\u5927\u9547",
  460400101: "\u548C\u5E86\u9547",
  460400102: "\u5357\u4E30\u9547",
  460400103: "\u5927\u6210\u9547",
  460400104: "\u96C5\u661F\u9547",
  460400105: "\u5170\u6D0B\u9547",
  460400106: "\u5149\u6751\u9547",
  460400107: "\u6728\u68E0\u9547",
  460400108: "\u6D77\u5934\u9547",
  460400109: "\u5CE8\u8513\u9547",
  460400111: "\u738B\u4E94\u9547",
  460400112: "\u767D\u9A6C\u4E95\u9547",
  460400113: "\u4E2D\u548C\u9547",
  460400114: "\u6392\u6D66\u9547",
  460400115: "\u4E1C\u6210\u9547",
  460400116: "\u65B0\u5DDE\u9547",
  460400499: "\u6D0B\u6D66\u7ECF\u6D4E\u5F00\u53D1\u533A",
  460400500: "\u534E\u5357\u70ED\u4F5C\u5B66\u9662",
  "": "\u5168\u90E8"
};
function _defineProperty$m(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function ownKeys$1(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key2) {
      _defineProperty$m(target, key2, source[key2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key2) {
      Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
    });
  }
  return target;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
var isFunction$1 = function isFunction(val) {
  return typeof val === "function";
};
var isArray$2 = Array.isArray;
var isString = function isString2(val) {
  return typeof val === "string";
};
var isObject$1 = function isObject(val) {
  return val !== null && _typeof$1(val) === "object";
};
var onRE = /^on[^a-z]/;
var isOn = function isOn2(key2) {
  return onRE.test(key2);
};
var cacheStringFunction = function cacheStringFunction2(fn) {
  var cache = /* @__PURE__ */ Object.create(null);
  return function(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
};
var camelizeRE = /-(\w)/g;
var camelize = cacheStringFunction(function(str) {
  return str.replace(camelizeRE, function(_2, c2) {
    return c2 ? c2.toUpperCase() : "";
  });
});
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cacheStringFunction(function(str) {
  return str.replace(hyphenateRE, "-$1").toLowerCase();
});
var hasOwnProperty$9 = Object.prototype.hasOwnProperty;
var hasOwn = function hasOwn2(val, key2) {
  return hasOwnProperty$9.call(val, key2);
};
function resolvePropValue(options, props2, key2, value) {
  var opt = options[key2];
  if (opt != null) {
    var hasDefault = hasOwn(opt, "default");
    if (hasDefault && value === void 0) {
      var defaultValue = opt.default;
      value = opt.type !== Function && isFunction$1(defaultValue) ? defaultValue() : defaultValue;
    }
    if (opt.type === Boolean) {
      if (!hasOwn(props2, key2) && !hasDefault) {
        value = false;
      } else if (value === "") {
        value = true;
      }
    }
  }
  return value;
}
function renderHelper(v2) {
  var props2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var defaultV = arguments.length > 2 ? arguments[2] : void 0;
  if (typeof v2 === "function") {
    return v2(props2);
  }
  return v2 !== null && v2 !== void 0 ? v2 : defaultV;
}
function classNames() {
  var classes = [];
  for (var i = 0; i < arguments.length; i++) {
    var value = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (!value)
      continue;
    if (isString(value)) {
      classes.push(value);
    } else if (isArray$2(value)) {
      for (var _i = 0; _i < value.length; _i++) {
        var inner = classNames(value[_i]);
        if (inner) {
          classes.push(inner);
        }
      }
    } else if (isObject$1(value)) {
      for (var name in value) {
        if (value[name]) {
          classes.push(name);
        }
      }
    }
  }
  return classes.join(" ");
}
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key2) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key2) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return function() {
    function class_1() {
      this.__entries__ = [];
    }
    Object.defineProperty(class_1.prototype, "size", {
      get: function() {
        return this.__entries__.length;
      },
      enumerable: true,
      configurable: true
    });
    class_1.prototype.get = function(key2) {
      var index2 = getIndex(this.__entries__, key2);
      var entry = this.__entries__[index2];
      return entry && entry[1];
    };
    class_1.prototype.set = function(key2, value) {
      var index2 = getIndex(this.__entries__, key2);
      if (~index2) {
        this.__entries__[index2][1] = value;
      } else {
        this.__entries__.push([key2, value]);
      }
    };
    class_1.prototype.delete = function(key2) {
      var entries = this.__entries__;
      var index2 = getIndex(entries, key2);
      if (~index2) {
        entries.splice(index2, 1);
      }
    };
    class_1.prototype.has = function(key2) {
      return !!~getIndex(this.__entries__, key2);
    };
    class_1.prototype.clear = function() {
      this.__entries__.splice(0);
    };
    class_1.prototype.forEach = function(callback, ctx) {
      if (ctx === void 0) {
        ctx = null;
      }
      for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
        var entry = _a[_i];
        callback.call(ctx, entry[1], entry[0]);
      }
    };
    return class_1;
  }();
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = function() {
  function ResizeObserverController2() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];
    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
  }
  ResizeObserverController2.prototype.addObserver = function(observer) {
    if (!~this.observers_.indexOf(observer)) {
      this.observers_.push(observer);
    }
    if (!this.connected_) {
      this.connect_();
    }
  };
  ResizeObserverController2.prototype.removeObserver = function(observer) {
    var observers2 = this.observers_;
    var index2 = observers2.indexOf(observer);
    if (~index2) {
      observers2.splice(index2, 1);
    }
    if (!observers2.length && this.connected_) {
      this.disconnect_();
    }
  };
  ResizeObserverController2.prototype.refresh = function() {
    var changesDetected = this.updateObservers_();
    if (changesDetected) {
      this.refresh();
    }
  };
  ResizeObserverController2.prototype.updateObservers_ = function() {
    var activeObservers = this.observers_.filter(function(observer) {
      return observer.gatherActive(), observer.hasActive();
    });
    activeObservers.forEach(function(observer) {
      return observer.broadcastActive();
    });
    return activeObservers.length > 0;
  };
  ResizeObserverController2.prototype.connect_ = function() {
    if (!isBrowser || this.connected_) {
      return;
    }
    document.addEventListener("transitionend", this.onTransitionEnd_);
    window.addEventListener("resize", this.refresh);
    if (mutationObserverSupported) {
      this.mutationsObserver_ = new MutationObserver(this.refresh);
      this.mutationsObserver_.observe(document, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
    } else {
      document.addEventListener("DOMSubtreeModified", this.refresh);
      this.mutationEventsAdded_ = true;
    }
    this.connected_ = true;
  };
  ResizeObserverController2.prototype.disconnect_ = function() {
    if (!isBrowser || !this.connected_) {
      return;
    }
    document.removeEventListener("transitionend", this.onTransitionEnd_);
    window.removeEventListener("resize", this.refresh);
    if (this.mutationsObserver_) {
      this.mutationsObserver_.disconnect();
    }
    if (this.mutationEventsAdded_) {
      document.removeEventListener("DOMSubtreeModified", this.refresh);
    }
    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
  };
  ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
    var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
    var isReflowProperty = transitionKeys.some(function(key2) {
      return !!~propertyName.indexOf(key2);
    });
    if (isReflowProperty) {
      this.refresh();
    }
  };
  ResizeObserverController2.getInstance = function() {
    if (!this.instance_) {
      this.instance_ = new ResizeObserverController2();
    }
    return this.instance_;
  };
  ResizeObserverController2.instance_ = null;
  return ResizeObserverController2;
}();
var defineConfigurable = function(target, props2) {
  for (var _i = 0, _a = Object.keys(props2); _i < _a.length; _i++) {
    var key2 = _a[_i];
    Object.defineProperty(target, key2, {
      value: props2[key2],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position) {
    var value = styles["border-" + position + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles["padding-" + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x2 = _a.x, y2 = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x2,
    y: y2,
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: height + y2,
    left: x2
  });
  return rect;
}
function createRectInit(x2, y2, width, height) {
  return { x: x2, y: y2, width, height };
}
var ResizeObservation = function() {
  function ResizeObservation2(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);
    this.target = target;
  }
  ResizeObservation2.prototype.isActive = function() {
    var rect = getContentRect(this.target);
    this.contentRect_ = rect;
    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
  };
  ResizeObservation2.prototype.broadcastRect = function() {
    var rect = this.contentRect_;
    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;
    return rect;
  };
  return ResizeObservation2;
}();
var ResizeObserverEntry = function() {
  function ResizeObserverEntry2(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);
    defineConfigurable(this, { target, contentRect });
  }
  return ResizeObserverEntry2;
}();
var ResizeObserverSPI = function() {
  function ResizeObserverSPI2(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();
    if (typeof callback !== "function") {
      throw new TypeError("The callback provided as parameter 1 is not a function.");
    }
    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
  }
  ResizeObserverSPI2.prototype.observe = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (observations.has(target)) {
      return;
    }
    observations.set(target, new ResizeObservation(target));
    this.controller_.addObserver(this);
    this.controller_.refresh();
  };
  ResizeObserverSPI2.prototype.unobserve = function(target) {
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    if (typeof Element === "undefined" || !(Element instanceof Object)) {
      return;
    }
    if (!(target instanceof getWindowOf(target).Element)) {
      throw new TypeError('parameter 1 is not of type "Element".');
    }
    var observations = this.observations_;
    if (!observations.has(target)) {
      return;
    }
    observations.delete(target);
    if (!observations.size) {
      this.controller_.removeObserver(this);
    }
  };
  ResizeObserverSPI2.prototype.disconnect = function() {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
  };
  ResizeObserverSPI2.prototype.gatherActive = function() {
    var _this = this;
    this.clearActive();
    this.observations_.forEach(function(observation) {
      if (observation.isActive()) {
        _this.activeObservations_.push(observation);
      }
    });
  };
  ResizeObserverSPI2.prototype.broadcastActive = function() {
    if (!this.hasActive()) {
      return;
    }
    var ctx = this.callbackCtx_;
    var entries = this.activeObservations_.map(function(observation) {
      return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });
    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
  };
  ResizeObserverSPI2.prototype.clearActive = function() {
    this.activeObservations_.splice(0);
  };
  ResizeObserverSPI2.prototype.hasActive = function() {
    return this.activeObservations_.length > 0;
  };
  return ResizeObserverSPI2;
}();
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver$1 = function() {
  function ResizeObserver2(callback) {
    if (!(this instanceof ResizeObserver2)) {
      throw new TypeError("Cannot call a class as a function.");
    }
    if (!arguments.length) {
      throw new TypeError("1 argument required, but only 0 present.");
    }
    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);
    observers.set(this, observer);
  }
  return ResizeObserver2;
}();
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver$1.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index$2 = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver$1;
}();
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray$2(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$2(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$2(o2, minLen);
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$2(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread();
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeGlobal$1 = freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal$1 || freeSelf || Function("return this")();
var root$1 = root;
var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$1 = objectProto$b.toString;
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$a = Object.prototype;
var nativeObjectToString = objectProto$a.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var isValid = function isValid2(value) {
  return value !== void 0 && value !== null && value !== "";
};
var isValid$1 = isValid;
var initDefaultProps = function initDefaultProps2(types, defaultProps) {
  var propTypes = _extends({}, types);
  Object.keys(defaultProps).forEach(function(k2) {
    var prop = propTypes[k2];
    if (prop) {
      if (prop.type || prop.default) {
        prop.default = defaultProps[k2];
      } else if (prop.def) {
        prop.def(defaultProps[k2]);
      } else {
        propTypes[k2] = {
          type: prop,
          default: defaultProps[k2]
        };
      }
    } else {
      throw new Error("not have ".concat(k2, " prop"));
    }
  });
  return propTypes;
};
var initDefaultProps$1 = initDefaultProps;
var splitAttrs = function splitAttrs2(attrs) {
  var allAttrs = Object.keys(attrs);
  var eventAttrs = {};
  var onEvents = {};
  var extraAttrs = {};
  for (var i = 0, l2 = allAttrs.length; i < l2; i++) {
    var key2 = allAttrs[i];
    if (isOn(key2)) {
      eventAttrs[key2[2].toLowerCase() + key2.slice(3)] = attrs[key2];
      onEvents[key2] = attrs[key2];
    } else {
      extraAttrs[key2] = attrs[key2];
    }
  }
  return {
    onEvents,
    events: eventAttrs,
    extraAttrs
  };
};
var parseStyleText = function parseStyleText2() {
  var cssText = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  var camel = arguments.length > 1 ? arguments[1] : void 0;
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  if (_typeof$1(cssText) === "object")
    return cssText;
  cssText.split(listDelimiter).forEach(function(item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      if (tmp.length > 1) {
        var k2 = camel ? camelize(tmp[0].trim()) : tmp[0].trim();
        res[k2] = tmp[1].trim();
      }
    }
  });
  return res;
};
var hasProp = function hasProp2(instance, prop) {
  return instance[prop] !== void 0;
};
var flattenChildren = function flattenChildren2() {
  var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var filterEmpty2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  var temp = Array.isArray(children) ? children : [children];
  var res = [];
  temp.forEach(function(child) {
    if (Array.isArray(child)) {
      res.push.apply(res, _toConsumableArray(flattenChildren2(child, filterEmpty2)));
    } else if (child && child.type === Fragment) {
      res.push.apply(res, _toConsumableArray(flattenChildren2(child.children, filterEmpty2)));
    } else if (child && isVNode(child)) {
      if (filterEmpty2 && !isEmptyElement(child)) {
        res.push(child);
      } else if (!filterEmpty2) {
        res.push(child);
      }
    } else if (isValid$1(child)) {
      res.push(child);
    }
  });
  return res;
};
var getSlot = function getSlot2(self2) {
  var name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (isVNode(self2)) {
    if (self2.type === Fragment) {
      return name === "default" ? flattenChildren(self2.children) : [];
    } else if (self2.children && self2.children[name]) {
      return flattenChildren(self2.children[name](options));
    } else {
      return [];
    }
  } else {
    var res = self2.$slots[name] && self2.$slots[name](options);
    return flattenChildren(res);
  }
};
var findDOMNode = function findDOMNode2(instance) {
  var _a;
  var node = ((_a = instance === null || instance === void 0 ? void 0 : instance.vnode) === null || _a === void 0 ? void 0 : _a.el) || instance && (instance.$el || instance);
  while (node && !node.tagName) {
    node = node.nextSibling;
  }
  return node;
};
var getOptionProps = function getOptionProps2(instance) {
  var res = {};
  if (instance.$ && instance.$.vnode) {
    var props2 = instance.$.vnode.props || {};
    Object.keys(instance.$props).forEach(function(k2) {
      var v2 = instance.$props[k2];
      var hyphenateKey = hyphenate(k2);
      if (v2 !== void 0 || hyphenateKey in props2) {
        res[k2] = v2;
      }
    });
  } else if (isVNode(instance) && _typeof$1(instance.type) === "object") {
    var originProps = instance.props || {};
    var _props = {};
    Object.keys(originProps).forEach(function(key2) {
      _props[camelize(key2)] = originProps[key2];
    });
    var options = instance.type.props || {};
    Object.keys(options).forEach(function(k2) {
      var v2 = resolvePropValue(options, _props, k2, _props[k2]);
      if (v2 !== void 0 || k2 in _props) {
        res[k2] = v2;
      }
    });
  }
  return res;
};
var getComponent = function getComponent2(instance) {
  var prop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "default";
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : instance;
  var execute = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
  var com = void 0;
  if (instance.$) {
    var temp = instance[prop];
    if (temp !== void 0) {
      return typeof temp === "function" && execute ? temp(options) : temp;
    } else {
      com = instance.$slots[prop];
      com = execute && com ? com(options) : com;
    }
  } else if (isVNode(instance)) {
    var _temp = instance.props && instance.props[prop];
    if (_temp !== void 0 && instance.props !== null) {
      return typeof _temp === "function" && execute ? _temp(options) : _temp;
    } else if (instance.type === Fragment) {
      com = instance.children;
    } else if (instance.children && instance.children[prop]) {
      com = instance.children[prop];
      com = execute && com ? com(options) : com;
    }
  }
  if (Array.isArray(com)) {
    com = flattenChildren(com);
    com = com.length === 1 ? com[0] : com;
    com = com.length === 0 ? void 0 : com;
  }
  return com;
};
function getEvents() {
  var ele = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var on = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  var props2 = {};
  if (ele.$) {
    props2 = _extends(_extends({}, props2), ele.$attrs);
  } else {
    props2 = _extends(_extends({}, props2), ele.props);
  }
  return splitAttrs(props2)[on ? "onEvents" : "events"];
}
function getStyle(ele, camel) {
  var props2 = (isVNode(ele) ? ele.props : ele.$attrs) || {};
  var style2 = props2.style || {};
  if (typeof style2 === "string") {
    style2 = parseStyleText(style2, camel);
  } else if (camel && style2) {
    var res = {};
    Object.keys(style2).forEach(function(k2) {
      return res[camelize(k2)] = style2[k2];
    });
    return res;
  }
  return style2;
}
function isEmptyElement(c2) {
  return c2 && (c2.type === Comment || c2.type === Fragment && c2.children.length === 0 || c2.type === Text && c2.children.trim() === "");
}
function filterEmpty() {
  var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var res = [];
  children.forEach(function(child) {
    if (Array.isArray(child)) {
      res.push.apply(res, _toConsumableArray(child));
    } else if (child.type === Fragment) {
      res.push.apply(res, _toConsumableArray(child.children));
    } else {
      res.push(child);
    }
  });
  return res.filter(function(c2) {
    return !isEmptyElement(c2);
  });
}
function isValidElement(element) {
  if (Array.isArray(element) && element.length === 1) {
    element = element[0];
  }
  return element && element.__v_isVNode && _typeof$1(element.type) !== "symbol";
}
function getPropsSlot(slots, props2) {
  var prop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "default";
  var _a, _b;
  return (_a = props2[prop]) !== null && _a !== void 0 ? _a : (_b = slots[prop]) === null || _b === void 0 ? void 0 : _b.call(slots);
}
var ResizeObserver = defineComponent({
  name: "ResizeObserver",
  props: {
    disabled: Boolean,
    onResize: Function
  },
  emits: ["resize"],
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var state = reactive({
      width: 0,
      height: 0,
      offsetHeight: 0,
      offsetWidth: 0
    });
    var currentElement = null;
    var resizeObserver = null;
    var destroyObserver = function destroyObserver2() {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
    var onResize = function onResize2(entries) {
      var onResize3 = props2.onResize;
      var target = entries[0].target;
      var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
      var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
      var fixedWidth = Math.floor(width);
      var fixedHeight = Math.floor(height);
      if (state.width !== fixedWidth || state.height !== fixedHeight || state.offsetWidth !== offsetWidth || state.offsetHeight !== offsetHeight) {
        var size = {
          width: fixedWidth,
          height: fixedHeight,
          offsetWidth,
          offsetHeight
        };
        _extends(state, size);
        if (onResize3) {
          Promise.resolve().then(function() {
            onResize3(_extends(_extends({}, size), {
              offsetWidth,
              offsetHeight
            }), target);
          });
        }
      }
    };
    var instance = getCurrentInstance();
    var registerObserver = function registerObserver2() {
      var disabled = props2.disabled;
      if (disabled) {
        destroyObserver();
        return;
      }
      var element = findDOMNode(instance);
      var elementChanged = element !== currentElement;
      if (elementChanged) {
        destroyObserver();
        currentElement = element;
      }
      if (!resizeObserver && element) {
        resizeObserver = new index$2(onResize);
        resizeObserver.observe(element);
      }
    };
    onMounted(function() {
      registerObserver();
    });
    onUpdated(function() {
      registerObserver();
    });
    onUnmounted(function() {
      destroyObserver();
    });
    watch(function() {
      return props2.disabled;
    }, function() {
      registerObserver();
    }, {
      flush: "post"
    });
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)[0];
    };
  }
});
var raf$1 = function raf(callback) {
  return setTimeout(callback, 16);
};
var caf = function caf2(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf$1 = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = /* @__PURE__ */ new Map();
function cleanup(id) {
  rafIds.delete(id);
}
function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id);
      callback();
    } else {
      var realId = raf$1(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
}
wrapperRaf.cancel = function(id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};
var tuple = function tuple2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args;
};
var withInstall = function withInstall2(comp) {
  var c2 = comp;
  c2.install = function(app) {
    app.component(c2.displayName || c2.name, comp);
  };
  return comp;
};
var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, "passive", {
    get: function get() {
      supportsPassive = true;
    }
  });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e2) {
}
var supportsPassive$1 = supportsPassive;
function addEventListenerWrap(target, eventType, cb, option) {
  if (target && target.addEventListener) {
    var opt = option;
    if (opt === void 0 && supportsPassive$1 && (eventType === "touchstart" || eventType === "touchmove" || eventType === "wheel")) {
      opt = {
        passive: false
      };
    }
    target.addEventListener(eventType, cb, opt);
  }
  return {
    remove: function remove() {
      if (target && target.removeEventListener) {
        target.removeEventListener(eventType, cb);
      }
    }
  };
}
var enUS$1 = {
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "",
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages"
};
var locale$2 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "Ok",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: true,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
var CalendarLocale = locale$2;
var locale$1 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
var TimePicker = locale$1;
var locale = {
  lang: _extends({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, CalendarLocale),
  timePickerLocale: _extends({}, TimePicker)
};
var enUS = locale;
var typeTemplate = "${label} is not a valid ${type}";
var localeValues = {
  locale: "en",
  Pagination: enUS$1,
  DatePicker: enUS,
  TimePicker,
  Calendar: enUS,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No Data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  }
};
var defaultLocale = localeValues;
var LocaleReceiver = defineComponent({
  name: "LocaleReceiver",
  props: {
    componentName: String,
    defaultLocale: {
      type: [Object, Function]
    },
    children: {
      type: Function
    }
  },
  setup: function setup2(props2, _ref) {
    var slots = _ref.slots;
    var localeData = inject("localeData", {});
    var locale2 = computed(function() {
      var _props$componentName = props2.componentName, componentName = _props$componentName === void 0 ? "global" : _props$componentName, defaultLocale$1 = props2.defaultLocale;
      var locale3 = defaultLocale$1 || defaultLocale[componentName || "global"];
      var antLocale = localeData.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends(_extends({}, typeof locale3 === "function" ? locale3() : locale3), localeFromContext || {});
    });
    var localeCode = computed(function() {
      var antLocale = localeData.antLocale;
      var localeCode2 = antLocale && antLocale.locale;
      if (antLocale && antLocale.exist && !localeCode2) {
        return defaultLocale.locale;
      }
      return localeCode2;
    });
    return function() {
      var children = props2.children || slots.default;
      var antLocale = localeData.antLocale;
      return children === null || children === void 0 ? void 0 : children(locale2.value, localeCode.value, antLocale);
    };
  }
});
function useLocaleReceiver(componentName, defaultLocale$1, propsLocale) {
  var localeData = inject("localeData", {});
  var componentLocale = computed(function() {
    var antLocale = localeData.antLocale;
    var locale2 = unref(defaultLocale$1) || defaultLocale[componentName || "global"];
    var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
    return _extends(_extends(_extends({}, typeof locale2 === "function" ? locale2() : locale2), localeFromContext || {}), unref(propsLocale) || {});
  });
  return [componentLocale];
}
var Empty$2 = function Empty() {
  var _useConfigInject = useConfigInject("empty", {}), getPrefixCls2 = _useConfigInject.getPrefixCls;
  var prefixCls = getPrefixCls2("empty-img-default");
  return createVNode("svg", {
    "class": prefixCls,
    "width": "184",
    "height": "152",
    "viewBox": "0 0 184 152"
  }, [createVNode("g", {
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("g", {
    "transform": "translate(24 31.67)"
  }, [createVNode("ellipse", {
    "class": "".concat(prefixCls, "-ellipse"),
    "cx": "67.797",
    "cy": "106.89",
    "rx": "67.797",
    "ry": "12.668"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls, "-path-1"),
    "d": "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls, "-path-2"),
    "d": "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    "transform": "translate(13.56)"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls, "-path-3"),
    "d": "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  }, null), createVNode("path", {
    "class": "".concat(prefixCls, "-path-4"),
    "d": "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
  }, null)]), createVNode("path", {
    "class": "".concat(prefixCls, "-path-5"),
    "d": "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
  }, null), createVNode("g", {
    "class": "".concat(prefixCls, "-g"),
    "transform": "translate(149.65 15.383)"
  }, [createVNode("ellipse", {
    "cx": "20.654",
    "cy": "3.167",
    "rx": "2.849",
    "ry": "2.815"
  }, null), createVNode("path", {
    "d": "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }, null)])])]);
};
Empty$2.PRESENTED_IMAGE_DEFAULT = true;
var DefaultEmptyImg = Empty$2;
var Simple = function Simple2() {
  var _useConfigInject = useConfigInject("empty", {}), getPrefixCls2 = _useConfigInject.getPrefixCls;
  var prefixCls = getPrefixCls2("empty-img-simple");
  return createVNode("svg", {
    "class": prefixCls,
    "width": "64",
    "height": "41",
    "viewBox": "0 0 64 41"
  }, [createVNode("g", {
    "transform": "translate(0 1)",
    "fill": "none",
    "fill-rule": "evenodd"
  }, [createVNode("ellipse", {
    "class": "".concat(prefixCls, "-ellipse"),
    "fill": "#F5F5F5",
    "cx": "32",
    "cy": "33",
    "rx": "32",
    "ry": "7"
  }, null), createVNode("g", {
    "class": "".concat(prefixCls, "-g"),
    "fill-rule": "nonzero",
    "stroke": "#D9D9D9"
  }, [createVNode("path", {
    "d": "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }, null), createVNode("path", {
    "d": "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    "fill": "#FAFAFA",
    "class": "".concat(prefixCls, "-path")
  }, null)])])]);
};
Simple.PRESENTED_IMAGE_SIMPLE = true;
var SimpleEmptyImg = Simple;
function e(e2, t2) {
  for (var n2 = 0; n2 < t2.length; n2++) {
    var r2 = t2[n2];
    r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e2, r2.key, r2);
  }
}
function t(t2, n2, r2) {
  return n2 && e(t2.prototype, n2), r2 && e(t2, r2), t2;
}
function n() {
  return (n = Object.assign || function(e2) {
    for (var t2 = 1; t2 < arguments.length; t2++) {
      var n2 = arguments[t2];
      for (var r2 in n2)
        Object.prototype.hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
    }
    return e2;
  }).apply(this, arguments);
}
function r(e2, t2) {
  e2.prototype = Object.create(t2.prototype), e2.prototype.constructor = e2, e2.__proto__ = t2;
}
function i$1(e2, t2) {
  if (e2 == null)
    return {};
  var n2, r2, i = {}, o2 = Object.keys(e2);
  for (r2 = 0; r2 < o2.length; r2++)
    t2.indexOf(n2 = o2[r2]) >= 0 || (i[n2] = e2[n2]);
  return i;
}
function o(e2) {
  return ((t2 = e2) != null && typeof t2 == "object" && Array.isArray(t2) === false) == 1 && Object.prototype.toString.call(e2) === "[object Object]";
  var t2;
}
var u = Object.prototype, a = u.toString, f = u.hasOwnProperty, c = /^\s*function (\w+)/;
function l(e2) {
  var t2, n2 = (t2 = e2 == null ? void 0 : e2.type) !== null && t2 !== void 0 ? t2 : e2;
  if (n2) {
    var r2 = n2.toString().match(c);
    return r2 ? r2[1] : "";
  }
  return "";
}
var s = function(e2) {
  var t2, n2;
  return o(e2) !== false && typeof (t2 = e2.constructor) == "function" && o(n2 = t2.prototype) !== false && n2.hasOwnProperty("isPrototypeOf") !== false;
}, v = function(e2) {
  return e2;
}, y = v;
var d = function(e2, t2) {
  return f.call(e2, t2);
}, h = Number.isInteger || function(e2) {
  return typeof e2 == "number" && isFinite(e2) && Math.floor(e2) === e2;
}, b = Array.isArray || function(e2) {
  return a.call(e2) === "[object Array]";
}, O = function(e2) {
  return a.call(e2) === "[object Function]";
}, g = function(e2) {
  return s(e2) && d(e2, "_vueTypes_name");
}, m = function(e2) {
  return s(e2) && (d(e2, "type") || ["_vueTypes_name", "validator", "default", "required"].some(function(t2) {
    return d(e2, t2);
  }));
};
function j(e2, t2) {
  return Object.defineProperty(e2.bind(t2), "__original", { value: e2 });
}
function _(e2, t2, n2) {
  var r2;
  n2 === void 0 && (n2 = false);
  var i = true, o2 = "";
  r2 = s(e2) ? e2 : { type: e2 };
  var u2 = g(r2) ? r2._vueTypes_name + " - " : "";
  if (m(r2) && r2.type !== null) {
    if (r2.type === void 0 || r2.type === true)
      return i;
    if (!r2.required && t2 === void 0)
      return i;
    b(r2.type) ? (i = r2.type.some(function(e3) {
      return _(e3, t2, true) === true;
    }), o2 = r2.type.map(function(e3) {
      return l(e3);
    }).join(" or ")) : i = (o2 = l(r2)) === "Array" ? b(t2) : o2 === "Object" ? s(t2) : o2 === "String" || o2 === "Number" || o2 === "Boolean" || o2 === "Function" ? function(e3) {
      if (e3 == null)
        return "";
      var t3 = e3.constructor.toString().match(c);
      return t3 ? t3[1] : "";
    }(t2) === o2 : t2 instanceof r2.type;
  }
  if (!i) {
    var a2 = u2 + 'value "' + t2 + '" should be of type "' + o2 + '"';
    return n2 === false ? (y(a2), false) : a2;
  }
  if (d(r2, "validator") && O(r2.validator)) {
    var f2 = y, v2 = [];
    if (y = function(e3) {
      v2.push(e3);
    }, i = r2.validator(t2), y = f2, !i) {
      var p = (v2.length > 1 ? "* " : "") + v2.join("\n* ");
      return v2.length = 0, n2 === false ? (y(p), i) : p;
    }
  }
  return i;
}
function T(e2, t2) {
  var n2 = Object.defineProperties(t2, { _vueTypes_name: { value: e2, writable: true }, isRequired: { get: function() {
    return this.required = true, this;
  } }, def: { value: function(e3) {
    return e3 !== void 0 || this.default ? O(e3) || _(this, e3, true) === true ? (this.default = b(e3) ? function() {
      return [].concat(e3);
    } : s(e3) ? function() {
      return Object.assign({}, e3);
    } : e3, this) : (y(this._vueTypes_name + ' - invalid default value: "' + e3 + '"'), this) : this;
  } } }), r2 = n2.validator;
  return O(r2) && (n2.validator = j(r2, n2)), n2;
}
function w(e2, t2) {
  var n2 = T(e2, t2);
  return Object.defineProperty(n2, "validate", { value: function(e3) {
    return O(this.validator) && y(this._vueTypes_name + " - calling .validate() will overwrite the current custom validator function. Validator info:\n" + JSON.stringify(this)), this.validator = j(e3, this), this;
  } });
}
function k(e2, t2, n2) {
  var r2, o2, u2 = (r2 = t2, o2 = {}, Object.getOwnPropertyNames(r2).forEach(function(e3) {
    o2[e3] = Object.getOwnPropertyDescriptor(r2, e3);
  }), Object.defineProperties({}, o2));
  if (u2._vueTypes_name = e2, !s(n2))
    return u2;
  var a2, f2, c2 = n2.validator, l2 = i$1(n2, ["validator"]);
  if (O(c2)) {
    var v2 = u2.validator;
    v2 && (v2 = (f2 = (a2 = v2).__original) !== null && f2 !== void 0 ? f2 : a2), u2.validator = j(v2 ? function(e3) {
      return v2.call(this, e3) && c2.call(this, e3);
    } : c2, u2);
  }
  return Object.assign(u2, l2);
}
function P(e2) {
  return e2.replace(/^(?!\s*$)/gm, "  ");
}
var x = function() {
  return w("any", {});
}, A = function() {
  return w("function", { type: Function });
}, E = function() {
  return w("boolean", { type: Boolean });
}, N = function() {
  return w("string", { type: String });
}, q = function() {
  return w("number", { type: Number });
}, S = function() {
  return w("array", { type: Array });
}, V = function() {
  return w("object", { type: Object });
}, F = function() {
  return T("integer", { type: Number, validator: function(e2) {
    return h(e2);
  } });
}, D = function() {
  return T("symbol", { validator: function(e2) {
    return typeof e2 == "symbol";
  } });
};
function L(e2, t2) {
  if (t2 === void 0 && (t2 = "custom validation failed"), typeof e2 != "function")
    throw new TypeError("[VueTypes error]: You must provide a function as argument");
  return T(e2.name || "<<anonymous function>>", { validator: function(n2) {
    var r2 = e2(n2);
    return r2 || y(this._vueTypes_name + " - " + t2), r2;
  } });
}
function Y(e2) {
  if (!b(e2))
    throw new TypeError("[VueTypes error]: You must provide an array as argument.");
  var t2 = 'oneOf - value should be one of "' + e2.join('", "') + '".', n2 = e2.reduce(function(e3, t3) {
    if (t3 != null) {
      var n3 = t3.constructor;
      e3.indexOf(n3) === -1 && e3.push(n3);
    }
    return e3;
  }, []);
  return T("oneOf", { type: n2.length > 0 ? n2 : void 0, validator: function(n3) {
    var r2 = e2.indexOf(n3) !== -1;
    return r2 || y(t2), r2;
  } });
}
function B(e2) {
  if (!b(e2))
    throw new TypeError("[VueTypes error]: You must provide an array as argument");
  for (var t2 = false, n2 = [], r2 = 0; r2 < e2.length; r2 += 1) {
    var i = e2[r2];
    if (m(i)) {
      if (g(i) && i._vueTypes_name === "oneOf") {
        n2 = n2.concat(i.type);
        continue;
      }
      if (O(i.validator) && (t2 = true), i.type !== true && i.type) {
        n2 = n2.concat(i.type);
        continue;
      }
    }
    n2.push(i);
  }
  return n2 = n2.filter(function(e3, t3) {
    return n2.indexOf(e3) === t3;
  }), T("oneOfType", t2 ? { type: n2, validator: function(t3) {
    var n3 = [], r3 = e2.some(function(e3) {
      var r4 = _(g(e3) && e3._vueTypes_name === "oneOf" ? e3.type || null : e3, t3, true);
      return typeof r4 == "string" && n3.push(r4), r4 === true;
    });
    return r3 || y("oneOfType - provided value does not match any of the " + n3.length + " passed-in validators:\n" + P(n3.join("\n"))), r3;
  } } : { type: n2 });
}
function I(e2) {
  return T("arrayOf", { type: Array, validator: function(t2) {
    var n2, r2 = t2.every(function(t3) {
      return (n2 = _(e2, t3, true)) === true;
    });
    return r2 || y("arrayOf - value validation error:\n" + P(n2)), r2;
  } });
}
function J(e2) {
  return T("instanceOf", { type: e2 });
}
function M(e2) {
  return T("objectOf", { type: Object, validator: function(t2) {
    var n2, r2 = Object.keys(t2).every(function(r3) {
      return (n2 = _(e2, t2[r3], true)) === true;
    });
    return r2 || y("objectOf - value validation error:\n" + P(n2)), r2;
  } });
}
function R(e2) {
  var t2 = Object.keys(e2), n2 = t2.filter(function(t3) {
    var n3;
    return !!((n3 = e2[t3]) === null || n3 === void 0 ? void 0 : n3.required);
  }), r2 = T("shape", { type: Object, validator: function(r3) {
    var i = this;
    if (!s(r3))
      return false;
    var o2 = Object.keys(r3);
    if (n2.length > 0 && n2.some(function(e3) {
      return o2.indexOf(e3) === -1;
    })) {
      var u2 = n2.filter(function(e3) {
        return o2.indexOf(e3) === -1;
      });
      return y(u2.length === 1 ? 'shape - required property "' + u2[0] + '" is not defined.' : 'shape - required properties "' + u2.join('", "') + '" are not defined.'), false;
    }
    return o2.every(function(n3) {
      if (t2.indexOf(n3) === -1)
        return i._vueTypes_isLoose === true || (y('shape - shape definition does not include a "' + n3 + '" property. Allowed keys: "' + t2.join('", "') + '".'), false);
      var o3 = _(e2[n3], r3[n3], true);
      return typeof o3 == "string" && y('shape - "' + n3 + '" property validation error:\n ' + P(o3)), o3 === true;
    });
  } });
  return Object.defineProperty(r2, "_vueTypes_isLoose", { writable: true, value: false }), Object.defineProperty(r2, "loose", { get: function() {
    return this._vueTypes_isLoose = true, this;
  } }), r2;
}
var $ = function() {
  function e2() {
  }
  return e2.extend = function(e3) {
    var t2 = this;
    if (b(e3))
      return e3.forEach(function(e4) {
        return t2.extend(e4);
      }), this;
    var n2 = e3.name, r2 = e3.validate, o2 = r2 !== void 0 && r2, u2 = e3.getter, a2 = u2 !== void 0 && u2, f2 = i$1(e3, ["name", "validate", "getter"]);
    if (d(this, n2))
      throw new TypeError('[VueTypes error]: Type "' + n2 + '" already defined');
    var c2, l2 = f2.type;
    return g(l2) ? (delete f2.type, Object.defineProperty(this, n2, a2 ? { get: function() {
      return k(n2, l2, f2);
    } } : { value: function() {
      var e4, t3 = k(n2, l2, f2);
      return t3.validator && (t3.validator = (e4 = t3.validator).bind.apply(e4, [t3].concat([].slice.call(arguments)))), t3;
    } })) : (c2 = a2 ? { get: function() {
      var e4 = Object.assign({}, f2);
      return o2 ? w(n2, e4) : T(n2, e4);
    }, enumerable: true } : { value: function() {
      var e4, t3, r3 = Object.assign({}, f2);
      return e4 = o2 ? w(n2, r3) : T(n2, r3), r3.validator && (e4.validator = (t3 = r3.validator).bind.apply(t3, [e4].concat([].slice.call(arguments)))), e4;
    }, enumerable: true }, Object.defineProperty(this, n2, c2));
  }, t(e2, null, [{ key: "any", get: function() {
    return x();
  } }, { key: "func", get: function() {
    return A().def(this.defaults.func);
  } }, { key: "bool", get: function() {
    return E().def(this.defaults.bool);
  } }, { key: "string", get: function() {
    return N().def(this.defaults.string);
  } }, { key: "number", get: function() {
    return q().def(this.defaults.number);
  } }, { key: "array", get: function() {
    return S().def(this.defaults.array);
  } }, { key: "object", get: function() {
    return V().def(this.defaults.object);
  } }, { key: "integer", get: function() {
    return F().def(this.defaults.integer);
  } }, { key: "symbol", get: function() {
    return D();
  } }]), e2;
}();
function z(e2) {
  var i;
  return e2 === void 0 && (e2 = { func: function() {
  }, bool: true, string: "", number: 0, array: function() {
    return [];
  }, object: function() {
    return {};
  }, integer: 0 }), (i = function(i2) {
    function o2() {
      return i2.apply(this, arguments) || this;
    }
    return r(o2, i2), t(o2, null, [{ key: "sensibleDefaults", get: function() {
      return n({}, this.defaults);
    }, set: function(t2) {
      this.defaults = t2 !== false ? n({}, t2 !== true ? t2 : e2) : {};
    } }]), o2;
  }($)).defaults = n({}, e2), i;
}
$.defaults = {}, $.custom = L, $.oneOf = Y, $.instanceOf = J, $.oneOfType = B, $.arrayOf = I, $.objectOf = M, $.shape = R, $.utils = { validate: function(e2, t2) {
  return _(t2, e2, true) === true;
}, toType: function(e2, t2, n2) {
  return n2 === void 0 && (n2 = false), n2 ? w(e2, t2) : T(e2, t2);
} };
(function(e2) {
  function t2() {
    return e2.apply(this, arguments) || this;
  }
  return r(t2, e2), t2;
})(z());
var PropTypes = z({
  func: void 0,
  bool: void 0,
  string: void 0,
  number: void 0,
  array: void 0,
  object: void 0,
  integer: void 0
});
PropTypes.extend([{
  name: "looseBool",
  getter: true,
  type: Boolean,
  default: void 0
}, {
  name: "style",
  getter: true,
  type: [String, Object],
  default: void 0
}, {
  name: "VueNode",
  getter: true,
  type: null
}]);
var PropTypes$1 = PropTypes;
var __rest$h = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var defaultEmptyImg = createVNode(DefaultEmptyImg, null, null);
var simpleEmptyImg = createVNode(SimpleEmptyImg, null, null);
var Empty2 = function Empty3(props2, _ref) {
  var _ref$slots = _ref.slots, slots = _ref$slots === void 0 ? {} : _ref$slots, attrs = _ref.attrs;
  var _a;
  var _useConfigInject = useConfigInject("empty", props2), direction = _useConfigInject.direction, prefixClsRef = _useConfigInject.prefixCls;
  var prefixCls = prefixClsRef.value;
  var _b = _extends(_extends({}, props2), attrs), _b$image = _b.image, image = _b$image === void 0 ? defaultEmptyImg : _b$image, _b$description = _b.description, description = _b$description === void 0 ? ((_a = slots.description) === null || _a === void 0 ? void 0 : _a.call(slots)) || void 0 : _b$description, imageStyle = _b.imageStyle, _b$class = _b.class, className = _b$class === void 0 ? "" : _b$class, restProps = __rest$h(_b, ["image", "description", "imageStyle", "class"]);
  return createVNode(LocaleReceiver, {
    "componentName": "Empty",
    "children": function children(locale2) {
      var _classNames;
      var des = typeof description !== "undefined" ? description : locale2.description;
      var alt = typeof des === "string" ? des : "empty";
      var imageNode = null;
      if (typeof image === "string") {
        imageNode = createVNode("img", {
          "alt": alt,
          "src": image
        }, null);
      } else {
        imageNode = image;
      }
      return createVNode("div", _objectSpread2$1({
        "class": classNames(prefixCls, className, (_classNames = {}, _defineProperty$m(_classNames, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), _defineProperty$m(_classNames, "".concat(prefixCls, "-rtl"), direction.value === "rtl"), _classNames))
      }, restProps), [createVNode("div", {
        "class": "".concat(prefixCls, "-image"),
        "style": imageStyle
      }, [imageNode]), des && createVNode("p", {
        "class": "".concat(prefixCls, "-description")
      }, [des]), slots.default && createVNode("div", {
        "class": "".concat(prefixCls, "-footer")
      }, [filterEmpty(slots.default())])]);
    }
  }, null);
};
Empty2.displayName = "AEmpty";
Empty2.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty2.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
Empty2.inheritAttrs = false;
Empty2.props = {
  prefixCls: String,
  image: PropTypes$1.any,
  description: PropTypes$1.any,
  imageStyle: {
    type: Object,
    default: void 0
  }
};
var Empty$1 = withInstall(Empty2);
var RenderEmpty = function RenderEmpty2(props2) {
  var _useConfigInject = useConfigInject("empty", props2), prefixCls = _useConfigInject.prefixCls;
  var renderHtml = function renderHtml2(componentName) {
    switch (componentName) {
      case "Table":
      case "List":
        return createVNode(Empty$1, {
          "image": Empty$1.PRESENTED_IMAGE_SIMPLE
        }, null);
      case "Select":
      case "TreeSelect":
      case "Cascader":
      case "Transfer":
      case "Mentions":
        return createVNode(Empty$1, {
          "image": Empty$1.PRESENTED_IMAGE_SIMPLE,
          "class": "".concat(prefixCls.value, "-small")
        }, null);
      default:
        return createVNode(Empty$1, null, null);
    }
  };
  return renderHtml(props2.componentName);
};
function renderEmpty(componentName) {
  return createVNode(RenderEmpty, {
    "componentName": componentName
  }, null);
}
var warned = {};
function warning$2(valid, message2) {
}
function call(method, valid, message2) {
  if (!valid && !warned[message2]) {
    method(false, message2);
    warned[message2] = true;
  }
}
function warningOnce(valid, message2) {
  call(warning$2, valid, message2);
}
var warning$1 = function(valid, component) {
  var message2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  warningOnce(valid, "[antdv: ".concat(component, "] ").concat(message2));
};
var ANT_MARK = "internalMark";
var LocaleProvider = defineComponent({
  name: "ALocaleProvider",
  props: {
    locale: {
      type: Object
    },
    ANT_MARK__: String
  },
  setup: function setup3(props2, _ref) {
    var slots = _ref.slots;
    warning$1(props2.ANT_MARK__ === ANT_MARK, "LocaleProvider", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead");
    var state = reactive({
      antLocale: _extends(_extends({}, props2.locale), {
        exist: true
      }),
      ANT_MARK__: ANT_MARK
    });
    provide("localeData", state);
    watch(function() {
      return props2.locale;
    }, function() {
      state.antLocale = _extends(_extends({}, props2.locale), {
        exist: true
      });
    }, {
      immediate: true
    });
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
});
LocaleProvider.install = function(app) {
  app.component(LocaleProvider.name, LocaleProvider);
  return app;
};
var LocaleProvider$1 = withInstall(LocaleProvider);
tuple("bottomLeft", "bottomRight", "topLeft", "topRight");
var getTransitionDirection = function getTransitionDirection2(placement) {
  if (placement !== void 0 && (placement === "topLeft" || placement === "topRight")) {
    return "slide-down";
  }
  return "slide-up";
};
var getTransitionProps = function getTransitionProps2(transitionName2) {
  var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var transitionProps = transitionName2 ? _extends({
    name: transitionName2,
    appear: true,
    enterFromClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-enter-prepare"),
    enterActiveClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-enter-prepare"),
    enterToClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-enter-active"),
    leaveFromClass: " ".concat(transitionName2, "-leave"),
    leaveActiveClass: "".concat(transitionName2, "-leave ").concat(transitionName2, "-leave-active"),
    leaveToClass: "".concat(transitionName2, "-leave ").concat(transitionName2, "-leave-active")
  }, opt) : _extends({
    css: false
  }, opt);
  return transitionProps;
};
var getTransitionGroupProps = function getTransitionGroupProps2(transitionName2) {
  var opt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var transitionProps = transitionName2 ? _extends({
    name: transitionName2,
    appear: true,
    appearActiveClass: "".concat(transitionName2),
    appearToClass: "".concat(transitionName2, "-appear ").concat(transitionName2, "-appear-active"),
    enterFromClass: "".concat(transitionName2, "-appear ").concat(transitionName2, "-enter ").concat(transitionName2, "-appear-prepare ").concat(transitionName2, "-enter-prepare"),
    enterActiveClass: "".concat(transitionName2),
    enterToClass: "".concat(transitionName2, "-enter ").concat(transitionName2, "-appear ").concat(transitionName2, "-appear-active ").concat(transitionName2, "-enter-active"),
    leaveActiveClass: "".concat(transitionName2, " ").concat(transitionName2, "-leave"),
    leaveToClass: "".concat(transitionName2, "-leave-active")
  }, opt) : _extends({
    css: false
  }, opt);
  return transitionProps;
};
var getTransitionName$1 = function getTransitionName(rootPrefixCls, motion, transitionName2) {
  if (transitionName2 !== void 0) {
    return transitionName2;
  }
  return "".concat(rootPrefixCls, "-").concat(motion);
};
var Notice = defineComponent({
  name: "Notice",
  inheritAttrs: false,
  props: ["prefixCls", "duration", "updateMark", "noticeKey", "closeIcon", "closable", "props", "onClick", "onClose", "holder", "visible"],
  setup: function setup4(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var closeTimer;
    var duration = computed(function() {
      return props2.duration === void 0 ? 1.5 : props2.duration;
    });
    var startCloseTimer = function startCloseTimer2() {
      if (duration.value) {
        closeTimer = setTimeout(function() {
          close3();
        }, duration.value * 1e3);
      }
    };
    var clearCloseTimer = function clearCloseTimer2() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };
    var close3 = function close4(e2) {
      if (e2) {
        e2.stopPropagation();
      }
      clearCloseTimer();
      var onClose = props2.onClose, noticeKey = props2.noticeKey;
      if (onClose) {
        onClose(noticeKey);
      }
    };
    var restartCloseTimer = function restartCloseTimer2() {
      clearCloseTimer();
      startCloseTimer();
    };
    onMounted(function() {
      startCloseTimer();
    });
    onUnmounted(function() {
      clearCloseTimer();
    });
    watch([duration, function() {
      return props2.updateMark;
    }, function() {
      return props2.visible;
    }], function(_ref2, _ref3) {
      var _ref4 = _slicedToArray$2(_ref2, 3), preDuration = _ref4[0], preUpdateMark = _ref4[1], preVisible = _ref4[2];
      var _ref5 = _slicedToArray$2(_ref3, 3), newDuration = _ref5[0], newUpdateMark = _ref5[1], newVisible = _ref5[2];
      if (preDuration !== newDuration || preUpdateMark !== newUpdateMark || preVisible !== newVisible && newVisible) {
        restartCloseTimer();
      }
    }, {
      flush: "post"
    });
    return function() {
      var _a, _b;
      var prefixCls = props2.prefixCls, closable = props2.closable, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_a = slots.closeIcon) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$closeIcon, onClick2 = props2.onClick, holder = props2.holder;
      var className = attrs.class, style2 = attrs.style;
      var componentClass = "".concat(prefixCls, "-notice");
      var dataOrAriaAttributeProps = Object.keys(attrs).reduce(function(acc, key2) {
        if (key2.substr(0, 5) === "data-" || key2.substr(0, 5) === "aria-" || key2 === "role") {
          acc[key2] = attrs[key2];
        }
        return acc;
      }, {});
      var node = createVNode("div", _objectSpread2$1({
        "class": classNames(componentClass, className, _defineProperty$m({}, "".concat(componentClass, "-closable"), closable)),
        "style": style2,
        "onMouseenter": clearCloseTimer,
        "onMouseleave": startCloseTimer,
        "onClick": onClick2
      }, dataOrAriaAttributeProps), [createVNode("div", {
        "class": "".concat(componentClass, "-content")
      }, [(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)]), closable ? createVNode("a", {
        "tabindex": 0,
        "onClick": close3,
        "class": "".concat(componentClass, "-close")
      }, [closeIcon || createVNode("span", {
        "class": "".concat(componentClass, "-close-x")
      }, null)]) : null]);
      if (holder) {
        return createVNode(Teleport, {
          "to": holder
        }, {
          default: function _default3() {
            return node;
          }
        });
      }
      return node;
    };
  }
});
var __rest$g = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var seed = 0;
var now$2 = Date.now();
function getUuid() {
  var id = seed;
  seed += 1;
  return "rcNotification_".concat(now$2, "_").concat(id);
}
var Notification = defineComponent({
  name: "Notification",
  inheritAttrs: false,
  props: ["prefixCls", "transitionName", "animation", "maxCount", "closeIcon"],
  setup: function setup5(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var hookRefs = /* @__PURE__ */ new Map();
    var notices = ref([]);
    var transitionProps = computed(function() {
      var prefixCls = props2.prefixCls, _props$animation = props2.animation, animation = _props$animation === void 0 ? "fade" : _props$animation;
      var name = props2.transitionName;
      if (!name && animation) {
        name = "".concat(prefixCls, "-").concat(animation);
      }
      return getTransitionGroupProps(name);
    });
    var add = function add2(originNotice, holderCallback) {
      var key2 = originNotice.key || getUuid();
      var notice2 = _extends(_extends({}, originNotice), {
        key: key2
      });
      var maxCount2 = props2.maxCount;
      var noticeIndex = notices.value.map(function(v2) {
        return v2.notice.key;
      }).indexOf(key2);
      var updatedNotices = notices.value.concat();
      if (noticeIndex !== -1) {
        updatedNotices.splice(noticeIndex, 1, {
          notice: notice2,
          holderCallback
        });
      } else {
        if (maxCount2 && notices.value.length >= maxCount2) {
          notice2.key = updatedNotices[0].notice.key;
          notice2.updateMark = getUuid();
          notice2.userPassKey = key2;
          updatedNotices.shift();
        }
        updatedNotices.push({
          notice: notice2,
          holderCallback
        });
      }
      notices.value = updatedNotices;
    };
    var remove = function remove2(removeKey) {
      notices.value = notices.value.filter(function(_ref2) {
        var _ref2$notice = _ref2.notice, key2 = _ref2$notice.key, userPassKey = _ref2$notice.userPassKey;
        var mergedKey = userPassKey || key2;
        return mergedKey !== removeKey;
      });
    };
    expose({
      add,
      remove,
      notices
    });
    return function() {
      var _className;
      var _a;
      var prefixCls = props2.prefixCls, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_a = slots.closeIcon) === null || _a === void 0 ? void 0 : _a.call(slots, {
        prefixCls
      }) : _props$closeIcon;
      var noticeNodes = notices.value.map(function(_ref3, index2) {
        var notice2 = _ref3.notice, holderCallback = _ref3.holderCallback;
        var updateMark = index2 === notices.value.length - 1 ? notice2.updateMark : void 0;
        var key2 = notice2.key, userPassKey = notice2.userPassKey;
        var content = notice2.content;
        var noticeProps = _extends(_extends(_extends({
          prefixCls,
          closeIcon: typeof closeIcon === "function" ? closeIcon({
            prefixCls
          }) : closeIcon
        }, notice2), notice2.props), {
          key: key2,
          noticeKey: userPassKey || key2,
          updateMark,
          onClose: function onClose(noticeKey) {
            var _a2;
            remove(noticeKey);
            (_a2 = notice2.onClose) === null || _a2 === void 0 ? void 0 : _a2.call(notice2);
          },
          onClick: notice2.onClick
        });
        if (holderCallback) {
          return createVNode("div", {
            "key": key2,
            "class": "".concat(prefixCls, "-hook-holder"),
            "ref": function ref2(div) {
              if (typeof key2 === "undefined") {
                return;
              }
              if (div) {
                hookRefs.set(key2, div);
                holderCallback(div, noticeProps);
              } else {
                hookRefs.delete(key2);
              }
            }
          }, null);
        }
        return createVNode(Notice, noticeProps, {
          default: function _default3() {
            return [typeof content === "function" ? content({
              prefixCls
            }) : content];
          }
        });
      });
      var className = (_className = {}, _defineProperty$m(_className, prefixCls, 1), _defineProperty$m(_className, attrs.class, !!attrs.class), _className);
      return createVNode("div", {
        "class": className,
        "style": attrs.style || {
          top: "65px",
          left: "50%"
        }
      }, [createVNode(TransitionGroup, _objectSpread2$1({
        "tag": "div"
      }, transitionProps.value), {
        default: function _default3() {
          return [noticeNodes];
        }
      })]);
    };
  }
});
Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _a = properties || {}, _a$name = _a.name, name = _a$name === void 0 ? "notification" : _a$name, getContainer4 = _a.getContainer, appContext = _a.appContext, customizePrefixCls = _a.prefixCls, customRootPrefixCls = _a.rootPrefixCls, customTransitionName = _a.transitionName, hasTransitionName2 = _a.hasTransitionName, props2 = __rest$g(_a, ["name", "getContainer", "appContext", "prefixCls", "rootPrefixCls", "transitionName", "hasTransitionName"]);
  var div = document.createElement("div");
  if (getContainer4) {
    var root2 = getContainer4();
    root2.appendChild(div);
  } else {
    document.body.appendChild(div);
  }
  var Wrapper = defineComponent({
    name: "NotificationWrapper",
    setup: function setup64(_props, _ref4) {
      var attrs = _ref4.attrs;
      var notiRef = ref();
      onMounted(function() {
        callback({
          notice: function notice2(noticeProps) {
            var _a2;
            (_a2 = notiRef.value) === null || _a2 === void 0 ? void 0 : _a2.add(noticeProps);
          },
          removeNotice: function removeNotice(key2) {
            var _a2;
            (_a2 = notiRef.value) === null || _a2 === void 0 ? void 0 : _a2.remove(key2);
          },
          destroy: function destroy3() {
            render(null, div);
            if (div.parentNode) {
              div.parentNode.removeChild(div);
            }
          },
          component: notiRef
        });
      });
      return function() {
        var global2 = globalConfigForApi;
        var prefixCls = global2.getPrefixCls(name, customizePrefixCls);
        var rootPrefixCls = global2.getRootPrefixCls(customRootPrefixCls, prefixCls);
        var transitionName2 = hasTransitionName2 ? customTransitionName : "".concat(rootPrefixCls, "-").concat(customTransitionName);
        return createVNode(ConfigProvider, _objectSpread2$1(_objectSpread2$1({}, global2), {}, {
          "notUpdateGlobalConfig": true,
          "prefixCls": rootPrefixCls
        }), {
          default: function _default3() {
            return [createVNode(Notification, _objectSpread2$1(_objectSpread2$1({
              "ref": notiRef
            }, attrs), {}, {
              "prefixCls": prefixCls,
              "transitionName": transitionName2
            }), null)];
          }
        });
      };
    }
  });
  var vm = createVNode(Wrapper, props2);
  vm.appContext = appContext || vm.appContext;
  render(vm, div);
};
var Notification$1 = Notification;
var LoadingOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
var LoadingOutlinedSvg = LoadingOutlined$2;
function bound01(n2, max) {
  if (isOnePointZero(n2)) {
    n2 = "100%";
  }
  var isPercent = isPercentage(n2);
  n2 = max === 360 ? n2 : Math.min(max, Math.max(0, parseFloat(n2)));
  if (isPercent) {
    n2 = parseInt(String(n2 * max), 10) / 100;
  }
  if (Math.abs(n2 - max) < 1e-6) {
    return 1;
  }
  if (max === 360) {
    n2 = (n2 < 0 ? n2 % max + max : n2 % max) / parseFloat(String(max));
  } else {
    n2 = n2 % max / parseFloat(String(max));
  }
  return n2;
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function isOnePointZero(n2) {
  return typeof n2 === "string" && n2.indexOf(".") !== -1 && parseFloat(n2) === 1;
}
function isPercentage(n2) {
  return typeof n2 === "string" && n2.indexOf("%") !== -1;
}
function boundAlpha(a2) {
  a2 = parseFloat(a2);
  if (isNaN(a2) || a2 < 0 || a2 > 1) {
    a2 = 1;
  }
  return a2;
}
function convertToPercentage(n2) {
  if (n2 <= 1) {
    return Number(n2) * 100 + "%";
  }
  return n2;
}
function pad2(c2) {
  return c2.length === 1 ? "0" + c2 : String(c2);
}
function rgbToRgb(r2, g2, b2) {
  return {
    r: bound01(r2, 255) * 255,
    g: bound01(g2, 255) * 255,
    b: bound01(b2, 255) * 255
  };
}
function rgbToHsl(r2, g2, b2) {
  r2 = bound01(r2, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max = Math.max(r2, g2, b2);
  var min = Math.min(r2, g2, b2);
  var h2 = 0;
  var s2 = 0;
  var l2 = (max + min) / 2;
  if (max === min) {
    s2 = 0;
    h2 = 0;
  } else {
    var d2 = max - min;
    s2 = l2 > 0.5 ? d2 / (2 - max - min) : d2 / (max + min);
    switch (max) {
      case r2:
        h2 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h2 = (b2 - r2) / d2 + 2;
        break;
      case b2:
        h2 = (r2 - g2) / d2 + 4;
        break;
    }
    h2 /= 6;
  }
  return { h: h2, s: s2, l: l2 };
}
function hue2rgb(p, q2, t2) {
  if (t2 < 0) {
    t2 += 1;
  }
  if (t2 > 1) {
    t2 -= 1;
  }
  if (t2 < 1 / 6) {
    return p + (q2 - p) * (6 * t2);
  }
  if (t2 < 1 / 2) {
    return q2;
  }
  if (t2 < 2 / 3) {
    return p + (q2 - p) * (2 / 3 - t2) * 6;
  }
  return p;
}
function hslToRgb(h2, s2, l2) {
  var r2;
  var g2;
  var b2;
  h2 = bound01(h2, 360);
  s2 = bound01(s2, 100);
  l2 = bound01(l2, 100);
  if (s2 === 0) {
    g2 = l2;
    b2 = l2;
    r2 = l2;
  } else {
    var q2 = l2 < 0.5 ? l2 * (1 + s2) : l2 + s2 - l2 * s2;
    var p = 2 * l2 - q2;
    r2 = hue2rgb(p, q2, h2 + 1 / 3);
    g2 = hue2rgb(p, q2, h2);
    b2 = hue2rgb(p, q2, h2 - 1 / 3);
  }
  return { r: r2 * 255, g: g2 * 255, b: b2 * 255 };
}
function rgbToHsv(r2, g2, b2) {
  r2 = bound01(r2, 255);
  g2 = bound01(g2, 255);
  b2 = bound01(b2, 255);
  var max = Math.max(r2, g2, b2);
  var min = Math.min(r2, g2, b2);
  var h2 = 0;
  var v2 = max;
  var d2 = max - min;
  var s2 = max === 0 ? 0 : d2 / max;
  if (max === min) {
    h2 = 0;
  } else {
    switch (max) {
      case r2:
        h2 = (g2 - b2) / d2 + (g2 < b2 ? 6 : 0);
        break;
      case g2:
        h2 = (b2 - r2) / d2 + 2;
        break;
      case b2:
        h2 = (r2 - g2) / d2 + 4;
        break;
    }
    h2 /= 6;
  }
  return { h: h2, s: s2, v: v2 };
}
function hsvToRgb(h2, s2, v2) {
  h2 = bound01(h2, 360) * 6;
  s2 = bound01(s2, 100);
  v2 = bound01(v2, 100);
  var i = Math.floor(h2);
  var f2 = h2 - i;
  var p = v2 * (1 - s2);
  var q2 = v2 * (1 - f2 * s2);
  var t2 = v2 * (1 - (1 - f2) * s2);
  var mod = i % 6;
  var r2 = [v2, q2, p, p, t2, v2][mod];
  var g2 = [t2, v2, v2, q2, p, p][mod];
  var b2 = [p, p, t2, v2, v2, q2][mod];
  return { r: r2 * 255, g: g2 * 255, b: b2 * 255 };
}
function rgbToHex(r2, g2, b2, allow3Char) {
  var hex = [
    pad2(Math.round(r2).toString(16)),
    pad2(Math.round(g2).toString(16)),
    pad2(Math.round(b2).toString(16))
  ];
  if (allow3Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1))) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}
function rgbaToHex(r2, g2, b2, a2, allow4Char) {
  var hex = [
    pad2(Math.round(r2).toString(16)),
    pad2(Math.round(g2).toString(16)),
    pad2(Math.round(b2).toString(16)),
    pad2(convertDecimalToHex(a2))
  ];
  if (allow4Char && hex[0].startsWith(hex[0].charAt(1)) && hex[1].startsWith(hex[1].charAt(1)) && hex[2].startsWith(hex[2].charAt(1)) && hex[3].startsWith(hex[3].charAt(1))) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}
function convertDecimalToHex(d2) {
  return Math.round(parseFloat(d2) * 255).toString(16);
}
function convertHexToDecimal(h2) {
  return parseIntFromHex(h2) / 255;
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function numberInputToObject(color) {
  return {
    r: color >> 16,
    g: (color & 65280) >> 8,
    b: color & 255
  };
}
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function inputToRGB(color) {
  var rgb = { r: 0, g: 0, b: 0 };
  var a2 = 1;
  var s2 = null;
  var v2 = null;
  var l2 = null;
  var ok = false;
  var format = false;
  if (typeof color === "string") {
    color = stringInputToObject(color);
  }
  if (typeof color === "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s2 = convertToPercentage(color.s);
      v2 = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s2, v2);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s2 = convertToPercentage(color.s);
      l2 = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s2, l2);
      ok = true;
      format = "hsl";
    }
    if (Object.prototype.hasOwnProperty.call(color, "a")) {
      a2 = color.a;
    }
  }
  a2 = boundAlpha(a2);
  return {
    ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a2
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?";
var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(color) {
  color = color.trim().toLowerCase();
  if (color.length === 0) {
    return false;
  }
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color === "transparent") {
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  }
  var match2 = matchers.rgb.exec(color);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3] };
  }
  match2 = matchers.rgba.exec(color);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3], a: match2[4] };
  }
  match2 = matchers.hsl.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3] };
  }
  match2 = matchers.hsla.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3], a: match2[4] };
  }
  match2 = matchers.hsv.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3] };
  }
  match2 = matchers.hsva.exec(color);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3], a: match2[4] };
  }
  match2 = matchers.hex8.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      a: convertHexToDecimal(match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex6.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      format: named ? "name" : "hex"
    };
  }
  match2 = matchers.hex4.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      a: convertHexToDecimal(match2[4] + match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex3.exec(color);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function isValidCSSUnit(color) {
  return Boolean(matchers.CSS_UNIT.exec(String(color)));
}
var TinyColor = function() {
  function TinyColor2(color, opts) {
    if (color === void 0) {
      color = "";
    }
    if (opts === void 0) {
      opts = {};
    }
    var _a;
    if (color instanceof TinyColor2) {
      return color;
    }
    if (typeof color === "number") {
      color = numberInputToObject(color);
    }
    this.originalInput = color;
    var rgb = inputToRGB(color);
    this.originalInput = color;
    this.r = rgb.r;
    this.g = rgb.g;
    this.b = rgb.b;
    this.a = rgb.a;
    this.roundA = Math.round(100 * this.a) / 100;
    this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
    this.gradientType = opts.gradientType;
    if (this.r < 1) {
      this.r = Math.round(this.r);
    }
    if (this.g < 1) {
      this.g = Math.round(this.g);
    }
    if (this.b < 1) {
      this.b = Math.round(this.b);
    }
    this.isValid = rgb.ok;
  }
  TinyColor2.prototype.isDark = function() {
    return this.getBrightness() < 128;
  };
  TinyColor2.prototype.isLight = function() {
    return !this.isDark();
  };
  TinyColor2.prototype.getBrightness = function() {
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
  };
  TinyColor2.prototype.getLuminance = function() {
    var rgb = this.toRgb();
    var R2;
    var G;
    var B2;
    var RsRGB = rgb.r / 255;
    var GsRGB = rgb.g / 255;
    var BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) {
      R2 = RsRGB / 12.92;
    } else {
      R2 = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    }
    if (GsRGB <= 0.03928) {
      G = GsRGB / 12.92;
    } else {
      G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    }
    if (BsRGB <= 0.03928) {
      B2 = BsRGB / 12.92;
    } else {
      B2 = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * R2 + 0.7152 * G + 0.0722 * B2;
  };
  TinyColor2.prototype.getAlpha = function() {
    return this.a;
  };
  TinyColor2.prototype.setAlpha = function(alpha) {
    this.a = boundAlpha(alpha);
    this.roundA = Math.round(100 * this.a) / 100;
    return this;
  };
  TinyColor2.prototype.toHsv = function() {
    var hsv = rgbToHsv(this.r, this.g, this.b);
    return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
  };
  TinyColor2.prototype.toHsvString = function() {
    var hsv = rgbToHsv(this.r, this.g, this.b);
    var h2 = Math.round(hsv.h * 360);
    var s2 = Math.round(hsv.s * 100);
    var v2 = Math.round(hsv.v * 100);
    return this.a === 1 ? "hsv(" + h2 + ", " + s2 + "%, " + v2 + "%)" : "hsva(" + h2 + ", " + s2 + "%, " + v2 + "%, " + this.roundA + ")";
  };
  TinyColor2.prototype.toHsl = function() {
    var hsl = rgbToHsl(this.r, this.g, this.b);
    return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
  };
  TinyColor2.prototype.toHslString = function() {
    var hsl = rgbToHsl(this.r, this.g, this.b);
    var h2 = Math.round(hsl.h * 360);
    var s2 = Math.round(hsl.s * 100);
    var l2 = Math.round(hsl.l * 100);
    return this.a === 1 ? "hsl(" + h2 + ", " + s2 + "%, " + l2 + "%)" : "hsla(" + h2 + ", " + s2 + "%, " + l2 + "%, " + this.roundA + ")";
  };
  TinyColor2.prototype.toHex = function(allow3Char) {
    if (allow3Char === void 0) {
      allow3Char = false;
    }
    return rgbToHex(this.r, this.g, this.b, allow3Char);
  };
  TinyColor2.prototype.toHexString = function(allow3Char) {
    if (allow3Char === void 0) {
      allow3Char = false;
    }
    return "#" + this.toHex(allow3Char);
  };
  TinyColor2.prototype.toHex8 = function(allow4Char) {
    if (allow4Char === void 0) {
      allow4Char = false;
    }
    return rgbaToHex(this.r, this.g, this.b, this.a, allow4Char);
  };
  TinyColor2.prototype.toHex8String = function(allow4Char) {
    if (allow4Char === void 0) {
      allow4Char = false;
    }
    return "#" + this.toHex8(allow4Char);
  };
  TinyColor2.prototype.toRgb = function() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  };
  TinyColor2.prototype.toRgbString = function() {
    var r2 = Math.round(this.r);
    var g2 = Math.round(this.g);
    var b2 = Math.round(this.b);
    return this.a === 1 ? "rgb(" + r2 + ", " + g2 + ", " + b2 + ")" : "rgba(" + r2 + ", " + g2 + ", " + b2 + ", " + this.roundA + ")";
  };
  TinyColor2.prototype.toPercentageRgb = function() {
    var fmt = function(x2) {
      return Math.round(bound01(x2, 255) * 100) + "%";
    };
    return {
      r: fmt(this.r),
      g: fmt(this.g),
      b: fmt(this.b),
      a: this.a
    };
  };
  TinyColor2.prototype.toPercentageRgbString = function() {
    var rnd = function(x2) {
      return Math.round(bound01(x2, 255) * 100);
    };
    return this.a === 1 ? "rgb(" + rnd(this.r) + "%, " + rnd(this.g) + "%, " + rnd(this.b) + "%)" : "rgba(" + rnd(this.r) + "%, " + rnd(this.g) + "%, " + rnd(this.b) + "%, " + this.roundA + ")";
  };
  TinyColor2.prototype.toName = function() {
    if (this.a === 0) {
      return "transparent";
    }
    if (this.a < 1) {
      return false;
    }
    var hex = "#" + rgbToHex(this.r, this.g, this.b, false);
    for (var _i = 0, _a = Object.entries(names); _i < _a.length; _i++) {
      var _b = _a[_i], key2 = _b[0], value = _b[1];
      if (hex === value) {
        return key2;
      }
    }
    return false;
  };
  TinyColor2.prototype.toString = function(format) {
    var formatSet = Boolean(format);
    format = format !== null && format !== void 0 ? format : this.format;
    var formattedString = false;
    var hasAlpha = this.a < 1 && this.a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format.startsWith("hex") || format === "name");
    if (needsAlphaFormat) {
      if (format === "name" && this.a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  };
  TinyColor2.prototype.toNumber = function() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  };
  TinyColor2.prototype.clone = function() {
    return new TinyColor2(this.toString());
  };
  TinyColor2.prototype.lighten = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.brighten = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var rgb = this.toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return new TinyColor2(rgb);
  };
  TinyColor2.prototype.darken = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.tint = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return this.mix("white", amount);
  };
  TinyColor2.prototype.shade = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    return this.mix("black", amount);
  };
  TinyColor2.prototype.desaturate = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.saturate = function(amount) {
    if (amount === void 0) {
      amount = 10;
    }
    var hsl = this.toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.greyscale = function() {
    return this.desaturate(100);
  };
  TinyColor2.prototype.spin = function(amount) {
    var hsl = this.toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.mix = function(color, amount) {
    if (amount === void 0) {
      amount = 50;
    }
    var rgb1 = this.toRgb();
    var rgb2 = new TinyColor2(color).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return new TinyColor2(rgba);
  };
  TinyColor2.prototype.analogous = function(results, slices) {
    if (results === void 0) {
      results = 6;
    }
    if (slices === void 0) {
      slices = 30;
    }
    var hsl = this.toHsl();
    var part = 360 / slices;
    var ret = [this];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(new TinyColor2(hsl));
    }
    return ret;
  };
  TinyColor2.prototype.complement = function() {
    var hsl = this.toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return new TinyColor2(hsl);
  };
  TinyColor2.prototype.monochromatic = function(results) {
    if (results === void 0) {
      results = 6;
    }
    var hsv = this.toHsv();
    var h2 = hsv.h;
    var s2 = hsv.s;
    var v2 = hsv.v;
    var res = [];
    var modification = 1 / results;
    while (results--) {
      res.push(new TinyColor2({ h: h2, s: s2, v: v2 }));
      v2 = (v2 + modification) % 1;
    }
    return res;
  };
  TinyColor2.prototype.splitcomplement = function() {
    var hsl = this.toHsl();
    var h2 = hsl.h;
    return [
      this,
      new TinyColor2({ h: (h2 + 72) % 360, s: hsl.s, l: hsl.l }),
      new TinyColor2({ h: (h2 + 216) % 360, s: hsl.s, l: hsl.l })
    ];
  };
  TinyColor2.prototype.onBackground = function(background) {
    var fg = this.toRgb();
    var bg = new TinyColor2(background).toRgb();
    return new TinyColor2({
      r: bg.r + (fg.r - bg.r) * fg.a,
      g: bg.g + (fg.g - bg.g) * fg.a,
      b: bg.b + (fg.b - bg.b) * fg.a
    });
  };
  TinyColor2.prototype.triad = function() {
    return this.polyad(3);
  };
  TinyColor2.prototype.tetrad = function() {
    return this.polyad(4);
  };
  TinyColor2.prototype.polyad = function(n2) {
    var hsl = this.toHsl();
    var h2 = hsl.h;
    var result = [this];
    var increment = 360 / n2;
    for (var i = 1; i < n2; i++) {
      result.push(new TinyColor2({ h: (h2 + i * increment) % 360, s: hsl.s, l: hsl.l }));
    }
    return result;
  };
  TinyColor2.prototype.equals = function(color) {
    return this.toRgbString() === new TinyColor2(color).toRgbString();
  };
  return TinyColor2;
}();
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv(_ref) {
  var r2 = _ref.r, g2 = _ref.g, b2 = _ref.b;
  var hsv = rgbToHsv(r2, g2, b2);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
}
function toHex(_ref2) {
  var r2 = _ref2.r, g2 = _ref2.g, b2 = _ref2.b;
  return "#".concat(rgbToHex(r2, g2, b2, false));
}
function mix$1(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}
function getHue(hsv, i, light) {
  var hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Number(saturation.toFixed(2));
}
function getValue$1(hsv, i, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }
  if (value > 1) {
    value = 1;
  }
  return Number(value.toFixed(2));
}
function generate$1(color) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color);
  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue$1(hsv, i, true)
    }));
    patterns.push(colorString);
  }
  patterns.push(toHex(pColor));
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);
    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue$1(_hsv, _i)
    }));
    patterns.push(_colorString);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(function(_ref3) {
      var index2 = _ref3.index, opacity = _ref3.opacity;
      var darkColorString = toHex(mix$1(inputToRGB(opts.backgroundColor || "#141414"), inputToRGB(patterns[index2]), opacity * 100));
      return darkColorString;
    });
  }
  return patterns;
}
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1890FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function(key2) {
  presetPalettes[key2] = generate$1(presetPrimaryColors[key2]);
  presetPalettes[key2].primary = presetPalettes[key2][5];
  presetDarkPalettes[key2] = generate$1(presetPrimaryColors[key2], {
    theme: "dark",
    backgroundColor: "#141414"
  });
  presetDarkPalettes[key2].primary = presetDarkPalettes[key2][5];
});
presetPalettes.red;
presetPalettes.volcano;
presetPalettes.gold;
presetPalettes.orange;
presetPalettes.yellow;
presetPalettes.lime;
presetPalettes.green;
presetPalettes.cyan;
presetPalettes.blue;
presetPalettes.geekblue;
presetPalettes.purple;
presetPalettes.magenta;
presetPalettes.grey;
var containers = [];
var styleElements = [];
var usage = "insert-css: You need to provide a CSS string. Usage: insertCss(cssString[, options]).";
function createStyleElement() {
  var styleElement = document.createElement("style");
  styleElement.setAttribute("type", "text/css");
  return styleElement;
}
function insertCss(css2, options) {
  options = options || {};
  if (css2 === void 0) {
    throw new Error(usage);
  }
  var position = options.prepend === true ? "prepend" : "append";
  var container = options.container !== void 0 ? options.container : document.querySelector("head");
  var containerId = containers.indexOf(container);
  if (containerId === -1) {
    containerId = containers.push(container) - 1;
    styleElements[containerId] = {};
  }
  var styleElement;
  if (styleElements[containerId] !== void 0 && styleElements[containerId][position] !== void 0) {
    styleElement = styleElements[containerId][position];
  } else {
    styleElement = styleElements[containerId][position] = createStyleElement();
    if (position === "prepend") {
      container.insertBefore(styleElement, container.childNodes[0]);
    } else {
      container.appendChild(styleElement);
    }
  }
  if (css2.charCodeAt(0) === 65279) {
    css2 = css2.substr(1, css2.length);
  }
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText += css2;
  } else {
    styleElement.textContent += css2;
  }
  return styleElement;
}
function _objectSpread$k(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$l(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$l(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function warning(valid, message2) {
}
function isIconDefinition(target) {
  return typeof target === "object" && typeof target.name === "string" && typeof target.theme === "string" && (typeof target.icon === "object" || typeof target.icon === "function");
}
function generate(node, key2, rootProps) {
  if (!rootProps) {
    return h$1(node.tag, _objectSpread$k({
      key: key2
    }, node.attrs), (node.children || []).map(function(child, index2) {
      return generate(child, "".concat(key2, "-").concat(node.tag, "-").concat(index2));
    }));
  }
  return h$1(node.tag, _objectSpread$k({
    key: key2
  }, rootProps, node.attrs), (node.children || []).map(function(child, index2) {
    return generate(child, "".concat(key2, "-").concat(node.tag, "-").concat(index2));
  }));
}
function getSecondaryColor(primaryColor) {
  return generate$1(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var cssInjectedFlag = false;
var useInsertStyles = function useInsertStyles2() {
  var styleStr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iconStyles;
  nextTick(function() {
    if (!cssInjectedFlag) {
      if (typeof window !== "undefined" && window.document && window.document.documentElement) {
        insertCss(styleStr, {
          prepend: true
        });
      }
      cssInjectedFlag = true;
    }
  });
};
var _excluded$1 = ["icon", "primaryColor", "secondaryColor"];
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _objectSpread$j(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$k(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$k(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return _objectSpread$j({}, twoToneColorPalette);
}
var IconBase = function IconBase2(props2, context) {
  var _props$context$attrs = _objectSpread$j({}, props2, context.attrs), icon = _props$context$attrs.icon, primaryColor = _props$context$attrs.primaryColor, secondaryColor = _props$context$attrs.secondaryColor, restProps = _objectWithoutProperties$1(_props$context$attrs, _excluded$1);
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles();
  warning(isIconDefinition(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === "function") {
    target = _objectSpread$j({}, target, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return generate(target.icon, "svg-".concat(target.name), _objectSpread$j({}, restProps, {
    "data-icon": target.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }));
};
IconBase.props = {
  icon: Object,
  primaryColor: String,
  secondaryColor: String,
  focusable: String
};
IconBase.inheritAttrs = false;
IconBase.displayName = "IconBase";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var VueIcon = IconBase;
function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray$1(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o2, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray$1(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return VueIcon.setTwoToneColors({
    primaryColor,
    secondaryColor
  });
}
function getTwoToneColor() {
  var colors = VueIcon.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}
var _excluded = ["class", "icon", "spin", "rotate", "tabindex", "twoToneColor", "onClick"];
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o2, minLen) {
  if (!o2)
    return;
  if (typeof o2 === "string")
    return _arrayLikeToArray(o2, minLen);
  var n2 = Object.prototype.toString.call(o2).slice(8, -1);
  if (n2 === "Object" && o2.constructor)
    n2 = o2.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o2);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o2, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectSpread$i(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$j(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$j(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key2, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key2 = sourceSymbolKeys[i];
      if (excluded.indexOf(key2) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key2))
        continue;
      target[key2] = source[key2];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
setTwoToneColor("#1890ff");
var Icon = function Icon2(props2, context) {
  var _classObj;
  var _props$context$attrs = _objectSpread$i({}, props2, context.attrs), cls = _props$context$attrs["class"], icon = _props$context$attrs.icon, spin = _props$context$attrs.spin, rotate = _props$context$attrs.rotate, tabindex = _props$context$attrs.tabindex, twoToneColor = _props$context$attrs.twoToneColor, onClick2 = _props$context$attrs.onClick, restProps = _objectWithoutProperties(_props$context$attrs, _excluded);
  var classObj = (_classObj = {
    anticon: true
  }, _defineProperty$j(_classObj, "anticon-".concat(icon.name), Boolean(icon.name)), _defineProperty$j(_classObj, cls, cls), _classObj);
  var svgClassString = spin === "" || !!spin || icon.name === "loading" ? "anticon-spin" : "";
  var iconTabIndex = tabindex;
  if (iconTabIndex === void 0 && onClick2) {
    iconTabIndex = -1;
    restProps.tabindex = iconTabIndex;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : void 0;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return createVNode("span", _objectSpread$i({
    "role": "img",
    "aria-label": icon.name
  }, restProps, {
    "onClick": onClick2,
    "class": classObj
  }), [createVNode(VueIcon, {
    "class": svgClassString,
    "icon": icon,
    "primaryColor": primaryColor,
    "secondaryColor": secondaryColor,
    "style": svgStyle
  }, null)]);
};
Icon.props = {
  spin: Boolean,
  rotate: Number,
  icon: Object,
  twoToneColor: String
};
Icon.displayName = "AntdIcon";
Icon.inheritAttrs = false;
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
var AntdIcon = Icon;
function _objectSpread$h(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$i(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$i(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var LoadingOutlined = function LoadingOutlined2(props2, context) {
  var p = _objectSpread$h({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$h({}, p, {
    "icon": LoadingOutlinedSvg
  }), null);
};
LoadingOutlined.displayName = "LoadingOutlined";
LoadingOutlined.inheritAttrs = false;
var LoadingOutlined$1 = LoadingOutlined;
var ExclamationCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
var ExclamationCircleFilledSvg = ExclamationCircleFilled$2;
function _objectSpread$g(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$h(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$h(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ExclamationCircleFilled = function ExclamationCircleFilled2(props2, context) {
  var p = _objectSpread$g({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$g({}, p, {
    "icon": ExclamationCircleFilledSvg
  }), null);
};
ExclamationCircleFilled.displayName = "ExclamationCircleFilled";
ExclamationCircleFilled.inheritAttrs = false;
var ExclamationCircleFilled$1 = ExclamationCircleFilled;
var CloseCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" } }] }, "name": "close-circle", "theme": "filled" };
var CloseCircleFilledSvg = CloseCircleFilled$2;
function _objectSpread$f(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$g(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$g(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CloseCircleFilled = function CloseCircleFilled2(props2, context) {
  var p = _objectSpread$f({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$f({}, p, {
    "icon": CloseCircleFilledSvg
  }), null);
};
CloseCircleFilled.displayName = "CloseCircleFilled";
CloseCircleFilled.inheritAttrs = false;
var CloseCircleFilled$1 = CloseCircleFilled;
var CheckCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
var CheckCircleFilledSvg = CheckCircleFilled$2;
function _objectSpread$e(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$f(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$f(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CheckCircleFilled = function CheckCircleFilled2(props2, context) {
  var p = _objectSpread$e({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$e({}, p, {
    "icon": CheckCircleFilledSvg
  }), null);
};
CheckCircleFilled.displayName = "CheckCircleFilled";
CheckCircleFilled.inheritAttrs = false;
var CheckCircleFilled$1 = CheckCircleFilled;
var InfoCircleFilled$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
var InfoCircleFilledSvg = InfoCircleFilled$2;
function _objectSpread$d(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$e(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$e(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var InfoCircleFilled = function InfoCircleFilled2(props2, context) {
  var p = _objectSpread$d({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$d({}, p, {
    "icon": InfoCircleFilledSvg
  }), null);
};
InfoCircleFilled.displayName = "InfoCircleFilled";
InfoCircleFilled.inheritAttrs = false;
var InfoCircleFilled$1 = InfoCircleFilled;
var defaultDuration$1 = 3;
var defaultTop$1;
var messageInstance;
var key = 1;
var localPrefixCls = "";
var transitionName = "move-up";
var hasTransitionName = false;
var getContainer$1 = function getContainer() {
  return document.body;
};
var maxCount$1;
var rtl$1 = false;
function getKeyThenIncreaseKey() {
  return key++;
}
function setMessageConfig(options) {
  if (options.top !== void 0) {
    defaultTop$1 = options.top;
    messageInstance = null;
  }
  if (options.duration !== void 0) {
    defaultDuration$1 = options.duration;
  }
  if (options.prefixCls !== void 0) {
    localPrefixCls = options.prefixCls;
  }
  if (options.getContainer !== void 0) {
    getContainer$1 = options.getContainer;
    messageInstance = null;
  }
  if (options.transitionName !== void 0) {
    transitionName = options.transitionName;
    messageInstance = null;
    hasTransitionName = true;
  }
  if (options.maxCount !== void 0) {
    maxCount$1 = options.maxCount;
    messageInstance = null;
  }
  if (options.rtl !== void 0) {
    rtl$1 = options.rtl;
  }
}
function getMessageInstance(args, callback) {
  if (messageInstance) {
    callback(messageInstance);
    return;
  }
  Notification$1.newInstance({
    appContext: args.appContext,
    prefixCls: args.prefixCls || localPrefixCls,
    rootPrefixCls: args.rootPrefixCls,
    transitionName,
    hasTransitionName,
    style: {
      top: defaultTop$1
    },
    getContainer: getContainer$1 || args.getPopupContainer,
    maxCount: maxCount$1,
    name: "message"
  }, function(instance) {
    if (messageInstance) {
      callback(messageInstance);
      return;
    }
    messageInstance = instance;
    callback(instance);
  });
}
var typeToIcon$1 = {
  info: InfoCircleFilled$1,
  success: CheckCircleFilled$1,
  error: CloseCircleFilled$1,
  warning: ExclamationCircleFilled$1,
  loading: LoadingOutlined$1
};
function notice$1(args) {
  var duration = args.duration !== void 0 ? args.duration : defaultDuration$1;
  var target = args.key || getKeyThenIncreaseKey();
  var closePromise = new Promise(function(resolve) {
    var callback = function callback2() {
      if (typeof args.onClose === "function") {
        args.onClose();
      }
      return resolve(true);
    };
    getMessageInstance(args, function(instance) {
      instance.notice({
        key: target,
        duration,
        style: args.style || {},
        class: args.class,
        content: function content(_ref) {
          var _classNames;
          var prefixCls = _ref.prefixCls;
          var Icon3 = typeToIcon$1[args.type];
          var iconNode = Icon3 ? createVNode(Icon3, null, null) : "";
          var messageClass = classNames("".concat(prefixCls, "-custom-content"), (_classNames = {}, _defineProperty$m(_classNames, "".concat(prefixCls, "-").concat(args.type), args.type), _defineProperty$m(_classNames, "".concat(prefixCls, "-rtl"), rtl$1 === true), _classNames));
          return createVNode("div", {
            "class": messageClass
          }, [typeof args.icon === "function" ? args.icon() : args.icon || iconNode, createVNode("span", null, [typeof args.content === "function" ? args.content() : args.content])]);
        },
        onClose: callback,
        onClick: args.onClick
      });
    });
  });
  var result = function result2() {
    if (messageInstance) {
      messageInstance.removeNotice(target);
    }
  };
  result.then = function(filled, rejected) {
    return closePromise.then(filled, rejected);
  };
  result.promise = closePromise;
  return result;
}
function isArgsProps(content) {
  return Object.prototype.toString.call(content) === "[object Object]" && !!content.content;
}
var api$1 = {
  open: notice$1,
  config: setMessageConfig,
  destroy: function destroy(messageKey) {
    if (messageInstance) {
      if (messageKey) {
        var _messageInstance = messageInstance, removeNotice = _messageInstance.removeNotice;
        removeNotice(messageKey);
      } else {
        var _messageInstance2 = messageInstance, destroy3 = _messageInstance2.destroy;
        destroy3();
        messageInstance = null;
      }
    }
  }
};
function attachTypeApi(originalApi, type) {
  originalApi[type] = function(content, duration, onClose) {
    if (isArgsProps(content)) {
      return originalApi.open(_extends(_extends({}, content), {
        type
      }));
    }
    if (typeof duration === "function") {
      onClose = duration;
      duration = void 0;
    }
    return originalApi.open({
      content,
      duration,
      type,
      onClose
    });
  };
}
["success", "info", "warning", "error", "loading"].forEach(function(type) {
  return attachTypeApi(api$1, type);
});
api$1.warn = api$1.warning;
var message = api$1;
var runtime = { exports: {} };
(function(module2) {
  var runtime2 = function(exports2) {
    var Op = Object.prototype;
    var hasOwn3 = Op.hasOwnProperty;
    var undefined$1;
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key2, value) {
      Object.defineProperty(obj, key2, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key2];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function(obj, key2, value) {
        return obj[key2] = value;
      };
    }
    function wrap(innerFn, outerFn, self2, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);
      generator._invoke = makeInvokeMethod(innerFn, self2, context);
      return generator;
    }
    exports2.wrap = wrap;
    function tryCatch(fn, obj, arg) {
      try {
        return { type: "normal", arg: fn.call(obj, arg) };
      } catch (err) {
        return { type: "throw", arg: err };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    var ContinueSentinel = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
      return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn3.call(NativeIteratorPrototype, iteratorSymbol)) {
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    define(Gp, "constructor", GeneratorFunctionPrototype);
    define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        define(prototype, method, function(arg) {
          return this._invoke(method, arg);
        });
      });
    }
    exports2.isGeneratorFunction = function(genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports2.mark = function(genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };
    exports2.awrap = function(arg) {
      return { __await: arg };
    };
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn3.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function(value2) {
              invoke("next", value2, resolve, reject);
            }, function(err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return PromiseImpl.resolve(value).then(function(unwrapped) {
            result.value = unwrapped;
            resolve(result);
          }, function(error) {
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function(resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
      return this;
    });
    exports2.AsyncIterator = AsyncIterator;
    exports2.async = function(innerFn, outerFn, self2, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0)
        PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self2, tryLocsList), PromiseImpl);
      return exports2.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self2, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self2, context);
          if (record.type === "normal") {
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        context.delegate = null;
        if (context.method === "throw") {
          if (delegate.iterator["return"]) {
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        context[delegate.resultName] = info.value;
        context.next = delegate.nextLoc;
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        return info;
      }
      context.delegate = null;
      return ContinueSentinel;
    }
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    define(Gp, iteratorSymbol, function() {
      return this;
    });
    define(Gp, "toString", function() {
      return "[object Generator]";
    });
    function pushTryEntry(locs) {
      var entry = { tryLoc: locs[0] };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{ tryLoc: "root" }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    exports2.keys = function(object) {
      var keys2 = [];
      for (var key2 in object) {
        keys2.push(key2);
      }
      keys2.reverse();
      return function next2() {
        while (keys2.length) {
          var key3 = keys2.pop();
          if (key3 in object) {
            next2.value = key3;
            next2.done = false;
            return next2;
          }
        }
        next2.done = true;
        return next2;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1, next2 = function next3() {
            while (++i < iterable.length) {
              if (hasOwn3.call(iterable, i)) {
                next3.value = iterable[i];
                next3.done = false;
                return next3;
              }
            }
            next3.value = undefined$1;
            next3.done = true;
            return next3;
          };
          return next2.next = next2;
        }
      }
      return { next: doneResult };
    }
    exports2.values = values;
    function doneResult() {
      return { value: undefined$1, done: true };
    }
    Context.prototype = {
      constructor: Context,
      reset: function(skipTempReset) {
        this.prev = 0;
        this.next = 0;
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            if (name.charAt(0) === "t" && hasOwn3.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function(exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            context.method = "next";
            context.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn3.call(entry, "catchLoc");
            var hasFinally = hasOwn3.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn3.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName,
          nextLoc
        };
        if (this.method === "next") {
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };
    return exports2;
  }(module2.exports);
  try {
    regeneratorRuntime = runtime2;
  } catch (accidentalStrictMode) {
    if (typeof globalThis === "object") {
      globalThis.regeneratorRuntime = runtime2;
    } else {
      Function("r", "regeneratorRuntime = r")(runtime2);
    }
  }
})(runtime);
var regenerator = runtime.exports;
var CheckCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" } }, { "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "check-circle", "theme": "outlined" };
var CheckCircleOutlinedSvg = CheckCircleOutlined$2;
function _objectSpread$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$d(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$d(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CheckCircleOutlined = function CheckCircleOutlined2(props2, context) {
  var p = _objectSpread$c({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$c({}, p, {
    "icon": CheckCircleOutlinedSvg
  }), null);
};
CheckCircleOutlined.displayName = "CheckCircleOutlined";
CheckCircleOutlined.inheritAttrs = false;
var CheckCircleOutlined$1 = CheckCircleOutlined;
var InfoCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z" } }] }, "name": "info-circle", "theme": "outlined" };
var InfoCircleOutlinedSvg = InfoCircleOutlined$2;
function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$c(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$c(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var InfoCircleOutlined = function InfoCircleOutlined2(props2, context) {
  var p = _objectSpread$b({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$b({}, p, {
    "icon": InfoCircleOutlinedSvg
  }), null);
};
InfoCircleOutlined.displayName = "InfoCircleOutlined";
InfoCircleOutlined.inheritAttrs = false;
var InfoCircleOutlined$1 = InfoCircleOutlined;
var CloseCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 00-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z" } }, { "tag": "path", "attrs": { "d": "M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }] }, "name": "close-circle", "theme": "outlined" };
var CloseCircleOutlinedSvg = CloseCircleOutlined$2;
function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$b(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$b(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CloseCircleOutlined = function CloseCircleOutlined2(props2, context) {
  var p = _objectSpread$a({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$a({}, p, {
    "icon": CloseCircleOutlinedSvg
  }), null);
};
CloseCircleOutlined.displayName = "CloseCircleOutlined";
CloseCircleOutlined.inheritAttrs = false;
var CloseCircleOutlined$1 = CloseCircleOutlined;
var ExclamationCircleOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" } }, { "tag": "path", "attrs": { "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z" } }] }, "name": "exclamation-circle", "theme": "outlined" };
var ExclamationCircleOutlinedSvg = ExclamationCircleOutlined$2;
function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$a(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$a(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var ExclamationCircleOutlined = function ExclamationCircleOutlined2(props2, context) {
  var p = _objectSpread$9({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$9({}, p, {
    "icon": ExclamationCircleOutlinedSvg
  }), null);
};
ExclamationCircleOutlined.displayName = "ExclamationCircleOutlined";
ExclamationCircleOutlined.inheritAttrs = false;
var ExclamationCircleOutlined$1 = ExclamationCircleOutlined;
var CloseOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlinedSvg = CloseOutlined$2;
function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$9(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$9(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CloseOutlined = function CloseOutlined2(props2, context) {
  var p = _objectSpread$8({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$8({}, p, {
    "icon": CloseOutlinedSvg
  }), null);
};
CloseOutlined.displayName = "CloseOutlined";
CloseOutlined.inheritAttrs = false;
var CloseOutlined$1 = CloseOutlined;
globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var notificationInstance = {};
var defaultDuration = 4.5;
var defaultTop = "24px";
var defaultBottom = "24px";
var defaultPrefixCls$1 = "";
var defaultPlacement = "topRight";
var defaultGetContainer = function defaultGetContainer2() {
  return document.body;
};
var defaultCloseIcon = null;
var rtl = false;
var maxCount;
function setNotificationConfig(options) {
  var duration = options.duration, placement = options.placement, bottom = options.bottom, top = options.top, getContainer4 = options.getContainer, closeIcon = options.closeIcon, prefixCls = options.prefixCls;
  if (prefixCls !== void 0) {
    defaultPrefixCls$1 = prefixCls;
  }
  if (duration !== void 0) {
    defaultDuration = duration;
  }
  if (placement !== void 0) {
    defaultPlacement = placement;
  }
  if (bottom !== void 0) {
    defaultBottom = typeof bottom === "number" ? "".concat(bottom, "px") : bottom;
  }
  if (top !== void 0) {
    defaultTop = typeof top === "number" ? "".concat(top, "px") : top;
  }
  if (getContainer4 !== void 0) {
    defaultGetContainer = getContainer4;
  }
  if (closeIcon !== void 0) {
    defaultCloseIcon = closeIcon;
  }
  if (options.rtl !== void 0) {
    rtl = options.rtl;
  }
  if (options.maxCount !== void 0) {
    maxCount = options.maxCount;
  }
}
function getPlacementStyle(placement) {
  var top = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultTop;
  var bottom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultBottom;
  var style2;
  switch (placement) {
    case "topLeft":
      style2 = {
        left: "0px",
        top,
        bottom: "auto"
      };
      break;
    case "topRight":
      style2 = {
        right: "0px",
        top,
        bottom: "auto"
      };
      break;
    case "bottomLeft":
      style2 = {
        left: "0px",
        top: "auto",
        bottom
      };
      break;
    default:
      style2 = {
        right: "0px",
        top: "auto",
        bottom
      };
      break;
  }
  return style2;
}
function getNotificationInstance(_ref, callback) {
  var customizePrefixCls = _ref.prefixCls, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement, _ref$getContainer = _ref.getContainer, getContainer4 = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer, top = _ref.top, bottom = _ref.bottom, _ref$closeIcon = _ref.closeIcon, _closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon, appContext = _ref.appContext;
  var _globalConfig = globalConfig(), getPrefixCls2 = _globalConfig.getPrefixCls;
  var prefixCls = getPrefixCls2("notification", customizePrefixCls || defaultPrefixCls$1);
  var cacheKey = "".concat(prefixCls, "-").concat(placement, "-").concat(rtl);
  var cacheInstance = notificationInstance[cacheKey];
  if (cacheInstance) {
    Promise.resolve(cacheInstance).then(function(instance) {
      callback(instance);
    });
    return;
  }
  var notificationClass = classNames("".concat(prefixCls, "-").concat(placement), _defineProperty$m({}, "".concat(prefixCls, "-rtl"), rtl === true));
  Notification$1.newInstance({
    name: "notification",
    prefixCls: customizePrefixCls || defaultPrefixCls$1,
    class: notificationClass,
    style: getPlacementStyle(placement, top, bottom),
    appContext,
    getContainer: getContainer4,
    closeIcon: function closeIcon(_ref2) {
      var prefixCls2 = _ref2.prefixCls;
      var closeIconToRender = createVNode("span", {
        "class": "".concat(prefixCls2, "-close-x")
      }, [renderHelper(_closeIcon, {}, createVNode(CloseOutlined$1, {
        "class": "".concat(prefixCls2, "-close-icon")
      }, null))]);
      return closeIconToRender;
    },
    maxCount,
    hasTransitionName: true
  }, function(notification2) {
    notificationInstance[cacheKey] = notification2;
    callback(notification2);
  });
}
var typeToIcon = {
  success: CheckCircleOutlined$1,
  info: InfoCircleOutlined$1,
  error: CloseCircleOutlined$1,
  warning: ExclamationCircleOutlined$1
};
function notice(args) {
  var icon = args.icon, type = args.type, description = args.description, message2 = args.message, btn = args.btn;
  var duration = args.duration === void 0 ? defaultDuration : args.duration;
  getNotificationInstance(args, function(notification2) {
    notification2.notice({
      content: function content(_ref3) {
        var outerPrefixCls = _ref3.prefixCls;
        var prefixCls = "".concat(outerPrefixCls, "-notice");
        var iconNode = null;
        if (icon) {
          iconNode = function iconNode2() {
            return createVNode("span", {
              "class": "".concat(prefixCls, "-icon")
            }, [renderHelper(icon)]);
          };
        } else if (type) {
          var Icon3 = typeToIcon[type];
          iconNode = function iconNode2() {
            return createVNode(Icon3, {
              "class": "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(type)
            }, null);
          };
        }
        return createVNode("div", {
          "class": iconNode ? "".concat(prefixCls, "-with-icon") : ""
        }, [iconNode && iconNode(), createVNode("div", {
          "class": "".concat(prefixCls, "-message")
        }, [!description && iconNode ? createVNode("span", {
          "class": "".concat(prefixCls, "-message-single-line-auto-margin")
        }, null) : null, renderHelper(message2)]), createVNode("div", {
          "class": "".concat(prefixCls, "-description")
        }, [renderHelper(description)]), btn ? createVNode("span", {
          "class": "".concat(prefixCls, "-btn")
        }, [renderHelper(btn)]) : null]);
      },
      duration,
      closable: true,
      onClose: args.onClose,
      onClick: args.onClick,
      key: args.key,
      style: args.style || {},
      class: args.class
    });
  });
}
var api = {
  open: notice,
  close: function close(key2) {
    Object.keys(notificationInstance).forEach(function(cacheKey) {
      return Promise.resolve(notificationInstance[cacheKey]).then(function(instance) {
        instance.removeNotice(key2);
      });
    });
  },
  config: setNotificationConfig,
  destroy: function destroy2() {
    Object.keys(notificationInstance).forEach(function(cacheKey) {
      Promise.resolve(notificationInstance[cacheKey]).then(function(instance) {
        instance.destroy();
      });
      delete notificationInstance[cacheKey];
    });
  }
};
var iconTypes = ["success", "info", "warning", "error"];
iconTypes.forEach(function(type) {
  api[type] = function(args) {
    return api.open(_extends(_extends({}, args), {
      type
    }));
  };
});
api.warn = api.warning;
var notification = api;
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var MARK_KEY = "vc-util-key";
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
  if (mark) {
    return mark.startsWith("data-") ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer2(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector("head");
  return head || document.body;
}
function injectCSS(css2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _a, _b;
  if (!canUseDom()) {
    return null;
  }
  var styleNode = document.createElement("style");
  if ((_a = option.csp) === null || _a === void 0 ? void 0 : _a.nonce) {
    styleNode.nonce = (_b = option.csp) === null || _b === void 0 ? void 0 : _b.nonce;
  }
  styleNode.innerHTML = css2;
  var container = getContainer2(option);
  var firstChild = container.firstChild;
  if (option.prepend && container.prepend) {
    container.prepend(styleNode);
  } else if (option.prepend && firstChild) {
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
var containerCache = /* @__PURE__ */ new Map();
function findExistNode(key2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var container = getContainer2(option);
  return Array.from(containerCache.get(container).children).find(function(node) {
    return node.tagName === "STYLE" && node.getAttribute(getMark(option)) === key2;
  });
}
function updateCSS(css2, key2) {
  var option = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _a, _b, _c;
  var container = getContainer2(option);
  if (!containerCache.has(container)) {
    var placeholderStyle = injectCSS("", option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    parentNode.removeChild(placeholderStyle);
  }
  var existNode = findExistNode(key2, option);
  if (existNode) {
    if (((_a = option.csp) === null || _a === void 0 ? void 0 : _a.nonce) && existNode.nonce !== ((_b = option.csp) === null || _b === void 0 ? void 0 : _b.nonce)) {
      existNode.nonce = (_c = option.csp) === null || _c === void 0 ? void 0 : _c.nonce;
    }
    if (existNode.innerHTML !== css2) {
      existNode.innerHTML = css2;
    }
    return existNode;
  }
  var newNode = injectCSS(css2, option);
  newNode.setAttribute(getMark(option), key2);
  return newNode;
}
var devWarning = function(valid, component, message2) {
  warningOnce(valid, "[ant-design-vue: ".concat(component, "] ").concat(message2));
};
var dynamicStyleMark = "-ant-".concat(Date.now(), "-").concat(Math.random());
function registerTheme(globalPrefixCls, theme) {
  var variables = {};
  var formatColor = function formatColor2(color, updater) {
    var clone2 = color.clone();
    clone2 = (updater === null || updater === void 0 ? void 0 : updater(clone2)) || clone2;
    return clone2.toRgbString();
  };
  var fillColor = function fillColor2(colorVal, type) {
    var baseColor = new TinyColor(colorVal);
    var colorPalettes = generate$1(baseColor.toRgbString());
    variables["".concat(type, "-color")] = formatColor(baseColor);
    variables["".concat(type, "-color-disabled")] = colorPalettes[1];
    variables["".concat(type, "-color-hover")] = colorPalettes[4];
    variables["".concat(type, "-color-active")] = colorPalettes[7];
    variables["".concat(type, "-color-outline")] = baseColor.clone().setAlpha(0.2).toRgbString();
    variables["".concat(type, "-color-deprecated-bg")] = colorPalettes[1];
    variables["".concat(type, "-color-deprecated-border")] = colorPalettes[3];
  };
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, "primary");
    var primaryColor = new TinyColor(theme.primaryColor);
    var primaryColors = generate$1(primaryColor.toRgbString());
    primaryColors.forEach(function(color, index2) {
      variables["primary-".concat(index2 + 1)] = color;
    });
    variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, function(c2) {
      return c2.lighten(35);
    });
    variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, function(c2) {
      return c2.lighten(20);
    });
    variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, function(c2) {
      return c2.tint(20);
    });
    variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, function(c2) {
      return c2.tint(50);
    });
    variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, function(c2) {
      return c2.setAlpha(c2.getAlpha() * 0.12);
    });
    var primaryActiveColor = new TinyColor(primaryColors[0]);
    variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, function(c2) {
      return c2.setAlpha(c2.getAlpha() * 0.3);
    });
    variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, function(c2) {
      return c2.darken(2);
    });
  }
  if (theme.successColor) {
    fillColor(theme.successColor, "success");
  }
  if (theme.warningColor) {
    fillColor(theme.warningColor, "warning");
  }
  if (theme.errorColor) {
    fillColor(theme.errorColor, "error");
  }
  if (theme.infoColor) {
    fillColor(theme.infoColor, "info");
  }
  var cssList = Object.keys(variables).map(function(key2) {
    return "--".concat(globalPrefixCls, "-").concat(key2, ": ").concat(variables[key2], ";");
  });
  if (canUseDom()) {
    updateCSS("\n  :root {\n    ".concat(cssList.join("\n"), "\n  }\n  "), "".concat(dynamicStyleMark, "-dynamic-theme"));
  } else {
    devWarning(false, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
  }
}
var GlobalFormContextKey = Symbol("GlobalFormContextKey");
var useProvideGlobalForm = function useProvideGlobalForm2(state) {
  provide(GlobalFormContextKey, state);
};
var configProviderProps = function configProviderProps2() {
  return {
    getTargetContainer: {
      type: Function
    },
    getPopupContainer: {
      type: Function
    },
    prefixCls: String,
    getPrefixCls: {
      type: Function
    },
    renderEmpty: {
      type: Function
    },
    transformCellText: {
      type: Function
    },
    csp: {
      type: Object,
      default: void 0
    },
    input: {
      type: Object
    },
    autoInsertSpaceInButton: {
      type: Boolean,
      default: void 0
    },
    locale: {
      type: Object,
      default: void 0
    },
    pageHeader: {
      type: Object
    },
    componentSize: {
      type: String
    },
    direction: {
      type: String
    },
    space: {
      type: Object
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    dropdownMatchSelectWidth: {
      type: [Number, Boolean],
      default: true
    },
    form: {
      type: Object,
      default: void 0
    },
    notUpdateGlobalConfig: Boolean
  };
};
var defaultPrefixCls = "ant";
function getGlobalPrefixCls() {
  return globalConfigForApi.prefixCls || defaultPrefixCls;
}
var globalConfigByCom = reactive({});
var globalConfigBySet = reactive({});
var globalConfigForApi = reactive({});
watchEffect(function() {
  _extends(globalConfigForApi, globalConfigByCom, globalConfigBySet);
  globalConfigForApi.prefixCls = getGlobalPrefixCls();
  globalConfigForApi.getPrefixCls = function(suffixCls, customizePrefixCls) {
    if (customizePrefixCls)
      return customizePrefixCls;
    return suffixCls ? "".concat(globalConfigForApi.prefixCls, "-").concat(suffixCls) : globalConfigForApi.prefixCls;
  };
  globalConfigForApi.getRootPrefixCls = function(rootPrefixCls, customizePrefixCls) {
    if (rootPrefixCls) {
      return rootPrefixCls;
    }
    if (globalConfigForApi.prefixCls) {
      return globalConfigForApi.prefixCls;
    }
    if (customizePrefixCls && customizePrefixCls.includes("-")) {
      return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
    }
    return getGlobalPrefixCls();
  };
});
var stopWatchEffect;
var setGlobalConfig = function setGlobalConfig2(params) {
  if (stopWatchEffect) {
    stopWatchEffect();
  }
  stopWatchEffect = watchEffect(function() {
    _extends(globalConfigBySet, reactive(params));
  });
  if (params.theme) {
    registerTheme(getGlobalPrefixCls(), params.theme);
  }
};
var globalConfig = function globalConfig2() {
  return {
    getPrefixCls: function getPrefixCls2(suffixCls, customizePrefixCls) {
      if (customizePrefixCls)
        return customizePrefixCls;
      return suffixCls ? "".concat(getGlobalPrefixCls(), "-").concat(suffixCls) : getGlobalPrefixCls();
    },
    getRootPrefixCls: function getRootPrefixCls(rootPrefixCls, customizePrefixCls) {
      if (rootPrefixCls) {
        return rootPrefixCls;
      }
      if (globalConfigForApi.prefixCls) {
        return globalConfigForApi.prefixCls;
      }
      if (customizePrefixCls && customizePrefixCls.includes("-")) {
        return customizePrefixCls.replace(/^(.*)-[^-]*$/, "$1");
      }
      return getGlobalPrefixCls();
    }
  };
};
var ConfigProvider = defineComponent({
  name: "AConfigProvider",
  inheritAttrs: false,
  props: configProviderProps(),
  setup: function setup6(props2, _ref) {
    var slots = _ref.slots;
    var getPrefixCls2 = function getPrefixCls3(suffixCls, customizePrefixCls) {
      var _props$prefixCls = props2.prefixCls, prefixCls = _props$prefixCls === void 0 ? "ant" : _props$prefixCls;
      if (customizePrefixCls)
        return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    };
    var renderEmptyComponent = function renderEmptyComponent2(name) {
      var renderEmpty$1 = props2.renderEmpty || slots.renderEmpty || renderEmpty;
      return renderEmpty$1(name);
    };
    var getPrefixClsWrapper = function getPrefixClsWrapper2(suffixCls, customizePrefixCls) {
      var prefixCls = props2.prefixCls;
      if (customizePrefixCls)
        return customizePrefixCls;
      var mergedPrefixCls = prefixCls || getPrefixCls2("");
      return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
    };
    var configProvider = reactive(_extends(_extends({}, props2), {
      getPrefixCls: getPrefixClsWrapper,
      renderEmpty: renderEmptyComponent
    }));
    Object.keys(props2).forEach(function(key2) {
      watch(function() {
        return props2[key2];
      }, function() {
        configProvider[key2] = props2[key2];
      });
    });
    if (!props2.notUpdateGlobalConfig) {
      _extends(globalConfigByCom, configProvider);
      watch(configProvider, function() {
        _extends(globalConfigByCom, configProvider);
      });
    }
    var validateMessagesRef = computed(function() {
      var _a, _b;
      var validateMessages = {};
      if (props2.locale) {
        validateMessages = ((_a = props2.locale.Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || ((_b = defaultLocale.Form) === null || _b === void 0 ? void 0 : _b.defaultValidateMessages) || {};
      }
      if (props2.form && props2.form.validateMessages) {
        validateMessages = _extends(_extends({}, validateMessages), props2.form.validateMessages);
      }
      return validateMessages;
    });
    useProvideGlobalForm({
      validateMessages: validateMessagesRef
    });
    provide("configProvider", configProvider);
    var renderProvider = function renderProvider2(legacyLocale) {
      var _a;
      return createVNode(LocaleProvider$1, {
        "locale": props2.locale || legacyLocale,
        "ANT_MARK__": ANT_MARK
      }, {
        default: function _default3() {
          return [(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)];
        }
      });
    };
    watchEffect(function() {
      if (props2.direction) {
        message.config({
          rtl: props2.direction === "rtl"
        });
        notification.config({
          rtl: props2.direction === "rtl"
        });
      }
    });
    return function() {
      return createVNode(LocaleReceiver, {
        "children": function children(_2, __, legacyLocale) {
          return renderProvider(legacyLocale);
        }
      }, null);
    };
  }
});
var defaultConfigProvider = reactive({
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls)
      return customizePrefixCls;
    return suffixCls ? "ant-".concat(suffixCls) : "ant";
  },
  renderEmpty,
  direction: "ltr"
});
ConfigProvider.config = setGlobalConfig;
ConfigProvider.install = function(app) {
  app.component(ConfigProvider.name, ConfigProvider);
};
var useConfigInject = function(name, props2) {
  var configProvider = inject("configProvider", defaultConfigProvider);
  var prefixCls = computed(function() {
    return configProvider.getPrefixCls(name, props2.prefixCls);
  });
  var direction = computed(function() {
    var _a;
    return (_a = props2.direction) !== null && _a !== void 0 ? _a : configProvider.direction;
  });
  var rootPrefixCls = computed(function() {
    return configProvider.getPrefixCls();
  });
  var autoInsertSpaceInButton = computed(function() {
    return configProvider.autoInsertSpaceInButton;
  });
  var renderEmpty2 = computed(function() {
    return configProvider.renderEmpty;
  });
  var space = computed(function() {
    return configProvider.space;
  });
  var pageHeader = computed(function() {
    return configProvider.pageHeader;
  });
  var form = computed(function() {
    return configProvider.form;
  });
  var getTargetContainer = computed(function() {
    return props2.getTargetContainer || configProvider.getTargetContainer;
  });
  var getPopupContainer = computed(function() {
    return props2.getPopupContainer || configProvider.getPopupContainer;
  });
  var dropdownMatchSelectWidth = computed(function() {
    var _a;
    return (_a = props2.dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : configProvider.dropdownMatchSelectWidth;
  });
  var virtual = computed(function() {
    return (props2.virtual === void 0 ? configProvider.virtual !== false : props2.virtual !== false) && dropdownMatchSelectWidth.value !== false;
  });
  var size = computed(function() {
    return props2.size || configProvider.componentSize;
  });
  var autocomplete = computed(function() {
    var _a;
    return props2.autocomplete || ((_a = configProvider.input) === null || _a === void 0 ? void 0 : _a.autocomplete);
  });
  var csp = computed(function() {
    return configProvider.csp;
  });
  return {
    configProvider,
    prefixCls,
    direction,
    size,
    getTargetContainer,
    getPopupContainer,
    space,
    pageHeader,
    form,
    autoInsertSpaceInButton,
    renderEmpty: renderEmpty2,
    virtual,
    dropdownMatchSelectWidth,
    rootPrefixCls,
    getPrefixCls: configProvider.getPrefixCls,
    autocomplete,
    csp
  };
};
function omit(obj, fields) {
  var shallowCopy = _extends({}, obj);
  for (var i = 0; i < fields.length; i += 1) {
    var key2 = fields[i];
    delete shallowCopy[key2];
  }
  return shallowCopy;
}
function _toArray(arr) {
  return _arrayWithHoles$2(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableRest$2();
}
function getKey$1(data4, index2) {
  var key2 = data4.key;
  var value;
  if ("value" in data4) {
    value = data4.value;
  }
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  if (value !== void 0) {
    return value;
  }
  return "rc-index-key-".concat(index2);
}
function fillFieldNames$2(fieldNames, childrenAsData) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options;
  return {
    label: label || (childrenAsData ? "children" : "label"),
    value: value || "value",
    options: options || "options"
  };
}
function flattenOptions(options) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
  var flattenList = [];
  var _fillFieldNames = fillFieldNames$2(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options;
  function dig(list, isGroupOption) {
    list.forEach(function(data4) {
      var label = data4[fieldLabel];
      if (isGroupOption || !(fieldOptions in data4)) {
        var value = data4[fieldValue];
        flattenList.push({
          key: getKey$1(data4, flattenList.length),
          groupOption: isGroupOption,
          data: data4,
          label,
          value
        });
      } else {
        var grpLabel = label;
        if (grpLabel === void 0 && childrenAsData) {
          grpLabel = data4.label;
        }
        flattenList.push({
          key: getKey$1(data4, flattenList.length),
          group: true,
          data: data4,
          label: grpLabel
        });
        dig(data4[fieldOptions], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}
function injectPropsWithOption(option) {
  var newOption = _extends({}, option);
  if (!("props" in newOption)) {
    Object.defineProperty(newOption, "props", {
      get: function get() {
        return newOption;
      }
    });
  }
  return newOption;
}
function getSeparatedContent(text, tokens) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match2 = false;
  function separate(str, _ref3) {
    var _ref4 = _toArray(_ref3), token = _ref4[0], restTokens = _ref4.slice(1);
    if (!token) {
      return [str];
    }
    var list2 = str.split(token);
    match2 = match2 || list2.length > 1;
    return list2.reduce(function(prevList, unitStr) {
      return [].concat(_toConsumableArray(prevList), _toConsumableArray(separate(unitStr, restTokens)));
    }, []).filter(function(unit) {
      return unit;
    });
  }
  var list = separate(text, tokens);
  return match2 ? list : null;
}
function contains(root2, n2) {
  if (!root2) {
    return false;
  }
  return root2.contains(n2);
}
var availablePrefixs = ["moz", "ms", "webkit"];
function requestAnimationFramePolyfill() {
  var lastTime = 0;
  return function(callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function() {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };
}
function getRequestAnimationFrame() {
  if (typeof window === "undefined") {
    return function() {
    };
  }
  if (window.requestAnimationFrame) {
    return window.requestAnimationFrame.bind(window);
  }
  var prefix = availablePrefixs.filter(function(key2) {
    return "".concat(key2, "RequestAnimationFrame") in window;
  })[0];
  return prefix ? window["".concat(prefix, "RequestAnimationFrame")] : requestAnimationFramePolyfill();
}
function cancelRequestAnimationFrame(id) {
  if (typeof window === "undefined") {
    return null;
  }
  if (window.cancelAnimationFrame) {
    return window.cancelAnimationFrame(id);
  }
  var prefix = availablePrefixs.filter(function(key2) {
    return "".concat(key2, "CancelAnimationFrame") in window || "".concat(key2, "CancelRequestAnimationFrame") in window;
  })[0];
  return prefix ? (window["".concat(prefix, "CancelAnimationFrame")] || window["".concat(prefix, "CancelRequestAnimationFrame")]).call(this, id) : clearTimeout(id);
}
var raf2 = getRequestAnimationFrame();
var cancelAnimationTimeout = function cancelAnimationTimeout2(frame) {
  return cancelRequestAnimationFrame(frame.id);
};
var requestAnimationTimeout = function requestAnimationTimeout2(callback) {
  var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var start = Date.now();
  function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = raf2(timeout);
    }
  }
  var frame = {
    id: raf2(timeout)
  };
  return frame;
};
var innerProps = {
  visible: Boolean,
  prefixCls: String,
  zIndex: Number,
  destroyPopupOnHide: Boolean,
  forceRender: Boolean,
  animation: [String, Object],
  transitionName: String,
  stretch: {
    type: String
  },
  align: {
    type: Object
  },
  point: {
    type: Object
  },
  getRootDomNode: {
    type: Function
  },
  getClassNameFromAlign: {
    type: Function
  },
  onMouseenter: {
    type: Function
  },
  onMouseleave: {
    type: Function
  },
  onMousedown: {
    type: Function
  },
  onTouchstart: {
    type: Function
  }
};
var mobileProps = _extends(_extends({}, innerProps), {
  mobile: {
    type: Object
  }
});
var popupProps = _extends(_extends({}, innerProps), {
  mask: Boolean,
  mobile: {
    type: Object
  },
  maskAnimation: String,
  maskTransitionName: String
});
function getMotion(_ref) {
  var prefixCls = _ref.prefixCls, animation = _ref.animation, transitionName2 = _ref.transitionName;
  if (animation) {
    return {
      name: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName2) {
    return {
      name: transitionName2
    };
  }
  return {};
}
function Mask$1(props2) {
  var prefixCls = props2.prefixCls, visible = props2.visible, zIndex = props2.zIndex, mask = props2.mask, maskAnimation = props2.maskAnimation, maskTransitionName = props2.maskTransitionName;
  if (!mask) {
    return null;
  }
  var motion = {};
  if (maskTransitionName || maskAnimation) {
    motion = getMotion({
      prefixCls,
      transitionName: maskTransitionName,
      animation: maskAnimation
    });
  }
  return createVNode(Transition, _objectSpread2$1({
    "appear": true
  }, motion), {
    default: function _default3() {
      return [withDirectives(createVNode("div", {
        "style": {
          zIndex
        },
        "class": "".concat(prefixCls, "-mask")
      }, null), [[resolveDirective("if"), visible]])];
    }
  });
}
Mask$1.displayName = "Mask";
var MobilePopupInner = defineComponent({
  name: "MobilePopupInner",
  inheritAttrs: false,
  props: mobileProps,
  emits: ["mouseenter", "mouseleave", "mousedown", "touchstart", "align"],
  setup: function setup7(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var elementRef = ref();
    expose({
      forceAlign: function forceAlign() {
      },
      getElement: function getElement2() {
        return elementRef.value;
      }
    });
    return function() {
      var _a;
      var zIndex = props2.zIndex, visible = props2.visible, prefixCls = props2.prefixCls, _props$mobile = props2.mobile;
      _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
      var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender;
      var mergedStyle = _extends({
        zIndex
      }, popupStyle);
      var childNode = flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots));
      if (childNode.length > 1) {
        childNode = createVNode("div", {
          "class": "".concat(prefixCls, "-content")
        }, [childNode]);
      }
      if (popupRender) {
        childNode = popupRender(childNode);
      }
      var mergedClassName = classNames(prefixCls, popupClassName);
      return createVNode(Transition, _objectSpread2$1({
        "ref": elementRef
      }, popupMotion), {
        default: function _default3() {
          return [visible ? createVNode("div", {
            "class": mergedClassName,
            "style": mergedStyle
          }, [childNode]) : null];
        }
      });
    };
  }
});
var __awaiter = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P2, generator) {
  function adopt(value) {
    return value instanceof P2 ? value : new P2(function(resolve) {
      resolve(value);
    });
  }
  return new (P2 || (P2 = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var StatusQueue = ["measure", "align", null, "motion"];
var useVisibleStatus = function(visible, doMeasure) {
  var status = ref(null);
  var rafRef = ref();
  var destroyRef = ref(false);
  function setStatus(nextStatus) {
    if (!destroyRef.value) {
      status.value = nextStatus;
    }
  }
  function cancelRaf() {
    wrapperRaf.cancel(rafRef.value);
  }
  function goNextStatus(callback) {
    cancelRaf();
    rafRef.value = wrapperRaf(function() {
      var newStatus = status.value;
      switch (status.value) {
        case "align":
          newStatus = "motion";
          break;
        case "motion":
          newStatus = "stable";
          break;
      }
      setStatus(newStatus);
      callback === null || callback === void 0 ? void 0 : callback();
    });
  }
  watch(visible, function() {
    setStatus("measure");
  }, {
    immediate: true,
    flush: "post"
  });
  onMounted(function() {
    watch(status, function() {
      switch (status.value) {
        case "measure":
          doMeasure();
          break;
      }
      if (status.value) {
        rafRef.value = wrapperRaf(function() {
          return __awaiter(void 0, void 0, void 0, /* @__PURE__ */ regenerator.mark(function _callee() {
            var index2, nextStatus;
            return regenerator.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    index2 = StatusQueue.indexOf(status.value);
                    nextStatus = StatusQueue[index2 + 1];
                    if (nextStatus && index2 !== -1) {
                      setStatus(nextStatus);
                    }
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        });
      }
    }, {
      immediate: true,
      flush: "post"
    });
  });
  onBeforeUnmount(function() {
    destroyRef.value = true;
    cancelRaf();
  });
  return [status, goNextStatus];
};
var useStretchStyle = function(stretch) {
  var targetSize = ref({
    width: 0,
    height: 0
  });
  function measureStretch(element) {
    targetSize.value = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
  }
  var style2 = computed(function() {
    var sizeStyle = {};
    if (stretch.value) {
      var _targetSize$value = targetSize.value, width = _targetSize$value.width, height = _targetSize$value.height;
      if (stretch.value.indexOf("height") !== -1 && height) {
        sizeStyle.height = "".concat(height, "px");
      } else if (stretch.value.indexOf("minHeight") !== -1 && height) {
        sizeStyle.minHeight = "".concat(height, "px");
      }
      if (stretch.value.indexOf("width") !== -1 && width) {
        sizeStyle.width = "".concat(width, "px");
      } else if (stretch.value.indexOf("minWidth") !== -1 && width) {
        sizeStyle.minWidth = "".concat(width, "px");
      }
    }
    return sizeStyle;
  });
  return [style2, measureStretch];
};
function ownKeys(object, enumerableOnly) {
  var keys2 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys2.push.apply(keys2, symbols);
  }
  return keys2;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key2) {
        _defineProperty$8(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function _defineProperty$8(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var vendorPrefix;
var jsCssMap = {
  Webkit: "-webkit-",
  Moz: "-moz-",
  ms: "-ms-",
  O: "-o-"
};
function getVendorPrefix() {
  if (vendorPrefix !== void 0) {
    return vendorPrefix;
  }
  vendorPrefix = "";
  var style2 = document.createElement("p").style;
  var testProp = "Transform";
  for (var key2 in jsCssMap) {
    if (key2 + testProp in style2) {
      vendorPrefix = key2;
    }
  }
  return vendorPrefix;
}
function getTransitionName2() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : "transitionProperty";
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : "transform";
}
function setTransitionProperty(node, value) {
  var name = getTransitionName2();
  if (name) {
    node.style[name] = value;
    if (name !== "transitionProperty") {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== "transform") {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName2()];
}
function getTransformXY(node) {
  var style2 = window.getComputedStyle(node, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var matrix = transform.replace(/[^0-9\-.,]/g, "").split(",");
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style2 = window.getComputedStyle(node, null);
  var transform = style2.getPropertyValue("transform") || style2.getPropertyValue(getTransformName());
  if (transform && transform !== "none") {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(",").map(function(item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(","), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(",").map(function(item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(","), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}
var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = "none";
  elem.offsetHeight;
  elem.style.display = originalStyle;
}
function css(el, name, v2) {
  var value = v2;
  if (_typeof(name) === "object") {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return void 0;
  }
  if (typeof value !== "undefined") {
    if (typeof value === "number") {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return void 0;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x2;
  var y2;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  box = elem.getBoundingClientRect();
  x2 = box.left;
  y2 = box.top;
  x2 -= docElem.clientLeft || body.clientLeft || 0;
  y2 -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x2,
    top: y2
  };
}
function getScroll$1(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d2 = w2.document;
    ret = d2.documentElement[method];
    if (typeof ret !== "number") {
      ret = d2.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w2) {
  return getScroll$1(w2);
}
function getScrollTop(w2) {
  return getScroll$1(w2, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w2);
  pos.top += getScrollTop(w2);
  return pos;
}
function isWindow(obj) {
  return obj !== null && obj !== void 0 && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = "";
  var d2 = getDocument(elem);
  computedStyle = computedStyle || d2.defaultView.getComputedStyle(elem, null);
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), "i");
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = "currentStyle";
var RUNTIME_STYLE = "runtimeStyle";
var LEFT = "left";
var PX = "px";
function _getComputedStyleIE(elem, name) {
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    var style2 = elem.style;
    var left = style2[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
    style2[LEFT] = name === "fontSize" ? "1em" : ret || 0;
    ret = style2.pixelLeft + PX;
    style2[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === "" ? "auto" : ret;
}
if (typeof window !== "undefined") {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === "left") {
    return option.useCssRight ? "right" : dir;
  }
  return option.useCssBottom ? "bottom" : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === "left") {
    return "right";
  } else if (dir === "right") {
    return "left";
  } else if (dir === "top") {
    return "bottom";
  } else if (dir === "bottom") {
    return "top";
  }
}
function setLeftTop(elem, offset3, option) {
  if (css(elem, "position") === "static") {
    elem.style.position = "relative";
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection("left", option);
  var verticalProperty = getOffsetDirection("top", option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== "left") {
    presetH = 999;
  }
  if (verticalProperty !== "top") {
    presetV = 999;
  }
  var originalTransition = "";
  var originalOffset = getOffset(elem);
  if ("left" in offset3 || "top" in offset3) {
    originalTransition = getTransitionProperty(elem) || "";
    setTransitionProperty(elem, "none");
  }
  if ("left" in offset3) {
    elem.style[oppositeHorizontalProperty] = "";
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ("top" in offset3) {
    elem.style[oppositeVerticalProperty] = "";
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key2 in offset3) {
    if (offset3.hasOwnProperty(key2)) {
      var dir = getOffsetDirection(key2, option);
      var preset = key2 === "left" ? presetH : presetV;
      var off = originalOffset[key2] - old[key2];
      if (dir === key2) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  forceRelayout(elem);
  if ("left" in offset3 || "top" in offset3) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset3) {
    if (offset3.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset3[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset3) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ("left" in offset3) {
    resultXY.x = originalXY.x + offset3.left - originalOffset.left;
  }
  if ("top" in offset3) {
    resultXY.y = originalXY.y + offset3.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset3, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset3.left.toFixed(0);
    var tTop = offset3.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset3, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset3);
  } else {
    setLeftTop(elem, offset3, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, "boxSizing") === "border-box";
}
var BOX_MODELS = ["margin", "border", "padding"];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style2 = elem.style;
  var name;
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style2[name];
      style2[name] = options[name];
    }
  }
  callback.call(elem);
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style2[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props2, which) {
  var value = 0;
  var prop;
  var j2;
  var i;
  for (j2 = 0; j2 < props2.length; j2++) {
    prop = props2[j2];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === "border") {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(["Width", "Height"], function(name) {
  domUtils["doc".concat(name)] = function(refWin) {
    var d2 = refWin.document;
    return Math.max(d2.documentElement["scroll".concat(name)], d2.body["scroll".concat(name)], domUtils["viewport".concat(name)](d2));
  };
  domUtils["viewport".concat(name)] = function(win) {
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    return doc.compatMode === "CSS1Compat" && documentElementProp || body && body[prop] || documentElementProp;
  };
});
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === "width" ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === "width" ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  var borderBoxValue = name === "width" ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === void 0 || borderBoxValue <= 0) {
    borderBoxValue = void 0;
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === void 0 || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === void 0) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== void 0 || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ["border", "padding"], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ["border"], which) : getPBMWidth(elem, ["margin"], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: "absolute",
  visibility: "hidden",
  display: "block"
};
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(void 0, args);
  } else {
    swap(elem, cssShow, function() {
      val = getWH.apply(void 0, args);
    });
  }
  return val;
}
each(["width", "height"], function(name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function(el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === "width" ? ["Left", "Right"] : ["Top", "Bottom"];
  domUtils[name] = function(elem, v2) {
    var val = v2;
    if (val !== void 0) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ["padding", "border"], which);
        }
        return css(elem, name, val);
      }
      return void 0;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== "undefined") {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow,
  each,
  css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix,
  getWindowScrollLeft: function getWindowScrollLeft(w2) {
    return getScrollLeft(w2);
  },
  getWindowScrollTop: function getWindowScrollTop(w2) {
    return getScrollTop(w2);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? void 0 : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);
var getParent$1 = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, "position");
  var skipStatic = positionStyle === "fixed" || positionStyle === "absolute";
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === "html" ? null : getParent$1(element);
  }
  for (parent = getParent$1(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent$1(parent)) {
    positionStyle = utils.css(parent, "position");
    if (positionStyle !== "static") {
      return parent;
    }
  }
  return null;
}
var getParent$1$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1$1(element); parent && parent !== body && parent !== doc; parent = getParent$1$1(parent)) {
    var positionStyle = utils.css(parent, "position");
    if (positionStyle === "fixed") {
      return true;
    }
  }
  return false;
}
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;
  while (el) {
    if ((navigator.userAgent.indexOf("MSIE") === -1 || el.clientWidth !== 0) && el !== body && el !== documentElement && utils.css(el, "overflow") !== "visible") {
      var pos = utils.offset(el);
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, "position");
    if (position === "absolute") {
      element.style.position = "fixed";
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === "hidden") {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === "hidden") {
    documentHeight = win.innerHeight;
  }
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}
function getRegion(node) {
  var offset3;
  var w2;
  var h2;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset3 = utils.offset(node);
    w2 = utils.outerWidth(node);
    h2 = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset3 = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w2 = utils.viewportWidth(win);
    h2 = utils.viewportHeight(win);
  }
  offset3.width = w2;
  offset3.height = h2;
  return offset3;
}
function getAlignOffset(region, align) {
  var V2 = align.charAt(0);
  var H = align.charAt(1);
  var w2 = region.width;
  var h2 = region.height;
  var x2 = region.left;
  var y2 = region.top;
  if (V2 === "c") {
    y2 += h2 / 2;
  } else if (V2 === "b") {
    y2 += h2;
  }
  if (H === "c") {
    x2 += w2 / 2;
  } else if (H === "r") {
    x2 += w2;
  }
  return {
    left: x2,
    top: y2
  };
}
function getElFuturePos(elRegion, refNodeRegion, points, offset3, targetOffset2) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset3[0] - targetOffset2[0]),
    top: Math.round(elRegion.top - diff[1] + offset3[1] - targetOffset2[1])
  };
}
function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function(p) {
    ret.push(p.replace(reg, function(m2) {
      return map[m2];
    }));
  });
  return ret;
}
function flipOffset(offset3, index2) {
  offset3[index2] = -offset3[index2];
  return offset3;
}
function convertOffset(str, offsetLen) {
  var n2;
  if (/%$/.test(str)) {
    n2 = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n2 = parseInt(str, 10);
  }
  return n2 || 0;
}
function normalizeOffset(offset3, el) {
  offset3[0] = convertOffset(offset3[0], el.width);
  offset3[1] = convertOffset(offset3[1], el.height);
}
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset3 = align.offset || [0, 0];
  var targetOffset2 = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset3 = [].concat(offset3);
  targetOffset2 = [].concat(targetOffset2);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  var elRegion = getRegion(source);
  normalizeOffset(offset3, elRegion);
  normalizeOffset(targetOffset2, tgtRegion);
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
  var newElRegion = utils.merge(elRegion, elFuturePos);
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        var newPoints = flip(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
        var newOffset = flipOffset(offset3, 0);
        var newTargetOffset = flipOffset(targetOffset2, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset3 = newOffset;
          targetOffset2 = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        var _newPoints = flip(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
        var _newOffset = flipOffset(offset3, 1);
        var _newTargetOffset = flipOffset(targetOffset2, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset3 = _newOffset;
          targetOffset2 = _newTargetOffset;
        }
      }
    }
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset3, targetOffset2);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: "r",
          r: "l"
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: "b",
          b: "t"
        });
      }
      points = _newPoints2;
      offset3 = align.offset || [0, 0];
      targetOffset2 = align.targetOffset || [0, 0];
    }
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, "width", utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, "height", utils.height(source) + newElRegion.height - elRegion.height);
  }
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points,
    offset: offset3,
    targetOffset: targetOffset2,
    overflow: newOverflowCfg
  };
}
function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;
function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ("pageX" in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ("pageY" in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
  var points = [align.points[0], "cc"];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points
  }), pointInView);
}
function cloneElement(vnode) {
  var nodeProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  var mergeRef = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var ele = vnode;
  if (Array.isArray(vnode)) {
    ele = filterEmpty(vnode)[0];
  }
  if (!ele) {
    return null;
  }
  var node = cloneVNode(ele, nodeProps, mergeRef);
  node.props = override ? _extends(_extends({}, node.props), nodeProps) : node.props;
  warning$1(_typeof$1(node.props.class) !== "object", "class must be string");
  return node;
}
var isVisible = function(element) {
  if (!element) {
    return false;
  }
  if (element.offsetParent) {
    return true;
  }
  if (element.getBBox) {
    var box = element.getBBox();
    if (box.width || box.height) {
      return true;
    }
  }
  if (element.getBoundingClientRect) {
    var _box = element.getBoundingClientRect();
    if (_box.width || _box.height) {
      return true;
    }
  }
  return false;
};
function isSamePoint(prev2, next2) {
  if (prev2 === next2)
    return true;
  if (!prev2 || !next2)
    return false;
  if ("pageX" in next2 && "pageY" in next2) {
    return prev2.pageX === next2.pageX && prev2.pageY === next2.pageY;
  }
  if ("clientX" in next2 && "clientY" in next2) {
    return prev2.clientX === next2.clientX && prev2.clientY === next2.clientY;
  }
  return false;
}
function restoreFocus(activeElement, container) {
  if (activeElement !== document.activeElement && contains(container, activeElement) && typeof activeElement.focus === "function") {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;
  function onResize(_ref) {
    var _ref2 = _slicedToArray$2(_ref, 1), target = _ref2[0].target;
    if (!document.documentElement.contains(target))
      return;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      Promise.resolve().then(function() {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }
    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }
  var resizeObserver = new index$2(onResize);
  if (element) {
    resizeObserver.observe(element);
  }
  return function() {
    resizeObserver.disconnect();
  };
}
var useBuffer = function(callback, buffer) {
  var called = false;
  var timeout = null;
  function cancelTrigger() {
    clearTimeout(timeout);
  }
  function trigger2(force) {
    if (!called || force === true) {
      if (callback() === false) {
        return;
      }
      called = true;
      cancelTrigger();
      timeout = setTimeout(function() {
        called = false;
      }, buffer.value);
    } else {
      cancelTrigger();
      timeout = setTimeout(function() {
        called = false;
        trigger2();
      }, buffer.value);
    }
  }
  return [trigger2, function() {
    called = false;
    cancelTrigger();
  }];
};
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function assocIndexOf(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key2) {
  var data4 = this.__data__, index2 = assocIndexOf(data4, key2);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data4.length - 1;
  if (index2 == lastIndex) {
    data4.pop();
  } else {
    splice.call(data4, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key2) {
  var data4 = this.__data__, index2 = assocIndexOf(data4, key2);
  return index2 < 0 ? void 0 : data4[index2][1];
}
function listCacheHas(key2) {
  return assocIndexOf(this.__data__, key2) > -1;
}
function listCacheSet(key2, value) {
  var data4 = this.__data__, index2 = assocIndexOf(data4, key2);
  if (index2 < 0) {
    ++this.size;
    data4.push([key2, value]);
  } else {
    data4[index2][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key2) {
  var data4 = this.__data__, result = data4["delete"](key2);
  this.size = data4.size;
  return result;
}
function stackGet(key2) {
  return this.__data__.get(key2);
}
function stackHas(key2) {
  return this.__data__.has(key2);
}
function isObject2(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction2(value) {
  if (!isObject2(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root$1["__core-js_shared__"];
var coreJsData$1 = coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative(value) {
  if (!isObject2(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object, key2) {
  return object == null ? void 0 : object[key2];
}
function getNative(object, key2) {
  var value = getValue(object, key2);
  return baseIsNative(value) ? value : void 0;
}
var Map$1 = getNative(root$1, "Map");
var Map$2 = Map$1;
var nativeCreate = getNative(Object, "create");
var nativeCreate$1 = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
function hashDelete(key2) {
  var result = this.has(key2) && delete this.__data__[key2];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet(key2) {
  var data4 = this.__data__;
  if (nativeCreate$1) {
    var result = data4[key2];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data4, key2) ? data4[key2] : void 0;
}
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas(key2) {
  var data4 = this.__data__;
  return nativeCreate$1 ? data4[key2] !== void 0 : hasOwnProperty$5.call(data4, key2);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key2, value) {
  var data4 = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data4[key2] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$2 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key2) {
  var data4 = map.__data__;
  return isKeyable(key2) ? data4[typeof key2 == "string" ? "string" : "hash"] : data4.map;
}
function mapCacheDelete(key2) {
  var result = getMapData(this, key2)["delete"](key2);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key2) {
  return getMapData(this, key2).get(key2);
}
function mapCacheHas(key2) {
  return getMapData(this, key2).has(key2);
}
function mapCacheSet(key2, value) {
  var data4 = getMapData(this, key2), size = data4.size;
  data4.set(key2, value);
  this.size += data4.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet(key2, value) {
  var data4 = this.__data__;
  if (data4 instanceof ListCache) {
    var pairs = data4.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key2, value]);
      this.size = ++data4.size;
      return this;
    }
    data4 = this.__data__ = new MapCache(pairs);
  }
  data4.set(key2, value);
  this.size = data4.size;
  return this;
}
function Stack(entries) {
  var data4 = this.__data__ = new ListCache(entries);
  this.size = data4.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache, key2) {
  return cache.has(key2);
}
var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var Uint8Array2 = root$1.Uint8Array;
var Uint8Array$1 = Uint8Array2;
function mapToArray(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key2) {
    result[++index2] = [key2, value];
  });
  return result;
}
function setToArray(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$2 = 1, COMPARE_UNORDERED_FLAG = 2;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag$1 = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
function arrayPush(array, values) {
  var index2 = -1, length = values.length, offset3 = array.length;
  while (++index2 < length) {
    array[offset3 + index2] = values[index2];
  }
  return array;
}
var isArray = Array.isArray;
var isArray$1 = isArray;
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
function arrayFilter(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$6 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;
function baseTimes(n2, iteratee) {
  var index2 = -1, result = Array(n2);
  while (++index2 < n2) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var isArguments = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments$1 = isArguments;
function stubFalse() {
  return false;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var Buffer2 = moduleExports$1 ? root$1.Buffer : void 0;
var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var freeProcess = moduleExports && freeGlobal$1.process;
var nodeUtil = function() {
  try {
    var types = freeModule && freeModule.require && freeModule.require("util").types;
    if (types) {
      return types;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e2) {
  }
}();
var nodeUtil$1 = nodeUtil;
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value), isArg = !isArr && isArguments$1(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key2 in value) {
    if ((inherited || hasOwnProperty$3.call(value, key2)) && !(skipIndexes && (key2 == "length" || isBuff && (key2 == "offset" || key2 == "parent") || isType && (key2 == "buffer" || key2 == "byteLength" || key2 == "byteOffset") || isIndex(key2, length)))) {
      result.push(key2);
    }
  }
  return result;
}
var objectProto$3 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto2 = typeof Ctor == "function" && Ctor.prototype || objectProto$3;
  return value === proto2;
}
var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key2 in Object(object)) {
    if (hasOwnProperty$2.call(object, key2) && key2 != "constructor") {
      result.push(key2);
    }
  }
  return result;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction2(value);
}
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key2 = objProps[index2];
    if (!(isPartial ? key2 in other : hasOwnProperty$1.call(other, key2))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key2 = objProps[index2];
    var objValue = object[key2], othValue = other[key2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key2, other, object, stack) : customizer(objValue, othValue, key2, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key2 == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var DataView = getNative(root$1, "DataView");
var DataView$1 = DataView;
var Promise$1 = getNative(root$1, "Promise");
var Promise$2 = Promise$1;
var Set$1 = getNative(root$1, "Set");
var Set$2 = Set$1;
var WeakMap$1 = getNative(root$1, "WeakMap");
var WeakMap$2 = WeakMap$1;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$2), promiseCtorString = toSource(Promise$2), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$2);
var getTag = baseGetTag;
if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$2 && getTag(new Map$2()) != mapTag || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var getTag$1 = getTag;
var COMPARE_PARTIAL_FLAG = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object), othIsArr = isArray$1(other), objTag = objIsArr ? arrayTag : getTag$1(object), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray$1(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var alignProps = {
  align: Object,
  target: [Object, Function],
  onAlign: Function,
  monitorBufferTime: Number,
  monitorWindowResize: Boolean,
  disabled: Boolean
};
function getElement(func) {
  if (typeof func !== "function")
    return null;
  return func();
}
function getPoint(point) {
  if (_typeof$1(point) !== "object" || !point)
    return null;
  return point;
}
var Align = defineComponent({
  name: "Align",
  props: alignProps,
  emits: ["align"],
  setup: function setup8(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var cacheRef = ref({});
    var nodeRef = ref();
    var _useBuffer = useBuffer(function() {
      var latestDisabled = props2.disabled, latestTarget = props2.target, latestAlign = props2.align, latestOnAlign = props2.onAlign;
      if (!latestDisabled && latestTarget && nodeRef.value) {
        var source = nodeRef.value;
        var result;
        var element = getElement(latestTarget);
        var point = getPoint(latestTarget);
        cacheRef.value.element = element;
        cacheRef.value.point = point;
        cacheRef.value.align = latestAlign;
        var _document = document, activeElement = _document.activeElement;
        if (element && isVisible(element)) {
          result = alignElement(source, element, latestAlign);
        } else if (point) {
          result = alignPoint(source, point, latestAlign);
        }
        restoreFocus(activeElement, source);
        if (latestOnAlign && result) {
          latestOnAlign(source, result);
        }
        return true;
      }
      return false;
    }, computed(function() {
      return props2.monitorBufferTime;
    })), _useBuffer2 = _slicedToArray$2(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1];
    var resizeMonitor = ref({
      cancel: function cancel() {
      }
    });
    var sourceResizeMonitor = ref({
      cancel: function cancel() {
      }
    });
    var goAlign = function goAlign2() {
      var target = props2.target;
      var element = getElement(target);
      var point = getPoint(target);
      if (nodeRef.value !== sourceResizeMonitor.value.element) {
        sourceResizeMonitor.value.cancel();
        sourceResizeMonitor.value.element = nodeRef.value;
        sourceResizeMonitor.value.cancel = monitorResize(nodeRef.value, _forceAlign);
      }
      if (cacheRef.value.element !== element || !isSamePoint(cacheRef.value.point, point) || !isEqual(cacheRef.value.align, props2.align)) {
        _forceAlign();
        if (resizeMonitor.value.element !== element) {
          resizeMonitor.value.cancel();
          resizeMonitor.value.element = element;
          resizeMonitor.value.cancel = monitorResize(element, _forceAlign);
        }
      }
    };
    onMounted(function() {
      nextTick(function() {
        goAlign();
      });
    });
    onUpdated(function() {
      nextTick(function() {
        goAlign();
      });
    });
    watch(function() {
      return props2.disabled;
    }, function(disabled) {
      if (!disabled) {
        _forceAlign();
      } else {
        cancelForceAlign();
      }
    }, {
      immediate: true,
      flush: "post"
    });
    var winResizeRef = ref(null);
    watch(function() {
      return props2.monitorWindowResize;
    }, function(monitorWindowResize) {
      if (monitorWindowResize) {
        if (!winResizeRef.value) {
          winResizeRef.value = addEventListenerWrap(window, "resize", _forceAlign);
        }
      } else if (winResizeRef.value) {
        winResizeRef.value.remove();
        winResizeRef.value = null;
      }
    }, {
      flush: "post"
    });
    onUnmounted(function() {
      resizeMonitor.value.cancel();
      sourceResizeMonitor.value.cancel();
      if (winResizeRef.value)
        winResizeRef.value.remove();
      cancelForceAlign();
    });
    expose({
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    });
    return function() {
      var child = slots === null || slots === void 0 ? void 0 : slots.default();
      if (child) {
        return cloneElement(child[0], {
          ref: nodeRef
        }, true, true);
      }
      return null;
    };
  }
});
var PopupInner = defineComponent({
  name: "PopupInner",
  inheritAttrs: false,
  props: innerProps,
  emits: ["mouseenter", "mouseleave", "mousedown", "touchstart", "align"],
  setup: function setup9(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs, slots = _ref.slots;
    var alignRef = ref();
    var elementRef = ref();
    var alignedClassName = ref();
    var _useStretchStyle = useStretchStyle(toRef(props2, "stretch")), _useStretchStyle2 = _slicedToArray$2(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    var doMeasure = function doMeasure2() {
      if (props2.stretch) {
        measureStretchStyle(props2.getRootDomNode());
      }
    };
    var visible = ref(false);
    var timeoutId;
    watch(function() {
      return props2.visible;
    }, function(val) {
      clearTimeout(timeoutId);
      if (val) {
        timeoutId = setTimeout(function() {
          visible.value = props2.visible;
        });
      } else {
        visible.value = false;
      }
    }, {
      immediate: true
    });
    var _useVisibleStatus = useVisibleStatus(visible, doMeasure), _useVisibleStatus2 = _slicedToArray$2(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1];
    var prepareResolveRef = ref();
    var getAlignTarget = function getAlignTarget2() {
      if (props2.point) {
        return props2.point;
      }
      return props2.getRootDomNode;
    };
    var forceAlign = function forceAlign2() {
      var _a;
      (_a = alignRef.value) === null || _a === void 0 ? void 0 : _a.forceAlign();
    };
    var onInternalAlign = function onInternalAlign2(popupDomNode, matchAlign) {
      var _a;
      var nextAlignedClassName = props2.getClassNameFromAlign(matchAlign);
      var preAlignedClassName = alignedClassName.value;
      if (alignedClassName.value !== nextAlignedClassName) {
        alignedClassName.value = nextAlignedClassName;
      }
      if (status.value === "align") {
        if (preAlignedClassName !== nextAlignedClassName) {
          Promise.resolve().then(function() {
            forceAlign();
          });
        } else {
          goNextStatus(function() {
            var _a2;
            (_a2 = prepareResolveRef.value) === null || _a2 === void 0 ? void 0 : _a2.call(prepareResolveRef);
          });
        }
        (_a = props2.onAlign) === null || _a === void 0 ? void 0 : _a.call(props2, popupDomNode, matchAlign);
      }
    };
    var motion = computed(function() {
      var m2 = _typeof$1(props2.animation) === "object" ? props2.animation : getMotion(props2);
      ["onAfterEnter", "onAfterLeave"].forEach(function(eventName) {
        var originFn = m2[eventName];
        m2[eventName] = function(node) {
          goNextStatus();
          status.value = "stable";
          originFn === null || originFn === void 0 ? void 0 : originFn(node);
        };
      });
      return m2;
    });
    var onShowPrepare = function onShowPrepare2() {
      return new Promise(function(resolve) {
        prepareResolveRef.value = resolve;
      });
    };
    watch([motion, status], function() {
      if (!motion.value && status.value === "motion") {
        goNextStatus();
      }
    }, {
      immediate: true
    });
    expose({
      forceAlign,
      getElement: function getElement2() {
        return elementRef.value.$el || elementRef.value;
      }
    });
    var alignDisabled = computed(function() {
      var _a;
      if (((_a = props2.align) === null || _a === void 0 ? void 0 : _a.points) && (status.value === "align" || status.value === "stable")) {
        return false;
      }
      return true;
    });
    return function() {
      var _a;
      var zIndex = props2.zIndex, align = props2.align, prefixCls = props2.prefixCls, destroyPopupOnHide = props2.destroyPopupOnHide, onMouseenter2 = props2.onMouseenter, onMouseleave2 = props2.onMouseleave, _props$onTouchstart = props2.onTouchstart, onTouchstart2 = _props$onTouchstart === void 0 ? function() {
      } : _props$onTouchstart, onMousedown2 = props2.onMousedown;
      var statusValue = status.value;
      var mergedStyle = [_extends(_extends({}, stretchStyle.value), {
        zIndex,
        opacity: statusValue === "motion" || statusValue === "stable" || !visible.value ? null : 0,
        pointerEvents: !visible.value && statusValue !== "stable" ? "none" : null
      }), attrs.style];
      var childNode = flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots, {
        visible: props2.visible
      }));
      if (childNode.length > 1) {
        childNode = createVNode("div", {
          "class": "".concat(prefixCls, "-content")
        }, [childNode]);
      }
      var mergedClassName = classNames(prefixCls, attrs.class, alignedClassName.value);
      var hasAnimate = visible.value || !props2.visible;
      var transitionProps = hasAnimate ? getTransitionProps(motion.value.name, motion.value) : {};
      return createVNode(Transition, _objectSpread2$1(_objectSpread2$1({
        "ref": elementRef
      }, transitionProps), {}, {
        "onBeforeEnter": onShowPrepare
      }), {
        default: function _default3() {
          return !destroyPopupOnHide || props2.visible ? withDirectives(createVNode(Align, {
            "target": getAlignTarget(),
            "key": "popup",
            "ref": alignRef,
            "monitorWindowResize": true,
            "disabled": alignDisabled.value,
            "align": align,
            "onAlign": onInternalAlign
          }, {
            default: function _default4() {
              return createVNode("div", _objectSpread2$1(_objectSpread2$1({
                "class": mergedClassName,
                "onMouseenter": onMouseenter2,
                "onMouseleave": onMouseleave2,
                "onMousedown": withModifiers(onMousedown2, ["capture"])
              }, _defineProperty$m({}, supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart", withModifiers(onTouchstart2, ["capture"]))), {}, {
                "style": mergedStyle
              }), [childNode]);
            }
          }), [[vShow, visible.value]]) : null;
        }
      });
    };
  }
});
var Popup = defineComponent({
  name: "Popup",
  inheritAttrs: false,
  props: popupProps,
  setup: function setup10(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots, expose = _ref.expose;
    var innerVisible = ref(false);
    var inMobile = ref(false);
    var popupRef = ref();
    watch([function() {
      return props2.visible;
    }, function() {
      return props2.mobile;
    }], function() {
      innerVisible.value = props2.visible;
      if (props2.visible && props2.mobile) {
        inMobile.value = true;
      }
    }, {
      immediate: true,
      flush: "post"
    });
    expose({
      forceAlign: function forceAlign() {
        var _a;
        (_a = popupRef.value) === null || _a === void 0 ? void 0 : _a.forceAlign();
      },
      getElement: function getElement2() {
        var _a;
        return (_a = popupRef.value) === null || _a === void 0 ? void 0 : _a.getElement();
      }
    });
    return function() {
      var cloneProps = _extends(_extends(_extends({}, props2), attrs), {
        visible: innerVisible.value
      });
      var popupNode = inMobile.value ? createVNode(MobilePopupInner, _objectSpread2$1(_objectSpread2$1({}, cloneProps), {}, {
        "mobile": props2.mobile,
        "ref": popupRef
      }), {
        default: slots.default
      }) : createVNode(PopupInner, _objectSpread2$1(_objectSpread2$1({}, cloneProps), {}, {
        "ref": popupRef
      }), {
        default: slots.default
      });
      return createVNode("div", null, [createVNode(Mask$1, cloneProps, null), popupNode]);
    };
  }
});
function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return _extends(_extends({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements2 = Object.keys(builtinPlacements);
  for (var i = 0; i < placements2.length; i += 1) {
    var placement = placements2[i];
    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return "";
}
var BaseMixin = {
  methods: {
    setState: function setState() {
      var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : void 0;
      var newState = typeof state === "function" ? state(this.$data, this.$props) : state;
      if (this.getDerivedStateFromProps) {
        var s2 = this.getDerivedStateFromProps(getOptionProps(this), _extends(_extends({}, this.$data), newState));
        if (s2 === null) {
          return;
        } else {
          newState = _extends(_extends({}, newState), s2 || {});
        }
      }
      _extends(this.$data, newState);
      if (this._.isMounted) {
        this.$forceUpdate();
      }
      nextTick(function() {
        callback && callback();
      });
    },
    __emit: function __emit() {
      var args = [].slice.call(arguments, 0);
      var eventName = args[0];
      eventName = "on".concat(eventName[0].toUpperCase()).concat(eventName.substring(1));
      var event = this.$props[eventName] || this.$attrs[eventName];
      if (args.length && event) {
        if (Array.isArray(event)) {
          for (var i = 0, l2 = event.length; i < l2; i++) {
            event[i].apply(event, _toConsumableArray(args.slice(1)));
          }
        } else {
          event.apply(void 0, _toConsumableArray(args.slice(1)));
        }
      }
    }
  }
};
var TriggerContextKey = Symbol("TriggerContextKey");
var useInjectTrigger = function useInjectTrigger2() {
  return inject(TriggerContextKey, {
    setPortal: function setPortal() {
    },
    popPortal: false
  });
};
var PortalContextKey = Symbol("PortalContextKey");
var useProvidePortal = function useProvidePortal2(instance) {
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    inTriggerContext: true
  };
  provide(PortalContextKey, {
    inTriggerContext: config.inTriggerContext,
    shouldRender: computed(function() {
      var _ref = instance || {}, sPopupVisible = _ref.sPopupVisible, popupRef = _ref.popupRef, forceRender = _ref.forceRender, autoDestroy = _ref.autoDestroy;
      var shouldRender = false;
      if (sPopupVisible || popupRef || forceRender) {
        shouldRender = true;
      }
      if (!sPopupVisible && autoDestroy) {
        shouldRender = false;
      }
      return shouldRender;
    })
  });
};
var useInjectPortal = function useInjectPortal2() {
  useProvidePortal({}, {
    inTriggerContext: false
  });
  var portalContext = inject(PortalContextKey, {
    shouldRender: computed(function() {
      return false;
    }),
    inTriggerContext: false
  });
  return {
    shouldRender: computed(function() {
      return portalContext.shouldRender.value || portalContext.inTriggerContext === false;
    })
  };
};
var Portal$1 = defineComponent({
  name: "Portal",
  inheritAttrs: false,
  props: {
    getContainer: PropTypes$1.func.isRequired,
    didUpdate: Function
  },
  setup: function setup11(props2, _ref) {
    var slots = _ref.slots;
    var isSSR = true;
    var container;
    var _useInjectPortal = useInjectPortal(), shouldRender = _useInjectPortal.shouldRender;
    onBeforeMount(function() {
      isSSR = false;
      if (shouldRender.value) {
        container = props2.getContainer();
      }
    });
    var stopWatch = watch(shouldRender, function() {
      if (shouldRender.value && !container) {
        container = props2.getContainer();
      }
      if (container) {
        stopWatch();
      }
    });
    onUpdated(function() {
      nextTick(function() {
        var _a;
        if (shouldRender.value) {
          (_a = props2.didUpdate) === null || _a === void 0 ? void 0 : _a.call(props2, props2);
        }
      });
    });
    onBeforeUnmount(function() {
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    });
    return function() {
      var _a;
      if (!shouldRender.value)
        return null;
      if (isSSR) {
        return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
      }
      return container ? createVNode(Teleport, {
        "to": container
      }, slots) : null;
    };
  }
});
function noop$2() {
}
function returnEmptyString() {
  return "";
}
function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }
  return window.document;
}
var ALL_HANDLERS = ["onClick", "onMousedown", "onTouchstart", "onMouseenter", "onMouseleave", "onFocus", "onBlur", "onContextmenu"];
var Trigger = defineComponent({
  name: "Trigger",
  mixins: [BaseMixin],
  inheritAttrs: false,
  props: {
    action: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]).def([]),
    showAction: PropTypes$1.any.def([]),
    hideAction: PropTypes$1.any.def([]),
    getPopupClassNameFromAlign: PropTypes$1.any.def(returnEmptyString),
    onPopupVisibleChange: Function,
    afterPopupVisibleChange: PropTypes$1.func.def(noop$2),
    popup: PropTypes$1.any,
    popupStyle: {
      type: Object,
      default: void 0
    },
    prefixCls: PropTypes$1.string.def("rc-trigger-popup"),
    popupClassName: PropTypes$1.string.def(""),
    popupPlacement: String,
    builtinPlacements: PropTypes$1.object,
    popupTransitionName: String,
    popupAnimation: PropTypes$1.any,
    mouseEnterDelay: PropTypes$1.number.def(0),
    mouseLeaveDelay: PropTypes$1.number.def(0.1),
    zIndex: Number,
    focusDelay: PropTypes$1.number.def(0),
    blurDelay: PropTypes$1.number.def(0.15),
    getPopupContainer: Function,
    getDocument: PropTypes$1.func.def(returnDocument),
    forceRender: {
      type: Boolean,
      default: void 0
    },
    destroyPopupOnHide: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: false
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    popupAlign: PropTypes$1.object.def(function() {
      return {};
    }),
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    defaultPopupVisible: {
      type: Boolean,
      default: false
    },
    maskTransitionName: String,
    maskAnimation: String,
    stretch: String,
    alignPoint: {
      type: Boolean,
      default: void 0
    },
    autoDestroy: {
      type: Boolean,
      default: false
    },
    mobile: Object,
    getTriggerDOMNode: Function
  },
  setup: function setup12(props2) {
    var align = computed(function() {
      var popupPlacement = props2.popupPlacement, popupAlign = props2.popupAlign, builtinPlacements = props2.builtinPlacements;
      if (popupPlacement && builtinPlacements) {
        return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
      }
      return popupAlign;
    });
    var _useInjectTrigger = useInjectTrigger(), setPortal = _useInjectTrigger.setPortal, popPortal = _useInjectTrigger.popPortal;
    var popupRef = ref(null);
    var setPopupRef = function setPopupRef2(val) {
      popupRef.value = val;
    };
    return {
      popPortal,
      setPortal,
      vcTriggerContext: inject("vcTriggerContext", {}),
      popupRef,
      setPopupRef,
      triggerRef: ref(null),
      align,
      focusTime: null,
      clickOutsideHandler: null,
      contextmenuOutsideHandler1: null,
      contextmenuOutsideHandler2: null,
      touchOutsideHandler: null,
      attachId: null,
      delayTimer: null,
      hasPopupMouseDown: false,
      preClickTime: null,
      preTouchTime: null,
      mouseDownTimeout: null,
      childOriginEvents: {}
    };
  },
  data: function data() {
    var _this = this;
    var _a, _b;
    var props2 = this.$props;
    var popupVisible2;
    if (this.popupVisible !== void 0) {
      popupVisible2 = !!props2.popupVisible;
    } else {
      popupVisible2 = !!props2.defaultPopupVisible;
    }
    ALL_HANDLERS.forEach(function(h2) {
      _this["fire".concat(h2)] = function(e2) {
        _this.fireEvents(h2, e2);
      };
    });
    (_b = (_a = this).setPortal) === null || _b === void 0 ? void 0 : _b.call(_a, createVNode(Portal$1, {
      "key": "portal",
      "getContainer": this.getContainer,
      "didUpdate": this.handlePortalUpdate
    }, {
      default: this.getComponent
    }));
    return {
      prevPopupVisible: popupVisible2,
      sPopupVisible: popupVisible2,
      point: null
    };
  },
  watch: {
    popupVisible: function popupVisible(val) {
      if (val !== void 0) {
        this.prevPopupVisible = this.sPopupVisible;
        this.sPopupVisible = val;
      }
    }
  },
  created: function created() {
    provide("vcTriggerContext", {
      onPopupMouseDown: this.onPopupMouseDown
    });
    useProvidePortal(this);
  },
  deactivated: function deactivated() {
    this.setPopupVisible(false);
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function() {
      _this2.updatedCal();
    });
  },
  updated: function updated() {
    var _this3 = this;
    this.$nextTick(function() {
      _this3.updatedCal();
    });
  },
  beforeUnmount: function beforeUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
    wrapperRaf.cancel(this.attachId);
  },
  methods: {
    updatedCal: function updatedCal() {
      var props2 = this.$props;
      var state = this.$data;
      if (state.sPopupVisible) {
        var currentDocument;
        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextmenuToShow())) {
          currentDocument = props2.getDocument(this.getRootDomNode());
          this.clickOutsideHandler = addEventListenerWrap(currentDocument, "mousedown", this.onDocumentClick);
        }
        if (!this.touchOutsideHandler) {
          currentDocument = currentDocument || props2.getDocument(this.getRootDomNode());
          this.touchOutsideHandler = addEventListenerWrap(currentDocument, "touchstart", this.onDocumentClick, supportsPassive$1 ? {
            passive: false
          } : false);
        }
        if (!this.contextmenuOutsideHandler1 && this.isContextmenuToShow()) {
          currentDocument = currentDocument || props2.getDocument(this.getRootDomNode());
          this.contextmenuOutsideHandler1 = addEventListenerWrap(currentDocument, "scroll", this.onContextmenuClose);
        }
        if (!this.contextmenuOutsideHandler2 && this.isContextmenuToShow()) {
          this.contextmenuOutsideHandler2 = addEventListenerWrap(window, "blur", this.onContextmenuClose);
        }
      } else {
        this.clearOutsideHandler();
      }
    },
    onMouseenter: function onMouseenter(e2) {
      var mouseEnterDelay = this.$props.mouseEnterDelay;
      this.fireEvents("onMouseenter", e2);
      this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e2);
    },
    onMouseMove: function onMouseMove(e2) {
      this.fireEvents("onMousemove", e2);
      this.setPoint(e2);
    },
    onMouseleave: function onMouseleave(e2) {
      this.fireEvents("onMouseleave", e2);
      this.delaySetPopupVisible(false, this.$props.mouseLeaveDelay);
    },
    onPopupMouseenter: function onPopupMouseenter() {
      this.clearDelayTimer();
    },
    onPopupMouseleave: function onPopupMouseleave(e2) {
      var _a;
      if (e2 && e2.relatedTarget && !e2.relatedTarget.setTimeout && contains((_a = this.popupRef) === null || _a === void 0 ? void 0 : _a.getElement(), e2.relatedTarget)) {
        return;
      }
      this.delaySetPopupVisible(false, this.$props.mouseLeaveDelay);
    },
    onFocus: function onFocus(e2) {
      this.fireEvents("onFocus", e2);
      this.clearDelayTimer();
      if (this.isFocusToShow()) {
        this.focusTime = Date.now();
        this.delaySetPopupVisible(true, this.$props.focusDelay);
      }
    },
    onMousedown: function onMousedown(e2) {
      this.fireEvents("onMousedown", e2);
      this.preClickTime = Date.now();
    },
    onTouchstart: function onTouchstart(e2) {
      this.fireEvents("onTouchstart", e2);
      this.preTouchTime = Date.now();
    },
    onBlur: function onBlur(e2) {
      if (!contains(e2.target, e2.relatedTarget || document.activeElement)) {
        this.fireEvents("onBlur", e2);
        this.clearDelayTimer();
        if (this.isBlurToHide()) {
          this.delaySetPopupVisible(false, this.$props.blurDelay);
        }
      }
    },
    onContextmenu: function onContextmenu(e2) {
      e2.preventDefault();
      this.fireEvents("onContextmenu", e2);
      this.setPopupVisible(true, e2);
    },
    onContextmenuClose: function onContextmenuClose() {
      if (this.isContextmenuToShow()) {
        this.close();
      }
    },
    onClick: function onClick(event) {
      this.fireEvents("onClick", event);
      if (this.focusTime) {
        var preTime;
        if (this.preClickTime && this.preTouchTime) {
          preTime = Math.min(this.preClickTime, this.preTouchTime);
        } else if (this.preClickTime) {
          preTime = this.preClickTime;
        } else if (this.preTouchTime) {
          preTime = this.preTouchTime;
        }
        if (Math.abs(preTime - this.focusTime) < 20) {
          return;
        }
        this.focusTime = 0;
      }
      this.preClickTime = 0;
      this.preTouchTime = 0;
      if (this.isClickToShow() && (this.isClickToHide() || this.isBlurToHide()) && event && event.preventDefault) {
        event.preventDefault();
      }
      if (event && event.domEvent) {
        event.domEvent.preventDefault();
      }
      var nextVisible = !this.$data.sPopupVisible;
      if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
        this.setPopupVisible(!this.$data.sPopupVisible, event);
      }
    },
    onPopupMouseDown: function onPopupMouseDown() {
      var _this4 = this;
      var _this$vcTriggerContex = this.vcTriggerContext, vcTriggerContext = _this$vcTriggerContex === void 0 ? {} : _this$vcTriggerContex;
      this.hasPopupMouseDown = true;
      clearTimeout(this.mouseDownTimeout);
      this.mouseDownTimeout = setTimeout(function() {
        _this4.hasPopupMouseDown = false;
      }, 0);
      if (vcTriggerContext.onPopupMouseDown) {
        vcTriggerContext.onPopupMouseDown.apply(vcTriggerContext, arguments);
      }
    },
    onDocumentClick: function onDocumentClick(event) {
      if (this.$props.mask && !this.$props.maskClosable) {
        return;
      }
      var target = event.target;
      var root2 = this.getRootDomNode();
      var popupNode = this.getPopupDomNode();
      if ((!contains(root2, target) || this.isContextMenuOnly()) && !contains(popupNode, target) && !this.hasPopupMouseDown) {
        this.delaySetPopupVisible(false, 0.1);
      }
    },
    getPopupDomNode: function getPopupDomNode() {
      var _a;
      return ((_a = this.popupRef) === null || _a === void 0 ? void 0 : _a.getElement()) || null;
    },
    getRootDomNode: function getRootDomNode() {
      var getTriggerDOMNode = this.$props.getTriggerDOMNode;
      if (getTriggerDOMNode) {
        var domNode = findDOMNode(this.triggerRef);
        return findDOMNode(getTriggerDOMNode(domNode));
      }
      try {
        var _domNode = findDOMNode(this.triggerRef);
        if (_domNode) {
          return _domNode;
        }
      } catch (err) {
      }
      return findDOMNode(this);
    },
    handleGetPopupClassFromAlign: function handleGetPopupClassFromAlign(align) {
      var className = [];
      var props2 = this.$props;
      var popupPlacement = props2.popupPlacement, builtinPlacements = props2.builtinPlacements, prefixCls = props2.prefixCls, alignPoint2 = props2.alignPoint, getPopupClassNameFromAlign = props2.getPopupClassNameFromAlign;
      if (popupPlacement && builtinPlacements) {
        className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint2));
      }
      if (getPopupClassNameFromAlign) {
        className.push(getPopupClassNameFromAlign(align));
      }
      return className.join(" ");
    },
    getPopupAlign: function getPopupAlign() {
      var props2 = this.$props;
      var popupPlacement = props2.popupPlacement, popupAlign = props2.popupAlign, builtinPlacements = props2.builtinPlacements;
      if (popupPlacement && builtinPlacements) {
        return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
      }
      return popupAlign;
    },
    getComponent: function getComponent$1() {
      var _this5 = this;
      var mouseProps = {};
      if (this.isMouseEnterToShow()) {
        mouseProps.onMouseenter = this.onPopupMouseenter;
      }
      if (this.isMouseLeaveToHide()) {
        mouseProps.onMouseleave = this.onPopupMouseleave;
      }
      mouseProps.onMousedown = this.onPopupMouseDown;
      mouseProps[supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart"] = this.onPopupMouseDown;
      var handleGetPopupClassFromAlign2 = this.handleGetPopupClassFromAlign, getRootDomNode2 = this.getRootDomNode, getContainer4 = this.getContainer, $attrs = this.$attrs;
      var _this$$props = this.$props, prefixCls = _this$$props.prefixCls, destroyPopupOnHide = _this$$props.destroyPopupOnHide, popupClassName = _this$$props.popupClassName, popupAnimation = _this$$props.popupAnimation, popupTransitionName = _this$$props.popupTransitionName, popupStyle = _this$$props.popupStyle, mask = _this$$props.mask, maskAnimation = _this$$props.maskAnimation, maskTransitionName = _this$$props.maskTransitionName, zIndex = _this$$props.zIndex, stretch = _this$$props.stretch, alignPoint2 = _this$$props.alignPoint, mobile = _this$$props.mobile, forceRender = _this$$props.forceRender;
      var _this$$data = this.$data, sPopupVisible = _this$$data.sPopupVisible, point = _this$$data.point;
      var popupProps2 = _extends(_extends({
        prefixCls,
        destroyPopupOnHide,
        visible: sPopupVisible,
        point: alignPoint2 ? point : null,
        align: this.align,
        animation: popupAnimation,
        getClassNameFromAlign: handleGetPopupClassFromAlign2,
        stretch,
        getRootDomNode: getRootDomNode2,
        mask,
        zIndex,
        transitionName: popupTransitionName,
        maskAnimation,
        maskTransitionName,
        getContainer: getContainer4,
        class: popupClassName,
        style: popupStyle,
        onAlign: $attrs.onPopupAlign || noop$2
      }, mouseProps), {
        ref: this.setPopupRef,
        mobile,
        forceRender
      });
      return createVNode(Popup, popupProps2, {
        default: this.$slots.popup || function() {
          return getComponent(_this5, "popup");
        }
      });
    },
    attachParent: function attachParent(popupContainer) {
      var _this6 = this;
      wrapperRaf.cancel(this.attachId);
      var _this$$props2 = this.$props, getPopupContainer = _this$$props2.getPopupContainer, getDocument2 = _this$$props2.getDocument;
      var domNode = this.getRootDomNode();
      var mountNode;
      if (!getPopupContainer) {
        mountNode = getDocument2(this.getRootDomNode()).body;
      } else if (domNode || getPopupContainer.length === 0) {
        mountNode = getPopupContainer(domNode);
      }
      if (mountNode) {
        mountNode.appendChild(popupContainer);
      } else {
        this.attachId = wrapperRaf(function() {
          _this6.attachParent(popupContainer);
        });
      }
    },
    getContainer: function getContainer3() {
      var props2 = this.$props;
      var getDocument2 = props2.getDocument;
      var popupContainer = getDocument2(this.getRootDomNode()).createElement("div");
      popupContainer.style.position = "absolute";
      popupContainer.style.top = "0";
      popupContainer.style.left = "0";
      popupContainer.style.width = "100%";
      this.attachParent(popupContainer);
      return popupContainer;
    },
    setPopupVisible: function setPopupVisible(sPopupVisible, event) {
      var alignPoint2 = this.alignPoint, prevPopupVisible = this.sPopupVisible, onPopupVisibleChange = this.onPopupVisibleChange;
      this.clearDelayTimer();
      if (prevPopupVisible !== sPopupVisible) {
        if (!hasProp(this, "popupVisible")) {
          this.setState({
            sPopupVisible,
            prevPopupVisible
          });
        }
        onPopupVisibleChange && onPopupVisibleChange(sPopupVisible);
      }
      if (alignPoint2 && event && sPopupVisible) {
        this.setPoint(event);
      }
    },
    setPoint: function setPoint(point) {
      var alignPoint2 = this.$props.alignPoint;
      if (!alignPoint2 || !point)
        return;
      this.setState({
        point: {
          pageX: point.pageX,
          pageY: point.pageY
        }
      });
    },
    handlePortalUpdate: function handlePortalUpdate() {
      if (this.prevPopupVisible !== this.sPopupVisible) {
        this.afterPopupVisibleChange(this.sPopupVisible);
      }
    },
    delaySetPopupVisible: function delaySetPopupVisible(visible, delayS, event) {
      var _this7 = this;
      var delay = delayS * 1e3;
      this.clearDelayTimer();
      if (delay) {
        var point = event ? {
          pageX: event.pageX,
          pageY: event.pageY
        } : null;
        this.delayTimer = requestAnimationTimeout(function() {
          _this7.setPopupVisible(visible, point);
          _this7.clearDelayTimer();
        }, delay);
      } else {
        this.setPopupVisible(visible, event);
      }
    },
    clearDelayTimer: function clearDelayTimer() {
      if (this.delayTimer) {
        cancelAnimationTimeout(this.delayTimer);
        this.delayTimer = null;
      }
    },
    clearOutsideHandler: function clearOutsideHandler() {
      if (this.clickOutsideHandler) {
        this.clickOutsideHandler.remove();
        this.clickOutsideHandler = null;
      }
      if (this.contextmenuOutsideHandler1) {
        this.contextmenuOutsideHandler1.remove();
        this.contextmenuOutsideHandler1 = null;
      }
      if (this.contextmenuOutsideHandler2) {
        this.contextmenuOutsideHandler2.remove();
        this.contextmenuOutsideHandler2 = null;
      }
      if (this.touchOutsideHandler) {
        this.touchOutsideHandler.remove();
        this.touchOutsideHandler = null;
      }
    },
    createTwoChains: function createTwoChains(event) {
      var fn = function fn2() {
      };
      var events = getEvents(this);
      if (this.childOriginEvents[event] && events[event]) {
        return this["fire".concat(event)];
      }
      fn = this.childOriginEvents[event] || events[event] || fn;
      return fn;
    },
    isClickToShow: function isClickToShow() {
      var _this$$props3 = this.$props, action = _this$$props3.action, showAction = _this$$props3.showAction;
      return action.indexOf("click") !== -1 || showAction.indexOf("click") !== -1;
    },
    isContextMenuOnly: function isContextMenuOnly() {
      var action = this.$props.action;
      return action === "contextmenu" || action.length === 1 && action[0] === "contextmenu";
    },
    isContextmenuToShow: function isContextmenuToShow() {
      var _this$$props4 = this.$props, action = _this$$props4.action, showAction = _this$$props4.showAction;
      return action.indexOf("contextmenu") !== -1 || showAction.indexOf("contextmenu") !== -1;
    },
    isClickToHide: function isClickToHide() {
      var _this$$props5 = this.$props, action = _this$$props5.action, hideAction = _this$$props5.hideAction;
      return action.indexOf("click") !== -1 || hideAction.indexOf("click") !== -1;
    },
    isMouseEnterToShow: function isMouseEnterToShow() {
      var _this$$props6 = this.$props, action = _this$$props6.action, showAction = _this$$props6.showAction;
      return action.indexOf("hover") !== -1 || showAction.indexOf("mouseenter") !== -1;
    },
    isMouseLeaveToHide: function isMouseLeaveToHide() {
      var _this$$props7 = this.$props, action = _this$$props7.action, hideAction = _this$$props7.hideAction;
      return action.indexOf("hover") !== -1 || hideAction.indexOf("mouseleave") !== -1;
    },
    isFocusToShow: function isFocusToShow() {
      var _this$$props8 = this.$props, action = _this$$props8.action, showAction = _this$$props8.showAction;
      return action.indexOf("focus") !== -1 || showAction.indexOf("focus") !== -1;
    },
    isBlurToHide: function isBlurToHide() {
      var _this$$props9 = this.$props, action = _this$$props9.action, hideAction = _this$$props9.hideAction;
      return action.indexOf("focus") !== -1 || hideAction.indexOf("blur") !== -1;
    },
    forcePopupAlign: function forcePopupAlign() {
      var _a;
      if (this.$data.sPopupVisible) {
        (_a = this.popupRef) === null || _a === void 0 ? void 0 : _a.forceAlign();
      }
    },
    fireEvents: function fireEvents(type, e2) {
      if (this.childOriginEvents[type]) {
        this.childOriginEvents[type](e2);
      }
      var event = this.$props[type] || this.$attrs[type];
      if (event) {
        event(e2);
      }
    },
    close: function close2() {
      this.setPopupVisible(false);
    }
  },
  render: function render2() {
    var _this8 = this;
    var $attrs = this.$attrs;
    var children = filterEmpty(getSlot(this));
    var alignPoint2 = this.$props.alignPoint;
    var child = children[0];
    this.childOriginEvents = getEvents(child);
    var newChildProps = {
      key: "trigger"
    };
    if (this.isContextmenuToShow()) {
      newChildProps.onContextmenu = this.onContextmenu;
    } else {
      newChildProps.onContextmenu = this.createTwoChains("onContextmenu");
    }
    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMousedown = this.onMousedown;
      newChildProps[supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart"] = this.onTouchstart;
    } else {
      newChildProps.onClick = this.createTwoChains("onClick");
      newChildProps.onMousedown = this.createTwoChains("onMousedown");
      newChildProps[supportsPassive$1 ? "onTouchstartPassive" : "onTouchstart"] = this.createTwoChains("onTouchstart");
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseenter = this.onMouseenter;
      if (alignPoint2) {
        newChildProps.onMousemove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseenter = this.createTwoChains("onMouseenter");
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseleave = this.onMouseleave;
    } else {
      newChildProps.onMouseleave = this.createTwoChains("onMouseleave");
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains("onFocus");
      newChildProps.onBlur = function(e2) {
        if (e2 && (!e2.relatedTarget || !contains(e2.target, e2.relatedTarget))) {
          _this8.createTwoChains("onBlur")(e2);
        }
      };
    }
    var childrenClassName = classNames(child && child.props && child.props.class, $attrs.class);
    if (childrenClassName) {
      newChildProps.class = childrenClassName;
    }
    var trigger2 = cloneElement(child, _extends(_extends({}, newChildProps), {
      ref: "triggerRef"
    }), true, true);
    if (this.popPortal) {
      return trigger2;
    } else {
      var portal = createVNode(Portal$1, {
        "key": "portal",
        "getContainer": this.getContainer,
        "didUpdate": this.handlePortalUpdate
      }, {
        default: this.getComponent
      });
      return createVNode(Fragment, null, [portal, trigger2]);
    }
  }
});
var __rest$f = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var getBuiltInPlacements = function getBuiltInPlacements2(dropdownMatchSelectWidth) {
  var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      }
    }
  };
};
var SelectTrigger = defineComponent({
  name: "SelectTrigger",
  inheritAttrs: false,
  props: {
    dropdownAlign: Object,
    visible: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    dropdownClassName: String,
    dropdownStyle: PropTypes$1.object,
    placement: String,
    empty: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    popupClassName: String,
    animation: String,
    transitionName: String,
    getPopupContainer: Function,
    dropdownRender: Function,
    containerWidth: Number,
    dropdownMatchSelectWidth: PropTypes$1.oneOfType([Number, Boolean]).def(true),
    popupElement: PropTypes$1.any,
    direction: String,
    getTriggerDOMNode: Function,
    onPopupVisibleChange: Function,
    onPopupMouseEnter: Function
  },
  setup: function setup13(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var builtInPlacements = computed(function() {
      var dropdownMatchSelectWidth = props2.dropdownMatchSelectWidth;
      return getBuiltInPlacements(dropdownMatchSelectWidth);
    });
    var popupRef = ref();
    expose({
      getPopupElement: function getPopupElement() {
        return popupRef.value;
      }
    });
    return function() {
      var _a = _extends(_extends({}, props2), attrs), _a$empty = _a.empty, empty = _a$empty === void 0 ? false : _a$empty, restProps = __rest$f(_a, ["empty"]);
      var visible = restProps.visible, dropdownAlign = restProps.dropdownAlign, prefixCls = restProps.prefixCls, popupElement = restProps.popupElement, dropdownClassName = restProps.dropdownClassName, dropdownStyle = restProps.dropdownStyle, _restProps$direction = restProps.direction, direction = _restProps$direction === void 0 ? "ltr" : _restProps$direction, placement = restProps.placement, dropdownMatchSelectWidth = restProps.dropdownMatchSelectWidth, containerWidth = restProps.containerWidth, dropdownRender = restProps.dropdownRender, animation = restProps.animation, transitionName2 = restProps.transitionName, getPopupContainer = restProps.getPopupContainer, getTriggerDOMNode = restProps.getTriggerDOMNode, onPopupVisibleChange = restProps.onPopupVisibleChange, onPopupMouseEnter = restProps.onPopupMouseEnter;
      var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
      var popupNode = popupElement;
      if (dropdownRender) {
        popupNode = dropdownRender({
          menuNode: popupElement,
          props: props2
        });
      }
      var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName2;
      var popupStyle = _extends({
        minWidth: "".concat(containerWidth, "px")
      }, dropdownStyle);
      if (typeof dropdownMatchSelectWidth === "number") {
        popupStyle.width = "".concat(dropdownMatchSelectWidth, "px");
      } else if (dropdownMatchSelectWidth) {
        popupStyle.width = "".concat(containerWidth, "px");
      }
      return createVNode(Trigger, _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
        "showAction": onPopupVisibleChange ? ["click"] : [],
        "hideAction": onPopupVisibleChange ? ["click"] : [],
        "popupPlacement": placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
        "builtinPlacements": builtInPlacements.value,
        "prefixCls": dropdownPrefixCls,
        "popupTransitionName": mergedTransitionName,
        "popupAlign": dropdownAlign,
        "popupVisible": visible,
        "getPopupContainer": getPopupContainer,
        "popupClassName": classNames(dropdownClassName, _defineProperty$m({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
        "popupStyle": popupStyle,
        "getTriggerDOMNode": getTriggerDOMNode,
        "onPopupVisibleChange": onPopupVisibleChange
      }), {
        default: slots.default,
        popup: function popup() {
          return createVNode("div", {
            "ref": popupRef,
            "onMouseenter": onPopupMouseEnter
          }, [popupNode]);
        }
      });
    };
  }
});
var SelectTrigger$1 = SelectTrigger;
var KeyCode = {
  MAC_ENTER: 3,
  BACKSPACE: 8,
  TAB: 9,
  NUM_CENTER: 12,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PRINT_SCREEN: 44,
  INSERT: 45,
  DELETE: 46,
  ZERO: 48,
  ONE: 49,
  TWO: 50,
  THREE: 51,
  FOUR: 52,
  FIVE: 53,
  SIX: 54,
  SEVEN: 55,
  EIGHT: 56,
  NINE: 57,
  QUESTION_MARK: 63,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90,
  META: 91,
  WIN_KEY_RIGHT: 92,
  CONTEXT_MENU: 93,
  NUM_ZERO: 96,
  NUM_ONE: 97,
  NUM_TWO: 98,
  NUM_THREE: 99,
  NUM_FOUR: 100,
  NUM_FIVE: 101,
  NUM_SIX: 102,
  NUM_SEVEN: 103,
  NUM_EIGHT: 104,
  NUM_NINE: 105,
  NUM_MULTIPLY: 106,
  NUM_PLUS: 107,
  NUM_MINUS: 109,
  NUM_PERIOD: 110,
  NUM_DIVISION: 111,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  NUMLOCK: 144,
  SEMICOLON: 186,
  DASH: 189,
  EQUALS: 187,
  COMMA: 188,
  PERIOD: 190,
  SLASH: 191,
  APOSTROPHE: 192,
  SINGLE_QUOTE: 222,
  OPEN_SQUARE_BRACKET: 219,
  BACKSLASH: 220,
  CLOSE_SQUARE_BRACKET: 221,
  WIN_KEY: 224,
  MAC_FF_META: 224,
  WIN_IME: 229,
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e2) {
    var keyCode = e2.keyCode;
    if (e2.altKey && !e2.ctrlKey || e2.metaKey || keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var KeyCode$1 = KeyCode;
var TransBtn = function TransBtn2(props2, _ref) {
  var slots = _ref.slots;
  var _a;
  var className = props2.class, customizeIcon = props2.customizeIcon, customizeIconProps = props2.customizeIconProps, _onMousedown = props2.onMousedown, onClick2 = props2.onClick;
  var icon;
  if (typeof customizeIcon === "function") {
    icon = customizeIcon(customizeIconProps);
  } else {
    icon = customizeIcon;
  }
  return createVNode("span", {
    "class": className,
    "onMousedown": function onMousedown2(event) {
      event.preventDefault();
      if (_onMousedown) {
        _onMousedown(event);
      }
    },
    "style": {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    "unselectable": "on",
    "onClick": onClick2,
    "aria-hidden": true
  }, [icon !== void 0 ? icon : createVNode("span", {
    "class": className.split(/\s+/).map(function(cls) {
      return "".concat(cls, "-icon");
    })
  }, [(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)])]);
};
TransBtn.inheritAttrs = false;
TransBtn.displayName = "TransBtn";
TransBtn.props = {
  class: String,
  customizeIcon: PropTypes$1.any,
  customizeIconProps: PropTypes$1.any,
  onMousedown: Function,
  onClick: Function
};
var TransBtn$1 = TransBtn;
function onCompositionStart(e2) {
  e2.target.composing = true;
}
function onCompositionEnd(e2) {
  if (!e2.target.composing)
    return;
  e2.target.composing = false;
  trigger(e2.target, "input");
}
function trigger(el, type) {
  var e2 = document.createEvent("HTMLEvents");
  e2.initEvent(type, true, true);
  el.dispatchEvent(e2);
}
function addEventListener$1(el, event, handler2, options) {
  el.addEventListener(event, handler2, options);
}
var antInput = {
  created: function created2(el, binding) {
    if (!binding.modifiers || !binding.modifiers.lazy) {
      addEventListener$1(el, "compositionstart", onCompositionStart);
      addEventListener$1(el, "compositionend", onCompositionEnd);
      addEventListener$1(el, "change", onCompositionEnd);
    }
  }
};
var antInputDirective = antInput;
var inputProps = {
  inputRef: PropTypes$1.any,
  prefixCls: String,
  id: String,
  inputElement: PropTypes$1.VueNode,
  disabled: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  editable: {
    type: Boolean,
    default: void 0
  },
  activeDescendantId: String,
  value: String,
  open: {
    type: Boolean,
    default: void 0
  },
  tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  attrs: PropTypes$1.object,
  onKeydown: {
    type: Function
  },
  onMousedown: {
    type: Function
  },
  onChange: {
    type: Function
  },
  onPaste: {
    type: Function
  },
  onCompositionstart: {
    type: Function
  },
  onCompositionend: {
    type: Function
  },
  onFocus: {
    type: Function
  },
  onBlur: {
    type: Function
  }
};
var Input = defineComponent({
  name: "Input",
  inheritAttrs: false,
  props: inputProps,
  setup: function setup14(props2) {
    var blurTimeout = null;
    var VCSelectContainerEvent = inject("VCSelectContainerEvent");
    return function() {
      var _a;
      var prefixCls = props2.prefixCls, id = props2.id, inputElement = props2.inputElement, disabled = props2.disabled, tabindex = props2.tabindex, autofocus = props2.autofocus, autocomplete = props2.autocomplete, editable = props2.editable, activeDescendantId = props2.activeDescendantId, value = props2.value, _onKeydown = props2.onKeydown, _onMousedown = props2.onMousedown, onChange = props2.onChange, onPaste = props2.onPaste, _onCompositionstart = props2.onCompositionstart, _onCompositionend = props2.onCompositionend, _onFocus = props2.onFocus, _onBlur = props2.onBlur, open2 = props2.open, inputRef = props2.inputRef, attrs = props2.attrs;
      var inputNode = inputElement || withDirectives(createVNode("input", null, null), [[antInputDirective]]);
      var inputProps2 = inputNode.props || {};
      var onOriginKeyDown = inputProps2.onKeydown, onOriginInput = inputProps2.onInput, onOriginFocus = inputProps2.onFocus, onOriginBlur = inputProps2.onBlur, onOriginMouseDown = inputProps2.onMousedown, onOriginCompositionStart = inputProps2.onCompositionstart, onOriginCompositionEnd = inputProps2.onCompositionend, style2 = inputProps2.style;
      inputNode = cloneElement(inputNode, _extends(_extends(_extends(_extends(_extends({
        type: "search"
      }, inputProps2), {
        id,
        ref: inputRef,
        disabled,
        tabindex,
        autocomplete: autocomplete || "off",
        autofocus,
        class: classNames("".concat(prefixCls, "-selection-search-input"), (_a = inputNode === null || inputNode === void 0 ? void 0 : inputNode.props) === null || _a === void 0 ? void 0 : _a.class),
        role: "combobox",
        "aria-expanded": open2,
        "aria-haspopup": "listbox",
        "aria-owns": "".concat(id, "_list"),
        "aria-autocomplete": "list",
        "aria-controls": "".concat(id, "_list"),
        "aria-activedescendant": activeDescendantId
      }), attrs), {
        value: editable ? value : "",
        readonly: !editable,
        unselectable: !editable ? "on" : null,
        style: _extends(_extends({}, style2), {
          opacity: editable ? null : 0
        }),
        onKeydown: function onKeydown(event) {
          _onKeydown(event);
          if (onOriginKeyDown) {
            onOriginKeyDown(event);
          }
        },
        onMousedown: function onMousedown2(event) {
          _onMousedown(event);
          if (onOriginMouseDown) {
            onOriginMouseDown(event);
          }
        },
        onInput: function onInput(event) {
          onChange(event);
          if (onOriginInput) {
            onOriginInput(event);
          }
        },
        onCompositionstart: function onCompositionstart(event) {
          _onCompositionstart(event);
          if (onOriginCompositionStart) {
            onOriginCompositionStart(event);
          }
        },
        onCompositionend: function onCompositionend(event) {
          _onCompositionend(event);
          if (onOriginCompositionEnd) {
            onOriginCompositionEnd(event);
          }
        },
        onPaste,
        onFocus: function onFocus2() {
          clearTimeout(blurTimeout);
          onOriginFocus && onOriginFocus(arguments.length <= 0 ? void 0 : arguments[0]);
          _onFocus && _onFocus(arguments.length <= 0 ? void 0 : arguments[0]);
          VCSelectContainerEvent === null || VCSelectContainerEvent === void 0 ? void 0 : VCSelectContainerEvent.focus(arguments.length <= 0 ? void 0 : arguments[0]);
        },
        onBlur: function onBlur2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          blurTimeout = setTimeout(function() {
            onOriginBlur && onOriginBlur(args[0]);
            _onBlur && _onBlur(args[0]);
            VCSelectContainerEvent === null || VCSelectContainerEvent === void 0 ? void 0 : VCSelectContainerEvent.blur(args[0]);
          }, 100);
        }
      }), inputNode.type === "textarea" ? {} : {
        type: "search"
      }), true, true);
      return inputNode;
    };
  }
});
var Input$1 = Input;
var attributes = "accept acceptcharset accesskey action allowfullscreen allowtransparency\nalt async autocomplete autofocus autoplay capture cellpadding cellspacing challenge\ncharset checked classid classname colspan cols content contenteditable contextmenu\ncontrols coords crossorigin data datetime default defer dir disabled download draggable\nenctype form formaction formenctype formmethod formnovalidate formtarget frameborder\nheaders height hidden high href hreflang htmlfor for httpequiv icon id inputmode integrity\nis keyparams keytype kind label lang list loop low manifest marginheight marginwidth max maxlength media\nmediagroup method min minlength multiple muted name novalidate nonce open\noptimum pattern placeholder poster preload radiogroup readonly rel required\nreversed role rowspan rows sandbox scope scoped scrolling seamless selected\nshape size sizes span spellcheck src srcdoc srclang srcset start step style\nsummary tabindex target title type usemap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionend onCompositionstart onCompositionupdate onKeydown\n    onKeypress onKeyup onFocus onBlur onChange onInput onSubmit onClick onContextmenu onDoubleclick onDblclick\n    onDrag onDragend onDragenter onDragexit onDragleave onDragover onDragstart onDrop onMousedown\n    onMouseenter onMouseleave onMousemove onMouseout onMouseover onMouseup onSelect onTouchcancel\n    onTouchend onTouchmove onTouchstart onTouchstartPassive onTouchmovePassive onScroll onWheel onAbort onCanplay onCanplaythrough\n    onDurationchange onEmptied onEncrypted onEnded onError onLoadeddata onLoadedmetadata\n    onLoadstart onPause onPlay onPlaying onProgress onRatechange onSeeked onSeeking onStalled onSuspend onTimeupdate onVolumechange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
var ariaPrefix = "aria-";
var dataPrefix = "data-";
function match(key2, prefix) {
  return key2.indexOf(prefix) === 0;
}
function pickAttrs(props2) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _extends({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props2).forEach(function(key2) {
    if (mergedConfig.aria && (key2 === "role" || match(key2, ariaPrefix)) || mergedConfig.data && match(key2, dataPrefix) || mergedConfig.attr && (propList.includes(key2) || propList.includes(key2.toLowerCase()))) {
      attrs[key2] = props2[key2];
    }
  });
  return attrs;
}
var OverflowContextProviderKey = Symbol("OverflowContextProviderKey");
var OverflowContextProvider = defineComponent({
  name: "OverflowContextProvider",
  inheritAttrs: false,
  props: {
    value: {
      type: Object
    }
  },
  setup: function setup15(props2, _ref) {
    var slots = _ref.slots;
    provide(OverflowContextProviderKey, computed(function() {
      return props2.value;
    }));
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
});
var useInjectOverflowContext = function useInjectOverflowContext2() {
  return inject(OverflowContextProviderKey, computed(function() {
    return null;
  }));
};
var __rest$e = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var UNDEFINED = void 0;
var Item$2 = defineComponent({
  name: "Item",
  props: {
    prefixCls: String,
    item: PropTypes$1.any,
    renderItem: Function,
    responsive: Boolean,
    itemKey: {
      type: [String, Number]
    },
    registerSize: Function,
    display: Boolean,
    order: Number,
    component: PropTypes$1.any,
    invalidate: Boolean
  },
  setup: function setup16(props2, _ref) {
    var slots = _ref.slots, expose = _ref.expose;
    var mergedHidden = computed(function() {
      return props2.responsive && !props2.display;
    });
    var itemNodeRef = ref();
    expose({
      itemNodeRef
    });
    function internalRegisterSize(width) {
      props2.registerSize(props2.itemKey, width);
    }
    onUnmounted(function() {
      internalRegisterSize(null);
    });
    return function() {
      var _a;
      var prefixCls = props2.prefixCls, invalidate = props2.invalidate, item = props2.item, renderItem = props2.renderItem, responsive = props2.responsive;
      props2.registerSize;
      props2.itemKey;
      props2.display;
      var order = props2.order, _props$component = props2.component, Component = _props$component === void 0 ? "div" : _props$component, restProps = __rest$e(props2, ["prefixCls", "invalidate", "item", "renderItem", "responsive", "registerSize", "itemKey", "display", "order", "component"]);
      var children = (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
      var childNode = renderItem && item !== UNDEFINED ? renderItem(item) : children;
      var overflowStyle;
      if (!invalidate) {
        overflowStyle = {
          opacity: mergedHidden.value ? 0 : 1,
          height: mergedHidden.value ? 0 : UNDEFINED,
          overflowY: mergedHidden.value ? "hidden" : UNDEFINED,
          order: responsive ? order : UNDEFINED,
          pointerEvents: mergedHidden.value ? "none" : UNDEFINED,
          position: mergedHidden.value ? "absolute" : UNDEFINED
        };
      }
      var overflowProps3 = {};
      if (mergedHidden.value) {
        overflowProps3["aria-hidden"] = true;
      }
      return createVNode(ResizeObserver, {
        "disabled": !responsive,
        "onResize": function onResize(_ref2) {
          var offsetWidth = _ref2.offsetWidth;
          internalRegisterSize(offsetWidth);
        }
      }, {
        default: function _default3() {
          return createVNode(Component, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
            "class": classNames(!invalidate && prefixCls),
            "style": overflowStyle
          }, overflowProps3), restProps), {}, {
            "ref": itemNodeRef
          }), {
            default: function _default4() {
              return [childNode];
            }
          });
        }
      });
    };
  }
});
var __rest$d = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var RawItem = defineComponent({
  name: "RawItem",
  inheritAttrs: false,
  props: {
    component: PropTypes$1.any,
    title: PropTypes$1.any,
    id: String,
    onMouseenter: {
      type: Function
    },
    onMouseleave: {
      type: Function
    },
    onClick: {
      type: Function
    },
    onKeydown: {
      type: Function
    },
    onFocus: {
      type: Function
    }
  },
  setup: function setup17(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var context = useInjectOverflowContext();
    return function() {
      var _a;
      if (!context.value) {
        var _props$component = props2.component, Component = _props$component === void 0 ? "div" : _props$component, _restProps = __rest$d(props2, ["component"]);
        return createVNode(Component, _objectSpread2$1(_objectSpread2$1({}, _restProps), attrs), {
          default: function _default3() {
            return [(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)];
          }
        });
      }
      var _b = context.value, contextClassName = _b.className, restContext = __rest$d(_b, ["className"]);
      var className = attrs.class, restProps = __rest$d(attrs, ["class"]);
      return createVNode(OverflowContextProvider, {
        "value": null
      }, {
        default: function _default3() {
          return [createVNode(Item$2, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
            "class": classNames(contextClassName, className)
          }, restContext), restProps), props2), slots)];
        }
      });
    };
  }
});
var __rest$c = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var RESPONSIVE = "responsive";
var INVALIDATE = "invalidate";
function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
var overflowProps = function overflowProps2() {
  return {
    id: String,
    prefixCls: String,
    data: Array,
    itemKey: [String, Number, Function],
    itemWidth: {
      type: Number,
      default: 10
    },
    renderItem: Function,
    renderRawItem: Function,
    maxCount: [Number, String],
    renderRest: Function,
    renderRawRest: Function,
    suffix: PropTypes$1.any,
    component: String,
    itemComponent: PropTypes$1.any,
    onVisibleChange: Function,
    ssr: String,
    onMousedown: Function
  };
};
var Overflow = defineComponent({
  name: "Overflow",
  inheritAttrs: false,
  props: overflowProps(),
  emits: ["visibleChange"],
  setup: function setup18(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots;
    var fullySSR = computed(function() {
      return props2.ssr === "full";
    });
    var containerWidth = ref(null);
    var mergedContainerWidth = computed(function() {
      return containerWidth.value || 0;
    });
    var itemWidths = ref(/* @__PURE__ */ new Map());
    var prevRestWidth = ref(0);
    var restWidth = ref(0);
    var suffixWidth = ref(0);
    var suffixFixedStart = ref(null);
    var displayCount = ref(null);
    var mergedDisplayCount = computed(function() {
      if (displayCount.value === null && fullySSR.value) {
        return Number.MAX_SAFE_INTEGER;
      }
      return displayCount.value || 0;
    });
    var restReady = ref(false);
    var itemPrefixCls = computed(function() {
      return "".concat(props2.prefixCls, "-item");
    });
    var mergedRestWidth = computed(function() {
      return Math.max(prevRestWidth.value, restWidth.value);
    });
    var isResponsive = computed(function() {
      return !!(props2.data.length && props2.maxCount === RESPONSIVE);
    });
    var invalidate = computed(function() {
      return props2.maxCount === INVALIDATE;
    });
    var showRest = computed(function() {
      return isResponsive.value || typeof props2.maxCount === "number" && props2.data.length > props2.maxCount;
    });
    var mergedData = computed(function() {
      var items = props2.data;
      if (isResponsive.value) {
        if (containerWidth.value === null && fullySSR.value) {
          items = props2.data;
        } else {
          items = props2.data.slice(0, Math.min(props2.data.length, mergedContainerWidth.value / props2.itemWidth));
        }
      } else if (typeof props2.maxCount === "number") {
        items = props2.data.slice(0, props2.maxCount);
      }
      return items;
    });
    var omittedItems = computed(function() {
      if (isResponsive.value) {
        return props2.data.slice(mergedDisplayCount.value + 1);
      }
      return props2.data.slice(mergedData.value.length);
    });
    var getKey2 = function getKey3(item, index2) {
      var _a, _b;
      if (typeof props2.itemKey === "function") {
        return props2.itemKey(item);
      }
      return (_b = props2.itemKey && ((_a = item) === null || _a === void 0 ? void 0 : _a[props2.itemKey])) !== null && _b !== void 0 ? _b : index2;
    };
    var mergedRenderItem = computed(function() {
      return props2.renderItem || function(item) {
        return item;
      };
    });
    var updateDisplayCount = function updateDisplayCount2(count, notReady) {
      displayCount.value = count;
      if (!notReady) {
        restReady.value = count < props2.data.length - 1;
        emit("visibleChange", count);
      }
    };
    var onOverflowResize = function onOverflowResize2(_2, element) {
      containerWidth.value = element.clientWidth;
    };
    var registerSize = function registerSize2(key2, width) {
      var clone2 = new Map(itemWidths.value);
      if (width === null) {
        clone2.delete(key2);
      } else {
        clone2.set(key2, width);
      }
      itemWidths.value = clone2;
    };
    var registerOverflowSize = function registerOverflowSize2(_2, width) {
      prevRestWidth.value = restWidth.value;
      restWidth.value = width;
    };
    var registerSuffixSize = function registerSuffixSize2(_2, width) {
      suffixWidth.value = width;
    };
    var getItemWidth = function getItemWidth2(index2) {
      return itemWidths.value.get(getKey2(mergedData.value[index2], index2));
    };
    watch([mergedContainerWidth, itemWidths, restWidth, suffixWidth, function() {
      return props2.itemKey;
    }, mergedData], function() {
      if (mergedContainerWidth.value && mergedRestWidth.value && mergedData.value) {
        var totalWidth = suffixWidth.value;
        var len = mergedData.value.length;
        var lastIndex = len - 1;
        if (!len) {
          updateDisplayCount(0);
          suffixFixedStart.value = null;
          return;
        }
        for (var i = 0; i < len; i += 1) {
          var currentItemWidth = getItemWidth(i);
          if (currentItemWidth === void 0) {
            updateDisplayCount(i - 1, true);
            break;
          }
          totalWidth += currentItemWidth;
          if (lastIndex === 0 && totalWidth <= mergedContainerWidth.value || i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth.value) {
            updateDisplayCount(lastIndex);
            suffixFixedStart.value = null;
            break;
          } else if (totalWidth + mergedRestWidth.value > mergedContainerWidth.value) {
            updateDisplayCount(i - 1);
            suffixFixedStart.value = totalWidth - currentItemWidth - suffixWidth.value + restWidth.value;
            break;
          }
        }
        if (props2.suffix && getItemWidth(0) + suffixWidth.value > mergedContainerWidth.value) {
          suffixFixedStart.value = null;
        }
      }
    });
    return function() {
      var displayRest = restReady.value && !!omittedItems.value.length;
      var itemComponent = props2.itemComponent, renderRawItem = props2.renderRawItem, renderRawRest = props2.renderRawRest, renderRest = props2.renderRest, _props$prefixCls = props2.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, suffix = props2.suffix, _props$component = props2.component, Component = _props$component === void 0 ? "div" : _props$component, id = props2.id, onMousedown2 = props2.onMousedown;
      var className = attrs.class, style2 = attrs.style, restAttrs = __rest$c(attrs, ["class", "style"]);
      var suffixStyle = {};
      if (suffixFixedStart.value !== null && isResponsive.value) {
        suffixStyle = {
          position: "absolute",
          left: "".concat(suffixFixedStart.value, "px"),
          top: 0
        };
      }
      var itemSharedProps = {
        prefixCls: itemPrefixCls.value,
        responsive: isResponsive.value,
        component: itemComponent,
        invalidate: invalidate.value
      };
      var internalRenderItemNode = renderRawItem ? function(item, index2) {
        var key2 = getKey2(item, index2);
        return createVNode(OverflowContextProvider, {
          "key": key2,
          "value": _extends(_extends({}, itemSharedProps), {
            order: index2,
            item,
            itemKey: key2,
            registerSize,
            display: index2 <= mergedDisplayCount.value
          })
        }, {
          default: function _default3() {
            return [renderRawItem(item, index2)];
          }
        });
      } : function(item, index2) {
        var key2 = getKey2(item, index2);
        return createVNode(Item$2, _objectSpread2$1(_objectSpread2$1({}, itemSharedProps), {}, {
          "order": index2,
          "key": key2,
          "item": item,
          "renderItem": mergedRenderItem.value,
          "itemKey": key2,
          "registerSize": registerSize,
          "display": index2 <= mergedDisplayCount.value
        }), null);
      };
      var restNode = function restNode2() {
        return null;
      };
      var restContextProps = {
        order: displayRest ? mergedDisplayCount.value : Number.MAX_SAFE_INTEGER,
        className: "".concat(itemPrefixCls.value, " ").concat(itemPrefixCls.value, "-rest"),
        registerSize: registerOverflowSize,
        display: displayRest
      };
      if (!renderRawRest) {
        var mergedRenderRest = renderRest || defaultRenderRest;
        restNode = function restNode2() {
          return createVNode(Item$2, _objectSpread2$1(_objectSpread2$1({}, itemSharedProps), restContextProps), {
            default: function _default3() {
              return typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems.value) : mergedRenderRest;
            }
          });
        };
      } else if (renderRawRest) {
        restNode = function restNode2() {
          return createVNode(OverflowContextProvider, {
            "value": _extends(_extends({}, itemSharedProps), restContextProps)
          }, {
            default: function _default3() {
              return [renderRawRest(omittedItems.value)];
            }
          });
        };
      }
      var overflowNode = function overflowNode2() {
        var _a;
        return createVNode(Component, _objectSpread2$1({
          "id": id,
          "class": classNames(!invalidate.value && prefixCls, className),
          "style": style2,
          "onMousedown": onMousedown2
        }, restAttrs), {
          default: function _default3() {
            return [mergedData.value.map(internalRenderItemNode), showRest.value ? restNode() : null, suffix && createVNode(Item$2, _objectSpread2$1(_objectSpread2$1({}, itemSharedProps), {}, {
              "order": mergedDisplayCount.value,
              "class": "".concat(itemPrefixCls.value, "-suffix"),
              "registerSize": registerSuffixSize,
              "display": true,
              "style": suffixStyle
            }), {
              default: function _default4() {
                return suffix;
              }
            }), (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)];
          }
        });
      };
      return createVNode(ResizeObserver, {
        "disabled": !isResponsive.value,
        "onResize": onOverflowResize
      }, {
        default: overflowNode
      });
    };
  }
});
Overflow.Item = RawItem;
Overflow.RESPONSIVE = RESPONSIVE;
Overflow.INVALIDATE = INVALIDATE;
var Overflow$1 = Overflow;
var TreeSelectLegacyContextPropsKey = Symbol("TreeSelectLegacyContextPropsKey");
function useInjectLegacySelectContext() {
  return inject(TreeSelectLegacyContextPropsKey, {});
}
var props$1 = {
  id: String,
  prefixCls: String,
  values: PropTypes$1.array,
  open: {
    type: Boolean,
    default: void 0
  },
  searchValue: String,
  inputRef: PropTypes$1.any,
  placeholder: PropTypes$1.any,
  disabled: {
    type: Boolean,
    default: void 0
  },
  mode: String,
  showSearch: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  activeDescendantId: String,
  tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  removeIcon: PropTypes$1.any,
  choiceTransitionName: String,
  maxTagCount: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  maxTagTextLength: Number,
  maxTagPlaceholder: PropTypes$1.any.def(function() {
    return function(omittedValues) {
      return "+ ".concat(omittedValues.length, " ...");
    };
  }),
  tagRender: Function,
  onToggleOpen: {
    type: Function
  },
  onRemove: Function,
  onInputChange: Function,
  onInputPaste: Function,
  onInputKeyDown: Function,
  onInputMouseDown: Function,
  onInputCompositionStart: Function,
  onInputCompositionEnd: Function
};
var onPreventMouseDown = function onPreventMouseDown2(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = defineComponent({
  name: "MultipleSelectSelector",
  inheritAttrs: false,
  props: props$1,
  setup: function setup19(props2) {
    var measureRef = ref();
    var inputWidth = ref(0);
    var focused = ref(false);
    var legacyTreeSelectContext = useInjectLegacySelectContext();
    var selectionPrefixCls = computed(function() {
      return "".concat(props2.prefixCls, "-selection");
    });
    var inputValue = computed(function() {
      return props2.open || props2.mode === "tags" ? props2.searchValue : "";
    });
    var inputEditable = computed(function() {
      return props2.mode === "tags" || props2.showSearch && (props2.open || focused.value);
    });
    onMounted(function() {
      watch(inputValue, function() {
        inputWidth.value = measureRef.value.scrollWidth;
      }, {
        flush: "post",
        immediate: true
      });
    });
    function defaultRenderSelector(title, content, itemDisabled, closable, onClose) {
      return createVNode("span", {
        "class": classNames("".concat(selectionPrefixCls.value, "-item"), _defineProperty$m({}, "".concat(selectionPrefixCls.value, "-item-disabled"), itemDisabled)),
        "title": typeof title === "string" || typeof title === "number" ? title.toString() : void 0
      }, [createVNode("span", {
        "class": "".concat(selectionPrefixCls.value, "-item-content")
      }, [content]), closable && createVNode(TransBtn$1, {
        "class": "".concat(selectionPrefixCls.value, "-item-remove"),
        "onMousedown": onPreventMouseDown,
        "onClick": onClose,
        "customizeIcon": props2.removeIcon
      }, {
        default: function _default3() {
          return [createTextVNode("\xD7")];
        }
      })]);
    }
    function customizeRenderSelector(value, content, itemDisabled, closable, onClose, option) {
      var _a;
      var onMouseDown2 = function onMouseDown3(e2) {
        onPreventMouseDown(e2);
        props2.onToggleOpen(!open);
      };
      var originData = option;
      if (legacyTreeSelectContext.keyEntities) {
        originData = ((_a = legacyTreeSelectContext.keyEntities[value]) === null || _a === void 0 ? void 0 : _a.node) || {};
      }
      return createVNode("span", {
        "key": value,
        "onMousedown": onMouseDown2
      }, [props2.tagRender({
        label: content,
        value,
        disabled: itemDisabled,
        closable,
        onClose,
        option: originData
      })]);
    }
    function renderItem(valueItem) {
      var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value, option = valueItem.option;
      var closable = !props2.disabled && !itemDisabled;
      var displayLabel = label;
      if (typeof props2.maxTagTextLength === "number") {
        if (typeof label === "string" || typeof label === "number") {
          var strLabel = String(displayLabel);
          if (strLabel.length > props2.maxTagTextLength) {
            displayLabel = "".concat(strLabel.slice(0, props2.maxTagTextLength), "...");
          }
        }
      }
      var onClose = function onClose2(event) {
        var _a;
        if (event)
          event.stopPropagation();
        (_a = props2.onRemove) === null || _a === void 0 ? void 0 : _a.call(props2, valueItem);
      };
      return typeof props2.tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, option) : defaultRenderSelector(label, displayLabel, itemDisabled, closable, onClose);
    }
    function renderRest(omittedValues) {
      var _props$maxTagPlacehol = props2.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues2) {
        return "+ ".concat(omittedValues2.length, " ...");
      } : _props$maxTagPlacehol;
      var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
      return defaultRenderSelector(content, content, false);
    }
    return function() {
      var id = props2.id, prefixCls = props2.prefixCls, values = props2.values, open2 = props2.open, inputRef = props2.inputRef, placeholder = props2.placeholder, disabled = props2.disabled, autofocus = props2.autofocus, autocomplete = props2.autocomplete, activeDescendantId = props2.activeDescendantId, tabindex = props2.tabindex, onInputChange = props2.onInputChange, onInputPaste = props2.onInputPaste, onInputKeyDown = props2.onInputKeyDown, onInputMouseDown = props2.onInputMouseDown, onInputCompositionStart = props2.onInputCompositionStart, onInputCompositionEnd = props2.onInputCompositionEnd;
      var inputNode = createVNode("div", {
        "class": "".concat(selectionPrefixCls.value, "-search"),
        "style": {
          width: inputWidth.value + "px"
        },
        "key": "input"
      }, [createVNode(Input$1, {
        "inputRef": inputRef,
        "open": open2,
        "prefixCls": prefixCls,
        "id": id,
        "inputElement": null,
        "disabled": disabled,
        "autofocus": autofocus,
        "autocomplete": autocomplete,
        "editable": inputEditable.value,
        "activeDescendantId": activeDescendantId,
        "value": inputValue.value,
        "onKeydown": onInputKeyDown,
        "onMousedown": onInputMouseDown,
        "onChange": onInputChange,
        "onPaste": onInputPaste,
        "onCompositionstart": onInputCompositionStart,
        "onCompositionend": onInputCompositionEnd,
        "tabindex": tabindex,
        "attrs": pickAttrs(props2, true),
        "onFocus": function onFocus2() {
          return focused.value = true;
        },
        "onBlur": function onBlur2() {
          return focused.value = false;
        }
      }, null), createVNode("span", {
        "ref": measureRef,
        "class": "".concat(selectionPrefixCls.value, "-search-mirror"),
        "aria-hidden": true
      }, [inputValue.value, createTextVNode("\xA0")])]);
      var selectionNode = createVNode(Overflow$1, {
        "prefixCls": "".concat(selectionPrefixCls.value, "-overflow"),
        "data": values,
        "renderItem": renderItem,
        "renderRest": renderRest,
        "suffix": inputNode,
        "itemKey": "key",
        "maxCount": props2.maxTagCount,
        "key": "overflow"
      }, null);
      return createVNode(Fragment, null, [selectionNode, !values.length && !inputValue.value && createVNode("span", {
        "class": "".concat(selectionPrefixCls.value, "-placeholder")
      }, [placeholder])]);
    };
  }
});
var MultipleSelector = SelectSelector;
var props = {
  inputElement: PropTypes$1.any,
  id: String,
  prefixCls: String,
  values: PropTypes$1.array,
  open: {
    type: Boolean,
    default: void 0
  },
  searchValue: String,
  inputRef: PropTypes$1.any,
  placeholder: PropTypes$1.any,
  disabled: {
    type: Boolean,
    default: void 0
  },
  mode: String,
  showSearch: {
    type: Boolean,
    default: void 0
  },
  autofocus: {
    type: Boolean,
    default: void 0
  },
  autocomplete: String,
  activeDescendantId: String,
  tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
  activeValue: String,
  backfill: {
    type: Boolean,
    default: void 0
  },
  optionLabelRender: Function,
  onInputChange: Function,
  onInputPaste: Function,
  onInputKeyDown: Function,
  onInputMouseDown: Function,
  onInputCompositionStart: Function,
  onInputCompositionEnd: Function
};
var SingleSelector = defineComponent({
  name: "SingleSelector",
  setup: function setup20(props2) {
    var inputChanged = ref(false);
    var combobox = computed(function() {
      return props2.mode === "combobox";
    });
    var inputEditable = computed(function() {
      return combobox.value || props2.showSearch;
    });
    var inputValue = computed(function() {
      var inputValue2 = props2.searchValue || "";
      if (combobox.value && props2.activeValue && !inputChanged.value) {
        inputValue2 = props2.activeValue;
      }
      return inputValue2;
    });
    var legacyTreeSelectContext = useInjectLegacySelectContext();
    watch([combobox, function() {
      return props2.activeValue;
    }], function() {
      if (combobox.value) {
        inputChanged.value = false;
      }
    }, {
      immediate: true
    });
    var hasTextInput = computed(function() {
      return props2.mode !== "combobox" && !props2.open && !props2.showSearch ? false : !!inputValue.value;
    });
    var title = computed(function() {
      var item = props2.values[0];
      return item && (typeof item.label === "string" || typeof item.label === "number") ? item.label.toString() : void 0;
    });
    var renderPlaceholder = function renderPlaceholder2() {
      if (props2.values[0]) {
        return null;
      }
      var hiddenStyle = hasTextInput.value ? {
        visibility: "hidden"
      } : void 0;
      return createVNode("span", {
        "class": "".concat(props2.prefixCls, "-selection-placeholder"),
        "style": hiddenStyle
      }, [props2.placeholder]);
    };
    return function() {
      var _a, _b, _c, _d;
      var inputElement = props2.inputElement, prefixCls = props2.prefixCls, id = props2.id, values = props2.values, inputRef = props2.inputRef, disabled = props2.disabled, autofocus = props2.autofocus, autocomplete = props2.autocomplete, activeDescendantId = props2.activeDescendantId, open2 = props2.open, tabindex = props2.tabindex, optionLabelRender = props2.optionLabelRender, onInputKeyDown = props2.onInputKeyDown, onInputMouseDown = props2.onInputMouseDown, onInputChange = props2.onInputChange, onInputPaste = props2.onInputPaste, onInputCompositionStart = props2.onInputCompositionStart, onInputCompositionEnd = props2.onInputCompositionEnd;
      var item = values[0];
      var titleNode = null;
      if (item && legacyTreeSelectContext.customSlots) {
        var key2 = (_a = item.key) !== null && _a !== void 0 ? _a : item.value;
        var originData = ((_b = legacyTreeSelectContext.keyEntities[key2]) === null || _b === void 0 ? void 0 : _b.node) || {};
        titleNode = legacyTreeSelectContext.customSlots[(_c = originData.slots) === null || _c === void 0 ? void 0 : _c.title] || legacyTreeSelectContext.customSlots.title || item.label;
        if (typeof titleNode === "function") {
          titleNode = titleNode(originData);
        }
      } else {
        titleNode = optionLabelRender && item ? optionLabelRender(item.option) : item === null || item === void 0 ? void 0 : item.label;
      }
      return createVNode(Fragment, null, [createVNode("span", {
        "class": "".concat(prefixCls, "-selection-search")
      }, [createVNode(Input$1, {
        "inputRef": inputRef,
        "prefixCls": prefixCls,
        "id": id,
        "open": open2,
        "inputElement": inputElement,
        "disabled": disabled,
        "autofocus": autofocus,
        "autocomplete": autocomplete,
        "editable": inputEditable.value,
        "activeDescendantId": activeDescendantId,
        "value": inputValue.value,
        "onKeydown": onInputKeyDown,
        "onMousedown": onInputMouseDown,
        "onChange": function onChange(e2) {
          inputChanged.value = true;
          onInputChange(e2);
        },
        "onPaste": onInputPaste,
        "onCompositionstart": onInputCompositionStart,
        "onCompositionend": onInputCompositionEnd,
        "tabindex": tabindex,
        "attrs": pickAttrs(props2, true)
      }, null)]), !combobox.value && item && !hasTextInput.value && createVNode("span", {
        "class": "".concat(prefixCls, "-selection-item"),
        "title": title.value
      }, [createVNode(Fragment, {
        "key": (_d = item.key) !== null && _d !== void 0 ? _d : item.value
      }, [titleNode])]), renderPlaceholder()]);
    };
  }
});
SingleSelector.props = props;
SingleSelector.inheritAttrs = false;
var SingleSelector$1 = SingleSelector;
function isValidateOpenKey(currentKeyCode) {
  return ![
    KeyCode$1.ESC,
    KeyCode$1.SHIFT,
    KeyCode$1.BACKSPACE,
    KeyCode$1.TAB,
    KeyCode$1.WIN_KEY,
    KeyCode$1.ALT,
    KeyCode$1.META,
    KeyCode$1.WIN_KEY_RIGHT,
    KeyCode$1.CTRL,
    KeyCode$1.SEMICOLON,
    KeyCode$1.EQUALS,
    KeyCode$1.CAPS_LOCK,
    KeyCode$1.CONTEXT_MENU,
    KeyCode$1.F1,
    KeyCode$1.F2,
    KeyCode$1.F3,
    KeyCode$1.F4,
    KeyCode$1.F5,
    KeyCode$1.F6,
    KeyCode$1.F7,
    KeyCode$1.F8,
    KeyCode$1.F9,
    KeyCode$1.F10,
    KeyCode$1.F11,
    KeyCode$1.F12
  ].includes(currentKeyCode);
}
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250;
  var lock = null;
  var timeout;
  onBeforeUnmount(function() {
    clearTimeout(timeout);
  });
  function doLock(locked) {
    if (locked || lock === null) {
      lock = locked;
    }
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      lock = null;
    }, duration);
  }
  return [function() {
    return lock;
  }, doLock];
}
function createRef() {
  var func = function func2(node) {
    func2.current = node;
  };
  return func;
}
var Selector = defineComponent({
  name: "Selector",
  inheritAttrs: false,
  props: {
    id: String,
    prefixCls: String,
    showSearch: {
      type: Boolean,
      default: void 0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    values: PropTypes$1.array,
    multiple: {
      type: Boolean,
      default: void 0
    },
    mode: String,
    searchValue: String,
    activeValue: String,
    inputElement: PropTypes$1.any,
    autofocus: {
      type: Boolean,
      default: void 0
    },
    activeDescendantId: String,
    tabindex: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    disabled: {
      type: Boolean,
      default: void 0
    },
    placeholder: PropTypes$1.any,
    removeIcon: PropTypes$1.any,
    maxTagCount: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string]),
    maxTagTextLength: Number,
    maxTagPlaceholder: PropTypes$1.any,
    tagRender: Function,
    optionLabelRender: Function,
    tokenWithEnter: {
      type: Boolean,
      default: void 0
    },
    choiceTransitionName: String,
    onToggleOpen: {
      type: Function
    },
    onSearch: Function,
    onSearchSubmit: Function,
    onRemove: Function,
    onInputKeyDown: {
      type: Function
    },
    domRef: Function
  },
  setup: function setup21(props2, _ref) {
    var expose = _ref.expose;
    var inputRef = createRef();
    var compositionStatus = false;
    var _useLock = useLock(0), _useLock2 = _slicedToArray$2(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
    var onInternalInputKeyDown = function onInternalInputKeyDown2(event) {
      var which = event.which;
      if (which === KeyCode$1.UP || which === KeyCode$1.DOWN) {
        event.preventDefault();
      }
      if (props2.onInputKeyDown) {
        props2.onInputKeyDown(event);
      }
      if (which === KeyCode$1.ENTER && props2.mode === "tags" && !compositionStatus && !props2.open) {
        props2.onSearchSubmit(event.target.value);
      }
      if (isValidateOpenKey(which)) {
        props2.onToggleOpen(true);
      }
    };
    var onInternalInputMouseDown = function onInternalInputMouseDown2() {
      setInputMouseDown(true);
    };
    var pastedText = null;
    var triggerOnSearch = function triggerOnSearch2(value) {
      if (props2.onSearch(value, true, compositionStatus) !== false) {
        props2.onToggleOpen(true);
      }
    };
    var onInputCompositionStart = function onInputCompositionStart2() {
      compositionStatus = true;
    };
    var onInputCompositionEnd = function onInputCompositionEnd2(e2) {
      compositionStatus = false;
      if (props2.mode !== "combobox") {
        triggerOnSearch(e2.target.value);
      }
    };
    var onInputChange = function onInputChange2(event) {
      var value = event.target.value;
      if (props2.tokenWithEnter && pastedText && /[\r\n]/.test(pastedText)) {
        var replacedText = pastedText.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
        value = value.replace(replacedText, pastedText);
      }
      pastedText = null;
      triggerOnSearch(value);
    };
    var onInputPaste = function onInputPaste2(e2) {
      var clipboardData = e2.clipboardData;
      var value = clipboardData.getData("text");
      pastedText = value;
    };
    var onClick2 = function onClick3(_ref2) {
      var target = _ref2.target;
      if (target !== inputRef.current) {
        var isIE = document.body.style.msTouchAction !== void 0;
        if (isIE) {
          setTimeout(function() {
            inputRef.current.focus();
          });
        } else {
          inputRef.current.focus();
        }
      }
    };
    var onMousedown2 = function onMousedown3(event) {
      var inputMouseDown = getInputMouseDown();
      if (event.target !== inputRef.current && !inputMouseDown) {
        event.preventDefault();
      }
      if (props2.mode !== "combobox" && (!props2.showSearch || !inputMouseDown) || !props2.open) {
        if (props2.open) {
          props2.onSearch("", true, false);
        }
        props2.onToggleOpen();
      }
    };
    expose({
      focus: function focus() {
        inputRef.current.focus();
      },
      blur: function blur() {
        inputRef.current.blur();
      }
    });
    return function() {
      var prefixCls = props2.prefixCls, domRef = props2.domRef, mode2 = props2.mode;
      var sharedProps = {
        inputRef,
        onInputKeyDown: onInternalInputKeyDown,
        onInputMouseDown: onInternalInputMouseDown,
        onInputChange,
        onInputPaste,
        onInputCompositionStart,
        onInputCompositionEnd
      };
      var selectNode = mode2 === "multiple" || mode2 === "tags" ? createVNode(MultipleSelector, _objectSpread2$1(_objectSpread2$1({}, props2), sharedProps), null) : createVNode(SingleSelector$1, _objectSpread2$1(_objectSpread2$1({}, props2), sharedProps), null);
      return createVNode("div", {
        "ref": domRef,
        "class": "".concat(prefixCls, "-selector"),
        "onClick": onClick2,
        "onMousedown": onMousedown2
      }, [selectNode]);
    };
  }
});
var Selector$1 = Selector;
function useSelectTriggerControl(refs, open2, triggerOpen) {
  function onGlobalMouseDown(event) {
    var _a, _b, _c;
    var target = event.target;
    if (target.shadowRoot && event.composed) {
      target = event.composedPath()[0] || target;
    }
    var elements = [(_a = refs[0]) === null || _a === void 0 ? void 0 : _a.value, (_c = (_b = refs[1]) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.getPopupElement()];
    if (open2.value && elements.every(function(element) {
      return element && !element.contains(target) && element !== target;
    })) {
      triggerOpen(false);
    }
  }
  onMounted(function() {
    window.addEventListener("mousedown", onGlobalMouseDown);
  });
  onBeforeUnmount(function() {
    window.removeEventListener("mousedown", onGlobalMouseDown);
  });
}
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
  var bool = ref(false);
  var delay;
  var cancelLatest = function cancelLatest2() {
    clearTimeout(delay);
  };
  onMounted(function() {
    cancelLatest();
  });
  var delaySetBool = function delaySetBool2(value, callback) {
    cancelLatest();
    delay = setTimeout(function() {
      bool.value = value;
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}
var BaseSelectContextKey = Symbol("BaseSelectContextKey");
function useProvideBaseSelectProps(props2) {
  return provide(BaseSelectContextKey, props2);
}
function useBaseProps() {
  return inject(BaseSelectContextKey, {});
}
var isMobile = function() {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4))) {
    return true;
  }
  return false;
};
function toReactive(objectRef) {
  if (!isRef(objectRef))
    return reactive(objectRef);
  var proxy = new Proxy({}, {
    get: function get(_2, p, receiver) {
      return Reflect.get(objectRef.value, p, receiver);
    },
    set: function set(_2, p, value) {
      objectRef.value[p] = value;
      return true;
    },
    deleteProperty: function deleteProperty(_2, p) {
      return Reflect.deleteProperty(objectRef.value, p);
    },
    has: function has(_2, p) {
      return Reflect.has(objectRef.value, p);
    },
    ownKeys: function ownKeys2() {
      return Object.keys(objectRef.value);
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor() {
      return {
        enumerable: true,
        configurable: true
      };
    }
  });
  return reactive(proxy);
}
var __rest$b = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autofocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabindex", "OptionList", "notFoundContent"];
var baseSelectPrivateProps = function baseSelectPrivateProps2() {
  return {
    prefixCls: String,
    id: String,
    omitDomProps: Array,
    displayValues: Array,
    onDisplayValuesChange: Function,
    activeValue: String,
    activeDescendantId: String,
    onActiveValueChange: Function,
    searchValue: String,
    onSearch: Function,
    onSearchSplit: Function,
    maxLength: Number,
    OptionList: PropTypes$1.any,
    emptyOptions: Boolean
  };
};
var baseSelectPropsWithoutPrivate = function baseSelectPropsWithoutPrivate2() {
  return {
    showSearch: {
      type: Boolean,
      default: void 0
    },
    tagRender: {
      type: Function
    },
    optionLabelRender: {
      type: Function
    },
    direction: {
      type: String
    },
    tabindex: Number,
    autofocus: Boolean,
    notFoundContent: PropTypes$1.any,
    placeholder: PropTypes$1.any,
    onClear: Function,
    choiceTransitionName: String,
    mode: String,
    disabled: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: void 0
    },
    open: {
      type: Boolean,
      default: void 0
    },
    defaultOpen: {
      type: Boolean,
      default: void 0
    },
    onDropdownVisibleChange: {
      type: Function
    },
    getInputElement: {
      type: Function
    },
    getRawInputElement: {
      type: Function
    },
    maxTagTextLength: Number,
    maxTagCount: {
      type: [String, Number]
    },
    maxTagPlaceholder: PropTypes$1.any,
    tokenSeparators: {
      type: Array
    },
    allowClear: {
      type: Boolean,
      default: void 0
    },
    showArrow: {
      type: Boolean,
      default: void 0
    },
    inputIcon: PropTypes$1.any,
    clearIcon: PropTypes$1.any,
    removeIcon: PropTypes$1.any,
    animation: String,
    transitionName: String,
    dropdownStyle: {
      type: Object
    },
    dropdownClassName: String,
    dropdownMatchSelectWidth: {
      type: [Boolean, Number],
      default: void 0
    },
    dropdownRender: {
      type: Function
    },
    dropdownAlign: Object,
    placement: {
      type: String
    },
    getPopupContainer: {
      type: Function
    },
    showAction: {
      type: Array
    },
    onBlur: {
      type: Function
    },
    onFocus: {
      type: Function
    },
    onKeyup: Function,
    onKeydown: Function,
    onMousedown: Function,
    onPopupScroll: Function,
    onInputKeyDown: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onClick: Function
  };
};
var baseSelectProps = function baseSelectProps2() {
  return _extends(_extends({}, baseSelectPrivateProps()), baseSelectPropsWithoutPrivate());
};
function isMultiple(mode2) {
  return mode2 === "tags" || mode2 === "multiple";
}
var BaseSelect = defineComponent({
  name: "BaseSelect",
  inheritAttrs: false,
  props: initDefaultProps$1(baseSelectProps(), {
    showAction: [],
    notFoundContent: "Not Found"
  }),
  setup: function setup22(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var multiple = computed(function() {
      return isMultiple(props2.mode);
    });
    var mergedShowSearch = computed(function() {
      return props2.showSearch !== void 0 ? props2.showSearch : multiple.value || props2.mode === "combobox";
    });
    var mobile = ref(false);
    onMounted(function() {
      mobile.value = isMobile();
    });
    var legacyTreeSelectContext = useInjectLegacySelectContext();
    var containerRef = ref(null);
    var selectorDomRef = createRef();
    var triggerRef = ref(null);
    var selectorRef = ref(null);
    var listRef = ref(null);
    var _useDelayReset = useDelayReset(), _useDelayReset2 = _slicedToArray$2(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
    var focus = function focus2() {
      var _a;
      (_a = selectorRef.value) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var blur = function blur2() {
      var _a;
      (_a = selectorRef.value) === null || _a === void 0 ? void 0 : _a.blur();
    };
    expose({
      focus,
      blur,
      scrollTo: function scrollTo(arg) {
        var _a;
        return (_a = listRef.value) === null || _a === void 0 ? void 0 : _a.scrollTo(arg);
      }
    });
    var mergedSearchValue = computed(function() {
      var _a;
      if (props2.mode !== "combobox") {
        return props2.searchValue;
      }
      var val = (_a = props2.displayValues[0]) === null || _a === void 0 ? void 0 : _a.value;
      return typeof val === "string" || typeof val === "number" ? String(val) : "";
    });
    var initOpen = props2.open !== void 0 ? props2.open : props2.defaultOpen;
    var innerOpen = ref(initOpen);
    var mergedOpen = ref(initOpen);
    var setInnerOpen = function setInnerOpen2(val) {
      innerOpen.value = props2.open !== void 0 ? props2.open : val;
      mergedOpen.value = innerOpen.value;
    };
    watch(function() {
      return props2.open;
    }, function() {
      setInnerOpen(props2.open);
    });
    var emptyListContent = computed(function() {
      return !props2.notFoundContent && props2.emptyOptions;
    });
    watchEffect(function() {
      mergedOpen.value = innerOpen.value;
      if (props2.disabled || emptyListContent.value && mergedOpen.value && props2.mode === "combobox") {
        mergedOpen.value = false;
      }
    });
    var triggerOpen = computed(function() {
      return emptyListContent.value ? false : mergedOpen.value;
    });
    var onToggleOpen = function onToggleOpen2(newOpen) {
      var nextOpen = newOpen !== void 0 ? newOpen : !mergedOpen.value;
      if (innerOpen.value !== nextOpen && !props2.disabled) {
        setInnerOpen(nextOpen);
        if (props2.onDropdownVisibleChange) {
          props2.onDropdownVisibleChange(nextOpen);
        }
      }
    };
    var tokenWithEnter = computed(function() {
      return (props2.tokenSeparators || []).some(function(tokenSeparator) {
        return ["\n", "\r\n"].includes(tokenSeparator);
      });
    });
    var onInternalSearch = function onInternalSearch2(searchText, fromTyping, isCompositing) {
      var _a, _b;
      var ret = true;
      var newSearchText = searchText;
      (_a = props2.onActiveValueChange) === null || _a === void 0 ? void 0 : _a.call(props2, null);
      var patchLabels = isCompositing ? null : getSeparatedContent(searchText, props2.tokenSeparators);
      if (props2.mode !== "combobox" && patchLabels) {
        newSearchText = "";
        (_b = props2.onSearchSplit) === null || _b === void 0 ? void 0 : _b.call(props2, patchLabels);
        onToggleOpen(false);
        ret = false;
      }
      if (props2.onSearch && mergedSearchValue.value !== newSearchText) {
        props2.onSearch(newSearchText, {
          source: fromTyping ? "typing" : "effect"
        });
      }
      return ret;
    };
    var onInternalSearchSubmit = function onInternalSearchSubmit2(searchText) {
      var _a;
      if (!searchText || !searchText.trim()) {
        return;
      }
      (_a = props2.onSearch) === null || _a === void 0 ? void 0 : _a.call(props2, searchText, {
        source: "submit"
      });
    };
    watch(mergedOpen, function() {
      if (!mergedOpen.value && !multiple.value && props2.mode !== "combobox") {
        onInternalSearch("", false, false);
      }
    }, {
      immediate: true,
      flush: "post"
    });
    watch(function() {
      return props2.disabled;
    }, function() {
      if (innerOpen.value && !!props2.disabled) {
        setInnerOpen(false);
      }
    }, {
      immediate: true
    });
    var _useLock = useLock(), _useLock2 = _slicedToArray$2(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
    var onInternalKeyDown = function onInternalKeyDown2(event) {
      var _a2;
      var _a;
      var clearLock = getClearLock();
      var which = event.which;
      if (which === KeyCode$1.ENTER) {
        if (props2.mode !== "combobox") {
          event.preventDefault();
        }
        if (!mergedOpen.value) {
          onToggleOpen(true);
        }
      }
      setClearLock(!!mergedSearchValue.value);
      if (which === KeyCode$1.BACKSPACE && !clearLock && multiple.value && !mergedSearchValue.value && props2.displayValues.length) {
        var cloneDisplayValues = _toConsumableArray(props2.displayValues);
        var removedDisplayValue = null;
        for (var i = cloneDisplayValues.length - 1; i >= 0; i -= 1) {
          var current2 = cloneDisplayValues[i];
          if (!current2.disabled) {
            cloneDisplayValues.splice(i, 1);
            removedDisplayValue = current2;
            break;
          }
        }
        if (removedDisplayValue) {
          props2.onDisplayValuesChange(cloneDisplayValues, {
            type: "remove",
            values: [removedDisplayValue]
          });
        }
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      if (mergedOpen.value && listRef.value) {
        var _listRef$value;
        (_listRef$value = listRef.value).onKeydown.apply(_listRef$value, [event].concat(rest));
      }
      (_a = props2.onKeydown) === null || _a === void 0 ? void 0 : (_a2 = _a).call.apply(_a2, [props2, event].concat(rest));
    };
    var onInternalKeyUp = function onInternalKeyUp2(event) {
      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }
      if (mergedOpen.value && listRef.value) {
        var _listRef$value2;
        (_listRef$value2 = listRef.value).onKeyup.apply(_listRef$value2, [event].concat(rest));
      }
      if (props2.onKeyup) {
        props2.onKeyup.apply(props2, [event].concat(rest));
      }
    };
    var onSelectorRemove = function onSelectorRemove2(val) {
      var newValues = props2.displayValues.filter(function(i) {
        return i !== val;
      });
      props2.onDisplayValuesChange(newValues, {
        type: "remove",
        values: [val]
      });
    };
    var focusRef = ref(false);
    var onContainerFocus = function onContainerFocus2() {
      setMockFocused(true);
      if (!props2.disabled) {
        if (props2.onFocus && !focusRef.value) {
          props2.onFocus.apply(props2, arguments);
        }
        if (props2.showAction && props2.showAction.includes("focus")) {
          onToggleOpen(true);
        }
      }
      focusRef.value = true;
    };
    var onContainerBlur = function onContainerBlur2() {
      setMockFocused(false, function() {
        focusRef.value = false;
        onToggleOpen(false);
      });
      if (props2.disabled) {
        return;
      }
      var searchVal = mergedSearchValue.value;
      if (searchVal) {
        if (props2.mode === "tags") {
          props2.onSearch(searchVal, {
            source: "submit"
          });
        } else if (props2.mode === "multiple") {
          props2.onSearch("", {
            source: "blur"
          });
        }
      }
      if (props2.onBlur) {
        props2.onBlur.apply(props2, arguments);
      }
    };
    provide("VCSelectContainerEvent", {
      focus: onContainerFocus,
      blur: onContainerBlur
    });
    var activeTimeoutIds = [];
    onMounted(function() {
      activeTimeoutIds.forEach(function(timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    });
    onBeforeUnmount(function() {
      activeTimeoutIds.forEach(function(timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    });
    var onInternalMouseDown = function onInternalMouseDown2(event) {
      var _b2;
      var _a, _b;
      var target = event.target;
      var popupElement = (_a = triggerRef.value) === null || _a === void 0 ? void 0 : _a.getPopupElement();
      if (popupElement && popupElement.contains(target)) {
        var timeoutId = setTimeout(function() {
          var _a2;
          var index2 = activeTimeoutIds.indexOf(timeoutId);
          if (index2 !== -1) {
            activeTimeoutIds.splice(index2, 1);
          }
          cancelSetMockFocused();
          if (!mobile.value && !popupElement.contains(document.activeElement)) {
            (_a2 = selectorRef.value) === null || _a2 === void 0 ? void 0 : _a2.focus();
          }
        });
        activeTimeoutIds.push(timeoutId);
      }
      for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        restArgs[_key3 - 1] = arguments[_key3];
      }
      (_b = props2.onMousedown) === null || _b === void 0 ? void 0 : (_b2 = _b).call.apply(_b2, [props2, event].concat(restArgs));
    };
    var containerWidth = ref(null);
    var instance = getCurrentInstance();
    var onPopupMouseEnter = function onPopupMouseEnter2() {
      instance.update();
    };
    onMounted(function() {
      watch(triggerOpen, function() {
        var _a;
        if (triggerOpen.value) {
          var newWidth = Math.ceil((_a = containerRef.value) === null || _a === void 0 ? void 0 : _a.offsetWidth);
          if (containerWidth.value !== newWidth && !Number.isNaN(newWidth)) {
            containerWidth.value = newWidth;
          }
        }
      }, {
        immediate: true,
        flush: "post"
      });
    });
    useSelectTriggerControl([containerRef, triggerRef], triggerOpen, onToggleOpen);
    useProvideBaseSelectProps(toReactive(_extends(_extends({}, toRefs(props2)), {
      open: mergedOpen,
      triggerOpen,
      showSearch: mergedShowSearch,
      multiple,
      toggleOpen: onToggleOpen
    })));
    return function() {
      var _classNames2;
      var _a = _extends(_extends({}, props2), attrs), prefixCls = _a.prefixCls, id = _a.id;
      _a.open;
      _a.defaultOpen;
      var mode2 = _a.mode;
      _a.showSearch;
      _a.searchValue;
      _a.onSearch;
      var allowClear = _a.allowClear, clearIcon = _a.clearIcon, showArrow = _a.showArrow, inputIcon = _a.inputIcon, disabled = _a.disabled, loading = _a.loading, getInputElement = _a.getInputElement, getPopupContainer = _a.getPopupContainer, placement = _a.placement, animation = _a.animation, transitionName2 = _a.transitionName, dropdownStyle = _a.dropdownStyle, dropdownClassName = _a.dropdownClassName, dropdownMatchSelectWidth = _a.dropdownMatchSelectWidth, dropdownRender = _a.dropdownRender, dropdownAlign = _a.dropdownAlign;
      _a.showAction;
      var direction = _a.direction;
      _a.tokenSeparators;
      var tagRender = _a.tagRender, optionLabelRender = _a.optionLabelRender;
      _a.onPopupScroll;
      _a.onDropdownVisibleChange;
      _a.onFocus;
      _a.onBlur;
      _a.onKeyup;
      _a.onKeydown;
      _a.onMousedown;
      var onClear = _a.onClear, omitDomProps = _a.omitDomProps, getRawInputElement = _a.getRawInputElement, displayValues = _a.displayValues, onDisplayValuesChange = _a.onDisplayValuesChange, emptyOptions = _a.emptyOptions, activeDescendantId = _a.activeDescendantId, activeValue = _a.activeValue, OptionList2 = _a.OptionList, restProps = __rest$b(_a, ["prefixCls", "id", "open", "defaultOpen", "mode", "showSearch", "searchValue", "onSearch", "allowClear", "clearIcon", "showArrow", "inputIcon", "disabled", "loading", "getInputElement", "getPopupContainer", "placement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "showAction", "direction", "tokenSeparators", "tagRender", "optionLabelRender", "onPopupScroll", "onDropdownVisibleChange", "onFocus", "onBlur", "onKeyup", "onKeydown", "onMousedown", "onClear", "omitDomProps", "getRawInputElement", "displayValues", "onDisplayValuesChange", "emptyOptions", "activeDescendantId", "activeValue", "OptionList"]);
      var customizeInputElement = mode2 === "combobox" && getInputElement && getInputElement() || null;
      var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
      var domProps = _extends({}, restProps);
      var onTriggerVisibleChange;
      if (customizeRawInputElement) {
        onTriggerVisibleChange = function onTriggerVisibleChange2(newOpen) {
          onToggleOpen(newOpen);
        };
      }
      DEFAULT_OMIT_PROPS.forEach(function(propName) {
        delete domProps[propName];
      });
      omitDomProps === null || omitDomProps === void 0 ? void 0 : omitDomProps.forEach(function(propName) {
        delete domProps[propName];
      });
      var mergedShowArrow = showArrow !== void 0 ? showArrow : loading || !multiple.value && mode2 !== "combobox";
      var arrowNode;
      if (mergedShowArrow) {
        arrowNode = createVNode(TransBtn$1, {
          "class": classNames("".concat(prefixCls, "-arrow"), _defineProperty$m({}, "".concat(prefixCls, "-arrow-loading"), loading)),
          "customizeIcon": inputIcon,
          "customizeIconProps": {
            loading,
            searchValue: mergedSearchValue.value,
            open: mergedOpen.value,
            focused: mockFocused.value,
            showSearch: mergedShowSearch.value
          }
        }, null);
      }
      var clearNode;
      var onClearMouseDown = function onClearMouseDown2() {
        onClear === null || onClear === void 0 ? void 0 : onClear();
        onDisplayValuesChange([], {
          type: "clear",
          values: displayValues
        });
        onInternalSearch("", false, false);
      };
      if (!disabled && allowClear && (displayValues.length || mergedSearchValue.value)) {
        clearNode = createVNode(TransBtn$1, {
          "class": "".concat(prefixCls, "-clear"),
          "onMousedown": onClearMouseDown,
          "customizeIcon": clearIcon
        }, {
          default: function _default3() {
            return [createTextVNode("\xD7")];
          }
        });
      }
      var optionList = createVNode(OptionList2, {
        "ref": listRef
      }, _extends(_extends({}, legacyTreeSelectContext.customSlots), {
        option: slots.option
      }));
      var mergedClassName = classNames(prefixCls, attrs.class, (_classNames2 = {}, _defineProperty$m(_classNames2, "".concat(prefixCls, "-focused"), mockFocused.value), _defineProperty$m(_classNames2, "".concat(prefixCls, "-multiple"), multiple.value), _defineProperty$m(_classNames2, "".concat(prefixCls, "-single"), !multiple.value), _defineProperty$m(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), _defineProperty$m(_classNames2, "".concat(prefixCls, "-show-arrow"), mergedShowArrow), _defineProperty$m(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$m(_classNames2, "".concat(prefixCls, "-loading"), loading), _defineProperty$m(_classNames2, "".concat(prefixCls, "-open"), mergedOpen.value), _defineProperty$m(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), _defineProperty$m(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch.value), _classNames2));
      var selectorNode = createVNode(SelectTrigger$1, {
        "ref": triggerRef,
        "disabled": disabled,
        "prefixCls": prefixCls,
        "visible": triggerOpen.value,
        "popupElement": optionList,
        "containerWidth": containerWidth.value,
        "animation": animation,
        "transitionName": transitionName2,
        "dropdownStyle": dropdownStyle,
        "dropdownClassName": dropdownClassName,
        "direction": direction,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth,
        "dropdownRender": dropdownRender,
        "dropdownAlign": dropdownAlign,
        "placement": placement,
        "getPopupContainer": getPopupContainer,
        "empty": emptyOptions,
        "getTriggerDOMNode": function getTriggerDOMNode() {
          return selectorDomRef.current;
        },
        "onPopupVisibleChange": onTriggerVisibleChange,
        "onPopupMouseEnter": onPopupMouseEnter
      }, {
        default: function _default3() {
          return customizeRawInputElement ? isValidElement(customizeRawInputElement) && cloneElement(customizeRawInputElement, {
            ref: selectorDomRef
          }, false, true) : createVNode(Selector$1, _objectSpread2$1(_objectSpread2$1({}, props2), {}, {
            "domRef": selectorDomRef,
            "prefixCls": prefixCls,
            "inputElement": customizeInputElement,
            "ref": selectorRef,
            "id": id,
            "showSearch": mergedShowSearch.value,
            "mode": mode2,
            "activeDescendantId": activeDescendantId,
            "tagRender": tagRender,
            "optionLabelRender": optionLabelRender,
            "values": displayValues,
            "open": mergedOpen.value,
            "onToggleOpen": onToggleOpen,
            "activeValue": activeValue,
            "searchValue": mergedSearchValue.value,
            "onSearch": onInternalSearch,
            "onSearchSubmit": onInternalSearchSubmit,
            "onRemove": onSelectorRemove,
            "tokenWithEnter": tokenWithEnter.value
          }), null);
        }
      });
      var renderNode;
      if (customizeRawInputElement) {
        renderNode = selectorNode;
      } else {
        renderNode = createVNode("div", _objectSpread2$1(_objectSpread2$1({}, domProps), {}, {
          "class": mergedClassName,
          "ref": containerRef,
          "onMousedown": onInternalMouseDown,
          "onKeydown": onInternalKeyDown,
          "onKeyup": onInternalKeyUp
        }), [mockFocused.value && !mergedOpen.value && createVNode("span", {
          "style": {
            width: 0,
            height: 0,
            display: "flex",
            overflow: "hidden",
            opacity: 0
          },
          "aria-live": "polite"
        }, ["".concat(displayValues.map(function(_ref2) {
          var label = _ref2.label, value = _ref2.value;
          return ["number", "string"].includes(_typeof$1(label)) ? label : value;
        }).join(", "))]), selectorNode, arrowNode, clearNode]);
      }
      return renderNode;
    };
  }
});
var Filter = function Filter2(_ref, _ref2) {
  var height = _ref.height, offset3 = _ref.offset, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize;
  var slots = _ref2.slots;
  var _a;
  var outerStyle = {};
  var innerStyle = {
    display: "flex",
    flexDirection: "column"
  };
  if (offset3 !== void 0) {
    outerStyle = {
      height: "".concat(height, "px"),
      position: "relative",
      overflow: "hidden"
    };
    innerStyle = _extends(_extends({}, innerStyle), {
      transform: "translateY(".concat(offset3, "px)"),
      position: "absolute",
      left: 0,
      right: 0,
      top: 0
    });
  }
  return createVNode("div", {
    "style": outerStyle
  }, [createVNode(ResizeObserver, {
    "onResize": function onResize(_ref3) {
      var offsetHeight = _ref3.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, {
    default: function _default3() {
      return [createVNode("div", {
        "style": innerStyle,
        "class": classNames(_defineProperty$m({}, "".concat(prefixCls, "-holder-inner"), prefixCls))
      }, [(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)])];
    }
  })]);
};
Filter.displayName = "Filter";
Filter.inheritAttrs = false;
Filter.props = {
  prefixCls: String,
  height: Number,
  offset: Number,
  onInnerResize: Function
};
var Filler = Filter;
var Item = function Item2(_ref, _ref2) {
  var setRef = _ref.setRef;
  var slots = _ref2.slots;
  var _a;
  var children = flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots));
  return children && children.length ? cloneVNode(children[0], {
    ref: setRef
  }) : children;
};
Item.props = {
  setRef: {
    type: Function,
    default: function _default() {
    }
  }
};
var Item$1 = Item;
var MIN_SIZE = 20;
function getPageY(e2) {
  return "touches" in e2 ? e2.touches[0].pageY : e2.pageY;
}
var ScrollBar = defineComponent({
  name: "ScrollBar",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    scrollTop: Number,
    scrollHeight: Number,
    height: Number,
    count: Number,
    onScroll: {
      type: Function
    },
    onStartMove: {
      type: Function
    },
    onStopMove: {
      type: Function
    }
  },
  setup: function setup23() {
    return {
      moveRaf: null,
      scrollbarRef: createRef(),
      thumbRef: createRef(),
      visibleTimeout: null,
      state: reactive({
        dragging: false,
        pageY: null,
        startTop: null,
        visible: false
      })
    };
  },
  watch: {
    scrollTop: {
      handler: function handler() {
        this.delayHidden();
      },
      flush: "post"
    }
  },
  mounted: function mounted2() {
    var _a, _b;
    (_a = this.scrollbarRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("touchstart", this.onScrollbarTouchStart, supportsPassive$1 ? {
      passive: false
    } : false);
    (_b = this.thumbRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener("touchstart", this.onMouseDown, supportsPassive$1 ? {
      passive: false
    } : false);
  },
  beforeUnmount: function beforeUnmount2() {
    this.removeEvents();
    clearTimeout(this.visibleTimeout);
  },
  methods: {
    delayHidden: function delayHidden() {
      var _this = this;
      clearTimeout(this.visibleTimeout);
      this.state.visible = true;
      this.visibleTimeout = setTimeout(function() {
        _this.state.visible = false;
      }, 2e3);
    },
    onScrollbarTouchStart: function onScrollbarTouchStart(e2) {
      e2.preventDefault();
    },
    onContainerMouseDown: function onContainerMouseDown(e2) {
      e2.stopPropagation();
      e2.preventDefault();
    },
    patchEvents: function patchEvents() {
      window.addEventListener("mousemove", this.onMouseMove);
      window.addEventListener("mouseup", this.onMouseUp);
      this.thumbRef.current.addEventListener("touchmove", this.onMouseMove, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.addEventListener("touchend", this.onMouseUp);
    },
    removeEvents: function removeEvents() {
      window.removeEventListener("mousemove", this.onMouseMove);
      window.removeEventListener("mouseup", this.onMouseUp);
      this.scrollbarRef.current.removeEventListener("touchstart", this.onScrollbarTouchStart, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.removeEventListener("touchstart", this.onMouseDown, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.removeEventListener("touchmove", this.onMouseMove, supportsPassive$1 ? {
        passive: false
      } : false);
      this.thumbRef.current.removeEventListener("touchend", this.onMouseUp);
      wrapperRaf.cancel(this.moveRaf);
    },
    onMouseDown: function onMouseDown(e2) {
      var onStartMove = this.$props.onStartMove;
      _extends(this.state, {
        dragging: true,
        pageY: getPageY(e2),
        startTop: this.getTop()
      });
      onStartMove();
      this.patchEvents();
      e2.stopPropagation();
      e2.preventDefault();
    },
    onMouseMove: function onMouseMove2(e2) {
      var _this$state = this.state, dragging = _this$state.dragging, pageY = _this$state.pageY, startTop = _this$state.startTop;
      var onScroll = this.$props.onScroll;
      wrapperRaf.cancel(this.moveRaf);
      if (dragging) {
        var offsetY = getPageY(e2) - pageY;
        var newTop = startTop + offsetY;
        var enableScrollRange = this.getEnableScrollRange();
        var enableHeightRange = this.getEnableHeightRange();
        var ptg = enableHeightRange ? newTop / enableHeightRange : 0;
        var newScrollTop = Math.ceil(ptg * enableScrollRange);
        this.moveRaf = wrapperRaf(function() {
          onScroll(newScrollTop);
        });
      }
    },
    onMouseUp: function onMouseUp() {
      var onStopMove = this.$props.onStopMove;
      this.state.dragging = false;
      onStopMove();
      this.removeEvents();
    },
    getSpinHeight: function getSpinHeight() {
      var _this$$props = this.$props, height = _this$$props.height, count = _this$$props.count;
      var baseHeight = height / count * 10;
      baseHeight = Math.max(baseHeight, MIN_SIZE);
      baseHeight = Math.min(baseHeight, height / 2);
      return Math.floor(baseHeight);
    },
    getEnableScrollRange: function getEnableScrollRange() {
      var _this$$props2 = this.$props, scrollHeight = _this$$props2.scrollHeight, height = _this$$props2.height;
      return scrollHeight - height || 0;
    },
    getEnableHeightRange: function getEnableHeightRange() {
      var height = this.$props.height;
      var spinHeight = this.getSpinHeight();
      return height - spinHeight || 0;
    },
    getTop: function getTop() {
      var scrollTop = this.$props.scrollTop;
      var enableScrollRange = this.getEnableScrollRange();
      var enableHeightRange = this.getEnableHeightRange();
      if (scrollTop === 0 || enableScrollRange === 0) {
        return 0;
      }
      var ptg = scrollTop / enableScrollRange;
      return ptg * enableHeightRange;
    },
    showScroll: function showScroll() {
      var _this$$props3 = this.$props, height = _this$$props3.height, scrollHeight = _this$$props3.scrollHeight;
      return scrollHeight > height;
    }
  },
  render: function render3() {
    var _this$state2 = this.state, dragging = _this$state2.dragging, visible = _this$state2.visible;
    var prefixCls = this.$props.prefixCls;
    var spinHeight = this.getSpinHeight() + "px";
    var top = this.getTop() + "px";
    var canScroll = this.showScroll();
    var mergedVisible = canScroll && visible;
    return createVNode("div", {
      "ref": this.scrollbarRef,
      "class": classNames("".concat(prefixCls, "-scrollbar"), _defineProperty$m({}, "".concat(prefixCls, "-scrollbar-show"), canScroll)),
      "style": {
        width: "8px",
        top: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: mergedVisible ? void 0 : "none"
      },
      "onMousedown": this.onContainerMouseDown,
      "onMousemove": this.delayHidden
    }, [createVNode("div", {
      "ref": this.thumbRef,
      "class": classNames("".concat(prefixCls, "-scrollbar-thumb"), _defineProperty$m({}, "".concat(prefixCls, "-scrollbar-thumb-moving"), dragging)),
      "style": {
        width: "100%",
        height: spinHeight,
        top,
        left: 0,
        position: "absolute",
        background: "rgba(0, 0, 0, 0.5)",
        borderRadius: "99px",
        cursor: "pointer",
        userSelect: "none"
      },
      "onMousedown": this.onMouseDown
    }, null)]);
  }
});
function useHeights(mergedData, getKey2, onItemAdd, onItemRemove) {
  var instance = /* @__PURE__ */ new Map();
  var heights = /* @__PURE__ */ new Map();
  var updatedMark = ref(Symbol("update"));
  watch(mergedData, function() {
    updatedMark.value = Symbol("update");
  });
  var heightUpdateId = 0;
  function collectHeight() {
    heightUpdateId += 1;
    var currentId = heightUpdateId;
    Promise.resolve().then(function() {
      if (currentId !== heightUpdateId)
        return;
      instance.forEach(function(element, key2) {
        if (element && element.offsetParent) {
          var offsetHeight = element.offsetHeight;
          if (heights.get(key2) !== offsetHeight) {
            updatedMark.value = Symbol("update");
            heights.set(key2, element.offsetHeight);
          }
        }
      });
    });
  }
  function setInstance(item, ins) {
    var key2 = getKey2(item);
    var origin = instance.get(key2);
    if (ins) {
      instance.set(key2, ins.$el || ins);
      collectHeight();
    } else {
      instance.delete(key2);
    }
    if (!origin !== !ins) {
      if (ins) {
        onItemAdd === null || onItemAdd === void 0 ? void 0 : onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(item);
      }
    }
  }
  return [setInstance, collectHeight, heights, updatedMark];
}
function useScrollTo(containerRef, mergedData, heights, props2, getKey2, collectHeight, syncScrollTop, triggerFlash) {
  var scroll;
  return function(arg) {
    if (arg === null || arg === void 0) {
      triggerFlash();
      return;
    }
    wrapperRaf.cancel(scroll);
    var data4 = mergedData.value;
    var itemHeight = props2.itemHeight;
    if (typeof arg === "number") {
      syncScrollTop(arg);
    } else if (arg && _typeof$1(arg) === "object") {
      var index2;
      var align = arg.align;
      if ("index" in arg) {
        index2 = arg.index;
      } else {
        index2 = data4.findIndex(function(item) {
          return getKey2(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset, offset3 = _arg$offset === void 0 ? 0 : _arg$offset;
      var syncScroll = function syncScroll2(times, targetAlign) {
        if (times < 0 || !containerRef.value)
          return;
        var height = containerRef.value.clientHeight;
        var needCollectHeight = false;
        var newTargetAlign = targetAlign;
        if (height) {
          var mergedAlign = targetAlign || align;
          var stackTop = 0;
          var itemTop = 0;
          var itemBottom = 0;
          var maxLen = Math.min(data4.length, index2);
          for (var i = 0; i <= maxLen; i += 1) {
            var key2 = getKey2(data4[i]);
            itemTop = stackTop;
            var cacheHeight = heights.get(key2);
            itemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
            stackTop = itemBottom;
            if (i === index2 && cacheHeight === void 0) {
              needCollectHeight = true;
            }
          }
          var scrollTop = containerRef.value.scrollTop;
          var targetTop = null;
          switch (mergedAlign) {
            case "top":
              targetTop = itemTop - offset3;
              break;
            case "bottom":
              targetTop = itemBottom - height + offset3;
              break;
            default: {
              var scrollBottom = scrollTop + height;
              if (itemTop < scrollTop) {
                newTargetAlign = "top";
              } else if (itemBottom > scrollBottom) {
                newTargetAlign = "bottom";
              }
            }
          }
          if (targetTop !== null && targetTop !== scrollTop) {
            syncScrollTop(targetTop);
          }
        }
        scroll = wrapperRaf(function() {
          if (needCollectHeight) {
            collectHeight();
          }
          syncScroll2(times - 1, newTargetAlign);
        });
      };
      syncScroll(5);
    }
  };
}
var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof$1(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var isFF$1 = isFF;
var useOriginScroll = function(isScrollAtTop, isScrollAtBottom) {
  var lock = false;
  var lockTimeout = null;
  function lockScroll() {
    clearTimeout(lockTimeout);
    lock = true;
    lockTimeout = setTimeout(function() {
      lock = false;
    }, 50);
  }
  return function(deltaY) {
    var smoothOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var originScroll = deltaY < 0 && isScrollAtTop.value || deltaY > 0 && isScrollAtBottom.value;
    if (smoothOffset && originScroll) {
      clearTimeout(lockTimeout);
      lock = false;
    } else if (!originScroll || lock) {
      lockScroll();
    }
    return !lock && originScroll;
  };
};
function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, onWheelDelta) {
  var offsetRef = 0;
  var nextFrame = null;
  var wheelValue = null;
  var isMouseScroll = false;
  var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);
  function onWheel(event) {
    if (!inVirtual.value)
      return;
    wrapperRaf.cancel(nextFrame);
    var deltaY = event.deltaY;
    offsetRef += deltaY;
    wheelValue = deltaY;
    if (originScroll(deltaY))
      return;
    if (!isFF$1) {
      event.preventDefault();
    }
    nextFrame = wrapperRaf(function() {
      var patchMultiple = isMouseScroll ? 10 : 1;
      onWheelDelta(offsetRef * patchMultiple);
      offsetRef = 0;
    });
  }
  function onFireFoxScroll(event) {
    if (!inVirtual.value)
      return;
    isMouseScroll = event.detail === wheelValue;
  }
  return [onWheel, onFireFoxScroll];
}
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touched = false;
  var touchY = 0;
  var element = null;
  var interval = null;
  var cleanUpEvents = function cleanUpEvents2() {
    if (element) {
      element.removeEventListener("touchmove", onTouchMove);
      element.removeEventListener("touchend", onTouchEnd);
    }
  };
  var onTouchMove = function onTouchMove2(e2) {
    if (touched) {
      var currentY = Math.ceil(e2.touches[0].pageY);
      var offsetY = touchY - currentY;
      touchY = currentY;
      if (callback(offsetY)) {
        e2.preventDefault();
      }
      clearInterval(interval);
      interval = setInterval(function() {
        offsetY *= SMOOTH_PTG;
        if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) {
          clearInterval(interval);
        }
      }, 16);
    }
  };
  var onTouchEnd = function onTouchEnd2() {
    touched = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart2(e2) {
    cleanUpEvents();
    if (e2.touches.length === 1 && !touched) {
      touched = true;
      touchY = Math.ceil(e2.touches[0].pageY);
      element = e2.target;
      element.addEventListener("touchmove", onTouchMove, {
        passive: false
      });
      element.addEventListener("touchend", onTouchEnd);
    }
  };
  var noop2 = function noop3() {
  };
  onMounted(function() {
    document.addEventListener("touchmove", noop2, {
      passive: false
    });
    watch(inVirtual, function(val) {
      listRef.value.removeEventListener("touchstart", onTouchStart);
      cleanUpEvents();
      clearInterval(interval);
      if (val) {
        listRef.value.addEventListener("touchstart", onTouchStart, {
          passive: false
        });
      }
    }, {
      immediate: true
    });
  });
  onBeforeUnmount(function() {
    document.removeEventListener("touchmove", noop2);
  });
}
var __rest$a = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function renderChildren(list, startIndex, endIndex, setNodeRef, renderFunc, _ref) {
  var getKey2 = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function(item, index2) {
    var eleIndex = startIndex + index2;
    var node = renderFunc(item, eleIndex, {});
    var key2 = getKey2(item);
    return createVNode(Item$1, {
      "key": key2,
      "setRef": function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, {
      default: function _default3() {
        return [node];
      }
    });
  });
}
var List$1 = defineComponent({
  name: "List",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    data: PropTypes$1.array,
    height: Number,
    itemHeight: Number,
    fullHeight: {
      type: Boolean,
      default: void 0
    },
    itemKey: {
      type: [String, Number, Function],
      required: true
    },
    component: {
      type: [String, Object]
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    children: Function,
    onScroll: Function,
    onMousedown: Function,
    onMouseenter: Function,
    onVisibleChange: Function
  },
  setup: function setup24(props2, _ref2) {
    var expose = _ref2.expose;
    var useVirtual = computed(function() {
      var height = props2.height, itemHeight = props2.itemHeight, virtual = props2.virtual;
      return !!(virtual !== false && height && itemHeight);
    });
    var inVirtual = computed(function() {
      var height = props2.height, itemHeight = props2.itemHeight, data5 = props2.data;
      return useVirtual.value && data5 && itemHeight * data5.length > height;
    });
    var state = reactive({
      scrollTop: 0,
      scrollMoving: false
    });
    var data4 = computed(function() {
      return props2.data || EMPTY_DATA;
    });
    var mergedData = shallowRef([]);
    watch(data4, function() {
      mergedData.value = toRaw(data4.value).slice();
    }, {
      immediate: true
    });
    var itemKey = shallowRef(function(_item) {
      return void 0;
    });
    watch(function() {
      return props2.itemKey;
    }, function(val) {
      if (typeof val === "function") {
        itemKey.value = val;
      } else {
        itemKey.value = function(item) {
          return item === null || item === void 0 ? void 0 : item[val];
        };
      }
    }, {
      immediate: true
    });
    var componentRef = ref();
    var fillerInnerRef = ref();
    var scrollBarRef = ref();
    var getKey2 = function getKey3(item) {
      return itemKey.value(item);
    };
    var sharedConfig = {
      getKey: getKey2
    };
    function syncScrollTop(newTop) {
      var value;
      if (typeof newTop === "function") {
        value = newTop(state.scrollTop);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      if (componentRef.value) {
        componentRef.value.scrollTop = alignedTop;
      }
      state.scrollTop = alignedTop;
    }
    var _useHeights = useHeights(mergedData, getKey2, null, null), _useHeights2 = _slicedToArray$2(_useHeights, 4), setInstance = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], updatedMark = _useHeights2[3];
    var calRes = reactive({
      scrollHeight: void 0,
      start: 0,
      end: 0,
      offset: void 0
    });
    var offsetHeight = ref(0);
    onMounted(function() {
      nextTick(function() {
        var _a;
        offsetHeight.value = ((_a = fillerInnerRef.value) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
      });
    });
    onUpdated(function() {
      nextTick(function() {
        var _a;
        offsetHeight.value = ((_a = fillerInnerRef.value) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
      });
    });
    watch([useVirtual, mergedData], function() {
      if (!useVirtual.value) {
        _extends(calRes, {
          scrollHeight: void 0,
          start: 0,
          end: mergedData.value.length - 1,
          offset: void 0
        });
      }
    }, {
      immediate: true
    });
    watch([useVirtual, mergedData, offsetHeight, inVirtual], function() {
      if (useVirtual.value && !inVirtual.value) {
        _extends(calRes, {
          scrollHeight: offsetHeight.value,
          start: 0,
          end: mergedData.value.length - 1,
          offset: void 0
        });
      }
    }, {
      immediate: true
    });
    watch([inVirtual, useVirtual, function() {
      return state.scrollTop;
    }, mergedData, updatedMark, function() {
      return props2.height;
    }, offsetHeight], function() {
      if (!useVirtual.value || !inVirtual.value) {
        return;
      }
      var itemTop = 0;
      var startIndex;
      var startOffset;
      var endIndex;
      var dataLen = mergedData.value.length;
      var data5 = mergedData.value;
      var scrollTop = state.scrollTop;
      var itemHeight = props2.itemHeight, height = props2.height;
      var scrollTopHeight = scrollTop + height;
      for (var i = 0; i < dataLen; i += 1) {
        var item = data5[i];
        var key2 = getKey2(item);
        var cacheHeight = heights.get(key2);
        if (cacheHeight === void 0) {
          cacheHeight = itemHeight;
        }
        var currentItemBottom = itemTop + cacheHeight;
        if (startIndex === void 0 && currentItemBottom >= scrollTop) {
          startIndex = i;
          startOffset = itemTop;
        }
        if (endIndex === void 0 && currentItemBottom > scrollTopHeight) {
          endIndex = i;
        }
        itemTop = currentItemBottom;
      }
      if (startIndex === void 0) {
        startIndex = 0;
        startOffset = 0;
      }
      if (endIndex === void 0) {
        endIndex = dataLen - 1;
      }
      endIndex = Math.min(endIndex + 1, dataLen);
      _extends(calRes, {
        scrollHeight: itemTop,
        start: startIndex,
        end: endIndex,
        offset: startOffset
      });
    }, {
      immediate: true
    });
    var maxScrollHeight = computed(function() {
      return calRes.scrollHeight - props2.height;
    });
    function keepInRange(newScrollTop) {
      var newTop = newScrollTop;
      if (!Number.isNaN(maxScrollHeight.value)) {
        newTop = Math.min(newTop, maxScrollHeight.value);
      }
      newTop = Math.max(newTop, 0);
      return newTop;
    }
    var isScrollAtTop = computed(function() {
      return state.scrollTop <= 0;
    });
    var isScrollAtBottom = computed(function() {
      return state.scrollTop >= maxScrollHeight.value;
    });
    var originScroll = useOriginScroll(isScrollAtTop, isScrollAtBottom);
    function onScrollBar(newScrollTop) {
      var newTop = newScrollTop;
      syncScrollTop(newTop);
    }
    function onFallbackScroll(e2) {
      var _a;
      var newScrollTop = e2.currentTarget.scrollTop;
      if (Math.abs(newScrollTop - state.scrollTop) >= 1) {
        syncScrollTop(newScrollTop);
      }
      (_a = props2.onScroll) === null || _a === void 0 ? void 0 : _a.call(props2, e2);
    }
    var _useFrameWheel = useFrameWheel(useVirtual, isScrollAtTop, isScrollAtBottom, function(offsetY) {
      syncScrollTop(function(top) {
        var newTop = top + offsetY;
        return newTop;
      });
    }), _useFrameWheel2 = _slicedToArray$2(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
    useMobileTouchMove(useVirtual, componentRef, function(deltaY, smoothOffset) {
      if (originScroll(deltaY, smoothOffset)) {
        return false;
      }
      onRawWheel({
        preventDefault: function preventDefault() {
        },
        deltaY
      });
      return true;
    });
    function onMozMousePixelScroll(e2) {
      if (useVirtual.value) {
        e2.preventDefault();
      }
    }
    var removeEventListener2 = function removeEventListener3() {
      if (componentRef.value) {
        componentRef.value.removeEventListener("wheel", onRawWheel, supportsPassive$1 ? {
          passive: false
        } : false);
        componentRef.value.removeEventListener("DOMMouseScroll", onFireFoxScroll);
        componentRef.value.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
      }
    };
    watchEffect(function() {
      nextTick(function() {
        if (componentRef.value) {
          removeEventListener2();
          componentRef.value.addEventListener("wheel", onRawWheel, supportsPassive$1 ? {
            passive: false
          } : false);
          componentRef.value.addEventListener("DOMMouseScroll", onFireFoxScroll);
          componentRef.value.addEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        }
      });
    });
    onBeforeUnmount(function() {
      removeEventListener2();
    });
    var scrollTo = useScrollTo(componentRef, mergedData, heights, props2, getKey2, collectHeight, syncScrollTop, function() {
      var _a;
      (_a = scrollBarRef.value) === null || _a === void 0 ? void 0 : _a.delayHidden();
    });
    expose({
      scrollTo
    });
    var componentStyle = computed(function() {
      var cs = null;
      if (props2.height) {
        cs = _extends(_defineProperty$m({}, props2.fullHeight ? "height" : "maxHeight", props2.height + "px"), ScrollStyle);
        if (useVirtual.value) {
          cs.overflowY = "hidden";
          if (state.scrollMoving) {
            cs.pointerEvents = "none";
          }
        }
      }
      return cs;
    });
    watch([function() {
      return calRes.start;
    }, function() {
      return calRes.end;
    }, mergedData], function() {
      if (props2.onVisibleChange) {
        var renderList2 = mergedData.value.slice(calRes.start, calRes.end + 1);
        props2.onVisibleChange(renderList2, mergedData.value);
      }
    }, {
      flush: "post"
    });
    return {
      state,
      mergedData,
      componentStyle,
      onFallbackScroll,
      onScrollBar,
      componentRef,
      useVirtual,
      calRes,
      collectHeight,
      setInstance,
      sharedConfig,
      scrollBarRef,
      fillerInnerRef
    };
  },
  render: function render4() {
    var _this = this;
    var _a = _extends(_extends({}, this.$props), this.$attrs), _a$prefixCls = _a.prefixCls, prefixCls = _a$prefixCls === void 0 ? "rc-virtual-list" : _a$prefixCls, height = _a.height;
    _a.itemHeight;
    _a.fullHeight;
    _a.data;
    _a.itemKey;
    _a.virtual;
    var _a$component = _a.component, Component = _a$component === void 0 ? "div" : _a$component;
    _a.onScroll;
    var _a$children = _a.children, children = _a$children === void 0 ? this.$slots.default : _a$children, style2 = _a.style, className = _a.class, restProps = __rest$a(_a, ["prefixCls", "height", "itemHeight", "fullHeight", "data", "itemKey", "virtual", "component", "onScroll", "children", "style", "class"]);
    var mergedClassName = classNames(prefixCls, className);
    var scrollTop = this.state.scrollTop;
    var _this$calRes = this.calRes, scrollHeight = _this$calRes.scrollHeight, offset3 = _this$calRes.offset, start = _this$calRes.start, end = _this$calRes.end;
    var componentStyle = this.componentStyle, onFallbackScroll = this.onFallbackScroll, onScrollBar = this.onScrollBar, useVirtual = this.useVirtual, collectHeight = this.collectHeight, sharedConfig = this.sharedConfig, setInstance = this.setInstance, mergedData = this.mergedData;
    return createVNode("div", _objectSpread2$1({
      "style": _extends(_extends({}, style2), {
        position: "relative"
      }),
      "class": mergedClassName
    }, restProps), [createVNode(Component, {
      "class": "".concat(prefixCls, "-holder"),
      "style": componentStyle,
      "ref": "componentRef",
      "onScroll": onFallbackScroll
    }, {
      default: function _default3() {
        return [createVNode(Filler, {
          "prefixCls": prefixCls,
          "height": scrollHeight,
          "offset": offset3,
          "onInnerResize": collectHeight,
          "ref": "fillerInnerRef"
        }, {
          default: function _default4() {
            return renderChildren(mergedData, start, end, setInstance, children, sharedConfig);
          }
        })];
      }
    }), useVirtual && createVNode(ScrollBar, {
      "ref": "scrollBarRef",
      "prefixCls": prefixCls,
      "scrollTop": scrollTop,
      "height": height,
      "scrollHeight": scrollHeight,
      "count": mergedData.length,
      "onScroll": onScrollBar,
      "onStartMove": function onStartMove() {
        _this.state.scrollMoving = true;
      },
      "onStopMove": function onStopMove() {
        _this.state.scrollMoving = false;
      }
    }, null)]);
  }
});
var List$2 = List$1;
function useMemo(getValue2, condition, shouldUpdate) {
  var cacheRef = ref(getValue2());
  watch(condition, function(next2, pre) {
    if (shouldUpdate) {
      if (shouldUpdate(next2, pre)) {
        cacheRef.value = getValue2();
      }
    } else {
      cacheRef.value = getValue2();
    }
  });
  return cacheRef;
}
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}
var SelectContextKey = Symbol("SelectContextKey");
function useProvideSelectProps(props2) {
  return provide(SelectContextKey, props2);
}
function useSelectProps() {
  return inject(SelectContextKey, {});
}
var __rest$9 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function isTitleType(content) {
  return typeof content === "string" || typeof content === "number";
}
var OptionList$1 = defineComponent({
  name: "OptionList",
  inheritAttrs: false,
  slots: ["option"],
  setup: function setup25(_2, _ref) {
    var expose = _ref.expose, slots = _ref.slots;
    var baseProps = useBaseProps();
    var props2 = useSelectProps();
    var itemPrefixCls = computed(function() {
      return "".concat(baseProps.prefixCls, "-item");
    });
    var memoFlattenOptions = useMemo(function() {
      return props2.flattenOptions;
    }, [function() {
      return baseProps.open;
    }, function() {
      return props2.flattenOptions;
    }], function(next2) {
      return next2[0];
    });
    var listRef = createRef();
    var onListMouseDown = function onListMouseDown2(event) {
      event.preventDefault();
    };
    var scrollIntoView = function scrollIntoView2(args) {
      if (listRef.current) {
        listRef.current.scrollTo(typeof args === "number" ? {
          index: args
        } : args);
      }
    };
    var getEnabledActiveIndex = function getEnabledActiveIndex2(index2) {
      var offset3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      var len = memoFlattenOptions.value.length;
      for (var i = 0; i < len; i += 1) {
        var current2 = (index2 + i * offset3 + len) % len;
        var _memoFlattenOptions$v = memoFlattenOptions.value[current2], group = _memoFlattenOptions$v.group, data4 = _memoFlattenOptions$v.data;
        if (!group && !data4.disabled) {
          return current2;
        }
      }
      return -1;
    };
    var state = reactive({
      activeIndex: getEnabledActiveIndex(0)
    });
    var setActive = function setActive2(index2) {
      var fromKeyboard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      state.activeIndex = index2;
      var info = {
        source: fromKeyboard ? "keyboard" : "mouse"
      };
      var flattenItem = memoFlattenOptions.value[index2];
      if (!flattenItem) {
        props2.onActiveValue(null, -1, info);
        return;
      }
      props2.onActiveValue(flattenItem.value, index2, info);
    };
    watch([function() {
      return memoFlattenOptions.value.length;
    }, function() {
      return baseProps.searchValue;
    }], function() {
      setActive(props2.defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, {
      immediate: true
    });
    var isSelected = function isSelected2(value) {
      return props2.rawValues.has(value) && baseProps.mode !== "combobox";
    };
    watch([function() {
      return baseProps.open;
    }, function() {
      return baseProps.searchValue;
    }], function() {
      if (!baseProps.multiple && baseProps.open && props2.rawValues.size === 1) {
        var value = Array.from(props2.rawValues)[0];
        var index2 = toRaw(memoFlattenOptions.value).findIndex(function(_ref2) {
          var data4 = _ref2.data;
          return data4[props2.fieldNames.value] === value;
        });
        if (index2 !== -1) {
          setActive(index2);
          nextTick(function() {
            scrollIntoView(index2);
          });
        }
      }
      if (baseProps.open) {
        nextTick(function() {
          var _a;
          (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(void 0);
        });
      }
    }, {
      immediate: true,
      flush: "post"
    });
    var onSelectValue = function onSelectValue2(value) {
      if (value !== void 0) {
        props2.onSelect(value, {
          selected: !props2.rawValues.has(value)
        });
      }
      if (!baseProps.multiple) {
        baseProps.toggleOpen(false);
      }
    };
    var getLabel = function getLabel2(item) {
      return typeof item.label === "function" ? item.label() : item.label;
    };
    function renderItem(index2) {
      var item = memoFlattenOptions.value[index2];
      if (!item)
        return null;
      var itemData = item.data || {};
      var value = itemData.value;
      var group = item.group;
      var attrs = pickAttrs(itemData, true);
      var mergedLabel = getLabel(item);
      return item ? createVNode("div", _objectSpread2$1(_objectSpread2$1({
        "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
      }, attrs), {}, {
        "key": index2,
        "role": group ? "presentation" : "option",
        "id": "".concat(baseProps.id, "_list_").concat(index2),
        "aria-selected": isSelected(value)
      }), [value]) : null;
    }
    var onKeydown = function onKeydown2(event) {
      var which = event.which, ctrlKey = event.ctrlKey;
      switch (which) {
        case KeyCode$1.N:
        case KeyCode$1.P:
        case KeyCode$1.UP:
        case KeyCode$1.DOWN: {
          var offset3 = 0;
          if (which === KeyCode$1.UP) {
            offset3 = -1;
          } else if (which === KeyCode$1.DOWN) {
            offset3 = 1;
          } else if (isPlatformMac() && ctrlKey) {
            if (which === KeyCode$1.N) {
              offset3 = 1;
            } else if (which === KeyCode$1.P) {
              offset3 = -1;
            }
          }
          if (offset3 !== 0) {
            var nextActiveIndex = getEnabledActiveIndex(state.activeIndex + offset3, offset3);
            scrollIntoView(nextActiveIndex);
            setActive(nextActiveIndex, true);
          }
          break;
        }
        case KeyCode$1.ENTER: {
          var item = memoFlattenOptions.value[state.activeIndex];
          if (item && !item.data.disabled) {
            onSelectValue(item.value);
          } else {
            onSelectValue(void 0);
          }
          if (baseProps.open) {
            event.preventDefault();
          }
          break;
        }
        case KeyCode$1.ESC: {
          baseProps.toggleOpen(false);
          if (baseProps.open) {
            event.stopPropagation();
          }
        }
      }
    };
    var onKeyup = function onKeyup2() {
    };
    var scrollTo = function scrollTo2(index2) {
      scrollIntoView(index2);
    };
    expose({
      onKeydown,
      onKeyup,
      scrollTo
    });
    return function() {
      var id = baseProps.id, notFoundContent = baseProps.notFoundContent, onPopupScroll = baseProps.onPopupScroll;
      var menuItemSelectedIcon = props2.menuItemSelectedIcon, fieldNames = props2.fieldNames, virtual = props2.virtual, listHeight = props2.listHeight, listItemHeight = props2.listItemHeight;
      var renderOption = slots.option;
      var activeIndex = state.activeIndex;
      var omitFieldNameList = Object.keys(fieldNames).map(function(key2) {
        return fieldNames[key2];
      });
      if (memoFlattenOptions.value.length === 0) {
        return createVNode("div", {
          "role": "listbox",
          "id": "".concat(id, "_list"),
          "class": "".concat(itemPrefixCls.value, "-empty"),
          "onMousedown": onListMouseDown
        }, [notFoundContent]);
      }
      return createVNode(Fragment, null, [createVNode("div", {
        "role": "listbox",
        "id": "".concat(id, "_list"),
        "style": {
          height: 0,
          width: 0,
          overflow: "hidden"
        }
      }, [renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)]), createVNode(List$2, {
        "itemKey": "key",
        "ref": listRef,
        "data": memoFlattenOptions.value,
        "height": listHeight,
        "itemHeight": listItemHeight,
        "fullHeight": false,
        "onMousedown": onListMouseDown,
        "onScroll": onPopupScroll,
        "virtual": virtual
      }, {
        default: function _default3(item, itemIndex) {
          var _classNames;
          var _a;
          var group = item.group, groupOption = item.groupOption, data4 = item.data, value = item.value;
          var key2 = data4.key;
          var label = typeof item.label === "function" ? item.label() : item.label;
          if (group) {
            var groupTitle = (_a = data4.title) !== null && _a !== void 0 ? _a : isTitleType(label) && label;
            return createVNode("div", {
              "class": classNames(itemPrefixCls.value, "".concat(itemPrefixCls.value, "-group")),
              "title": groupTitle
            }, [renderOption ? renderOption(data4) : label !== void 0 ? label : key2]);
          }
          var disabled = data4.disabled, title = data4.title;
          data4.children;
          var style2 = data4.style, cls = data4.class, className = data4.className, otherProps = __rest$9(data4, ["disabled", "title", "children", "style", "class", "className"]);
          var passedProps = omit(otherProps, omitFieldNameList);
          var selected = isSelected(value);
          var optionPrefixCls = "".concat(itemPrefixCls.value, "-option");
          var optionClassName = classNames(itemPrefixCls.value, optionPrefixCls, cls, className, (_classNames = {}, _defineProperty$m(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), _defineProperty$m(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !disabled), _defineProperty$m(_classNames, "".concat(optionPrefixCls, "-disabled"), disabled), _defineProperty$m(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
          var mergedLabel = getLabel(item);
          var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
          var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
          var optionTitle = isTitleType(content) ? content.toString() : void 0;
          if (title !== void 0) {
            optionTitle = title;
          }
          return createVNode("div", _objectSpread2$1(_objectSpread2$1({}, passedProps), {}, {
            "aria-selected": selected,
            "class": optionClassName,
            "title": optionTitle,
            "onMousemove": function onMousemove(e2) {
              if (otherProps.onMousemove) {
                otherProps.onMousemove(e2);
              }
              if (activeIndex === itemIndex || disabled) {
                return;
              }
              setActive(itemIndex);
            },
            "onClick": function onClick2(e2) {
              if (!disabled) {
                onSelectValue(value);
              }
              if (otherProps.onClick) {
                otherProps.onClick(e2);
              }
            },
            "style": style2
          }), [createVNode("div", {
            "class": "".concat(optionPrefixCls, "-content")
          }, [renderOption ? renderOption(data4) : content]), isValidElement(menuItemSelectedIcon) || selected, iconVisible && createVNode(TransBtn$1, {
            "class": "".concat(itemPrefixCls.value, "-option-state"),
            "customizeIcon": menuItemSelectedIcon,
            "customizeIconProps": {
              isSelected: selected
            }
          }, {
            default: function _default4() {
              return [selected ? "\u2713" : null];
            }
          })]);
        }
      })]);
    };
  }
});
var OptionList$2 = OptionList$1;
var __rest$8 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function convertNodeToOption(node) {
  var _a = node, key2 = _a.key, children = _a.children, _b = _a.props, value = _b.value, disabled = _b.disabled, restProps = __rest$8(_b, ["value", "disabled"]);
  var child = children === null || children === void 0 ? void 0 : children.default;
  return _extends({
    key: key2,
    value: value !== void 0 ? value : key2,
    children: child,
    disabled: disabled || disabled === ""
  }, restProps);
}
function convertChildrenToData(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var dd = flattenChildren(nodes).map(function(node, index2) {
    var _a;
    if (!isValidElement(node) || !node.type) {
      return null;
    }
    var isSelectOptGroup = node.type.isSelectOptGroup, key2 = node.key, children = node.children, props2 = node.props;
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node);
    }
    var child = children && children.default ? children.default() : void 0;
    var label = (props2 === null || props2 === void 0 ? void 0 : props2.label) || ((_a = children.label) === null || _a === void 0 ? void 0 : _a.call(children)) || key2;
    return _extends(_extends({
      key: "__RC_SELECT_GRP__".concat(key2 === null ? index2 : String(key2), "__")
    }, props2), {
      label,
      options: convertChildrenToData(child || [])
    });
  }).filter(function(data4) {
    return data4;
  });
  return dd;
}
function useOptions(options, children, fieldNames) {
  var mergedOptions = shallowRef();
  var valueOptions = shallowRef();
  var labelOptions = shallowRef();
  var tempMergedOptions = shallowRef([]);
  watch([options, children], function() {
    if (options.value) {
      tempMergedOptions.value = toRaw(options.value).slice();
    } else {
      tempMergedOptions.value = convertChildrenToData(children.value);
    }
  }, {
    immediate: true,
    deep: true
  });
  watchEffect(function() {
    var newOptions = tempMergedOptions.value;
    var newValueOptions = /* @__PURE__ */ new Map();
    var newLabelOptions = /* @__PURE__ */ new Map();
    var fieldNamesValue = fieldNames.value;
    function dig(optionList) {
      var isChildren = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      for (var i = 0; i < optionList.length; i += 1) {
        var option = optionList[i];
        if (!option[fieldNamesValue.options] || isChildren) {
          newValueOptions.set(option[fieldNamesValue.value], option);
          newLabelOptions.set(option[fieldNamesValue.label], option);
        } else {
          dig(option[fieldNamesValue.options], true);
        }
      }
    }
    dig(newOptions);
    mergedOptions.value = newOptions;
    valueOptions.value = newValueOptions;
    labelOptions.value = newLabelOptions;
  });
  return {
    options: mergedOptions,
    valueOptions,
    labelOptions
  };
}
var uuid$2 = 0;
var isBrowserClient = canUseDom();
function getUUID$1() {
  var retId;
  if (isBrowserClient) {
    retId = uuid$2;
    uuid$2 += 1;
  } else {
    retId = "TEST_OR_SSR";
  }
  return retId;
}
function useId() {
  var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ref("");
  var innerId = "rc_select_".concat(getUUID$1());
  return id.value || innerId;
}
function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
function includes(test, search) {
  return toArray(test).join("").toUpperCase().includes(search);
}
var useFilterOptions = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
  return computed(function() {
    var searchValueVal = searchValue.value;
    var optionFilterPropValue = optionFilterProp === null || optionFilterProp === void 0 ? void 0 : optionFilterProp.value;
    var filterOptionValue = filterOption === null || filterOption === void 0 ? void 0 : filterOption.value;
    if (!searchValueVal || filterOptionValue === false) {
      return options.value;
    }
    var _fieldNames$value = fieldNames.value, fieldOptions = _fieldNames$value.options, fieldLabel = _fieldNames$value.label, fieldValue = _fieldNames$value.value;
    var filteredOptions = [];
    var customizeFilter = typeof filterOptionValue === "function";
    var upperSearch = searchValueVal.toUpperCase();
    var filterFunc = customizeFilter ? filterOptionValue : function(_2, option) {
      if (optionFilterPropValue) {
        return includes(option[optionFilterPropValue], upperSearch);
      }
      if (option[fieldOptions]) {
        return includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
      }
      return includes(option[fieldValue], upperSearch);
    };
    var wrapOption = customizeFilter ? function(opt) {
      return injectPropsWithOption(opt);
    } : function(opt) {
      return opt;
    };
    options.value.forEach(function(item) {
      if (item[fieldOptions]) {
        var matchGroup = filterFunc(searchValueVal, wrapOption(item));
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          var subOptions = item[fieldOptions].filter(function(subItem) {
            return filterFunc(searchValueVal, wrapOption(subItem));
          });
          if (subOptions.length) {
            filteredOptions.push(_extends(_extends({}, item), _defineProperty$m({}, fieldOptions, subOptions)));
          }
        }
        return;
      }
      if (filterFunc(searchValueVal, wrapOption(item))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  });
};
var useCache = function(labeledValues, valueOptions) {
  var cacheRef = shallowRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  });
  var filledLabeledValues = computed(function() {
    var _cacheRef$value = cacheRef.value, prevValueCache = _cacheRef$value.values, prevOptionCache = _cacheRef$value.options;
    var patchedValues = labeledValues.value.map(function(item) {
      var _a;
      if (item.label === void 0) {
        return _extends(_extends({}, item), {
          label: (_a = prevValueCache.get(item.value)) === null || _a === void 0 ? void 0 : _a.label
        });
      }
      return item;
    });
    var valueCache = /* @__PURE__ */ new Map();
    var optionCache = /* @__PURE__ */ new Map();
    patchedValues.forEach(function(item) {
      valueCache.set(item.value, item);
      optionCache.set(item.value, valueOptions.value.get(item.value) || prevOptionCache.get(item.value));
    });
    cacheRef.value.values = valueCache;
    cacheRef.value.options = optionCache;
    return patchedValues;
  });
  var getOption = function getOption2(val) {
    return valueOptions.value.get(val) || cacheRef.value.options.get(val);
  };
  return [filledLabeledValues, getOption];
};
function useMergedState(defaultStateValue, option) {
  var _ref = option || {}, defaultValue = _ref.defaultValue, _ref$value = _ref.value, value = _ref$value === void 0 ? ref() : _ref$value;
  var initValue = typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
  if (value.value !== void 0) {
    initValue = unref(value);
  }
  if (defaultValue !== void 0) {
    initValue = typeof defaultValue === "function" ? defaultValue() : defaultValue;
  }
  var innerValue = ref(initValue);
  var mergedValue = ref(initValue);
  watchEffect(function() {
    var val = value.value !== void 0 ? value.value : innerValue.value;
    if (option.postState) {
      val = option.postState(val);
    }
    mergedValue.value = val;
  });
  function triggerChange(newValue) {
    var preVal = mergedValue.value;
    innerValue.value = newValue;
    if (toRaw(mergedValue.value) !== newValue && option.onChange) {
      option.onChange(newValue, preVal);
    }
  }
  watch(value, function() {
    innerValue.value = value.value;
  });
  return [mergedValue, triggerChange];
}
function useState(defaultStateValue) {
  var initValue = typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
  var innerValue = ref(initValue);
  function triggerChange(newValue) {
    innerValue.value = newValue;
  }
  return [innerValue, triggerChange];
}
var OMIT_DOM_PROPS = ["inputValue"];
function selectProps$1() {
  return _extends(_extends({}, baseSelectPropsWithoutPrivate()), {
    prefixCls: String,
    id: String,
    backfill: {
      type: Boolean,
      default: void 0
    },
    fieldNames: Object,
    inputValue: String,
    searchValue: String,
    onSearch: Function,
    autoClearSearchValue: {
      type: Boolean,
      default: void 0
    },
    onSelect: Function,
    onDeselect: Function,
    filterOption: {
      type: [Boolean, Function],
      default: void 0
    },
    filterSort: Function,
    optionFilterProp: String,
    optionLabelProp: String,
    options: Array,
    defaultActiveFirstOption: {
      type: Boolean,
      default: void 0
    },
    virtual: {
      type: Boolean,
      default: void 0
    },
    listHeight: Number,
    listItemHeight: Number,
    menuItemSelectedIcon: PropTypes$1.any,
    mode: String,
    labelInValue: {
      type: Boolean,
      default: void 0
    },
    value: PropTypes$1.any,
    defaultValue: PropTypes$1.any,
    onChange: Function,
    children: Array
  });
}
function isRawValue(value) {
  return !value || _typeof$1(value) !== "object";
}
var Select$1 = defineComponent({
  name: "Select",
  inheritAttrs: false,
  props: initDefaultProps$1(selectProps$1(), {
    prefixCls: "vc-select",
    autoClearSearchValue: true,
    listHeight: 200,
    listItemHeight: 20,
    dropdownMatchSelectWidth: true
  }),
  setup: function setup26(props2, _ref) {
    var expose = _ref.expose, attrs = _ref.attrs, slots = _ref.slots;
    var mergedId = useId(toRef(props2, "id"));
    var multiple = computed(function() {
      return isMultiple(props2.mode);
    });
    var childrenAsData = computed(function() {
      return !!(!props2.options && props2.children);
    });
    var mergedFilterOption = computed(function() {
      if (props2.filterOption === void 0 && props2.mode === "combobox") {
        return false;
      }
      return props2.filterOption;
    });
    var mergedFieldNames = computed(function() {
      return fillFieldNames$2(props2.fieldNames, childrenAsData.value);
    });
    var _useMergedState = useMergedState("", {
      value: computed(function() {
        return props2.searchValue !== void 0 ? props2.searchValue : props2.inputValue;
      }),
      postState: function postState(search) {
        return search || "";
      }
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
    var parsedOptions = useOptions(toRef(props2, "options"), toRef(props2, "children"), mergedFieldNames);
    var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
    var convert2LabelValues = function convert2LabelValues2(draftValues) {
      var valueList = toArray(draftValues);
      return valueList.map(function(val) {
        var _a, _b;
        var rawValue;
        var rawLabel;
        var rawKey;
        var rawDisabled;
        if (isRawValue(val)) {
          rawValue = val;
        } else {
          rawKey = val.key;
          rawLabel = val.label;
          rawValue = (_a = val.value) !== null && _a !== void 0 ? _a : rawKey;
        }
        var option = valueOptions.value.get(rawValue);
        if (option) {
          if (rawLabel === void 0)
            rawLabel = option === null || option === void 0 ? void 0 : option[props2.optionLabelProp || mergedFieldNames.value.label];
          if (rawKey === void 0)
            rawKey = (_b = option === null || option === void 0 ? void 0 : option.key) !== null && _b !== void 0 ? _b : rawValue;
          rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
        }
        return {
          label: rawLabel,
          value: rawValue,
          key: rawKey,
          disabled: rawDisabled,
          option
        };
      });
    };
    var _useMergedState3 = useMergedState(props2.defaultValue, {
      value: toRef(props2, "value")
    }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
    var rawLabeledValues = computed(function() {
      var _a;
      var values = convert2LabelValues(internalValue.value);
      if (props2.mode === "combobox" && !((_a = values[0]) === null || _a === void 0 ? void 0 : _a.value)) {
        return [];
      }
      return values;
    });
    var _useCache = useCache(rawLabeledValues, valueOptions), _useCache2 = _slicedToArray$2(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
    var displayValues = computed(function() {
      if (!props2.mode && mergedValues.value.length === 1) {
        var firstValue = mergedValues.value[0];
        if (firstValue.value === null && (firstValue.label === null || firstValue.label === void 0)) {
          return [];
        }
      }
      return mergedValues.value.map(function(item) {
        var _a;
        return _extends(_extends({}, item), {
          label: (_a = typeof item.label === "function" ? item.label() : item.label) !== null && _a !== void 0 ? _a : item.value
        });
      });
    });
    var rawValues = computed(function() {
      return new Set(mergedValues.value.map(function(val) {
        return val.value;
      }));
    });
    watchEffect(function() {
      var _a;
      if (props2.mode === "combobox") {
        var strValue = (_a = mergedValues.value[0]) === null || _a === void 0 ? void 0 : _a.value;
        if (strValue !== void 0 && strValue !== null) {
          setSearchValue(String(strValue));
        }
      }
    }, {
      flush: "post"
    });
    var createTagOption = function createTagOption2(val, label) {
      var _ref2;
      var mergedLabel = label !== null && label !== void 0 ? label : val;
      return _ref2 = {}, _defineProperty$m(_ref2, mergedFieldNames.value.value, val), _defineProperty$m(_ref2, mergedFieldNames.value.label, mergedLabel), _ref2;
    };
    var filledTagOptions = shallowRef();
    watchEffect(function() {
      if (props2.mode !== "tags") {
        filledTagOptions.value = mergedOptions.value;
        return;
      }
      var cloneOptions = mergedOptions.value.slice();
      var existOptions = function existOptions2(val) {
        return valueOptions.value.has(val);
      };
      _toConsumableArray(mergedValues.value).sort(function(a2, b2) {
        return a2.value < b2.value ? -1 : 1;
      }).forEach(function(item) {
        var val = item.value;
        if (!existOptions(val)) {
          cloneOptions.push(createTagOption(val, item.label));
        }
      });
      filledTagOptions.value = cloneOptions;
    });
    var filteredOptions = useFilterOptions(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, toRef(props2, "optionFilterProp"));
    var filledSearchOptions = computed(function() {
      if (props2.mode !== "tags" || !mergedSearchValue.value || filteredOptions.value.some(function(item) {
        return item[props2.optionFilterProp || "value"] === mergedSearchValue.value;
      })) {
        return filteredOptions.value;
      }
      return [createTagOption(mergedSearchValue.value)].concat(_toConsumableArray(filteredOptions.value));
    });
    var orderedFilteredOptions = computed(function() {
      if (!props2.filterSort) {
        return filledSearchOptions.value;
      }
      return _toConsumableArray(filledSearchOptions.value).sort(function(a2, b2) {
        return props2.filterSort(a2, b2);
      });
    });
    var displayOptions = computed(function() {
      return flattenOptions(orderedFilteredOptions.value, {
        fieldNames: mergedFieldNames.value,
        childrenAsData: childrenAsData.value
      });
    });
    var triggerChange = function triggerChange2(values) {
      var labeledValues = convert2LabelValues(values);
      setInternalValue(labeledValues);
      if (props2.onChange && (labeledValues.length !== mergedValues.value.length || labeledValues.some(function(newVal, index2) {
        var _a;
        return ((_a = mergedValues.value[index2]) === null || _a === void 0 ? void 0 : _a.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
      }))) {
        var returnValues = props2.labelInValue ? labeledValues.map(function(v2) {
          return _extends(_extends({}, v2), {
            originLabel: v2.label,
            label: typeof v2.label === "function" ? v2.label() : v2.label
          });
        }) : labeledValues.map(function(v2) {
          return v2.value;
        });
        var returnOptions = labeledValues.map(function(v2) {
          return injectPropsWithOption(getMixedOption(v2.value));
        });
        props2.onChange(multiple.value ? returnValues : returnValues[0], multiple.value ? returnOptions : returnOptions[0]);
      }
    };
    var _useState = useState(null), _useState2 = _slicedToArray$2(_useState, 2), activeValue = _useState2[0], setActiveValue = _useState2[1];
    var _useState3 = useState(0), _useState4 = _slicedToArray$2(_useState3, 2), accessibilityIndex = _useState4[0], setAccessibilityIndex = _useState4[1];
    var mergedDefaultActiveFirstOption = computed(function() {
      return props2.defaultActiveFirstOption !== void 0 ? props2.defaultActiveFirstOption : props2.mode !== "combobox";
    });
    var onActiveValue = function onActiveValue2(active, index2) {
      var _ref3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref3$source = _ref3.source, source = _ref3$source === void 0 ? "keyboard" : _ref3$source;
      setAccessibilityIndex(index2);
      if (props2.backfill && props2.mode === "combobox" && active !== null && source === "keyboard") {
        setActiveValue(String(active));
      }
    };
    var triggerSelect = function triggerSelect2(val, selected) {
      var getSelectEnt = function getSelectEnt2() {
        var _a;
        var option2 = getMixedOption(val);
        var originLabel = option2 === null || option2 === void 0 ? void 0 : option2[mergedFieldNames.value.label];
        return [props2.labelInValue ? {
          label: typeof originLabel === "function" ? originLabel() : originLabel,
          originLabel,
          value: val,
          key: (_a = option2 === null || option2 === void 0 ? void 0 : option2.key) !== null && _a !== void 0 ? _a : val
        } : val, injectPropsWithOption(option2)];
      };
      if (selected && props2.onSelect) {
        var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = _slicedToArray$2(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], option = _getSelectEnt2[1];
        props2.onSelect(wrappedValue, option);
      } else if (!selected && props2.onDeselect) {
        var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = _slicedToArray$2(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option = _getSelectEnt4[1];
        props2.onDeselect(_wrappedValue, _option);
      }
    };
    var onInternalSelect = function onInternalSelect2(val, info) {
      var cloneValues;
      var mergedSelect = multiple.value ? info.selected : true;
      if (mergedSelect) {
        cloneValues = multiple.value ? [].concat(_toConsumableArray(mergedValues.value), [val]) : [val];
      } else {
        cloneValues = mergedValues.value.filter(function(v2) {
          return v2.value !== val;
        });
      }
      triggerChange(cloneValues);
      triggerSelect(val, mergedSelect);
      if (props2.mode === "combobox") {
        setActiveValue("");
      } else if (!multiple.value || props2.autoClearSearchValue) {
        setSearchValue("");
        setActiveValue("");
      }
    };
    var onDisplayValuesChange = function onDisplayValuesChange2(nextValues, info) {
      triggerChange(nextValues);
      if (info.type === "remove" || info.type === "clear") {
        info.values.forEach(function(item) {
          triggerSelect(item.value, false);
        });
      }
    };
    var onInternalSearch = function onInternalSearch2(searchText, info) {
      var _a;
      setSearchValue(searchText);
      setActiveValue(null);
      if (info.source === "submit") {
        var formatted = (searchText || "").trim();
        if (formatted) {
          var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues.value), [formatted])));
          triggerChange(newRawValues);
          triggerSelect(formatted, true);
          setSearchValue("");
        }
        return;
      }
      if (info.source !== "blur") {
        if (props2.mode === "combobox") {
          triggerChange(searchText);
        }
        (_a = props2.onSearch) === null || _a === void 0 ? void 0 : _a.call(props2, searchText);
      }
    };
    var onInternalSearchSplit = function onInternalSearchSplit2(words) {
      var patchValues = words;
      if (props2.mode !== "tags") {
        patchValues = words.map(function(word) {
          var opt = labelOptions.value.get(word);
          return opt === null || opt === void 0 ? void 0 : opt.value;
        }).filter(function(val) {
          return val !== void 0;
        });
      }
      var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues.value), _toConsumableArray(patchValues))));
      triggerChange(newRawValues);
      newRawValues.forEach(function(newRawValue) {
        triggerSelect(newRawValue, true);
      });
    };
    var realVirtual = computed(function() {
      return props2.virtual !== false && props2.dropdownMatchSelectWidth !== false;
    });
    useProvideSelectProps(toReactive(_extends(_extends({}, parsedOptions), {
      flattenOptions: displayOptions,
      onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      onSelect: onInternalSelect,
      menuItemSelectedIcon: toRef(props2, "menuItemSelectedIcon"),
      rawValues,
      fieldNames: mergedFieldNames,
      virtual: realVirtual,
      listHeight: toRef(props2, "listHeight"),
      listItemHeight: toRef(props2, "listItemHeight"),
      childrenAsData
    })));
    var selectRef = ref();
    expose({
      focus: function focus() {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.blur();
      },
      scrollTo: function scrollTo(arg) {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.scrollTo(arg);
      }
    });
    var pickProps = computed(function() {
      return omit(props2, [
        "id",
        "mode",
        "prefixCls",
        "backfill",
        "fieldNames",
        "inputValue",
        "searchValue",
        "onSearch",
        "autoClearSearchValue",
        "onSelect",
        "onDeselect",
        "dropdownMatchSelectWidth",
        "filterOption",
        "filterSort",
        "optionFilterProp",
        "optionLabelProp",
        "options",
        "children",
        "defaultActiveFirstOption",
        "menuItemSelectedIcon",
        "virtual",
        "listHeight",
        "listItemHeight",
        "value",
        "defaultValue",
        "labelInValue",
        "onChange"
      ]);
    });
    return function() {
      return createVNode(BaseSelect, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, pickProps.value), attrs), {}, {
        "id": mergedId,
        "prefixCls": props2.prefixCls,
        "ref": selectRef,
        "omitDomProps": OMIT_DOM_PROPS,
        "mode": props2.mode,
        "displayValues": displayValues.value,
        "onDisplayValuesChange": onDisplayValuesChange,
        "searchValue": mergedSearchValue.value,
        "onSearch": onInternalSearch,
        "onSearchSplit": onInternalSearchSplit,
        "dropdownMatchSelectWidth": props2.dropdownMatchSelectWidth,
        "OptionList": OptionList$2,
        "emptyOptions": !displayOptions.value.length,
        "activeValue": activeValue.value,
        "activeDescendantId": "".concat(mergedId, "_list_").concat(accessibilityIndex.value)
      }), slots);
    };
  }
});
var Option = function Option2() {
  return null;
};
Option.isSelectOption = true;
Option.displayName = "ASelectOption";
var Option$1 = Option;
var OptGroup = function OptGroup2() {
  return null;
};
OptGroup.isSelectOptGroup = true;
OptGroup.displayName = "ASelectOptGroup";
var OptGroup$1 = OptGroup;
var DownOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
var DownOutlinedSvg = DownOutlined$2;
function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$7(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$7(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DownOutlined = function DownOutlined2(props2, context) {
  var p = _objectSpread$7({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$7({}, p, {
    "icon": DownOutlinedSvg
  }), null);
};
DownOutlined.displayName = "DownOutlined";
DownOutlined.inheritAttrs = false;
var DownOutlined$1 = DownOutlined;
var CheckOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlinedSvg = CheckOutlined$2;
function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$6(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$6(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var CheckOutlined = function CheckOutlined2(props2, context) {
  var p = _objectSpread$6({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$6({}, p, {
    "icon": CheckOutlinedSvg
  }), null);
};
CheckOutlined.displayName = "CheckOutlined";
CheckOutlined.inheritAttrs = false;
var CheckOutlined$1 = CheckOutlined;
var SearchOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
var SearchOutlinedSvg = SearchOutlined$2;
function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$5(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$5(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var SearchOutlined = function SearchOutlined2(props2, context) {
  var p = _objectSpread$5({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$5({}, p, {
    "icon": SearchOutlinedSvg
  }), null);
};
SearchOutlined.displayName = "SearchOutlined";
SearchOutlined.inheritAttrs = false;
var SearchOutlined$1 = SearchOutlined;
function getIcons(props2) {
  var slots = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var loading = props2.loading, multiple = props2.multiple, prefixCls = props2.prefixCls;
  var suffixIcon = props2.suffixIcon || slots.suffixIcon && slots.suffixIcon();
  var clearIcon = props2.clearIcon || slots.clearIcon && slots.clearIcon();
  var menuItemSelectedIcon = props2.menuItemSelectedIcon || slots.menuItemSelectedIcon && slots.menuItemSelectedIcon();
  var removeIcon = props2.removeIcon || slots.removeIcon && slots.removeIcon();
  var mergedClearIcon = clearIcon;
  if (!clearIcon) {
    mergedClearIcon = createVNode(CloseCircleFilled$1, null, null);
  }
  var mergedSuffixIcon = null;
  if (suffixIcon !== void 0) {
    mergedSuffixIcon = suffixIcon;
  } else if (loading) {
    mergedSuffixIcon = createVNode(LoadingOutlined$1, {
      "spin": true
    }, null);
  } else {
    var iconCls = "".concat(prefixCls, "-suffix");
    mergedSuffixIcon = function mergedSuffixIcon2(_ref) {
      var open2 = _ref.open, showSearch = _ref.showSearch;
      if (open2 && showSearch) {
        return createVNode(SearchOutlined$1, {
          "class": iconCls
        }, null);
      }
      return createVNode(DownOutlined$1, {
        "class": iconCls
      }, null);
    };
  }
  var mergedItemIcon = null;
  if (menuItemSelectedIcon !== void 0) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = createVNode(CheckOutlined$1, null, null);
  } else {
    mergedItemIcon = null;
  }
  var mergedRemoveIcon = null;
  if (removeIcon !== void 0) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = createVNode(CloseOutlined$1, null, null);
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}
var ContextKey = Symbol("ContextProps");
var InternalContextKey = Symbol("InternalContextProps");
var defaultContext = {
  id: computed(function() {
    return void 0;
  }),
  onFieldBlur: function onFieldBlur() {
  },
  onFieldChange: function onFieldChange() {
  },
  clearValidate: function clearValidate() {
  }
};
var defaultInternalContext = {
  addFormItemField: function addFormItemField() {
  },
  removeFormItemField: function removeFormItemField() {
  }
};
var useInjectFormItemContext = function useInjectFormItemContext2() {
  var internalContext = inject(InternalContextKey, defaultInternalContext);
  var formItemFieldKey = Symbol("FormItemFieldKey");
  var instance = getCurrentInstance();
  internalContext.addFormItemField(formItemFieldKey, instance.type);
  onBeforeUnmount(function() {
    internalContext.removeFormItemField(formItemFieldKey);
  });
  provide(InternalContextKey, defaultInternalContext);
  provide(ContextKey, defaultContext);
  return inject(ContextKey, defaultContext);
};
defineComponent({
  name: "AFormItemRest",
  setup: function setup27(_2, _ref) {
    var slots = _ref.slots;
    provide(InternalContextKey, defaultInternalContext);
    provide(ContextKey, defaultContext);
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
});
var selectProps = function selectProps2() {
  return _extends(_extends({}, omit(selectProps$1(), ["inputIcon", "mode", "getInputElement", "getRawInputElement", "backfill"])), {
    value: {
      type: [Array, Object, String, Number]
    },
    defaultValue: {
      type: [Array, Object, String, Number]
    },
    notFoundContent: PropTypes$1.any,
    suffixIcon: PropTypes$1.any,
    itemIcon: PropTypes$1.any,
    size: String,
    mode: String,
    bordered: {
      type: Boolean,
      default: true
    },
    transitionName: String,
    choiceTransitionName: {
      type: String,
      default: ""
    },
    "onUpdate:value": Function
  });
};
var SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var Select = defineComponent({
  name: "ASelect",
  Option: Option$1,
  OptGroup: OptGroup$1,
  inheritAttrs: false,
  props: initDefaultProps$1(selectProps(), {
    listHeight: 256,
    listItemHeight: 24
  }),
  SECRET_COMBOBOX_MODE_DO_NOT_USE,
  slots: [
    "notFoundContent",
    "suffixIcon",
    "itemIcon",
    "removeIcon",
    "clearIcon",
    "dropdownRender",
    "option",
    "placeholder",
    "tagRender",
    "maxTagPlaceholder",
    "optionLabel"
  ],
  setup: function setup28(props2, _ref) {
    var attrs = _ref.attrs, emit = _ref.emit, slots = _ref.slots, expose = _ref.expose;
    var selectRef = ref();
    var formItemContext = useInjectFormItemContext();
    var focus = function focus2() {
      var _a;
      (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var blur = function blur2() {
      var _a;
      (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.blur();
    };
    var scrollTo = function scrollTo2(arg) {
      var _a;
      (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.scrollTo(arg);
    };
    var mode2 = computed(function() {
      var mode3 = props2.mode;
      if (mode3 === "combobox") {
        return void 0;
      }
      if (mode3 === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
        return "combobox";
      }
      return mode3;
    });
    var _useConfigInject = useConfigInject("select", props2), prefixCls = _useConfigInject.prefixCls, direction = _useConfigInject.direction, configProvider = _useConfigInject.configProvider, size = _useConfigInject.size, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var rootPrefixCls = computed(function() {
      return getPrefixCls2();
    });
    var transitionName2 = computed(function() {
      return getTransitionName$1(rootPrefixCls.value, "slide-up", props2.transitionName);
    });
    var mergedClassName = computed(function() {
      var _classNames;
      return classNames((_classNames = {}, _defineProperty$m(_classNames, "".concat(prefixCls.value, "-lg"), size.value === "large"), _defineProperty$m(_classNames, "".concat(prefixCls.value, "-sm"), size.value === "small"), _defineProperty$m(_classNames, "".concat(prefixCls.value, "-rtl"), direction.value === "rtl"), _defineProperty$m(_classNames, "".concat(prefixCls.value, "-borderless"), !props2.bordered), _classNames));
    });
    var triggerChange = function triggerChange2() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      emit("update:value", args[0]);
      emit.apply(void 0, ["change"].concat(args));
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2(e2) {
      emit("blur", e2);
      formItemContext.onFieldBlur();
    };
    expose({
      blur,
      focus,
      scrollTo
    });
    var isMultiple2 = computed(function() {
      return mode2.value === "multiple" || mode2.value === "tags";
    });
    return function() {
      var _a, _b;
      var notFoundContent = props2.notFoundContent, _props$listHeight = props2.listHeight, listHeight = _props$listHeight === void 0 ? 256 : _props$listHeight, _props$listItemHeight = props2.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 24 : _props$listItemHeight, getPopupContainer = props2.getPopupContainer, dropdownClassName = props2.dropdownClassName, virtual = props2.virtual, dropdownMatchSelectWidth = props2.dropdownMatchSelectWidth, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, _props$placeholder = props2.placeholder, placeholder = _props$placeholder === void 0 ? (_a = slots.placeholder) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$placeholder;
      var renderEmpty2 = configProvider.renderEmpty, getContextPopupContainer = configProvider.getPopupContainer;
      var mergedNotFound;
      if (notFoundContent !== void 0) {
        mergedNotFound = notFoundContent;
      } else if (slots.notFoundContent) {
        mergedNotFound = slots.notFoundContent();
      } else if (mode2.value === "combobox") {
        mergedNotFound = null;
      } else {
        mergedNotFound = renderEmpty2("Select");
      }
      var _getIcons = getIcons(_extends(_extends({}, props2), {
        multiple: isMultiple2.value,
        prefixCls: prefixCls.value
      }), slots), suffixIcon = _getIcons.suffixIcon, itemIcon = _getIcons.itemIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
      var selectProps3 = omit(props2, ["prefixCls", "suffixIcon", "itemIcon", "removeIcon", "clearIcon", "size", "bordered"]);
      var rcSelectRtlDropDownClassName = classNames(dropdownClassName, _defineProperty$m({}, "".concat(prefixCls.value, "-dropdown-").concat(direction.value), direction.value === "rtl"));
      return createVNode(Select$1, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
        "ref": selectRef,
        "virtual": virtual,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth
      }, selectProps3), attrs), {}, {
        "placeholder": placeholder,
        "listHeight": listHeight,
        "listItemHeight": listItemHeight,
        "mode": mode2.value,
        "prefixCls": prefixCls.value,
        "direction": direction.value,
        "inputIcon": suffixIcon,
        "menuItemSelectedIcon": itemIcon,
        "removeIcon": removeIcon,
        "clearIcon": clearIcon,
        "notFoundContent": mergedNotFound,
        "class": [mergedClassName.value, attrs.class],
        "getPopupContainer": getPopupContainer || getContextPopupContainer,
        "dropdownClassName": rcSelectRtlDropDownClassName,
        "onChange": triggerChange,
        "onBlur": handleBlur,
        "id": id,
        "dropdownRender": selectProps3.dropdownRender || slots.dropdownRender,
        "transitionName": transitionName2.value,
        "children": (_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots),
        "tagRender": props2.tagRender || slots.tagRender,
        "optionLabelRender": slots.optionLabel,
        "maxTagPlaceholder": props2.maxTagPlaceholder || slots.maxTagPlaceholder
      }), {
        option: slots.option
      });
    };
  }
});
Select.install = function(app) {
  app.component(Select.name, Select);
  app.component(Select.Option.displayName, Select.Option);
  app.component(Select.OptGroup.displayName, Select.OptGroup);
  return app;
};
Select.Option;
Select.OptGroup;
var VcSelect = Select;
var responsiveMap = {
  xs: "(max-width: 575px)",
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 992px)",
  xl: "(min-width: 1200px)",
  xxl: "(min-width: 1600px)",
  xxxl: "(min-width: 2000px)"
};
var subscribers = /* @__PURE__ */ new Map();
var subUid = -1;
var screens = {};
var responsiveObserve = {
  matchHandlers: {},
  dispatch: function dispatch(pointMap) {
    screens = pointMap;
    subscribers.forEach(function(func) {
      return func(screens);
    });
    return subscribers.size >= 1;
  },
  subscribe: function subscribe(func) {
    if (!subscribers.size)
      this.register();
    subUid += 1;
    subscribers.set(subUid, func);
    func(screens);
    return subUid;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers.delete(token);
    if (!subscribers.size)
      this.unregister();
  },
  unregister: function unregister() {
    var _this = this;
    Object.keys(responsiveMap).forEach(function(screen) {
      var matchMediaQuery = responsiveMap[screen];
      var handler2 = _this.matchHandlers[matchMediaQuery];
      handler2 === null || handler2 === void 0 ? void 0 : handler2.mql.removeListener(handler2 === null || handler2 === void 0 ? void 0 : handler2.listener);
    });
    subscribers.clear();
  },
  register: function register() {
    var _this2 = this;
    Object.keys(responsiveMap).forEach(function(screen) {
      var matchMediaQuery = responsiveMap[screen];
      var listener = function listener2(_ref) {
        var matches = _ref.matches;
        _this2.dispatch(_extends(_extends({}, screens), _defineProperty$m({}, screen, matches)));
      };
      var mql = window.matchMedia(matchMediaQuery);
      mql.addListener(listener);
      _this2.matchHandlers[matchMediaQuery] = {
        mql,
        listener
      };
      listener(mql);
    });
  }
};
var ResponsiveObserve = responsiveObserve;
function useBreakpoint() {
  var screens2 = ref({});
  var token = null;
  onMounted(function() {
    token = ResponsiveObserve.subscribe(function(supportScreens) {
      screens2.value = supportScreens;
    });
  });
  onUnmounted(function() {
    ResponsiveObserve.unsubscribe(token);
  });
  return screens2;
}
var autoAdjustOverflow$2 = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset$2 = [0, 0];
var placements$3 = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$2,
    offset: [0, -4],
    targetOffset: targetOffset$2
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflow$2,
    offset: [4, 0],
    targetOffset: targetOffset$2
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$2,
    offset: [0, 4],
    targetOffset: targetOffset$2
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflow$2,
    offset: [-4, 0],
    targetOffset: targetOffset$2
  }
};
var tooltipContentProps = {
  prefixCls: String,
  id: String,
  overlayInnerStyle: PropTypes$1.any
};
var Content$1 = defineComponent({
  name: "Content",
  props: tooltipContentProps,
  slots: ["overlay"],
  setup: function setup29(props2, _ref) {
    var slots = _ref.slots;
    return function() {
      var _a;
      return createVNode("div", {
        "class": "".concat(props2.prefixCls, "-inner"),
        "id": props2.id,
        "role": "tooltip",
        "style": props2.overlayInnerStyle
      }, [(_a = slots.overlay) === null || _a === void 0 ? void 0 : _a.call(slots)]);
    };
  }
});
var __rest$7 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function noop$1() {
}
var Tooltip$1 = defineComponent({
  name: "Tooltip",
  inheritAttrs: false,
  props: {
    trigger: PropTypes$1.any.def(["hover"]),
    defaultVisible: {
      type: Boolean,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    placement: PropTypes$1.string.def("right"),
    transitionName: String,
    animation: PropTypes$1.any,
    afterVisibleChange: PropTypes$1.func.def(function() {
    }),
    overlayStyle: {
      type: Object,
      default: void 0
    },
    overlayClassName: String,
    prefixCls: PropTypes$1.string.def("rc-tooltip"),
    mouseEnterDelay: PropTypes$1.number.def(0.1),
    mouseLeaveDelay: PropTypes$1.number.def(0.1),
    getPopupContainer: Function,
    destroyTooltipOnHide: {
      type: Boolean,
      default: false
    },
    align: PropTypes$1.object.def(function() {
      return {};
    }),
    arrowContent: PropTypes$1.any.def(null),
    tipId: String,
    builtinPlacements: PropTypes$1.object,
    overlayInnerStyle: {
      type: Object,
      default: void 0
    },
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    onVisibleChange: Function,
    onPopupAlign: Function
  },
  slots: ["arrowContent", "overlay"],
  setup: function setup30(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, expose = _ref.expose;
    var triggerDOM = ref();
    var getPopupElement = function getPopupElement2() {
      var prefixCls = props2.prefixCls, tipId = props2.tipId, overlayInnerStyle = props2.overlayInnerStyle;
      return [createVNode("div", {
        "class": "".concat(prefixCls, "-arrow"),
        "key": "arrow"
      }, [getPropsSlot(slots, props2, "arrowContent")]), createVNode(Content$1, {
        "key": "content",
        "prefixCls": prefixCls,
        "id": tipId,
        "overlayInnerStyle": overlayInnerStyle
      }, {
        overlay: slots.overlay
      })];
    };
    var getPopupDomNode2 = function getPopupDomNode3() {
      return triggerDOM.value.getPopupDomNode();
    };
    expose({
      getPopupDomNode: getPopupDomNode2,
      triggerDOM,
      forcePopupAlign: function forcePopupAlign2() {
        var _a;
        return (_a = triggerDOM.value) === null || _a === void 0 ? void 0 : _a.forcePopupAlign();
      }
    });
    var destroyTooltip = ref(false);
    var autoDestroy = ref(false);
    watchEffect(function() {
      var destroyTooltipOnHide = props2.destroyTooltipOnHide;
      if (typeof destroyTooltipOnHide === "boolean") {
        destroyTooltip.value = destroyTooltipOnHide;
      } else if (destroyTooltipOnHide && _typeof$1(destroyTooltipOnHide) === "object") {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip.value = keepParent === true;
        autoDestroy.value = keepParent === false;
      }
    });
    return function() {
      var overlayClassName = props2.overlayClassName, trigger2 = props2.trigger, mouseEnterDelay = props2.mouseEnterDelay, mouseLeaveDelay = props2.mouseLeaveDelay, overlayStyle = props2.overlayStyle, prefixCls = props2.prefixCls, afterVisibleChange = props2.afterVisibleChange, transitionName2 = props2.transitionName, animation = props2.animation, placement = props2.placement, align = props2.align;
      props2.destroyTooltipOnHide;
      var defaultVisible = props2.defaultVisible, restProps = __rest$7(props2, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "afterVisibleChange", "transitionName", "animation", "placement", "align", "destroyTooltipOnHide", "defaultVisible"]);
      var extraProps = _extends({}, restProps);
      if (props2.visible !== void 0) {
        extraProps.popupVisible = props2.visible;
      }
      var triggerProps = _extends(_extends(_extends({
        popupClassName: overlayClassName,
        prefixCls,
        action: trigger2,
        builtinPlacements: placements$3,
        popupPlacement: placement,
        popupAlign: align,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName2,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip.value,
        autoDestroy: autoDestroy.value,
        mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay
      }, extraProps), attrs), {
        onPopupVisibleChange: props2.onVisibleChange || noop$1,
        onPopupAlign: props2.onPopupAlign || noop$1,
        ref: triggerDOM,
        popup: getPopupElement()
      });
      return createVNode(Trigger, triggerProps, {
        default: slots.default
      });
    };
  }
});
tuple("success", "processing", "error", "default", "warning");
var PresetColorTypes = tuple("pink", "red", "yellow", "orange", "cyan", "green", "blue", "purple", "geekblue", "magenta", "volcano", "gold", "lime");
var abstractTooltipProps = function() {
  return {
    trigger: [String, Array],
    visible: {
      type: Boolean,
      default: void 0
    },
    defaultVisible: {
      type: Boolean,
      default: void 0
    },
    placement: String,
    color: String,
    transitionName: String,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    overlayClassName: String,
    openClassName: String,
    prefixCls: String,
    mouseEnterDelay: Number,
    mouseLeaveDelay: Number,
    getPopupContainer: Function,
    arrowPointAtCenter: {
      type: Boolean,
      default: void 0
    },
    autoAdjustOverflow: {
      type: [Boolean, Object],
      default: void 0
    },
    destroyTooltipOnHide: {
      type: Boolean,
      default: void 0
    },
    align: {
      type: Object,
      default: void 0
    },
    builtinPlacements: {
      type: Object,
      default: void 0
    },
    children: Array,
    onVisibleChange: Function,
    "onUpdate:visible": Function
  };
};
var autoAdjustOverflowEnabled = {
  adjustX: 1,
  adjustY: 1
};
var autoAdjustOverflowDisabled = {
  adjustX: 0,
  adjustY: 0
};
var targetOffset$1 = [0, 0];
function getOverflowOptions(autoAdjustOverflow2) {
  if (typeof autoAdjustOverflow2 === "boolean") {
    return autoAdjustOverflow2 ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
  }
  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow2);
}
function getPlacements(config) {
  var _config$arrowWidth = config.arrowWidth, arrowWidth = _config$arrowWidth === void 0 ? 4 : _config$arrowWidth, _config$horizontalArr = config.horizontalArrowShift, horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr, _config$verticalArrow = config.verticalArrowShift, verticalArrowShift = _config$verticalArrow === void 0 ? 8 : _config$verticalArrow, autoAdjustOverflow2 = config.autoAdjustOverflow, arrowPointAtCenter = config.arrowPointAtCenter;
  var placementMap = {
    left: {
      points: ["cr", "cl"],
      offset: [-4, 0]
    },
    right: {
      points: ["cl", "cr"],
      offset: [4, 0]
    },
    top: {
      points: ["bc", "tc"],
      offset: [0, -4]
    },
    bottom: {
      points: ["tc", "bc"],
      offset: [0, 4]
    },
    topLeft: {
      points: ["bl", "tc"],
      offset: [-(horizontalArrowShift + arrowWidth), -4]
    },
    leftTop: {
      points: ["tr", "cl"],
      offset: [-4, -(verticalArrowShift + arrowWidth)]
    },
    topRight: {
      points: ["br", "tc"],
      offset: [horizontalArrowShift + arrowWidth, -4]
    },
    rightTop: {
      points: ["tl", "cr"],
      offset: [4, -(verticalArrowShift + arrowWidth)]
    },
    bottomRight: {
      points: ["tr", "bc"],
      offset: [horizontalArrowShift + arrowWidth, 4]
    },
    rightBottom: {
      points: ["bl", "cr"],
      offset: [4, verticalArrowShift + arrowWidth]
    },
    bottomLeft: {
      points: ["tl", "bc"],
      offset: [-(horizontalArrowShift + arrowWidth), 4]
    },
    leftBottom: {
      points: ["br", "cl"],
      offset: [-4, verticalArrowShift + arrowWidth]
    }
  };
  Object.keys(placementMap).forEach(function(key2) {
    placementMap[key2] = arrowPointAtCenter ? _extends(_extends({}, placementMap[key2]), {
      overflow: getOverflowOptions(autoAdjustOverflow2),
      targetOffset: targetOffset$1
    }) : _extends(_extends({}, placements$3[key2]), {
      overflow: getOverflowOptions(autoAdjustOverflow2)
    });
    placementMap[key2].ignoreShake = true;
  });
  return placementMap;
}
function firstNotUndefined() {
  var arr = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  for (var i = 0, len = arr.length; i < len; i++) {
    if (arr[i] !== void 0) {
      return arr[i];
    }
  }
  return void 0;
}
var splitObject = function splitObject2(obj, keys2) {
  var picked = {};
  var omitted = _extends({}, obj);
  keys2.forEach(function(key2) {
    if (obj && key2 in obj) {
      picked[key2] = obj[key2];
      delete omitted[key2];
    }
  });
  return {
    picked,
    omitted
  };
};
var PresetColorRegex = new RegExp("^(".concat(PresetColorTypes.join("|"), ")(-inverse)?$"));
var tooltipProps = function tooltipProps2() {
  return _extends(_extends({}, abstractTooltipProps()), {
    title: PropTypes$1.any
  });
};
var ToolTip = defineComponent({
  name: "ATooltip",
  inheritAttrs: false,
  props: initDefaultProps$1(tooltipProps(), {
    trigger: "hover",
    transitionName: "zoom-big-fast",
    align: {},
    placement: "top",
    mouseEnterDelay: 0.1,
    mouseLeaveDelay: 0.1,
    arrowPointAtCenter: false,
    autoAdjustOverflow: true
  }),
  slots: ["title"],
  setup: function setup31(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs, expose = _ref.expose;
    var _useConfigInject = useConfigInject("tooltip", props2), prefixCls = _useConfigInject.prefixCls, getPopupContainer = _useConfigInject.getPopupContainer;
    var visible = ref(firstNotUndefined([props2.visible, props2.defaultVisible]));
    var tooltip = ref();
    onMounted(function() {
      warning$1(props2.defaultVisible === void 0, "Tooltip", "'defaultVisible' is deprecated, please use 'v-model:visible'");
    });
    var rafId;
    watch(function() {
      return props2.visible;
    }, function(val) {
      wrapperRaf.cancel(rafId);
      rafId = wrapperRaf(function() {
        visible.value = !!val;
      });
    });
    var isNoTitle = function isNoTitle2() {
      var _a;
      var title = (_a = props2.title) !== null && _a !== void 0 ? _a : slots.title;
      return !title && title !== 0;
    };
    var handleVisibleChange = function handleVisibleChange2(val) {
      var noTitle = isNoTitle();
      if (props2.visible === void 0) {
        visible.value = noTitle ? false : val;
      }
      if (!noTitle) {
        emit("update:visible", val);
        emit("visibleChange", val);
      }
    };
    var getPopupDomNode2 = function getPopupDomNode3() {
      return tooltip.value.getPopupDomNode();
    };
    expose({
      getPopupDomNode: getPopupDomNode2,
      visible,
      forcePopupAlign: function forcePopupAlign2() {
        var _a;
        return (_a = tooltip.value) === null || _a === void 0 ? void 0 : _a.forcePopupAlign();
      }
    });
    var tooltipPlacements = computed(function() {
      var builtinPlacements = props2.builtinPlacements, arrowPointAtCenter = props2.arrowPointAtCenter, autoAdjustOverflow2 = props2.autoAdjustOverflow;
      return builtinPlacements || getPlacements({
        arrowPointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow2
      });
    });
    var isTrueProps = function isTrueProps2(val) {
      return val || val === "";
    };
    var getDisabledCompatibleChildren = function getDisabledCompatibleChildren2(ele) {
      var elementType = ele.type;
      if (_typeof$1(elementType) === "object" && ele.props) {
        if ((elementType.__ANT_BUTTON === true || elementType === "button") && isTrueProps(ele.props.disabled) || elementType.__ANT_SWITCH === true && (isTrueProps(ele.props.disabled) || isTrueProps(ele.props.loading))) {
          var _splitObject = splitObject(getStyle(ele), ["position", "left", "right", "top", "bottom", "float", "display", "zIndex"]), picked = _splitObject.picked, omitted = _splitObject.omitted;
          var spanStyle = _extends(_extends({
            display: "inline-block"
          }, picked), {
            cursor: "not-allowed",
            lineHeight: 1,
            width: ele.props && ele.props.block ? "100%" : null
          });
          var buttonStyle = _extends(_extends({}, omitted), {
            pointerEvents: "none"
          });
          var child = cloneElement(ele, {
            style: buttonStyle
          }, true);
          return createVNode("span", {
            "style": spanStyle,
            "class": "".concat(prefixCls.value, "-disabled-compatible-wrapper")
          }, [child]);
        }
      }
      return ele;
    };
    var getOverlay = function getOverlay2() {
      var _a, _b;
      return (_a = props2.title) !== null && _a !== void 0 ? _a : (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots);
    };
    var onPopupAlign = function onPopupAlign2(domNode, align) {
      var placements2 = tooltipPlacements.value;
      var placement = Object.keys(placements2).filter(function(key2) {
        return placements2[key2].points[0] === align.points[0] && placements2[key2].points[1] === align.points[1];
      })[0];
      if (!placement) {
        return;
      }
      var rect = domNode.getBoundingClientRect();
      var transformOrigin = {
        top: "50%",
        left: "50%"
      };
      if (placement.indexOf("top") >= 0 || placement.indexOf("Bottom") >= 0) {
        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
      } else if (placement.indexOf("Top") >= 0 || placement.indexOf("bottom") >= 0) {
        transformOrigin.top = "".concat(-align.offset[1], "px");
      }
      if (placement.indexOf("left") >= 0 || placement.indexOf("Right") >= 0) {
        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
      } else if (placement.indexOf("right") >= 0 || placement.indexOf("Left") >= 0) {
        transformOrigin.left = "".concat(-align.offset[0], "px");
      }
      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
    };
    return function() {
      var _classNames;
      var _a, _b;
      var openClassName = props2.openClassName, color = props2.color, overlayClassName = props2.overlayClassName;
      var children = (_b = filterEmpty((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots))) !== null && _b !== void 0 ? _b : null;
      children = children.length === 1 ? children[0] : children;
      var tempVisible = visible.value;
      if (props2.visible === void 0 && isNoTitle()) {
        tempVisible = false;
      }
      if (!children) {
        return null;
      }
      var child = getDisabledCompatibleChildren(isValidElement(children) ? children : createVNode("span", null, [children]));
      var childCls = classNames((_classNames = {}, _defineProperty$m(_classNames, openClassName || "".concat(prefixCls.value, "-open"), true), _defineProperty$m(_classNames, child.props && child.props.class, child.props && child.props.class), _classNames));
      var customOverlayClassName = classNames(overlayClassName, _defineProperty$m({}, "".concat(prefixCls.value, "-").concat(color), color && PresetColorRegex.test(color)));
      var formattedOverlayInnerStyle;
      var arrowContentStyle;
      if (color && !PresetColorRegex.test(color)) {
        formattedOverlayInnerStyle = {
          backgroundColor: color
        };
        arrowContentStyle = {
          backgroundColor: color
        };
      }
      var vcTooltipProps = _extends(_extends(_extends({}, attrs), props2), {
        prefixCls: prefixCls.value,
        getPopupContainer: getPopupContainer.value,
        builtinPlacements: tooltipPlacements.value,
        visible: tempVisible,
        ref: tooltip,
        overlayClassName: customOverlayClassName,
        overlayInnerStyle: formattedOverlayInnerStyle,
        onVisibleChange: handleVisibleChange,
        onPopupAlign
      });
      return createVNode(Tooltip$1, vcTooltipProps, {
        default: function _default3() {
          return [visible.value ? cloneElement(child, {
            class: childCls
          }) : child];
        },
        arrowContent: function arrowContent() {
          return createVNode("span", {
            "class": "".concat(prefixCls.value, "-arrow-content"),
            "style": arrowContentStyle
          }, null);
        },
        overlay: getOverlay
      });
    };
  }
});
var Tooltip = withInstall(ToolTip);
var autoAdjustOverflow$1 = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements$1 = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topCenter: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflow$1,
    offset: [0, -4],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomCenter: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflow$1,
    offset: [0, 4],
    targetOffset
  }
};
var placements$2 = placements$1;
var __rest$6 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var Dropdown$2 = defineComponent({
  props: {
    minOverlayWidthMatchTrigger: {
      type: Boolean,
      default: void 0
    },
    arrow: {
      type: Boolean,
      default: false
    },
    prefixCls: PropTypes$1.string.def("rc-dropdown"),
    transitionName: String,
    overlayClassName: PropTypes$1.string.def(""),
    openClassName: String,
    animation: PropTypes$1.any,
    align: PropTypes$1.object,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    placement: PropTypes$1.string.def("bottomLeft"),
    overlay: PropTypes$1.any,
    trigger: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.arrayOf(PropTypes$1.string)]).def("hover"),
    alignPoint: {
      type: Boolean,
      default: void 0
    },
    showAction: PropTypes$1.array,
    hideAction: PropTypes$1.array,
    getPopupContainer: Function,
    visible: {
      type: Boolean,
      default: void 0
    },
    defaultVisible: {
      type: Boolean,
      default: false
    },
    mouseEnterDelay: PropTypes$1.number.def(0.15),
    mouseLeaveDelay: PropTypes$1.number.def(0.1)
  },
  emits: ["visibleChange", "overlayClick"],
  slots: ["overlay"],
  setup: function setup32(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, expose = _ref.expose;
    var triggerVisible = ref(!!props2.visible);
    watch(function() {
      return props2.visible;
    }, function(val) {
      if (val !== void 0) {
        triggerVisible.value = val;
      }
    });
    var triggerRef = ref();
    expose({
      triggerRef
    });
    var onClick2 = function onClick3(e2) {
      if (props2.visible === void 0) {
        triggerVisible.value = false;
      }
      emit("overlayClick", e2);
    };
    var onVisibleChange = function onVisibleChange2(visible) {
      if (props2.visible === void 0) {
        triggerVisible.value = visible;
      }
      emit("visibleChange", visible);
    };
    var getMenuElement = function getMenuElement2() {
      var _a;
      var overlayElement = (_a = slots.overlay) === null || _a === void 0 ? void 0 : _a.call(slots);
      var extraOverlayProps = {
        prefixCls: "".concat(props2.prefixCls, "-menu"),
        onClick: onClick2,
        getPopupContainer: function getPopupContainer() {
          return triggerRef.value.getPopupDomNode();
        }
      };
      return createVNode(Fragment, null, [props2.arrow && createVNode("div", {
        "class": "".concat(props2.prefixCls, "-arrow")
      }, null), cloneElement(overlayElement, extraOverlayProps, false)]);
    };
    var minOverlayWidthMatchTrigger = computed(function() {
      var _props$minOverlayWidt = props2.minOverlayWidthMatchTrigger, matchTrigger = _props$minOverlayWidt === void 0 ? !props2.alignPoint : _props$minOverlayWidt;
      return matchTrigger;
    });
    var renderChildren2 = function renderChildren3() {
      var _a;
      var children = (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
      return triggerVisible.value && children ? cloneElement(children[0], {
        class: props2.openClassName || "".concat(props2.prefixCls, "-open")
      }, false) : children;
    };
    var triggerHideAction = computed(function() {
      if (!props2.hideAction && props2.trigger.indexOf("contextmenu") !== -1) {
        return ["click"];
      }
      return props2.hideAction;
    });
    return function() {
      var prefixCls = props2.prefixCls, arrow = props2.arrow, showAction = props2.showAction, overlayStyle = props2.overlayStyle, trigger2 = props2.trigger, placement = props2.placement, align = props2.align, getPopupContainer = props2.getPopupContainer, transitionName2 = props2.transitionName, animation = props2.animation, overlayClassName = props2.overlayClassName, otherProps = __rest$6(props2, ["prefixCls", "arrow", "showAction", "overlayStyle", "trigger", "placement", "align", "getPopupContainer", "transitionName", "animation", "overlayClassName"]);
      return createVNode(Trigger, _objectSpread2$1(_objectSpread2$1({}, otherProps), {}, {
        "prefixCls": prefixCls,
        "ref": triggerRef,
        "popupClassName": classNames(overlayClassName, _defineProperty$m({}, "".concat(prefixCls, "-show-arrow"), arrow)),
        "popupStyle": overlayStyle,
        "builtinPlacements": placements$2,
        "action": trigger2,
        "showAction": showAction,
        "hideAction": triggerHideAction.value || [],
        "popupPlacement": placement,
        "popupAlign": align,
        "popupTransitionName": transitionName2,
        "popupAnimation": animation,
        "popupVisible": triggerVisible.value,
        "stretch": minOverlayWidthMatchTrigger.value ? "minWidth" : "",
        "onPopupVisibleChange": onVisibleChange,
        "getPopupContainer": getPopupContainer
      }), {
        popup: getMenuElement,
        default: renderChildren2
      });
    };
  }
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: "transitionstart",
    WebkitTransition: "webkitTransitionStart",
    MozTransition: "mozTransitionStart",
    OTransition: "oTransitionStart",
    msTransition: "MSTransitionStart"
  },
  animationstart: {
    animation: "animationstart",
    WebkitAnimation: "webkitAnimationStart",
    MozAnimation: "mozAnimationStart",
    OAnimation: "oAnimationStart",
    msAnimation: "MSAnimationStart"
  }
};
var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: "transitionend",
    WebkitTransition: "webkitTransitionEnd",
    MozTransition: "mozTransitionEnd",
    OTransition: "oTransitionEnd",
    msTransition: "MSTransitionEnd"
  },
  animationend: {
    animation: "animationend",
    WebkitAnimation: "webkitAnimationEnd",
    MozAnimation: "mozAnimationEnd",
    OAnimation: "oAnimationEnd",
    msAnimation: "MSAnimationEnd"
  }
};
var startEvents = [];
var endEvents = [];
function detectEvents() {
  var testEl = document.createElement("div");
  var style2 = testEl.style;
  if (!("AnimationEvent" in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }
  if (!("TransitionEvent" in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }
  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style2) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }
  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}
if (typeof window !== "undefined" && typeof document !== "undefined") {
  detectEvents();
}
function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}
function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}
var TransitionEvents = {
  startEvents,
  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function(startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function(startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },
  endEvents,
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function(endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function(endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};
var TransitionEvents$1 = TransitionEvents;
var styleForPesudo;
function isHidden(element) {
  return !element || element.offsetParent === null;
}
function isNotGrey(color) {
  var match2 = (color || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
  if (match2 && match2[1] && match2[2] && match2[3]) {
    return !(match2[1] === match2[2] && match2[2] === match2[3]);
  }
  return true;
}
var Wave = defineComponent({
  name: "Wave",
  props: {
    insertExtraNode: Boolean,
    disabled: Boolean
  },
  setup: function setup33(props2, _ref) {
    var slots = _ref.slots, expose = _ref.expose;
    var instance = getCurrentInstance();
    var _useConfigInject = useConfigInject("", props2), csp = _useConfigInject.csp, prefixCls = _useConfigInject.prefixCls;
    expose({
      csp
    });
    var eventIns = null;
    var clickWaveTimeoutId = null;
    var animationStartId = null;
    var animationStart = false;
    var extraNode = null;
    var isUnmounted = false;
    var onTransitionStart = function onTransitionStart2(e2) {
      if (isUnmounted)
        return;
      var node = findDOMNode(instance);
      if (!e2 || e2.target !== node) {
        return;
      }
      if (!animationStart) {
        resetEffect(node);
      }
    };
    var onTransitionEnd = function onTransitionEnd2(e2) {
      if (!e2 || e2.animationName !== "fadeEffect") {
        return;
      }
      resetEffect(e2.target);
    };
    var getAttributeName = function getAttributeName2() {
      var insertExtraNode = props2.insertExtraNode;
      return insertExtraNode ? "".concat(prefixCls.value, "-click-animating") : "".concat(prefixCls.value, "-click-animating-without-extra-node");
    };
    var onClick2 = function onClick3(node, waveColor) {
      var _a;
      var insertExtraNode = props2.insertExtraNode, disabled = props2.disabled;
      if (disabled || !node || isHidden(node) || node.className.indexOf("-leave") >= 0) {
        return;
      }
      extraNode = document.createElement("div");
      extraNode.className = "".concat(prefixCls.value, "-click-animating-node");
      var attributeName = getAttributeName();
      node.removeAttribute(attributeName);
      node.setAttribute(attributeName, "true");
      styleForPesudo = styleForPesudo || document.createElement("style");
      if (waveColor && waveColor !== "#ffffff" && waveColor !== "rgb(255, 255, 255)" && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && waveColor !== "transparent") {
        if ((_a = csp.value) === null || _a === void 0 ? void 0 : _a.nonce) {
          styleForPesudo.nonce = csp.value.nonce;
        }
        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "\n        [".concat(prefixCls.value, "-click-animating-without-extra-node='true']::after, .").concat(prefixCls.value, "-click-animating-node {\n          --antd-wave-shadow-color: ").concat(waveColor, ";\n        }");
        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }
      if (insertExtraNode) {
        node.appendChild(extraNode);
      }
      TransitionEvents$1.addStartEventListener(node, onTransitionStart);
      TransitionEvents$1.addEndEventListener(node, onTransitionEnd);
    };
    var resetEffect = function resetEffect2(node) {
      if (!node || node === extraNode || !(node instanceof Element)) {
        return;
      }
      var insertExtraNode = props2.insertExtraNode;
      var attributeName = getAttributeName();
      node.setAttribute(attributeName, "false");
      if (styleForPesudo) {
        styleForPesudo.innerHTML = "";
      }
      if (insertExtraNode && extraNode && node.contains(extraNode)) {
        node.removeChild(extraNode);
      }
      TransitionEvents$1.removeStartEventListener(node, onTransitionStart);
      TransitionEvents$1.removeEndEventListener(node, onTransitionEnd);
    };
    var bindAnimationEvent = function bindAnimationEvent2(node) {
      if (!node || !node.getAttribute || node.getAttribute("disabled") || node.className.indexOf("disabled") >= 0) {
        return;
      }
      var newClick = function newClick2(e2) {
        if (e2.target.tagName === "INPUT" || isHidden(e2.target)) {
          return;
        }
        resetEffect(node);
        var waveColor = getComputedStyle(node).getPropertyValue("border-top-color") || getComputedStyle(node).getPropertyValue("border-color") || getComputedStyle(node).getPropertyValue("background-color");
        clickWaveTimeoutId = setTimeout(function() {
          return onClick2(node, waveColor);
        }, 0);
        wrapperRaf.cancel(animationStartId);
        animationStart = true;
        animationStartId = wrapperRaf(function() {
          animationStart = false;
        }, 10);
      };
      node.addEventListener("click", newClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener("click", newClick, true);
        }
      };
    };
    onMounted(function() {
      nextTick(function() {
        var node = findDOMNode(instance);
        if (node.nodeType !== 1) {
          return;
        }
        eventIns = bindAnimationEvent(node);
      });
    });
    onBeforeUnmount(function() {
      if (eventIns) {
        eventIns.cancel();
      }
      clearTimeout(clickWaveTimeoutId);
      isUnmounted = true;
    });
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)[0];
    };
  }
});
function convertLegacyProps(type) {
  if (type === "danger") {
    return {
      danger: true
    };
  }
  return {
    type
  };
}
var buttonProps = function buttonProps2() {
  return {
    prefixCls: String,
    type: String,
    htmlType: {
      type: String,
      default: "button"
    },
    shape: {
      type: String
    },
    size: {
      type: String
    },
    loading: {
      type: [Boolean, Object],
      default: function _default3() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    ghost: {
      type: Boolean,
      default: void 0
    },
    block: {
      type: Boolean,
      default: void 0
    },
    danger: {
      type: Boolean,
      default: void 0
    },
    icon: PropTypes$1.any,
    href: String,
    target: String,
    title: String,
    onClick: {
      type: Function
    },
    onMousedown: {
      type: Function
    }
  };
};
var buttonTypes = buttonProps;
var getCollapsedWidth = function getCollapsedWidth2(node) {
  if (node) {
    node.style.width = "0px";
    node.style.opacity = "0";
    node.style.transform = "scale(0)";
  }
};
var getRealWidth = function getRealWidth2(node) {
  nextTick(function() {
    if (node) {
      node.style.width = "".concat(node.scrollWidth, "px");
      node.style.opacity = "1";
      node.style.transform = "scale(1)";
    }
  });
};
var resetStyle = function resetStyle2(node) {
  if (node && node.style) {
    node.style.width = null;
    node.style.opacity = null;
    node.style.transform = null;
  }
};
var LoadingIcon = defineComponent({
  name: "LoadingIcon",
  props: {
    prefixCls: String,
    loading: [Boolean, Object],
    existIcon: Boolean
  },
  setup: function setup34(props2) {
    return function() {
      var existIcon = props2.existIcon, prefixCls = props2.prefixCls, loading = props2.loading;
      if (existIcon) {
        return createVNode("span", {
          "class": "".concat(prefixCls, "-loading-icon")
        }, [createVNode(LoadingOutlined$1, null, null)]);
      }
      var visible = !!loading;
      return createVNode(Transition, {
        "name": "".concat(prefixCls, "-loading-icon-motion"),
        "onBeforeEnter": getCollapsedWidth,
        "onEnter": getRealWidth,
        "onAfterEnter": resetStyle,
        "onBeforeLeave": getRealWidth,
        "onLeave": function onLeave(node) {
          setTimeout(function() {
            getCollapsedWidth(node);
          });
        },
        "onAfterLeave": resetStyle
      }, {
        default: function _default3() {
          return [visible ? createVNode("span", {
            "class": "".concat(prefixCls, "-loading-icon")
          }, [createVNode(LoadingOutlined$1, null, null)]) : null];
        }
      });
    };
  }
});
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isUnborderedButtonType(type) {
  return type === "text" || type === "link";
}
var Button = defineComponent({
  name: "AButton",
  inheritAttrs: false,
  __ANT_BUTTON: true,
  props: initDefaultProps$1(buttonTypes(), {
    type: "default"
  }),
  slots: ["icon"],
  setup: function setup35(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var _useConfigInject = useConfigInject("btn", props2), prefixCls = _useConfigInject.prefixCls, autoInsertSpaceInButton = _useConfigInject.autoInsertSpaceInButton, direction = _useConfigInject.direction, size = _useConfigInject.size;
    var buttonNodeRef = ref(null);
    var delayTimeoutRef = ref(void 0);
    var isNeedInserted = false;
    var innerLoading = ref(false);
    var hasTwoCNChar = ref(false);
    var autoInsertSpace = computed(function() {
      return autoInsertSpaceInButton.value !== false;
    });
    var loadingOrDelay = computed(function() {
      return _typeof$1(props2.loading) === "object" && props2.loading.delay ? props2.loading.delay || true : !!props2.loading;
    });
    watch(loadingOrDelay, function(val) {
      clearTimeout(delayTimeoutRef.value);
      if (typeof loadingOrDelay.value === "number") {
        delayTimeoutRef.value = setTimeout(function() {
          innerLoading.value = val;
        }, loadingOrDelay.value);
      } else {
        innerLoading.value = val;
      }
    }, {
      immediate: true
    });
    var classes = computed(function() {
      var _ref2;
      var type = props2.type, _props$shape = props2.shape, shape = _props$shape === void 0 ? "default" : _props$shape, ghost = props2.ghost, block = props2.block, danger = props2.danger;
      var pre = prefixCls.value;
      var sizeClassNameMap = {
        large: "lg",
        small: "sm",
        middle: void 0
      };
      var sizeFullname = size.value;
      var sizeCls = sizeFullname ? sizeClassNameMap[sizeFullname] || "" : "";
      return _ref2 = {}, _defineProperty$m(_ref2, "".concat(pre), true), _defineProperty$m(_ref2, "".concat(pre, "-").concat(type), type), _defineProperty$m(_ref2, "".concat(pre, "-").concat(shape), shape !== "default" && shape), _defineProperty$m(_ref2, "".concat(pre, "-").concat(sizeCls), sizeCls), _defineProperty$m(_ref2, "".concat(pre, "-loading"), innerLoading.value), _defineProperty$m(_ref2, "".concat(pre, "-background-ghost"), ghost && !isUnborderedButtonType(type)), _defineProperty$m(_ref2, "".concat(pre, "-two-chinese-chars"), hasTwoCNChar.value && autoInsertSpace.value), _defineProperty$m(_ref2, "".concat(pre, "-block"), block), _defineProperty$m(_ref2, "".concat(pre, "-dangerous"), !!danger), _defineProperty$m(_ref2, "".concat(pre, "-rtl"), direction.value === "rtl"), _ref2;
    });
    var fixTwoCNChar = function fixTwoCNChar2() {
      var node = buttonNodeRef.value;
      if (!node || autoInsertSpaceInButton.value === false) {
        return;
      }
      var buttonText = node.textContent;
      if (isNeedInserted && isTwoCNChar(buttonText)) {
        if (!hasTwoCNChar.value) {
          hasTwoCNChar.value = true;
        }
      } else if (hasTwoCNChar.value) {
        hasTwoCNChar.value = false;
      }
    };
    var handleClick = function handleClick2(event) {
      if (innerLoading.value || props2.disabled) {
        event.preventDefault();
        return;
      }
      emit("click", event);
    };
    var insertSpace = function insertSpace2(child, needInserted) {
      var SPACE = needInserted ? " " : "";
      if (child.type === Text) {
        var text = child.children.trim();
        if (isTwoCNChar(text)) {
          text = text.split("").join(SPACE);
        }
        return createVNode("span", null, [text]);
      }
      return child;
    };
    watchEffect(function() {
      devWarning(!(props2.ghost && isUnborderedButtonType(props2.type)), "Button", "`link` or `text` button can't be a `ghost` button.");
    });
    onMounted(fixTwoCNChar);
    onUpdated(fixTwoCNChar);
    onBeforeUnmount(function() {
      delayTimeoutRef.value && clearTimeout(delayTimeoutRef.value);
    });
    return function() {
      var _a, _b;
      var _props$icon = props2.icon, icon = _props$icon === void 0 ? (_a = slots.icon) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$icon;
      var children = flattenChildren((_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots));
      isNeedInserted = children.length === 1 && !icon && !isUnborderedButtonType(props2.type);
      var type = props2.type, htmlType = props2.htmlType, disabled = props2.disabled, href = props2.href, title = props2.title, target = props2.target, onMousedown2 = props2.onMousedown;
      var iconType = innerLoading.value ? "loading" : icon;
      var buttonProps3 = _extends(_extends({}, attrs), {
        title,
        disabled,
        class: [classes.value, attrs.class, _defineProperty$m({}, "".concat(prefixCls.value, "-icon-only"), children.length === 0 && !!iconType)],
        onClick: handleClick,
        onMousedown: onMousedown2
      });
      if (!disabled) {
        delete buttonProps3.disabled;
      }
      var iconNode = icon && !innerLoading.value ? icon : createVNode(LoadingIcon, {
        "existIcon": !!icon,
        "prefixCls": prefixCls.value,
        "loading": !!innerLoading.value
      }, null);
      var kids = children.map(function(child) {
        return insertSpace(child, isNeedInserted && autoInsertSpace.value);
      });
      if (href !== void 0) {
        return createVNode("a", _objectSpread2$1(_objectSpread2$1({}, buttonProps3), {}, {
          "href": href,
          "target": target,
          "ref": buttonNodeRef
        }), [iconNode, kids]);
      }
      var buttonNode = createVNode("button", _objectSpread2$1(_objectSpread2$1({}, buttonProps3), {}, {
        "ref": buttonNodeRef,
        "type": htmlType
      }), [iconNode, kids]);
      if (isUnborderedButtonType(type)) {
        return buttonNode;
      }
      return createVNode(Wave, {
        "ref": "wave",
        "disabled": !!innerLoading.value
      }, {
        default: function _default3() {
          return [buttonNode];
        }
      });
    };
  }
});
function _defineProperties(target, props2) {
  for (var i = 0; i < props2.length; i++) {
    var descriptor = props2[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var UnreachableException = /* @__PURE__ */ _createClass(function UnreachableException2(value) {
  _classCallCheck(this, UnreachableException2);
  this.error = new Error("unreachable case: ".concat(JSON.stringify(value)));
});
var buttonGroupProps = function buttonGroupProps2() {
  return {
    prefixCls: String,
    size: {
      type: String
    }
  };
};
var ButtonGroup$1 = defineComponent({
  name: "AButtonGroup",
  props: buttonGroupProps(),
  setup: function setup36(props2, _ref) {
    var slots = _ref.slots;
    var _useConfigInject = useConfigInject("btn-group", props2), prefixCls = _useConfigInject.prefixCls, direction = _useConfigInject.direction;
    var classes = computed(function() {
      var _ref2;
      var size = props2.size;
      var sizeCls = "";
      switch (size) {
        case "large":
          sizeCls = "lg";
          break;
        case "small":
          sizeCls = "sm";
          break;
        case "middle":
        case void 0:
          break;
        default:
          console.warn(new UnreachableException(size).error);
      }
      return _ref2 = {}, _defineProperty$m(_ref2, "".concat(prefixCls.value), true), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-").concat(sizeCls), sizeCls), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-rtl"), direction.value === "rtl"), _ref2;
    });
    return function() {
      var _a;
      return createVNode("div", {
        "class": classes.value
      }, [flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots))]);
    };
  }
});
Button.Group = ButtonGroup$1;
Button.install = function(app) {
  app.component(Button.name, Button);
  app.component(ButtonGroup$1.name, ButtonGroup$1);
  return app;
};
var dropdownProps = function dropdownProps2() {
  return {
    arrow: {
      type: [Boolean, Object],
      default: void 0
    },
    trigger: {
      type: [Array, String]
    },
    overlay: PropTypes$1.any,
    visible: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    align: {
      type: Object
    },
    getPopupContainer: Function,
    prefixCls: String,
    transitionName: String,
    placement: String,
    overlayClassName: String,
    overlayStyle: {
      type: Object,
      default: void 0
    },
    forceRender: {
      type: Boolean,
      default: void 0
    },
    mouseEnterDelay: Number,
    mouseLeaveDelay: Number,
    openClassName: String,
    minOverlayWidthMatchTrigger: {
      type: Boolean,
      default: void 0
    },
    destroyPopupOnHide: {
      type: Boolean,
      default: void 0
    },
    onVisibleChange: {
      type: Function
    },
    "onUpdate:visible": {
      type: Function
    }
  };
};
var buttonTypesProps = buttonTypes();
var dropdownButtonProps = function dropdownButtonProps2() {
  return _extends(_extends({}, dropdownProps()), {
    type: buttonTypesProps.type,
    size: String,
    htmlType: buttonTypesProps.htmlType,
    href: String,
    disabled: {
      type: Boolean,
      default: void 0
    },
    prefixCls: String,
    icon: PropTypes$1.any,
    title: String,
    loading: buttonTypesProps.loading,
    onClick: {
      type: Function
    }
  });
};
var EllipsisOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z" } }] }, "name": "ellipsis", "theme": "outlined" };
var EllipsisOutlinedSvg = EllipsisOutlined$2;
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$4(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$4(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var EllipsisOutlined = function EllipsisOutlined2(props2, context) {
  var p = _objectSpread$4({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$4({}, p, {
    "icon": EllipsisOutlinedSvg
  }), null);
};
EllipsisOutlined.displayName = "EllipsisOutlined";
EllipsisOutlined.inheritAttrs = false;
var EllipsisOutlined$1 = EllipsisOutlined;
var __rest$5 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var ButtonGroup = Button.Group;
var DropdownButton = defineComponent({
  name: "ADropdownButton",
  inheritAttrs: false,
  __ANT_BUTTON: true,
  props: initDefaultProps$1(dropdownButtonProps(), {
    trigger: "hover",
    placement: "bottomRight",
    type: "default"
  }),
  slots: ["icon", "leftButton", "rightButton", "overlay"],
  setup: function setup37(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var handleVisibleChange = function handleVisibleChange2(val) {
      emit("update:visible", val);
      emit("visibleChange", val);
    };
    var _useConfigInject = useConfigInject("dropdown-button", props2), prefixCls = _useConfigInject.prefixCls, direction = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer;
    return function() {
      var _a, _b;
      var _c = _extends(_extends({}, props2), attrs), _c$type = _c.type, type = _c$type === void 0 ? "default" : _c$type, disabled = _c.disabled, loading = _c.loading, htmlType = _c.htmlType, _c$class = _c.class, className = _c$class === void 0 ? "" : _c$class, _c$overlay = _c.overlay, _overlay = _c$overlay === void 0 ? (_a = slots.overlay) === null || _a === void 0 ? void 0 : _a.call(slots) : _c$overlay, trigger2 = _c.trigger, align = _c.align, visible = _c.visible;
      _c.onVisibleChange;
      var _c$placement = _c.placement, placement = _c$placement === void 0 ? direction.value === "rtl" ? "bottomLeft" : "bottomRight" : _c$placement, href = _c.href, title = _c.title, _c$icon = _c.icon, icon = _c$icon === void 0 ? ((_b = slots.icon) === null || _b === void 0 ? void 0 : _b.call(slots)) || createVNode(EllipsisOutlined$1, null, null) : _c$icon, mouseEnterDelay = _c.mouseEnterDelay, mouseLeaveDelay = _c.mouseLeaveDelay, overlayClassName = _c.overlayClassName, overlayStyle = _c.overlayStyle, destroyPopupOnHide = _c.destroyPopupOnHide, onClick2 = _c.onClick;
      _c["onUpdate:visible"];
      var restProps = __rest$5(_c, ["type", "disabled", "loading", "htmlType", "class", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "href", "title", "icon", "mouseEnterDelay", "mouseLeaveDelay", "overlayClassName", "overlayStyle", "destroyPopupOnHide", "onClick", "onUpdate:visible"]);
      var dropdownProps3 = {
        align,
        disabled,
        trigger: disabled ? [] : trigger2,
        placement,
        getPopupContainer: getPopupContainer.value,
        onVisibleChange: handleVisibleChange,
        mouseEnterDelay,
        mouseLeaveDelay,
        visible,
        overlayClassName,
        overlayStyle,
        destroyPopupOnHide
      };
      var leftButton = createVNode(Button, {
        "type": type,
        "disabled": disabled,
        "loading": loading,
        "onClick": onClick2,
        "htmlType": htmlType,
        "href": href,
        "title": title
      }, {
        default: slots.default
      });
      var rightButton = createVNode(Button, {
        "type": type,
        "icon": icon
      }, null);
      return createVNode(ButtonGroup, _objectSpread2$1(_objectSpread2$1({}, restProps), {}, {
        "class": classNames(prefixCls.value, className)
      }), {
        default: function _default3() {
          return [slots.leftButton ? slots.leftButton({
            button: leftButton
          }) : leftButton, createVNode(Dropdown$1, dropdownProps3, {
            default: function _default4() {
              return [slots.rightButton ? slots.rightButton({
                button: rightButton
              }) : rightButton];
            },
            overlay: function overlay() {
              return _overlay;
            }
          })];
        }
      });
    };
  }
});
var RightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlinedSvg = RightOutlined$2;
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$3(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$3(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var RightOutlined = function RightOutlined2(props2, context) {
  var p = _objectSpread$3({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$3({}, p, {
    "icon": RightOutlinedSvg
  }), null);
};
RightOutlined.displayName = "RightOutlined";
RightOutlined.inheritAttrs = false;
var RightOutlined$1 = RightOutlined;
var Dropdown = defineComponent({
  name: "ADropdown",
  inheritAttrs: false,
  props: initDefaultProps$1(dropdownProps(), {
    mouseEnterDelay: 0.15,
    mouseLeaveDelay: 0.1,
    placement: "bottomLeft",
    trigger: "hover"
  }),
  slots: ["overlay"],
  setup: function setup38(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var _useConfigInject = useConfigInject("dropdown", props2), prefixCls = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, direction = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer;
    var transitionName2 = computed(function() {
      var _props$placement = props2.placement, placement2 = _props$placement === void 0 ? "" : _props$placement, transitionName3 = props2.transitionName;
      if (transitionName3 !== void 0) {
        return transitionName3;
      }
      if (placement2.indexOf("top") >= 0) {
        return "".concat(rootPrefixCls.value, "-slide-down");
      }
      return "".concat(rootPrefixCls.value, "-slide-up");
    });
    var renderOverlay = function renderOverlay2() {
      var _a, _b, _c;
      var overlay = props2.overlay || ((_a = slots.overlay) === null || _a === void 0 ? void 0 : _a.call(slots));
      var overlayNode = Array.isArray(overlay) ? overlay[0] : overlay;
      if (!overlayNode)
        return null;
      var overlayProps = overlayNode.props || {};
      devWarning(!overlayProps.mode || overlayProps.mode === "vertical", "Dropdown", 'mode="'.concat(overlayProps.mode, `" is not supported for Dropdown's Menu.`));
      var _overlayProps$selecta = overlayProps.selectable, selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta, _overlayProps$expandI = overlayProps.expandIcon, expandIcon = _overlayProps$expandI === void 0 ? (_c = (_b = overlayNode.children) === null || _b === void 0 ? void 0 : _b.expandIcon) === null || _c === void 0 ? void 0 : _c.call(_b) : _overlayProps$expandI;
      var overlayNodeExpandIcon = typeof expandIcon !== "undefined" && isValidElement(expandIcon) ? expandIcon : createVNode("span", {
        "class": "".concat(prefixCls.value, "-menu-submenu-arrow")
      }, [createVNode(RightOutlined$1, {
        "class": "".concat(prefixCls.value, "-menu-submenu-arrow-icon")
      }, null)]);
      var fixedModeOverlay = isValidElement(overlayNode) ? cloneElement(overlayNode, {
        mode: "vertical",
        selectable,
        expandIcon: function expandIcon2() {
          return overlayNodeExpandIcon;
        }
      }) : overlayNode;
      return fixedModeOverlay;
    };
    var placement = computed(function() {
      var placement2 = props2.placement;
      if (!placement2) {
        return direction.value === "rtl" ? "bottomRight" : "bottomLeft";
      }
      if (placement2.includes("Center")) {
        var newPlacement = placement2.slice(0, placement2.indexOf("Center"));
        devWarning(!placement2.includes("Center"), "Dropdown", "You are using '".concat(placement2, "' placement in Dropdown, which is deprecated. Try to use '").concat(newPlacement, "' instead."));
        return newPlacement;
      }
      return placement2;
    });
    var handleVisibleChange = function handleVisibleChange2(val) {
      emit("update:visible", val);
      emit("visibleChange", val);
    };
    return function() {
      var _a, _b;
      var arrow = props2.arrow, trigger2 = props2.trigger, disabled = props2.disabled, overlayClassName = props2.overlayClassName;
      var child = (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)[0];
      var dropdownTrigger = cloneElement(child, _extends({
        class: classNames((_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.class, _defineProperty$m({}, "".concat(prefixCls.value, "-rtl"), direction.value === "rtl"), "".concat(prefixCls.value, "-trigger"))
      }, disabled ? {
        disabled
      } : {}));
      var overlayClassNameCustomized = classNames(overlayClassName, _defineProperty$m({}, "".concat(prefixCls.value, "-rtl"), direction.value === "rtl"));
      var triggerActions = disabled ? [] : trigger2;
      var alignPoint2;
      if (triggerActions && triggerActions.indexOf("contextmenu") !== -1) {
        alignPoint2 = true;
      }
      var builtinPlacements = getPlacements({
        arrowPointAtCenter: _typeof$1(arrow) === "object" && arrow.pointAtCenter,
        autoAdjustOverflow: true
      });
      var dropdownProps3 = omit(_extends(_extends(_extends({}, props2), attrs), {
        builtinPlacements,
        overlayClassName: overlayClassNameCustomized,
        arrow,
        alignPoint: alignPoint2,
        prefixCls: prefixCls.value,
        getPopupContainer: getPopupContainer.value,
        transitionName: transitionName2.value,
        trigger: triggerActions,
        onVisibleChange: handleVisibleChange,
        placement: placement.value
      }), ["overlay", "onUpdate:visible"]);
      return createVNode(Dropdown$2, dropdownProps3, {
        default: function _default3() {
          return [dropdownTrigger];
        },
        overlay: renderOverlay
      });
    };
  }
});
Dropdown.Button = DropdownButton;
var Dropdown$1 = Dropdown;
function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
  if (ret !== void 0) {
    return !!ret;
  }
  if (objA === objB) {
    return true;
  }
  if (_typeof$1(objA) !== "object" || !objA || _typeof$1(objB) !== "object" || !objB) {
    return false;
  }
  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var idx = 0; idx < keysA.length; idx++) {
    var key2 = keysA[idx];
    if (!bHasOwnProperty(key2)) {
      return false;
    }
    var valueA = objA[key2];
    var valueB = objB[key2];
    ret = compare ? compare.call(compareContext, valueA, valueB, key2) : void 0;
    if (ret === false || ret === void 0 && valueA !== valueB) {
      return false;
    }
  }
  return true;
}
function shallowequal(value, other, customizer, thisArg) {
  return shallowEqual(toRaw(value), toRaw(other), customizer, thisArg);
}
var MenuContextKey = Symbol("menuContextKey");
var useProvideMenu = function useProvideMenu2(props2) {
  provide(MenuContextKey, props2);
};
var useInjectMenu = function useInjectMenu2() {
  return inject(MenuContextKey);
};
var ForceRenderKey = Symbol("ForceRenderKey");
var useProvideForceRender = function useProvideForceRender2(forceRender) {
  provide(ForceRenderKey, forceRender);
};
var useInjectForceRender = function useInjectForceRender2() {
  return inject(ForceRenderKey, false);
};
var MenuFirstLevelContextKey = Symbol("menuFirstLevelContextKey");
var useProvideFirstLevel = function useProvideFirstLevel2(firstLevel) {
  provide(MenuFirstLevelContextKey, firstLevel);
};
var useInjectFirstLevel = function useInjectFirstLevel2() {
  return inject(MenuFirstLevelContextKey, true);
};
var MenuContextProvider = defineComponent({
  name: "MenuContextProvider",
  inheritAttrs: false,
  props: {
    mode: {
      type: String,
      default: void 0
    },
    overflowDisabled: {
      type: Boolean,
      default: void 0
    },
    isRootMenu: {
      type: Boolean,
      default: void 0
    }
  },
  setup: function setup39(props2, _ref) {
    var slots = _ref.slots;
    var menuContext = useInjectMenu();
    var newContext = _extends({}, menuContext);
    if (props2.mode !== void 0) {
      newContext.mode = toRef(props2, "mode");
    }
    if (props2.isRootMenu !== void 0) {
      newContext.isRootMenu = toRef(props2, "isRootMenu");
    }
    if (props2.overflowDisabled !== void 0) {
      newContext.overflowDisabled = toRef(props2, "overflowDisabled");
    }
    useProvideMenu(newContext);
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
});
var useProvideMenu$1 = useProvideMenu;
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return index2;
    }
  }
  return -1;
}
function baseIsNaN(value) {
  return value !== value;
}
function strictIndexOf(array, value, fromIndex) {
  var index2 = fromIndex - 1, length = array.length;
  while (++index2 < length) {
    if (array[index2] === value) {
      return index2;
    }
  }
  return -1;
}
function baseIndexOf(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
function arrayIncludesWith(array, value, comparator) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (comparator(value, array[index2])) {
      return true;
    }
  }
  return false;
}
function noop() {
}
var INFINITY = 1 / 0;
var createSet = !(Set$2 && 1 / setToArray(new Set$2([, -0]))[1] == INFINITY) ? noop : function(values) {
  return new Set$2(values);
};
var createSet$1 = createSet;
var LARGE_ARRAY_SIZE = 200;
function baseUniq(array, iteratee, comparator) {
  var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
  if (comparator) {
    isCommon = false;
    includes2 = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet$1(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes2 = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length) {
      var value = array[index2], computed2 = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed2) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed2);
        }
        result.push(value);
      } else if (!includes2(seen, computed2, comparator)) {
        if (seen !== result) {
          seen.push(computed2);
        }
        result.push(value);
      }
    }
  return result;
}
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}
var SiderCollapsedKey = Symbol("siderCollapsed");
var OVERFLOW_KEY = "$$__vc-menu-more__key";
var KeyPathContext = Symbol("KeyPathContext");
var useInjectKeyPath = function useInjectKeyPath2() {
  return inject(KeyPathContext, {
    parentEventKeys: computed(function() {
      return [];
    }),
    parentKeys: computed(function() {
      return [];
    }),
    parentInfo: {}
  });
};
var useProvideKeyPath = function useProvideKeyPath2(eventKey, key2, menuInfo) {
  var _useInjectKeyPath = useInjectKeyPath(), parentEventKeys = _useInjectKeyPath.parentEventKeys, parentKeys = _useInjectKeyPath.parentKeys;
  var eventKeys = computed(function() {
    return [].concat(_toConsumableArray(parentEventKeys.value), [eventKey]);
  });
  var keys2 = computed(function() {
    return [].concat(_toConsumableArray(parentKeys.value), [key2]);
  });
  provide(KeyPathContext, {
    parentEventKeys: eventKeys,
    parentKeys: keys2,
    parentInfo: menuInfo
  });
  return keys2;
};
var measure = Symbol("measure");
var PathContext = defineComponent({
  setup: function setup40(_props, _ref) {
    var slots = _ref.slots;
    provide(measure, true);
    return function() {
      var _a;
      return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
    };
  }
});
var useMeasure = function useMeasure2() {
  return inject(measure, false);
};
var useProvideKeyPath$1 = useProvideKeyPath;
function useDirectionStyle(level) {
  var _useInjectMenu = useInjectMenu(), mode2 = _useInjectMenu.mode, rtl2 = _useInjectMenu.rtl, inlineIndent = _useInjectMenu.inlineIndent;
  return computed(function() {
    return mode2.value !== "inline" ? null : rtl2.value ? {
      paddingRight: "".concat(level.value * inlineIndent.value, "px")
    } : {
      paddingLeft: "".concat(level.value * inlineIndent.value, "px")
    };
  });
}
var indexGuid$1 = 0;
var menuItemProps = function menuItemProps2() {
  return {
    id: String,
    role: String,
    disabled: Boolean,
    danger: Boolean,
    title: {
      type: [String, Boolean],
      default: void 0
    },
    icon: PropTypes$1.any,
    onMouseenter: Function,
    onMouseleave: Function,
    onClick: Function,
    onKeydown: Function,
    onFocus: Function
  };
};
var MenuItem = defineComponent({
  name: "AMenuItem",
  inheritAttrs: false,
  props: menuItemProps(),
  slots: ["icon", "title"],
  setup: function setup41(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs;
    var instance = getCurrentInstance();
    var isMeasure = useMeasure();
    var key2 = _typeof$1(instance.vnode.key) === "symbol" ? String(instance.vnode.key) : instance.vnode.key;
    devWarning(_typeof$1(instance.vnode.key) !== "symbol", "MenuItem", 'MenuItem `:key="'.concat(String(key2), '"` not support Symbol type'));
    var eventKey = "menu_item_".concat(++indexGuid$1, "_$$_").concat(key2);
    var _useInjectKeyPath = useInjectKeyPath(), parentEventKeys = _useInjectKeyPath.parentEventKeys, parentKeys = _useInjectKeyPath.parentKeys;
    var _useInjectMenu = useInjectMenu(), prefixCls = _useInjectMenu.prefixCls, activeKeys = _useInjectMenu.activeKeys, disabled = _useInjectMenu.disabled, changeActiveKeys = _useInjectMenu.changeActiveKeys, rtl2 = _useInjectMenu.rtl, inlineCollapsed = _useInjectMenu.inlineCollapsed, siderCollapsed = _useInjectMenu.siderCollapsed, onItemClick = _useInjectMenu.onItemClick, selectedKeys = _useInjectMenu.selectedKeys, registerMenuInfo = _useInjectMenu.registerMenuInfo, unRegisterMenuInfo = _useInjectMenu.unRegisterMenuInfo;
    var firstLevel = useInjectFirstLevel();
    var isActive = ref(false);
    var keysPath = computed(function() {
      return [].concat(_toConsumableArray(parentKeys.value), [key2]);
    });
    var menuInfo = {
      eventKey,
      key: key2,
      parentEventKeys,
      parentKeys,
      isLeaf: true
    };
    registerMenuInfo(eventKey, menuInfo);
    onBeforeUnmount(function() {
      unRegisterMenuInfo(eventKey);
    });
    watch(activeKeys, function() {
      isActive.value = !!activeKeys.value.find(function(val) {
        return val === key2;
      });
    }, {
      immediate: true
    });
    var mergedDisabled = computed(function() {
      return disabled.value || props2.disabled;
    });
    var selected = computed(function() {
      return selectedKeys.value.includes(key2);
    });
    var classNames2 = computed(function() {
      var _ref2;
      var itemCls = "".concat(prefixCls.value, "-item");
      return _ref2 = {}, _defineProperty$m(_ref2, "".concat(itemCls), true), _defineProperty$m(_ref2, "".concat(itemCls, "-danger"), props2.danger), _defineProperty$m(_ref2, "".concat(itemCls, "-active"), isActive.value), _defineProperty$m(_ref2, "".concat(itemCls, "-selected"), selected.value), _defineProperty$m(_ref2, "".concat(itemCls, "-disabled"), mergedDisabled.value), _ref2;
    });
    var getEventInfo = function getEventInfo2(e2) {
      return {
        key: key2,
        eventKey,
        keyPath: keysPath.value,
        eventKeyPath: [].concat(_toConsumableArray(parentEventKeys.value), [eventKey]),
        domEvent: e2,
        item: _extends(_extends({}, props2), attrs)
      };
    };
    var onInternalClick = function onInternalClick2(e2) {
      if (mergedDisabled.value) {
        return;
      }
      var info = getEventInfo(e2);
      emit("click", e2);
      onItemClick(info);
    };
    var onMouseEnter = function onMouseEnter2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys(keysPath.value);
        emit("mouseenter", event);
      }
    };
    var onMouseLeave = function onMouseLeave2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys([]);
        emit("mouseleave", event);
      }
    };
    var onInternalKeyDown = function onInternalKeyDown2(e2) {
      emit("keydown", e2);
      if (e2.which === KeyCode$1.ENTER) {
        var info = getEventInfo(e2);
        emit("click", e2);
        onItemClick(info);
      }
    };
    var onInternalFocus = function onInternalFocus2(e2) {
      changeActiveKeys(keysPath.value);
      emit("focus", e2);
    };
    var renderItemChildren = function renderItemChildren2(icon, children) {
      var wrapNode = createVNode("span", {
        "class": "".concat(prefixCls.value, "-title-content")
      }, [children]);
      if (!icon || isValidElement(children) && children.type === "span") {
        if (children && inlineCollapsed.value && firstLevel && typeof children === "string") {
          return createVNode("div", {
            "class": "".concat(prefixCls.value, "-inline-collapsed-noicon")
          }, [children.charAt(0)]);
        }
      }
      return wrapNode;
    };
    var directionStyle = useDirectionStyle(computed(function() {
      return keysPath.value.length;
    }));
    return function() {
      var _ref3;
      var _a, _b, _c;
      if (isMeasure)
        return null;
      var title = (_a = props2.title) !== null && _a !== void 0 ? _a : (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots);
      var children = flattenChildren((_c = slots.default) === null || _c === void 0 ? void 0 : _c.call(slots));
      var childrenLength = children.length;
      var tooltipTitle = title;
      if (typeof title === "undefined") {
        tooltipTitle = firstLevel && childrenLength ? children : "";
      } else if (title === false) {
        tooltipTitle = "";
      }
      var tooltipProps3 = {
        title: tooltipTitle
      };
      if (!siderCollapsed.value && !inlineCollapsed.value) {
        tooltipProps3.title = null;
        tooltipProps3.visible = false;
      }
      var optionRoleProps = {};
      if (props2.role === "option") {
        optionRoleProps["aria-selected"] = selected.value;
      }
      var icon = getPropsSlot(slots, props2, "icon");
      return createVNode(Tooltip, _objectSpread2$1(_objectSpread2$1({}, tooltipProps3), {}, {
        "placement": rtl2.value ? "left" : "right",
        "overlayClassName": "".concat(prefixCls.value, "-inline-collapsed-tooltip")
      }), {
        default: function _default3() {
          return [createVNode(Overflow$1.Item, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({
            "component": "li"
          }, attrs), {}, {
            "id": props2.id,
            "style": _extends(_extends({}, attrs.style || {}), directionStyle.value),
            "class": [classNames2.value, (_ref3 = {}, _defineProperty$m(_ref3, "".concat(attrs.class), !!attrs.class), _defineProperty$m(_ref3, "".concat(prefixCls.value, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _ref3)],
            "role": props2.role || "menuitem",
            "tabindex": props2.disabled ? null : -1,
            "data-menu-id": key2,
            "aria-disabled": props2.disabled
          }, optionRoleProps), {}, {
            "onMouseenter": onMouseEnter,
            "onMouseleave": onMouseLeave,
            "onClick": onInternalClick,
            "onKeydown": onInternalKeyDown,
            "onFocus": onInternalFocus,
            "title": typeof title === "string" ? title : void 0
          }), {
            default: function _default4() {
              return [cloneElement(icon, {
                class: "".concat(prefixCls.value, "-item-icon")
              }, false), renderItemChildren(icon, children)];
            }
          })];
        }
      });
    };
  }
});
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var placements = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var placementsRtl = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflow,
    offset: [0, -7]
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflow,
    offset: [0, 7]
  },
  rightTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflow,
    offset: [-4, 0]
  },
  leftTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflow,
    offset: [4, 0]
  }
};
var popupPlacementMap = {
  horizontal: "bottomLeft",
  vertical: "rightTop",
  "vertical-left": "rightTop",
  "vertical-right": "leftTop"
};
var PopupTrigger = defineComponent({
  name: "PopupTrigger",
  inheritAttrs: false,
  props: {
    prefixCls: String,
    mode: String,
    visible: Boolean,
    popupClassName: String,
    popupOffset: Array,
    disabled: Boolean,
    onVisibleChange: Function
  },
  slots: ["popup"],
  emits: ["visibleChange"],
  setup: function setup42(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit;
    var innerVisible = ref(false);
    var _useInjectMenu = useInjectMenu(), getPopupContainer = _useInjectMenu.getPopupContainer, rtl2 = _useInjectMenu.rtl, subMenuOpenDelay = _useInjectMenu.subMenuOpenDelay, subMenuCloseDelay = _useInjectMenu.subMenuCloseDelay, builtinPlacements = _useInjectMenu.builtinPlacements, triggerSubMenuAction = _useInjectMenu.triggerSubMenuAction, isRootMenu = _useInjectMenu.isRootMenu, forceSubMenuRender = _useInjectMenu.forceSubMenuRender, motion = _useInjectMenu.motion, defaultMotions = _useInjectMenu.defaultMotions;
    var forceRender = useInjectForceRender();
    var placement = computed(function() {
      return rtl2.value ? _extends(_extends({}, placementsRtl), builtinPlacements.value) : _extends(_extends({}, placements), builtinPlacements.value);
    });
    var popupPlacement = computed(function() {
      return popupPlacementMap[props2.mode];
    });
    var visibleRef = ref();
    watch(function() {
      return props2.visible;
    }, function(visible) {
      wrapperRaf.cancel(visibleRef.value);
      visibleRef.value = wrapperRaf(function() {
        innerVisible.value = visible;
      });
    }, {
      immediate: true
    });
    onBeforeUnmount(function() {
      wrapperRaf.cancel(visibleRef.value);
    });
    var onVisibleChange = function onVisibleChange2(visible) {
      emit("visibleChange", visible);
    };
    var mergedMotion = computed(function() {
      var _a, _b;
      var m2 = motion.value || ((_a = defaultMotions.value) === null || _a === void 0 ? void 0 : _a[props2.mode]) || ((_b = defaultMotions.value) === null || _b === void 0 ? void 0 : _b.other);
      var res = typeof m2 === "function" ? m2() : m2;
      return res ? getTransitionProps(res.name, {
        css: true
      }) : void 0;
    });
    return function() {
      var prefixCls = props2.prefixCls, popupClassName = props2.popupClassName, mode2 = props2.mode, popupOffset = props2.popupOffset, disabled = props2.disabled;
      return createVNode(Trigger, {
        "prefixCls": prefixCls,
        "popupClassName": classNames("".concat(prefixCls, "-popup"), _defineProperty$m({}, "".concat(prefixCls, "-rtl"), rtl2.value), popupClassName),
        "stretch": mode2 === "horizontal" ? "minWidth" : null,
        "getPopupContainer": isRootMenu.value ? getPopupContainer.value : function(triggerNode) {
          return triggerNode.parentNode;
        },
        "builtinPlacements": placement.value,
        "popupPlacement": popupPlacement.value,
        "popupVisible": innerVisible.value,
        "popupAlign": popupOffset && {
          offset: popupOffset
        },
        "action": disabled ? [] : [triggerSubMenuAction.value],
        "mouseEnterDelay": subMenuOpenDelay.value,
        "mouseLeaveDelay": subMenuCloseDelay.value,
        "onPopupVisibleChange": onVisibleChange,
        "forceRender": forceRender || forceSubMenuRender.value,
        "popupAnimation": mergedMotion.value
      }, {
        popup: slots.popup,
        default: slots.default
      });
    };
  }
});
var InternalSubMenuList = function InternalSubMenuList2(_props, _ref) {
  var slots = _ref.slots, attrs = _ref.attrs;
  var _a;
  var _useInjectMenu = useInjectMenu(), prefixCls = _useInjectMenu.prefixCls, mode2 = _useInjectMenu.mode;
  return createVNode("ul", _objectSpread2$1(_objectSpread2$1({}, attrs), {}, {
    "class": classNames(prefixCls.value, "".concat(prefixCls.value, "-sub"), "".concat(prefixCls.value, "-").concat(mode2.value === "inline" ? "inline" : "vertical")),
    "data-menu-list": true
  }), [(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)]);
};
InternalSubMenuList.displayName = "SubMenuList";
var SubMenuList = InternalSubMenuList;
var InlineSubMenuList = defineComponent({
  name: "InlineSubMenuList",
  inheritAttrs: false,
  props: {
    id: String,
    open: Boolean,
    keyPath: Array
  },
  setup: function setup43(props2, _ref) {
    var slots = _ref.slots;
    var fixedMode = computed(function() {
      return "inline";
    });
    var _useInjectMenu = useInjectMenu(), motion = _useInjectMenu.motion, mode2 = _useInjectMenu.mode, defaultMotions = _useInjectMenu.defaultMotions;
    var sameModeRef = computed(function() {
      return mode2.value === fixedMode.value;
    });
    var destroy3 = ref(!sameModeRef.value);
    var mergedOpen = computed(function() {
      return sameModeRef.value ? props2.open : false;
    });
    watch(mode2, function() {
      if (sameModeRef.value) {
        destroy3.value = false;
      }
    }, {
      flush: "post"
    });
    var mergedMotion = computed(function() {
      var _a, _b;
      var m2 = motion.value || ((_a = defaultMotions.value) === null || _a === void 0 ? void 0 : _a[fixedMode.value]) || ((_b = defaultMotions.value) === null || _b === void 0 ? void 0 : _b.other);
      var res = typeof m2 === "function" ? m2() : m2;
      return _extends(_extends({}, res), {
        appear: props2.keyPath.length <= 1
      });
    });
    return function() {
      var _a;
      if (destroy3.value) {
        return null;
      }
      return createVNode(MenuContextProvider, {
        "mode": fixedMode.value
      }, {
        default: function _default3() {
          return [createVNode(Transition, mergedMotion.value, {
            default: function _default4() {
              return [withDirectives(createVNode(SubMenuList, {
                "id": props2.id
              }, {
                default: function _default5() {
                  return [(_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots)];
                }
              }), [[vShow, mergedOpen.value]])];
            }
          })];
        }
      });
    };
  }
});
var indexGuid = 0;
var subMenuProps = function subMenuProps2() {
  return {
    icon: PropTypes$1.any,
    title: PropTypes$1.any,
    disabled: Boolean,
    level: Number,
    popupClassName: String,
    popupOffset: Array,
    internalPopupClose: Boolean,
    eventKey: String,
    expandIcon: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onTitleClick: Function
  };
};
var SubMenu = defineComponent({
  name: "ASubMenu",
  inheritAttrs: false,
  props: subMenuProps(),
  slots: ["icon", "title", "expandIcon"],
  setup: function setup44(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs, emit = _ref.emit;
    var _a, _b;
    useProvideFirstLevel(false);
    var isMeasure = useMeasure();
    var instance = getCurrentInstance();
    var vnodeKey = _typeof$1(instance.vnode.key) === "symbol" ? String(instance.vnode.key) : instance.vnode.key;
    devWarning(_typeof$1(instance.vnode.key) !== "symbol", "SubMenu", 'SubMenu `:key="'.concat(String(vnodeKey), '"` not support Symbol type'));
    var key2 = isValid$1(vnodeKey) ? vnodeKey : "sub_menu_".concat(++indexGuid, "_$$_not_set_key");
    var eventKey = (_a = props2.eventKey) !== null && _a !== void 0 ? _a : isValid$1(vnodeKey) ? "sub_menu_".concat(++indexGuid, "_$$_").concat(vnodeKey) : key2;
    var _useInjectKeyPath = useInjectKeyPath(), parentEventKeys = _useInjectKeyPath.parentEventKeys, parentInfo = _useInjectKeyPath.parentInfo, parentKeys = _useInjectKeyPath.parentKeys;
    var keysPath = computed(function() {
      return [].concat(_toConsumableArray(parentKeys.value), [key2]);
    });
    var childrenEventKeys = ref([]);
    var menuInfo = {
      eventKey,
      key: key2,
      parentEventKeys,
      childrenEventKeys,
      parentKeys
    };
    (_b = parentInfo.childrenEventKeys) === null || _b === void 0 ? void 0 : _b.value.push(eventKey);
    onBeforeUnmount(function() {
      var _a2;
      if (parentInfo.childrenEventKeys) {
        parentInfo.childrenEventKeys.value = (_a2 = parentInfo.childrenEventKeys) === null || _a2 === void 0 ? void 0 : _a2.value.filter(function(k2) {
          return k2 != eventKey;
        });
      }
    });
    useProvideKeyPath$1(eventKey, key2, menuInfo);
    var _useInjectMenu = useInjectMenu(), prefixCls = _useInjectMenu.prefixCls, activeKeys = _useInjectMenu.activeKeys, contextDisabled = _useInjectMenu.disabled, changeActiveKeys = _useInjectMenu.changeActiveKeys, mode2 = _useInjectMenu.mode, inlineCollapsed = _useInjectMenu.inlineCollapsed, antdMenuTheme = _useInjectMenu.antdMenuTheme, openKeys = _useInjectMenu.openKeys, overflowDisabled = _useInjectMenu.overflowDisabled, onOpenChange = _useInjectMenu.onOpenChange, registerMenuInfo = _useInjectMenu.registerMenuInfo, unRegisterMenuInfo = _useInjectMenu.unRegisterMenuInfo, selectedSubMenuKeys = _useInjectMenu.selectedSubMenuKeys, menuExpandIcon = _useInjectMenu.expandIcon;
    var hasKey = vnodeKey !== void 0 && vnodeKey !== null;
    var forceRender = !isMeasure && (useInjectForceRender() || !hasKey);
    useProvideForceRender(forceRender);
    if (isMeasure && hasKey || !isMeasure && !hasKey || forceRender) {
      registerMenuInfo(eventKey, menuInfo);
      onBeforeUnmount(function() {
        unRegisterMenuInfo(eventKey);
      });
    }
    var subMenuPrefixCls = computed(function() {
      return "".concat(prefixCls.value, "-submenu");
    });
    var mergedDisabled = computed(function() {
      return contextDisabled.value || props2.disabled;
    });
    var elementRef = ref();
    var popupRef = ref();
    var originOpen = computed(function() {
      return openKeys.value.includes(key2);
    });
    var open2 = computed(function() {
      return !overflowDisabled.value && originOpen.value;
    });
    var childrenSelected = computed(function() {
      return selectedSubMenuKeys.value.includes(key2);
    });
    var isActive = ref(false);
    watch(activeKeys, function() {
      isActive.value = !!activeKeys.value.find(function(val) {
        return val === key2;
      });
    }, {
      immediate: true
    });
    var onInternalTitleClick = function onInternalTitleClick2(e2) {
      if (mergedDisabled.value) {
        return;
      }
      emit("titleClick", e2, key2);
      if (mode2.value === "inline") {
        onOpenChange(key2, !originOpen.value);
      }
    };
    var onMouseEnter = function onMouseEnter2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys(keysPath.value);
        emit("mouseenter", event);
      }
    };
    var onMouseLeave = function onMouseLeave2(event) {
      if (!mergedDisabled.value) {
        changeActiveKeys([]);
        emit("mouseleave", event);
      }
    };
    var directionStyle = useDirectionStyle(computed(function() {
      return keysPath.value.length;
    }));
    var onPopupVisibleChange = function onPopupVisibleChange2(newVisible) {
      if (mode2.value !== "inline") {
        onOpenChange(key2, newVisible);
      }
    };
    var onInternalFocus = function onInternalFocus2() {
      changeActiveKeys(keysPath.value);
    };
    var popupId = eventKey && "".concat(eventKey, "-popup");
    var popupClassName = computed(function() {
      return classNames(prefixCls.value, "".concat(prefixCls.value, "-").concat(antdMenuTheme.value), props2.popupClassName);
    });
    var renderTitle = function renderTitle2(title, icon) {
      if (!icon) {
        return inlineCollapsed.value && !parentKeys.value.length && title && typeof title === "string" ? createVNode("div", {
          "class": "".concat(prefixCls.value, "-inline-collapsed-noicon")
        }, [title.charAt(0)]) : createVNode("span", {
          "class": "".concat(prefixCls.value, "-title-content")
        }, [title]);
      }
      var titleIsSpan = isValidElement(title) && title.type === "span";
      return createVNode(Fragment, null, [cloneElement(icon, {
        class: "".concat(prefixCls.value, "-item-icon")
      }, false), titleIsSpan ? title : createVNode("span", {
        "class": "".concat(prefixCls.value, "-title-content")
      }, [title])]);
    };
    var triggerModeRef = computed(function() {
      return mode2.value !== "inline" && keysPath.value.length > 1 ? "vertical" : mode2.value;
    });
    var renderMode = computed(function() {
      return mode2.value === "horizontal" ? "vertical" : mode2.value;
    });
    var subMenuTriggerModeRef = computed(function() {
      return triggerModeRef.value === "horizontal" ? "vertical" : triggerModeRef.value;
    });
    var baseTitleNode = function baseTitleNode2() {
      var subMenuPrefixClsValue = subMenuPrefixCls.value;
      var icon = getPropsSlot(slots, props2, "icon");
      var expandIcon = props2.expandIcon || slots.expandIcon || menuExpandIcon.value;
      var title = renderTitle(getPropsSlot(slots, props2, "title"), icon);
      return createVNode("div", {
        "style": directionStyle.value,
        "class": "".concat(subMenuPrefixClsValue, "-title"),
        "tabindex": mergedDisabled.value ? null : -1,
        "ref": elementRef,
        "title": typeof title === "string" ? title : null,
        "data-menu-id": key2,
        "aria-expanded": open2.value,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled.value,
        "onClick": onInternalTitleClick,
        "onFocus": onInternalFocus
      }, [title, mode2.value !== "horizontal" && expandIcon ? expandIcon(_extends(_extends({}, props2), {
        isOpen: open2.value
      })) : createVNode("i", {
        "class": "".concat(subMenuPrefixClsValue, "-arrow")
      }, null)]);
    };
    return function() {
      var _classNames;
      var _a2;
      if (isMeasure) {
        if (!hasKey) {
          return null;
        }
        return (_a2 = slots.default) === null || _a2 === void 0 ? void 0 : _a2.call(slots);
      }
      var subMenuPrefixClsValue = subMenuPrefixCls.value;
      var titleNode = function titleNode2() {
        return null;
      };
      if (!overflowDisabled.value && mode2.value !== "inline") {
        titleNode = function titleNode2() {
          return createVNode(PopupTrigger, {
            "mode": triggerModeRef.value,
            "prefixCls": subMenuPrefixClsValue,
            "visible": !props2.internalPopupClose && open2.value,
            "popupClassName": popupClassName.value,
            "popupOffset": props2.popupOffset,
            "disabled": mergedDisabled.value,
            "onVisibleChange": onPopupVisibleChange
          }, {
            default: function _default3() {
              return [baseTitleNode()];
            },
            popup: function popup() {
              return createVNode(MenuContextProvider, {
                "mode": subMenuTriggerModeRef.value,
                "isRootMenu": false
              }, {
                default: function _default3() {
                  return [createVNode(SubMenuList, {
                    "id": popupId,
                    "ref": popupRef
                  }, {
                    default: slots.default
                  })];
                }
              });
            }
          });
        };
      } else {
        titleNode = function titleNode2() {
          return createVNode(PopupTrigger, null, {
            default: baseTitleNode
          });
        };
      }
      return createVNode(MenuContextProvider, {
        "mode": renderMode.value
      }, {
        default: function _default3() {
          return [createVNode(Overflow$1.Item, _objectSpread2$1(_objectSpread2$1({
            "component": "li"
          }, attrs), {}, {
            "role": "none",
            "class": classNames(subMenuPrefixClsValue, "".concat(subMenuPrefixClsValue, "-").concat(mode2.value), attrs.class, (_classNames = {}, _defineProperty$m(_classNames, "".concat(subMenuPrefixClsValue, "-open"), open2.value), _defineProperty$m(_classNames, "".concat(subMenuPrefixClsValue, "-active"), isActive.value), _defineProperty$m(_classNames, "".concat(subMenuPrefixClsValue, "-selected"), childrenSelected.value), _defineProperty$m(_classNames, "".concat(subMenuPrefixClsValue, "-disabled"), mergedDisabled.value), _classNames)),
            "onMouseenter": onMouseEnter,
            "onMouseleave": onMouseLeave,
            "data-submenu-id": key2
          }), {
            default: function _default4() {
              return createVNode(Fragment, null, [titleNode(), !overflowDisabled.value && createVNode(InlineSubMenuList, {
                "id": popupId,
                "open": open2.value,
                "keyPath": keysPath.value
              }, {
                default: slots.default
              })]);
            }
          })];
        }
      });
    };
  }
});
function hasClass(node, className) {
  if (node.classList) {
    return node.classList.contains(className);
  }
  var originClass = node.className;
  return " ".concat(originClass, " ").indexOf(" ".concat(className, " ")) > -1;
}
function addClass(node, className) {
  if (node.classList) {
    node.classList.add(className);
  } else {
    if (!hasClass(node, className)) {
      node.className = "".concat(node.className, " ").concat(className);
    }
  }
}
function removeClass(node, className) {
  if (node.classList) {
    node.classList.remove(className);
  } else {
    if (hasClass(node, className)) {
      var originClass = node.className;
      node.className = " ".concat(originClass, " ").replace(" ".concat(className, " "), " ");
    }
  }
}
var collapseMotion = function collapseMotion2() {
  var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ant-motion-collapse";
  var appear = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  return {
    name,
    appear,
    css: true,
    onBeforeEnter: function onBeforeEnter(node) {
      node.style.height = "0px";
      node.style.opacity = "0";
      addClass(node, name);
    },
    onEnter: function onEnter(node) {
      nextTick(function() {
        node.style.height = "".concat(node.scrollHeight, "px");
        node.style.opacity = "1";
      });
    },
    onAfterEnter: function onAfterEnter(node) {
      if (node) {
        removeClass(node, name);
        node.style.height = null;
        node.style.opacity = null;
      }
    },
    onBeforeLeave: function onBeforeLeave(node) {
      addClass(node, name);
      node.style.height = "".concat(node.offsetHeight, "px");
      node.style.opacity = null;
    },
    onLeave: function onLeave(node) {
      setTimeout(function() {
        node.style.height = "0px";
        node.style.opacity = "0";
      });
    },
    onAfterLeave: function onAfterLeave(node) {
      if (node) {
        removeClass(node, name);
        if (node.style) {
          node.style.height = null;
          node.style.opacity = null;
        }
      }
    }
  };
};
var collapseMotion$1 = collapseMotion;
var menuProps = function menuProps2() {
  return {
    id: String,
    prefixCls: String,
    disabled: Boolean,
    inlineCollapsed: Boolean,
    disabledOverflow: Boolean,
    forceSubMenuRender: Boolean,
    openKeys: Array,
    selectedKeys: Array,
    activeKey: String,
    selectable: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    motion: Object,
    theme: {
      type: String,
      default: "light"
    },
    mode: {
      type: String,
      default: "vertical"
    },
    inlineIndent: {
      type: Number,
      default: 24
    },
    subMenuOpenDelay: {
      type: Number,
      default: 0.1
    },
    subMenuCloseDelay: {
      type: Number,
      default: 0.1
    },
    builtinPlacements: {
      type: Object
    },
    triggerSubMenuAction: {
      type: String,
      default: "hover"
    },
    getPopupContainer: Function,
    expandIcon: Function,
    onOpenChange: Function,
    onSelect: Function,
    onDeselect: Function,
    onClick: [Function, Array],
    onFocus: Function,
    onBlur: Function,
    onMousedown: Function,
    "onUpdate:openKeys": Function,
    "onUpdate:selectedKeys": Function,
    "onUpdate:activeKey": Function
  };
};
var EMPTY_LIST = [];
var Menu = defineComponent({
  name: "AMenu",
  inheritAttrs: false,
  props: menuProps(),
  slots: ["expandIcon", "overflowedIndicator"],
  setup: function setup45(props2, _ref) {
    var slots = _ref.slots, emit = _ref.emit, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("menu", props2), prefixCls = _useConfigInject.prefixCls, direction = _useConfigInject.direction, getPrefixCls2 = _useConfigInject.getPrefixCls;
    var store = ref({});
    var siderCollapsed = inject(SiderCollapsedKey, ref(void 0));
    var inlineCollapsed = computed(function() {
      if (siderCollapsed.value !== void 0) {
        return siderCollapsed.value;
      }
      return props2.inlineCollapsed;
    });
    var isMounted = ref(false);
    onMounted(function() {
      isMounted.value = true;
    });
    watchEffect(function() {
      devWarning(!(props2.inlineCollapsed === true && props2.mode !== "inline"), "Menu", "`inlineCollapsed` should only be used when `mode` is inline.");
      devWarning(!(siderCollapsed.value !== void 0 && props2.inlineCollapsed === true), "Menu", "`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.");
    });
    var activeKeys = ref([]);
    var mergedSelectedKeys = ref([]);
    var keyMapStore = ref({});
    watch(store, function() {
      var newKeyMapStore = {};
      for (var _i = 0, _Object$values = Object.values(store.value); _i < _Object$values.length; _i++) {
        var menuInfo = _Object$values[_i];
        newKeyMapStore[menuInfo.key] = menuInfo;
      }
      keyMapStore.value = newKeyMapStore;
    }, {
      flush: "post"
    });
    watchEffect(function() {
      if (props2.activeKey !== void 0) {
        var keys2 = [];
        var menuInfo = props2.activeKey ? keyMapStore.value[props2.activeKey] : void 0;
        if (menuInfo && props2.activeKey !== void 0) {
          keys2 = uniq([].concat(unref(menuInfo.parentKeys), props2.activeKey));
        } else {
          keys2 = [];
        }
        if (!shallowequal(activeKeys.value, keys2)) {
          activeKeys.value = keys2;
        }
      }
    });
    watch(function() {
      return props2.selectedKeys;
    }, function(selectedKeys) {
      if (selectedKeys) {
        mergedSelectedKeys.value = selectedKeys.slice();
      }
    }, {
      immediate: true,
      deep: true
    });
    var selectedSubMenuKeys = ref([]);
    watch([keyMapStore, mergedSelectedKeys], function() {
      var subMenuParentKeys = [];
      mergedSelectedKeys.value.forEach(function(key2) {
        var menuInfo = keyMapStore.value[key2];
        if (menuInfo) {
          subMenuParentKeys = subMenuParentKeys.concat(unref(menuInfo.parentKeys));
        }
      });
      subMenuParentKeys = uniq(subMenuParentKeys);
      if (!shallowequal(selectedSubMenuKeys.value, subMenuParentKeys)) {
        selectedSubMenuKeys.value = subMenuParentKeys;
      }
    }, {
      immediate: true
    });
    var triggerSelection = function triggerSelection2(info) {
      if (!props2.selectable) {
        return;
      }
      var targetKey = info.key;
      var exist = mergedSelectedKeys.value.includes(targetKey);
      var newSelectedKeys;
      if (props2.multiple) {
        if (exist) {
          newSelectedKeys = mergedSelectedKeys.value.filter(function(key2) {
            return key2 !== targetKey;
          });
        } else {
          newSelectedKeys = [].concat(_toConsumableArray(mergedSelectedKeys.value), [targetKey]);
        }
      } else {
        newSelectedKeys = [targetKey];
      }
      var selectInfo = _extends(_extends({}, info), {
        selectedKeys: newSelectedKeys
      });
      if (!shallowequal(newSelectedKeys, mergedSelectedKeys.value)) {
        if (props2.selectedKeys === void 0) {
          mergedSelectedKeys.value = newSelectedKeys;
        }
        emit("update:selectedKeys", newSelectedKeys);
        if (exist && props2.multiple) {
          emit("deselect", selectInfo);
        } else {
          emit("select", selectInfo);
        }
      }
      if (mergedMode.value !== "inline" && !props2.multiple && mergedOpenKeys.value.length) {
        triggerOpenKeys(EMPTY_LIST);
      }
    };
    var mergedOpenKeys = ref([]);
    watch(function() {
      return props2.openKeys;
    }, function() {
      var openKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : mergedOpenKeys.value;
      if (!shallowequal(mergedOpenKeys.value, openKeys)) {
        mergedOpenKeys.value = openKeys.slice();
      }
    }, {
      immediate: true,
      deep: true
    });
    var timeout;
    var changeActiveKeys = function changeActiveKeys2(keys2) {
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        if (props2.activeKey === void 0) {
          activeKeys.value = keys2;
        }
        emit("update:activeKey", keys2[keys2.length - 1]);
      });
    };
    var disabled = computed(function() {
      return !!props2.disabled;
    });
    var isRtl = computed(function() {
      return direction.value === "rtl";
    });
    var mergedMode = ref("vertical");
    var mergedInlineCollapsed = ref(false);
    watchEffect(function() {
      if ((props2.mode === "inline" || props2.mode === "vertical") && inlineCollapsed.value) {
        mergedMode.value = "vertical";
        mergedInlineCollapsed.value = inlineCollapsed.value;
      } else {
        mergedMode.value = props2.mode;
        mergedInlineCollapsed.value = false;
      }
    });
    var isInlineMode = computed(function() {
      return mergedMode.value === "inline";
    });
    var triggerOpenKeys = function triggerOpenKeys2(keys2) {
      mergedOpenKeys.value = keys2;
      emit("update:openKeys", keys2);
      emit("openChange", keys2);
    };
    var inlineCacheOpenKeys = ref(mergedOpenKeys.value);
    var mountRef = ref(false);
    watch(mergedOpenKeys, function() {
      if (isInlineMode.value) {
        inlineCacheOpenKeys.value = mergedOpenKeys.value;
      }
    }, {
      immediate: true
    });
    watch(isInlineMode, function() {
      if (!mountRef.value) {
        mountRef.value = true;
        return;
      }
      if (isInlineMode.value) {
        mergedOpenKeys.value = inlineCacheOpenKeys.value;
      } else {
        triggerOpenKeys(EMPTY_LIST);
      }
    }, {
      immediate: true
    });
    var className = computed(function() {
      var _ref2;
      return _ref2 = {}, _defineProperty$m(_ref2, "".concat(prefixCls.value), true), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-root"), true), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-").concat(mergedMode.value), true), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-inline-collapsed"), mergedInlineCollapsed.value), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-rtl"), isRtl.value), _defineProperty$m(_ref2, "".concat(prefixCls.value, "-").concat(props2.theme), true), _ref2;
    });
    var rootPrefixCls = computed(function() {
      return getPrefixCls2();
    });
    var defaultMotions = computed(function() {
      return {
        horizontal: {
          name: "".concat(rootPrefixCls.value, "-slide-up")
        },
        inline: collapseMotion$1,
        other: {
          name: "".concat(rootPrefixCls.value, "-zoom-big")
        }
      };
    });
    useProvideFirstLevel(true);
    var getChildrenKeys = function getChildrenKeys2() {
      var eventKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var keys2 = [];
      var storeValue = store.value;
      eventKeys.forEach(function(eventKey) {
        var _storeValue$eventKey = storeValue[eventKey], key2 = _storeValue$eventKey.key, childrenEventKeys = _storeValue$eventKey.childrenEventKeys;
        keys2.push.apply(keys2, [key2].concat(_toConsumableArray(getChildrenKeys2(unref(childrenEventKeys)))));
      });
      return keys2;
    };
    var onInternalClick = function onInternalClick2(info) {
      emit("click", info);
      triggerSelection(info);
    };
    var onInternalOpenChange = function onInternalOpenChange2(key2, open2) {
      var childrenEventKeys = keyMapStore.value[key2].childrenEventKeys;
      var newOpenKeys = mergedOpenKeys.value.filter(function(k2) {
        return k2 !== key2;
      });
      if (open2) {
        newOpenKeys.push(key2);
      } else if (mergedMode.value !== "inline") {
        var subPathKeys = getChildrenKeys(unref(childrenEventKeys));
        newOpenKeys = uniq(newOpenKeys.filter(function(k2) {
          return !subPathKeys.includes(k2);
        }));
      }
      if (!shallowequal(mergedOpenKeys, newOpenKeys)) {
        triggerOpenKeys(newOpenKeys);
      }
    };
    var registerMenuInfo = function registerMenuInfo2(key2, info) {
      store.value = _extends(_extends({}, store.value), _defineProperty$m({}, key2, info));
    };
    var unRegisterMenuInfo = function unRegisterMenuInfo2(key2) {
      delete store.value[key2];
      store.value = _extends({}, store.value);
    };
    var lastVisibleIndex = ref(0);
    var expandIcon = computed(function() {
      return props2.expandIcon || slots.expandIcon ? function(opt) {
        var icon = props2.expandIcon || slots.expandIcon;
        icon = typeof icon === "function" ? icon(opt) : icon;
        return cloneElement(icon, {
          class: "".concat(prefixCls.value, "-submenu-expand-icon")
        }, false);
      } : null;
    });
    useProvideMenu$1({
      store,
      prefixCls,
      activeKeys,
      openKeys: mergedOpenKeys,
      selectedKeys: mergedSelectedKeys,
      changeActiveKeys,
      disabled,
      rtl: isRtl,
      mode: mergedMode,
      inlineIndent: computed(function() {
        return props2.inlineIndent;
      }),
      subMenuCloseDelay: computed(function() {
        return props2.subMenuCloseDelay;
      }),
      subMenuOpenDelay: computed(function() {
        return props2.subMenuOpenDelay;
      }),
      builtinPlacements: computed(function() {
        return props2.builtinPlacements;
      }),
      triggerSubMenuAction: computed(function() {
        return props2.triggerSubMenuAction;
      }),
      getPopupContainer: computed(function() {
        return props2.getPopupContainer;
      }),
      inlineCollapsed: mergedInlineCollapsed,
      antdMenuTheme: computed(function() {
        return props2.theme;
      }),
      siderCollapsed,
      defaultMotions: computed(function() {
        return isMounted.value ? defaultMotions.value : null;
      }),
      motion: computed(function() {
        return isMounted.value ? props2.motion : null;
      }),
      overflowDisabled: ref(void 0),
      onOpenChange: onInternalOpenChange,
      onItemClick: onInternalClick,
      registerMenuInfo,
      unRegisterMenuInfo,
      selectedSubMenuKeys,
      isRootMenu: ref(true),
      expandIcon,
      forceSubMenuRender: computed(function() {
        return props2.forceSubMenuRender;
      })
    });
    return function() {
      var _a, _b;
      var childList = flattenChildren((_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots));
      var allVisible = lastVisibleIndex.value >= childList.length - 1 || mergedMode.value !== "horizontal" || props2.disabledOverflow;
      var wrappedChildList = mergedMode.value !== "horizontal" || props2.disabledOverflow ? childList : childList.map(function(child, index2) {
        return createVNode(MenuContextProvider, {
          "key": child.key,
          "overflowDisabled": index2 > lastVisibleIndex.value
        }, {
          default: function _default3() {
            return child;
          }
        });
      });
      var overflowedIndicator = ((_b = slots.overflowedIndicator) === null || _b === void 0 ? void 0 : _b.call(slots)) || createVNode(EllipsisOutlined$1, null, null);
      return createVNode(Overflow$1, _objectSpread2$1(_objectSpread2$1({}, attrs), {}, {
        "onMousedown": props2.onMousedown,
        "prefixCls": "".concat(prefixCls.value, "-overflow"),
        "component": "ul",
        "itemComponent": MenuItem,
        "class": [className.value, attrs.class],
        "role": "menu",
        "id": props2.id,
        "data": wrappedChildList,
        "renderRawItem": function renderRawItem(node) {
          return node;
        },
        "renderRawRest": function renderRawRest(omitItems) {
          var len = omitItems.length;
          var originOmitItems = len ? childList.slice(-len) : null;
          return createVNode(Fragment, null, [createVNode(SubMenu, {
            "eventKey": OVERFLOW_KEY,
            "key": OVERFLOW_KEY,
            "title": overflowedIndicator,
            "disabled": allVisible,
            "internalPopupClose": len === 0
          }, {
            default: function _default3() {
              return originOmitItems;
            }
          }), createVNode(PathContext, null, {
            default: function _default3() {
              return [createVNode(SubMenu, {
                "eventKey": OVERFLOW_KEY,
                "key": OVERFLOW_KEY,
                "title": overflowedIndicator,
                "disabled": allVisible,
                "internalPopupClose": len === 0
              }, {
                default: function _default4() {
                  return originOmitItems;
                }
              })];
            }
          })]);
        },
        "maxCount": mergedMode.value !== "horizontal" || props2.disabledOverflow ? Overflow$1.INVALIDATE : Overflow$1.RESPONSIVE,
        "ssr": "full",
        "data-menu-list": true,
        "onVisibleChange": function onVisibleChange(newLastIndex) {
          lastVisibleIndex.value = newLastIndex;
        }
      }), {
        default: function _default3() {
          return [createVNode(Teleport, {
            "to": "body"
          }, {
            default: function _default4() {
              return [createVNode("div", {
                "style": {
                  display: "none"
                },
                "aria-hidden": true
              }, [createVNode(PathContext, null, {
                default: function _default5() {
                  return [wrappedChildList];
                }
              })])];
            }
          })];
        }
      });
    };
  }
});
var menuItemGroupProps = function menuItemGroupProps2() {
  return {
    title: PropTypes$1.any
  };
};
var ItemGroup = defineComponent({
  name: "AMenuItemGroup",
  inheritAttrs: false,
  props: menuItemGroupProps(),
  slots: ["title"],
  setup: function setup46(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var _useInjectMenu = useInjectMenu(), prefixCls = _useInjectMenu.prefixCls;
    var groupPrefixCls = computed(function() {
      return "".concat(prefixCls.value, "-item-group");
    });
    var isMeasure = useMeasure();
    return function() {
      var _a, _b;
      if (isMeasure)
        return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
      return createVNode("li", _objectSpread2$1(_objectSpread2$1({}, attrs), {}, {
        "onClick": function onClick2(e2) {
          return e2.stopPropagation();
        },
        "class": groupPrefixCls.value
      }), [createVNode("div", {
        "title": typeof props2.title === "string" ? props2.title : void 0,
        "class": "".concat(groupPrefixCls.value, "-title")
      }, [getPropsSlot(slots, props2, "title")]), createVNode("ul", {
        "class": "".concat(groupPrefixCls.value, "-list")
      }, [(_b = slots.default) === null || _b === void 0 ? void 0 : _b.call(slots)])]);
    };
  }
});
var menuDividerProps = function menuDividerProps2() {
  return {
    prefixCls: String,
    dashed: Boolean
  };
};
var Divider = defineComponent({
  name: "AMenuDivider",
  props: menuDividerProps(),
  setup: function setup47(props2) {
    var _useConfigInject = useConfigInject("menu", props2), prefixCls = _useConfigInject.prefixCls;
    var cls = computed(function() {
      var _ref;
      return _ref = {}, _defineProperty$m(_ref, "".concat(prefixCls.value, "-item-divider"), true), _defineProperty$m(_ref, "".concat(prefixCls.value, "-item-divider-dashed"), !!props2.dashed), _ref;
    });
    return function() {
      return createVNode("li", {
        "class": cls.value
      }, null);
    };
  }
});
Menu.install = function(app) {
  app.component(Menu.name, Menu);
  app.component(MenuItem.name, MenuItem);
  app.component(SubMenu.name, SubMenu);
  app.component(Divider.name, Divider);
  app.component(ItemGroup.name, ItemGroup);
  return app;
};
Menu.Item = MenuItem;
Menu.Divider = Divider;
Menu.SubMenu = SubMenu;
Menu.ItemGroup = ItemGroup;
var symbolTag = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
var reWhitespace = /\s/;
function trimmedEndIndex(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var reTrimStart = /^\s+/;
function baseTrim(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var canUseDocElement = function canUseDocElement2() {
  return canUseDom() && window.document.documentElement;
};
var now = function() {
  return root$1.Date.now();
};
var now$1 = now;
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject2(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now$1());
  }
  function debounced() {
    var time = now$1(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var VALUE_SPLIT = "__RC_CASCADER_SPLIT__";
var SHOW_PARENT = "SHOW_PARENT";
var SHOW_CHILD = "SHOW_CHILD";
function toPathKey(value) {
  return value.join(VALUE_SPLIT);
}
function toPathKeys(value) {
  return value.map(toPathKey);
}
function toPathValueStr(pathKey) {
  return pathKey.split(VALUE_SPLIT);
}
function fillFieldNames$1(fieldNames) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, children = _ref.children;
  var val = value || "value";
  return {
    label: label || "label",
    value: val,
    key: val,
    children: children || "children"
  };
}
function isLeaf(option, fieldNames) {
  var _a, _b;
  return (_a = option.isLeaf) !== null && _a !== void 0 ? _a : !((_b = option[fieldNames.children]) === null || _b === void 0 ? void 0 : _b.length);
}
function scrollIntoParentView(element) {
  var parent = element.parentElement;
  if (!parent) {
    return;
  }
  var elementToParent = element.offsetTop - parent.offsetTop;
  if (elementToParent - parent.scrollTop < 0) {
    parent.scrollTo({
      top: elementToParent
    });
  } else if (elementToParent + element.offsetHeight - parent.scrollTop > parent.offsetHeight) {
    parent.scrollTo({
      top: elementToParent + element.offsetHeight - parent.offsetHeight
    });
  }
}
globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function getPosition(level, index2) {
  return "".concat(level, "-").concat(index2);
}
globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function getKey(key2, pos) {
  if (key2 !== null && key2 !== void 0) {
    return key2;
  }
  return pos;
}
function fillFieldNames(fieldNames) {
  var _ref = fieldNames || {}, title = _ref.title, _title = _ref._title, key2 = _ref.key, children = _ref.children;
  var mergedTitle = title || "title";
  return {
    title: mergedTitle,
    _title: _title || [mergedTitle],
    key: key2 || "key",
    children: children || "children"
  };
}
function traverseDataNodes(dataNodes, callback, config) {
  var mergedConfig = {};
  if (_typeof$1(config) === "object") {
    mergedConfig = config;
  } else {
    mergedConfig = {
      externalGetKey: config
    };
  }
  mergedConfig = mergedConfig || {};
  var _mergedConfig = mergedConfig, childrenPropName = _mergedConfig.childrenPropName, externalGetKey = _mergedConfig.externalGetKey, fieldNames = _mergedConfig.fieldNames;
  var _fillFieldNames2 = fillFieldNames(fieldNames), fieldKey = _fillFieldNames2.key, fieldChildren = _fillFieldNames2.children;
  var mergeChildrenPropName = childrenPropName || fieldChildren;
  var syntheticGetKey;
  if (externalGetKey) {
    if (typeof externalGetKey === "string") {
      syntheticGetKey = function syntheticGetKey2(node) {
        return node[externalGetKey];
      };
    } else if (typeof externalGetKey === "function") {
      syntheticGetKey = function syntheticGetKey2(node) {
        return externalGetKey(node);
      };
    }
  } else {
    syntheticGetKey = function syntheticGetKey2(node, pos) {
      return getKey(node[fieldKey], pos);
    };
  }
  function processNode(node, index2, parent, pathNodes) {
    var children = node ? node[mergeChildrenPropName] : dataNodes;
    var pos = node ? getPosition(parent.pos, index2) : "0";
    var connectNodes = node ? [].concat(_toConsumableArray(pathNodes), [node]) : [];
    if (node) {
      var key2 = syntheticGetKey(node, pos);
      var data4 = {
        node,
        index: index2,
        pos,
        key: key2,
        parentPos: parent.node ? parent.pos : null,
        level: parent.level + 1,
        nodes: connectNodes
      };
      callback(data4);
    }
    if (children) {
      children.forEach(function(subNode, subIndex) {
        processNode(subNode, subIndex, {
          node,
          pos,
          level: parent ? parent.level + 1 : -1
        }, connectNodes);
      });
    }
  }
  processNode(null);
}
function convertDataToEntities(dataNodes) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, initWrapper = _ref2.initWrapper, processEntity = _ref2.processEntity, onProcessFinished = _ref2.onProcessFinished, externalGetKey = _ref2.externalGetKey, childrenPropName = _ref2.childrenPropName, fieldNames = _ref2.fieldNames;
  var legacyExternalGetKey = arguments.length > 2 ? arguments[2] : void 0;
  var mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
  var posEntities = {};
  var keyEntities = {};
  var wrapper = {
    posEntities,
    keyEntities
  };
  if (initWrapper) {
    wrapper = initWrapper(wrapper) || wrapper;
  }
  traverseDataNodes(dataNodes, function(item) {
    var node = item.node, index2 = item.index, pos = item.pos, key2 = item.key, parentPos = item.parentPos, level = item.level, nodes = item.nodes;
    var entity = {
      node,
      nodes,
      index: index2,
      key: key2,
      pos,
      level
    };
    var mergedKey = getKey(key2, pos);
    posEntities[pos] = entity;
    keyEntities[mergedKey] = entity;
    entity.parent = posEntities[parentPos];
    if (entity.parent) {
      entity.parent.children = entity.parent.children || [];
      entity.parent.children.push(entity);
    }
    if (processEntity) {
      processEntity(entity, wrapper);
    }
  }, {
    externalGetKey: mergedExternalGetKey,
    childrenPropName,
    fieldNames
  });
  if (onProcessFinished) {
    onProcessFinished(wrapper);
  }
  return wrapper;
}
var useEntities = function(options, fieldNames) {
  var entities = computed(function() {
    return convertDataToEntities(options.value, {
      fieldNames: fieldNames.value,
      initWrapper: function initWrapper(wrapper) {
        return _extends(_extends({}, wrapper), {
          pathKeyEntities: {}
        });
      },
      processEntity: function processEntity(entity, wrapper) {
        var pathKey = entity.nodes.map(function(node) {
          return node[fieldNames.value.value];
        }).join(VALUE_SPLIT);
        wrapper.pathKeyEntities[pathKey] = entity;
        entity.key = pathKey;
      }
    }).pathKeyEntities;
  });
  return entities;
};
function useSearchConfig(showSearch) {
  var mergedShowSearch = ref(false);
  var mergedSearchConfig = ref({});
  watchEffect(function() {
    if (!showSearch.value) {
      mergedShowSearch.value = false;
      mergedSearchConfig.value = {};
      return;
    }
    var searchConfig = {
      matchInputWidth: true,
      limit: 50
    };
    if (showSearch.value && _typeof$1(showSearch.value) === "object") {
      searchConfig = _extends(_extends({}, searchConfig), showSearch.value);
    }
    if (searchConfig.limit <= 0) {
      delete searchConfig.limit;
    }
    mergedShowSearch.value = true;
    mergedSearchConfig.value = searchConfig;
    return;
  });
  return {
    showSearch: mergedShowSearch,
    searchConfig: mergedSearchConfig
  };
}
var SEARCH_MARK = "__rc_cascader_search_mark__";
var defaultFilter = function defaultFilter2(search, options, _ref) {
  var label = _ref.label;
  return options.some(function(opt) {
    return String(opt[label]).toLowerCase().includes(search.toLowerCase());
  });
};
var defaultRender = function defaultRender2(_ref2) {
  var path = _ref2.path, fieldNames = _ref2.fieldNames;
  return path.map(function(opt) {
    return opt[fieldNames.label];
  }).join(" / ");
};
var useSearchOptions = function(search, options, fieldNames, prefixCls, config, changeOnSelect) {
  return computed(function() {
    var _config$value = config.value, _config$value$filter = _config$value.filter, filter = _config$value$filter === void 0 ? defaultFilter : _config$value$filter, _config$value$render = _config$value.render, render7 = _config$value$render === void 0 ? defaultRender : _config$value$render, _config$value$limit = _config$value.limit, limit = _config$value$limit === void 0 ? 50 : _config$value$limit, sort = _config$value.sort;
    var filteredOptions = [];
    if (!search.value) {
      return [];
    }
    function dig(list, pathOptions) {
      list.forEach(function(option) {
        if (!sort && limit > 0 && filteredOptions.length >= limit) {
          return;
        }
        var connectedPathOptions = [].concat(_toConsumableArray(pathOptions), [option]);
        var children = option[fieldNames.value.children];
        if (!children || children.length === 0 || changeOnSelect.value) {
          if (filter(search.value, connectedPathOptions, {
            label: fieldNames.value.label
          })) {
            var _extends2;
            filteredOptions.push(_extends(_extends({}, option), (_extends2 = {}, _defineProperty$m(_extends2, fieldNames.value.label, render7({
              inputValue: search.value,
              path: connectedPathOptions,
              prefixCls: prefixCls.value,
              fieldNames: fieldNames.value
            })), _defineProperty$m(_extends2, SEARCH_MARK, connectedPathOptions), _extends2)));
          }
        }
        if (children) {
          dig(option[fieldNames.value.children], connectedPathOptions);
        }
      });
    }
    dig(options.value, []);
    if (sort) {
      filteredOptions.sort(function(a2, b2) {
        return sort(a2[SEARCH_MARK], b2[SEARCH_MARK], search.value, fieldNames.value);
      });
    }
    return limit > 0 ? filteredOptions.slice(0, limit) : filteredOptions;
  });
};
function formatStrategyValues(pathKeys, keyPathEntities, showCheckedStrategy) {
  var valueSet = new Set(pathKeys);
  return pathKeys.filter(function(key2) {
    var entity = keyPathEntities[key2];
    var parent = entity ? entity.parent : null;
    var children = entity ? entity.children : null;
    return showCheckedStrategy === SHOW_CHILD ? !(children && children.some(function(child) {
      return child.key && valueSet.has(child.key);
    })) : !(parent && !parent.node.disabled && valueSet.has(parent.key));
  });
}
function toPathOptions(valueCells, options, fieldNames) {
  var stringMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var _a;
  var currentList = options;
  var valueOptions = [];
  var _loop = function _loop2(i2) {
    var valueCell = valueCells[i2];
    var foundIndex = currentList === null || currentList === void 0 ? void 0 : currentList.findIndex(function(option) {
      var val = option[fieldNames.value];
      return stringMode ? String(val) === String(valueCell) : val === valueCell;
    });
    var foundOption = foundIndex !== -1 ? currentList === null || currentList === void 0 ? void 0 : currentList[foundIndex] : null;
    valueOptions.push({
      value: (_a = foundOption === null || foundOption === void 0 ? void 0 : foundOption[fieldNames.value]) !== null && _a !== void 0 ? _a : valueCell,
      index: foundIndex,
      option: foundOption
    });
    currentList = foundOption === null || foundOption === void 0 ? void 0 : foundOption[fieldNames.children];
  };
  for (var i = 0; i < valueCells.length; i += 1) {
    _loop(i);
  }
  return valueOptions;
}
var useMissingValues = function(options, fieldNames, rawValues) {
  return computed(function() {
    var missingValues = [];
    var existsValues = [];
    rawValues.value.forEach(function(valueCell) {
      var pathOptions = toPathOptions(valueCell, options.value, fieldNames.value);
      if (pathOptions.every(function(opt) {
        return opt.option;
      })) {
        existsValues.push(valueCell);
      } else {
        missingValues.push(valueCell);
      }
    });
    return [existsValues, missingValues];
  });
};
function removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
  var filteredKeys = /* @__PURE__ */ new Set();
  halfCheckedKeys.forEach(function(key2) {
    if (!checkedKeys.has(key2)) {
      filteredKeys.add(key2);
    }
  });
  return filteredKeys;
}
function isCheckDisabled(node) {
  var _ref = node || {}, disabled = _ref.disabled, disableCheckbox = _ref.disableCheckbox, checkable = _ref.checkable;
  return !!(disabled || disableCheckbox) || checkable === false;
}
function fillConductCheck(keys2, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys2);
  var halfCheckedKeys = /* @__PURE__ */ new Set();
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || /* @__PURE__ */ new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node = entity.node, _entity$children = entity.children, children = _entity$children === void 0 ? [] : _entity$children;
      if (checkedKeys.has(key2) && !syntheticGetCheckDisabled(node)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.add(childEntity.key);
        });
      }
    });
  }
  var visitedKeys = /* @__PURE__ */ new Set();
  for (var _level = maxLevel; _level >= 0; _level -= 1) {
    var _entities = levelEntities.get(_level) || /* @__PURE__ */ new Set();
    _entities.forEach(function(entity) {
      var parent = entity.parent, node = entity.node;
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref2) {
        var key2 = _ref2.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (allChecked) {
        checkedKeys.add(parent.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }
      visitedKeys.add(parent.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function cleanConductCheck(keys2, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
  var checkedKeys = new Set(keys2);
  var halfCheckedKeys = new Set(halfKeys);
  for (var level = 0; level <= maxLevel; level += 1) {
    var entities = levelEntities.get(level) || /* @__PURE__ */ new Set();
    entities.forEach(function(entity) {
      var key2 = entity.key, node = entity.node, _entity$children2 = entity.children, children = _entity$children2 === void 0 ? [] : _entity$children2;
      if (!checkedKeys.has(key2) && !halfCheckedKeys.has(key2) && !syntheticGetCheckDisabled(node)) {
        children.filter(function(childEntity) {
          return !syntheticGetCheckDisabled(childEntity.node);
        }).forEach(function(childEntity) {
          checkedKeys.delete(childEntity.key);
        });
      }
    });
  }
  halfCheckedKeys = /* @__PURE__ */ new Set();
  var visitedKeys = /* @__PURE__ */ new Set();
  for (var _level2 = maxLevel; _level2 >= 0; _level2 -= 1) {
    var _entities2 = levelEntities.get(_level2) || /* @__PURE__ */ new Set();
    _entities2.forEach(function(entity) {
      var parent = entity.parent, node = entity.node;
      if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) {
        return;
      }
      if (syntheticGetCheckDisabled(entity.parent.node)) {
        visitedKeys.add(parent.key);
        return;
      }
      var allChecked = true;
      var partialChecked = false;
      (parent.children || []).filter(function(childEntity) {
        return !syntheticGetCheckDisabled(childEntity.node);
      }).forEach(function(_ref3) {
        var key2 = _ref3.key;
        var checked = checkedKeys.has(key2);
        if (allChecked && !checked) {
          allChecked = false;
        }
        if (!partialChecked && (checked || halfCheckedKeys.has(key2))) {
          partialChecked = true;
        }
      });
      if (!allChecked) {
        checkedKeys.delete(parent.key);
      }
      if (partialChecked) {
        halfCheckedKeys.add(parent.key);
      }
      visitedKeys.add(parent.key);
    });
  }
  return {
    checkedKeys: Array.from(checkedKeys),
    halfCheckedKeys: Array.from(removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
  };
}
function conductCheck(keyList, checked, keyEntities, maxLevel, levelEntities, getCheckDisabled) {
  var syntheticGetCheckDisabled;
  if (getCheckDisabled) {
    syntheticGetCheckDisabled = getCheckDisabled;
  } else {
    syntheticGetCheckDisabled = isCheckDisabled;
  }
  var keys2 = new Set(keyList.filter(function(key2) {
    var hasEntity = !!keyEntities[key2];
    return hasEntity;
  }));
  var result;
  if (checked === true) {
    result = fillConductCheck(keys2, levelEntities, maxLevel, syntheticGetCheckDisabled);
  } else {
    result = cleanConductCheck(keys2, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
  }
  return result;
}
var useDisplayValues = function(rawValues, options, fieldNames, multiple, displayRender) {
  return computed(function() {
    var mergedDisplayRender = displayRender.value || function(_ref) {
      var labels = _ref.labels;
      var mergedLabels = multiple.value ? labels.slice(-1) : labels;
      var SPLIT = " / ";
      if (mergedLabels.every(function(label) {
        return ["string", "number"].includes(_typeof$1(label));
      })) {
        return mergedLabels.join(SPLIT);
      }
      return mergedLabels.reduce(function(list, label, index2) {
        var keyedLabel = isValidElement(label) ? cloneElement(label, {
          key: index2
        }) : label;
        if (index2 === 0) {
          return [keyedLabel];
        }
        return [].concat(_toConsumableArray(list), [SPLIT, keyedLabel]);
      }, []);
    };
    return rawValues.value.map(function(valueCells) {
      var valueOptions = toPathOptions(valueCells, options.value, fieldNames.value);
      var label = mergedDisplayRender({
        labels: valueOptions.map(function(_ref2) {
          var option = _ref2.option, value2 = _ref2.value;
          var _a;
          return (_a = option === null || option === void 0 ? void 0 : option[fieldNames.value.label]) !== null && _a !== void 0 ? _a : value2;
        }),
        selectedOptions: valueOptions.map(function(_ref3) {
          var option = _ref3.option;
          return option;
        })
      });
      var value = toPathKey(valueCells);
      return {
        label,
        value,
        key: value,
        valueCells
      };
    });
  });
};
var CascaderContextKey = Symbol("CascaderContextKey");
var useProvideCascader = function useProvideCascader2(props2) {
  provide(CascaderContextKey, props2);
};
var useInjectCascader = function useInjectCascader2() {
  return inject(CascaderContextKey);
};
var useActive = function() {
  var baseProps = useBaseProps();
  var _useInjectCascader = useInjectCascader(), values = _useInjectCascader.values;
  var _useState = useState([]), _useState2 = _slicedToArray$2(_useState, 2), activeValueCells = _useState2[0], setActiveValueCells = _useState2[1];
  watch(function() {
    return baseProps.open;
  }, function() {
    if (baseProps.open && !baseProps.multiple) {
      var firstValueCells = values.value[0];
      setActiveValueCells(firstValueCells || []);
    }
  }, {
    immediate: true
  });
  return [activeValueCells, setActiveValueCells];
};
var useKeyboard = function(context, options, fieldNames, activeValueCells, setActiveValueCells, onKeyBoardSelect) {
  var baseProps = useBaseProps();
  var rtl2 = computed(function() {
    return baseProps.direction === "rtl";
  });
  var _ref = [ref([]), ref(), ref([])], validActiveValueCells = _ref[0], lastActiveIndex = _ref[1], lastActiveOptions = _ref[2];
  watchEffect(function() {
    var activeIndex = -1;
    var currentOptions = options.value;
    var mergedActiveIndexes = [];
    var mergedActiveValueCells = [];
    var len = activeValueCells.value.length;
    var _loop = function _loop2(i2) {
      var nextActiveIndex = currentOptions.findIndex(function(option) {
        return option[fieldNames.value.value] === activeValueCells.value[i2];
      });
      if (nextActiveIndex === -1) {
        return "break";
      }
      activeIndex = nextActiveIndex;
      mergedActiveIndexes.push(activeIndex);
      mergedActiveValueCells.push(activeValueCells.value[i2]);
      currentOptions = currentOptions[activeIndex][fieldNames.value.children];
    };
    for (var i = 0; i < len && currentOptions; i += 1) {
      var _ret = _loop(i);
      if (_ret === "break")
        break;
    }
    var activeOptions = options.value;
    for (var _i = 0; _i < mergedActiveIndexes.length - 1; _i += 1) {
      activeOptions = activeOptions[mergedActiveIndexes[_i]][fieldNames.value.children];
    }
    var _ref2 = [mergedActiveValueCells, activeIndex, activeOptions];
    validActiveValueCells.value = _ref2[0];
    lastActiveIndex.value = _ref2[1];
    lastActiveOptions.value = _ref2[2];
  });
  var internalSetActiveValueCells = function internalSetActiveValueCells2(next2) {
    setActiveValueCells(next2);
  };
  var offsetActiveOption = function offsetActiveOption2(offset3) {
    var len = lastActiveOptions.value.length;
    var currentIndex = lastActiveIndex.value;
    if (currentIndex === -1 && offset3 < 0) {
      currentIndex = len;
    }
    for (var i = 0; i < len; i += 1) {
      currentIndex = (currentIndex + offset3 + len) % len;
      var option = lastActiveOptions.value[currentIndex];
      if (option && !option.disabled) {
        var value = option[fieldNames.value.value];
        var nextActiveCells = validActiveValueCells.value.slice(0, -1).concat(value);
        internalSetActiveValueCells(nextActiveCells);
        return;
      }
    }
  };
  var prevColumn = function prevColumn2() {
    if (validActiveValueCells.value.length > 1) {
      var nextActiveCells = validActiveValueCells.value.slice(0, -1);
      internalSetActiveValueCells(nextActiveCells);
    } else {
      baseProps.toggleOpen(false);
    }
  };
  var nextColumn = function nextColumn2() {
    var _a;
    var nextOptions = ((_a = lastActiveOptions.value[lastActiveIndex.value]) === null || _a === void 0 ? void 0 : _a[fieldNames.value.children]) || [];
    var nextOption = nextOptions.find(function(option) {
      return !option.disabled;
    });
    if (nextOption) {
      var nextActiveCells = [].concat(_toConsumableArray(validActiveValueCells.value), [nextOption[fieldNames.value.value]]);
      internalSetActiveValueCells(nextActiveCells);
    }
  };
  context.expose({
    onKeydown: function onKeydown(event) {
      var which = event.which;
      switch (which) {
        case KeyCode$1.UP:
        case KeyCode$1.DOWN: {
          var offset3 = 0;
          if (which === KeyCode$1.UP) {
            offset3 = -1;
          } else if (which === KeyCode$1.DOWN) {
            offset3 = 1;
          }
          if (offset3 !== 0) {
            offsetActiveOption(offset3);
          }
          break;
        }
        case KeyCode$1.LEFT: {
          if (rtl2.value) {
            nextColumn();
          } else {
            prevColumn();
          }
          break;
        }
        case KeyCode$1.RIGHT: {
          if (rtl2.value) {
            prevColumn();
          } else {
            nextColumn();
          }
          break;
        }
        case KeyCode$1.BACKSPACE: {
          if (!baseProps.searchValue) {
            prevColumn();
          }
          break;
        }
        case KeyCode$1.ENTER: {
          if (validActiveValueCells.value.length) {
            var option = lastActiveOptions.value[lastActiveIndex.value];
            var originOptions = (option === null || option === void 0 ? void 0 : option[SEARCH_MARK]) || [];
            if (originOptions.length) {
              onKeyBoardSelect(originOptions.map(function(opt) {
                return opt[fieldNames.value.value];
              }), originOptions[originOptions.length - 1]);
            } else {
              onKeyBoardSelect(validActiveValueCells.value, option);
            }
          }
          break;
        }
        case KeyCode$1.ESC: {
          baseProps.toggleOpen(false);
          if (open) {
            event.stopPropagation();
          }
        }
      }
    },
    onKeyup: function onKeyup() {
    }
  });
};
function Checkbox(_ref) {
  var _ref2;
  var prefixCls = _ref.prefixCls, checked = _ref.checked, halfChecked = _ref.halfChecked, disabled = _ref.disabled, onClick2 = _ref.onClick;
  var _useInjectCascader = useInjectCascader(), customSlots = _useInjectCascader.customSlots, checkable = _useInjectCascader.checkable;
  var mergedCheckable = checkable.value !== false ? customSlots.value.checkable : checkable.value;
  var customCheckbox = typeof mergedCheckable === "function" ? mergedCheckable() : typeof mergedCheckable === "boolean" ? null : mergedCheckable;
  return createVNode("span", {
    "class": (_ref2 = {}, _defineProperty$m(_ref2, prefixCls, true), _defineProperty$m(_ref2, "".concat(prefixCls, "-checked"), checked), _defineProperty$m(_ref2, "".concat(prefixCls, "-indeterminate"), !checked && halfChecked), _defineProperty$m(_ref2, "".concat(prefixCls, "-disabled"), disabled), _ref2),
    "onClick": onClick2
  }, [customCheckbox]);
}
Checkbox.props = ["prefixCls", "checked", "halfChecked", "disabled", "onClick"];
Checkbox.displayName = "Checkbox";
Checkbox.inheritAttrs = false;
var FIX_LABEL = "__cascader_fix_label__";
function Column(_ref) {
  var prefixCls = _ref.prefixCls, multiple = _ref.multiple, options = _ref.options, activeValue = _ref.activeValue, prevValuePath = _ref.prevValuePath, onToggleOpen = _ref.onToggleOpen, onSelect = _ref.onSelect, onActive = _ref.onActive, checkedSet = _ref.checkedSet, halfCheckedSet = _ref.halfCheckedSet, loadingKeys = _ref.loadingKeys, isSelectable = _ref.isSelectable;
  var _a, _b, _c, _d, _e, _f;
  var menuPrefixCls = "".concat(prefixCls, "-menu");
  var menuItemPrefixCls = "".concat(prefixCls, "-menu-item");
  var _useInjectCascader = useInjectCascader(), fieldNames = _useInjectCascader.fieldNames, changeOnSelect = _useInjectCascader.changeOnSelect, expandTrigger = _useInjectCascader.expandTrigger, expandIconRef = _useInjectCascader.expandIcon, loadingIconRef = _useInjectCascader.loadingIcon, dropdownMenuColumnStyle = _useInjectCascader.dropdownMenuColumnStyle, customSlots = _useInjectCascader.customSlots;
  var expandIcon = (_a = expandIconRef.value) !== null && _a !== void 0 ? _a : (_c = (_b = customSlots.value).expandIcon) === null || _c === void 0 ? void 0 : _c.call(_b);
  var loadingIcon = (_d = loadingIconRef.value) !== null && _d !== void 0 ? _d : (_f = (_e = customSlots.value).loadingIcon) === null || _f === void 0 ? void 0 : _f.call(_e);
  var hoverOpen = expandTrigger.value === "hover";
  return createVNode("ul", {
    "class": menuPrefixCls,
    "role": "menu"
  }, [options.map(function(option) {
    var _ref2;
    var _a2;
    var disabled = option.disabled;
    var searchOptions = option[SEARCH_MARK];
    var label = (_a2 = option[FIX_LABEL]) !== null && _a2 !== void 0 ? _a2 : option[fieldNames.value.label];
    var value = option[fieldNames.value.value];
    var isMergedLeaf = isLeaf(option, fieldNames.value);
    var fullPath = searchOptions ? searchOptions.map(function(opt) {
      return opt[fieldNames.value.value];
    }) : [].concat(_toConsumableArray(prevValuePath), [value]);
    var fullPathKey = toPathKey(fullPath);
    var isLoading = loadingKeys.includes(fullPathKey);
    var checked = checkedSet.has(fullPathKey);
    var halfChecked = halfCheckedSet.has(fullPathKey);
    var triggerOpenPath = function triggerOpenPath2() {
      if (!disabled && (!hoverOpen || !isMergedLeaf)) {
        onActive(fullPath);
      }
    };
    var triggerSelect = function triggerSelect2() {
      if (isSelectable(option)) {
        onSelect(fullPath, isMergedLeaf);
      }
    };
    var title;
    if (typeof option.title === "string") {
      title = option.title;
    } else if (typeof label === "string") {
      title = label;
    }
    return createVNode("li", {
      "key": fullPathKey,
      "class": [menuItemPrefixCls, (_ref2 = {}, _defineProperty$m(_ref2, "".concat(menuItemPrefixCls, "-expand"), !isMergedLeaf), _defineProperty$m(_ref2, "".concat(menuItemPrefixCls, "-active"), activeValue === value), _defineProperty$m(_ref2, "".concat(menuItemPrefixCls, "-disabled"), disabled), _defineProperty$m(_ref2, "".concat(menuItemPrefixCls, "-loading"), isLoading), _ref2)],
      "style": dropdownMenuColumnStyle.value,
      "role": "menuitemcheckbox",
      "title": title,
      "aria-checked": checked,
      "data-path-key": fullPathKey,
      "onClick": function onClick2() {
        triggerOpenPath();
        if (!multiple || isMergedLeaf) {
          triggerSelect();
        }
      },
      "onDblclick": function onDblclick() {
        if (changeOnSelect.value) {
          onToggleOpen(false);
        }
      },
      "onMouseenter": function onMouseenter2() {
        if (hoverOpen) {
          triggerOpenPath();
        }
      },
      "onMousedown": function onMousedown2(e2) {
        e2.preventDefault();
      }
    }, [multiple && createVNode(Checkbox, {
      "prefixCls": "".concat(prefixCls, "-checkbox"),
      "checked": checked,
      "halfChecked": halfChecked,
      "disabled": disabled,
      "onClick": function onClick2(e2) {
        e2.stopPropagation();
        triggerSelect();
      }
    }, null), createVNode("div", {
      "class": "".concat(menuItemPrefixCls, "-content")
    }, [label]), !isLoading && expandIcon && !isMergedLeaf && createVNode("div", {
      "class": "".concat(menuItemPrefixCls, "-expand-icon")
    }, [expandIcon]), isLoading && loadingIcon && createVNode("div", {
      "class": "".concat(menuItemPrefixCls, "-loading-icon")
    }, [loadingIcon])]);
  })]);
}
Column.props = ["prefixCls", "multiple", "options", "activeValue", "prevValuePath", "onToggleOpen", "onSelect", "onActive", "checkedSet", "halfCheckedSet", "loadingKeys", "isSelectable"];
Column.displayName = "Column";
Column.inheritAttrs = false;
var OptionList = defineComponent({
  name: "OptionList",
  inheritAttrs: false,
  setup: function setup48(_props, context) {
    var attrs = context.attrs, slots = context.slots;
    var baseProps = useBaseProps();
    var containerRef = ref();
    var rtl2 = computed(function() {
      return baseProps.direction === "rtl";
    });
    var _useInjectCascader = useInjectCascader(), options = _useInjectCascader.options, values = _useInjectCascader.values, halfValues = _useInjectCascader.halfValues, fieldNames = _useInjectCascader.fieldNames, changeOnSelect = _useInjectCascader.changeOnSelect, onSelect = _useInjectCascader.onSelect, searchOptions = _useInjectCascader.searchOptions, dropdownPrefixCls = _useInjectCascader.dropdownPrefixCls, loadData = _useInjectCascader.loadData, expandTrigger = _useInjectCascader.expandTrigger, customSlots = _useInjectCascader.customSlots;
    var mergedPrefixCls = computed(function() {
      return dropdownPrefixCls.value || baseProps.prefixCls;
    });
    var loadingKeys = shallowRef([]);
    var internalLoadData = function internalLoadData2(valueCells) {
      if (!loadData.value || baseProps.searchValue) {
        return;
      }
      var optionList = toPathOptions(valueCells, options.value, fieldNames.value);
      var rawOptions = optionList.map(function(_ref) {
        var option = _ref.option;
        return option;
      });
      var lastOption = rawOptions[rawOptions.length - 1];
      if (lastOption && !isLeaf(lastOption, fieldNames.value)) {
        var pathKey = toPathKey(valueCells);
        loadingKeys.value = [].concat(_toConsumableArray(loadingKeys.value), [pathKey]);
        loadData.value(rawOptions);
      }
    };
    watchEffect(function() {
      if (loadingKeys.value.length) {
        loadingKeys.value.forEach(function(loadingKey) {
          var valueStrCells = toPathValueStr(loadingKey);
          var optionList = toPathOptions(valueStrCells, options.value, fieldNames.value, true).map(function(_ref2) {
            var option = _ref2.option;
            return option;
          });
          var lastOption = optionList[optionList.length - 1];
          if (!lastOption || lastOption[fieldNames.value.children] || isLeaf(lastOption, fieldNames.value)) {
            loadingKeys.value = loadingKeys.value.filter(function(key2) {
              return key2 !== loadingKey;
            });
          }
        });
      }
    });
    var checkedSet = computed(function() {
      return new Set(toPathKeys(values.value));
    });
    var halfCheckedSet = computed(function() {
      return new Set(toPathKeys(halfValues.value));
    });
    var _useActive = useActive(), _useActive2 = _slicedToArray$2(_useActive, 2), activeValueCells = _useActive2[0], setActiveValueCells = _useActive2[1];
    var onPathOpen = function onPathOpen2(nextValueCells) {
      setActiveValueCells(nextValueCells);
      internalLoadData(nextValueCells);
    };
    var isSelectable = function isSelectable2(option) {
      var disabled = option.disabled;
      var isMergedLeaf = isLeaf(option, fieldNames.value);
      return !disabled && (isMergedLeaf || changeOnSelect.value || baseProps.multiple);
    };
    var onPathSelect = function onPathSelect2(valuePath, leaf) {
      var fromKeyboard = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      onSelect(valuePath);
      if (!baseProps.multiple && (leaf || changeOnSelect.value && (expandTrigger.value === "hover" || fromKeyboard))) {
        baseProps.toggleOpen(false);
      }
    };
    var mergedOptions = computed(function() {
      if (baseProps.searchValue) {
        return searchOptions.value;
      }
      return options.value;
    });
    var optionColumns = computed(function() {
      var optionList = [{
        options: mergedOptions.value
      }];
      var currentList = mergedOptions.value;
      var _loop = function _loop2(i2) {
        var activeValueCell = activeValueCells.value[i2];
        var currentOption = currentList.find(function(option) {
          return option[fieldNames.value.value] === activeValueCell;
        });
        var subOptions = currentOption === null || currentOption === void 0 ? void 0 : currentOption[fieldNames.value.children];
        if (!(subOptions === null || subOptions === void 0 ? void 0 : subOptions.length)) {
          return "break";
        }
        currentList = subOptions;
        optionList.push({
          options: subOptions
        });
      };
      for (var i = 0; i < activeValueCells.value.length; i += 1) {
        var _ret = _loop(i);
        if (_ret === "break")
          break;
      }
      return optionList;
    });
    var onKeyboardSelect = function onKeyboardSelect2(selectValueCells, option) {
      if (isSelectable(option)) {
        onPathSelect(selectValueCells, isLeaf(option, fieldNames.value), true);
      }
    };
    useKeyboard(context, mergedOptions, fieldNames, activeValueCells, onPathOpen, onKeyboardSelect);
    var onListMouseDown = function onListMouseDown2(event) {
      event.preventDefault();
    };
    onMounted(function() {
      watch(activeValueCells, function(cells) {
        var _a;
        for (var i = 0; i < cells.length; i += 1) {
          var cellPath = cells.slice(0, i + 1);
          var cellKeyPath = toPathKey(cellPath);
          var ele = (_a = containerRef.value) === null || _a === void 0 ? void 0 : _a.querySelector('li[data-path-key="'.concat(cellKeyPath.replace(/\\{0,2}"/g, '\\"'), '"]'));
          if (ele) {
            scrollIntoParentView(ele);
          }
        }
      }, {
        flush: "post",
        immediate: true
      });
    });
    return function() {
      var _ref3, _ref4;
      var _a, _b, _c, _d, _e;
      var _baseProps$notFoundCo = baseProps.notFoundContent, notFoundContent = _baseProps$notFoundCo === void 0 ? ((_a = slots.notFoundContent) === null || _a === void 0 ? void 0 : _a.call(slots)) || ((_c = (_b = customSlots.value).notFoundContent) === null || _c === void 0 ? void 0 : _c.call(_b)) : _baseProps$notFoundCo, multiple = baseProps.multiple, toggleOpen = baseProps.toggleOpen;
      var isEmpty = !((_e = (_d = optionColumns.value[0]) === null || _d === void 0 ? void 0 : _d.options) === null || _e === void 0 ? void 0 : _e.length);
      var emptyList = [(_ref3 = {}, _defineProperty$m(_ref3, fieldNames.value.value, "__EMPTY__"), _defineProperty$m(_ref3, FIX_LABEL, notFoundContent), _defineProperty$m(_ref3, "disabled", true), _ref3)];
      var columnProps = _extends(_extends({}, attrs), {
        multiple: !isEmpty && multiple,
        onSelect: onPathSelect,
        onActive: onPathOpen,
        onToggleOpen: toggleOpen,
        checkedSet: checkedSet.value,
        halfCheckedSet: halfCheckedSet.value,
        loadingKeys: loadingKeys.value,
        isSelectable
      });
      var mergedOptionColumns = isEmpty ? [{
        options: emptyList
      }] : optionColumns.value;
      var columnNodes = mergedOptionColumns.map(function(col, index2) {
        var prevValuePath = activeValueCells.value.slice(0, index2);
        var activeValue = activeValueCells.value[index2];
        return createVNode(Column, _objectSpread2$1(_objectSpread2$1({
          "key": index2
        }, columnProps), {}, {
          "prefixCls": mergedPrefixCls.value,
          "options": col.options,
          "prevValuePath": prevValuePath,
          "activeValue": activeValue
        }), null);
      });
      return createVNode("div", {
        "class": ["".concat(mergedPrefixCls.value, "-menus"), (_ref4 = {}, _defineProperty$m(_ref4, "".concat(mergedPrefixCls.value, "-menu-empty"), isEmpty), _defineProperty$m(_ref4, "".concat(mergedPrefixCls.value, "-rtl"), rtl2.value), _ref4)],
        "onMousedown": onListMouseDown,
        "ref": containerRef
      }, [columnNodes]);
    };
  }
});
function useMaxLevel(keyEntities) {
  var maxLevel = ref(0);
  var levelEntities = shallowRef();
  watchEffect(function() {
    var newLevelEntities = /* @__PURE__ */ new Map();
    var newMaxLevel = 0;
    var keyEntitiesValue = keyEntities.value || {};
    for (var key2 in keyEntitiesValue) {
      if (Object.prototype.hasOwnProperty.call(keyEntitiesValue, key2)) {
        var entity = keyEntitiesValue[key2];
        var level = entity.level;
        var levelSet = newLevelEntities.get(level);
        if (!levelSet) {
          levelSet = /* @__PURE__ */ new Set();
          newLevelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        newMaxLevel = Math.max(newMaxLevel, level);
      }
    }
    maxLevel.value = newMaxLevel;
    levelEntities.value = newLevelEntities;
  });
  return {
    maxLevel,
    levelEntities
  };
}
function baseCascaderProps() {
  return _extends(_extends({}, omit(baseSelectPropsWithoutPrivate(), ["tokenSeparators", "mode", "showSearch"])), {
    id: String,
    prefixCls: String,
    fieldNames: Object,
    children: Array,
    value: {
      type: [String, Number, Array]
    },
    defaultValue: {
      type: [String, Number, Array]
    },
    changeOnSelect: {
      type: Boolean,
      default: void 0
    },
    displayRender: Function,
    checkable: {
      type: Boolean,
      default: void 0
    },
    showCheckedStrategy: {
      type: String,
      default: SHOW_PARENT
    },
    showSearch: {
      type: [Boolean, Object],
      default: void 0
    },
    searchValue: String,
    onSearch: Function,
    expandTrigger: String,
    options: Array,
    dropdownPrefixCls: String,
    loadData: Function,
    popupVisible: {
      type: Boolean,
      default: void 0
    },
    popupClassName: String,
    dropdownClassName: String,
    dropdownMenuColumnStyle: {
      type: Object,
      default: void 0
    },
    popupStyle: {
      type: Object,
      default: void 0
    },
    dropdownStyle: {
      type: Object,
      default: void 0
    },
    popupPlacement: String,
    placement: String,
    onPopupVisibleChange: Function,
    onDropdownVisibleChange: Function,
    expandIcon: PropTypes$1.any,
    loadingIcon: PropTypes$1.any
  });
}
function internalCascaderProps() {
  return _extends(_extends({}, baseCascaderProps()), {
    onChange: Function,
    customSlots: Object
  });
}
function isMultipleValue(value) {
  return Array.isArray(value) && Array.isArray(value[0]);
}
function toRawValues(value) {
  if (!value) {
    return [];
  }
  if (isMultipleValue(value)) {
    return value;
  }
  return (value.length === 0 ? [] : [value]).map(function(val) {
    return Array.isArray(val) ? val : [val];
  });
}
var Cascader$2 = defineComponent({
  name: "Cascader",
  inheritAttrs: false,
  props: initDefaultProps$1(internalCascaderProps(), {}),
  setup: function setup49(props2, _ref) {
    var attrs = _ref.attrs, expose = _ref.expose, slots = _ref.slots;
    var mergedId = useId(toRef(props2, "id"));
    var multiple = computed(function() {
      return !!props2.checkable;
    });
    var _useMergedState = useMergedState(props2.defaultValue, {
      value: computed(function() {
        return props2.value;
      }),
      postState: toRawValues
    }), _useMergedState2 = _slicedToArray$2(_useMergedState, 2), rawValues = _useMergedState2[0], setRawValues = _useMergedState2[1];
    var mergedFieldNames = computed(function() {
      return fillFieldNames$1(props2.fieldNames);
    });
    var mergedOptions = computed(function() {
      return props2.options || [];
    });
    var pathKeyEntities = useEntities(mergedOptions, mergedFieldNames);
    var getValueByKeyPath = function getValueByKeyPath2(pathKeys) {
      var keyPathEntities = pathKeyEntities.value;
      return pathKeys.map(function(pathKey) {
        var nodes = keyPathEntities[pathKey].nodes;
        return nodes.map(function(node) {
          return node[mergedFieldNames.value.value];
        });
      });
    };
    var _useMergedState3 = useMergedState("", {
      value: computed(function() {
        return props2.searchValue;
      }),
      postState: function postState(search) {
        return search || "";
      }
    }), _useMergedState4 = _slicedToArray$2(_useMergedState3, 2), mergedSearchValue = _useMergedState4[0], setSearchValue = _useMergedState4[1];
    var onInternalSearch = function onInternalSearch2(searchText, info) {
      setSearchValue(searchText);
      if (info.source !== "blur" && props2.onSearch) {
        props2.onSearch(searchText);
      }
    };
    var _useSearchConfig = useSearchConfig(toRef(props2, "showSearch")), mergedShowSearch = _useSearchConfig.showSearch, mergedSearchConfig = _useSearchConfig.searchConfig;
    var searchOptions = useSearchOptions(mergedSearchValue, mergedOptions, mergedFieldNames, computed(function() {
      return props2.dropdownPrefixCls || props2.prefixCls;
    }), mergedSearchConfig, toRef(props2, "changeOnSelect"));
    var missingValuesInfo = useMissingValues(mergedOptions, mergedFieldNames, rawValues);
    var _ref2 = [ref([]), ref([]), ref([])], checkedValues = _ref2[0], halfCheckedValues = _ref2[1], missingCheckedValues = _ref2[2];
    var _useMaxLevel = useMaxLevel(pathKeyEntities), maxLevel = _useMaxLevel.maxLevel, levelEntities = _useMaxLevel.levelEntities;
    watchEffect(function() {
      var _missingValuesInfo$va = _slicedToArray$2(missingValuesInfo.value, 2), existValues = _missingValuesInfo$va[0], missingValues = _missingValuesInfo$va[1];
      if (!multiple.value || !rawValues.value.length) {
        var _ref3 = [existValues, [], missingValues];
        checkedValues.value = _ref3[0];
        halfCheckedValues.value = _ref3[1];
        missingCheckedValues.value = _ref3[2];
        return;
      }
      var keyPathValues = toPathKeys(existValues);
      var keyPathEntities = pathKeyEntities.value;
      var _conductCheck = conductCheck(keyPathValues, true, keyPathEntities, maxLevel.value, levelEntities.value), checkedKeys = _conductCheck.checkedKeys, halfCheckedKeys = _conductCheck.halfCheckedKeys;
      var _ref4 = [getValueByKeyPath(checkedKeys), getValueByKeyPath(halfCheckedKeys), missingValues];
      checkedValues.value = _ref4[0];
      halfCheckedValues.value = _ref4[1];
      missingCheckedValues.value = _ref4[2];
    });
    var deDuplicatedValues = computed(function() {
      var checkedKeys = toPathKeys(checkedValues.value);
      var deduplicateKeys = formatStrategyValues(checkedKeys, pathKeyEntities.value, props2.showCheckedStrategy);
      return [].concat(_toConsumableArray(missingCheckedValues.value), _toConsumableArray(getValueByKeyPath(deduplicateKeys)));
    });
    var displayValues = useDisplayValues(deDuplicatedValues, mergedOptions, mergedFieldNames, multiple, toRef(props2, "displayRender"));
    var triggerChange = function triggerChange2(nextValues) {
      setRawValues(nextValues);
      if (props2.onChange) {
        var nextRawValues = toRawValues(nextValues);
        var valueOptions = nextRawValues.map(function(valueCells) {
          return toPathOptions(valueCells, mergedOptions.value, mergedFieldNames.value).map(function(valueOpt) {
            return valueOpt.option;
          });
        });
        var triggerValues = multiple.value ? nextRawValues : nextRawValues[0];
        var triggerOptions = multiple.value ? valueOptions : valueOptions[0];
        props2.onChange(triggerValues, triggerOptions);
      }
    };
    var onInternalSelect = function onInternalSelect2(valuePath) {
      setSearchValue("");
      if (!multiple.value) {
        triggerChange(valuePath);
      } else {
        var pathKey = toPathKey(valuePath);
        var checkedPathKeys = toPathKeys(checkedValues.value);
        var halfCheckedPathKeys = toPathKeys(halfCheckedValues.value);
        var existInChecked = checkedPathKeys.includes(pathKey);
        var existInMissing = missingCheckedValues.value.some(function(valueCells) {
          return toPathKey(valueCells) === pathKey;
        });
        var nextCheckedValues = checkedValues.value;
        var nextMissingValues = missingCheckedValues.value;
        if (existInMissing && !existInChecked) {
          nextMissingValues = missingCheckedValues.value.filter(function(valueCells) {
            return toPathKey(valueCells) !== pathKey;
          });
        } else {
          var nextRawCheckedKeys = existInChecked ? checkedPathKeys.filter(function(key2) {
            return key2 !== pathKey;
          }) : [].concat(_toConsumableArray(checkedPathKeys), [pathKey]);
          var checkedKeys;
          if (existInChecked) {
            var _conductCheck2 = conductCheck(nextRawCheckedKeys, {
              checked: false,
              halfCheckedKeys: halfCheckedPathKeys
            }, pathKeyEntities.value, maxLevel.value, levelEntities.value);
            checkedKeys = _conductCheck2.checkedKeys;
          } else {
            var _conductCheck3 = conductCheck(nextRawCheckedKeys, true, pathKeyEntities.value, maxLevel.value, levelEntities.value);
            checkedKeys = _conductCheck3.checkedKeys;
          }
          var deDuplicatedKeys = formatStrategyValues(checkedKeys, pathKeyEntities.value, props2.showCheckedStrategy);
          nextCheckedValues = getValueByKeyPath(deDuplicatedKeys);
        }
        triggerChange([].concat(_toConsumableArray(nextMissingValues), _toConsumableArray(nextCheckedValues)));
      }
    };
    var onDisplayValuesChange = function onDisplayValuesChange2(_2, info) {
      if (info.type === "clear") {
        triggerChange([]);
        return;
      }
      var valueCells = info.values[0].valueCells;
      onInternalSelect(valueCells);
    };
    var mergedOpen = computed(function() {
      return props2.open !== void 0 ? props2.open : props2.popupVisible;
    });
    var mergedDropdownClassName = computed(function() {
      return props2.dropdownClassName || props2.popupClassName;
    });
    var mergedDropdownStyle = computed(function() {
      return props2.dropdownStyle || props2.popupStyle || {};
    });
    var mergedPlacement = computed(function() {
      return props2.placement || props2.popupPlacement;
    });
    var onInternalDropdownVisibleChange = function onInternalDropdownVisibleChange2(nextVisible) {
      var _a, _b;
      (_a = props2.onDropdownVisibleChange) === null || _a === void 0 ? void 0 : _a.call(props2, nextVisible);
      (_b = props2.onPopupVisibleChange) === null || _b === void 0 ? void 0 : _b.call(props2, nextVisible);
    };
    var _toRefs = toRefs(props2), changeOnSelect = _toRefs.changeOnSelect, checkable = _toRefs.checkable, dropdownPrefixCls = _toRefs.dropdownPrefixCls, loadData = _toRefs.loadData, expandTrigger = _toRefs.expandTrigger, expandIcon = _toRefs.expandIcon, loadingIcon = _toRefs.loadingIcon, dropdownMenuColumnStyle = _toRefs.dropdownMenuColumnStyle, customSlots = _toRefs.customSlots;
    useProvideCascader({
      options: mergedOptions,
      fieldNames: mergedFieldNames,
      values: checkedValues,
      halfValues: halfCheckedValues,
      changeOnSelect,
      onSelect: onInternalSelect,
      checkable,
      searchOptions,
      dropdownPrefixCls,
      loadData,
      expandTrigger,
      expandIcon,
      loadingIcon,
      dropdownMenuColumnStyle,
      customSlots
    });
    var selectRef = ref();
    expose({
      focus: function focus() {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.blur();
      },
      scrollTo: function scrollTo(arg) {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.scrollTo(arg);
      }
    });
    var pickProps = computed(function() {
      return omit(props2, [
        "id",
        "prefixCls",
        "fieldNames",
        "defaultValue",
        "value",
        "changeOnSelect",
        "onChange",
        "displayRender",
        "checkable",
        "searchValue",
        "onSearch",
        "showSearch",
        "expandTrigger",
        "options",
        "dropdownPrefixCls",
        "loadData",
        "popupVisible",
        "open",
        "popupClassName",
        "dropdownClassName",
        "dropdownMenuColumnStyle",
        "popupPlacement",
        "placement",
        "onDropdownVisibleChange",
        "onPopupVisibleChange",
        "expandIcon",
        "loadingIcon",
        "customSlots",
        "showCheckedStrategy",
        "children"
      ]);
    });
    return function() {
      var emptyOptions = !(mergedSearchValue.value ? searchOptions.value : mergedOptions.value).length;
      var _props$dropdownMatchS = props2.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? false : _props$dropdownMatchS;
      var dropdownStyle = mergedSearchValue.value && mergedSearchConfig.value.matchInputWidth || emptyOptions ? {} : {
        minWidth: "auto"
      };
      return createVNode(BaseSelect, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, pickProps.value), attrs), {}, {
        "ref": selectRef,
        "id": mergedId,
        "prefixCls": props2.prefixCls,
        "dropdownMatchSelectWidth": dropdownMatchSelectWidth,
        "dropdownStyle": _extends(_extends({}, mergedDropdownStyle.value), dropdownStyle),
        "displayValues": displayValues.value,
        "onDisplayValuesChange": onDisplayValuesChange,
        "mode": multiple.value ? "multiple" : void 0,
        "searchValue": mergedSearchValue.value,
        "onSearch": onInternalSearch,
        "showSearch": mergedShowSearch.value,
        "OptionList": OptionList,
        "emptyOptions": emptyOptions,
        "open": mergedOpen.value,
        "dropdownClassName": mergedDropdownClassName.value,
        "placement": mergedPlacement.value,
        "onDropdownVisibleChange": onInternalDropdownVisibleChange,
        "getRawInputElement": function getRawInputElement() {
          var _a;
          return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots);
        }
      }), slots);
    };
  }
});
var LeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlinedSvg = LeftOutlined$2;
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$2(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$2(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var LeftOutlined = function LeftOutlined2(props2, context) {
  var p = _objectSpread$2({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$2({}, p, {
    "icon": LeftOutlinedSvg
  }), null);
};
LeftOutlined.displayName = "LeftOutlined";
LeftOutlined.inheritAttrs = false;
var LeftOutlined$1 = LeftOutlined;
var __rest$4 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function highlightKeyword(str, lowerKeyword, prefixCls) {
  var cells = str.toLowerCase().split(lowerKeyword).reduce(function(list, cur, index2) {
    return index2 === 0 ? [cur] : [].concat(_toConsumableArray(list), [lowerKeyword, cur]);
  }, []);
  var fillCells = [];
  var start = 0;
  cells.forEach(function(cell, index2) {
    var end = start + cell.length;
    var originWorld = str.slice(start, end);
    start = end;
    if (index2 % 2 === 1) {
      originWorld = createVNode("span", {
        "class": "".concat(prefixCls, "-menu-item-keyword"),
        "key": "seperator"
      }, [originWorld]);
    }
    fillCells.push(originWorld);
  });
  return fillCells;
}
var defaultSearchRender = function defaultSearchRender2(_ref) {
  var inputValue = _ref.inputValue, path = _ref.path, prefixCls = _ref.prefixCls, fieldNames = _ref.fieldNames;
  var optionList = [];
  var lower = inputValue.toLowerCase();
  path.forEach(function(node, index2) {
    if (index2 !== 0) {
      optionList.push(" / ");
    }
    var label = node[fieldNames.label];
    var type = _typeof$1(label);
    if (type === "string" || type === "number") {
      label = highlightKeyword(String(label), lower, prefixCls);
    }
    optionList.push(label);
  });
  return optionList;
};
function cascaderProps() {
  return _extends(_extends({}, omit(internalCascaderProps(), ["customSlots", "checkable", "options"])), {
    multiple: {
      type: Boolean,
      default: void 0
    },
    size: String,
    bordered: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String
    },
    suffixIcon: PropTypes$1.any,
    options: Array,
    "onUpdate:value": Function
  });
}
var Cascader = defineComponent({
  name: "ACascader",
  inheritAttrs: false,
  props: initDefaultProps$1(cascaderProps(), {
    bordered: true,
    choiceTransitionName: "",
    allowClear: true
  }),
  setup: function setup50(props2, _ref2) {
    var attrs = _ref2.attrs, expose = _ref2.expose, slots = _ref2.slots, emit = _ref2.emit;
    var formItemContext = useInjectFormItemContext();
    var _useConfigInject = useConfigInject("cascader", props2), cascaderPrefixCls = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, getPrefixCls2 = _useConfigInject.getPrefixCls, direction = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer, renderEmpty2 = _useConfigInject.renderEmpty, size = _useConfigInject.size;
    var prefixCls = computed(function() {
      return getPrefixCls2("select", props2.prefixCls);
    });
    var isRtl = computed(function() {
      return direction.value === "rtl";
    });
    var mergedShowSearch = computed(function() {
      if (!props2.showSearch) {
        return props2.showSearch;
      }
      var searchConfig = {
        render: defaultSearchRender
      };
      if (_typeof$1(props2.showSearch) === "object") {
        searchConfig = _extends(_extends({}, searchConfig), props2.showSearch);
      }
      return searchConfig;
    });
    var mergedDropdownClassName = computed(function() {
      return classNames(props2.dropdownClassName || props2.popupClassName, "".concat(cascaderPrefixCls.value, "-dropdown"), _defineProperty$m({}, "".concat(cascaderPrefixCls.value, "-dropdown-rtl"), isRtl.value));
    });
    var selectRef = ref();
    expose({
      focus: function focus() {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.focus();
      },
      blur: function blur() {
        var _a;
        (_a = selectRef.value) === null || _a === void 0 ? void 0 : _a.blur();
      }
    });
    var handleChange2 = function handleChange3() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      emit("update:value", args[0]);
      emit.apply(void 0, ["change"].concat(args));
      formItemContext.onFieldChange();
    };
    var handleBlur = function handleBlur2() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      emit.apply(void 0, ["blur"].concat(args));
      formItemContext.onFieldBlur();
    };
    var mergedShowArrow = computed(function() {
      return props2.showArrow !== void 0 ? props2.showArrow : props2.loading || !props2.multiple;
    });
    var placement = computed(function() {
      if (props2.placement !== void 0) {
        return props2.placement;
      }
      return direction.value === "rtl" ? "bottomRight" : "bottomLeft";
    });
    return function() {
      var _ref3;
      var _a, _b;
      var _props$notFoundConten = props2.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? (_a = slots.notFoundContent) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$notFoundConten, _props$expandIcon = props2.expandIcon, expandIcon = _props$expandIcon === void 0 ? (_b = slots.expandIcon) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$expandIcon, multiple = props2.multiple, bordered = props2.bordered, allowClear = props2.allowClear, choiceTransitionName = props2.choiceTransitionName, transitionName2 = props2.transitionName, _props$id = props2.id, id = _props$id === void 0 ? formItemContext.id.value : _props$id, restProps = __rest$4(props2, ["notFoundContent", "expandIcon", "multiple", "bordered", "allowClear", "choiceTransitionName", "transitionName", "id"]);
      var mergedNotFoundContent = notFoundContent || renderEmpty2.value("Cascader");
      var mergedExpandIcon = expandIcon;
      if (!expandIcon) {
        mergedExpandIcon = isRtl.value ? createVNode(LeftOutlined$1, null, null) : createVNode(RightOutlined$1, null, null);
      }
      var loadingIcon = createVNode("span", {
        "class": "".concat(prefixCls.value, "-menu-item-loading-icon")
      }, [createVNode(LoadingOutlined$1, {
        "spin": true
      }, null)]);
      var _getIcons = getIcons(_extends(_extends({}, props2), {
        multiple,
        prefixCls: prefixCls.value,
        showArrow: mergedShowArrow.value
      }), slots), suffixIcon = _getIcons.suffixIcon, removeIcon = _getIcons.removeIcon, clearIcon = _getIcons.clearIcon;
      return createVNode(Cascader$2, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, restProps), attrs), {}, {
        "id": id,
        "prefixCls": prefixCls.value,
        "class": [cascaderPrefixCls.value, (_ref3 = {}, _defineProperty$m(_ref3, "".concat(prefixCls.value, "-lg"), size.value === "large"), _defineProperty$m(_ref3, "".concat(prefixCls.value, "-sm"), size.value === "small"), _defineProperty$m(_ref3, "".concat(prefixCls.value, "-rtl"), isRtl.value), _defineProperty$m(_ref3, "".concat(prefixCls.value, "-borderless"), !bordered), _ref3), attrs.class],
        "direction": direction.value,
        "placement": placement.value,
        "notFoundContent": mergedNotFoundContent,
        "allowClear": allowClear,
        "showSearch": mergedShowSearch.value,
        "expandIcon": mergedExpandIcon,
        "inputIcon": suffixIcon,
        "removeIcon": removeIcon,
        "clearIcon": clearIcon,
        "loadingIcon": loadingIcon,
        "checkable": !!multiple,
        "dropdownClassName": mergedDropdownClassName.value,
        "dropdownPrefixCls": cascaderPrefixCls.value,
        "choiceTransitionName": getTransitionName$1(rootPrefixCls.value, "", choiceTransitionName),
        "transitionName": getTransitionName$1(rootPrefixCls.value, getTransitionDirection(placement.value), transitionName2),
        "getPopupContainer": getPopupContainer.value,
        "customSlots": _extends(_extends({}, slots), {
          checkable: function checkable() {
            return createVNode("span", {
              "class": "".concat(cascaderPrefixCls.value, "-checkbox-inner")
            }, null);
          }
        }),
        "displayRender": props2.displayRender || slots.displayRender,
        "maxTagPlaceholder": props2.maxTagPlaceholder || slots.maxTagPlaceholder,
        "showArrow": props2.showArrow,
        "onChange": handleChange2,
        "onBlur": handleBlur,
        "ref": selectRef
      }), slots);
    };
  }
});
var Cascader$1 = withInstall(Cascader);
Dropdown$1.Button = DropdownButton;
Dropdown$1.install = function(app) {
  app.component(Dropdown$1.name, Dropdown$1);
  app.component(DropdownButton.name, DropdownButton);
  return app;
};
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === "undefined") {
    return 0;
  }
  if (fresh || cached === void 0) {
    var inner = document.createElement("div");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    var outerStyle = outer.style;
    outerStyle.position = "absolute";
    outerStyle.top = "0";
    outerStyle.left = "0";
    outerStyle.pointerEvents = "none";
    outerStyle.visibility = "hidden";
    outerStyle.width = "200px";
    outerStyle.height = "150px";
    outerStyle.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
function setStyle(style2) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$element = options.element, element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style2);
  styleKeys.forEach(function(key2) {
    oldStyle[key2] = element.style[key2];
  });
  styleKeys.forEach(function(key2) {
    element.style[key2] = style2[key2];
  });
  return oldStyle;
}
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var cacheStyle$1 = {};
var switchScrollingEffect = function(close3) {
  if (!isBodyOverflowing() && !close3) {
    return;
  }
  var scrollingEffectClassName2 = "ant-scrolling-effect";
  var scrollingEffectClassNameReg2 = new RegExp("".concat(scrollingEffectClassName2), "g");
  var bodyClassName = document.body.className;
  if (close3) {
    if (!scrollingEffectClassNameReg2.test(bodyClassName))
      return;
    setStyle(cacheStyle$1);
    cacheStyle$1 = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg2, "").trim();
    return;
  }
  var scrollBarSize = getScrollBarSize();
  if (scrollBarSize) {
    cacheStyle$1 = setStyle({
      position: "relative",
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });
    if (!scrollingEffectClassNameReg2.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName2);
      document.body.className = addClassName.trim();
    }
  }
};
var locks = [];
var scrollingEffectClassName = "ant-scrolling-effect";
var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), "g");
var uuid$1 = 0;
var cacheStyle = /* @__PURE__ */ new Map();
var ScrollLocker = /* @__PURE__ */ _createClass(function ScrollLocker2(options) {
  var _this = this;
  _classCallCheck(this, ScrollLocker2);
  this.getContainer = function() {
    var _a;
    return (_a = _this.options) === null || _a === void 0 ? void 0 : _a.container;
  };
  this.reLock = function(options2) {
    var findLock = locks.find(function(_ref) {
      var target = _ref.target;
      return target === _this.lockTarget;
    });
    if (findLock) {
      _this.unLock();
    }
    _this.options = options2;
    if (findLock) {
      findLock.options = options2;
      _this.lock();
    }
  };
  this.lock = function() {
    var _a;
    if (locks.some(function(_ref2) {
      var target = _ref2.target;
      return target === _this.lockTarget;
    })) {
      return;
    }
    if (locks.some(function(_ref3) {
      var options2 = _ref3.options;
      var _a2;
      return (options2 === null || options2 === void 0 ? void 0 : options2.container) === ((_a2 = _this.options) === null || _a2 === void 0 ? void 0 : _a2.container);
    })) {
      locks = [].concat(_toConsumableArray(locks), [{
        target: _this.lockTarget,
        options: _this.options
      }]);
      return;
    }
    var scrollBarSize = 0;
    var container = ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.container) || document.body;
    if (container === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || container.scrollHeight > container.clientHeight) {
      scrollBarSize = getScrollBarSize();
    }
    var containerClassName = container.className;
    if (locks.filter(function(_ref4) {
      var options2 = _ref4.options;
      var _a2;
      return (options2 === null || options2 === void 0 ? void 0 : options2.container) === ((_a2 = _this.options) === null || _a2 === void 0 ? void 0 : _a2.container);
    }).length === 0) {
      cacheStyle.set(container, setStyle({
        width: scrollBarSize !== 0 ? "calc(100% - ".concat(scrollBarSize, "px)") : void 0,
        overflow: "hidden",
        overflowX: "hidden",
        overflowY: "hidden"
      }, {
        element: container
      }));
    }
    if (!scrollingEffectClassNameReg.test(containerClassName)) {
      var addClassName = "".concat(containerClassName, " ").concat(scrollingEffectClassName);
      container.className = addClassName.trim();
    }
    locks = [].concat(_toConsumableArray(locks), [{
      target: _this.lockTarget,
      options: _this.options
    }]);
  };
  this.unLock = function() {
    var _a;
    var findLock = locks.find(function(_ref5) {
      var target = _ref5.target;
      return target === _this.lockTarget;
    });
    locks = locks.filter(function(_ref6) {
      var target = _ref6.target;
      return target !== _this.lockTarget;
    });
    if (!findLock || locks.some(function(_ref7) {
      var options2 = _ref7.options;
      var _a2;
      return (options2 === null || options2 === void 0 ? void 0 : options2.container) === ((_a2 = findLock.options) === null || _a2 === void 0 ? void 0 : _a2.container);
    })) {
      return;
    }
    var container = ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.container) || document.body;
    var containerClassName = container.className;
    if (!scrollingEffectClassNameReg.test(containerClassName))
      return;
    setStyle(cacheStyle.get(container), {
      element: container
    });
    cacheStyle.delete(container);
    container.className = container.className.replace(scrollingEffectClassNameReg, "").trim();
  };
  this.lockTarget = uuid$1++;
  this.options = options;
});
var openCount = 0;
var supportDom = canUseDom();
var cacheOverflow = {};
var getParent2 = function getParent3(getContainer4) {
  if (!supportDom) {
    return null;
  }
  if (getContainer4) {
    if (typeof getContainer4 === "string") {
      return document.querySelectorAll(getContainer4)[0];
    }
    if (typeof getContainer4 === "function") {
      return getContainer4();
    }
    if (_typeof$1(getContainer4) === "object" && getContainer4 instanceof window.HTMLElement) {
      return getContainer4;
    }
  }
  return document.body;
};
var Portal = defineComponent({
  name: "PortalWrapper",
  inheritAttrs: false,
  props: {
    wrapperClassName: String,
    forceRender: {
      type: Boolean,
      default: void 0
    },
    getContainer: PropTypes$1.any,
    visible: {
      type: Boolean,
      default: void 0
    }
  },
  setup: function setup51(props2, _ref) {
    var slots = _ref.slots;
    var container = ref();
    var componentRef = ref();
    var rafId = ref();
    var scrollLocker = new ScrollLocker({
      container: getParent2(props2.getContainer)
    });
    var removeCurrentContainer = function removeCurrentContainer2() {
      var _a, _b;
      (_b = (_a = container.value) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(container.value);
    };
    var attachToParent = function attachToParent2() {
      var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      if (force || container.value && !container.value.parentNode) {
        var parent = getParent2(props2.getContainer);
        if (parent) {
          parent.appendChild(container.value);
          return true;
        }
        return false;
      }
      return true;
    };
    var getContainer4 = function getContainer5() {
      if (!supportDom) {
        return null;
      }
      if (!container.value) {
        container.value = document.createElement("div");
        attachToParent(true);
      }
      setWrapperClassName();
      return container.value;
    };
    var setWrapperClassName = function setWrapperClassName2() {
      var wrapperClassName = props2.wrapperClassName;
      if (container.value && wrapperClassName && wrapperClassName !== container.value.className) {
        container.value.className = wrapperClassName;
      }
    };
    onUpdated(function() {
      setWrapperClassName();
      attachToParent();
    });
    var switchScrolling = function switchScrolling2() {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        switchScrollingEffect();
        cacheOverflow = setStyle({
          overflow: "hidden",
          overflowX: "hidden",
          overflowY: "hidden"
        });
      } else if (!openCount) {
        setStyle(cacheOverflow);
        cacheOverflow = {};
        switchScrollingEffect(true);
      }
    };
    var instance = getCurrentInstance();
    onMounted(function() {
      var init = false;
      watch([function() {
        return props2.visible;
      }, function() {
        return props2.getContainer;
      }], function(_ref2, _ref3) {
        var _ref4 = _slicedToArray$2(_ref2, 2), visible = _ref4[0], getContainer5 = _ref4[1];
        var _ref5 = _slicedToArray$2(_ref3, 2), prevVisible = _ref5[0], prevGetContainer = _ref5[1];
        if (supportDom && getParent2(props2.getContainer) === document.body) {
          if (visible && !prevVisible) {
            openCount += 1;
          } else if (init) {
            openCount -= 1;
          }
        }
        if (init) {
          var getContainerIsFunc = typeof getContainer5 === "function" && typeof prevGetContainer === "function";
          if (getContainerIsFunc ? getContainer5.toString() !== prevGetContainer.toString() : getContainer5 !== prevGetContainer) {
            removeCurrentContainer();
          }
          if (visible && visible !== prevVisible && supportDom && getParent2(getContainer5) !== scrollLocker.getContainer()) {
            scrollLocker.reLock({
              container: getParent2(getContainer5)
            });
          }
        }
        init = true;
      }, {
        immediate: true,
        flush: "post"
      });
      nextTick(function() {
        if (!attachToParent()) {
          rafId.value = wrapperRaf(function() {
            instance.update();
          });
        }
      });
    });
    onBeforeUnmount(function() {
      var visible = props2.visible, getContainer5 = props2.getContainer;
      if (supportDom && getParent2(getContainer5) === document.body) {
        openCount = visible && openCount ? openCount - 1 : openCount;
      }
      removeCurrentContainer();
      wrapperRaf.cancel(rafId.value);
    });
    return function() {
      var forceRender = props2.forceRender, visible = props2.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount2() {
          return openCount;
        },
        getContainer: getContainer4,
        switchScrollingEffect: switchScrolling,
        scrollLocker
      };
      if (forceRender || visible || componentRef.value) {
        portal = createVNode(Portal$1, {
          "getContainer": getContainer4,
          "ref": componentRef
        }, {
          default: function _default3() {
            var _a;
            return (_a = slots.default) === null || _a === void 0 ? void 0 : _a.call(slots, childProps);
          }
        });
      }
      return portal;
    };
  }
});
function dialogPropTypes() {
  return {
    keyboard: {
      type: Boolean,
      default: void 0
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    afterClose: Function,
    closable: {
      type: Boolean,
      default: void 0
    },
    maskClosable: {
      type: Boolean,
      default: void 0
    },
    visible: {
      type: Boolean,
      default: void 0
    },
    destroyOnClose: {
      type: Boolean,
      default: void 0
    },
    mousePosition: PropTypes$1.shape({
      x: Number,
      y: Number
    }).loose,
    title: PropTypes$1.any,
    footer: PropTypes$1.any,
    transitionName: String,
    maskTransitionName: String,
    animation: PropTypes$1.any,
    maskAnimation: PropTypes$1.any,
    wrapStyle: {
      type: Object,
      default: void 0
    },
    bodyStyle: {
      type: Object,
      default: void 0
    },
    maskStyle: {
      type: Object,
      default: void 0
    },
    prefixCls: String,
    wrapClassName: String,
    rootClassName: String,
    width: [String, Number],
    height: [String, Number],
    zIndex: Number,
    bodyProps: PropTypes$1.any,
    maskProps: PropTypes$1.any,
    wrapProps: PropTypes$1.any,
    getContainer: PropTypes$1.any,
    dialogStyle: {
      type: Object,
      default: void 0
    },
    dialogClass: String,
    closeIcon: PropTypes$1.any,
    forceRender: {
      type: Boolean,
      default: void 0
    },
    getOpenCount: Function,
    focusTriggerAfterClose: {
      type: Boolean,
      default: void 0
    },
    onClose: Function,
    modalRender: Function
  };
}
function getMotionName(prefixCls, transitionName2, animationName) {
  var motionName = transitionName2;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }
  return motionName;
}
var uuid = -1;
function getUUID() {
  uuid += 1;
  return uuid;
}
function getScroll(w2, top) {
  var ret = w2["page".concat(top ? "Y" : "X", "Offset")];
  var method = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d2 = w2.document;
    ret = d2.documentElement[method];
    if (typeof ret !== "number") {
      ret = d2.body[method];
    }
  }
  return ret;
}
function offset2(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w2 = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w2);
  pos.top += getScroll(w2, true);
  return pos;
}
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
};
var Content = defineComponent({
  name: "Content",
  inheritAttrs: false,
  props: _extends(_extends({}, dialogPropTypes()), {
    motionName: String,
    ariaId: String,
    onVisibleChanged: Function,
    onMousedown: Function,
    onMouseup: Function
  }),
  setup: function setup52(props2, _ref) {
    var expose = _ref.expose, slots = _ref.slots, attrs = _ref.attrs;
    var sentinelStartRef = ref();
    var sentinelEndRef = ref();
    var dialogRef = ref();
    expose({
      focus: function focus() {
        var _a;
        (_a = sentinelStartRef.value) === null || _a === void 0 ? void 0 : _a.focus();
      },
      changeActive: function changeActive(next2) {
        var _document = document, activeElement = _document.activeElement;
        if (next2 && activeElement === sentinelEndRef.value) {
          sentinelStartRef.value.focus();
        } else if (!next2 && activeElement === sentinelStartRef.value) {
          sentinelEndRef.value.focus();
        }
      }
    });
    var transformOrigin = ref();
    var contentStyleRef = computed(function() {
      var width = props2.width, height = props2.height;
      var contentStyle = {};
      if (width !== void 0) {
        contentStyle.width = typeof width === "number" ? "".concat(width, "px") : width;
      }
      if (height !== void 0) {
        contentStyle.height = typeof height === "number" ? "".concat(height, "px") : height;
      }
      if (transformOrigin.value) {
        contentStyle.transformOrigin = transformOrigin.value;
      }
      return contentStyle;
    });
    var onPrepare = function onPrepare2() {
      nextTick(function() {
        if (dialogRef.value) {
          var elementOffset = offset2(dialogRef.value);
          transformOrigin.value = props2.mousePosition ? "".concat(props2.mousePosition.x - elementOffset.left, "px ").concat(props2.mousePosition.y - elementOffset.top, "px") : "";
        }
      });
    };
    var onVisibleChanged = function onVisibleChanged2(visible) {
      props2.onVisibleChanged(visible);
    };
    return function() {
      var _a, _b, _c, _d;
      var prefixCls = props2.prefixCls, _props$footer = props2.footer, footer = _props$footer === void 0 ? (_a = slots.footer) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$footer, _props$title = props2.title, title = _props$title === void 0 ? (_b = slots.title) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$title, ariaId = props2.ariaId, closable = props2.closable, _props$closeIcon = props2.closeIcon, closeIcon = _props$closeIcon === void 0 ? (_c = slots.closeIcon) === null || _c === void 0 ? void 0 : _c.call(slots) : _props$closeIcon, onClose = props2.onClose, bodyStyle = props2.bodyStyle, bodyProps = props2.bodyProps, onMousedown2 = props2.onMousedown, onMouseup = props2.onMouseup, visible = props2.visible, _props$modalRender = props2.modalRender, modalRender = _props$modalRender === void 0 ? slots.modalRender : _props$modalRender, destroyOnClose = props2.destroyOnClose, motionName = props2.motionName;
      var footerNode;
      if (footer) {
        footerNode = createVNode("div", {
          "class": "".concat(prefixCls, "-footer")
        }, [footer]);
      }
      var headerNode;
      if (title) {
        headerNode = createVNode("div", {
          "class": "".concat(prefixCls, "-header")
        }, [createVNode("div", {
          "class": "".concat(prefixCls, "-title"),
          "id": ariaId
        }, [title])]);
      }
      var closer;
      if (closable) {
        closer = createVNode("button", {
          "type": "button",
          "onClick": onClose,
          "aria-label": "Close",
          "class": "".concat(prefixCls, "-close")
        }, [closeIcon || createVNode("span", {
          "class": "".concat(prefixCls, "-close-x")
        }, null)]);
      }
      var content = createVNode("div", {
        "class": "".concat(prefixCls, "-content")
      }, [closer, headerNode, createVNode("div", _objectSpread2$1({
        "class": "".concat(prefixCls, "-body"),
        "style": bodyStyle
      }, bodyProps), [(_d = slots.default) === null || _d === void 0 ? void 0 : _d.call(slots)]), footerNode]);
      var transitionProps = getTransitionProps(motionName);
      return createVNode(Transition, _objectSpread2$1(_objectSpread2$1({}, transitionProps), {}, {
        "onBeforeEnter": onPrepare,
        "onAfterEnter": function onAfterEnter() {
          return onVisibleChanged(true);
        },
        "onAfterLeave": function onAfterLeave() {
          return onVisibleChanged(false);
        }
      }), {
        default: function _default3() {
          return [visible || !destroyOnClose ? withDirectives(createVNode("div", _objectSpread2$1(_objectSpread2$1({}, attrs), {}, {
            "ref": dialogRef,
            "key": "dialog-element",
            "role": "document",
            "style": [contentStyleRef.value, attrs.style],
            "class": [prefixCls, attrs.class],
            "onMousedown": onMousedown2,
            "onMouseup": onMouseup
          }), [createVNode("div", {
            "tabindex": 0,
            "ref": sentinelStartRef,
            "style": sentinelStyle,
            "aria-hidden": "true"
          }, null), modalRender ? modalRender({
            originVNode: content
          }) : content, createVNode("div", {
            "tabindex": 0,
            "ref": sentinelEndRef,
            "style": sentinelStyle,
            "aria-hidden": "true"
          }, null)]), [[vShow, visible]]) : null];
        }
      });
    };
  }
});
function _objectDestructuringEmpty(obj) {
  if (obj == null)
    throw new TypeError("Cannot destructure undefined");
}
var Mask = defineComponent({
  name: "Mask",
  props: {
    prefixCls: String,
    visible: Boolean,
    motionName: String,
    maskProps: Object
  },
  setup: function setup53(props2, _ref) {
    _objectDestructuringEmpty(_ref);
    return function() {
      var prefixCls = props2.prefixCls, visible = props2.visible, maskProps = props2.maskProps, motionName = props2.motionName;
      var transitionProps = getTransitionProps(motionName);
      return createVNode(Transition, transitionProps, {
        default: function _default3() {
          return [withDirectives(createVNode("div", _objectSpread2$1({
            "class": "".concat(prefixCls, "-mask")
          }, maskProps), null), [[vShow, visible]])];
        }
      });
    };
  }
});
var Dialog = defineComponent({
  name: "Dialog",
  inheritAttrs: false,
  props: initDefaultProps$1(_extends(_extends({}, dialogPropTypes()), {
    getOpenCount: Function,
    scrollLocker: Object
  }), {
    mask: true,
    visible: false,
    keyboard: true,
    closable: true,
    maskClosable: true,
    destroyOnClose: false,
    prefixCls: "rc-dialog",
    getOpenCount: function getOpenCount() {
      return null;
    },
    focusTriggerAfterClose: true
  }),
  setup: function setup54(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var lastOutSideActiveElementRef = ref();
    var wrapperRef = ref();
    var contentRef = ref();
    var animatedVisible = ref(props2.visible);
    var ariaIdRef = ref("vcDialogTitle".concat(getUUID()));
    var onDialogVisibleChanged = function onDialogVisibleChanged2(newVisible) {
      var _a, _b;
      if (newVisible) {
        if (!contains(wrapperRef.value, document.activeElement)) {
          lastOutSideActiveElementRef.value = document.activeElement;
          (_a = contentRef.value) === null || _a === void 0 ? void 0 : _a.focus();
        }
      } else {
        var preAnimatedVisible = animatedVisible.value;
        animatedVisible.value = false;
        if (props2.mask && lastOutSideActiveElementRef.value && props2.focusTriggerAfterClose) {
          try {
            lastOutSideActiveElementRef.value.focus({
              preventScroll: true
            });
          } catch (e2) {
          }
          lastOutSideActiveElementRef.value = null;
        }
        if (preAnimatedVisible) {
          (_b = props2.afterClose) === null || _b === void 0 ? void 0 : _b.call(props2);
        }
      }
    };
    var onInternalClose = function onInternalClose2(e2) {
      var _a;
      (_a = props2.onClose) === null || _a === void 0 ? void 0 : _a.call(props2, e2);
    };
    var contentClickRef = ref(false);
    var contentTimeoutRef = ref();
    var onContentMouseDown = function onContentMouseDown2() {
      clearTimeout(contentTimeoutRef.value);
      contentClickRef.value = true;
    };
    var onContentMouseUp = function onContentMouseUp2() {
      contentTimeoutRef.value = setTimeout(function() {
        contentClickRef.value = false;
      });
    };
    var onWrapperClick = function onWrapperClick2(e2) {
      if (!props2.maskClosable)
        return null;
      if (contentClickRef.value) {
        contentClickRef.value = false;
      } else if (wrapperRef.value === e2.target) {
        onInternalClose(e2);
      }
    };
    var onWrapperKeyDown = function onWrapperKeyDown2(e2) {
      if (props2.keyboard && e2.keyCode === KeyCode$1.ESC) {
        e2.stopPropagation();
        onInternalClose(e2);
        return;
      }
      if (props2.visible) {
        if (e2.keyCode === KeyCode$1.TAB) {
          contentRef.value.changeActive(!e2.shiftKey);
        }
      }
    };
    watch(function() {
      return props2.visible;
    }, function() {
      if (props2.visible) {
        animatedVisible.value = true;
      }
    }, {
      flush: "post"
    });
    onBeforeUnmount(function() {
      var _a;
      clearTimeout(contentTimeoutRef.value);
      (_a = props2.scrollLocker) === null || _a === void 0 ? void 0 : _a.unLock();
    });
    watchEffect(function() {
      var _a, _b;
      (_a = props2.scrollLocker) === null || _a === void 0 ? void 0 : _a.unLock();
      if (animatedVisible.value) {
        (_b = props2.scrollLocker) === null || _b === void 0 ? void 0 : _b.lock();
      }
    });
    return function() {
      var prefixCls = props2.prefixCls, mask = props2.mask, visible = props2.visible, maskTransitionName = props2.maskTransitionName, maskAnimation = props2.maskAnimation, zIndex = props2.zIndex, wrapClassName = props2.wrapClassName, rootClassName = props2.rootClassName, wrapStyle = props2.wrapStyle, closable = props2.closable, maskProps = props2.maskProps, maskStyle = props2.maskStyle, transitionName2 = props2.transitionName, animation = props2.animation, wrapProps = props2.wrapProps, _props$title = props2.title, title = _props$title === void 0 ? slots.title : _props$title;
      var style2 = attrs.style, className = attrs.class;
      return createVNode("div", _objectSpread2$1({
        "class": ["".concat(prefixCls, "-root"), rootClassName]
      }, pickAttrs(props2, {
        data: true
      })), [createVNode(Mask, {
        "prefixCls": prefixCls,
        "visible": mask && visible,
        "motionName": getMotionName(prefixCls, maskTransitionName, maskAnimation),
        "style": _extends({
          zIndex
        }, maskStyle),
        "maskProps": maskProps
      }, null), createVNode("div", _objectSpread2$1({
        "tabIndex": -1,
        "onKeydown": onWrapperKeyDown,
        "class": classNames("".concat(prefixCls, "-wrap"), wrapClassName),
        "ref": wrapperRef,
        "onClick": onWrapperClick,
        "role": "dialog",
        "aria-labelledby": title ? ariaIdRef.value : null,
        "style": _extends(_extends({
          zIndex
        }, wrapStyle), {
          display: !animatedVisible.value ? "none" : null
        })
      }, wrapProps), [createVNode(Content, _objectSpread2$1(_objectSpread2$1({}, omit(props2, ["scrollLocker"])), {}, {
        "style": style2,
        "class": className,
        "onMousedown": onContentMouseDown,
        "onMouseup": onContentMouseUp,
        "ref": contentRef,
        "closable": closable,
        "ariaId": ariaIdRef.value,
        "prefixCls": prefixCls,
        "visible": visible,
        "onClose": onInternalClose,
        "onVisibleChanged": onDialogVisibleChanged,
        "motionName": getMotionName(prefixCls, transitionName2, animation)
      }), slots)])]);
    };
  }
});
var IDialogPropTypes = dialogPropTypes();
var DialogWrap = defineComponent({
  name: "DialogWrap",
  inheritAttrs: false,
  props: initDefaultProps$1(IDialogPropTypes, {
    visible: false
  }),
  setup: function setup55(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    var animatedVisible = ref(props2.visible);
    useProvidePortal({}, {
      inTriggerContext: false
    });
    watch(function() {
      return props2.visible;
    }, function() {
      if (props2.visible) {
        animatedVisible.value = true;
      }
    }, {
      flush: "post"
    });
    return function() {
      var visible = props2.visible, getContainer4 = props2.getContainer, forceRender = props2.forceRender, _props$destroyOnClose = props2.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props2.afterClose;
      var dialogProps = _extends(_extends(_extends({}, props2), attrs), {
        ref: "_component",
        key: "dialog"
      });
      if (getContainer4 === false) {
        return createVNode(Dialog, _objectSpread2$1(_objectSpread2$1({}, dialogProps), {}, {
          "getOpenCount": function getOpenCount2() {
            return 2;
          }
        }), slots);
      }
      if (!forceRender && destroyOnClose && !animatedVisible.value) {
        return null;
      }
      return createVNode(Portal, {
        "visible": visible,
        "forceRender": forceRender,
        "getContainer": getContainer4
      }, {
        default: function _default3(childProps) {
          dialogProps = _extends(_extends(_extends({}, dialogProps), childProps), {
            afterClose: function afterClose() {
              _afterClose === null || _afterClose === void 0 ? void 0 : _afterClose();
              animatedVisible.value = false;
            }
          });
          return createVNode(Dialog, dialogProps, slots);
        }
      });
    };
  }
});
var DialogWrap$1 = DialogWrap;
var __rest$3 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var spinProps = function spinProps2() {
  return {
    prefixCls: String,
    spinning: {
      type: Boolean,
      default: void 0
    },
    size: String,
    wrapperClassName: String,
    tip: PropTypes$1.any,
    delay: Number,
    indicator: PropTypes$1.any
  };
};
var defaultIndicator = null;
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
function setDefaultIndicator(Content2) {
  var Indicator = Content2.indicator;
  defaultIndicator = typeof Indicator === "function" ? Indicator : function() {
    return createVNode(Indicator, null, null);
  };
}
var Spin = defineComponent({
  name: "ASpin",
  inheritAttrs: false,
  props: initDefaultProps$1(spinProps(), {
    size: "default",
    spinning: true,
    wrapperClassName: ""
  }),
  setup: function setup56() {
    return {
      originalUpdateSpinning: null,
      configProvider: inject("configProvider", defaultConfigProvider)
    };
  },
  data: function data2() {
    var spinning = this.spinning, delay = this.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    return {
      sSpinning: spinning && !shouldBeDelayed
    };
  },
  created: function created3() {
    this.originalUpdateSpinning = this.updateSpinning;
    this.debouncifyUpdateSpinning(this.$props);
  },
  mounted: function mounted3() {
    this.updateSpinning();
  },
  updated: function updated2() {
    var _this = this;
    nextTick(function() {
      _this.debouncifyUpdateSpinning();
      _this.updateSpinning();
    });
  },
  beforeUnmount: function beforeUnmount3() {
    this.cancelExistingSpin();
  },
  methods: {
    debouncifyUpdateSpinning: function debouncifyUpdateSpinning(props2) {
      var _ref = props2 || this.$props, delay = _ref.delay;
      if (delay) {
        this.cancelExistingSpin();
        this.updateSpinning = debounce(this.originalUpdateSpinning, delay);
      }
    },
    updateSpinning: function updateSpinning() {
      var spinning = this.spinning, sSpinning = this.sSpinning;
      if (sSpinning !== spinning) {
        this.sSpinning = spinning;
      }
    },
    cancelExistingSpin: function cancelExistingSpin() {
      var updateSpinning2 = this.updateSpinning;
      if (updateSpinning2 && updateSpinning2.cancel) {
        updateSpinning2.cancel();
      }
    },
    renderIndicator: function renderIndicator(prefixCls) {
      var dotClassName = "".concat(prefixCls, "-dot");
      var indicator = getComponent(this, "indicator");
      if (indicator === null) {
        return null;
      }
      if (Array.isArray(indicator)) {
        indicator = indicator.length === 1 ? indicator[0] : indicator;
      }
      if (isVNode(indicator)) {
        return cloneVNode(indicator, {
          class: dotClassName
        });
      }
      if (defaultIndicator && isVNode(defaultIndicator())) {
        return cloneVNode(defaultIndicator(), {
          class: dotClassName
        });
      }
      return createVNode("span", {
        "class": "".concat(dotClassName, " ").concat(prefixCls, "-dot-spin")
      }, [createVNode("i", {
        "class": "".concat(prefixCls, "-dot-item")
      }, null), createVNode("i", {
        "class": "".concat(prefixCls, "-dot-item")
      }, null), createVNode("i", {
        "class": "".concat(prefixCls, "-dot-item")
      }, null), createVNode("i", {
        "class": "".concat(prefixCls, "-dot-item")
      }, null)]);
    }
  },
  render: function render5() {
    var _spinClassName;
    var _a, _b;
    var _this$$props = this.$props, size = _this$$props.size, customizePrefixCls = _this$$props.prefixCls, _this$$props$tip = _this$$props.tip, tip = _this$$props$tip === void 0 ? (_b = (_a = this.$slots).tip) === null || _b === void 0 ? void 0 : _b.call(_a) : _this$$props$tip, wrapperClassName = _this$$props.wrapperClassName;
    var _c = this.$attrs, cls = _c.class, style2 = _c.style, divProps = __rest$3(_c, ["class", "style"]);
    var _this$configProvider = this.configProvider, getPrefixCls2 = _this$configProvider.getPrefixCls, direction = _this$configProvider.direction;
    var prefixCls = getPrefixCls2("spin", customizePrefixCls);
    var sSpinning = this.sSpinning;
    var spinClassName = (_spinClassName = {}, _defineProperty$m(_spinClassName, prefixCls, true), _defineProperty$m(_spinClassName, "".concat(prefixCls, "-sm"), size === "small"), _defineProperty$m(_spinClassName, "".concat(prefixCls, "-lg"), size === "large"), _defineProperty$m(_spinClassName, "".concat(prefixCls, "-spinning"), sSpinning), _defineProperty$m(_spinClassName, "".concat(prefixCls, "-show-text"), !!tip), _defineProperty$m(_spinClassName, "".concat(prefixCls, "-rtl"), direction === "rtl"), _defineProperty$m(_spinClassName, cls, !!cls), _spinClassName);
    var spinElement = createVNode("div", _objectSpread2$1(_objectSpread2$1({}, divProps), {}, {
      "style": style2,
      "class": spinClassName
    }), [this.renderIndicator(prefixCls), tip ? createVNode("div", {
      "class": "".concat(prefixCls, "-text")
    }, [tip]) : null]);
    var children = getSlot(this);
    if (children && children.length) {
      var _containerClassName;
      var containerClassName = (_containerClassName = {}, _defineProperty$m(_containerClassName, "".concat(prefixCls, "-container"), true), _defineProperty$m(_containerClassName, "".concat(prefixCls, "-blur"), sSpinning), _containerClassName);
      return createVNode("div", {
        "class": ["".concat(prefixCls, "-nested-loading"), wrapperClassName]
      }, [sSpinning && createVNode("div", {
        "key": "loading"
      }, [spinElement]), createVNode("div", {
        "class": containerClassName,
        "key": "container"
      }, [children])]);
    }
    return spinElement;
  }
});
Spin.setDefaultIndicator = setDefaultIndicator;
Spin.install = function(app) {
  app.component(Spin.name, Spin);
  return app;
};
var DoubleLeftOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
var DoubleLeftOutlinedSvg = DoubleLeftOutlined$2;
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty$1(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty$1(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DoubleLeftOutlined = function DoubleLeftOutlined2(props2, context) {
  var p = _objectSpread$1({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread$1({}, p, {
    "icon": DoubleLeftOutlinedSvg
  }), null);
};
DoubleLeftOutlined.displayName = "DoubleLeftOutlined";
DoubleLeftOutlined.inheritAttrs = false;
var DoubleLeftOutlined$1 = DoubleLeftOutlined;
var DoubleRightOutlined$2 = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
var DoubleRightOutlinedSvg = DoubleRightOutlined$2;
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key2) {
      _defineProperty(target, key2, source[key2]);
    });
  }
  return target;
}
function _defineProperty(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var DoubleRightOutlined = function DoubleRightOutlined2(props2, context) {
  var p = _objectSpread({}, props2, context.attrs);
  return createVNode(AntdIcon, _objectSpread({}, p, {
    "icon": DoubleRightOutlinedSvg
  }), null);
};
DoubleRightOutlined.displayName = "DoubleRightOutlined";
DoubleRightOutlined.inheritAttrs = false;
var DoubleRightOutlined$1 = DoubleRightOutlined;
var MiniSelect = defineComponent({
  inheritAttrs: false,
  props: selectProps(),
  Option: VcSelect.Option,
  setup: function setup57(props2, _ref) {
    var attrs = _ref.attrs, slots = _ref.slots;
    return function() {
      var selelctProps = _extends(_extends(_extends({}, props2), {
        size: "small"
      }), attrs);
      return createVNode(VcSelect, selelctProps, slots);
    };
  }
});
var Pager = defineComponent({
  name: "Pager",
  inheritAttrs: false,
  props: {
    rootPrefixCls: String,
    page: Number,
    active: {
      type: Boolean,
      default: void 0
    },
    last: {
      type: Boolean,
      default: void 0
    },
    locale: PropTypes$1.object,
    showTitle: {
      type: Boolean,
      default: void 0
    },
    itemRender: {
      type: Function,
      default: function _default2() {
      }
    },
    onClick: {
      type: Function
    },
    onKeypress: {
      type: Function
    }
  },
  eimt: ["click", "keypress"],
  setup: function setup58(props2, _ref) {
    var emit = _ref.emit, attrs = _ref.attrs;
    var handleClick = function handleClick2() {
      emit("click", props2.page);
    };
    var handleKeyPress = function handleKeyPress2(event) {
      emit("keypress", event, handleClick, props2.page);
    };
    return function() {
      var _classNames;
      var showTitle = props2.showTitle, page = props2.page, itemRender = props2.itemRender;
      var _cls = attrs.class, style2 = attrs.style;
      var prefixCls = "".concat(props2.rootPrefixCls, "-item");
      var cls = classNames(prefixCls, "".concat(prefixCls, "-").concat(props2.page), (_classNames = {}, _defineProperty$m(_classNames, "".concat(prefixCls, "-active"), props2.active), _defineProperty$m(_classNames, "".concat(prefixCls, "-disabled"), !props2.page), _classNames), _cls);
      return createVNode("li", {
        "onClick": handleClick,
        "onKeypress": handleKeyPress,
        "title": showTitle ? String(page) : null,
        "tabindex": "0",
        "class": cls,
        "style": style2
      }, [itemRender({
        page,
        type: "page",
        originalElement: createVNode("a", {
          "rel": "nofollow"
        }, [page])
      })]);
    };
  }
});
var KEYCODE = {
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
  BACKSPACE: 8,
  DELETE: 46,
  ENTER: 13,
  ARROW_UP: 38,
  ARROW_DOWN: 40
};
var Options = defineComponent({
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    changeSize: Function,
    quickGo: Function,
    selectComponentClass: PropTypes$1.any,
    current: Number,
    pageSizeOptions: PropTypes$1.array.def(["10", "20", "50", "100"]),
    pageSize: Number,
    buildOptionText: Function,
    locale: PropTypes$1.object,
    rootPrefixCls: String,
    selectPrefixCls: String,
    goButton: PropTypes$1.any
  },
  setup: function setup59(props2) {
    var goInputText = ref("");
    var validValue = computed(function() {
      return !goInputText.value || isNaN(goInputText.value) ? void 0 : Number(goInputText.value);
    });
    var defaultBuildOptionText = function defaultBuildOptionText2(opt) {
      return "".concat(opt.value, " ").concat(props2.locale.items_per_page);
    };
    var handleChange2 = function handleChange3(e2) {
      var _e$target = e2.target, value = _e$target.value, composing = _e$target.composing;
      if (e2.isComposing || composing || goInputText.value === value)
        return;
      goInputText.value = value;
    };
    var handleBlur = function handleBlur2(e2) {
      var goButton = props2.goButton, quickGo = props2.quickGo, rootPrefixCls = props2.rootPrefixCls;
      if (goButton || goInputText.value === "") {
        return;
      }
      if (e2.relatedTarget && (e2.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e2.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
        goInputText.value = "";
        return;
      } else {
        quickGo(validValue.value);
        goInputText.value = "";
      }
    };
    var go = function go2(e2) {
      if (goInputText.value === "") {
        return;
      }
      if (e2.keyCode === KEYCODE.ENTER || e2.type === "click") {
        props2.quickGo(validValue.value);
        goInputText.value = "";
      }
    };
    var pageSizeOptions = computed(function() {
      var pageSize2 = props2.pageSize, pageSizeOptions2 = props2.pageSizeOptions;
      if (pageSizeOptions2.some(function(option) {
        return option.toString() === pageSize2.toString();
      })) {
        return pageSizeOptions2;
      }
      return pageSizeOptions2.concat([pageSize2.toString()]).sort(function(a2, b2) {
        var numberA = isNaN(Number(a2)) ? 0 : Number(a2);
        var numberB = isNaN(Number(b2)) ? 0 : Number(b2);
        return numberA - numberB;
      });
    });
    return function() {
      var rootPrefixCls = props2.rootPrefixCls, locale2 = props2.locale, changeSize = props2.changeSize, quickGo = props2.quickGo, goButton = props2.goButton, Select2 = props2.selectComponentClass, selectPrefixCls = props2.selectPrefixCls, pageSize2 = props2.pageSize, disabled = props2.disabled;
      var prefixCls = "".concat(rootPrefixCls, "-options");
      var changeSelect = null;
      var goInput = null;
      var gotoButton = null;
      if (!changeSize && !quickGo) {
        return null;
      }
      if (changeSize && Select2) {
        var buildOptionText = props2.buildOptionText || defaultBuildOptionText;
        var options = pageSizeOptions.value.map(function(opt, i) {
          return createVNode(Select2.Option, {
            "key": i,
            "value": opt
          }, {
            default: function _default3() {
              return [buildOptionText({
                value: opt
              })];
            }
          });
        });
        changeSelect = createVNode(Select2, {
          "disabled": disabled,
          "prefixCls": selectPrefixCls,
          "showSearch": false,
          "class": "".concat(prefixCls, "-size-changer"),
          "optionLabelProp": "children",
          "value": (pageSize2 || pageSizeOptions.value[0]).toString(),
          "onChange": function onChange(value) {
            return changeSize(Number(value));
          },
          "getPopupContainer": function getPopupContainer(triggerNode) {
            return triggerNode.parentNode;
          }
        }, {
          default: function _default3() {
            return [options];
          }
        });
      }
      if (quickGo) {
        if (goButton) {
          gotoButton = typeof goButton === "boolean" ? createVNode("button", {
            "type": "button",
            "onClick": go,
            "onKeyup": go,
            "disabled": disabled,
            "class": "".concat(prefixCls, "-quick-jumper-button")
          }, [locale2.jump_to_confirm]) : createVNode("span", {
            "onClick": go,
            "onKeyup": go
          }, [goButton]);
        }
        goInput = createVNode("div", {
          "class": "".concat(prefixCls, "-quick-jumper")
        }, [locale2.jump_to, withDirectives(createVNode("input", {
          "disabled": disabled,
          "type": "text",
          "value": goInputText.value,
          "onInput": handleChange2,
          "onChange": handleChange2,
          "onKeyup": go,
          "onBlur": handleBlur
        }, null), [[antInputDirective]]), locale2.page, gotoButton]);
      }
      return createVNode("li", {
        "class": "".concat(prefixCls)
      }, [changeSelect, goInput]);
    };
  }
});
var LOCALE = {
  items_per_page: "\u6761/\u9875",
  jump_to: "\u8DF3\u81F3",
  jump_to_confirm: "\u786E\u5B9A",
  page: "\u9875",
  prev_page: "\u4E0A\u4E00\u9875",
  next_page: "\u4E0B\u4E00\u9875",
  prev_5: "\u5411\u524D 5 \u9875",
  next_5: "\u5411\u540E 5 \u9875",
  prev_3: "\u5411\u524D 3 \u9875",
  next_3: "\u5411\u540E 3 \u9875"
};
var __rest$2 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
function isInteger(value) {
  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function defaultItemRender(_ref) {
  var originalElement = _ref.originalElement;
  return originalElement;
}
function calculatePage(p, state, props2) {
  var pageSize2 = typeof p === "undefined" ? state.statePageSize : p;
  return Math.floor((props2.total - 1) / pageSize2) + 1;
}
var VcPagination = defineComponent({
  name: "Pagination",
  mixins: [BaseMixin],
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: void 0
    },
    prefixCls: PropTypes$1.string.def("rc-pagination"),
    selectPrefixCls: PropTypes$1.string.def("rc-select"),
    current: Number,
    defaultCurrent: PropTypes$1.number.def(1),
    total: PropTypes$1.number.def(0),
    pageSize: Number,
    defaultPageSize: PropTypes$1.number.def(10),
    hideOnSinglePage: {
      type: Boolean,
      default: false
    },
    showSizeChanger: {
      type: Boolean,
      default: void 0
    },
    showLessItems: {
      type: Boolean,
      default: false
    },
    selectComponentClass: PropTypes$1.any,
    showPrevNextJumpers: {
      type: Boolean,
      default: true
    },
    showQuickJumper: PropTypes$1.oneOfType([PropTypes$1.looseBool, PropTypes$1.object]).def(false),
    showTitle: {
      type: Boolean,
      default: true
    },
    pageSizeOptions: PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string])),
    buildOptionText: Function,
    showTotal: Function,
    simple: {
      type: Boolean,
      default: void 0
    },
    locale: PropTypes$1.object.def(LOCALE),
    itemRender: PropTypes$1.func.def(defaultItemRender),
    prevIcon: PropTypes$1.any,
    nextIcon: PropTypes$1.any,
    jumpPrevIcon: PropTypes$1.any,
    jumpNextIcon: PropTypes$1.any,
    totalBoundaryShowSizeChanger: PropTypes$1.number.def(50)
  },
  data: function data3() {
    var props2 = this.$props;
    var current2 = firstNotUndefined([this.current, this.defaultCurrent]);
    var pageSize2 = firstNotUndefined([this.pageSize, this.defaultPageSize]);
    current2 = Math.min(current2, calculatePage(pageSize2, void 0, props2));
    return {
      stateCurrent: current2,
      stateCurrentInputValue: current2,
      statePageSize: pageSize2
    };
  },
  watch: {
    current: function current(val) {
      this.setState({
        stateCurrent: val,
        stateCurrentInputValue: val
      });
    },
    pageSize: function pageSize(val) {
      var newState = {};
      var current2 = this.stateCurrent;
      var newCurrent = calculatePage(val, this.$data, this.$props);
      current2 = current2 > newCurrent ? newCurrent : current2;
      if (!hasProp(this, "current")) {
        newState.stateCurrent = current2;
        newState.stateCurrentInputValue = current2;
      }
      newState.statePageSize = val;
      this.setState(newState);
    },
    stateCurrent: function stateCurrent(_val, oldValue) {
      var _this = this;
      this.$nextTick(function() {
        if (_this.$refs.paginationNode) {
          var lastCurrentNode = _this.$refs.paginationNode.querySelector(".".concat(_this.prefixCls, "-item-").concat(oldValue));
          if (lastCurrentNode && document.activeElement === lastCurrentNode) {
            lastCurrentNode.blur();
          }
        }
      });
    },
    total: function total() {
      var newState = {};
      var newCurrent = calculatePage(this.pageSize, this.$data, this.$props);
      if (hasProp(this, "current")) {
        var current2 = Math.min(this.current, newCurrent);
        newState.stateCurrent = current2;
        newState.stateCurrentInputValue = current2;
      } else {
        var _current = this.stateCurrent;
        if (_current === 0 && newCurrent > 0) {
          _current = 1;
        } else {
          _current = Math.min(this.stateCurrent, newCurrent);
        }
        newState.stateCurrent = _current;
      }
      this.setState(newState);
    }
  },
  methods: {
    getJumpPrevPage: function getJumpPrevPage() {
      return Math.max(1, this.stateCurrent - (this.showLessItems ? 3 : 5));
    },
    getJumpNextPage: function getJumpNextPage() {
      return Math.min(calculatePage(void 0, this.$data, this.$props), this.stateCurrent + (this.showLessItems ? 3 : 5));
    },
    getItemIcon: function getItemIcon(icon, label) {
      var prefixCls = this.$props.prefixCls;
      var iconNode = getComponent(this, icon, this.$props) || createVNode("button", {
        "type": "button",
        "aria-label": label,
        "class": "".concat(prefixCls, "-item-link")
      }, null);
      return iconNode;
    },
    getValidValue: function getValidValue(e2) {
      var inputValue = e2.target.value;
      var allPages = calculatePage(void 0, this.$data, this.$props);
      var stateCurrentInputValue = this.$data.stateCurrentInputValue;
      var value;
      if (inputValue === "") {
        value = inputValue;
      } else if (isNaN(Number(inputValue))) {
        value = stateCurrentInputValue;
      } else if (inputValue >= allPages) {
        value = allPages;
      } else {
        value = Number(inputValue);
      }
      return value;
    },
    isValid: function isValid3(page) {
      return isInteger(page) && page !== this.stateCurrent;
    },
    shouldDisplayQuickJumper: function shouldDisplayQuickJumper() {
      var _this$$props = this.$props, showQuickJumper = _this$$props.showQuickJumper, pageSize2 = _this$$props.pageSize, total2 = _this$$props.total;
      if (total2 <= pageSize2) {
        return false;
      }
      return showQuickJumper;
    },
    handleKeyDown: function handleKeyDown(event) {
      if (event.keyCode === KEYCODE.ARROW_UP || event.keyCode === KEYCODE.ARROW_DOWN) {
        event.preventDefault();
      }
    },
    handleKeyUp: function handleKeyUp(e2) {
      if (e2.isComposing || e2.target.composing)
        return;
      var value = this.getValidValue(e2);
      var stateCurrentInputValue = this.stateCurrentInputValue;
      if (value !== stateCurrentInputValue) {
        this.setState({
          stateCurrentInputValue: value
        });
      }
      if (e2.keyCode === KEYCODE.ENTER) {
        this.handleChange(value);
      } else if (e2.keyCode === KEYCODE.ARROW_UP) {
        this.handleChange(value - 1);
      } else if (e2.keyCode === KEYCODE.ARROW_DOWN) {
        this.handleChange(value + 1);
      }
    },
    changePageSize: function changePageSize(size) {
      var current2 = this.stateCurrent;
      var preCurrent = current2;
      var newCurrent = calculatePage(size, this.$data, this.$props);
      current2 = current2 > newCurrent ? newCurrent : current2;
      if (newCurrent === 0) {
        current2 = this.stateCurrent;
      }
      if (typeof size === "number") {
        if (!hasProp(this, "pageSize")) {
          this.setState({
            statePageSize: size
          });
        }
        if (!hasProp(this, "current")) {
          this.setState({
            stateCurrent: current2,
            stateCurrentInputValue: current2
          });
        }
      }
      this.__emit("update:pageSize", size);
      if (current2 !== preCurrent) {
        this.__emit("update:current", current2);
      }
      this.__emit("showSizeChange", current2, size);
      this.__emit("change", current2, size);
    },
    handleChange: function handleChange(p) {
      var disabled = this.$props.disabled;
      var page = p;
      if (this.isValid(page) && !disabled) {
        var currentPage = calculatePage(void 0, this.$data, this.$props);
        if (page > currentPage) {
          page = currentPage;
        } else if (page < 1) {
          page = 1;
        }
        if (!hasProp(this, "current")) {
          this.setState({
            stateCurrent: page,
            stateCurrentInputValue: page
          });
        }
        this.__emit("update:current", page);
        this.__emit("change", page, this.statePageSize);
        return page;
      }
      return this.stateCurrent;
    },
    prev: function prev() {
      if (this.hasPrev()) {
        this.handleChange(this.stateCurrent - 1);
      }
    },
    next: function next() {
      if (this.hasNext()) {
        this.handleChange(this.stateCurrent + 1);
      }
    },
    jumpPrev: function jumpPrev() {
      this.handleChange(this.getJumpPrevPage());
    },
    jumpNext: function jumpNext() {
      this.handleChange(this.getJumpNextPage());
    },
    hasPrev: function hasPrev() {
      return this.stateCurrent > 1;
    },
    hasNext: function hasNext() {
      return this.stateCurrent < calculatePage(void 0, this.$data, this.$props);
    },
    getShowSizeChanger: function getShowSizeChanger() {
      var _this$$props2 = this.$props, showSizeChanger = _this$$props2.showSizeChanger, total2 = _this$$props2.total, totalBoundaryShowSizeChanger = _this$$props2.totalBoundaryShowSizeChanger;
      if (typeof showSizeChanger !== "undefined") {
        return showSizeChanger;
      }
      return total2 > totalBoundaryShowSizeChanger;
    },
    runIfEnter: function runIfEnter(event, callback) {
      if (event.key === "Enter" || event.charCode === 13) {
        for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          restParams[_key - 2] = arguments[_key];
        }
        callback.apply(void 0, restParams);
      }
    },
    runIfEnterPrev: function runIfEnterPrev(event) {
      this.runIfEnter(event, this.prev);
    },
    runIfEnterNext: function runIfEnterNext(event) {
      this.runIfEnter(event, this.next);
    },
    runIfEnterJumpPrev: function runIfEnterJumpPrev(event) {
      this.runIfEnter(event, this.jumpPrev);
    },
    runIfEnterJumpNext: function runIfEnterJumpNext(event) {
      this.runIfEnter(event, this.jumpNext);
    },
    handleGoTO: function handleGoTO(event) {
      if (event.keyCode === KEYCODE.ENTER || event.type === "click") {
        this.handleChange(this.stateCurrentInputValue);
      }
    },
    renderPrev: function renderPrev(prevPage) {
      var itemRender = this.$props.itemRender;
      var prevButton = itemRender({
        page: prevPage,
        type: "prev",
        originalElement: this.getItemIcon("prevIcon", "prev page")
      });
      var disabled = !this.hasPrev();
      return isValidElement(prevButton) ? cloneElement(prevButton, disabled ? {
        disabled
      } : {}) : prevButton;
    },
    renderNext: function renderNext(nextPage) {
      var itemRender = this.$props.itemRender;
      var nextButton = itemRender({
        page: nextPage,
        type: "next",
        originalElement: this.getItemIcon("nextIcon", "next page")
      });
      var disabled = !this.hasNext();
      return isValidElement(nextButton) ? cloneElement(nextButton, disabled ? {
        disabled
      } : {}) : nextButton;
    }
  },
  render: function render6() {
    var _classNames6;
    var _this$$props3 = this.$props, prefixCls = _this$$props3.prefixCls, disabled = _this$$props3.disabled, hideOnSinglePage = _this$$props3.hideOnSinglePage, total2 = _this$$props3.total, locale2 = _this$$props3.locale, showQuickJumper = _this$$props3.showQuickJumper, showLessItems = _this$$props3.showLessItems, showTitle = _this$$props3.showTitle, showTotal = _this$$props3.showTotal, simple = _this$$props3.simple, itemRender = _this$$props3.itemRender, showPrevNextJumpers = _this$$props3.showPrevNextJumpers, jumpPrevIcon = _this$$props3.jumpPrevIcon, jumpNextIcon = _this$$props3.jumpNextIcon, selectComponentClass = _this$$props3.selectComponentClass, selectPrefixCls = _this$$props3.selectPrefixCls, pageSizeOptions = _this$$props3.pageSizeOptions;
    var stateCurrent2 = this.stateCurrent, statePageSize = this.statePageSize;
    var _a = splitAttrs(this.$attrs).extraAttrs, className = _a.class, restAttrs = __rest$2(_a, ["class"]);
    if (hideOnSinglePage === true && this.total <= statePageSize) {
      return null;
    }
    var allPages = calculatePage(void 0, this.$data, this.$props);
    var pagerList = [];
    var jumpPrev2 = null;
    var jumpNext2 = null;
    var firstPager = null;
    var lastPager = null;
    var gotoButton = null;
    var goButton = showQuickJumper && showQuickJumper.goButton;
    var pageBufferSize = showLessItems ? 1 : 2;
    var prevPage = stateCurrent2 - 1 > 0 ? stateCurrent2 - 1 : 0;
    var nextPage = stateCurrent2 + 1 < allPages ? stateCurrent2 + 1 : allPages;
    var hasPrev2 = this.hasPrev();
    var hasNext2 = this.hasNext();
    if (simple) {
      if (goButton) {
        if (typeof goButton === "boolean") {
          gotoButton = createVNode("button", {
            "type": "button",
            "onClick": this.handleGoTO,
            "onKeyup": this.handleGoTO
          }, [locale2.jump_to_confirm]);
        } else {
          gotoButton = createVNode("span", {
            "onClick": this.handleGoTO,
            "onKeyup": this.handleGoTO
          }, [goButton]);
        }
        gotoButton = createVNode("li", {
          "title": showTitle ? "".concat(locale2.jump_to).concat(stateCurrent2, "/").concat(allPages) : null,
          "class": "".concat(prefixCls, "-simple-pager")
        }, [gotoButton]);
      }
      return createVNode("ul", _objectSpread2$1({
        "class": classNames("".concat(prefixCls, " ").concat(prefixCls, "-simple"), _defineProperty$m({}, "".concat(prefixCls, "-disabled"), disabled), className)
      }, restAttrs), [createVNode("li", {
        "title": showTitle ? locale2.prev_page : null,
        "onClick": this.prev,
        "tabindex": hasPrev2 ? 0 : null,
        "onKeypress": this.runIfEnterPrev,
        "class": classNames("".concat(prefixCls, "-prev"), _defineProperty$m({}, "".concat(prefixCls, "-disabled"), !hasPrev2)),
        "aria-disabled": !hasPrev2
      }, [this.renderPrev(prevPage)]), createVNode("li", {
        "title": showTitle ? "".concat(stateCurrent2, "/").concat(allPages) : null,
        "class": "".concat(prefixCls, "-simple-pager")
      }, [withDirectives(createVNode("input", {
        "type": "text",
        "value": this.stateCurrentInputValue,
        "disabled": disabled,
        "onKeydown": this.handleKeyDown,
        "onKeyup": this.handleKeyUp,
        "onInput": this.handleKeyUp,
        "onChange": this.handleKeyUp,
        "size": "3"
      }, null), [[antInputDirective]]), createVNode("span", {
        "class": "".concat(prefixCls, "-slash")
      }, [createTextVNode("\uFF0F")]), allPages]), createVNode("li", {
        "title": showTitle ? locale2.next_page : null,
        "onClick": this.next,
        "tabindex": hasNext2 ? 0 : null,
        "onKeypress": this.runIfEnterNext,
        "class": classNames("".concat(prefixCls, "-next"), _defineProperty$m({}, "".concat(prefixCls, "-disabled"), !hasNext2)),
        "aria-disabled": !hasNext2
      }, [this.renderNext(nextPage)]), gotoButton]);
    }
    if (allPages <= 3 + pageBufferSize * 2) {
      var pagerProps = {
        locale: locale2,
        rootPrefixCls: prefixCls,
        showTitle,
        itemRender,
        onClick: this.handleChange,
        onKeypress: this.runIfEnter
      };
      if (!allPages) {
        pagerList.push(createVNode(Pager, _objectSpread2$1(_objectSpread2$1({}, pagerProps), {}, {
          "key": "noPager",
          "page": 1,
          "class": "".concat(prefixCls, "-item-disabled")
        }), null));
      }
      for (var i = 1; i <= allPages; i += 1) {
        var active = stateCurrent2 === i;
        pagerList.push(createVNode(Pager, _objectSpread2$1(_objectSpread2$1({}, pagerProps), {}, {
          "key": i,
          "page": i,
          "active": active
        }), null));
      }
    } else {
      var prevItemTitle = showLessItems ? locale2.prev_3 : locale2.prev_5;
      var nextItemTitle = showLessItems ? locale2.next_3 : locale2.next_5;
      if (showPrevNextJumpers) {
        jumpPrev2 = createVNode("li", {
          "title": this.showTitle ? prevItemTitle : null,
          "key": "prev",
          "onClick": this.jumpPrev,
          "tabindex": "0",
          "onKeypress": this.runIfEnterJumpPrev,
          "class": classNames("".concat(prefixCls, "-jump-prev"), _defineProperty$m({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
        }, [itemRender({
          page: this.getJumpPrevPage(),
          type: "jump-prev",
          originalElement: this.getItemIcon("jumpPrevIcon", "prev page")
        })]);
        jumpNext2 = createVNode("li", {
          "title": this.showTitle ? nextItemTitle : null,
          "key": "next",
          "tabindex": "0",
          "onClick": this.jumpNext,
          "onKeypress": this.runIfEnterJumpNext,
          "class": classNames("".concat(prefixCls, "-jump-next"), _defineProperty$m({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
        }, [itemRender({
          page: this.getJumpNextPage(),
          type: "jump-next",
          originalElement: this.getItemIcon("jumpNextIcon", "next page")
        })]);
      }
      lastPager = createVNode(Pager, {
        "locale": locale2,
        "last": true,
        "rootPrefixCls": prefixCls,
        "onClick": this.handleChange,
        "onKeypress": this.runIfEnter,
        "key": allPages,
        "page": allPages,
        "active": false,
        "showTitle": showTitle,
        "itemRender": itemRender
      }, null);
      firstPager = createVNode(Pager, {
        "locale": locale2,
        "rootPrefixCls": prefixCls,
        "onClick": this.handleChange,
        "onKeypress": this.runIfEnter,
        "key": 1,
        "page": 1,
        "active": false,
        "showTitle": showTitle,
        "itemRender": itemRender
      }, null);
      var left = Math.max(1, stateCurrent2 - pageBufferSize);
      var right = Math.min(stateCurrent2 + pageBufferSize, allPages);
      if (stateCurrent2 - 1 <= pageBufferSize) {
        right = 1 + pageBufferSize * 2;
      }
      if (allPages - stateCurrent2 <= pageBufferSize) {
        left = allPages - pageBufferSize * 2;
      }
      for (var _i = left; _i <= right; _i += 1) {
        var _active = stateCurrent2 === _i;
        pagerList.push(createVNode(Pager, {
          "locale": locale2,
          "rootPrefixCls": prefixCls,
          "onClick": this.handleChange,
          "onKeypress": this.runIfEnter,
          "key": _i,
          "page": _i,
          "active": _active,
          "showTitle": showTitle,
          "itemRender": itemRender
        }, null));
      }
      if (stateCurrent2 - 1 >= pageBufferSize * 2 && stateCurrent2 !== 1 + 2) {
        pagerList[0] = createVNode(Pager, {
          "locale": locale2,
          "rootPrefixCls": prefixCls,
          "onClick": this.handleChange,
          "onKeypress": this.runIfEnter,
          "key": left,
          "page": left,
          "class": "".concat(prefixCls, "-item-after-jump-prev"),
          "active": false,
          "showTitle": this.showTitle,
          "itemRender": itemRender
        }, null);
        pagerList.unshift(jumpPrev2);
      }
      if (allPages - stateCurrent2 >= pageBufferSize * 2 && stateCurrent2 !== allPages - 2) {
        pagerList[pagerList.length - 1] = createVNode(Pager, {
          "locale": locale2,
          "rootPrefixCls": prefixCls,
          "onClick": this.handleChange,
          "onKeypress": this.runIfEnter,
          "key": right,
          "page": right,
          "class": "".concat(prefixCls, "-item-before-jump-next"),
          "active": false,
          "showTitle": this.showTitle,
          "itemRender": itemRender
        }, null);
        pagerList.push(jumpNext2);
      }
      if (left !== 1) {
        pagerList.unshift(firstPager);
      }
      if (right !== allPages) {
        pagerList.push(lastPager);
      }
    }
    var totalText = null;
    if (showTotal) {
      totalText = createVNode("li", {
        "class": "".concat(prefixCls, "-total-text")
      }, [showTotal(total2, [total2 === 0 ? 0 : (stateCurrent2 - 1) * statePageSize + 1, stateCurrent2 * statePageSize > total2 ? total2 : stateCurrent2 * statePageSize])]);
    }
    var prevDisabled = !hasPrev2 || !allPages;
    var nextDisabled = !hasNext2 || !allPages;
    var buildOptionText = this.buildOptionText || this.$slots.buildOptionText;
    return createVNode("ul", _objectSpread2$1(_objectSpread2$1({
      "unselectable": "on",
      "ref": "paginationNode"
    }, restAttrs), {}, {
      "class": classNames((_classNames6 = {}, _defineProperty$m(_classNames6, "".concat(prefixCls), true), _defineProperty$m(_classNames6, "".concat(prefixCls, "-disabled"), disabled), _classNames6), className)
    }), [totalText, createVNode("li", {
      "title": showTitle ? locale2.prev_page : null,
      "onClick": this.prev,
      "tabindex": prevDisabled ? null : 0,
      "onKeypress": this.runIfEnterPrev,
      "class": classNames("".concat(prefixCls, "-prev"), _defineProperty$m({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
      "aria-disabled": prevDisabled
    }, [this.renderPrev(prevPage)]), pagerList, createVNode("li", {
      "title": showTitle ? locale2.next_page : null,
      "onClick": this.next,
      "tabindex": nextDisabled ? null : 0,
      "onKeypress": this.runIfEnterNext,
      "class": classNames("".concat(prefixCls, "-next"), _defineProperty$m({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
      "aria-disabled": nextDisabled
    }, [this.renderNext(nextPage)]), createVNode(Options, {
      "disabled": disabled,
      "locale": locale2,
      "rootPrefixCls": prefixCls,
      "selectComponentClass": selectComponentClass,
      "selectPrefixCls": selectPrefixCls,
      "changeSize": this.getShowSizeChanger() ? this.changePageSize : null,
      "current": stateCurrent2,
      "pageSize": statePageSize,
      "pageSizeOptions": pageSizeOptions,
      "buildOptionText": buildOptionText || null,
      "quickGo": this.shouldDisplayQuickJumper() ? this.handleChange : null,
      "goButton": goButton
    }, null)]);
  }
});
var __rest$1 = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var paginationProps = function paginationProps2() {
  return {
    total: Number,
    defaultCurrent: Number,
    disabled: {
      type: Boolean,
      default: void 0
    },
    current: Number,
    defaultPageSize: Number,
    pageSize: Number,
    hideOnSinglePage: {
      type: Boolean,
      default: void 0
    },
    showSizeChanger: {
      type: Boolean,
      default: void 0
    },
    pageSizeOptions: Array,
    buildOptionText: Function,
    showQuickJumper: {
      type: [Boolean, Object],
      default: void 0
    },
    showTotal: Function,
    size: String,
    simple: {
      type: Boolean,
      default: void 0
    },
    locale: Object,
    prefixCls: String,
    selectPrefixCls: String,
    totalBoundaryShowSizeChanger: Number,
    selectComponentClass: String,
    itemRender: Function,
    role: String,
    responsive: Boolean,
    showLessItems: {
      type: Boolean,
      default: void 0
    },
    onChange: Function,
    onShowSizeChange: Function,
    "onUpdate:current": Function,
    "onUpdate:pageSize": Function
  };
};
var Pagination$1 = defineComponent({
  name: "APagination",
  inheritAttrs: false,
  props: paginationProps(),
  setup: function setup60(props2, _ref) {
    var slots = _ref.slots, attrs = _ref.attrs;
    var _useConfigInject = useConfigInject("pagination", props2), prefixCls = _useConfigInject.prefixCls, configProvider = _useConfigInject.configProvider, direction = _useConfigInject.direction;
    var selectPrefixCls = computed(function() {
      return configProvider.getPrefixCls("select", props2.selectPrefixCls);
    });
    var breakpoint = useBreakpoint();
    var _useLocaleReceiver = useLocaleReceiver("Pagination", enUS$1, toRef(props2, "locale")), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    var getIconsProps = function getIconsProps2(pre) {
      var ellipsis = createVNode("span", {
        "class": "".concat(pre, "-item-ellipsis")
      }, [createTextVNode("\u2022\u2022\u2022")]);
      var prevIcon = createVNode("button", {
        "class": "".concat(pre, "-item-link"),
        "type": "button",
        "tabindex": -1
      }, [createVNode(LeftOutlined$1, null, null)]);
      var nextIcon = createVNode("button", {
        "class": "".concat(pre, "-item-link"),
        "type": "button",
        "tabindex": -1
      }, [createVNode(RightOutlined$1, null, null)]);
      var jumpPrevIcon = createVNode("a", {
        "rel": "nofollow",
        "class": "".concat(pre, "-item-link")
      }, [createVNode("div", {
        "class": "".concat(pre, "-item-container")
      }, [createVNode(DoubleLeftOutlined$1, {
        "class": "".concat(pre, "-item-link-icon")
      }, null), ellipsis])]);
      var jumpNextIcon = createVNode("a", {
        "rel": "nofollow",
        "class": "".concat(pre, "-item-link")
      }, [createVNode("div", {
        "class": "".concat(pre, "-item-container")
      }, [createVNode(DoubleRightOutlined$1, {
        "class": "".concat(pre, "-item-link-icon")
      }, null), ellipsis])]);
      if (direction.value === "rtl") {
        var _ref2 = [nextIcon, prevIcon];
        prevIcon = _ref2[0];
        nextIcon = _ref2[1];
        var _ref3 = [jumpNextIcon, jumpPrevIcon];
        jumpPrevIcon = _ref3[0];
        jumpNextIcon = _ref3[1];
      }
      return {
        prevIcon,
        nextIcon,
        jumpPrevIcon,
        jumpNextIcon
      };
    };
    return function() {
      var _a;
      var size = props2.size, _props$itemRender = props2.itemRender, itemRender = _props$itemRender === void 0 ? slots.itemRender : _props$itemRender, _props$buildOptionTex = props2.buildOptionText, buildOptionText = _props$buildOptionTex === void 0 ? slots.buildOptionText : _props$buildOptionTex, selectComponentClass = props2.selectComponentClass, responsive = props2.responsive, restProps = __rest$1(props2, ["size", "itemRender", "buildOptionText", "selectComponentClass", "responsive"]);
      var isSmall = size === "small" || !!(((_a = breakpoint.value) === null || _a === void 0 ? void 0 : _a.xs) && !size && responsive);
      var paginationProps3 = _extends(_extends(_extends(_extends(_extends({}, restProps), getIconsProps(prefixCls.value)), {
        prefixCls: prefixCls.value,
        selectPrefixCls: selectPrefixCls.value,
        selectComponentClass: selectComponentClass || (isSmall ? MiniSelect : VcSelect),
        locale: locale2.value,
        buildOptionText
      }), attrs), {
        class: classNames(_defineProperty$m({
          mini: isSmall
        }, "".concat(prefixCls.value, "-rtl"), direction.value === "rtl"), attrs.class),
        itemRender
      });
      return createVNode(VcPagination, paginationProps3, null);
    };
  }
});
var Pagination = withInstall(Pagination$1);
var __rest = globalThis && globalThis.__rest || function(s2, e2) {
  var t2 = {};
  for (var p in s2) {
    if (Object.prototype.hasOwnProperty.call(s2, p) && e2.indexOf(p) < 0)
      t2[p] = s2[p];
  }
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e2.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t2[p[i]] = s2[p[i]];
    }
  return t2;
};
var mousePosition = null;
var getClickPosition = function getClickPosition2(e2) {
  mousePosition = {
    x: e2.pageX,
    y: e2.pageY
  };
  setTimeout(function() {
    return mousePosition = null;
  }, 100);
};
if (canUseDocElement()) {
  addEventListenerWrap(document.documentElement, "click", getClickPosition, true);
}
var modalProps = function modalProps2() {
  return {
    prefixCls: String,
    visible: {
      type: Boolean,
      default: void 0
    },
    confirmLoading: {
      type: Boolean,
      default: void 0
    },
    title: PropTypes$1.any,
    closable: {
      type: Boolean,
      default: void 0
    },
    closeIcon: PropTypes$1.any,
    onOk: Function,
    onCancel: Function,
    "onUpdate:visible": Function,
    onChange: Function,
    afterClose: Function,
    centered: {
      type: Boolean,
      default: void 0
    },
    width: [String, Number],
    footer: PropTypes$1.any,
    okText: PropTypes$1.any,
    okType: String,
    cancelText: PropTypes$1.any,
    icon: PropTypes$1.any,
    maskClosable: {
      type: Boolean,
      default: void 0
    },
    forceRender: {
      type: Boolean,
      default: void 0
    },
    okButtonProps: Object,
    cancelButtonProps: Object,
    destroyOnClose: {
      type: Boolean,
      default: void 0
    },
    wrapClassName: String,
    maskTransitionName: String,
    transitionName: String,
    getContainer: {
      type: [String, Function, Boolean, Object],
      default: void 0
    },
    zIndex: Number,
    bodyStyle: {
      type: Object,
      default: void 0
    },
    maskStyle: {
      type: Object,
      default: void 0
    },
    mask: {
      type: Boolean,
      default: void 0
    },
    keyboard: {
      type: Boolean,
      default: void 0
    },
    wrapProps: Object,
    focusTriggerAfterClose: {
      type: Boolean,
      default: void 0
    },
    modalRender: Function
  };
};
var destroyFns = [];
var Modal = defineComponent({
  name: "AModal",
  inheritAttrs: false,
  props: initDefaultProps$1(modalProps(), {
    width: 520,
    transitionName: "zoom",
    maskTransitionName: "fade",
    confirmLoading: false,
    visible: false,
    okType: "primary"
  }),
  setup: function setup61(props2, _ref) {
    var emit = _ref.emit, slots = _ref.slots, attrs = _ref.attrs;
    var _useLocaleReceiver = useLocaleReceiver("Modal"), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    var _useConfigInject = useConfigInject("modal", props2), prefixCls = _useConfigInject.prefixCls, rootPrefixCls = _useConfigInject.rootPrefixCls, direction = _useConfigInject.direction, getPopupContainer = _useConfigInject.getPopupContainer;
    var handleCancel = function handleCancel2(e2) {
      emit("update:visible", false);
      emit("cancel", e2);
      emit("change", false);
    };
    var handleOk = function handleOk2(e2) {
      emit("ok", e2);
    };
    var renderFooter = function renderFooter2() {
      var _a, _b;
      var _props$okText = props2.okText, okText = _props$okText === void 0 ? (_a = slots.okText) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$okText, okType = props2.okType, _props$cancelText = props2.cancelText, cancelText = _props$cancelText === void 0 ? (_b = slots.cancelText) === null || _b === void 0 ? void 0 : _b.call(slots) : _props$cancelText, confirmLoading = props2.confirmLoading;
      return createVNode(Fragment, null, [createVNode(Button, _objectSpread2$1({
        "onClick": handleCancel
      }, props2.cancelButtonProps), {
        default: function _default3() {
          return [cancelText || locale2.value.cancelText];
        }
      }), createVNode(Button, _objectSpread2$1(_objectSpread2$1({}, convertLegacyProps(okType)), {}, {
        "loading": confirmLoading,
        "onClick": handleOk
      }, props2.okButtonProps), {
        default: function _default3() {
          return [okText || locale2.value.okText];
        }
      })]);
    };
    return function() {
      var _classNames;
      var _a;
      props2.prefixCls;
      var visible = props2.visible, wrapClassName = props2.wrapClassName, centered = props2.centered, getContainer4 = props2.getContainer, _props$closeIcon = props2.closeIcon, _closeIcon = _props$closeIcon === void 0 ? (_a = slots.closeIcon) === null || _a === void 0 ? void 0 : _a.call(slots) : _props$closeIcon, _props$focusTriggerAf = props2.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, restProps = __rest(props2, ["prefixCls", "visible", "wrapClassName", "centered", "getContainer", "closeIcon", "focusTriggerAfterClose"]);
      var wrapClassNameExtended = classNames(wrapClassName, (_classNames = {}, _defineProperty$m(_classNames, "".concat(prefixCls.value, "-centered"), !!centered), _defineProperty$m(_classNames, "".concat(prefixCls.value, "-wrap-rtl"), direction.value === "rtl"), _classNames));
      return createVNode(DialogWrap$1, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, restProps), attrs), {}, {
        "getContainer": getContainer4 || getPopupContainer.value,
        "prefixCls": prefixCls.value,
        "wrapClassName": wrapClassNameExtended,
        "visible": visible,
        "mousePosition": mousePosition,
        "onClose": handleCancel,
        "focusTriggerAfterClose": focusTriggerAfterClose,
        "transitionName": getTransitionName$1(rootPrefixCls.value, "zoom", props2.transitionName),
        "maskTransitionName": getTransitionName$1(rootPrefixCls.value, "fade", props2.maskTransitionName)
      }), _extends(_extends({}, slots), {
        footer: slots.footer || renderFooter,
        closeIcon: function closeIcon() {
          return createVNode("span", {
            "class": "".concat(prefixCls.value, "-close-x")
          }, [_closeIcon || createVNode(CloseOutlined$1, {
            "class": "".concat(prefixCls.value, "-close-icon")
          }, null)]);
        }
      }));
    };
  }
});
var useDestroyed = function useDestroyed2() {
  var destroyed = ref(false);
  onBeforeUnmount(function() {
    destroyed.value = true;
  });
  return destroyed;
};
var useDestroyed$1 = useDestroyed;
var actionButtonProps = {
  type: {
    type: String
  },
  actionFn: Function,
  close: Function,
  autofocus: Boolean,
  prefixCls: String,
  buttonProps: Object,
  emitEvent: Boolean,
  quitOnNullishReturnValue: Boolean
};
function isThenable(thing) {
  return !!(thing && !!thing.then);
}
var ActionButton = defineComponent({
  name: "ActionButton",
  props: actionButtonProps,
  setup: function setup62(props2, _ref) {
    var slots = _ref.slots;
    var clickedRef = ref(false);
    var buttonRef = ref();
    var loading = ref(false);
    var timeoutId;
    var isDestroyed = useDestroyed$1();
    onMounted(function() {
      if (props2.autofocus) {
        timeoutId = setTimeout(function() {
          var _a;
          return (_a = buttonRef.value.$el) === null || _a === void 0 ? void 0 : _a.focus();
        });
      }
    });
    onBeforeUnmount(function() {
      clearTimeout(timeoutId);
    });
    var handlePromiseOnOk = function handlePromiseOnOk2(returnValueOfOnOk) {
      var close3 = props2.close;
      if (!isThenable(returnValueOfOnOk)) {
        return;
      }
      loading.value = true;
      returnValueOfOnOk.then(function() {
        if (!isDestroyed.value) {
          loading.value = false;
        }
        close3.apply(void 0, arguments);
        clickedRef.value = false;
      }, function(e2) {
        console.error(e2);
        if (!isDestroyed.value) {
          loading.value = false;
        }
        clickedRef.value = false;
      });
    };
    var onClick2 = function onClick3(e2) {
      var actionFn = props2.actionFn, _props$close = props2.close, close3 = _props$close === void 0 ? function() {
      } : _props$close;
      if (clickedRef.value) {
        return;
      }
      clickedRef.value = true;
      if (!actionFn) {
        close3();
        return;
      }
      var returnValueOfOnOk;
      if (props2.emitEvent) {
        returnValueOfOnOk = actionFn(e2);
        if (props2.quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
          clickedRef.value = false;
          close3(e2);
          return;
        }
      } else if (actionFn.length) {
        returnValueOfOnOk = actionFn(close3);
        clickedRef.value = false;
      } else {
        returnValueOfOnOk = actionFn();
        if (!returnValueOfOnOk) {
          close3();
          return;
        }
      }
      handlePromiseOnOk(returnValueOfOnOk);
    };
    return function() {
      var type = props2.type, prefixCls = props2.prefixCls, buttonProps3 = props2.buttonProps;
      return createVNode(Button, _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, convertLegacyProps(type)), {}, {
        "onClick": onClick2,
        "loading": loading.value,
        "prefixCls": prefixCls
      }, buttonProps3), {}, {
        "ref": buttonRef
      }), slots);
    };
  }
});
function renderSomeContent(someContent) {
  if (typeof someContent === "function") {
    return someContent();
  }
  return someContent;
}
var ConfirmDialog = defineComponent({
  name: "ConfirmDialog",
  inheritAttrs: false,
  props: ["icon", "onCancel", "onOk", "close", "closable", "zIndex", "afterClose", "visible", "keyboard", "centered", "getContainer", "maskStyle", "okButtonProps", "cancelButtonProps", "okType", "prefixCls", "okCancel", "width", "mask", "maskClosable", "okText", "cancelText", "autoFocusButton", "transitionName", "maskTransitionName", "type", "title", "content", "direction", "rootPrefixCls", "bodyStyle", "closeIcon", "modalRender", "focusTriggerAfterClose", "wrapClassName"],
  setup: function setup63(props2, _ref) {
    var attrs = _ref.attrs;
    var _useLocaleReceiver = useLocaleReceiver("Modal"), _useLocaleReceiver2 = _slicedToArray$2(_useLocaleReceiver, 1), locale2 = _useLocaleReceiver2[0];
    return function() {
      var icon = props2.icon, onCancel = props2.onCancel, onOk = props2.onOk, close3 = props2.close, _props$closable = props2.closable, closable = _props$closable === void 0 ? false : _props$closable, zIndex = props2.zIndex, afterClose = props2.afterClose, visible = props2.visible, keyboard = props2.keyboard, centered = props2.centered, getContainer4 = props2.getContainer, maskStyle = props2.maskStyle, okButtonProps = props2.okButtonProps, cancelButtonProps = props2.cancelButtonProps, _props$okCancel = props2.okCancel, okCancel = _props$okCancel === void 0 ? true : _props$okCancel, _props$width = props2.width, width = _props$width === void 0 ? 416 : _props$width, _props$mask = props2.mask, mask = _props$mask === void 0 ? true : _props$mask, _props$maskClosable = props2.maskClosable, maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable, type = props2.type, title = props2.title, content = props2.content, direction = props2.direction, closeIcon = props2.closeIcon, modalRender = props2.modalRender, focusTriggerAfterClose = props2.focusTriggerAfterClose, rootPrefixCls = props2.rootPrefixCls, bodyStyle = props2.bodyStyle, wrapClassName = props2.wrapClassName;
      var okType = props2.okType || "primary";
      var prefixCls = props2.prefixCls || "ant-modal";
      var contentPrefixCls = "".concat(prefixCls, "-confirm");
      var style2 = attrs.style || {};
      var okText = renderSomeContent(props2.okText) || (okCancel ? locale2.value.okText : locale2.value.justOkText);
      var cancelText = renderSomeContent(props2.cancelText) || locale2.value.cancelText;
      var autoFocusButton = props2.autoFocusButton === null ? false : props2.autoFocusButton || "ok";
      var classString = classNames(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(type), "".concat(prefixCls, "-").concat(type), _defineProperty$m({}, "".concat(contentPrefixCls, "-rtl"), direction === "rtl"), attrs.class);
      var cancelButton = okCancel && createVNode(ActionButton, {
        "actionFn": onCancel,
        "close": close3,
        "autofocus": autoFocusButton === "cancel",
        "buttonProps": cancelButtonProps,
        "prefixCls": "".concat(rootPrefixCls, "-btn")
      }, {
        default: function _default3() {
          return [cancelText];
        }
      });
      return createVNode(Modal, {
        "prefixCls": prefixCls,
        "class": classString,
        "wrapClassName": classNames(_defineProperty$m({}, "".concat(contentPrefixCls, "-centered"), !!centered), wrapClassName),
        "onCancel": function onCancel2(e2) {
          return close3({
            triggerCancel: true
          }, e2);
        },
        "visible": visible,
        "title": "",
        "footer": "",
        "transitionName": getTransitionName$1(rootPrefixCls, "zoom", props2.transitionName),
        "maskTransitionName": getTransitionName$1(rootPrefixCls, "fade", props2.maskTransitionName),
        "mask": mask,
        "maskClosable": maskClosable,
        "maskStyle": maskStyle,
        "style": style2,
        "bodyStyle": bodyStyle,
        "width": width,
        "zIndex": zIndex,
        "afterClose": afterClose,
        "keyboard": keyboard,
        "centered": centered,
        "getContainer": getContainer4,
        "closable": closable,
        "closeIcon": closeIcon,
        "modalRender": modalRender,
        "focusTriggerAfterClose": focusTriggerAfterClose
      }, {
        default: function _default3() {
          return [createVNode("div", {
            "class": "".concat(contentPrefixCls, "-body-wrapper")
          }, [createVNode("div", {
            "class": "".concat(contentPrefixCls, "-body")
          }, [renderSomeContent(icon), title === void 0 ? null : createVNode("span", {
            "class": "".concat(contentPrefixCls, "-title")
          }, [renderSomeContent(title)]), createVNode("div", {
            "class": "".concat(contentPrefixCls, "-content")
          }, [renderSomeContent(content)])]), createVNode("div", {
            "class": "".concat(contentPrefixCls, "-btns")
          }, [cancelButton, createVNode(ActionButton, {
            "type": okType,
            "actionFn": onOk,
            "close": close3,
            "autofocus": autoFocusButton === "ok",
            "buttonProps": okButtonProps,
            "prefixCls": "".concat(rootPrefixCls, "-btn")
          }, {
            default: function _default4() {
              return [okText];
            }
          })])])];
        }
      });
    };
  }
});
var confirm = function confirm2(config) {
  var container = document.createDocumentFragment();
  var currentConfig = _extends(_extends({}, omit(config, ["parentContext", "appContext"])), {
    close: close3,
    visible: true
  });
  var confirmDialogInstance = null;
  function destroy3() {
    if (confirmDialogInstance) {
      render(null, container);
      confirmDialogInstance.component.update();
      confirmDialogInstance = null;
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var triggerCancel = args.some(function(param) {
      return param && param.triggerCancel;
    });
    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, args);
    }
    for (var i = 0; i < destroyFns.length; i++) {
      var fn = destroyFns[i];
      if (fn === close3) {
        destroyFns.splice(i, 1);
        break;
      }
    }
  }
  function close3() {
    var _this = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    currentConfig = _extends(_extends({}, currentConfig), {
      visible: false,
      afterClose: function afterClose() {
        if (typeof config.afterClose === "function") {
          config.afterClose();
        }
        destroy3.apply(_this, args);
      }
    });
    update(currentConfig);
  }
  function update(configUpdate) {
    if (typeof configUpdate === "function") {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = _extends(_extends({}, currentConfig), configUpdate);
    }
    if (confirmDialogInstance) {
      _extends(confirmDialogInstance.component.props, currentConfig);
      confirmDialogInstance.component.update();
    }
  }
  var Wrapper = function Wrapper2(p) {
    var global2 = globalConfigForApi;
    var rootPrefixCls = global2.prefixCls;
    var prefixCls = p.prefixCls || "".concat(rootPrefixCls, "-modal");
    return createVNode(ConfigProvider, _objectSpread2$1(_objectSpread2$1({}, global2), {}, {
      "notUpdateGlobalConfig": true,
      "prefixCls": rootPrefixCls
    }), {
      default: function _default3() {
        return [createVNode(ConfirmDialog, _objectSpread2$1(_objectSpread2$1({}, p), {}, {
          "rootPrefixCls": rootPrefixCls,
          "prefixCls": prefixCls
        }), null)];
      }
    });
  };
  function render$1(props2) {
    var vm = createVNode(Wrapper, _extends({}, props2));
    vm.appContext = config.parentContext || config.appContext || vm.appContext;
    render(vm, container);
    return vm;
  }
  confirmDialogInstance = render$1(currentConfig);
  destroyFns.push(close3);
  return {
    destroy: close3,
    update
  };
};
var confirm$1 = confirm;
function withWarn(props2) {
  return _extends(_extends({
    icon: function icon() {
      return createVNode(ExclamationCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "warning"
  });
}
function withInfo(props2) {
  return _extends(_extends({
    icon: function icon() {
      return createVNode(InfoCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "info"
  });
}
function withSuccess(props2) {
  return _extends(_extends({
    icon: function icon() {
      return createVNode(CheckCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "success"
  });
}
function withError(props2) {
  return _extends(_extends({
    icon: function icon() {
      return createVNode(CloseCircleOutlined$1, null, null);
    },
    okCancel: false
  }, props2), {
    type: "error"
  });
}
function withConfirm(props2) {
  return _extends(_extends({
    icon: function icon() {
      return createVNode(ExclamationCircleOutlined$1, null, null);
    },
    okCancel: true
  }, props2), {
    type: "confirm"
  });
}
function modalWarn(props2) {
  return confirm$1(withWarn(props2));
}
Modal.info = function infoFn(props2) {
  return confirm$1(withInfo(props2));
};
Modal.success = function successFn(props2) {
  return confirm$1(withSuccess(props2));
};
Modal.error = function errorFn(props2) {
  return confirm$1(withError(props2));
};
Modal.warning = modalWarn;
Modal.warn = modalWarn;
Modal.confirm = function confirmFn(props2) {
  return confirm$1(withConfirm(props2));
};
Modal.destroyAll = function destroyAllFn() {
  while (destroyFns.length) {
    var close3 = destroyFns.pop();
    if (close3) {
      close3();
    }
  }
};
Modal.install = function(app) {
  app.component(Modal.name, Modal);
  return app;
};
const regionData = [
  {
    value: "110000",
    label: "\u5317\u4EAC\u5E02",
    children: [
      {
        value: "110100",
        label: "\u5317\u4EAC\u5E02",
        children: [
          { value: "110101", label: "\u4E1C\u57CE\u533A" },
          { value: "110102", label: "\u897F\u57CE\u533A" },
          { value: "110105", label: "\u671D\u9633\u533A" },
          { value: "110106", label: "\u4E30\u53F0\u533A" },
          { value: "110107", label: "\u77F3\u666F\u5C71\u533A" },
          { value: "110108", label: "\u6D77\u6DC0\u533A" },
          { value: "110109", label: "\u95E8\u5934\u6C9F\u533A" },
          { value: "110111", label: "\u623F\u5C71\u533A" },
          { value: "110112", label: "\u901A\u5DDE\u533A" },
          { value: "110113", label: "\u987A\u4E49\u533A" },
          { value: "110114", label: "\u660C\u5E73\u533A" },
          { value: "110115", label: "\u5927\u5174\u533A" },
          { value: "110116", label: "\u6000\u67D4\u533A" },
          { value: "110117", label: "\u5E73\u8C37\u533A" },
          { value: "110118", label: "\u5BC6\u4E91\u533A" },
          { value: "110119", label: "\u5EF6\u5E86\u533A" }
        ]
      }
    ]
  },
  {
    value: "120000",
    label: "\u5929\u6D25\u5E02",
    children: [
      {
        value: "120100",
        label: "\u5929\u6D25\u5E02",
        children: [
          { value: "120101", label: "\u548C\u5E73\u533A" },
          { value: "120102", label: "\u6CB3\u4E1C\u533A" },
          { value: "120103", label: "\u6CB3\u897F\u533A" },
          { value: "120104", label: "\u5357\u5F00\u533A" },
          { value: "120105", label: "\u6CB3\u5317\u533A" },
          { value: "120106", label: "\u7EA2\u6865\u533A" },
          { value: "120110", label: "\u4E1C\u4E3D\u533A" },
          { value: "120111", label: "\u897F\u9752\u533A" },
          { value: "120112", label: "\u6D25\u5357\u533A" },
          { value: "120113", label: "\u5317\u8FB0\u533A" },
          { value: "120114", label: "\u6B66\u6E05\u533A" },
          { value: "120115", label: "\u5B9D\u577B\u533A" },
          { value: "120116", label: "\u6EE8\u6D77\u65B0\u533A" },
          { value: "120117", label: "\u5B81\u6CB3\u533A" },
          { value: "120118", label: "\u9759\u6D77\u533A" },
          { value: "120119", label: "\u84DF\u5DDE\u533A" }
        ]
      }
    ]
  },
  {
    value: "130000",
    label: "\u6CB3\u5317\u7701",
    children: [
      {
        value: "130100",
        label: "\u77F3\u5BB6\u5E84\u5E02",
        children: [
          { value: "130102", label: "\u957F\u5B89\u533A" },
          { value: "130104", label: "\u6865\u897F\u533A" },
          { value: "130105", label: "\u65B0\u534E\u533A" },
          { value: "130107", label: "\u4E95\u9649\u77FF\u533A" },
          { value: "130108", label: "\u88D5\u534E\u533A" },
          { value: "130109", label: "\u85C1\u57CE\u533A" },
          { value: "130110", label: "\u9E7F\u6CC9\u533A" },
          { value: "130111", label: "\u683E\u57CE\u533A" },
          { value: "130121", label: "\u4E95\u9649\u53BF" },
          { value: "130123", label: "\u6B63\u5B9A\u53BF" },
          { value: "130125", label: "\u884C\u5510\u53BF" },
          { value: "130126", label: "\u7075\u5BFF\u53BF" },
          { value: "130127", label: "\u9AD8\u9091\u53BF" },
          { value: "130128", label: "\u6DF1\u6CFD\u53BF" },
          { value: "130129", label: "\u8D5E\u7687\u53BF" },
          { value: "130130", label: "\u65E0\u6781\u53BF" },
          { value: "130131", label: "\u5E73\u5C71\u53BF" },
          { value: "130132", label: "\u5143\u6C0F\u53BF" },
          { value: "130133", label: "\u8D75\u53BF" },
          { value: "130171", label: "\u77F3\u5BB6\u5E84\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "130172", label: "\u77F3\u5BB6\u5E84\u5FAA\u73AF\u5316\u5DE5\u56ED\u533A" },
          { value: "130181", label: "\u8F9B\u96C6\u5E02" },
          { value: "130183", label: "\u664B\u5DDE\u5E02" },
          { value: "130184", label: "\u65B0\u4E50\u5E02" }
        ]
      },
      {
        value: "130200",
        label: "\u5510\u5C71\u5E02",
        children: [
          { value: "130202", label: "\u8DEF\u5357\u533A" },
          { value: "130203", label: "\u8DEF\u5317\u533A" },
          { value: "130204", label: "\u53E4\u51B6\u533A" },
          { value: "130205", label: "\u5F00\u5E73\u533A" },
          { value: "130207", label: "\u4E30\u5357\u533A" },
          { value: "130208", label: "\u4E30\u6DA6\u533A" },
          { value: "130209", label: "\u66F9\u5983\u7538\u533A" },
          { value: "130224", label: "\u6EE6\u5357\u53BF" },
          { value: "130225", label: "\u4E50\u4EAD\u53BF" },
          { value: "130227", label: "\u8FC1\u897F\u53BF" },
          { value: "130229", label: "\u7389\u7530\u53BF" },
          { value: "130271", label: "\u6CB3\u5317\u5510\u5C71\u82A6\u53F0\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "130272", label: "\u5510\u5C71\u5E02\u6C49\u6CBD\u7BA1\u7406\u533A" },
          { value: "130273", label: "\u5510\u5C71\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "130274", label: "\u6CB3\u5317\u5510\u5C71\u6D77\u6E2F\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "130281", label: "\u9075\u5316\u5E02" },
          { value: "130283", label: "\u8FC1\u5B89\u5E02" },
          { value: "130284", label: "\u6EE6\u5DDE\u5E02" }
        ]
      },
      {
        value: "130300",
        label: "\u79E6\u7687\u5C9B\u5E02",
        children: [
          { value: "130302", label: "\u6D77\u6E2F\u533A" },
          { value: "130303", label: "\u5C71\u6D77\u5173\u533A" },
          { value: "130304", label: "\u5317\u6234\u6CB3\u533A" },
          { value: "130306", label: "\u629A\u5B81\u533A" },
          { value: "130321", label: "\u9752\u9F99\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "130322", label: "\u660C\u9ECE\u53BF" },
          { value: "130324", label: "\u5362\u9F99\u53BF" },
          { value: "130371", label: "\u79E6\u7687\u5C9B\u5E02\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "130372", label: "\u5317\u6234\u6CB3\u65B0\u533A" }
        ]
      },
      {
        value: "130400",
        label: "\u90AF\u90F8\u5E02",
        children: [
          { value: "130402", label: "\u90AF\u5C71\u533A" },
          { value: "130403", label: "\u4E1B\u53F0\u533A" },
          { value: "130404", label: "\u590D\u5174\u533A" },
          { value: "130406", label: "\u5CF0\u5CF0\u77FF\u533A" },
          { value: "130407", label: "\u80A5\u4E61\u533A" },
          { value: "130408", label: "\u6C38\u5E74\u533A" },
          { value: "130423", label: "\u4E34\u6F33\u53BF" },
          { value: "130424", label: "\u6210\u5B89\u53BF" },
          { value: "130425", label: "\u5927\u540D\u53BF" },
          { value: "130426", label: "\u6D89\u53BF" },
          { value: "130427", label: "\u78C1\u53BF" },
          { value: "130430", label: "\u90B1\u53BF" },
          { value: "130431", label: "\u9E21\u6CFD\u53BF" },
          { value: "130432", label: "\u5E7F\u5E73\u53BF" },
          { value: "130433", label: "\u9986\u9676\u53BF" },
          { value: "130434", label: "\u9B4F\u53BF" },
          { value: "130435", label: "\u66F2\u5468\u53BF" },
          { value: "130471", label: "\u90AF\u90F8\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "130473", label: "\u90AF\u90F8\u5180\u5357\u65B0\u533A" },
          { value: "130481", label: "\u6B66\u5B89\u5E02" }
        ]
      },
      {
        value: "130500",
        label: "\u90A2\u53F0\u5E02",
        children: [
          { value: "130502", label: "\u6865\u4E1C\u533A" },
          { value: "130503", label: "\u6865\u897F\u533A" },
          { value: "130521", label: "\u90A2\u53F0\u53BF" },
          { value: "130522", label: "\u4E34\u57CE\u53BF" },
          { value: "130523", label: "\u5185\u4E18\u53BF" },
          { value: "130524", label: "\u67CF\u4E61\u53BF" },
          { value: "130525", label: "\u9686\u5C27\u53BF" },
          { value: "130526", label: "\u4EFB\u53BF" },
          { value: "130527", label: "\u5357\u548C\u53BF" },
          { value: "130528", label: "\u5B81\u664B\u53BF" },
          { value: "130529", label: "\u5DE8\u9E7F\u53BF" },
          { value: "130530", label: "\u65B0\u6CB3\u53BF" },
          { value: "130531", label: "\u5E7F\u5B97\u53BF" },
          { value: "130532", label: "\u5E73\u4E61\u53BF" },
          { value: "130533", label: "\u5A01\u53BF" },
          { value: "130534", label: "\u6E05\u6CB3\u53BF" },
          { value: "130535", label: "\u4E34\u897F\u53BF" },
          { value: "130571", label: "\u6CB3\u5317\u90A2\u53F0\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "130581", label: "\u5357\u5BAB\u5E02" },
          { value: "130582", label: "\u6C99\u6CB3\u5E02" }
        ]
      },
      {
        value: "130600",
        label: "\u4FDD\u5B9A\u5E02",
        children: [
          { value: "130602", label: "\u7ADE\u79C0\u533A" },
          { value: "130606", label: "\u83B2\u6C60\u533A" },
          { value: "130607", label: "\u6EE1\u57CE\u533A" },
          { value: "130608", label: "\u6E05\u82D1\u533A" },
          { value: "130609", label: "\u5F90\u6C34\u533A" },
          { value: "130623", label: "\u6D9E\u6C34\u53BF" },
          { value: "130624", label: "\u961C\u5E73\u53BF" },
          { value: "130626", label: "\u5B9A\u5174\u53BF" },
          { value: "130627", label: "\u5510\u53BF" },
          { value: "130628", label: "\u9AD8\u9633\u53BF" },
          { value: "130629", label: "\u5BB9\u57CE\u53BF" },
          { value: "130630", label: "\u6D9E\u6E90\u53BF" },
          { value: "130631", label: "\u671B\u90FD\u53BF" },
          { value: "130632", label: "\u5B89\u65B0\u53BF" },
          { value: "130633", label: "\u6613\u53BF" },
          { value: "130634", label: "\u66F2\u9633\u53BF" },
          { value: "130635", label: "\u8821\u53BF" },
          { value: "130636", label: "\u987A\u5E73\u53BF" },
          { value: "130637", label: "\u535A\u91CE\u53BF" },
          { value: "130638", label: "\u96C4\u53BF" },
          { value: "130671", label: "\u4FDD\u5B9A\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "130672", label: "\u4FDD\u5B9A\u767D\u6C9F\u65B0\u57CE" },
          { value: "130681", label: "\u6DBF\u5DDE\u5E02" },
          { value: "130682", label: "\u5B9A\u5DDE\u5E02" },
          { value: "130683", label: "\u5B89\u56FD\u5E02" },
          { value: "130684", label: "\u9AD8\u7891\u5E97\u5E02" }
        ]
      },
      {
        value: "130700",
        label: "\u5F20\u5BB6\u53E3\u5E02",
        children: [
          { value: "130702", label: "\u6865\u4E1C\u533A" },
          { value: "130703", label: "\u6865\u897F\u533A" },
          { value: "130705", label: "\u5BA3\u5316\u533A" },
          { value: "130706", label: "\u4E0B\u82B1\u56ED\u533A" },
          { value: "130708", label: "\u4E07\u5168\u533A" },
          { value: "130709", label: "\u5D07\u793C\u533A" },
          { value: "130722", label: "\u5F20\u5317\u53BF" },
          { value: "130723", label: "\u5EB7\u4FDD\u53BF" },
          { value: "130724", label: "\u6CBD\u6E90\u53BF" },
          { value: "130725", label: "\u5C1A\u4E49\u53BF" },
          { value: "130726", label: "\u851A\u53BF" },
          { value: "130727", label: "\u9633\u539F\u53BF" },
          { value: "130728", label: "\u6000\u5B89\u53BF" },
          { value: "130730", label: "\u6000\u6765\u53BF" },
          { value: "130731", label: "\u6DBF\u9E7F\u53BF" },
          { value: "130732", label: "\u8D64\u57CE\u53BF" },
          { value: "130771", label: "\u5F20\u5BB6\u53E3\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "130772", label: "\u5F20\u5BB6\u53E3\u5E02\u5BDF\u5317\u7BA1\u7406\u533A" },
          { value: "130773", label: "\u5F20\u5BB6\u53E3\u5E02\u585E\u5317\u7BA1\u7406\u533A" }
        ]
      },
      {
        value: "130800",
        label: "\u627F\u5FB7\u5E02",
        children: [
          { value: "130802", label: "\u53CC\u6865\u533A" },
          { value: "130803", label: "\u53CC\u6EE6\u533A" },
          { value: "130804", label: "\u9E70\u624B\u8425\u5B50\u77FF\u533A" },
          { value: "130821", label: "\u627F\u5FB7\u53BF" },
          { value: "130822", label: "\u5174\u9686\u53BF" },
          { value: "130824", label: "\u6EE6\u5E73\u53BF" },
          { value: "130825", label: "\u9686\u5316\u53BF" },
          { value: "130826", label: "\u4E30\u5B81\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "130827", label: "\u5BBD\u57CE\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "130828", label: "\u56F4\u573A\u6EE1\u65CF\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" },
          { value: "130871", label: "\u627F\u5FB7\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "130881", label: "\u5E73\u6CC9\u5E02" }
        ]
      },
      {
        value: "130900",
        label: "\u6CA7\u5DDE\u5E02",
        children: [
          { value: "130902", label: "\u65B0\u534E\u533A" },
          { value: "130903", label: "\u8FD0\u6CB3\u533A" },
          { value: "130921", label: "\u6CA7\u53BF" },
          { value: "130922", label: "\u9752\u53BF" },
          { value: "130923", label: "\u4E1C\u5149\u53BF" },
          { value: "130924", label: "\u6D77\u5174\u53BF" },
          { value: "130925", label: "\u76D0\u5C71\u53BF" },
          { value: "130926", label: "\u8083\u5B81\u53BF" },
          { value: "130927", label: "\u5357\u76AE\u53BF" },
          { value: "130928", label: "\u5434\u6865\u53BF" },
          { value: "130929", label: "\u732E\u53BF" },
          { value: "130930", label: "\u5B5F\u6751\u56DE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "130971", label: "\u6CB3\u5317\u6CA7\u5DDE\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "130972", label: "\u6CA7\u5DDE\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "130973", label: "\u6CA7\u5DDE\u6E24\u6D77\u65B0\u533A" },
          { value: "130981", label: "\u6CCA\u5934\u5E02" },
          { value: "130982", label: "\u4EFB\u4E18\u5E02" },
          { value: "130983", label: "\u9EC4\u9A85\u5E02" },
          { value: "130984", label: "\u6CB3\u95F4\u5E02" }
        ]
      },
      {
        value: "131000",
        label: "\u5ECA\u574A\u5E02",
        children: [
          { value: "131002", label: "\u5B89\u6B21\u533A" },
          { value: "131003", label: "\u5E7F\u9633\u533A" },
          { value: "131022", label: "\u56FA\u5B89\u53BF" },
          { value: "131023", label: "\u6C38\u6E05\u53BF" },
          { value: "131024", label: "\u9999\u6CB3\u53BF" },
          { value: "131025", label: "\u5927\u57CE\u53BF" },
          { value: "131026", label: "\u6587\u5B89\u53BF" },
          { value: "131028", label: "\u5927\u5382\u56DE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "131071", label: "\u5ECA\u574A\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "131081", label: "\u9738\u5DDE\u5E02" },
          { value: "131082", label: "\u4E09\u6CB3\u5E02" }
        ]
      },
      {
        value: "131100",
        label: "\u8861\u6C34\u5E02",
        children: [
          { value: "131102", label: "\u6843\u57CE\u533A" },
          { value: "131103", label: "\u5180\u5DDE\u533A" },
          { value: "131121", label: "\u67A3\u5F3A\u53BF" },
          { value: "131122", label: "\u6B66\u9091\u53BF" },
          { value: "131123", label: "\u6B66\u5F3A\u53BF" },
          { value: "131124", label: "\u9976\u9633\u53BF" },
          { value: "131125", label: "\u5B89\u5E73\u53BF" },
          { value: "131126", label: "\u6545\u57CE\u53BF" },
          { value: "131127", label: "\u666F\u53BF" },
          { value: "131128", label: "\u961C\u57CE\u53BF" },
          { value: "131171", label: "\u6CB3\u5317\u8861\u6C34\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "131172", label: "\u8861\u6C34\u6EE8\u6E56\u65B0\u533A" },
          { value: "131182", label: "\u6DF1\u5DDE\u5E02" }
        ]
      }
    ]
  },
  {
    value: "140000",
    label: "\u5C71\u897F\u7701",
    children: [
      {
        value: "140100",
        label: "\u592A\u539F\u5E02",
        children: [
          { value: "140105", label: "\u5C0F\u5E97\u533A" },
          { value: "140106", label: "\u8FCE\u6CFD\u533A" },
          { value: "140107", label: "\u674F\u82B1\u5CAD\u533A" },
          { value: "140108", label: "\u5C16\u8349\u576A\u533A" },
          { value: "140109", label: "\u4E07\u67CF\u6797\u533A" },
          { value: "140110", label: "\u664B\u6E90\u533A" },
          { value: "140121", label: "\u6E05\u5F90\u53BF" },
          { value: "140122", label: "\u9633\u66F2\u53BF" },
          { value: "140123", label: "\u5A04\u70E6\u53BF" },
          { value: "140171", label: "\u5C71\u897F\u8F6C\u578B\u7EFC\u5408\u6539\u9769\u793A\u8303\u533A" },
          { value: "140181", label: "\u53E4\u4EA4\u5E02" }
        ]
      },
      {
        value: "140200",
        label: "\u5927\u540C\u5E02",
        children: [
          { value: "140212", label: "\u65B0\u8363\u533A" },
          { value: "140213", label: "\u5E73\u57CE\u533A" },
          { value: "140214", label: "\u4E91\u5188\u533A" },
          { value: "140215", label: "\u4E91\u5DDE\u533A" },
          { value: "140221", label: "\u9633\u9AD8\u53BF" },
          { value: "140222", label: "\u5929\u9547\u53BF" },
          { value: "140223", label: "\u5E7F\u7075\u53BF" },
          { value: "140224", label: "\u7075\u4E18\u53BF" },
          { value: "140225", label: "\u6D51\u6E90\u53BF" },
          { value: "140226", label: "\u5DE6\u4E91\u53BF" },
          { value: "140271", label: "\u5C71\u897F\u5927\u540C\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "140300",
        label: "\u9633\u6CC9\u5E02",
        children: [
          { value: "140302", label: "\u57CE\u533A" },
          { value: "140303", label: "\u77FF\u533A" },
          { value: "140311", label: "\u90CA\u533A" },
          { value: "140321", label: "\u5E73\u5B9A\u53BF" },
          { value: "140322", label: "\u76C2\u53BF" }
        ]
      },
      {
        value: "140400",
        label: "\u957F\u6CBB\u5E02",
        children: [
          { value: "140403", label: "\u6F5E\u5DDE\u533A" },
          { value: "140404", label: "\u4E0A\u515A\u533A" },
          { value: "140405", label: "\u5C6F\u7559\u533A" },
          { value: "140406", label: "\u6F5E\u57CE\u533A" },
          { value: "140423", label: "\u8944\u57A3\u53BF" },
          { value: "140425", label: "\u5E73\u987A\u53BF" },
          { value: "140426", label: "\u9ECE\u57CE\u53BF" },
          { value: "140427", label: "\u58F6\u5173\u53BF" },
          { value: "140428", label: "\u957F\u5B50\u53BF" },
          { value: "140429", label: "\u6B66\u4E61\u53BF" },
          { value: "140430", label: "\u6C81\u53BF" },
          { value: "140431", label: "\u6C81\u6E90\u53BF" },
          { value: "140471", label: "\u5C71\u897F\u957F\u6CBB\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A" }
        ]
      },
      {
        value: "140500",
        label: "\u664B\u57CE\u5E02",
        children: [
          { value: "140502", label: "\u57CE\u533A" },
          { value: "140521", label: "\u6C81\u6C34\u53BF" },
          { value: "140522", label: "\u9633\u57CE\u53BF" },
          { value: "140524", label: "\u9675\u5DDD\u53BF" },
          { value: "140525", label: "\u6CFD\u5DDE\u53BF" },
          { value: "140581", label: "\u9AD8\u5E73\u5E02" }
        ]
      },
      {
        value: "140600",
        label: "\u6714\u5DDE\u5E02",
        children: [
          { value: "140602", label: "\u6714\u57CE\u533A" },
          { value: "140603", label: "\u5E73\u9C81\u533A" },
          { value: "140621", label: "\u5C71\u9634\u53BF" },
          { value: "140622", label: "\u5E94\u53BF" },
          { value: "140623", label: "\u53F3\u7389\u53BF" },
          { value: "140671", label: "\u5C71\u897F\u6714\u5DDE\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "140681", label: "\u6000\u4EC1\u5E02" }
        ]
      },
      {
        value: "140700",
        label: "\u664B\u4E2D\u5E02",
        children: [
          { value: "140702", label: "\u6986\u6B21\u533A" },
          { value: "140721", label: "\u6986\u793E\u53BF" },
          { value: "140722", label: "\u5DE6\u6743\u53BF" },
          { value: "140723", label: "\u548C\u987A\u53BF" },
          { value: "140724", label: "\u6614\u9633\u53BF" },
          { value: "140725", label: "\u5BFF\u9633\u53BF" },
          { value: "140726", label: "\u592A\u8C37\u53BF" },
          { value: "140727", label: "\u7941\u53BF" },
          { value: "140728", label: "\u5E73\u9065\u53BF" },
          { value: "140729", label: "\u7075\u77F3\u53BF" },
          { value: "140781", label: "\u4ECB\u4F11\u5E02" }
        ]
      },
      {
        value: "140800",
        label: "\u8FD0\u57CE\u5E02",
        children: [
          { value: "140802", label: "\u76D0\u6E56\u533A" },
          { value: "140821", label: "\u4E34\u7317\u53BF" },
          { value: "140822", label: "\u4E07\u8363\u53BF" },
          { value: "140823", label: "\u95FB\u559C\u53BF" },
          { value: "140824", label: "\u7A37\u5C71\u53BF" },
          { value: "140825", label: "\u65B0\u7EDB\u53BF" },
          { value: "140826", label: "\u7EDB\u53BF" },
          { value: "140827", label: "\u57A3\u66F2\u53BF" },
          { value: "140828", label: "\u590F\u53BF" },
          { value: "140829", label: "\u5E73\u9646\u53BF" },
          { value: "140830", label: "\u82AE\u57CE\u53BF" },
          { value: "140881", label: "\u6C38\u6D4E\u5E02" },
          { value: "140882", label: "\u6CB3\u6D25\u5E02" }
        ]
      },
      {
        value: "140900",
        label: "\u5FFB\u5DDE\u5E02",
        children: [
          { value: "140902", label: "\u5FFB\u5E9C\u533A" },
          { value: "140921", label: "\u5B9A\u8944\u53BF" },
          { value: "140922", label: "\u4E94\u53F0\u53BF" },
          { value: "140923", label: "\u4EE3\u53BF" },
          { value: "140924", label: "\u7E41\u5CD9\u53BF" },
          { value: "140925", label: "\u5B81\u6B66\u53BF" },
          { value: "140926", label: "\u9759\u4E50\u53BF" },
          { value: "140927", label: "\u795E\u6C60\u53BF" },
          { value: "140928", label: "\u4E94\u5BE8\u53BF" },
          { value: "140929", label: "\u5CA2\u5C9A\u53BF" },
          { value: "140930", label: "\u6CB3\u66F2\u53BF" },
          { value: "140931", label: "\u4FDD\u5FB7\u53BF" },
          { value: "140932", label: "\u504F\u5173\u53BF" },
          { value: "140971", label: "\u4E94\u53F0\u5C71\u98CE\u666F\u540D\u80DC\u533A" },
          { value: "140981", label: "\u539F\u5E73\u5E02" }
        ]
      },
      {
        value: "141000",
        label: "\u4E34\u6C7E\u5E02",
        children: [
          { value: "141002", label: "\u5C27\u90FD\u533A" },
          { value: "141021", label: "\u66F2\u6C83\u53BF" },
          { value: "141022", label: "\u7FFC\u57CE\u53BF" },
          { value: "141023", label: "\u8944\u6C7E\u53BF" },
          { value: "141024", label: "\u6D2A\u6D1E\u53BF" },
          { value: "141025", label: "\u53E4\u53BF" },
          { value: "141026", label: "\u5B89\u6CFD\u53BF" },
          { value: "141027", label: "\u6D6E\u5C71\u53BF" },
          { value: "141028", label: "\u5409\u53BF" },
          { value: "141029", label: "\u4E61\u5B81\u53BF" },
          { value: "141030", label: "\u5927\u5B81\u53BF" },
          { value: "141031", label: "\u96B0\u53BF" },
          { value: "141032", label: "\u6C38\u548C\u53BF" },
          { value: "141033", label: "\u84B2\u53BF" },
          { value: "141034", label: "\u6C7E\u897F\u53BF" },
          { value: "141081", label: "\u4FAF\u9A6C\u5E02" },
          { value: "141082", label: "\u970D\u5DDE\u5E02" }
        ]
      },
      {
        value: "141100",
        label: "\u5415\u6881\u5E02",
        children: [
          { value: "141102", label: "\u79BB\u77F3\u533A" },
          { value: "141121", label: "\u6587\u6C34\u53BF" },
          { value: "141122", label: "\u4EA4\u57CE\u53BF" },
          { value: "141123", label: "\u5174\u53BF" },
          { value: "141124", label: "\u4E34\u53BF" },
          { value: "141125", label: "\u67F3\u6797\u53BF" },
          { value: "141126", label: "\u77F3\u697C\u53BF" },
          { value: "141127", label: "\u5C9A\u53BF" },
          { value: "141128", label: "\u65B9\u5C71\u53BF" },
          { value: "141129", label: "\u4E2D\u9633\u53BF" },
          { value: "141130", label: "\u4EA4\u53E3\u53BF" },
          { value: "141181", label: "\u5B5D\u4E49\u5E02" },
          { value: "141182", label: "\u6C7E\u9633\u5E02" }
        ]
      }
    ]
  },
  {
    value: "150000",
    label: "\u5185\u8499\u53E4\u81EA\u6CBB\u533A",
    children: [
      {
        value: "150100",
        label: "\u547C\u548C\u6D69\u7279\u5E02",
        children: [
          { value: "150102", label: "\u65B0\u57CE\u533A" },
          { value: "150103", label: "\u56DE\u6C11\u533A" },
          { value: "150104", label: "\u7389\u6CC9\u533A" },
          { value: "150105", label: "\u8D5B\u7F55\u533A" },
          { value: "150121", label: "\u571F\u9ED8\u7279\u5DE6\u65D7" },
          { value: "150122", label: "\u6258\u514B\u6258\u53BF" },
          { value: "150123", label: "\u548C\u6797\u683C\u5C14\u53BF" },
          { value: "150124", label: "\u6E05\u6C34\u6CB3\u53BF" },
          { value: "150125", label: "\u6B66\u5DDD\u53BF" },
          { value: "150171", label: "\u547C\u548C\u6D69\u7279\u91D1\u6D77\u5DE5\u4E1A\u56ED\u533A" },
          { value: "150172", label: "\u547C\u548C\u6D69\u7279\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "150200",
        label: "\u5305\u5934\u5E02",
        children: [
          { value: "150202", label: "\u4E1C\u6CB3\u533A" },
          { value: "150203", label: "\u6606\u90FD\u4ED1\u533A" },
          { value: "150204", label: "\u9752\u5C71\u533A" },
          { value: "150205", label: "\u77F3\u62D0\u533A" },
          { value: "150206", label: "\u767D\u4E91\u9102\u535A\u77FF\u533A" },
          { value: "150207", label: "\u4E5D\u539F\u533A" },
          { value: "150221", label: "\u571F\u9ED8\u7279\u53F3\u65D7" },
          { value: "150222", label: "\u56FA\u9633\u53BF" },
          { value: "150223", label: "\u8FBE\u5C14\u7F55\u8302\u660E\u5B89\u8054\u5408\u65D7" },
          { value: "150271", label: "\u5305\u5934\u7A00\u571F\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "150300",
        label: "\u4E4C\u6D77\u5E02",
        children: [
          { value: "150302", label: "\u6D77\u52C3\u6E7E\u533A" },
          { value: "150303", label: "\u6D77\u5357\u533A" },
          { value: "150304", label: "\u4E4C\u8FBE\u533A" }
        ]
      },
      {
        value: "150400",
        label: "\u8D64\u5CF0\u5E02",
        children: [
          { value: "150402", label: "\u7EA2\u5C71\u533A" },
          { value: "150403", label: "\u5143\u5B9D\u5C71\u533A" },
          { value: "150404", label: "\u677E\u5C71\u533A" },
          { value: "150421", label: "\u963F\u9C81\u79D1\u5C14\u6C81\u65D7" },
          { value: "150422", label: "\u5DF4\u6797\u5DE6\u65D7" },
          { value: "150423", label: "\u5DF4\u6797\u53F3\u65D7" },
          { value: "150424", label: "\u6797\u897F\u53BF" },
          { value: "150425", label: "\u514B\u4EC0\u514B\u817E\u65D7" },
          { value: "150426", label: "\u7FC1\u725B\u7279\u65D7" },
          { value: "150428", label: "\u5580\u5587\u6C81\u65D7" },
          { value: "150429", label: "\u5B81\u57CE\u53BF" },
          { value: "150430", label: "\u6556\u6C49\u65D7" }
        ]
      },
      {
        value: "150500",
        label: "\u901A\u8FBD\u5E02",
        children: [
          { value: "150502", label: "\u79D1\u5C14\u6C81\u533A" },
          { value: "150521", label: "\u79D1\u5C14\u6C81\u5DE6\u7FFC\u4E2D\u65D7" },
          { value: "150522", label: "\u79D1\u5C14\u6C81\u5DE6\u7FFC\u540E\u65D7" },
          { value: "150523", label: "\u5F00\u9C81\u53BF" },
          { value: "150524", label: "\u5E93\u4F26\u65D7" },
          { value: "150525", label: "\u5948\u66FC\u65D7" },
          { value: "150526", label: "\u624E\u9C81\u7279\u65D7" },
          { value: "150571", label: "\u901A\u8FBD\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "150581", label: "\u970D\u6797\u90ED\u52D2\u5E02" }
        ]
      },
      {
        value: "150600",
        label: "\u9102\u5C14\u591A\u65AF\u5E02",
        children: [
          { value: "150602", label: "\u4E1C\u80DC\u533A" },
          { value: "150603", label: "\u5EB7\u5DF4\u4EC0\u533A" },
          { value: "150621", label: "\u8FBE\u62C9\u7279\u65D7" },
          { value: "150622", label: "\u51C6\u683C\u5C14\u65D7" },
          { value: "150623", label: "\u9102\u6258\u514B\u524D\u65D7" },
          { value: "150624", label: "\u9102\u6258\u514B\u65D7" },
          { value: "150625", label: "\u676D\u9526\u65D7" },
          { value: "150626", label: "\u4E4C\u5BA1\u65D7" },
          { value: "150627", label: "\u4F0A\u91D1\u970D\u6D1B\u65D7" }
        ]
      },
      {
        value: "150700",
        label: "\u547C\u4F26\u8D1D\u5C14\u5E02",
        children: [
          { value: "150702", label: "\u6D77\u62C9\u5C14\u533A" },
          { value: "150703", label: "\u624E\u8D49\u8BFA\u5C14\u533A" },
          { value: "150721", label: "\u963F\u8363\u65D7" },
          { value: "150722", label: "\u83AB\u529B\u8FBE\u74E6\u8FBE\u65A1\u5C14\u65CF\u81EA\u6CBB\u65D7" },
          { value: "150723", label: "\u9102\u4F26\u6625\u81EA\u6CBB\u65D7" },
          { value: "150724", label: "\u9102\u6E29\u514B\u65CF\u81EA\u6CBB\u65D7" },
          { value: "150725", label: "\u9648\u5DF4\u5C14\u864E\u65D7" },
          { value: "150726", label: "\u65B0\u5DF4\u5C14\u864E\u5DE6\u65D7" },
          { value: "150727", label: "\u65B0\u5DF4\u5C14\u864E\u53F3\u65D7" },
          { value: "150781", label: "\u6EE1\u6D32\u91CC\u5E02" },
          { value: "150782", label: "\u7259\u514B\u77F3\u5E02" },
          { value: "150783", label: "\u624E\u5170\u5C6F\u5E02" },
          { value: "150784", label: "\u989D\u5C14\u53E4\u7EB3\u5E02" },
          { value: "150785", label: "\u6839\u6CB3\u5E02" }
        ]
      },
      {
        value: "150800",
        label: "\u5DF4\u5F66\u6DD6\u5C14\u5E02",
        children: [
          { value: "150802", label: "\u4E34\u6CB3\u533A" },
          { value: "150821", label: "\u4E94\u539F\u53BF" },
          { value: "150822", label: "\u78F4\u53E3\u53BF" },
          { value: "150823", label: "\u4E4C\u62C9\u7279\u524D\u65D7" },
          { value: "150824", label: "\u4E4C\u62C9\u7279\u4E2D\u65D7" },
          { value: "150825", label: "\u4E4C\u62C9\u7279\u540E\u65D7" },
          { value: "150826", label: "\u676D\u9526\u540E\u65D7" }
        ]
      },
      {
        value: "150900",
        label: "\u4E4C\u5170\u5BDF\u5E03\u5E02",
        children: [
          { value: "150902", label: "\u96C6\u5B81\u533A" },
          { value: "150921", label: "\u5353\u8D44\u53BF" },
          { value: "150922", label: "\u5316\u5FB7\u53BF" },
          { value: "150923", label: "\u5546\u90FD\u53BF" },
          { value: "150924", label: "\u5174\u548C\u53BF" },
          { value: "150925", label: "\u51C9\u57CE\u53BF" },
          { value: "150926", label: "\u5BDF\u54C8\u5C14\u53F3\u7FFC\u524D\u65D7" },
          { value: "150927", label: "\u5BDF\u54C8\u5C14\u53F3\u7FFC\u4E2D\u65D7" },
          { value: "150928", label: "\u5BDF\u54C8\u5C14\u53F3\u7FFC\u540E\u65D7" },
          { value: "150929", label: "\u56DB\u5B50\u738B\u65D7" },
          { value: "150981", label: "\u4E30\u9547\u5E02" }
        ]
      },
      {
        value: "152200",
        label: "\u5174\u5B89\u76DF",
        children: [
          { value: "152201", label: "\u4E4C\u5170\u6D69\u7279\u5E02" },
          { value: "152202", label: "\u963F\u5C14\u5C71\u5E02" },
          { value: "152221", label: "\u79D1\u5C14\u6C81\u53F3\u7FFC\u524D\u65D7" },
          { value: "152222", label: "\u79D1\u5C14\u6C81\u53F3\u7FFC\u4E2D\u65D7" },
          { value: "152223", label: "\u624E\u8D49\u7279\u65D7" },
          { value: "152224", label: "\u7A81\u6CC9\u53BF" }
        ]
      },
      {
        value: "152500",
        label: "\u9521\u6797\u90ED\u52D2\u76DF",
        children: [
          { value: "152501", label: "\u4E8C\u8FDE\u6D69\u7279\u5E02" },
          { value: "152502", label: "\u9521\u6797\u6D69\u7279\u5E02" },
          { value: "152522", label: "\u963F\u5DF4\u560E\u65D7" },
          { value: "152523", label: "\u82CF\u5C3C\u7279\u5DE6\u65D7" },
          { value: "152524", label: "\u82CF\u5C3C\u7279\u53F3\u65D7" },
          { value: "152525", label: "\u4E1C\u4E4C\u73E0\u7A46\u6C81\u65D7" },
          { value: "152526", label: "\u897F\u4E4C\u73E0\u7A46\u6C81\u65D7" },
          { value: "152527", label: "\u592A\u4EC6\u5BFA\u65D7" },
          { value: "152528", label: "\u9576\u9EC4\u65D7" },
          { value: "152529", label: "\u6B63\u9576\u767D\u65D7" },
          { value: "152530", label: "\u6B63\u84DD\u65D7" },
          { value: "152531", label: "\u591A\u4F26\u53BF" },
          { value: "152571", label: "\u4E4C\u62C9\u76D6\u7BA1\u59D4\u4F1A" }
        ]
      },
      {
        value: "152900",
        label: "\u963F\u62C9\u5584\u76DF",
        children: [
          { value: "152921", label: "\u963F\u62C9\u5584\u5DE6\u65D7" },
          { value: "152922", label: "\u963F\u62C9\u5584\u53F3\u65D7" },
          { value: "152923", label: "\u989D\u6D4E\u7EB3\u65D7" },
          { value: "152971", label: "\u5185\u8499\u53E4\u963F\u62C9\u5584\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      }
    ]
  },
  {
    value: "210000",
    label: "\u8FBD\u5B81\u7701",
    children: [
      {
        value: "210100",
        label: "\u6C88\u9633\u5E02",
        children: [
          { value: "210102", label: "\u548C\u5E73\u533A" },
          { value: "210103", label: "\u6C88\u6CB3\u533A" },
          { value: "210104", label: "\u5927\u4E1C\u533A" },
          { value: "210105", label: "\u7687\u59D1\u533A" },
          { value: "210106", label: "\u94C1\u897F\u533A" },
          { value: "210111", label: "\u82CF\u5BB6\u5C6F\u533A" },
          { value: "210112", label: "\u6D51\u5357\u533A" },
          { value: "210113", label: "\u6C88\u5317\u65B0\u533A" },
          { value: "210114", label: "\u4E8E\u6D2A\u533A" },
          { value: "210115", label: "\u8FBD\u4E2D\u533A" },
          { value: "210123", label: "\u5EB7\u5E73\u53BF" },
          { value: "210124", label: "\u6CD5\u5E93\u53BF" },
          { value: "210181", label: "\u65B0\u6C11\u5E02" }
        ]
      },
      {
        value: "210200",
        label: "\u5927\u8FDE\u5E02",
        children: [
          { value: "210202", label: "\u4E2D\u5C71\u533A" },
          { value: "210203", label: "\u897F\u5C97\u533A" },
          { value: "210204", label: "\u6C99\u6CB3\u53E3\u533A" },
          { value: "210211", label: "\u7518\u4E95\u5B50\u533A" },
          { value: "210212", label: "\u65C5\u987A\u53E3\u533A" },
          { value: "210213", label: "\u91D1\u5DDE\u533A" },
          { value: "210214", label: "\u666E\u5170\u5E97\u533A" },
          { value: "210224", label: "\u957F\u6D77\u53BF" },
          { value: "210281", label: "\u74E6\u623F\u5E97\u5E02" },
          { value: "210283", label: "\u5E84\u6CB3\u5E02" }
        ]
      },
      {
        value: "210300",
        label: "\u978D\u5C71\u5E02",
        children: [
          { value: "210302", label: "\u94C1\u4E1C\u533A" },
          { value: "210303", label: "\u94C1\u897F\u533A" },
          { value: "210304", label: "\u7ACB\u5C71\u533A" },
          { value: "210311", label: "\u5343\u5C71\u533A" },
          { value: "210321", label: "\u53F0\u5B89\u53BF" },
          { value: "210323", label: "\u5CAB\u5CA9\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "210381", label: "\u6D77\u57CE\u5E02" }
        ]
      },
      {
        value: "210400",
        label: "\u629A\u987A\u5E02",
        children: [
          { value: "210402", label: "\u65B0\u629A\u533A" },
          { value: "210403", label: "\u4E1C\u6D32\u533A" },
          { value: "210404", label: "\u671B\u82B1\u533A" },
          { value: "210411", label: "\u987A\u57CE\u533A" },
          { value: "210421", label: "\u629A\u987A\u53BF" },
          { value: "210422", label: "\u65B0\u5BBE\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "210423", label: "\u6E05\u539F\u6EE1\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "210500",
        label: "\u672C\u6EAA\u5E02",
        children: [
          { value: "210502", label: "\u5E73\u5C71\u533A" },
          { value: "210503", label: "\u6EAA\u6E56\u533A" },
          { value: "210504", label: "\u660E\u5C71\u533A" },
          { value: "210505", label: "\u5357\u82AC\u533A" },
          { value: "210521", label: "\u672C\u6EAA\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "210522", label: "\u6853\u4EC1\u6EE1\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "210600",
        label: "\u4E39\u4E1C\u5E02",
        children: [
          { value: "210602", label: "\u5143\u5B9D\u533A" },
          { value: "210603", label: "\u632F\u5174\u533A" },
          { value: "210604", label: "\u632F\u5B89\u533A" },
          { value: "210624", label: "\u5BBD\u7538\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "210681", label: "\u4E1C\u6E2F\u5E02" },
          { value: "210682", label: "\u51E4\u57CE\u5E02" }
        ]
      },
      {
        value: "210700",
        label: "\u9526\u5DDE\u5E02",
        children: [
          { value: "210702", label: "\u53E4\u5854\u533A" },
          { value: "210703", label: "\u51CC\u6CB3\u533A" },
          { value: "210711", label: "\u592A\u548C\u533A" },
          { value: "210726", label: "\u9ED1\u5C71\u53BF" },
          { value: "210727", label: "\u4E49\u53BF" },
          { value: "210781", label: "\u51CC\u6D77\u5E02" },
          { value: "210782", label: "\u5317\u9547\u5E02" }
        ]
      },
      {
        value: "210800",
        label: "\u8425\u53E3\u5E02",
        children: [
          { value: "210802", label: "\u7AD9\u524D\u533A" },
          { value: "210803", label: "\u897F\u5E02\u533A" },
          { value: "210804", label: "\u9C85\u9C7C\u5708\u533A" },
          { value: "210811", label: "\u8001\u8FB9\u533A" },
          { value: "210881", label: "\u76D6\u5DDE\u5E02" },
          { value: "210882", label: "\u5927\u77F3\u6865\u5E02" }
        ]
      },
      {
        value: "210900",
        label: "\u961C\u65B0\u5E02",
        children: [
          { value: "210902", label: "\u6D77\u5DDE\u533A" },
          { value: "210903", label: "\u65B0\u90B1\u533A" },
          { value: "210904", label: "\u592A\u5E73\u533A" },
          { value: "210905", label: "\u6E05\u6CB3\u95E8\u533A" },
          { value: "210911", label: "\u7EC6\u6CB3\u533A" },
          { value: "210921", label: "\u961C\u65B0\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" },
          { value: "210922", label: "\u5F70\u6B66\u53BF" }
        ]
      },
      {
        value: "211000",
        label: "\u8FBD\u9633\u5E02",
        children: [
          { value: "211002", label: "\u767D\u5854\u533A" },
          { value: "211003", label: "\u6587\u5723\u533A" },
          { value: "211004", label: "\u5B8F\u4F1F\u533A" },
          { value: "211005", label: "\u5F13\u957F\u5CAD\u533A" },
          { value: "211011", label: "\u592A\u5B50\u6CB3\u533A" },
          { value: "211021", label: "\u8FBD\u9633\u53BF" },
          { value: "211081", label: "\u706F\u5854\u5E02" }
        ]
      },
      {
        value: "211100",
        label: "\u76D8\u9526\u5E02",
        children: [
          { value: "211102", label: "\u53CC\u53F0\u5B50\u533A" },
          { value: "211103", label: "\u5174\u9686\u53F0\u533A" },
          { value: "211104", label: "\u5927\u6D3C\u533A" },
          { value: "211122", label: "\u76D8\u5C71\u53BF" }
        ]
      },
      {
        value: "211200",
        label: "\u94C1\u5CAD\u5E02",
        children: [
          { value: "211202", label: "\u94F6\u5DDE\u533A" },
          { value: "211204", label: "\u6E05\u6CB3\u533A" },
          { value: "211221", label: "\u94C1\u5CAD\u53BF" },
          { value: "211223", label: "\u897F\u4E30\u53BF" },
          { value: "211224", label: "\u660C\u56FE\u53BF" },
          { value: "211281", label: "\u8C03\u5175\u5C71\u5E02" },
          { value: "211282", label: "\u5F00\u539F\u5E02" }
        ]
      },
      {
        value: "211300",
        label: "\u671D\u9633\u5E02",
        children: [
          { value: "211302", label: "\u53CC\u5854\u533A" },
          { value: "211303", label: "\u9F99\u57CE\u533A" },
          { value: "211321", label: "\u671D\u9633\u53BF" },
          { value: "211322", label: "\u5EFA\u5E73\u53BF" },
          { value: "211324", label: "\u5580\u5587\u6C81\u5DE6\u7FFC\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" },
          { value: "211381", label: "\u5317\u7968\u5E02" },
          { value: "211382", label: "\u51CC\u6E90\u5E02" }
        ]
      },
      {
        value: "211400",
        label: "\u846B\u82A6\u5C9B\u5E02",
        children: [
          { value: "211402", label: "\u8FDE\u5C71\u533A" },
          { value: "211403", label: "\u9F99\u6E2F\u533A" },
          { value: "211404", label: "\u5357\u7968\u533A" },
          { value: "211421", label: "\u7EE5\u4E2D\u53BF" },
          { value: "211422", label: "\u5EFA\u660C\u53BF" },
          { value: "211481", label: "\u5174\u57CE\u5E02" }
        ]
      }
    ]
  },
  {
    value: "220000",
    label: "\u5409\u6797\u7701",
    children: [
      {
        value: "220100",
        label: "\u957F\u6625\u5E02",
        children: [
          { value: "220102", label: "\u5357\u5173\u533A" },
          { value: "220103", label: "\u5BBD\u57CE\u533A" },
          { value: "220104", label: "\u671D\u9633\u533A" },
          { value: "220105", label: "\u4E8C\u9053\u533A" },
          { value: "220106", label: "\u7EFF\u56ED\u533A" },
          { value: "220112", label: "\u53CC\u9633\u533A" },
          { value: "220113", label: "\u4E5D\u53F0\u533A" },
          { value: "220122", label: "\u519C\u5B89\u53BF" },
          { value: "220171", label: "\u957F\u6625\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "220172", label: "\u957F\u6625\u51C0\u6708\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "220173", label: "\u957F\u6625\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "220174", label: "\u957F\u6625\u6C7D\u8F66\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "220182", label: "\u6986\u6811\u5E02" },
          { value: "220183", label: "\u5FB7\u60E0\u5E02" }
        ]
      },
      {
        value: "220200",
        label: "\u5409\u6797\u5E02",
        children: [
          { value: "220202", label: "\u660C\u9091\u533A" },
          { value: "220203", label: "\u9F99\u6F6D\u533A" },
          { value: "220204", label: "\u8239\u8425\u533A" },
          { value: "220211", label: "\u4E30\u6EE1\u533A" },
          { value: "220221", label: "\u6C38\u5409\u53BF" },
          { value: "220271", label: "\u5409\u6797\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "220272", label: "\u5409\u6797\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "220273", label: "\u5409\u6797\u4E2D\u56FD\u65B0\u52A0\u5761\u98DF\u54C1\u533A" },
          { value: "220281", label: "\u86DF\u6CB3\u5E02" },
          { value: "220282", label: "\u6866\u7538\u5E02" },
          { value: "220283", label: "\u8212\u5170\u5E02" },
          { value: "220284", label: "\u78D0\u77F3\u5E02" }
        ]
      },
      {
        value: "220300",
        label: "\u56DB\u5E73\u5E02",
        children: [
          { value: "220302", label: "\u94C1\u897F\u533A" },
          { value: "220303", label: "\u94C1\u4E1C\u533A" },
          { value: "220322", label: "\u68A8\u6811\u53BF" },
          { value: "220323", label: "\u4F0A\u901A\u6EE1\u65CF\u81EA\u6CBB\u53BF" },
          { value: "220381", label: "\u516C\u4E3B\u5CAD\u5E02" },
          { value: "220382", label: "\u53CC\u8FBD\u5E02" }
        ]
      },
      {
        value: "220400",
        label: "\u8FBD\u6E90\u5E02",
        children: [
          { value: "220402", label: "\u9F99\u5C71\u533A" },
          { value: "220403", label: "\u897F\u5B89\u533A" },
          { value: "220421", label: "\u4E1C\u4E30\u53BF" },
          { value: "220422", label: "\u4E1C\u8FBD\u53BF" }
        ]
      },
      {
        value: "220500",
        label: "\u901A\u5316\u5E02",
        children: [
          { value: "220502", label: "\u4E1C\u660C\u533A" },
          { value: "220503", label: "\u4E8C\u9053\u6C5F\u533A" },
          { value: "220521", label: "\u901A\u5316\u53BF" },
          { value: "220523", label: "\u8F89\u5357\u53BF" },
          { value: "220524", label: "\u67F3\u6CB3\u53BF" },
          { value: "220581", label: "\u6885\u6CB3\u53E3\u5E02" },
          { value: "220582", label: "\u96C6\u5B89\u5E02" }
        ]
      },
      {
        value: "220600",
        label: "\u767D\u5C71\u5E02",
        children: [
          { value: "220602", label: "\u6D51\u6C5F\u533A" },
          { value: "220605", label: "\u6C5F\u6E90\u533A" },
          { value: "220621", label: "\u629A\u677E\u53BF" },
          { value: "220622", label: "\u9756\u5B87\u53BF" },
          { value: "220623", label: "\u957F\u767D\u671D\u9C9C\u65CF\u81EA\u6CBB\u53BF" },
          { value: "220681", label: "\u4E34\u6C5F\u5E02" }
        ]
      },
      {
        value: "220700",
        label: "\u677E\u539F\u5E02",
        children: [
          { value: "220702", label: "\u5B81\u6C5F\u533A" },
          { value: "220721", label: "\u524D\u90ED\u5C14\u7F57\u65AF\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" },
          { value: "220722", label: "\u957F\u5CAD\u53BF" },
          { value: "220723", label: "\u4E7E\u5B89\u53BF" },
          { value: "220771", label: "\u5409\u6797\u677E\u539F\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "220781", label: "\u6276\u4F59\u5E02" }
        ]
      },
      {
        value: "220800",
        label: "\u767D\u57CE\u5E02",
        children: [
          { value: "220802", label: "\u6D2E\u5317\u533A" },
          { value: "220821", label: "\u9547\u8D49\u53BF" },
          { value: "220822", label: "\u901A\u6986\u53BF" },
          { value: "220871", label: "\u5409\u6797\u767D\u57CE\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "220881", label: "\u6D2E\u5357\u5E02" },
          { value: "220882", label: "\u5927\u5B89\u5E02" }
        ]
      },
      {
        value: "222400",
        label: "\u5EF6\u8FB9\u671D\u9C9C\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "222401", label: "\u5EF6\u5409\u5E02" },
          { value: "222402", label: "\u56FE\u4EEC\u5E02" },
          { value: "222403", label: "\u6566\u5316\u5E02" },
          { value: "222404", label: "\u73F2\u6625\u5E02" },
          { value: "222405", label: "\u9F99\u4E95\u5E02" },
          { value: "222406", label: "\u548C\u9F99\u5E02" },
          { value: "222424", label: "\u6C6A\u6E05\u53BF" },
          { value: "222426", label: "\u5B89\u56FE\u53BF" }
        ]
      }
    ]
  },
  {
    value: "230000",
    label: "\u9ED1\u9F99\u6C5F\u7701",
    children: [
      {
        value: "230100",
        label: "\u54C8\u5C14\u6EE8\u5E02",
        children: [
          { value: "230102", label: "\u9053\u91CC\u533A" },
          { value: "230103", label: "\u5357\u5C97\u533A" },
          { value: "230104", label: "\u9053\u5916\u533A" },
          { value: "230108", label: "\u5E73\u623F\u533A" },
          { value: "230109", label: "\u677E\u5317\u533A" },
          { value: "230110", label: "\u9999\u574A\u533A" },
          { value: "230111", label: "\u547C\u5170\u533A" },
          { value: "230112", label: "\u963F\u57CE\u533A" },
          { value: "230113", label: "\u53CC\u57CE\u533A" },
          { value: "230123", label: "\u4F9D\u5170\u53BF" },
          { value: "230124", label: "\u65B9\u6B63\u53BF" },
          { value: "230125", label: "\u5BBE\u53BF" },
          { value: "230126", label: "\u5DF4\u5F66\u53BF" },
          { value: "230127", label: "\u6728\u5170\u53BF" },
          { value: "230128", label: "\u901A\u6CB3\u53BF" },
          { value: "230129", label: "\u5EF6\u5BFF\u53BF" },
          { value: "230183", label: "\u5C1A\u5FD7\u5E02" },
          { value: "230184", label: "\u4E94\u5E38\u5E02" }
        ]
      },
      {
        value: "230200",
        label: "\u9F50\u9F50\u54C8\u5C14\u5E02",
        children: [
          { value: "230202", label: "\u9F99\u6C99\u533A" },
          { value: "230203", label: "\u5EFA\u534E\u533A" },
          { value: "230204", label: "\u94C1\u950B\u533A" },
          { value: "230205", label: "\u6602\u6602\u6EAA\u533A" },
          { value: "230206", label: "\u5BCC\u62C9\u5C14\u57FA\u533A" },
          { value: "230207", label: "\u78BE\u5B50\u5C71\u533A" },
          { value: "230208", label: "\u6885\u91CC\u65AF\u8FBE\u65A1\u5C14\u65CF\u533A" },
          { value: "230221", label: "\u9F99\u6C5F\u53BF" },
          { value: "230223", label: "\u4F9D\u5B89\u53BF" },
          { value: "230224", label: "\u6CF0\u6765\u53BF" },
          { value: "230225", label: "\u7518\u5357\u53BF" },
          { value: "230227", label: "\u5BCC\u88D5\u53BF" },
          { value: "230229", label: "\u514B\u5C71\u53BF" },
          { value: "230230", label: "\u514B\u4E1C\u53BF" },
          { value: "230231", label: "\u62DC\u6CC9\u53BF" },
          { value: "230281", label: "\u8BB7\u6CB3\u5E02" }
        ]
      },
      {
        value: "230300",
        label: "\u9E21\u897F\u5E02",
        children: [
          { value: "230302", label: "\u9E21\u51A0\u533A" },
          { value: "230303", label: "\u6052\u5C71\u533A" },
          { value: "230304", label: "\u6EF4\u9053\u533A" },
          { value: "230305", label: "\u68A8\u6811\u533A" },
          { value: "230306", label: "\u57CE\u5B50\u6CB3\u533A" },
          { value: "230307", label: "\u9EBB\u5C71\u533A" },
          { value: "230321", label: "\u9E21\u4E1C\u53BF" },
          { value: "230381", label: "\u864E\u6797\u5E02" },
          { value: "230382", label: "\u5BC6\u5C71\u5E02" }
        ]
      },
      {
        value: "230400",
        label: "\u9E64\u5C97\u5E02",
        children: [
          { value: "230402", label: "\u5411\u9633\u533A" },
          { value: "230403", label: "\u5DE5\u519C\u533A" },
          { value: "230404", label: "\u5357\u5C71\u533A" },
          { value: "230405", label: "\u5174\u5B89\u533A" },
          { value: "230406", label: "\u4E1C\u5C71\u533A" },
          { value: "230407", label: "\u5174\u5C71\u533A" },
          { value: "230421", label: "\u841D\u5317\u53BF" },
          { value: "230422", label: "\u7EE5\u6EE8\u53BF" }
        ]
      },
      {
        value: "230500",
        label: "\u53CC\u9E2D\u5C71\u5E02",
        children: [
          { value: "230502", label: "\u5C16\u5C71\u533A" },
          { value: "230503", label: "\u5CAD\u4E1C\u533A" },
          { value: "230505", label: "\u56DB\u65B9\u53F0\u533A" },
          { value: "230506", label: "\u5B9D\u5C71\u533A" },
          { value: "230521", label: "\u96C6\u8D24\u53BF" },
          { value: "230522", label: "\u53CB\u8C0A\u53BF" },
          { value: "230523", label: "\u5B9D\u6E05\u53BF" },
          { value: "230524", label: "\u9976\u6CB3\u53BF" }
        ]
      },
      {
        value: "230600",
        label: "\u5927\u5E86\u5E02",
        children: [
          { value: "230602", label: "\u8428\u5C14\u56FE\u533A" },
          { value: "230603", label: "\u9F99\u51E4\u533A" },
          { value: "230604", label: "\u8BA9\u80E1\u8DEF\u533A" },
          { value: "230605", label: "\u7EA2\u5C97\u533A" },
          { value: "230606", label: "\u5927\u540C\u533A" },
          { value: "230621", label: "\u8087\u5DDE\u53BF" },
          { value: "230622", label: "\u8087\u6E90\u53BF" },
          { value: "230623", label: "\u6797\u7538\u53BF" },
          { value: "230624", label: "\u675C\u5C14\u4F2F\u7279\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" },
          { value: "230671", label: "\u5927\u5E86\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "230700",
        label: "\u4F0A\u6625\u5E02",
        children: [
          { value: "230717", label: "\u4F0A\u7F8E\u533A" },
          { value: "230718", label: "\u4E4C\u7FE0\u533A" },
          { value: "230719", label: "\u53CB\u597D\u533A" },
          { value: "230722", label: "\u5609\u836B\u53BF" },
          { value: "230723", label: "\u6C64\u65FA\u53BF" },
          { value: "230724", label: "\u4E30\u6797\u53BF" },
          { value: "230725", label: "\u5927\u7B90\u5C71\u53BF" },
          { value: "230726", label: "\u5357\u5C94\u53BF" },
          { value: "230751", label: "\u91D1\u6797\u533A" },
          { value: "230781", label: "\u94C1\u529B\u5E02" }
        ]
      },
      {
        value: "230800",
        label: "\u4F73\u6728\u65AF\u5E02",
        children: [
          { value: "230803", label: "\u5411\u9633\u533A" },
          { value: "230804", label: "\u524D\u8FDB\u533A" },
          { value: "230805", label: "\u4E1C\u98CE\u533A" },
          { value: "230811", label: "\u90CA\u533A" },
          { value: "230822", label: "\u6866\u5357\u53BF" },
          { value: "230826", label: "\u6866\u5DDD\u53BF" },
          { value: "230828", label: "\u6C64\u539F\u53BF" },
          { value: "230881", label: "\u540C\u6C5F\u5E02" },
          { value: "230882", label: "\u5BCC\u9526\u5E02" },
          { value: "230883", label: "\u629A\u8FDC\u5E02" }
        ]
      },
      {
        value: "230900",
        label: "\u4E03\u53F0\u6CB3\u5E02",
        children: [
          { value: "230902", label: "\u65B0\u5174\u533A" },
          { value: "230903", label: "\u6843\u5C71\u533A" },
          { value: "230904", label: "\u8304\u5B50\u6CB3\u533A" },
          { value: "230921", label: "\u52C3\u5229\u53BF" }
        ]
      },
      {
        value: "231000",
        label: "\u7261\u4E39\u6C5F\u5E02",
        children: [
          { value: "231002", label: "\u4E1C\u5B89\u533A" },
          { value: "231003", label: "\u9633\u660E\u533A" },
          { value: "231004", label: "\u7231\u6C11\u533A" },
          { value: "231005", label: "\u897F\u5B89\u533A" },
          { value: "231025", label: "\u6797\u53E3\u53BF" },
          { value: "231071", label: "\u7261\u4E39\u6C5F\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "231081", label: "\u7EE5\u82AC\u6CB3\u5E02" },
          { value: "231083", label: "\u6D77\u6797\u5E02" },
          { value: "231084", label: "\u5B81\u5B89\u5E02" },
          { value: "231085", label: "\u7A46\u68F1\u5E02" },
          { value: "231086", label: "\u4E1C\u5B81\u5E02" }
        ]
      },
      {
        value: "231100",
        label: "\u9ED1\u6CB3\u5E02",
        children: [
          { value: "231102", label: "\u7231\u8F89\u533A" },
          { value: "231123", label: "\u900A\u514B\u53BF" },
          { value: "231124", label: "\u5B59\u5434\u53BF" },
          { value: "231181", label: "\u5317\u5B89\u5E02" },
          { value: "231182", label: "\u4E94\u5927\u8FDE\u6C60\u5E02" },
          { value: "231183", label: "\u5AE9\u6C5F\u5E02" }
        ]
      },
      {
        value: "231200",
        label: "\u7EE5\u5316\u5E02",
        children: [
          { value: "231202", label: "\u5317\u6797\u533A" },
          { value: "231221", label: "\u671B\u594E\u53BF" },
          { value: "231222", label: "\u5170\u897F\u53BF" },
          { value: "231223", label: "\u9752\u5188\u53BF" },
          { value: "231224", label: "\u5E86\u5B89\u53BF" },
          { value: "231225", label: "\u660E\u6C34\u53BF" },
          { value: "231226", label: "\u7EE5\u68F1\u53BF" },
          { value: "231281", label: "\u5B89\u8FBE\u5E02" },
          { value: "231282", label: "\u8087\u4E1C\u5E02" },
          { value: "231283", label: "\u6D77\u4F26\u5E02" }
        ]
      },
      {
        value: "232700",
        label: "\u5927\u5174\u5B89\u5CAD\u5730\u533A",
        children: [
          { value: "232701", label: "\u6F20\u6CB3\u5E02" },
          { value: "232721", label: "\u547C\u739B\u53BF" },
          { value: "232722", label: "\u5854\u6CB3\u53BF" },
          { value: "232761", label: "\u52A0\u683C\u8FBE\u5947\u533A" },
          { value: "232762", label: "\u677E\u5CAD\u533A" },
          { value: "232763", label: "\u65B0\u6797\u533A" },
          { value: "232764", label: "\u547C\u4E2D\u533A" }
        ]
      }
    ]
  },
  {
    value: "310000",
    label: "\u4E0A\u6D77\u5E02",
    children: [
      {
        value: "310100",
        label: "\u4E0A\u6D77\u5E02",
        children: [
          { value: "310101", label: "\u9EC4\u6D66\u533A" },
          { value: "310104", label: "\u5F90\u6C47\u533A" },
          { value: "310105", label: "\u957F\u5B81\u533A" },
          { value: "310106", label: "\u9759\u5B89\u533A" },
          { value: "310107", label: "\u666E\u9640\u533A" },
          { value: "310109", label: "\u8679\u53E3\u533A" },
          { value: "310110", label: "\u6768\u6D66\u533A" },
          { value: "310112", label: "\u95F5\u884C\u533A" },
          { value: "310113", label: "\u5B9D\u5C71\u533A" },
          { value: "310114", label: "\u5609\u5B9A\u533A" },
          { value: "310115", label: "\u6D66\u4E1C\u65B0\u533A" },
          { value: "310116", label: "\u91D1\u5C71\u533A" },
          { value: "310117", label: "\u677E\u6C5F\u533A" },
          { value: "310118", label: "\u9752\u6D66\u533A" },
          { value: "310120", label: "\u5949\u8D24\u533A" },
          { value: "310151", label: "\u5D07\u660E\u533A" }
        ]
      }
    ]
  },
  {
    value: "320000",
    label: "\u6C5F\u82CF\u7701",
    children: [
      {
        value: "320100",
        label: "\u5357\u4EAC\u5E02",
        children: [
          { value: "320102", label: "\u7384\u6B66\u533A" },
          { value: "320104", label: "\u79E6\u6DEE\u533A" },
          { value: "320105", label: "\u5EFA\u90BA\u533A" },
          { value: "320106", label: "\u9F13\u697C\u533A" },
          { value: "320111", label: "\u6D66\u53E3\u533A" },
          { value: "320113", label: "\u6816\u971E\u533A" },
          { value: "320114", label: "\u96E8\u82B1\u53F0\u533A" },
          { value: "320115", label: "\u6C5F\u5B81\u533A" },
          { value: "320116", label: "\u516D\u5408\u533A" },
          { value: "320117", label: "\u6EA7\u6C34\u533A" },
          { value: "320118", label: "\u9AD8\u6DF3\u533A" }
        ]
      },
      {
        value: "320200",
        label: "\u65E0\u9521\u5E02",
        children: [
          { value: "320205", label: "\u9521\u5C71\u533A" },
          { value: "320206", label: "\u60E0\u5C71\u533A" },
          { value: "320211", label: "\u6EE8\u6E56\u533A" },
          { value: "320213", label: "\u6881\u6EAA\u533A" },
          { value: "320214", label: "\u65B0\u5434\u533A" },
          { value: "320281", label: "\u6C5F\u9634\u5E02" },
          { value: "320282", label: "\u5B9C\u5174\u5E02" }
        ]
      },
      {
        value: "320300",
        label: "\u5F90\u5DDE\u5E02",
        children: [
          { value: "320302", label: "\u9F13\u697C\u533A" },
          { value: "320303", label: "\u4E91\u9F99\u533A" },
          { value: "320305", label: "\u8D3E\u6C6A\u533A" },
          { value: "320311", label: "\u6CC9\u5C71\u533A" },
          { value: "320312", label: "\u94DC\u5C71\u533A" },
          { value: "320321", label: "\u4E30\u53BF" },
          { value: "320322", label: "\u6C9B\u53BF" },
          { value: "320324", label: "\u7762\u5B81\u53BF" },
          { value: "320371", label: "\u5F90\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "320381", label: "\u65B0\u6C82\u5E02" },
          { value: "320382", label: "\u90B3\u5DDE\u5E02" }
        ]
      },
      {
        value: "320400",
        label: "\u5E38\u5DDE\u5E02",
        children: [
          { value: "320402", label: "\u5929\u5B81\u533A" },
          { value: "320404", label: "\u949F\u697C\u533A" },
          { value: "320411", label: "\u65B0\u5317\u533A" },
          { value: "320412", label: "\u6B66\u8FDB\u533A" },
          { value: "320413", label: "\u91D1\u575B\u533A" },
          { value: "320481", label: "\u6EA7\u9633\u5E02" }
        ]
      },
      {
        value: "320500",
        label: "\u82CF\u5DDE\u5E02",
        children: [
          { value: "320505", label: "\u864E\u4E18\u533A" },
          { value: "320506", label: "\u5434\u4E2D\u533A" },
          { value: "320507", label: "\u76F8\u57CE\u533A" },
          { value: "320508", label: "\u59D1\u82CF\u533A" },
          { value: "320509", label: "\u5434\u6C5F\u533A" },
          { value: "320571", label: "\u82CF\u5DDE\u5DE5\u4E1A\u56ED\u533A" },
          { value: "320581", label: "\u5E38\u719F\u5E02" },
          { value: "320582", label: "\u5F20\u5BB6\u6E2F\u5E02" },
          { value: "320583", label: "\u6606\u5C71\u5E02" },
          { value: "320585", label: "\u592A\u4ED3\u5E02" }
        ]
      },
      {
        value: "320600",
        label: "\u5357\u901A\u5E02",
        children: [
          { value: "320602", label: "\u5D07\u5DDD\u533A" },
          { value: "320611", label: "\u6E2F\u95F8\u533A" },
          { value: "320612", label: "\u901A\u5DDE\u533A" },
          { value: "320623", label: "\u5982\u4E1C\u53BF" },
          { value: "320671", label: "\u5357\u901A\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "320681", label: "\u542F\u4E1C\u5E02" },
          { value: "320682", label: "\u5982\u768B\u5E02" },
          { value: "320684", label: "\u6D77\u95E8\u5E02" },
          { value: "320685", label: "\u6D77\u5B89\u5E02" }
        ]
      },
      {
        value: "320700",
        label: "\u8FDE\u4E91\u6E2F\u5E02",
        children: [
          { value: "320703", label: "\u8FDE\u4E91\u533A" },
          { value: "320706", label: "\u6D77\u5DDE\u533A" },
          { value: "320707", label: "\u8D63\u6986\u533A" },
          { value: "320722", label: "\u4E1C\u6D77\u53BF" },
          { value: "320723", label: "\u704C\u4E91\u53BF" },
          { value: "320724", label: "\u704C\u5357\u53BF" },
          { value: "320771", label: "\u8FDE\u4E91\u6E2F\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "320772", label: "\u8FDE\u4E91\u6E2F\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "320800",
        label: "\u6DEE\u5B89\u5E02",
        children: [
          { value: "320803", label: "\u6DEE\u5B89\u533A" },
          { value: "320804", label: "\u6DEE\u9634\u533A" },
          { value: "320812", label: "\u6E05\u6C5F\u6D66\u533A" },
          { value: "320813", label: "\u6D2A\u6CFD\u533A" },
          { value: "320826", label: "\u6D9F\u6C34\u53BF" },
          { value: "320830", label: "\u76F1\u7719\u53BF" },
          { value: "320831", label: "\u91D1\u6E56\u53BF" },
          { value: "320871", label: "\u6DEE\u5B89\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "320900",
        label: "\u76D0\u57CE\u5E02",
        children: [
          { value: "320902", label: "\u4EAD\u6E56\u533A" },
          { value: "320903", label: "\u76D0\u90FD\u533A" },
          { value: "320904", label: "\u5927\u4E30\u533A" },
          { value: "320921", label: "\u54CD\u6C34\u53BF" },
          { value: "320922", label: "\u6EE8\u6D77\u53BF" },
          { value: "320923", label: "\u961C\u5B81\u53BF" },
          { value: "320924", label: "\u5C04\u9633\u53BF" },
          { value: "320925", label: "\u5EFA\u6E56\u53BF" },
          { value: "320971", label: "\u76D0\u57CE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "320981", label: "\u4E1C\u53F0\u5E02" }
        ]
      },
      {
        value: "321000",
        label: "\u626C\u5DDE\u5E02",
        children: [
          { value: "321002", label: "\u5E7F\u9675\u533A" },
          { value: "321003", label: "\u9097\u6C5F\u533A" },
          { value: "321012", label: "\u6C5F\u90FD\u533A" },
          { value: "321023", label: "\u5B9D\u5E94\u53BF" },
          { value: "321071", label: "\u626C\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "321081", label: "\u4EEA\u5F81\u5E02" },
          { value: "321084", label: "\u9AD8\u90AE\u5E02" }
        ]
      },
      {
        value: "321100",
        label: "\u9547\u6C5F\u5E02",
        children: [
          { value: "321102", label: "\u4EAC\u53E3\u533A" },
          { value: "321111", label: "\u6DA6\u5DDE\u533A" },
          { value: "321112", label: "\u4E39\u5F92\u533A" },
          { value: "321171", label: "\u9547\u6C5F\u65B0\u533A" },
          { value: "321181", label: "\u4E39\u9633\u5E02" },
          { value: "321182", label: "\u626C\u4E2D\u5E02" },
          { value: "321183", label: "\u53E5\u5BB9\u5E02" }
        ]
      },
      {
        value: "321200",
        label: "\u6CF0\u5DDE\u5E02",
        children: [
          { value: "321202", label: "\u6D77\u9675\u533A" },
          { value: "321203", label: "\u9AD8\u6E2F\u533A" },
          { value: "321204", label: "\u59DC\u5830\u533A" },
          { value: "321271", label: "\u6CF0\u5DDE\u533B\u836F\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "321281", label: "\u5174\u5316\u5E02" },
          { value: "321282", label: "\u9756\u6C5F\u5E02" },
          { value: "321283", label: "\u6CF0\u5174\u5E02" }
        ]
      },
      {
        value: "321300",
        label: "\u5BBF\u8FC1\u5E02",
        children: [
          { value: "321302", label: "\u5BBF\u57CE\u533A" },
          { value: "321311", label: "\u5BBF\u8C6B\u533A" },
          { value: "321322", label: "\u6CAD\u9633\u53BF" },
          { value: "321323", label: "\u6CD7\u9633\u53BF" },
          { value: "321324", label: "\u6CD7\u6D2A\u53BF" },
          { value: "321371", label: "\u5BBF\u8FC1\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      }
    ]
  },
  {
    value: "330000",
    label: "\u6D59\u6C5F\u7701",
    children: [
      {
        value: "330100",
        label: "\u676D\u5DDE\u5E02",
        children: [
          { value: "330102", label: "\u4E0A\u57CE\u533A" },
          { value: "330105", label: "\u62F1\u5885\u533A" },
          { value: "330106", label: "\u897F\u6E56\u533A" },
          { value: "330108", label: "\u6EE8\u6C5F\u533A" },
          { value: "330109", label: "\u8427\u5C71\u533A" },
          { value: "330110", label: "\u4F59\u676D\u533A" },
          { value: "330111", label: "\u5BCC\u9633\u533A" },
          { value: "330112", label: "\u4E34\u5B89\u533A" },
          { value: "330113", label: "\u4E34\u5E73\u533A" },
          { value: "330114", label: "\u94B1\u5858\u533A" },
          { value: "330122", label: "\u6850\u5E90\u53BF" },
          { value: "330127", label: "\u6DF3\u5B89\u53BF" },
          { value: "330182", label: "\u5EFA\u5FB7\u5E02" }
        ]
      },
      {
        value: "330200",
        label: "\u5B81\u6CE2\u5E02",
        children: [
          { value: "330203", label: "\u6D77\u66D9\u533A" },
          { value: "330205", label: "\u6C5F\u5317\u533A" },
          { value: "330206", label: "\u5317\u4ED1\u533A" },
          { value: "330211", label: "\u9547\u6D77\u533A" },
          { value: "330212", label: "\u911E\u5DDE\u533A" },
          { value: "330213", label: "\u5949\u5316\u533A" },
          { value: "330225", label: "\u8C61\u5C71\u53BF" },
          { value: "330226", label: "\u5B81\u6D77\u53BF" },
          { value: "330281", label: "\u4F59\u59DA\u5E02" },
          { value: "330282", label: "\u6148\u6EAA\u5E02" }
        ]
      },
      {
        value: "330300",
        label: "\u6E29\u5DDE\u5E02",
        children: [
          { value: "330302", label: "\u9E7F\u57CE\u533A" },
          { value: "330303", label: "\u9F99\u6E7E\u533A" },
          { value: "330304", label: "\u74EF\u6D77\u533A" },
          { value: "330305", label: "\u6D1E\u5934\u533A" },
          { value: "330324", label: "\u6C38\u5609\u53BF" },
          { value: "330326", label: "\u5E73\u9633\u53BF" },
          { value: "330327", label: "\u82CD\u5357\u53BF" },
          { value: "330328", label: "\u6587\u6210\u53BF" },
          { value: "330329", label: "\u6CF0\u987A\u53BF" },
          { value: "330371", label: "\u6E29\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "330381", label: "\u745E\u5B89\u5E02" },
          { value: "330382", label: "\u4E50\u6E05\u5E02" },
          { value: "330383", label: "\u9F99\u6E2F\u5E02" }
        ]
      },
      {
        value: "330400",
        label: "\u5609\u5174\u5E02",
        children: [
          { value: "330402", label: "\u5357\u6E56\u533A" },
          { value: "330411", label: "\u79C0\u6D32\u533A" },
          { value: "330421", label: "\u5609\u5584\u53BF" },
          { value: "330424", label: "\u6D77\u76D0\u53BF" },
          { value: "330481", label: "\u6D77\u5B81\u5E02" },
          { value: "330482", label: "\u5E73\u6E56\u5E02" },
          { value: "330483", label: "\u6850\u4E61\u5E02" }
        ]
      },
      {
        value: "330500",
        label: "\u6E56\u5DDE\u5E02",
        children: [
          { value: "330502", label: "\u5434\u5174\u533A" },
          { value: "330503", label: "\u5357\u6D54\u533A" },
          { value: "330521", label: "\u5FB7\u6E05\u53BF" },
          { value: "330522", label: "\u957F\u5174\u53BF" },
          { value: "330523", label: "\u5B89\u5409\u53BF" }
        ]
      },
      {
        value: "330600",
        label: "\u7ECD\u5174\u5E02",
        children: [
          { value: "330602", label: "\u8D8A\u57CE\u533A" },
          { value: "330603", label: "\u67EF\u6865\u533A" },
          { value: "330604", label: "\u4E0A\u865E\u533A" },
          { value: "330624", label: "\u65B0\u660C\u53BF" },
          { value: "330681", label: "\u8BF8\u66A8\u5E02" },
          { value: "330683", label: "\u5D4A\u5DDE\u5E02" }
        ]
      },
      {
        value: "330700",
        label: "\u91D1\u534E\u5E02",
        children: [
          { value: "330702", label: "\u5A7A\u57CE\u533A" },
          { value: "330703", label: "\u91D1\u4E1C\u533A" },
          { value: "330723", label: "\u6B66\u4E49\u53BF" },
          { value: "330726", label: "\u6D66\u6C5F\u53BF" },
          { value: "330727", label: "\u78D0\u5B89\u53BF" },
          { value: "330781", label: "\u5170\u6EAA\u5E02" },
          { value: "330782", label: "\u4E49\u4E4C\u5E02" },
          { value: "330783", label: "\u4E1C\u9633\u5E02" },
          { value: "330784", label: "\u6C38\u5EB7\u5E02" }
        ]
      },
      {
        value: "330800",
        label: "\u8862\u5DDE\u5E02",
        children: [
          { value: "330802", label: "\u67EF\u57CE\u533A" },
          { value: "330803", label: "\u8862\u6C5F\u533A" },
          { value: "330822", label: "\u5E38\u5C71\u53BF" },
          { value: "330824", label: "\u5F00\u5316\u53BF" },
          { value: "330825", label: "\u9F99\u6E38\u53BF" },
          { value: "330881", label: "\u6C5F\u5C71\u5E02" }
        ]
      },
      {
        value: "330900",
        label: "\u821F\u5C71\u5E02",
        children: [
          { value: "330902", label: "\u5B9A\u6D77\u533A" },
          { value: "330903", label: "\u666E\u9640\u533A" },
          { value: "330921", label: "\u5CB1\u5C71\u53BF" },
          { value: "330922", label: "\u5D4A\u6CD7\u53BF" }
        ]
      },
      {
        value: "331000",
        label: "\u53F0\u5DDE\u5E02",
        children: [
          { value: "331002", label: "\u6912\u6C5F\u533A" },
          { value: "331003", label: "\u9EC4\u5CA9\u533A" },
          { value: "331004", label: "\u8DEF\u6865\u533A" },
          { value: "331022", label: "\u4E09\u95E8\u53BF" },
          { value: "331023", label: "\u5929\u53F0\u53BF" },
          { value: "331024", label: "\u4ED9\u5C45\u53BF" },
          { value: "331081", label: "\u6E29\u5CAD\u5E02" },
          { value: "331082", label: "\u4E34\u6D77\u5E02" },
          { value: "331083", label: "\u7389\u73AF\u5E02" }
        ]
      },
      {
        value: "331100",
        label: "\u4E3D\u6C34\u5E02",
        children: [
          { value: "331102", label: "\u83B2\u90FD\u533A" },
          { value: "331121", label: "\u9752\u7530\u53BF" },
          { value: "331122", label: "\u7F19\u4E91\u53BF" },
          { value: "331123", label: "\u9042\u660C\u53BF" },
          { value: "331124", label: "\u677E\u9633\u53BF" },
          { value: "331125", label: "\u4E91\u548C\u53BF" },
          { value: "331126", label: "\u5E86\u5143\u53BF" },
          { value: "331127", label: "\u666F\u5B81\u7572\u65CF\u81EA\u6CBB\u53BF" },
          { value: "331181", label: "\u9F99\u6CC9\u5E02" }
        ]
      }
    ]
  },
  {
    value: "340000",
    label: "\u5B89\u5FBD\u7701",
    children: [
      {
        value: "340100",
        label: "\u5408\u80A5\u5E02",
        children: [
          { value: "340102", label: "\u7476\u6D77\u533A" },
          { value: "340103", label: "\u5E90\u9633\u533A" },
          { value: "340104", label: "\u8700\u5C71\u533A" },
          { value: "340111", label: "\u5305\u6CB3\u533A" },
          { value: "340121", label: "\u957F\u4E30\u53BF" },
          { value: "340122", label: "\u80A5\u4E1C\u53BF" },
          { value: "340123", label: "\u80A5\u897F\u53BF" },
          { value: "340124", label: "\u5E90\u6C5F\u53BF" },
          { value: "340171", label: "\u5408\u80A5\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "340172", label: "\u5408\u80A5\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "340173", label: "\u5408\u80A5\u65B0\u7AD9\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "340181", label: "\u5DE2\u6E56\u5E02" }
        ]
      },
      {
        value: "340200",
        label: "\u829C\u6E56\u5E02",
        children: [
          { value: "340202", label: "\u955C\u6E56\u533A" },
          { value: "340203", label: "\u5F0B\u6C5F\u533A" },
          { value: "340207", label: "\u9E20\u6C5F\u533A" },
          { value: "340208", label: "\u4E09\u5C71\u533A" },
          { value: "340221", label: "\u829C\u6E56\u53BF" },
          { value: "340222", label: "\u7E41\u660C\u53BF" },
          { value: "340223", label: "\u5357\u9675\u53BF" },
          { value: "340225", label: "\u65E0\u4E3A\u53BF" },
          { value: "340271", label: "\u829C\u6E56\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "340272", label: "\u5B89\u5FBD\u829C\u6E56\u957F\u6C5F\u5927\u6865\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "340300",
        label: "\u868C\u57E0\u5E02",
        children: [
          { value: "340302", label: "\u9F99\u5B50\u6E56\u533A" },
          { value: "340303", label: "\u868C\u5C71\u533A" },
          { value: "340304", label: "\u79B9\u4F1A\u533A" },
          { value: "340311", label: "\u6DEE\u4E0A\u533A" },
          { value: "340321", label: "\u6000\u8FDC\u53BF" },
          { value: "340322", label: "\u4E94\u6CB3\u53BF" },
          { value: "340323", label: "\u56FA\u9547\u53BF" },
          { value: "340371", label: "\u868C\u57E0\u5E02\u9AD8\u65B0\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "340372", label: "\u868C\u57E0\u5E02\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "340400",
        label: "\u6DEE\u5357\u5E02",
        children: [
          { value: "340402", label: "\u5927\u901A\u533A" },
          { value: "340403", label: "\u7530\u5BB6\u5EB5\u533A" },
          { value: "340404", label: "\u8C22\u5BB6\u96C6\u533A" },
          { value: "340405", label: "\u516B\u516C\u5C71\u533A" },
          { value: "340406", label: "\u6F58\u96C6\u533A" },
          { value: "340421", label: "\u51E4\u53F0\u53BF" },
          { value: "340422", label: "\u5BFF\u53BF" }
        ]
      },
      {
        value: "340500",
        label: "\u9A6C\u978D\u5C71\u5E02",
        children: [
          { value: "340503", label: "\u82B1\u5C71\u533A" },
          { value: "340504", label: "\u96E8\u5C71\u533A" },
          { value: "340506", label: "\u535A\u671B\u533A" },
          { value: "340521", label: "\u5F53\u6D82\u53BF" },
          { value: "340522", label: "\u542B\u5C71\u53BF" },
          { value: "340523", label: "\u548C\u53BF" }
        ]
      },
      {
        value: "340600",
        label: "\u6DEE\u5317\u5E02",
        children: [
          { value: "340602", label: "\u675C\u96C6\u533A" },
          { value: "340603", label: "\u76F8\u5C71\u533A" },
          { value: "340604", label: "\u70C8\u5C71\u533A" },
          { value: "340621", label: "\u6FC9\u6EAA\u53BF" }
        ]
      },
      {
        value: "340700",
        label: "\u94DC\u9675\u5E02",
        children: [
          { value: "340705", label: "\u94DC\u5B98\u533A" },
          { value: "340706", label: "\u4E49\u5B89\u533A" },
          { value: "340711", label: "\u90CA\u533A" },
          { value: "340722", label: "\u679E\u9633\u53BF" }
        ]
      },
      {
        value: "340800",
        label: "\u5B89\u5E86\u5E02",
        children: [
          { value: "340802", label: "\u8FCE\u6C5F\u533A" },
          { value: "340803", label: "\u5927\u89C2\u533A" },
          { value: "340811", label: "\u5B9C\u79C0\u533A" },
          { value: "340822", label: "\u6000\u5B81\u53BF" },
          { value: "340825", label: "\u592A\u6E56\u53BF" },
          { value: "340826", label: "\u5BBF\u677E\u53BF" },
          { value: "340827", label: "\u671B\u6C5F\u53BF" },
          { value: "340828", label: "\u5CB3\u897F\u53BF" },
          { value: "340871", label: "\u5B89\u5FBD\u5B89\u5E86\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "340881", label: "\u6850\u57CE\u5E02" },
          { value: "340882", label: "\u6F5C\u5C71\u5E02" }
        ]
      },
      {
        value: "341000",
        label: "\u9EC4\u5C71\u5E02",
        children: [
          { value: "341002", label: "\u5C6F\u6EAA\u533A" },
          { value: "341003", label: "\u9EC4\u5C71\u533A" },
          { value: "341004", label: "\u5FBD\u5DDE\u533A" },
          { value: "341021", label: "\u6B59\u53BF" },
          { value: "341022", label: "\u4F11\u5B81\u53BF" },
          { value: "341023", label: "\u9EDF\u53BF" },
          { value: "341024", label: "\u7941\u95E8\u53BF" }
        ]
      },
      {
        value: "341100",
        label: "\u6EC1\u5DDE\u5E02",
        children: [
          { value: "341102", label: "\u7405\u740A\u533A" },
          { value: "341103", label: "\u5357\u8C2F\u533A" },
          { value: "341122", label: "\u6765\u5B89\u53BF" },
          { value: "341124", label: "\u5168\u6912\u53BF" },
          { value: "341125", label: "\u5B9A\u8FDC\u53BF" },
          { value: "341126", label: "\u51E4\u9633\u53BF" },
          { value: "341171", label: "\u82CF\u6EC1\u73B0\u4EE3\u4EA7\u4E1A\u56ED" },
          { value: "341172", label: "\u6EC1\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "341181", label: "\u5929\u957F\u5E02" },
          { value: "341182", label: "\u660E\u5149\u5E02" }
        ]
      },
      {
        value: "341200",
        label: "\u961C\u9633\u5E02",
        children: [
          { value: "341202", label: "\u988D\u5DDE\u533A" },
          { value: "341203", label: "\u988D\u4E1C\u533A" },
          { value: "341204", label: "\u988D\u6CC9\u533A" },
          { value: "341221", label: "\u4E34\u6CC9\u53BF" },
          { value: "341222", label: "\u592A\u548C\u53BF" },
          { value: "341225", label: "\u961C\u5357\u53BF" },
          { value: "341226", label: "\u988D\u4E0A\u53BF" },
          { value: "341271", label: "\u961C\u9633\u5408\u80A5\u73B0\u4EE3\u4EA7\u4E1A\u56ED\u533A" },
          { value: "341272", label: "\u961C\u9633\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "341282", label: "\u754C\u9996\u5E02" }
        ]
      },
      {
        value: "341300",
        label: "\u5BBF\u5DDE\u5E02",
        children: [
          { value: "341302", label: "\u57C7\u6865\u533A" },
          { value: "341321", label: "\u7800\u5C71\u53BF" },
          { value: "341322", label: "\u8427\u53BF" },
          { value: "341323", label: "\u7075\u74A7\u53BF" },
          { value: "341324", label: "\u6CD7\u53BF" },
          { value: "341371", label: "\u5BBF\u5DDE\u9A6C\u978D\u5C71\u73B0\u4EE3\u4EA7\u4E1A\u56ED\u533A" },
          { value: "341372", label: "\u5BBF\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "341500",
        label: "\u516D\u5B89\u5E02",
        children: [
          { value: "341502", label: "\u91D1\u5B89\u533A" },
          { value: "341503", label: "\u88D5\u5B89\u533A" },
          { value: "341504", label: "\u53F6\u96C6\u533A" },
          { value: "341522", label: "\u970D\u90B1\u53BF" },
          { value: "341523", label: "\u8212\u57CE\u53BF" },
          { value: "341524", label: "\u91D1\u5BE8\u53BF" },
          { value: "341525", label: "\u970D\u5C71\u53BF" }
        ]
      },
      {
        value: "341600",
        label: "\u4EB3\u5DDE\u5E02",
        children: [
          { value: "341602", label: "\u8C2F\u57CE\u533A" },
          { value: "341621", label: "\u6DA1\u9633\u53BF" },
          { value: "341622", label: "\u8499\u57CE\u53BF" },
          { value: "341623", label: "\u5229\u8F9B\u53BF" }
        ]
      },
      {
        value: "341700",
        label: "\u6C60\u5DDE\u5E02",
        children: [
          { value: "341702", label: "\u8D35\u6C60\u533A" },
          { value: "341721", label: "\u4E1C\u81F3\u53BF" },
          { value: "341722", label: "\u77F3\u53F0\u53BF" },
          { value: "341723", label: "\u9752\u9633\u53BF" }
        ]
      },
      {
        value: "341800",
        label: "\u5BA3\u57CE\u5E02",
        children: [
          { value: "341802", label: "\u5BA3\u5DDE\u533A" },
          { value: "341821", label: "\u90CE\u6EAA\u53BF" },
          { value: "341823", label: "\u6CFE\u53BF" },
          { value: "341824", label: "\u7EE9\u6EAA\u53BF" },
          { value: "341825", label: "\u65CC\u5FB7\u53BF" },
          { value: "341871", label: "\u5BA3\u57CE\u5E02\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "341881", label: "\u5B81\u56FD\u5E02" },
          { value: "341882", label: "\u5E7F\u5FB7\u5E02" }
        ]
      }
    ]
  },
  {
    value: "350000",
    label: "\u798F\u5EFA\u7701",
    children: [
      {
        value: "350100",
        label: "\u798F\u5DDE\u5E02",
        children: [
          { value: "350102", label: "\u9F13\u697C\u533A" },
          { value: "350103", label: "\u53F0\u6C5F\u533A" },
          { value: "350104", label: "\u4ED3\u5C71\u533A" },
          { value: "350105", label: "\u9A6C\u5C3E\u533A" },
          { value: "350111", label: "\u664B\u5B89\u533A" },
          { value: "350112", label: "\u957F\u4E50\u533A" },
          { value: "350121", label: "\u95FD\u4FAF\u53BF" },
          { value: "350122", label: "\u8FDE\u6C5F\u53BF" },
          { value: "350123", label: "\u7F57\u6E90\u53BF" },
          { value: "350124", label: "\u95FD\u6E05\u53BF" },
          { value: "350125", label: "\u6C38\u6CF0\u53BF" },
          { value: "350128", label: "\u5E73\u6F6D\u53BF" },
          { value: "350181", label: "\u798F\u6E05\u5E02" }
        ]
      },
      {
        value: "350200",
        label: "\u53A6\u95E8\u5E02",
        children: [
          { value: "350203", label: "\u601D\u660E\u533A" },
          { value: "350205", label: "\u6D77\u6CA7\u533A" },
          { value: "350206", label: "\u6E56\u91CC\u533A" },
          { value: "350211", label: "\u96C6\u7F8E\u533A" },
          { value: "350212", label: "\u540C\u5B89\u533A" },
          { value: "350213", label: "\u7FD4\u5B89\u533A" }
        ]
      },
      {
        value: "350300",
        label: "\u8386\u7530\u5E02",
        children: [
          { value: "350302", label: "\u57CE\u53A2\u533A" },
          { value: "350303", label: "\u6DB5\u6C5F\u533A" },
          { value: "350304", label: "\u8354\u57CE\u533A" },
          { value: "350305", label: "\u79C0\u5C7F\u533A" },
          { value: "350322", label: "\u4ED9\u6E38\u53BF" }
        ]
      },
      {
        value: "350400",
        label: "\u4E09\u660E\u5E02",
        children: [
          { value: "350402", label: "\u6885\u5217\u533A" },
          { value: "350403", label: "\u4E09\u5143\u533A" },
          { value: "350421", label: "\u660E\u6EAA\u53BF" },
          { value: "350423", label: "\u6E05\u6D41\u53BF" },
          { value: "350424", label: "\u5B81\u5316\u53BF" },
          { value: "350425", label: "\u5927\u7530\u53BF" },
          { value: "350426", label: "\u5C24\u6EAA\u53BF" },
          { value: "350427", label: "\u6C99\u53BF" },
          { value: "350428", label: "\u5C06\u4E50\u53BF" },
          { value: "350429", label: "\u6CF0\u5B81\u53BF" },
          { value: "350430", label: "\u5EFA\u5B81\u53BF" },
          { value: "350481", label: "\u6C38\u5B89\u5E02" }
        ]
      },
      {
        value: "350500",
        label: "\u6CC9\u5DDE\u5E02",
        children: [
          { value: "350502", label: "\u9CA4\u57CE\u533A" },
          { value: "350503", label: "\u4E30\u6CFD\u533A" },
          { value: "350504", label: "\u6D1B\u6C5F\u533A" },
          { value: "350505", label: "\u6CC9\u6E2F\u533A" },
          { value: "350521", label: "\u60E0\u5B89\u53BF" },
          { value: "350524", label: "\u5B89\u6EAA\u53BF" },
          { value: "350525", label: "\u6C38\u6625\u53BF" },
          { value: "350526", label: "\u5FB7\u5316\u53BF" },
          { value: "350527", label: "\u91D1\u95E8\u53BF" },
          { value: "350581", label: "\u77F3\u72EE\u5E02" },
          { value: "350582", label: "\u664B\u6C5F\u5E02" },
          { value: "350583", label: "\u5357\u5B89\u5E02" }
        ]
      },
      {
        value: "350600",
        label: "\u6F33\u5DDE\u5E02",
        children: [
          { value: "350602", label: "\u8297\u57CE\u533A" },
          { value: "350603", label: "\u9F99\u6587\u533A" },
          { value: "350622", label: "\u4E91\u9704\u53BF" },
          { value: "350623", label: "\u6F33\u6D66\u53BF" },
          { value: "350624", label: "\u8BCF\u5B89\u53BF" },
          { value: "350625", label: "\u957F\u6CF0\u53BF" },
          { value: "350626", label: "\u4E1C\u5C71\u53BF" },
          { value: "350627", label: "\u5357\u9756\u53BF" },
          { value: "350628", label: "\u5E73\u548C\u53BF" },
          { value: "350629", label: "\u534E\u5B89\u53BF" },
          { value: "350681", label: "\u9F99\u6D77\u5E02" }
        ]
      },
      {
        value: "350700",
        label: "\u5357\u5E73\u5E02",
        children: [
          { value: "350702", label: "\u5EF6\u5E73\u533A" },
          { value: "350703", label: "\u5EFA\u9633\u533A" },
          { value: "350721", label: "\u987A\u660C\u53BF" },
          { value: "350722", label: "\u6D66\u57CE\u53BF" },
          { value: "350723", label: "\u5149\u6CFD\u53BF" },
          { value: "350724", label: "\u677E\u6EAA\u53BF" },
          { value: "350725", label: "\u653F\u548C\u53BF" },
          { value: "350781", label: "\u90B5\u6B66\u5E02" },
          { value: "350782", label: "\u6B66\u5937\u5C71\u5E02" },
          { value: "350783", label: "\u5EFA\u74EF\u5E02" }
        ]
      },
      {
        value: "350800",
        label: "\u9F99\u5CA9\u5E02",
        children: [
          { value: "350802", label: "\u65B0\u7F57\u533A" },
          { value: "350803", label: "\u6C38\u5B9A\u533A" },
          { value: "350821", label: "\u957F\u6C40\u53BF" },
          { value: "350823", label: "\u4E0A\u676D\u53BF" },
          { value: "350824", label: "\u6B66\u5E73\u53BF" },
          { value: "350825", label: "\u8FDE\u57CE\u53BF" },
          { value: "350881", label: "\u6F33\u5E73\u5E02" }
        ]
      },
      {
        value: "350900",
        label: "\u5B81\u5FB7\u5E02",
        children: [
          { value: "350902", label: "\u8549\u57CE\u533A" },
          { value: "350921", label: "\u971E\u6D66\u53BF" },
          { value: "350922", label: "\u53E4\u7530\u53BF" },
          { value: "350923", label: "\u5C4F\u5357\u53BF" },
          { value: "350924", label: "\u5BFF\u5B81\u53BF" },
          { value: "350925", label: "\u5468\u5B81\u53BF" },
          { value: "350926", label: "\u67D8\u8363\u53BF" },
          { value: "350981", label: "\u798F\u5B89\u5E02" },
          { value: "350982", label: "\u798F\u9F0E\u5E02" }
        ]
      }
    ]
  },
  {
    value: "360000",
    label: "\u6C5F\u897F\u7701",
    children: [
      {
        value: "360100",
        label: "\u5357\u660C\u5E02",
        children: [
          { value: "360102", label: "\u4E1C\u6E56\u533A" },
          { value: "360103", label: "\u897F\u6E56\u533A" },
          { value: "360104", label: "\u9752\u4E91\u8C31\u533A" },
          { value: "360105", label: "\u6E7E\u91CC\u533A" },
          { value: "360111", label: "\u9752\u5C71\u6E56\u533A" },
          { value: "360112", label: "\u65B0\u5EFA\u533A" },
          { value: "360121", label: "\u5357\u660C\u53BF" },
          { value: "360123", label: "\u5B89\u4E49\u53BF" },
          { value: "360124", label: "\u8FDB\u8D24\u53BF" }
        ]
      },
      {
        value: "360200",
        label: "\u666F\u5FB7\u9547\u5E02",
        children: [
          { value: "360202", label: "\u660C\u6C5F\u533A" },
          { value: "360203", label: "\u73E0\u5C71\u533A" },
          { value: "360222", label: "\u6D6E\u6881\u53BF" },
          { value: "360281", label: "\u4E50\u5E73\u5E02" }
        ]
      },
      {
        value: "360300",
        label: "\u840D\u4E61\u5E02",
        children: [
          { value: "360302", label: "\u5B89\u6E90\u533A" },
          { value: "360313", label: "\u6E58\u4E1C\u533A" },
          { value: "360321", label: "\u83B2\u82B1\u53BF" },
          { value: "360322", label: "\u4E0A\u6817\u53BF" },
          { value: "360323", label: "\u82A6\u6EAA\u53BF" }
        ]
      },
      {
        value: "360400",
        label: "\u4E5D\u6C5F\u5E02",
        children: [
          { value: "360402", label: "\u6FC2\u6EAA\u533A" },
          { value: "360403", label: "\u6D54\u9633\u533A" },
          { value: "360404", label: "\u67F4\u6851\u533A" },
          { value: "360423", label: "\u6B66\u5B81\u53BF" },
          { value: "360424", label: "\u4FEE\u6C34\u53BF" },
          { value: "360425", label: "\u6C38\u4FEE\u53BF" },
          { value: "360426", label: "\u5FB7\u5B89\u53BF" },
          { value: "360428", label: "\u90FD\u660C\u53BF" },
          { value: "360429", label: "\u6E56\u53E3\u53BF" },
          { value: "360430", label: "\u5F6D\u6CFD\u53BF" },
          { value: "360481", label: "\u745E\u660C\u5E02" },
          { value: "360482", label: "\u5171\u9752\u57CE\u5E02" },
          { value: "360483", label: "\u5E90\u5C71\u5E02" }
        ]
      },
      {
        value: "360500",
        label: "\u65B0\u4F59\u5E02",
        children: [
          { value: "360502", label: "\u6E1D\u6C34\u533A" },
          { value: "360521", label: "\u5206\u5B9C\u53BF" }
        ]
      },
      {
        value: "360600",
        label: "\u9E70\u6F6D\u5E02",
        children: [
          { value: "360602", label: "\u6708\u6E56\u533A" },
          { value: "360603", label: "\u4F59\u6C5F\u533A" },
          { value: "360681", label: "\u8D35\u6EAA\u5E02" }
        ]
      },
      {
        value: "360700",
        label: "\u8D63\u5DDE\u5E02",
        children: [
          { value: "360702", label: "\u7AE0\u8D21\u533A" },
          { value: "360703", label: "\u5357\u5EB7\u533A" },
          { value: "360704", label: "\u8D63\u53BF\u533A" },
          { value: "360722", label: "\u4FE1\u4E30\u53BF" },
          { value: "360723", label: "\u5927\u4F59\u53BF" },
          { value: "360724", label: "\u4E0A\u72B9\u53BF" },
          { value: "360725", label: "\u5D07\u4E49\u53BF" },
          { value: "360726", label: "\u5B89\u8FDC\u53BF" },
          { value: "360727", label: "\u9F99\u5357\u53BF" },
          { value: "360728", label: "\u5B9A\u5357\u53BF" },
          { value: "360729", label: "\u5168\u5357\u53BF" },
          { value: "360730", label: "\u5B81\u90FD\u53BF" },
          { value: "360731", label: "\u4E8E\u90FD\u53BF" },
          { value: "360732", label: "\u5174\u56FD\u53BF" },
          { value: "360733", label: "\u4F1A\u660C\u53BF" },
          { value: "360734", label: "\u5BFB\u4E4C\u53BF" },
          { value: "360735", label: "\u77F3\u57CE\u53BF" },
          { value: "360781", label: "\u745E\u91D1\u5E02" }
        ]
      },
      {
        value: "360800",
        label: "\u5409\u5B89\u5E02",
        children: [
          { value: "360802", label: "\u5409\u5DDE\u533A" },
          { value: "360803", label: "\u9752\u539F\u533A" },
          { value: "360821", label: "\u5409\u5B89\u53BF" },
          { value: "360822", label: "\u5409\u6C34\u53BF" },
          { value: "360823", label: "\u5CE1\u6C5F\u53BF" },
          { value: "360824", label: "\u65B0\u5E72\u53BF" },
          { value: "360825", label: "\u6C38\u4E30\u53BF" },
          { value: "360826", label: "\u6CF0\u548C\u53BF" },
          { value: "360827", label: "\u9042\u5DDD\u53BF" },
          { value: "360828", label: "\u4E07\u5B89\u53BF" },
          { value: "360829", label: "\u5B89\u798F\u53BF" },
          { value: "360830", label: "\u6C38\u65B0\u53BF" },
          { value: "360881", label: "\u4E95\u5188\u5C71\u5E02" }
        ]
      },
      {
        value: "360900",
        label: "\u5B9C\u6625\u5E02",
        children: [
          { value: "360902", label: "\u8881\u5DDE\u533A" },
          { value: "360921", label: "\u5949\u65B0\u53BF" },
          { value: "360922", label: "\u4E07\u8F7D\u53BF" },
          { value: "360923", label: "\u4E0A\u9AD8\u53BF" },
          { value: "360924", label: "\u5B9C\u4E30\u53BF" },
          { value: "360925", label: "\u9756\u5B89\u53BF" },
          { value: "360926", label: "\u94DC\u9F13\u53BF" },
          { value: "360981", label: "\u4E30\u57CE\u5E02" },
          { value: "360982", label: "\u6A1F\u6811\u5E02" },
          { value: "360983", label: "\u9AD8\u5B89\u5E02" }
        ]
      },
      {
        value: "361000",
        label: "\u629A\u5DDE\u5E02",
        children: [
          { value: "361002", label: "\u4E34\u5DDD\u533A" },
          { value: "361003", label: "\u4E1C\u4E61\u533A" },
          { value: "361021", label: "\u5357\u57CE\u53BF" },
          { value: "361022", label: "\u9ECE\u5DDD\u53BF" },
          { value: "361023", label: "\u5357\u4E30\u53BF" },
          { value: "361024", label: "\u5D07\u4EC1\u53BF" },
          { value: "361025", label: "\u4E50\u5B89\u53BF" },
          { value: "361026", label: "\u5B9C\u9EC4\u53BF" },
          { value: "361027", label: "\u91D1\u6EAA\u53BF" },
          { value: "361028", label: "\u8D44\u6EAA\u53BF" },
          { value: "361030", label: "\u5E7F\u660C\u53BF" }
        ]
      },
      {
        value: "361100",
        label: "\u4E0A\u9976\u5E02",
        children: [
          { value: "361102", label: "\u4FE1\u5DDE\u533A" },
          { value: "361103", label: "\u5E7F\u4E30\u533A" },
          { value: "361104", label: "\u5E7F\u4FE1\u533A" },
          { value: "361123", label: "\u7389\u5C71\u53BF" },
          { value: "361124", label: "\u94C5\u5C71\u53BF" },
          { value: "361125", label: "\u6A2A\u5CF0\u53BF" },
          { value: "361126", label: "\u5F0B\u9633\u53BF" },
          { value: "361127", label: "\u4F59\u5E72\u53BF" },
          { value: "361128", label: "\u9131\u9633\u53BF" },
          { value: "361129", label: "\u4E07\u5E74\u53BF" },
          { value: "361130", label: "\u5A7A\u6E90\u53BF" },
          { value: "361181", label: "\u5FB7\u5174\u5E02" }
        ]
      }
    ]
  },
  {
    value: "370000",
    label: "\u5C71\u4E1C\u7701",
    children: [
      {
        value: "370100",
        label: "\u6D4E\u5357\u5E02",
        children: [
          { value: "370102", label: "\u5386\u4E0B\u533A" },
          { value: "370103", label: "\u5E02\u4E2D\u533A" },
          { value: "370104", label: "\u69D0\u836B\u533A" },
          { value: "370105", label: "\u5929\u6865\u533A" },
          { value: "370112", label: "\u5386\u57CE\u533A" },
          { value: "370113", label: "\u957F\u6E05\u533A" },
          { value: "370114", label: "\u7AE0\u4E18\u533A" },
          { value: "370115", label: "\u6D4E\u9633\u533A" },
          { value: "370116", label: "\u83B1\u829C\u533A" },
          { value: "370117", label: "\u94A2\u57CE\u533A" },
          { value: "370124", label: "\u5E73\u9634\u53BF" },
          { value: "370126", label: "\u5546\u6CB3\u53BF" },
          { value: "370171", label: "\u6D4E\u5357\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "370200",
        label: "\u9752\u5C9B\u5E02",
        children: [
          { value: "370202", label: "\u5E02\u5357\u533A" },
          { value: "370203", label: "\u5E02\u5317\u533A" },
          { value: "370211", label: "\u9EC4\u5C9B\u533A" },
          { value: "370212", label: "\u5D02\u5C71\u533A" },
          { value: "370213", label: "\u674E\u6CA7\u533A" },
          { value: "370214", label: "\u57CE\u9633\u533A" },
          { value: "370215", label: "\u5373\u58A8\u533A" },
          { value: "370271", label: "\u9752\u5C9B\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "370281", label: "\u80F6\u5DDE\u5E02" },
          { value: "370283", label: "\u5E73\u5EA6\u5E02" },
          { value: "370285", label: "\u83B1\u897F\u5E02" }
        ]
      },
      {
        value: "370300",
        label: "\u6DC4\u535A\u5E02",
        children: [
          { value: "370302", label: "\u6DC4\u5DDD\u533A" },
          { value: "370303", label: "\u5F20\u5E97\u533A" },
          { value: "370304", label: "\u535A\u5C71\u533A" },
          { value: "370305", label: "\u4E34\u6DC4\u533A" },
          { value: "370306", label: "\u5468\u6751\u533A" },
          { value: "370321", label: "\u6853\u53F0\u53BF" },
          { value: "370322", label: "\u9AD8\u9752\u53BF" },
          { value: "370323", label: "\u6C82\u6E90\u53BF" }
        ]
      },
      {
        value: "370400",
        label: "\u67A3\u5E84\u5E02",
        children: [
          { value: "370402", label: "\u5E02\u4E2D\u533A" },
          { value: "370403", label: "\u859B\u57CE\u533A" },
          { value: "370404", label: "\u5CC4\u57CE\u533A" },
          { value: "370405", label: "\u53F0\u513F\u5E84\u533A" },
          { value: "370406", label: "\u5C71\u4EAD\u533A" },
          { value: "370481", label: "\u6ED5\u5DDE\u5E02" }
        ]
      },
      {
        value: "370500",
        label: "\u4E1C\u8425\u5E02",
        children: [
          { value: "370502", label: "\u4E1C\u8425\u533A" },
          { value: "370503", label: "\u6CB3\u53E3\u533A" },
          { value: "370505", label: "\u57A6\u5229\u533A" },
          { value: "370522", label: "\u5229\u6D25\u53BF" },
          { value: "370523", label: "\u5E7F\u9976\u53BF" },
          { value: "370571", label: "\u4E1C\u8425\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "370572", label: "\u4E1C\u8425\u6E2F\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "370600",
        label: "\u70DF\u53F0\u5E02",
        children: [
          { value: "370602", label: "\u829D\u7F58\u533A" },
          { value: "370611", label: "\u798F\u5C71\u533A" },
          { value: "370612", label: "\u725F\u5E73\u533A" },
          { value: "370613", label: "\u83B1\u5C71\u533A" },
          { value: "370634", label: "\u957F\u5C9B\u53BF" },
          { value: "370671", label: "\u70DF\u53F0\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "370672", label: "\u70DF\u53F0\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "370681", label: "\u9F99\u53E3\u5E02" },
          { value: "370682", label: "\u83B1\u9633\u5E02" },
          { value: "370683", label: "\u83B1\u5DDE\u5E02" },
          { value: "370684", label: "\u84EC\u83B1\u5E02" },
          { value: "370685", label: "\u62DB\u8FDC\u5E02" },
          { value: "370686", label: "\u6816\u971E\u5E02" },
          { value: "370687", label: "\u6D77\u9633\u5E02" }
        ]
      },
      {
        value: "370700",
        label: "\u6F4D\u574A\u5E02",
        children: [
          { value: "370702", label: "\u6F4D\u57CE\u533A" },
          { value: "370703", label: "\u5BD2\u4EAD\u533A" },
          { value: "370704", label: "\u574A\u5B50\u533A" },
          { value: "370705", label: "\u594E\u6587\u533A" },
          { value: "370724", label: "\u4E34\u6710\u53BF" },
          { value: "370725", label: "\u660C\u4E50\u53BF" },
          { value: "370772", label: "\u6F4D\u574A\u6EE8\u6D77\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "370781", label: "\u9752\u5DDE\u5E02" },
          { value: "370782", label: "\u8BF8\u57CE\u5E02" },
          { value: "370783", label: "\u5BFF\u5149\u5E02" },
          { value: "370784", label: "\u5B89\u4E18\u5E02" },
          { value: "370785", label: "\u9AD8\u5BC6\u5E02" },
          { value: "370786", label: "\u660C\u9091\u5E02" }
        ]
      },
      {
        value: "370800",
        label: "\u6D4E\u5B81\u5E02",
        children: [
          { value: "370811", label: "\u4EFB\u57CE\u533A" },
          { value: "370812", label: "\u5156\u5DDE\u533A" },
          { value: "370826", label: "\u5FAE\u5C71\u53BF" },
          { value: "370827", label: "\u9C7C\u53F0\u53BF" },
          { value: "370828", label: "\u91D1\u4E61\u53BF" },
          { value: "370829", label: "\u5609\u7965\u53BF" },
          { value: "370830", label: "\u6C76\u4E0A\u53BF" },
          { value: "370831", label: "\u6CD7\u6C34\u53BF" },
          { value: "370832", label: "\u6881\u5C71\u53BF" },
          { value: "370871", label: "\u6D4E\u5B81\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "370881", label: "\u66F2\u961C\u5E02" },
          { value: "370883", label: "\u90B9\u57CE\u5E02" }
        ]
      },
      {
        value: "370900",
        label: "\u6CF0\u5B89\u5E02",
        children: [
          { value: "370902", label: "\u6CF0\u5C71\u533A" },
          { value: "370911", label: "\u5CB1\u5CB3\u533A" },
          { value: "370921", label: "\u5B81\u9633\u53BF" },
          { value: "370923", label: "\u4E1C\u5E73\u53BF" },
          { value: "370982", label: "\u65B0\u6CF0\u5E02" },
          { value: "370983", label: "\u80A5\u57CE\u5E02" }
        ]
      },
      {
        value: "371000",
        label: "\u5A01\u6D77\u5E02",
        children: [
          { value: "371002", label: "\u73AF\u7FE0\u533A" },
          { value: "371003", label: "\u6587\u767B\u533A" },
          { value: "371071", label: "\u5A01\u6D77\u706B\u70AC\u9AD8\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "371072", label: "\u5A01\u6D77\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "371073", label: "\u5A01\u6D77\u4E34\u6E2F\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "371082", label: "\u8363\u6210\u5E02" },
          { value: "371083", label: "\u4E73\u5C71\u5E02" }
        ]
      },
      {
        value: "371100",
        label: "\u65E5\u7167\u5E02",
        children: [
          { value: "371102", label: "\u4E1C\u6E2F\u533A" },
          { value: "371103", label: "\u5C9A\u5C71\u533A" },
          { value: "371121", label: "\u4E94\u83B2\u53BF" },
          { value: "371122", label: "\u8392\u53BF" },
          { value: "371171", label: "\u65E5\u7167\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "371300",
        label: "\u4E34\u6C82\u5E02",
        children: [
          { value: "371302", label: "\u5170\u5C71\u533A" },
          { value: "371311", label: "\u7F57\u5E84\u533A" },
          { value: "371312", label: "\u6CB3\u4E1C\u533A" },
          { value: "371321", label: "\u6C82\u5357\u53BF" },
          { value: "371322", label: "\u90EF\u57CE\u53BF" },
          { value: "371323", label: "\u6C82\u6C34\u53BF" },
          { value: "371324", label: "\u5170\u9675\u53BF" },
          { value: "371325", label: "\u8D39\u53BF" },
          { value: "371326", label: "\u5E73\u9091\u53BF" },
          { value: "371327", label: "\u8392\u5357\u53BF" },
          { value: "371328", label: "\u8499\u9634\u53BF" },
          { value: "371329", label: "\u4E34\u6CAD\u53BF" },
          { value: "371371", label: "\u4E34\u6C82\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "371372", label: "\u4E34\u6C82\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "371373", label: "\u4E34\u6C82\u4E34\u6E2F\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "371400",
        label: "\u5FB7\u5DDE\u5E02",
        children: [
          { value: "371402", label: "\u5FB7\u57CE\u533A" },
          { value: "371403", label: "\u9675\u57CE\u533A" },
          { value: "371422", label: "\u5B81\u6D25\u53BF" },
          { value: "371423", label: "\u5E86\u4E91\u53BF" },
          { value: "371424", label: "\u4E34\u9091\u53BF" },
          { value: "371425", label: "\u9F50\u6CB3\u53BF" },
          { value: "371426", label: "\u5E73\u539F\u53BF" },
          { value: "371427", label: "\u590F\u6D25\u53BF" },
          { value: "371428", label: "\u6B66\u57CE\u53BF" },
          { value: "371471", label: "\u5FB7\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "371472", label: "\u5FB7\u5DDE\u8FD0\u6CB3\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "371481", label: "\u4E50\u9675\u5E02" },
          { value: "371482", label: "\u79B9\u57CE\u5E02" }
        ]
      },
      {
        value: "371500",
        label: "\u804A\u57CE\u5E02",
        children: [
          { value: "371502", label: "\u4E1C\u660C\u5E9C\u533A" },
          { value: "371503", label: "\u830C\u5E73\u533A" },
          { value: "371521", label: "\u9633\u8C37\u53BF" },
          { value: "371522", label: "\u8398\u53BF" },
          { value: "371524", label: "\u4E1C\u963F\u53BF" },
          { value: "371525", label: "\u51A0\u53BF" },
          { value: "371526", label: "\u9AD8\u5510\u53BF" },
          { value: "371581", label: "\u4E34\u6E05\u5E02" }
        ]
      },
      {
        value: "371600",
        label: "\u6EE8\u5DDE\u5E02",
        children: [
          { value: "371602", label: "\u6EE8\u57CE\u533A" },
          { value: "371603", label: "\u6CBE\u5316\u533A" },
          { value: "371621", label: "\u60E0\u6C11\u53BF" },
          { value: "371622", label: "\u9633\u4FE1\u53BF" },
          { value: "371623", label: "\u65E0\u68E3\u53BF" },
          { value: "371625", label: "\u535A\u5174\u53BF" },
          { value: "371681", label: "\u90B9\u5E73\u5E02" }
        ]
      },
      {
        value: "371700",
        label: "\u83CF\u6CFD\u5E02",
        children: [
          { value: "371702", label: "\u7261\u4E39\u533A" },
          { value: "371703", label: "\u5B9A\u9676\u533A" },
          { value: "371721", label: "\u66F9\u53BF" },
          { value: "371722", label: "\u5355\u53BF" },
          { value: "371723", label: "\u6210\u6B66\u53BF" },
          { value: "371724", label: "\u5DE8\u91CE\u53BF" },
          { value: "371725", label: "\u90D3\u57CE\u53BF" },
          { value: "371726", label: "\u9104\u57CE\u53BF" },
          { value: "371728", label: "\u4E1C\u660E\u53BF" },
          { value: "371771", label: "\u83CF\u6CFD\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "371772", label: "\u83CF\u6CFD\u9AD8\u65B0\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      }
    ]
  },
  {
    value: "410000",
    label: "\u6CB3\u5357\u7701",
    children: [
      {
        value: "410100",
        label: "\u90D1\u5DDE\u5E02",
        children: [
          { value: "410102", label: "\u4E2D\u539F\u533A" },
          { value: "410103", label: "\u4E8C\u4E03\u533A" },
          { value: "410104", label: "\u7BA1\u57CE\u56DE\u65CF\u533A" },
          { value: "410105", label: "\u91D1\u6C34\u533A" },
          { value: "410106", label: "\u4E0A\u8857\u533A" },
          { value: "410108", label: "\u60E0\u6D4E\u533A" },
          { value: "410122", label: "\u4E2D\u725F\u53BF" },
          { value: "410171", label: "\u90D1\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "410172", label: "\u90D1\u5DDE\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "410173", label: "\u90D1\u5DDE\u822A\u7A7A\u6E2F\u7ECF\u6D4E\u7EFC\u5408\u5B9E\u9A8C\u533A" },
          { value: "410181", label: "\u5DE9\u4E49\u5E02" },
          { value: "410182", label: "\u8365\u9633\u5E02" },
          { value: "410183", label: "\u65B0\u5BC6\u5E02" },
          { value: "410184", label: "\u65B0\u90D1\u5E02" },
          { value: "410185", label: "\u767B\u5C01\u5E02" }
        ]
      },
      {
        value: "410200",
        label: "\u5F00\u5C01\u5E02",
        children: [
          { value: "410202", label: "\u9F99\u4EAD\u533A" },
          { value: "410203", label: "\u987A\u6CB3\u56DE\u65CF\u533A" },
          { value: "410204", label: "\u9F13\u697C\u533A" },
          { value: "410205", label: "\u79B9\u738B\u53F0\u533A" },
          { value: "410212", label: "\u7965\u7B26\u533A" },
          { value: "410221", label: "\u675E\u53BF" },
          { value: "410222", label: "\u901A\u8BB8\u53BF" },
          { value: "410223", label: "\u5C09\u6C0F\u53BF" },
          { value: "410225", label: "\u5170\u8003\u53BF" }
        ]
      },
      {
        value: "410300",
        label: "\u6D1B\u9633\u5E02",
        children: [
          { value: "410302", label: "\u8001\u57CE\u533A" },
          { value: "410303", label: "\u897F\u5DE5\u533A" },
          { value: "410304", label: "\u700D\u6CB3\u56DE\u65CF\u533A" },
          { value: "410305", label: "\u6DA7\u897F\u533A" },
          { value: "410306", label: "\u5409\u5229\u533A" },
          { value: "410311", label: "\u6D1B\u9F99\u533A" },
          { value: "410322", label: "\u5B5F\u6D25\u53BF" },
          { value: "410323", label: "\u65B0\u5B89\u53BF" },
          { value: "410324", label: "\u683E\u5DDD\u53BF" },
          { value: "410325", label: "\u5D69\u53BF" },
          { value: "410326", label: "\u6C5D\u9633\u53BF" },
          { value: "410327", label: "\u5B9C\u9633\u53BF" },
          { value: "410328", label: "\u6D1B\u5B81\u53BF" },
          { value: "410329", label: "\u4F0A\u5DDD\u53BF" },
          { value: "410371", label: "\u6D1B\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "410381", label: "\u5043\u5E08\u5E02" }
        ]
      },
      {
        value: "410400",
        label: "\u5E73\u9876\u5C71\u5E02",
        children: [
          { value: "410402", label: "\u65B0\u534E\u533A" },
          { value: "410403", label: "\u536B\u4E1C\u533A" },
          { value: "410404", label: "\u77F3\u9F99\u533A" },
          { value: "410411", label: "\u6E5B\u6CB3\u533A" },
          { value: "410421", label: "\u5B9D\u4E30\u53BF" },
          { value: "410422", label: "\u53F6\u53BF" },
          { value: "410423", label: "\u9C81\u5C71\u53BF" },
          { value: "410425", label: "\u90CF\u53BF" },
          { value: "410471", label: "\u5E73\u9876\u5C71\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "410472", label: "\u5E73\u9876\u5C71\u5E02\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A" },
          { value: "410481", label: "\u821E\u94A2\u5E02" },
          { value: "410482", label: "\u6C5D\u5DDE\u5E02" }
        ]
      },
      {
        value: "410500",
        label: "\u5B89\u9633\u5E02",
        children: [
          { value: "410502", label: "\u6587\u5CF0\u533A" },
          { value: "410503", label: "\u5317\u5173\u533A" },
          { value: "410505", label: "\u6BB7\u90FD\u533A" },
          { value: "410506", label: "\u9F99\u5B89\u533A" },
          { value: "410522", label: "\u5B89\u9633\u53BF" },
          { value: "410523", label: "\u6C64\u9634\u53BF" },
          { value: "410526", label: "\u6ED1\u53BF" },
          { value: "410527", label: "\u5185\u9EC4\u53BF" },
          { value: "410571", label: "\u5B89\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "410581", label: "\u6797\u5DDE\u5E02" }
        ]
      },
      {
        value: "410600",
        label: "\u9E64\u58C1\u5E02",
        children: [
          { value: "410602", label: "\u9E64\u5C71\u533A" },
          { value: "410603", label: "\u5C71\u57CE\u533A" },
          { value: "410611", label: "\u6DC7\u6EE8\u533A" },
          { value: "410621", label: "\u6D5A\u53BF" },
          { value: "410622", label: "\u6DC7\u53BF" },
          { value: "410671", label: "\u9E64\u58C1\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "410700",
        label: "\u65B0\u4E61\u5E02",
        children: [
          { value: "410702", label: "\u7EA2\u65D7\u533A" },
          { value: "410703", label: "\u536B\u6EE8\u533A" },
          { value: "410704", label: "\u51E4\u6CC9\u533A" },
          { value: "410711", label: "\u7267\u91CE\u533A" },
          { value: "410721", label: "\u65B0\u4E61\u53BF" },
          { value: "410724", label: "\u83B7\u5609\u53BF" },
          { value: "410725", label: "\u539F\u9633\u53BF" },
          { value: "410726", label: "\u5EF6\u6D25\u53BF" },
          { value: "410727", label: "\u5C01\u4E18\u53BF" },
          { value: "410771", label: "\u65B0\u4E61\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "410772", label: "\u65B0\u4E61\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "410773", label: "\u65B0\u4E61\u5E02\u5E73\u539F\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A" },
          { value: "410781", label: "\u536B\u8F89\u5E02" },
          { value: "410782", label: "\u8F89\u53BF\u5E02" },
          { value: "410783", label: "\u957F\u57A3\u5E02" }
        ]
      },
      {
        value: "410800",
        label: "\u7126\u4F5C\u5E02",
        children: [
          { value: "410802", label: "\u89E3\u653E\u533A" },
          { value: "410803", label: "\u4E2D\u7AD9\u533A" },
          { value: "410804", label: "\u9A6C\u6751\u533A" },
          { value: "410811", label: "\u5C71\u9633\u533A" },
          { value: "410821", label: "\u4FEE\u6B66\u53BF" },
          { value: "410822", label: "\u535A\u7231\u53BF" },
          { value: "410823", label: "\u6B66\u965F\u53BF" },
          { value: "410825", label: "\u6E29\u53BF" },
          { value: "410871", label: "\u7126\u4F5C\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A" },
          { value: "410882", label: "\u6C81\u9633\u5E02" },
          { value: "410883", label: "\u5B5F\u5DDE\u5E02" }
        ]
      },
      {
        value: "410900",
        label: "\u6FEE\u9633\u5E02",
        children: [
          { value: "410902", label: "\u534E\u9F99\u533A" },
          { value: "410922", label: "\u6E05\u4E30\u53BF" },
          { value: "410923", label: "\u5357\u4E50\u53BF" },
          { value: "410926", label: "\u8303\u53BF" },
          { value: "410927", label: "\u53F0\u524D\u53BF" },
          { value: "410928", label: "\u6FEE\u9633\u53BF" },
          { value: "410971", label: "\u6CB3\u5357\u6FEE\u9633\u5DE5\u4E1A\u56ED\u533A" },
          { value: "410972", label: "\u6FEE\u9633\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "411000",
        label: "\u8BB8\u660C\u5E02",
        children: [
          { value: "411002", label: "\u9B4F\u90FD\u533A" },
          { value: "411003", label: "\u5EFA\u5B89\u533A" },
          { value: "411024", label: "\u9122\u9675\u53BF" },
          { value: "411025", label: "\u8944\u57CE\u53BF" },
          { value: "411071", label: "\u8BB8\u660C\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "411081", label: "\u79B9\u5DDE\u5E02" },
          { value: "411082", label: "\u957F\u845B\u5E02" }
        ]
      },
      {
        value: "411100",
        label: "\u6F2F\u6CB3\u5E02",
        children: [
          { value: "411102", label: "\u6E90\u6C47\u533A" },
          { value: "411103", label: "\u90FE\u57CE\u533A" },
          { value: "411104", label: "\u53EC\u9675\u533A" },
          { value: "411121", label: "\u821E\u9633\u53BF" },
          { value: "411122", label: "\u4E34\u988D\u53BF" },
          { value: "411171", label: "\u6F2F\u6CB3\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "411200",
        label: "\u4E09\u95E8\u5CE1\u5E02",
        children: [
          { value: "411202", label: "\u6E56\u6EE8\u533A" },
          { value: "411203", label: "\u9655\u5DDE\u533A" },
          { value: "411221", label: "\u6E11\u6C60\u53BF" },
          { value: "411224", label: "\u5362\u6C0F\u53BF" },
          { value: "411271", label: "\u6CB3\u5357\u4E09\u95E8\u5CE1\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "411281", label: "\u4E49\u9A6C\u5E02" },
          { value: "411282", label: "\u7075\u5B9D\u5E02" }
        ]
      },
      {
        value: "411300",
        label: "\u5357\u9633\u5E02",
        children: [
          { value: "411302", label: "\u5B9B\u57CE\u533A" },
          { value: "411303", label: "\u5367\u9F99\u533A" },
          { value: "411321", label: "\u5357\u53EC\u53BF" },
          { value: "411322", label: "\u65B9\u57CE\u53BF" },
          { value: "411323", label: "\u897F\u5CE1\u53BF" },
          { value: "411324", label: "\u9547\u5E73\u53BF" },
          { value: "411325", label: "\u5185\u4E61\u53BF" },
          { value: "411326", label: "\u6DC5\u5DDD\u53BF" },
          { value: "411327", label: "\u793E\u65D7\u53BF" },
          { value: "411328", label: "\u5510\u6CB3\u53BF" },
          { value: "411329", label: "\u65B0\u91CE\u53BF" },
          { value: "411330", label: "\u6850\u67CF\u53BF" },
          { value: "411371", label: "\u5357\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" },
          { value: "411372", label: "\u5357\u9633\u5E02\u57CE\u4E61\u4E00\u4F53\u5316\u793A\u8303\u533A" },
          { value: "411381", label: "\u9093\u5DDE\u5E02" }
        ]
      },
      {
        value: "411400",
        label: "\u5546\u4E18\u5E02",
        children: [
          { value: "411402", label: "\u6881\u56ED\u533A" },
          { value: "411403", label: "\u7762\u9633\u533A" },
          { value: "411421", label: "\u6C11\u6743\u53BF" },
          { value: "411422", label: "\u7762\u53BF" },
          { value: "411423", label: "\u5B81\u9675\u53BF" },
          { value: "411424", label: "\u67D8\u57CE\u53BF" },
          { value: "411425", label: "\u865E\u57CE\u53BF" },
          { value: "411426", label: "\u590F\u9091\u53BF" },
          { value: "411471", label: "\u8C6B\u4E1C\u7EFC\u5408\u7269\u6D41\u4EA7\u4E1A\u805A\u96C6\u533A" },
          { value: "411472", label: "\u6CB3\u5357\u5546\u4E18\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "411481", label: "\u6C38\u57CE\u5E02" }
        ]
      },
      {
        value: "411500",
        label: "\u4FE1\u9633\u5E02",
        children: [
          { value: "411502", label: "\u6D49\u6CB3\u533A" },
          { value: "411503", label: "\u5E73\u6865\u533A" },
          { value: "411521", label: "\u7F57\u5C71\u53BF" },
          { value: "411522", label: "\u5149\u5C71\u53BF" },
          { value: "411523", label: "\u65B0\u53BF" },
          { value: "411524", label: "\u5546\u57CE\u53BF" },
          { value: "411525", label: "\u56FA\u59CB\u53BF" },
          { value: "411526", label: "\u6F62\u5DDD\u53BF" },
          { value: "411527", label: "\u6DEE\u6EE8\u53BF" },
          { value: "411528", label: "\u606F\u53BF" },
          { value: "411571", label: "\u4FE1\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "411600",
        label: "\u5468\u53E3\u5E02",
        children: [
          { value: "411602", label: "\u5DDD\u6C47\u533A" },
          { value: "411603", label: "\u6DEE\u9633\u533A" },
          { value: "411621", label: "\u6276\u6C9F\u53BF" },
          { value: "411622", label: "\u897F\u534E\u53BF" },
          { value: "411623", label: "\u5546\u6C34\u53BF" },
          { value: "411624", label: "\u6C88\u4E18\u53BF" },
          { value: "411625", label: "\u90F8\u57CE\u53BF" },
          { value: "411627", label: "\u592A\u5EB7\u53BF" },
          { value: "411628", label: "\u9E7F\u9091\u53BF" },
          { value: "411671", label: "\u6CB3\u5357\u5468\u53E3\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "411681", label: "\u9879\u57CE\u5E02" }
        ]
      },
      {
        value: "411700",
        label: "\u9A7B\u9A6C\u5E97\u5E02",
        children: [
          { value: "411702", label: "\u9A7F\u57CE\u533A" },
          { value: "411721", label: "\u897F\u5E73\u53BF" },
          { value: "411722", label: "\u4E0A\u8521\u53BF" },
          { value: "411723", label: "\u5E73\u8206\u53BF" },
          { value: "411724", label: "\u6B63\u9633\u53BF" },
          { value: "411725", label: "\u786E\u5C71\u53BF" },
          { value: "411726", label: "\u6CCC\u9633\u53BF" },
          { value: "411727", label: "\u6C5D\u5357\u53BF" },
          { value: "411728", label: "\u9042\u5E73\u53BF" },
          { value: "411729", label: "\u65B0\u8521\u53BF" },
          { value: "411771", label: "\u6CB3\u5357\u9A7B\u9A6C\u5E97\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "419000",
        label: "\u7701\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
        children: [{ value: "419001", label: "\u6D4E\u6E90\u5E02" }]
      }
    ]
  },
  {
    value: "420000",
    label: "\u6E56\u5317\u7701",
    children: [
      {
        value: "420100",
        label: "\u6B66\u6C49\u5E02",
        children: [
          { value: "420102", label: "\u6C5F\u5CB8\u533A" },
          { value: "420103", label: "\u6C5F\u6C49\u533A" },
          { value: "420104", label: "\u785A\u53E3\u533A" },
          { value: "420105", label: "\u6C49\u9633\u533A" },
          { value: "420106", label: "\u6B66\u660C\u533A" },
          { value: "420107", label: "\u9752\u5C71\u533A" },
          { value: "420111", label: "\u6D2A\u5C71\u533A" },
          { value: "420112", label: "\u4E1C\u897F\u6E56\u533A" },
          { value: "420113", label: "\u6C49\u5357\u533A" },
          { value: "420114", label: "\u8521\u7538\u533A" },
          { value: "420115", label: "\u6C5F\u590F\u533A" },
          { value: "420116", label: "\u9EC4\u9642\u533A" },
          { value: "420117", label: "\u65B0\u6D32\u533A" }
        ]
      },
      {
        value: "420200",
        label: "\u9EC4\u77F3\u5E02",
        children: [
          { value: "420202", label: "\u9EC4\u77F3\u6E2F\u533A" },
          { value: "420203", label: "\u897F\u585E\u5C71\u533A" },
          { value: "420204", label: "\u4E0B\u9646\u533A" },
          { value: "420205", label: "\u94C1\u5C71\u533A" },
          { value: "420222", label: "\u9633\u65B0\u53BF" },
          { value: "420281", label: "\u5927\u51B6\u5E02" }
        ]
      },
      {
        value: "420300",
        label: "\u5341\u5830\u5E02",
        children: [
          { value: "420302", label: "\u8305\u7BAD\u533A" },
          { value: "420303", label: "\u5F20\u6E7E\u533A" },
          { value: "420304", label: "\u90E7\u9633\u533A" },
          { value: "420322", label: "\u90E7\u897F\u53BF" },
          { value: "420323", label: "\u7AF9\u5C71\u53BF" },
          { value: "420324", label: "\u7AF9\u6EAA\u53BF" },
          { value: "420325", label: "\u623F\u53BF" },
          { value: "420381", label: "\u4E39\u6C5F\u53E3\u5E02" }
        ]
      },
      {
        value: "420500",
        label: "\u5B9C\u660C\u5E02",
        children: [
          { value: "420502", label: "\u897F\u9675\u533A" },
          { value: "420503", label: "\u4F0D\u5BB6\u5C97\u533A" },
          { value: "420504", label: "\u70B9\u519B\u533A" },
          { value: "420505", label: "\u7307\u4EAD\u533A" },
          { value: "420506", label: "\u5937\u9675\u533A" },
          { value: "420525", label: "\u8FDC\u5B89\u53BF" },
          { value: "420526", label: "\u5174\u5C71\u53BF" },
          { value: "420527", label: "\u79ED\u5F52\u53BF" },
          { value: "420528", label: "\u957F\u9633\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF" },
          { value: "420529", label: "\u4E94\u5CF0\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF" },
          { value: "420581", label: "\u5B9C\u90FD\u5E02" },
          { value: "420582", label: "\u5F53\u9633\u5E02" },
          { value: "420583", label: "\u679D\u6C5F\u5E02" }
        ]
      },
      {
        value: "420600",
        label: "\u8944\u9633\u5E02",
        children: [
          { value: "420602", label: "\u8944\u57CE\u533A" },
          { value: "420606", label: "\u6A0A\u57CE\u533A" },
          { value: "420607", label: "\u8944\u5DDE\u533A" },
          { value: "420624", label: "\u5357\u6F33\u53BF" },
          { value: "420625", label: "\u8C37\u57CE\u53BF" },
          { value: "420626", label: "\u4FDD\u5EB7\u53BF" },
          { value: "420682", label: "\u8001\u6CB3\u53E3\u5E02" },
          { value: "420683", label: "\u67A3\u9633\u5E02" },
          { value: "420684", label: "\u5B9C\u57CE\u5E02" }
        ]
      },
      {
        value: "420700",
        label: "\u9102\u5DDE\u5E02",
        children: [
          { value: "420702", label: "\u6881\u5B50\u6E56\u533A" },
          { value: "420703", label: "\u534E\u5BB9\u533A" },
          { value: "420704", label: "\u9102\u57CE\u533A" }
        ]
      },
      {
        value: "420800",
        label: "\u8346\u95E8\u5E02",
        children: [
          { value: "420802", label: "\u4E1C\u5B9D\u533A" },
          { value: "420804", label: "\u6387\u5200\u533A" },
          { value: "420822", label: "\u6C99\u6D0B\u53BF" },
          { value: "420881", label: "\u949F\u7965\u5E02" },
          { value: "420882", label: "\u4EAC\u5C71\u5E02" }
        ]
      },
      {
        value: "420900",
        label: "\u5B5D\u611F\u5E02",
        children: [
          { value: "420902", label: "\u5B5D\u5357\u533A" },
          { value: "420921", label: "\u5B5D\u660C\u53BF" },
          { value: "420922", label: "\u5927\u609F\u53BF" },
          { value: "420923", label: "\u4E91\u68A6\u53BF" },
          { value: "420981", label: "\u5E94\u57CE\u5E02" },
          { value: "420982", label: "\u5B89\u9646\u5E02" },
          { value: "420984", label: "\u6C49\u5DDD\u5E02" }
        ]
      },
      {
        value: "421000",
        label: "\u8346\u5DDE\u5E02",
        children: [
          { value: "421002", label: "\u6C99\u5E02\u533A" },
          { value: "421003", label: "\u8346\u5DDE\u533A" },
          { value: "421022", label: "\u516C\u5B89\u53BF" },
          { value: "421023", label: "\u76D1\u5229\u53BF" },
          { value: "421024", label: "\u6C5F\u9675\u53BF" },
          { value: "421071", label: "\u8346\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "421081", label: "\u77F3\u9996\u5E02" },
          { value: "421083", label: "\u6D2A\u6E56\u5E02" },
          { value: "421087", label: "\u677E\u6ECB\u5E02" }
        ]
      },
      {
        value: "421100",
        label: "\u9EC4\u5188\u5E02",
        children: [
          { value: "421102", label: "\u9EC4\u5DDE\u533A" },
          { value: "421121", label: "\u56E2\u98CE\u53BF" },
          { value: "421122", label: "\u7EA2\u5B89\u53BF" },
          { value: "421123", label: "\u7F57\u7530\u53BF" },
          { value: "421124", label: "\u82F1\u5C71\u53BF" },
          { value: "421125", label: "\u6D60\u6C34\u53BF" },
          { value: "421126", label: "\u8572\u6625\u53BF" },
          { value: "421127", label: "\u9EC4\u6885\u53BF" },
          { value: "421171", label: "\u9F99\u611F\u6E56\u7BA1\u7406\u533A" },
          { value: "421181", label: "\u9EBB\u57CE\u5E02" },
          { value: "421182", label: "\u6B66\u7A74\u5E02" }
        ]
      },
      {
        value: "421200",
        label: "\u54B8\u5B81\u5E02",
        children: [
          { value: "421202", label: "\u54B8\u5B89\u533A" },
          { value: "421221", label: "\u5609\u9C7C\u53BF" },
          { value: "421222", label: "\u901A\u57CE\u53BF" },
          { value: "421223", label: "\u5D07\u9633\u53BF" },
          { value: "421224", label: "\u901A\u5C71\u53BF" },
          { value: "421281", label: "\u8D64\u58C1\u5E02" }
        ]
      },
      {
        value: "421300",
        label: "\u968F\u5DDE\u5E02",
        children: [
          { value: "421303", label: "\u66FE\u90FD\u533A" },
          { value: "421321", label: "\u968F\u53BF" },
          { value: "421381", label: "\u5E7F\u6C34\u5E02" }
        ]
      },
      {
        value: "422800",
        label: "\u6069\u65BD\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "422801", label: "\u6069\u65BD\u5E02" },
          { value: "422802", label: "\u5229\u5DDD\u5E02" },
          { value: "422822", label: "\u5EFA\u59CB\u53BF" },
          { value: "422823", label: "\u5DF4\u4E1C\u53BF" },
          { value: "422825", label: "\u5BA3\u6069\u53BF" },
          { value: "422826", label: "\u54B8\u4E30\u53BF" },
          { value: "422827", label: "\u6765\u51E4\u53BF" },
          { value: "422828", label: "\u9E64\u5CF0\u53BF" }
        ]
      },
      {
        value: "429000",
        label: "\u7701\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
        children: [
          { value: "429004", label: "\u4ED9\u6843\u5E02" },
          { value: "429005", label: "\u6F5C\u6C5F\u5E02" },
          { value: "429006", label: "\u5929\u95E8\u5E02" },
          { value: "429021", label: "\u795E\u519C\u67B6\u6797\u533A" }
        ]
      }
    ]
  },
  {
    value: "430000",
    label: "\u6E56\u5357\u7701",
    children: [
      {
        value: "430100",
        label: "\u957F\u6C99\u5E02",
        children: [
          { value: "430102", label: "\u8299\u84C9\u533A" },
          { value: "430103", label: "\u5929\u5FC3\u533A" },
          { value: "430104", label: "\u5CB3\u9E93\u533A" },
          { value: "430105", label: "\u5F00\u798F\u533A" },
          { value: "430111", label: "\u96E8\u82B1\u533A" },
          { value: "430112", label: "\u671B\u57CE\u533A" },
          { value: "430121", label: "\u957F\u6C99\u53BF" },
          { value: "430181", label: "\u6D4F\u9633\u5E02" },
          { value: "430182", label: "\u5B81\u4E61\u5E02" }
        ]
      },
      {
        value: "430200",
        label: "\u682A\u6D32\u5E02",
        children: [
          { value: "430202", label: "\u8377\u5858\u533A" },
          { value: "430203", label: "\u82A6\u6DDE\u533A" },
          { value: "430204", label: "\u77F3\u5CF0\u533A" },
          { value: "430211", label: "\u5929\u5143\u533A" },
          { value: "430212", label: "\u6E0C\u53E3\u533A" },
          { value: "430223", label: "\u6538\u53BF" },
          { value: "430224", label: "\u8336\u9675\u53BF" },
          { value: "430225", label: "\u708E\u9675\u53BF" },
          { value: "430271", label: "\u4E91\u9F99\u793A\u8303\u533A" },
          { value: "430281", label: "\u91B4\u9675\u5E02" }
        ]
      },
      {
        value: "430300",
        label: "\u6E58\u6F6D\u5E02",
        children: [
          { value: "430302", label: "\u96E8\u6E56\u533A" },
          { value: "430304", label: "\u5CB3\u5858\u533A" },
          { value: "430321", label: "\u6E58\u6F6D\u53BF" },
          { value: "430371", label: "\u6E56\u5357\u6E58\u6F6D\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A" },
          { value: "430372", label: "\u6E58\u6F6D\u662D\u5C71\u793A\u8303\u533A" },
          { value: "430373", label: "\u6E58\u6F6D\u4E5D\u534E\u793A\u8303\u533A" },
          { value: "430381", label: "\u6E58\u4E61\u5E02" },
          { value: "430382", label: "\u97F6\u5C71\u5E02" }
        ]
      },
      {
        value: "430400",
        label: "\u8861\u9633\u5E02",
        children: [
          { value: "430405", label: "\u73E0\u6656\u533A" },
          { value: "430406", label: "\u96C1\u5CF0\u533A" },
          { value: "430407", label: "\u77F3\u9F13\u533A" },
          { value: "430408", label: "\u84B8\u6E58\u533A" },
          { value: "430412", label: "\u5357\u5CB3\u533A" },
          { value: "430421", label: "\u8861\u9633\u53BF" },
          { value: "430422", label: "\u8861\u5357\u53BF" },
          { value: "430423", label: "\u8861\u5C71\u53BF" },
          { value: "430424", label: "\u8861\u4E1C\u53BF" },
          { value: "430426", label: "\u7941\u4E1C\u53BF" },
          { value: "430471", label: "\u8861\u9633\u7EFC\u5408\u4FDD\u7A0E\u533A" },
          { value: "430472", label: "\u6E56\u5357\u8861\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A" },
          { value: "430473", label: "\u6E56\u5357\u8861\u9633\u677E\u6728\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "430481", label: "\u8012\u9633\u5E02" },
          { value: "430482", label: "\u5E38\u5B81\u5E02" }
        ]
      },
      {
        value: "430500",
        label: "\u90B5\u9633\u5E02",
        children: [
          { value: "430502", label: "\u53CC\u6E05\u533A" },
          { value: "430503", label: "\u5927\u7965\u533A" },
          { value: "430511", label: "\u5317\u5854\u533A" },
          { value: "430522", label: "\u65B0\u90B5\u53BF" },
          { value: "430523", label: "\u90B5\u9633\u53BF" },
          { value: "430524", label: "\u9686\u56DE\u53BF" },
          { value: "430525", label: "\u6D1E\u53E3\u53BF" },
          { value: "430527", label: "\u7EE5\u5B81\u53BF" },
          { value: "430528", label: "\u65B0\u5B81\u53BF" },
          { value: "430529", label: "\u57CE\u6B65\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "430581", label: "\u6B66\u5188\u5E02" },
          { value: "430582", label: "\u90B5\u4E1C\u5E02" }
        ]
      },
      {
        value: "430600",
        label: "\u5CB3\u9633\u5E02",
        children: [
          { value: "430602", label: "\u5CB3\u9633\u697C\u533A" },
          { value: "430603", label: "\u4E91\u6EAA\u533A" },
          { value: "430611", label: "\u541B\u5C71\u533A" },
          { value: "430621", label: "\u5CB3\u9633\u53BF" },
          { value: "430623", label: "\u534E\u5BB9\u53BF" },
          { value: "430624", label: "\u6E58\u9634\u53BF" },
          { value: "430626", label: "\u5E73\u6C5F\u53BF" },
          { value: "430671", label: "\u5CB3\u9633\u5E02\u5C48\u539F\u7BA1\u7406\u533A" },
          { value: "430681", label: "\u6C68\u7F57\u5E02" },
          { value: "430682", label: "\u4E34\u6E58\u5E02" }
        ]
      },
      {
        value: "430700",
        label: "\u5E38\u5FB7\u5E02",
        children: [
          { value: "430702", label: "\u6B66\u9675\u533A" },
          { value: "430703", label: "\u9F0E\u57CE\u533A" },
          { value: "430721", label: "\u5B89\u4E61\u53BF" },
          { value: "430722", label: "\u6C49\u5BFF\u53BF" },
          { value: "430723", label: "\u6FA7\u53BF" },
          { value: "430724", label: "\u4E34\u6FA7\u53BF" },
          { value: "430725", label: "\u6843\u6E90\u53BF" },
          { value: "430726", label: "\u77F3\u95E8\u53BF" },
          { value: "430771", label: "\u5E38\u5FB7\u5E02\u897F\u6D1E\u5EAD\u7BA1\u7406\u533A" },
          { value: "430781", label: "\u6D25\u5E02\u5E02" }
        ]
      },
      {
        value: "430800",
        label: "\u5F20\u5BB6\u754C\u5E02",
        children: [
          { value: "430802", label: "\u6C38\u5B9A\u533A" },
          { value: "430811", label: "\u6B66\u9675\u6E90\u533A" },
          { value: "430821", label: "\u6148\u5229\u53BF" },
          { value: "430822", label: "\u6851\u690D\u53BF" }
        ]
      },
      {
        value: "430900",
        label: "\u76CA\u9633\u5E02",
        children: [
          { value: "430902", label: "\u8D44\u9633\u533A" },
          { value: "430903", label: "\u8D6B\u5C71\u533A" },
          { value: "430921", label: "\u5357\u53BF" },
          { value: "430922", label: "\u6843\u6C5F\u53BF" },
          { value: "430923", label: "\u5B89\u5316\u53BF" },
          { value: "430971", label: "\u76CA\u9633\u5E02\u5927\u901A\u6E56\u7BA1\u7406\u533A" },
          { value: "430972", label: "\u6E56\u5357\u76CA\u9633\u9AD8\u65B0\u6280\u672F\u4EA7\u4E1A\u56ED\u533A" },
          { value: "430981", label: "\u6C85\u6C5F\u5E02" }
        ]
      },
      {
        value: "431000",
        label: "\u90F4\u5DDE\u5E02",
        children: [
          { value: "431002", label: "\u5317\u6E56\u533A" },
          { value: "431003", label: "\u82CF\u4ED9\u533A" },
          { value: "431021", label: "\u6842\u9633\u53BF" },
          { value: "431022", label: "\u5B9C\u7AE0\u53BF" },
          { value: "431023", label: "\u6C38\u5174\u53BF" },
          { value: "431024", label: "\u5609\u79BE\u53BF" },
          { value: "431025", label: "\u4E34\u6B66\u53BF" },
          { value: "431026", label: "\u6C5D\u57CE\u53BF" },
          { value: "431027", label: "\u6842\u4E1C\u53BF" },
          { value: "431028", label: "\u5B89\u4EC1\u53BF" },
          { value: "431081", label: "\u8D44\u5174\u5E02" }
        ]
      },
      {
        value: "431100",
        label: "\u6C38\u5DDE\u5E02",
        children: [
          { value: "431102", label: "\u96F6\u9675\u533A" },
          { value: "431103", label: "\u51B7\u6C34\u6EE9\u533A" },
          { value: "431121", label: "\u7941\u9633\u53BF" },
          { value: "431122", label: "\u4E1C\u5B89\u53BF" },
          { value: "431123", label: "\u53CC\u724C\u53BF" },
          { value: "431124", label: "\u9053\u53BF" },
          { value: "431125", label: "\u6C5F\u6C38\u53BF" },
          { value: "431126", label: "\u5B81\u8FDC\u53BF" },
          { value: "431127", label: "\u84DD\u5C71\u53BF" },
          { value: "431128", label: "\u65B0\u7530\u53BF" },
          { value: "431129", label: "\u6C5F\u534E\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "431171", label: "\u6C38\u5DDE\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "431172", label: "\u6C38\u5DDE\u5E02\u91D1\u6D1E\u7BA1\u7406\u533A" },
          { value: "431173", label: "\u6C38\u5DDE\u5E02\u56DE\u9F99\u5729\u7BA1\u7406\u533A" }
        ]
      },
      {
        value: "431200",
        label: "\u6000\u5316\u5E02",
        children: [
          { value: "431202", label: "\u9E64\u57CE\u533A" },
          { value: "431221", label: "\u4E2D\u65B9\u53BF" },
          { value: "431222", label: "\u6C85\u9675\u53BF" },
          { value: "431223", label: "\u8FB0\u6EAA\u53BF" },
          { value: "431224", label: "\u6E86\u6D66\u53BF" },
          { value: "431225", label: "\u4F1A\u540C\u53BF" },
          { value: "431226", label: "\u9EBB\u9633\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "431227", label: "\u65B0\u6643\u4F97\u65CF\u81EA\u6CBB\u53BF" },
          { value: "431228", label: "\u82B7\u6C5F\u4F97\u65CF\u81EA\u6CBB\u53BF" },
          { value: "431229", label: "\u9756\u5DDE\u82D7\u65CF\u4F97\u65CF\u81EA\u6CBB\u53BF" },
          { value: "431230", label: "\u901A\u9053\u4F97\u65CF\u81EA\u6CBB\u53BF" },
          { value: "431271", label: "\u6000\u5316\u5E02\u6D2A\u6C5F\u7BA1\u7406\u533A" },
          { value: "431281", label: "\u6D2A\u6C5F\u5E02" }
        ]
      },
      {
        value: "431300",
        label: "\u5A04\u5E95\u5E02",
        children: [
          { value: "431302", label: "\u5A04\u661F\u533A" },
          { value: "431321", label: "\u53CC\u5CF0\u53BF" },
          { value: "431322", label: "\u65B0\u5316\u53BF" },
          { value: "431381", label: "\u51B7\u6C34\u6C5F\u5E02" },
          { value: "431382", label: "\u6D9F\u6E90\u5E02" }
        ]
      },
      {
        value: "433100",
        label: "\u6E58\u897F\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "433101", label: "\u5409\u9996\u5E02" },
          { value: "433122", label: "\u6CF8\u6EAA\u53BF" },
          { value: "433123", label: "\u51E4\u51F0\u53BF" },
          { value: "433124", label: "\u82B1\u57A3\u53BF" },
          { value: "433125", label: "\u4FDD\u9756\u53BF" },
          { value: "433126", label: "\u53E4\u4E08\u53BF" },
          { value: "433127", label: "\u6C38\u987A\u53BF" },
          { value: "433130", label: "\u9F99\u5C71\u53BF" },
          { value: "433173", label: "\u6E56\u5357\u6C38\u987A\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      }
    ]
  },
  {
    value: "440000",
    label: "\u5E7F\u4E1C\u7701",
    children: [
      {
        value: "440100",
        label: "\u5E7F\u5DDE\u5E02",
        children: [
          { value: "440103", label: "\u8354\u6E7E\u533A" },
          { value: "440104", label: "\u8D8A\u79C0\u533A" },
          { value: "440105", label: "\u6D77\u73E0\u533A" },
          { value: "440106", label: "\u5929\u6CB3\u533A" },
          { value: "440111", label: "\u767D\u4E91\u533A" },
          { value: "440112", label: "\u9EC4\u57D4\u533A" },
          { value: "440113", label: "\u756A\u79BA\u533A" },
          { value: "440114", label: "\u82B1\u90FD\u533A" },
          { value: "440115", label: "\u5357\u6C99\u533A" },
          { value: "440117", label: "\u4ECE\u5316\u533A" },
          { value: "440118", label: "\u589E\u57CE\u533A" }
        ]
      },
      {
        value: "440200",
        label: "\u97F6\u5173\u5E02",
        children: [
          { value: "440203", label: "\u6B66\u6C5F\u533A" },
          { value: "440204", label: "\u6D48\u6C5F\u533A" },
          { value: "440205", label: "\u66F2\u6C5F\u533A" },
          { value: "440222", label: "\u59CB\u5174\u53BF" },
          { value: "440224", label: "\u4EC1\u5316\u53BF" },
          { value: "440229", label: "\u7FC1\u6E90\u53BF" },
          { value: "440232", label: "\u4E73\u6E90\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "440233", label: "\u65B0\u4E30\u53BF" },
          { value: "440281", label: "\u4E50\u660C\u5E02" },
          { value: "440282", label: "\u5357\u96C4\u5E02" }
        ]
      },
      {
        value: "440300",
        label: "\u6DF1\u5733\u5E02",
        children: [
          { value: "440303", label: "\u7F57\u6E56\u533A" },
          { value: "440304", label: "\u798F\u7530\u533A" },
          { value: "440305", label: "\u5357\u5C71\u533A" },
          { value: "440306", label: "\u5B9D\u5B89\u533A" },
          { value: "440307", label: "\u9F99\u5C97\u533A" },
          { value: "440308", label: "\u76D0\u7530\u533A" },
          { value: "440309", label: "\u9F99\u534E\u533A" },
          { value: "440310", label: "\u576A\u5C71\u533A" },
          { value: "440311", label: "\u5149\u660E\u533A" }
        ]
      },
      {
        value: "440400",
        label: "\u73E0\u6D77\u5E02",
        children: [
          { value: "440402", label: "\u9999\u6D32\u533A" },
          { value: "440403", label: "\u6597\u95E8\u533A" },
          { value: "440404", label: "\u91D1\u6E7E\u533A" }
        ]
      },
      {
        value: "440500",
        label: "\u6C55\u5934\u5E02",
        children: [
          { value: "440507", label: "\u9F99\u6E56\u533A" },
          { value: "440511", label: "\u91D1\u5E73\u533A" },
          { value: "440512", label: "\u6FE0\u6C5F\u533A" },
          { value: "440513", label: "\u6F6E\u9633\u533A" },
          { value: "440514", label: "\u6F6E\u5357\u533A" },
          { value: "440515", label: "\u6F84\u6D77\u533A" },
          { value: "440523", label: "\u5357\u6FB3\u53BF" }
        ]
      },
      {
        value: "440600",
        label: "\u4F5B\u5C71\u5E02",
        children: [
          { value: "440604", label: "\u7985\u57CE\u533A" },
          { value: "440605", label: "\u5357\u6D77\u533A" },
          { value: "440606", label: "\u987A\u5FB7\u533A" },
          { value: "440607", label: "\u4E09\u6C34\u533A" },
          { value: "440608", label: "\u9AD8\u660E\u533A" }
        ]
      },
      {
        value: "440700",
        label: "\u6C5F\u95E8\u5E02",
        children: [
          { value: "440703", label: "\u84EC\u6C5F\u533A" },
          { value: "440704", label: "\u6C5F\u6D77\u533A" },
          { value: "440705", label: "\u65B0\u4F1A\u533A" },
          { value: "440781", label: "\u53F0\u5C71\u5E02" },
          { value: "440783", label: "\u5F00\u5E73\u5E02" },
          { value: "440784", label: "\u9E64\u5C71\u5E02" },
          { value: "440785", label: "\u6069\u5E73\u5E02" }
        ]
      },
      {
        value: "440800",
        label: "\u6E5B\u6C5F\u5E02",
        children: [
          { value: "440802", label: "\u8D64\u574E\u533A" },
          { value: "440803", label: "\u971E\u5C71\u533A" },
          { value: "440804", label: "\u5761\u5934\u533A" },
          { value: "440811", label: "\u9EBB\u7AE0\u533A" },
          { value: "440823", label: "\u9042\u6EAA\u53BF" },
          { value: "440825", label: "\u5F90\u95FB\u53BF" },
          { value: "440881", label: "\u5EC9\u6C5F\u5E02" },
          { value: "440882", label: "\u96F7\u5DDE\u5E02" },
          { value: "440883", label: "\u5434\u5DDD\u5E02" }
        ]
      },
      {
        value: "440900",
        label: "\u8302\u540D\u5E02",
        children: [
          { value: "440902", label: "\u8302\u5357\u533A" },
          { value: "440904", label: "\u7535\u767D\u533A" },
          { value: "440981", label: "\u9AD8\u5DDE\u5E02" },
          { value: "440982", label: "\u5316\u5DDE\u5E02" },
          { value: "440983", label: "\u4FE1\u5B9C\u5E02" }
        ]
      },
      {
        value: "441200",
        label: "\u8087\u5E86\u5E02",
        children: [
          { value: "441202", label: "\u7AEF\u5DDE\u533A" },
          { value: "441203", label: "\u9F0E\u6E56\u533A" },
          { value: "441204", label: "\u9AD8\u8981\u533A" },
          { value: "441223", label: "\u5E7F\u5B81\u53BF" },
          { value: "441224", label: "\u6000\u96C6\u53BF" },
          { value: "441225", label: "\u5C01\u5F00\u53BF" },
          { value: "441226", label: "\u5FB7\u5E86\u53BF" },
          { value: "441284", label: "\u56DB\u4F1A\u5E02" }
        ]
      },
      {
        value: "441300",
        label: "\u60E0\u5DDE\u5E02",
        children: [
          { value: "441302", label: "\u60E0\u57CE\u533A" },
          { value: "441303", label: "\u60E0\u9633\u533A" },
          { value: "441322", label: "\u535A\u7F57\u53BF" },
          { value: "441323", label: "\u60E0\u4E1C\u53BF" },
          { value: "441324", label: "\u9F99\u95E8\u53BF" }
        ]
      },
      {
        value: "441400",
        label: "\u6885\u5DDE\u5E02",
        children: [
          { value: "441402", label: "\u6885\u6C5F\u533A" },
          { value: "441403", label: "\u6885\u53BF\u533A" },
          { value: "441422", label: "\u5927\u57D4\u53BF" },
          { value: "441423", label: "\u4E30\u987A\u53BF" },
          { value: "441424", label: "\u4E94\u534E\u53BF" },
          { value: "441426", label: "\u5E73\u8FDC\u53BF" },
          { value: "441427", label: "\u8549\u5CAD\u53BF" },
          { value: "441481", label: "\u5174\u5B81\u5E02" }
        ]
      },
      {
        value: "441500",
        label: "\u6C55\u5C3E\u5E02",
        children: [
          { value: "441502", label: "\u57CE\u533A" },
          { value: "441521", label: "\u6D77\u4E30\u53BF" },
          { value: "441523", label: "\u9646\u6CB3\u53BF" },
          { value: "441581", label: "\u9646\u4E30\u5E02" }
        ]
      },
      {
        value: "441600",
        label: "\u6CB3\u6E90\u5E02",
        children: [
          { value: "441602", label: "\u6E90\u57CE\u533A" },
          { value: "441621", label: "\u7D2B\u91D1\u53BF" },
          { value: "441622", label: "\u9F99\u5DDD\u53BF" },
          { value: "441623", label: "\u8FDE\u5E73\u53BF" },
          { value: "441624", label: "\u548C\u5E73\u53BF" },
          { value: "441625", label: "\u4E1C\u6E90\u53BF" }
        ]
      },
      {
        value: "441700",
        label: "\u9633\u6C5F\u5E02",
        children: [
          { value: "441702", label: "\u6C5F\u57CE\u533A" },
          { value: "441704", label: "\u9633\u4E1C\u533A" },
          { value: "441721", label: "\u9633\u897F\u53BF" },
          { value: "441781", label: "\u9633\u6625\u5E02" }
        ]
      },
      {
        value: "441800",
        label: "\u6E05\u8FDC\u5E02",
        children: [
          { value: "441802", label: "\u6E05\u57CE\u533A" },
          { value: "441803", label: "\u6E05\u65B0\u533A" },
          { value: "441821", label: "\u4F5B\u5188\u53BF" },
          { value: "441823", label: "\u9633\u5C71\u53BF" },
          { value: "441825", label: "\u8FDE\u5C71\u58EE\u65CF\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "441826", label: "\u8FDE\u5357\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "441881", label: "\u82F1\u5FB7\u5E02" },
          { value: "441882", label: "\u8FDE\u5DDE\u5E02" }
        ]
      },
      {
        value: "441900",
        label: "\u4E1C\u839E\u5E02",
        children: [
          { value: "441900003", label: "\u4E1C\u57CE\u8857\u9053" },
          { value: "441900004", label: "\u5357\u57CE\u8857\u9053" },
          { value: "441900005", label: "\u4E07\u6C5F\u8857\u9053" },
          { value: "441900006", label: "\u839E\u57CE\u8857\u9053" },
          { value: "441900101", label: "\u77F3\u78A3\u9547" },
          { value: "441900102", label: "\u77F3\u9F99\u9547" },
          { value: "441900103", label: "\u8336\u5C71\u9547" },
          { value: "441900104", label: "\u77F3\u6392\u9547" },
          { value: "441900105", label: "\u4F01\u77F3\u9547" },
          { value: "441900106", label: "\u6A2A\u6CA5\u9547" },
          { value: "441900107", label: "\u6865\u5934\u9547" },
          { value: "441900108", label: "\u8C22\u5C97\u9547" },
          { value: "441900109", label: "\u4E1C\u5751\u9547" },
          { value: "441900110", label: "\u5E38\u5E73\u9547" },
          { value: "441900111", label: "\u5BEE\u6B65\u9547" },
          { value: "441900112", label: "\u6A1F\u6728\u5934\u9547" },
          { value: "441900113", label: "\u5927\u6717\u9547" },
          { value: "441900114", label: "\u9EC4\u6C5F\u9547" },
          { value: "441900115", label: "\u6E05\u6EAA\u9547" },
          { value: "441900116", label: "\u5858\u53A6\u9547" },
          { value: "441900117", label: "\u51E4\u5C97\u9547" },
          { value: "441900118", label: "\u5927\u5CAD\u5C71\u9547" },
          { value: "441900119", label: "\u957F\u5B89\u9547" },
          { value: "441900121", label: "\u864E\u95E8\u9547" },
          { value: "441900122", label: "\u539A\u8857\u9547" },
          { value: "441900123", label: "\u6C99\u7530\u9547" },
          { value: "441900124", label: "\u9053\u6ED8\u9547" },
          { value: "441900125", label: "\u6D2A\u6885\u9547" },
          { value: "441900126", label: "\u9EBB\u6D8C\u9547" },
          { value: "441900127", label: "\u671B\u725B\u58A9\u9547" },
          { value: "441900128", label: "\u4E2D\u5802\u9547" },
          { value: "441900129", label: "\u9AD8\u57D7\u9547" },
          { value: "441900401", label: "\u677E\u5C71\u6E56" },
          { value: "441900402", label: "\u4E1C\u839E\u6E2F" },
          { value: "441900403", label: "\u4E1C\u839E\u751F\u6001\u56ED" }
        ]
      },
      {
        value: "442000",
        label: "\u4E2D\u5C71\u5E02",
        children: [
          { value: "442000001", label: "\u77F3\u5C90\u8857\u9053" },
          { value: "442000002", label: "\u4E1C\u533A\u8857\u9053" },
          { value: "442000003", label: "\u4E2D\u5C71\u6E2F\u8857\u9053" },
          { value: "442000004", label: "\u897F\u533A\u8857\u9053" },
          { value: "442000005", label: "\u5357\u533A\u8857\u9053" },
          { value: "442000006", label: "\u4E94\u6842\u5C71\u8857\u9053" },
          { value: "442000100", label: "\u5C0F\u6984\u9547" },
          { value: "442000101", label: "\u9EC4\u5703\u9547" },
          { value: "442000102", label: "\u6C11\u4F17\u9547" },
          { value: "442000103", label: "\u4E1C\u51E4\u9547" },
          { value: "442000104", label: "\u4E1C\u5347\u9547" },
          { value: "442000105", label: "\u53E4\u9547\u9547" },
          { value: "442000106", label: "\u6C99\u6EAA\u9547" },
          { value: "442000107", label: "\u5766\u6D32\u9547" },
          { value: "442000108", label: "\u6E2F\u53E3\u9547" },
          { value: "442000109", label: "\u4E09\u89D2\u9547" },
          { value: "442000110", label: "\u6A2A\u680F\u9547" },
          { value: "442000111", label: "\u5357\u5934\u9547" },
          { value: "442000112", label: "\u961C\u6C99\u9547" },
          { value: "442000113", label: "\u5357\u6717\u9547" },
          { value: "442000114", label: "\u4E09\u4E61\u9547" },
          { value: "442000115", label: "\u677F\u8299\u9547" },
          { value: "442000116", label: "\u5927\u6D8C\u9547" },
          { value: "442000117", label: "\u795E\u6E7E\u9547" }
        ]
      },
      {
        value: "445100",
        label: "\u6F6E\u5DDE\u5E02",
        children: [
          { value: "445102", label: "\u6E58\u6865\u533A" },
          { value: "445103", label: "\u6F6E\u5B89\u533A" },
          { value: "445122", label: "\u9976\u5E73\u53BF" }
        ]
      },
      {
        value: "445200",
        label: "\u63ED\u9633\u5E02",
        children: [
          { value: "445202", label: "\u6995\u57CE\u533A" },
          { value: "445203", label: "\u63ED\u4E1C\u533A" },
          { value: "445222", label: "\u63ED\u897F\u53BF" },
          { value: "445224", label: "\u60E0\u6765\u53BF" },
          { value: "445281", label: "\u666E\u5B81\u5E02" }
        ]
      },
      {
        value: "445300",
        label: "\u4E91\u6D6E\u5E02",
        children: [
          { value: "445302", label: "\u4E91\u57CE\u533A" },
          { value: "445303", label: "\u4E91\u5B89\u533A" },
          { value: "445321", label: "\u65B0\u5174\u53BF" },
          { value: "445322", label: "\u90C1\u5357\u53BF" },
          { value: "445381", label: "\u7F57\u5B9A\u5E02" }
        ]
      }
    ]
  },
  {
    value: "450000",
    label: "\u5E7F\u897F\u58EE\u65CF\u81EA\u6CBB\u533A",
    children: [
      {
        value: "450100",
        label: "\u5357\u5B81\u5E02",
        children: [
          { value: "450102", label: "\u5174\u5B81\u533A" },
          { value: "450103", label: "\u9752\u79C0\u533A" },
          { value: "450105", label: "\u6C5F\u5357\u533A" },
          { value: "450107", label: "\u897F\u4E61\u5858\u533A" },
          { value: "450108", label: "\u826F\u5E86\u533A" },
          { value: "450109", label: "\u9095\u5B81\u533A" },
          { value: "450110", label: "\u6B66\u9E23\u533A" },
          { value: "450123", label: "\u9686\u5B89\u53BF" },
          { value: "450124", label: "\u9A6C\u5C71\u53BF" },
          { value: "450125", label: "\u4E0A\u6797\u53BF" },
          { value: "450126", label: "\u5BBE\u9633\u53BF" },
          { value: "450127", label: "\u6A2A\u53BF" }
        ]
      },
      {
        value: "450200",
        label: "\u67F3\u5DDE\u5E02",
        children: [
          { value: "450202", label: "\u57CE\u4E2D\u533A" },
          { value: "450203", label: "\u9C7C\u5CF0\u533A" },
          { value: "450204", label: "\u67F3\u5357\u533A" },
          { value: "450205", label: "\u67F3\u5317\u533A" },
          { value: "450206", label: "\u67F3\u6C5F\u533A" },
          { value: "450222", label: "\u67F3\u57CE\u53BF" },
          { value: "450223", label: "\u9E7F\u5BE8\u53BF" },
          { value: "450224", label: "\u878D\u5B89\u53BF" },
          { value: "450225", label: "\u878D\u6C34\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "450226", label: "\u4E09\u6C5F\u4F97\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "450300",
        label: "\u6842\u6797\u5E02",
        children: [
          { value: "450302", label: "\u79C0\u5CF0\u533A" },
          { value: "450303", label: "\u53E0\u5F69\u533A" },
          { value: "450304", label: "\u8C61\u5C71\u533A" },
          { value: "450305", label: "\u4E03\u661F\u533A" },
          { value: "450311", label: "\u96C1\u5C71\u533A" },
          { value: "450312", label: "\u4E34\u6842\u533A" },
          { value: "450321", label: "\u9633\u6714\u53BF" },
          { value: "450323", label: "\u7075\u5DDD\u53BF" },
          { value: "450324", label: "\u5168\u5DDE\u53BF" },
          { value: "450325", label: "\u5174\u5B89\u53BF" },
          { value: "450326", label: "\u6C38\u798F\u53BF" },
          { value: "450327", label: "\u704C\u9633\u53BF" },
          { value: "450328", label: "\u9F99\u80DC\u5404\u65CF\u81EA\u6CBB\u53BF" },
          { value: "450329", label: "\u8D44\u6E90\u53BF" },
          { value: "450330", label: "\u5E73\u4E50\u53BF" },
          { value: "450332", label: "\u606D\u57CE\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "450381", label: "\u8354\u6D66\u5E02" }
        ]
      },
      {
        value: "450400",
        label: "\u68A7\u5DDE\u5E02",
        children: [
          { value: "450403", label: "\u4E07\u79C0\u533A" },
          { value: "450405", label: "\u957F\u6D32\u533A" },
          { value: "450406", label: "\u9F99\u5729\u533A" },
          { value: "450421", label: "\u82CD\u68A7\u53BF" },
          { value: "450422", label: "\u85E4\u53BF" },
          { value: "450423", label: "\u8499\u5C71\u53BF" },
          { value: "450481", label: "\u5C91\u6EAA\u5E02" }
        ]
      },
      {
        value: "450500",
        label: "\u5317\u6D77\u5E02",
        children: [
          { value: "450502", label: "\u6D77\u57CE\u533A" },
          { value: "450503", label: "\u94F6\u6D77\u533A" },
          { value: "450512", label: "\u94C1\u5C71\u6E2F\u533A" },
          { value: "450521", label: "\u5408\u6D66\u53BF" }
        ]
      },
      {
        value: "450600",
        label: "\u9632\u57CE\u6E2F\u5E02",
        children: [
          { value: "450602", label: "\u6E2F\u53E3\u533A" },
          { value: "450603", label: "\u9632\u57CE\u533A" },
          { value: "450621", label: "\u4E0A\u601D\u53BF" },
          { value: "450681", label: "\u4E1C\u5174\u5E02" }
        ]
      },
      {
        value: "450700",
        label: "\u94A6\u5DDE\u5E02",
        children: [
          { value: "450702", label: "\u94A6\u5357\u533A" },
          { value: "450703", label: "\u94A6\u5317\u533A" },
          { value: "450721", label: "\u7075\u5C71\u53BF" },
          { value: "450722", label: "\u6D66\u5317\u53BF" }
        ]
      },
      {
        value: "450800",
        label: "\u8D35\u6E2F\u5E02",
        children: [
          { value: "450802", label: "\u6E2F\u5317\u533A" },
          { value: "450803", label: "\u6E2F\u5357\u533A" },
          { value: "450804", label: "\u8983\u5858\u533A" },
          { value: "450821", label: "\u5E73\u5357\u53BF" },
          { value: "450881", label: "\u6842\u5E73\u5E02" }
        ]
      },
      {
        value: "450900",
        label: "\u7389\u6797\u5E02",
        children: [
          { value: "450902", label: "\u7389\u5DDE\u533A" },
          { value: "450903", label: "\u798F\u7EF5\u533A" },
          { value: "450921", label: "\u5BB9\u53BF" },
          { value: "450922", label: "\u9646\u5DDD\u53BF" },
          { value: "450923", label: "\u535A\u767D\u53BF" },
          { value: "450924", label: "\u5174\u4E1A\u53BF" },
          { value: "450981", label: "\u5317\u6D41\u5E02" }
        ]
      },
      {
        value: "451000",
        label: "\u767E\u8272\u5E02",
        children: [
          { value: "451002", label: "\u53F3\u6C5F\u533A" },
          { value: "451003", label: "\u7530\u9633\u533A" },
          { value: "451022", label: "\u7530\u4E1C\u53BF" },
          { value: "451023", label: "\u5E73\u679C\u53BF" },
          { value: "451024", label: "\u5FB7\u4FDD\u53BF" },
          { value: "451026", label: "\u90A3\u5761\u53BF" },
          { value: "451027", label: "\u51CC\u4E91\u53BF" },
          { value: "451028", label: "\u4E50\u4E1A\u53BF" },
          { value: "451029", label: "\u7530\u6797\u53BF" },
          { value: "451030", label: "\u897F\u6797\u53BF" },
          { value: "451031", label: "\u9686\u6797\u5404\u65CF\u81EA\u6CBB\u53BF" },
          { value: "451081", label: "\u9756\u897F\u5E02" }
        ]
      },
      {
        value: "451100",
        label: "\u8D3A\u5DDE\u5E02",
        children: [
          { value: "451102", label: "\u516B\u6B65\u533A" },
          { value: "451103", label: "\u5E73\u6842\u533A" },
          { value: "451121", label: "\u662D\u5E73\u53BF" },
          { value: "451122", label: "\u949F\u5C71\u53BF" },
          { value: "451123", label: "\u5BCC\u5DDD\u7476\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "451200",
        label: "\u6CB3\u6C60\u5E02",
        children: [
          { value: "451202", label: "\u91D1\u57CE\u6C5F\u533A" },
          { value: "451203", label: "\u5B9C\u5DDE\u533A" },
          { value: "451221", label: "\u5357\u4E39\u53BF" },
          { value: "451222", label: "\u5929\u5CE8\u53BF" },
          { value: "451223", label: "\u51E4\u5C71\u53BF" },
          { value: "451224", label: "\u4E1C\u5170\u53BF" },
          { value: "451225", label: "\u7F57\u57CE\u4EEB\u4F6C\u65CF\u81EA\u6CBB\u53BF" },
          { value: "451226", label: "\u73AF\u6C5F\u6BDB\u5357\u65CF\u81EA\u6CBB\u53BF" },
          { value: "451227", label: "\u5DF4\u9A6C\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "451228", label: "\u90FD\u5B89\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "451229", label: "\u5927\u5316\u7476\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "451300",
        label: "\u6765\u5BBE\u5E02",
        children: [
          { value: "451302", label: "\u5174\u5BBE\u533A" },
          { value: "451321", label: "\u5FFB\u57CE\u53BF" },
          { value: "451322", label: "\u8C61\u5DDE\u53BF" },
          { value: "451323", label: "\u6B66\u5BA3\u53BF" },
          { value: "451324", label: "\u91D1\u79C0\u7476\u65CF\u81EA\u6CBB\u53BF" },
          { value: "451381", label: "\u5408\u5C71\u5E02" }
        ]
      },
      {
        value: "451400",
        label: "\u5D07\u5DE6\u5E02",
        children: [
          { value: "451402", label: "\u6C5F\u5DDE\u533A" },
          { value: "451421", label: "\u6276\u7EE5\u53BF" },
          { value: "451422", label: "\u5B81\u660E\u53BF" },
          { value: "451423", label: "\u9F99\u5DDE\u53BF" },
          { value: "451424", label: "\u5927\u65B0\u53BF" },
          { value: "451425", label: "\u5929\u7B49\u53BF" },
          { value: "451481", label: "\u51ED\u7965\u5E02" }
        ]
      }
    ]
  },
  {
    value: "460000",
    label: "\u6D77\u5357\u7701",
    children: [
      {
        value: "460100",
        label: "\u6D77\u53E3\u5E02",
        children: [
          { value: "460105", label: "\u79C0\u82F1\u533A" },
          { value: "460106", label: "\u9F99\u534E\u533A" },
          { value: "460107", label: "\u743C\u5C71\u533A" },
          { value: "460108", label: "\u7F8E\u5170\u533A" }
        ]
      },
      {
        value: "460200",
        label: "\u4E09\u4E9A\u5E02",
        children: [
          { value: "460202", label: "\u6D77\u68E0\u533A" },
          { value: "460203", label: "\u5409\u9633\u533A" },
          { value: "460204", label: "\u5929\u6DAF\u533A" },
          { value: "460205", label: "\u5D16\u5DDE\u533A" }
        ]
      },
      {
        value: "460300",
        label: "\u4E09\u6C99\u5E02",
        children: [
          { value: "460321", label: "\u897F\u6C99\u7FA4\u5C9B" },
          { value: "460322", label: "\u5357\u6C99\u7FA4\u5C9B" },
          { value: "460323", label: "\u4E2D\u6C99\u7FA4\u5C9B\u7684\u5C9B\u7901\u53CA\u5176\u6D77\u57DF" }
        ]
      },
      {
        value: "460400",
        label: "\u510B\u5DDE\u5E02",
        children: [
          { value: "460400100", label: "\u90A3\u5927\u9547" },
          { value: "460400101", label: "\u548C\u5E86\u9547" },
          { value: "460400102", label: "\u5357\u4E30\u9547" },
          { value: "460400103", label: "\u5927\u6210\u9547" },
          { value: "460400104", label: "\u96C5\u661F\u9547" },
          { value: "460400105", label: "\u5170\u6D0B\u9547" },
          { value: "460400106", label: "\u5149\u6751\u9547" },
          { value: "460400107", label: "\u6728\u68E0\u9547" },
          { value: "460400108", label: "\u6D77\u5934\u9547" },
          { value: "460400109", label: "\u5CE8\u8513\u9547" },
          { value: "460400111", label: "\u738B\u4E94\u9547" },
          { value: "460400112", label: "\u767D\u9A6C\u4E95\u9547" },
          { value: "460400113", label: "\u4E2D\u548C\u9547" },
          { value: "460400114", label: "\u6392\u6D66\u9547" },
          { value: "460400115", label: "\u4E1C\u6210\u9547" },
          { value: "460400116", label: "\u65B0\u5DDE\u9547" },
          { value: "460400499", label: "\u6D0B\u6D66\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "460400500", label: "\u534E\u5357\u70ED\u4F5C\u5B66\u9662" }
        ]
      },
      {
        value: "469000",
        label: "\u7701\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
        children: [
          { value: "469001", label: "\u4E94\u6307\u5C71\u5E02" },
          { value: "469002", label: "\u743C\u6D77\u5E02" },
          { value: "469005", label: "\u6587\u660C\u5E02" },
          { value: "469006", label: "\u4E07\u5B81\u5E02" },
          { value: "469007", label: "\u4E1C\u65B9\u5E02" },
          { value: "469021", label: "\u5B9A\u5B89\u53BF" },
          { value: "469022", label: "\u5C6F\u660C\u53BF" },
          { value: "469023", label: "\u6F84\u8FC8\u53BF" },
          { value: "469024", label: "\u4E34\u9AD8\u53BF" },
          { value: "469025", label: "\u767D\u6C99\u9ECE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "469026", label: "\u660C\u6C5F\u9ECE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "469027", label: "\u4E50\u4E1C\u9ECE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "469028", label: "\u9675\u6C34\u9ECE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "469029", label: "\u4FDD\u4EAD\u9ECE\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "469030", label: "\u743C\u4E2D\u9ECE\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" }
        ]
      }
    ]
  },
  {
    value: "500000",
    label: "\u91CD\u5E86\u5E02",
    children: [
      {
        value: "500100",
        label: "\u91CD\u5E86\u5E02",
        children: [
          { value: "500101", label: "\u4E07\u5DDE\u533A" },
          { value: "500102", label: "\u6DAA\u9675\u533A" },
          { value: "500103", label: "\u6E1D\u4E2D\u533A" },
          { value: "500104", label: "\u5927\u6E21\u53E3\u533A" },
          { value: "500105", label: "\u6C5F\u5317\u533A" },
          { value: "500106", label: "\u6C99\u576A\u575D\u533A" },
          { value: "500107", label: "\u4E5D\u9F99\u5761\u533A" },
          { value: "500108", label: "\u5357\u5CB8\u533A" },
          { value: "500109", label: "\u5317\u789A\u533A" },
          { value: "500110", label: "\u7DA6\u6C5F\u533A" },
          { value: "500111", label: "\u5927\u8DB3\u533A" },
          { value: "500112", label: "\u6E1D\u5317\u533A" },
          { value: "500113", label: "\u5DF4\u5357\u533A" },
          { value: "500114", label: "\u9ED4\u6C5F\u533A" },
          { value: "500115", label: "\u957F\u5BFF\u533A" },
          { value: "500116", label: "\u6C5F\u6D25\u533A" },
          { value: "500117", label: "\u5408\u5DDD\u533A" },
          { value: "500118", label: "\u6C38\u5DDD\u533A" },
          { value: "500119", label: "\u5357\u5DDD\u533A" },
          { value: "500120", label: "\u74A7\u5C71\u533A" },
          { value: "500151", label: "\u94DC\u6881\u533A" },
          { value: "500152", label: "\u6F7C\u5357\u533A" },
          { value: "500153", label: "\u8363\u660C\u533A" },
          { value: "500154", label: "\u5F00\u5DDE\u533A" },
          { value: "500155", label: "\u6881\u5E73\u533A" },
          { value: "500156", label: "\u6B66\u9686\u533A" }
        ]
      },
      {
        value: "500200",
        label: "\u53BF",
        children: [
          { value: "500229", label: "\u57CE\u53E3\u53BF" },
          { value: "500230", label: "\u4E30\u90FD\u53BF" },
          { value: "500231", label: "\u57AB\u6C5F\u53BF" },
          { value: "500233", label: "\u5FE0\u53BF" },
          { value: "500235", label: "\u4E91\u9633\u53BF" },
          { value: "500236", label: "\u5949\u8282\u53BF" },
          { value: "500237", label: "\u5DEB\u5C71\u53BF" },
          { value: "500238", label: "\u5DEB\u6EAA\u53BF" },
          { value: "500240", label: "\u77F3\u67F1\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF" },
          { value: "500241", label: "\u79C0\u5C71\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "500242", label: "\u9149\u9633\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "500243", label: "\u5F6D\u6C34\u82D7\u65CF\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF" }
        ]
      }
    ]
  },
  {
    value: "510000",
    label: "\u56DB\u5DDD\u7701",
    children: [
      {
        value: "510100",
        label: "\u6210\u90FD\u5E02",
        children: [
          { value: "510104", label: "\u9526\u6C5F\u533A" },
          { value: "510105", label: "\u9752\u7F8A\u533A" },
          { value: "510106", label: "\u91D1\u725B\u533A" },
          { value: "510107", label: "\u6B66\u4FAF\u533A" },
          { value: "510108", label: "\u6210\u534E\u533A" },
          { value: "510112", label: "\u9F99\u6CC9\u9A7F\u533A" },
          { value: "510113", label: "\u9752\u767D\u6C5F\u533A" },
          { value: "510114", label: "\u65B0\u90FD\u533A" },
          { value: "510115", label: "\u6E29\u6C5F\u533A" },
          { value: "510116", label: "\u53CC\u6D41\u533A" },
          { value: "510117", label: "\u90EB\u90FD\u533A" },
          { value: "510121", label: "\u91D1\u5802\u53BF" },
          { value: "510129", label: "\u5927\u9091\u53BF" },
          { value: "510131", label: "\u84B2\u6C5F\u53BF" },
          { value: "510132", label: "\u65B0\u6D25\u53BF" },
          { value: "510181", label: "\u90FD\u6C5F\u5830\u5E02" },
          { value: "510182", label: "\u5F6D\u5DDE\u5E02" },
          { value: "510183", label: "\u909B\u5D03\u5E02" },
          { value: "510184", label: "\u5D07\u5DDE\u5E02" },
          { value: "510185", label: "\u7B80\u9633\u5E02" }
        ]
      },
      {
        value: "510300",
        label: "\u81EA\u8D21\u5E02",
        children: [
          { value: "510302", label: "\u81EA\u6D41\u4E95\u533A" },
          { value: "510303", label: "\u8D21\u4E95\u533A" },
          { value: "510304", label: "\u5927\u5B89\u533A" },
          { value: "510311", label: "\u6CBF\u6EE9\u533A" },
          { value: "510321", label: "\u8363\u53BF" },
          { value: "510322", label: "\u5BCC\u987A\u53BF" }
        ]
      },
      {
        value: "510400",
        label: "\u6500\u679D\u82B1\u5E02",
        children: [
          { value: "510402", label: "\u4E1C\u533A" },
          { value: "510403", label: "\u897F\u533A" },
          { value: "510411", label: "\u4EC1\u548C\u533A" },
          { value: "510421", label: "\u7C73\u6613\u53BF" },
          { value: "510422", label: "\u76D0\u8FB9\u53BF" }
        ]
      },
      {
        value: "510500",
        label: "\u6CF8\u5DDE\u5E02",
        children: [
          { value: "510502", label: "\u6C5F\u9633\u533A" },
          { value: "510503", label: "\u7EB3\u6EAA\u533A" },
          { value: "510504", label: "\u9F99\u9A6C\u6F6D\u533A" },
          { value: "510521", label: "\u6CF8\u53BF" },
          { value: "510522", label: "\u5408\u6C5F\u53BF" },
          { value: "510524", label: "\u53D9\u6C38\u53BF" },
          { value: "510525", label: "\u53E4\u853A\u53BF" }
        ]
      },
      {
        value: "510600",
        label: "\u5FB7\u9633\u5E02",
        children: [
          { value: "510603", label: "\u65CC\u9633\u533A" },
          { value: "510604", label: "\u7F57\u6C5F\u533A" },
          { value: "510623", label: "\u4E2D\u6C5F\u53BF" },
          { value: "510681", label: "\u5E7F\u6C49\u5E02" },
          { value: "510682", label: "\u4EC0\u90A1\u5E02" },
          { value: "510683", label: "\u7EF5\u7AF9\u5E02" }
        ]
      },
      {
        value: "510700",
        label: "\u7EF5\u9633\u5E02",
        children: [
          { value: "510703", label: "\u6DAA\u57CE\u533A" },
          { value: "510704", label: "\u6E38\u4ED9\u533A" },
          { value: "510705", label: "\u5B89\u5DDE\u533A" },
          { value: "510722", label: "\u4E09\u53F0\u53BF" },
          { value: "510723", label: "\u76D0\u4EAD\u53BF" },
          { value: "510725", label: "\u6893\u6F7C\u53BF" },
          { value: "510726", label: "\u5317\u5DDD\u7F8C\u65CF\u81EA\u6CBB\u53BF" },
          { value: "510727", label: "\u5E73\u6B66\u53BF" },
          { value: "510781", label: "\u6C5F\u6CB9\u5E02" }
        ]
      },
      {
        value: "510800",
        label: "\u5E7F\u5143\u5E02",
        children: [
          { value: "510802", label: "\u5229\u5DDE\u533A" },
          { value: "510811", label: "\u662D\u5316\u533A" },
          { value: "510812", label: "\u671D\u5929\u533A" },
          { value: "510821", label: "\u65FA\u82CD\u53BF" },
          { value: "510822", label: "\u9752\u5DDD\u53BF" },
          { value: "510823", label: "\u5251\u9601\u53BF" },
          { value: "510824", label: "\u82CD\u6EAA\u53BF" }
        ]
      },
      {
        value: "510900",
        label: "\u9042\u5B81\u5E02",
        children: [
          { value: "510903", label: "\u8239\u5C71\u533A" },
          { value: "510904", label: "\u5B89\u5C45\u533A" },
          { value: "510921", label: "\u84EC\u6EAA\u53BF" },
          { value: "510923", label: "\u5927\u82F1\u53BF" },
          { value: "510981", label: "\u5C04\u6D2A\u5E02" }
        ]
      },
      {
        value: "511000",
        label: "\u5185\u6C5F\u5E02",
        children: [
          { value: "511002", label: "\u5E02\u4E2D\u533A" },
          { value: "511011", label: "\u4E1C\u5174\u533A" },
          { value: "511024", label: "\u5A01\u8FDC\u53BF" },
          { value: "511025", label: "\u8D44\u4E2D\u53BF" },
          { value: "511071", label: "\u5185\u6C5F\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "511083", label: "\u9686\u660C\u5E02" }
        ]
      },
      {
        value: "511100",
        label: "\u4E50\u5C71\u5E02",
        children: [
          { value: "511102", label: "\u5E02\u4E2D\u533A" },
          { value: "511111", label: "\u6C99\u6E7E\u533A" },
          { value: "511112", label: "\u4E94\u901A\u6865\u533A" },
          { value: "511113", label: "\u91D1\u53E3\u6CB3\u533A" },
          { value: "511123", label: "\u728D\u4E3A\u53BF" },
          { value: "511124", label: "\u4E95\u7814\u53BF" },
          { value: "511126", label: "\u5939\u6C5F\u53BF" },
          { value: "511129", label: "\u6C90\u5DDD\u53BF" },
          { value: "511132", label: "\u5CE8\u8FB9\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "511133", label: "\u9A6C\u8FB9\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "511181", label: "\u5CE8\u7709\u5C71\u5E02" }
        ]
      },
      {
        value: "511300",
        label: "\u5357\u5145\u5E02",
        children: [
          { value: "511302", label: "\u987A\u5E86\u533A" },
          { value: "511303", label: "\u9AD8\u576A\u533A" },
          { value: "511304", label: "\u5609\u9675\u533A" },
          { value: "511321", label: "\u5357\u90E8\u53BF" },
          { value: "511322", label: "\u8425\u5C71\u53BF" },
          { value: "511323", label: "\u84EC\u5B89\u53BF" },
          { value: "511324", label: "\u4EEA\u9647\u53BF" },
          { value: "511325", label: "\u897F\u5145\u53BF" },
          { value: "511381", label: "\u9606\u4E2D\u5E02" }
        ]
      },
      {
        value: "511400",
        label: "\u7709\u5C71\u5E02",
        children: [
          { value: "511402", label: "\u4E1C\u5761\u533A" },
          { value: "511403", label: "\u5F6D\u5C71\u533A" },
          { value: "511421", label: "\u4EC1\u5BFF\u53BF" },
          { value: "511423", label: "\u6D2A\u96C5\u53BF" },
          { value: "511424", label: "\u4E39\u68F1\u53BF" },
          { value: "511425", label: "\u9752\u795E\u53BF" }
        ]
      },
      {
        value: "511500",
        label: "\u5B9C\u5BBE\u5E02",
        children: [
          { value: "511502", label: "\u7FE0\u5C4F\u533A" },
          { value: "511503", label: "\u5357\u6EAA\u533A" },
          { value: "511504", label: "\u53D9\u5DDE\u533A" },
          { value: "511523", label: "\u6C5F\u5B89\u53BF" },
          { value: "511524", label: "\u957F\u5B81\u53BF" },
          { value: "511525", label: "\u9AD8\u53BF" },
          { value: "511526", label: "\u73D9\u53BF" },
          { value: "511527", label: "\u7B60\u8FDE\u53BF" },
          { value: "511528", label: "\u5174\u6587\u53BF" },
          { value: "511529", label: "\u5C4F\u5C71\u53BF" }
        ]
      },
      {
        value: "511600",
        label: "\u5E7F\u5B89\u5E02",
        children: [
          { value: "511602", label: "\u5E7F\u5B89\u533A" },
          { value: "511603", label: "\u524D\u950B\u533A" },
          { value: "511621", label: "\u5CB3\u6C60\u53BF" },
          { value: "511622", label: "\u6B66\u80DC\u53BF" },
          { value: "511623", label: "\u90BB\u6C34\u53BF" },
          { value: "511681", label: "\u534E\u84E5\u5E02" }
        ]
      },
      {
        value: "511700",
        label: "\u8FBE\u5DDE\u5E02",
        children: [
          { value: "511702", label: "\u901A\u5DDD\u533A" },
          { value: "511703", label: "\u8FBE\u5DDD\u533A" },
          { value: "511722", label: "\u5BA3\u6C49\u53BF" },
          { value: "511723", label: "\u5F00\u6C5F\u53BF" },
          { value: "511724", label: "\u5927\u7AF9\u53BF" },
          { value: "511725", label: "\u6E20\u53BF" },
          { value: "511771", label: "\u8FBE\u5DDE\u7ECF\u6D4E\u5F00\u53D1\u533A" },
          { value: "511781", label: "\u4E07\u6E90\u5E02" }
        ]
      },
      {
        value: "511800",
        label: "\u96C5\u5B89\u5E02",
        children: [
          { value: "511802", label: "\u96E8\u57CE\u533A" },
          { value: "511803", label: "\u540D\u5C71\u533A" },
          { value: "511822", label: "\u8365\u7ECF\u53BF" },
          { value: "511823", label: "\u6C49\u6E90\u53BF" },
          { value: "511824", label: "\u77F3\u68C9\u53BF" },
          { value: "511825", label: "\u5929\u5168\u53BF" },
          { value: "511826", label: "\u82A6\u5C71\u53BF" },
          { value: "511827", label: "\u5B9D\u5174\u53BF" }
        ]
      },
      {
        value: "511900",
        label: "\u5DF4\u4E2D\u5E02",
        children: [
          { value: "511902", label: "\u5DF4\u5DDE\u533A" },
          { value: "511903", label: "\u6069\u9633\u533A" },
          { value: "511921", label: "\u901A\u6C5F\u53BF" },
          { value: "511922", label: "\u5357\u6C5F\u53BF" },
          { value: "511923", label: "\u5E73\u660C\u53BF" },
          { value: "511971", label: "\u5DF4\u4E2D\u7ECF\u6D4E\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "512000",
        label: "\u8D44\u9633\u5E02",
        children: [
          { value: "512002", label: "\u96C1\u6C5F\u533A" },
          { value: "512021", label: "\u5B89\u5CB3\u53BF" },
          { value: "512022", label: "\u4E50\u81F3\u53BF" }
        ]
      },
      {
        value: "513200",
        label: "\u963F\u575D\u85CF\u65CF\u7F8C\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "513201", label: "\u9A6C\u5C14\u5EB7\u5E02" },
          { value: "513221", label: "\u6C76\u5DDD\u53BF" },
          { value: "513222", label: "\u7406\u53BF" },
          { value: "513223", label: "\u8302\u53BF" },
          { value: "513224", label: "\u677E\u6F58\u53BF" },
          { value: "513225", label: "\u4E5D\u5BE8\u6C9F\u53BF" },
          { value: "513226", label: "\u91D1\u5DDD\u53BF" },
          { value: "513227", label: "\u5C0F\u91D1\u53BF" },
          { value: "513228", label: "\u9ED1\u6C34\u53BF" },
          { value: "513230", label: "\u58E4\u5858\u53BF" },
          { value: "513231", label: "\u963F\u575D\u53BF" },
          { value: "513232", label: "\u82E5\u5C14\u76D6\u53BF" },
          { value: "513233", label: "\u7EA2\u539F\u53BF" }
        ]
      },
      {
        value: "513300",
        label: "\u7518\u5B5C\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "513301", label: "\u5EB7\u5B9A\u5E02" },
          { value: "513322", label: "\u6CF8\u5B9A\u53BF" },
          { value: "513323", label: "\u4E39\u5DF4\u53BF" },
          { value: "513324", label: "\u4E5D\u9F99\u53BF" },
          { value: "513325", label: "\u96C5\u6C5F\u53BF" },
          { value: "513326", label: "\u9053\u5B5A\u53BF" },
          { value: "513327", label: "\u7089\u970D\u53BF" },
          { value: "513328", label: "\u7518\u5B5C\u53BF" },
          { value: "513329", label: "\u65B0\u9F99\u53BF" },
          { value: "513330", label: "\u5FB7\u683C\u53BF" },
          { value: "513331", label: "\u767D\u7389\u53BF" },
          { value: "513332", label: "\u77F3\u6E20\u53BF" },
          { value: "513333", label: "\u8272\u8FBE\u53BF" },
          { value: "513334", label: "\u7406\u5858\u53BF" },
          { value: "513335", label: "\u5DF4\u5858\u53BF" },
          { value: "513336", label: "\u4E61\u57CE\u53BF" },
          { value: "513337", label: "\u7A3B\u57CE\u53BF" },
          { value: "513338", label: "\u5F97\u8363\u53BF" }
        ]
      },
      {
        value: "513400",
        label: "\u51C9\u5C71\u5F5D\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "513401", label: "\u897F\u660C\u5E02" },
          { value: "513422", label: "\u6728\u91CC\u85CF\u65CF\u81EA\u6CBB\u53BF" },
          { value: "513423", label: "\u76D0\u6E90\u53BF" },
          { value: "513424", label: "\u5FB7\u660C\u53BF" },
          { value: "513425", label: "\u4F1A\u7406\u53BF" },
          { value: "513426", label: "\u4F1A\u4E1C\u53BF" },
          { value: "513427", label: "\u5B81\u5357\u53BF" },
          { value: "513428", label: "\u666E\u683C\u53BF" },
          { value: "513429", label: "\u5E03\u62D6\u53BF" },
          { value: "513430", label: "\u91D1\u9633\u53BF" },
          { value: "513431", label: "\u662D\u89C9\u53BF" },
          { value: "513432", label: "\u559C\u5FB7\u53BF" },
          { value: "513433", label: "\u5195\u5B81\u53BF" },
          { value: "513434", label: "\u8D8A\u897F\u53BF" },
          { value: "513435", label: "\u7518\u6D1B\u53BF" },
          { value: "513436", label: "\u7F8E\u59D1\u53BF" },
          { value: "513437", label: "\u96F7\u6CE2\u53BF" }
        ]
      }
    ]
  },
  {
    value: "520000",
    label: "\u8D35\u5DDE\u7701",
    children: [
      {
        value: "520100",
        label: "\u8D35\u9633\u5E02",
        children: [
          { value: "520102", label: "\u5357\u660E\u533A" },
          { value: "520103", label: "\u4E91\u5CA9\u533A" },
          { value: "520111", label: "\u82B1\u6EAA\u533A" },
          { value: "520112", label: "\u4E4C\u5F53\u533A" },
          { value: "520113", label: "\u767D\u4E91\u533A" },
          { value: "520115", label: "\u89C2\u5C71\u6E56\u533A" },
          { value: "520121", label: "\u5F00\u9633\u53BF" },
          { value: "520122", label: "\u606F\u70FD\u53BF" },
          { value: "520123", label: "\u4FEE\u6587\u53BF" },
          { value: "520181", label: "\u6E05\u9547\u5E02" }
        ]
      },
      {
        value: "520200",
        label: "\u516D\u76D8\u6C34\u5E02",
        children: [
          { value: "520201", label: "\u949F\u5C71\u533A" },
          { value: "520203", label: "\u516D\u679D\u7279\u533A" },
          { value: "520221", label: "\u6C34\u57CE\u53BF" },
          { value: "520281", label: "\u76D8\u5DDE\u5E02" }
        ]
      },
      {
        value: "520300",
        label: "\u9075\u4E49\u5E02",
        children: [
          { value: "520302", label: "\u7EA2\u82B1\u5C97\u533A" },
          { value: "520303", label: "\u6C47\u5DDD\u533A" },
          { value: "520304", label: "\u64AD\u5DDE\u533A" },
          { value: "520322", label: "\u6850\u6893\u53BF" },
          { value: "520323", label: "\u7EE5\u9633\u53BF" },
          { value: "520324", label: "\u6B63\u5B89\u53BF" },
          { value: "520325", label: "\u9053\u771F\u4EE1\u4F6C\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520326", label: "\u52A1\u5DDD\u4EE1\u4F6C\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520327", label: "\u51E4\u5188\u53BF" },
          { value: "520328", label: "\u6E44\u6F6D\u53BF" },
          { value: "520329", label: "\u4F59\u5E86\u53BF" },
          { value: "520330", label: "\u4E60\u6C34\u53BF" },
          { value: "520381", label: "\u8D64\u6C34\u5E02" },
          { value: "520382", label: "\u4EC1\u6000\u5E02" }
        ]
      },
      {
        value: "520400",
        label: "\u5B89\u987A\u5E02",
        children: [
          { value: "520402", label: "\u897F\u79C0\u533A" },
          { value: "520403", label: "\u5E73\u575D\u533A" },
          { value: "520422", label: "\u666E\u5B9A\u53BF" },
          { value: "520423", label: "\u9547\u5B81\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520424", label: "\u5173\u5CAD\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520425", label: "\u7D2B\u4E91\u82D7\u65CF\u5E03\u4F9D\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "520500",
        label: "\u6BD5\u8282\u5E02",
        children: [
          { value: "520502", label: "\u4E03\u661F\u5173\u533A" },
          { value: "520521", label: "\u5927\u65B9\u53BF" },
          { value: "520522", label: "\u9ED4\u897F\u53BF" },
          { value: "520523", label: "\u91D1\u6C99\u53BF" },
          { value: "520524", label: "\u7EC7\u91D1\u53BF" },
          { value: "520525", label: "\u7EB3\u96CD\u53BF" },
          { value: "520526", label: "\u5A01\u5B81\u5F5D\u65CF\u56DE\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520527", label: "\u8D6B\u7AE0\u53BF" }
        ]
      },
      {
        value: "520600",
        label: "\u94DC\u4EC1\u5E02",
        children: [
          { value: "520602", label: "\u78A7\u6C5F\u533A" },
          { value: "520603", label: "\u4E07\u5C71\u533A" },
          { value: "520621", label: "\u6C5F\u53E3\u53BF" },
          { value: "520622", label: "\u7389\u5C4F\u4F97\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520623", label: "\u77F3\u9621\u53BF" },
          { value: "520624", label: "\u601D\u5357\u53BF" },
          { value: "520625", label: "\u5370\u6C5F\u571F\u5BB6\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520626", label: "\u5FB7\u6C5F\u53BF" },
          { value: "520627", label: "\u6CBF\u6CB3\u571F\u5BB6\u65CF\u81EA\u6CBB\u53BF" },
          { value: "520628", label: "\u677E\u6843\u82D7\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "522300",
        label: "\u9ED4\u897F\u5357\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "522301", label: "\u5174\u4E49\u5E02" },
          { value: "522302", label: "\u5174\u4EC1\u5E02" },
          { value: "522323", label: "\u666E\u5B89\u53BF" },
          { value: "522324", label: "\u6674\u9686\u53BF" },
          { value: "522325", label: "\u8D1E\u4E30\u53BF" },
          { value: "522326", label: "\u671B\u8C1F\u53BF" },
          { value: "522327", label: "\u518C\u4EA8\u53BF" },
          { value: "522328", label: "\u5B89\u9F99\u53BF" }
        ]
      },
      {
        value: "522600",
        label: "\u9ED4\u4E1C\u5357\u82D7\u65CF\u4F97\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "522601", label: "\u51EF\u91CC\u5E02" },
          { value: "522622", label: "\u9EC4\u5E73\u53BF" },
          { value: "522623", label: "\u65BD\u79C9\u53BF" },
          { value: "522624", label: "\u4E09\u7A57\u53BF" },
          { value: "522625", label: "\u9547\u8FDC\u53BF" },
          { value: "522626", label: "\u5C91\u5DE9\u53BF" },
          { value: "522627", label: "\u5929\u67F1\u53BF" },
          { value: "522628", label: "\u9526\u5C4F\u53BF" },
          { value: "522629", label: "\u5251\u6CB3\u53BF" },
          { value: "522630", label: "\u53F0\u6C5F\u53BF" },
          { value: "522631", label: "\u9ECE\u5E73\u53BF" },
          { value: "522632", label: "\u6995\u6C5F\u53BF" },
          { value: "522633", label: "\u4ECE\u6C5F\u53BF" },
          { value: "522634", label: "\u96F7\u5C71\u53BF" },
          { value: "522635", label: "\u9EBB\u6C5F\u53BF" },
          { value: "522636", label: "\u4E39\u5BE8\u53BF" }
        ]
      },
      {
        value: "522700",
        label: "\u9ED4\u5357\u5E03\u4F9D\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "522701", label: "\u90FD\u5300\u5E02" },
          { value: "522702", label: "\u798F\u6CC9\u5E02" },
          { value: "522722", label: "\u8354\u6CE2\u53BF" },
          { value: "522723", label: "\u8D35\u5B9A\u53BF" },
          { value: "522725", label: "\u74EE\u5B89\u53BF" },
          { value: "522726", label: "\u72EC\u5C71\u53BF" },
          { value: "522727", label: "\u5E73\u5858\u53BF" },
          { value: "522728", label: "\u7F57\u7538\u53BF" },
          { value: "522729", label: "\u957F\u987A\u53BF" },
          { value: "522730", label: "\u9F99\u91CC\u53BF" },
          { value: "522731", label: "\u60E0\u6C34\u53BF" },
          { value: "522732", label: "\u4E09\u90FD\u6C34\u65CF\u81EA\u6CBB\u53BF" }
        ]
      }
    ]
  },
  {
    value: "530000",
    label: "\u4E91\u5357\u7701",
    children: [
      {
        value: "530100",
        label: "\u6606\u660E\u5E02",
        children: [
          { value: "530102", label: "\u4E94\u534E\u533A" },
          { value: "530103", label: "\u76D8\u9F99\u533A" },
          { value: "530111", label: "\u5B98\u6E21\u533A" },
          { value: "530112", label: "\u897F\u5C71\u533A" },
          { value: "530113", label: "\u4E1C\u5DDD\u533A" },
          { value: "530114", label: "\u5448\u8D21\u533A" },
          { value: "530115", label: "\u664B\u5B81\u533A" },
          { value: "530124", label: "\u5BCC\u6C11\u53BF" },
          { value: "530125", label: "\u5B9C\u826F\u53BF" },
          { value: "530126", label: "\u77F3\u6797\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530127", label: "\u5D69\u660E\u53BF" },
          { value: "530128", label: "\u7984\u529D\u5F5D\u65CF\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530129", label: "\u5BFB\u7538\u56DE\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530181", label: "\u5B89\u5B81\u5E02" }
        ]
      },
      {
        value: "530300",
        label: "\u66F2\u9756\u5E02",
        children: [
          { value: "530302", label: "\u9E92\u9E9F\u533A" },
          { value: "530303", label: "\u6CBE\u76CA\u533A" },
          { value: "530304", label: "\u9A6C\u9F99\u533A" },
          { value: "530322", label: "\u9646\u826F\u53BF" },
          { value: "530323", label: "\u5E08\u5B97\u53BF" },
          { value: "530324", label: "\u7F57\u5E73\u53BF" },
          { value: "530325", label: "\u5BCC\u6E90\u53BF" },
          { value: "530326", label: "\u4F1A\u6CFD\u53BF" },
          { value: "530381", label: "\u5BA3\u5A01\u5E02" }
        ]
      },
      {
        value: "530400",
        label: "\u7389\u6EAA\u5E02",
        children: [
          { value: "530402", label: "\u7EA2\u5854\u533A" },
          { value: "530403", label: "\u6C5F\u5DDD\u533A" },
          { value: "530422", label: "\u6F84\u6C5F\u53BF" },
          { value: "530423", label: "\u901A\u6D77\u53BF" },
          { value: "530424", label: "\u534E\u5B81\u53BF" },
          { value: "530425", label: "\u6613\u95E8\u53BF" },
          { value: "530426", label: "\u5CE8\u5C71\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530427", label: "\u65B0\u5E73\u5F5D\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530428", label: "\u5143\u6C5F\u54C8\u5C3C\u65CF\u5F5D\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "530500",
        label: "\u4FDD\u5C71\u5E02",
        children: [
          { value: "530502", label: "\u9686\u9633\u533A" },
          { value: "530521", label: "\u65BD\u7538\u53BF" },
          { value: "530523", label: "\u9F99\u9675\u53BF" },
          { value: "530524", label: "\u660C\u5B81\u53BF" },
          { value: "530581", label: "\u817E\u51B2\u5E02" }
        ]
      },
      {
        value: "530600",
        label: "\u662D\u901A\u5E02",
        children: [
          { value: "530602", label: "\u662D\u9633\u533A" },
          { value: "530621", label: "\u9C81\u7538\u53BF" },
          { value: "530622", label: "\u5DE7\u5BB6\u53BF" },
          { value: "530623", label: "\u76D0\u6D25\u53BF" },
          { value: "530624", label: "\u5927\u5173\u53BF" },
          { value: "530625", label: "\u6C38\u5584\u53BF" },
          { value: "530626", label: "\u7EE5\u6C5F\u53BF" },
          { value: "530627", label: "\u9547\u96C4\u53BF" },
          { value: "530628", label: "\u5F5D\u826F\u53BF" },
          { value: "530629", label: "\u5A01\u4FE1\u53BF" },
          { value: "530681", label: "\u6C34\u5BCC\u5E02" }
        ]
      },
      {
        value: "530700",
        label: "\u4E3D\u6C5F\u5E02",
        children: [
          { value: "530702", label: "\u53E4\u57CE\u533A" },
          { value: "530721", label: "\u7389\u9F99\u7EB3\u897F\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530722", label: "\u6C38\u80DC\u53BF" },
          { value: "530723", label: "\u534E\u576A\u53BF" },
          { value: "530724", label: "\u5B81\u8497\u5F5D\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "530800",
        label: "\u666E\u6D31\u5E02",
        children: [
          { value: "530802", label: "\u601D\u8305\u533A" },
          { value: "530821", label: "\u5B81\u6D31\u54C8\u5C3C\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530822", label: "\u58A8\u6C5F\u54C8\u5C3C\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530823", label: "\u666F\u4E1C\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530824", label: "\u666F\u8C37\u50A3\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530825", label: "\u9547\u6C85\u5F5D\u65CF\u54C8\u5C3C\u65CF\u62C9\u795C\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530826", label: "\u6C5F\u57CE\u54C8\u5C3C\u65CF\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530827", label: "\u5B5F\u8FDE\u50A3\u65CF\u62C9\u795C\u65CF\u4F64\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530828", label: "\u6F9C\u6CA7\u62C9\u795C\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530829", label: "\u897F\u76DF\u4F64\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "530900",
        label: "\u4E34\u6CA7\u5E02",
        children: [
          { value: "530902", label: "\u4E34\u7FD4\u533A" },
          { value: "530921", label: "\u51E4\u5E86\u53BF" },
          { value: "530922", label: "\u4E91\u53BF" },
          { value: "530923", label: "\u6C38\u5FB7\u53BF" },
          { value: "530924", label: "\u9547\u5EB7\u53BF" },
          { value: "530925", label: "\u53CC\u6C5F\u62C9\u795C\u65CF\u4F64\u65CF\u5E03\u6717\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530926", label: "\u803F\u9A6C\u50A3\u65CF\u4F64\u65CF\u81EA\u6CBB\u53BF" },
          { value: "530927", label: "\u6CA7\u6E90\u4F64\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "532300",
        label: "\u695A\u96C4\u5F5D\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "532301", label: "\u695A\u96C4\u5E02" },
          { value: "532322", label: "\u53CC\u67CF\u53BF" },
          { value: "532323", label: "\u725F\u5B9A\u53BF" },
          { value: "532324", label: "\u5357\u534E\u53BF" },
          { value: "532325", label: "\u59DA\u5B89\u53BF" },
          { value: "532326", label: "\u5927\u59DA\u53BF" },
          { value: "532327", label: "\u6C38\u4EC1\u53BF" },
          { value: "532328", label: "\u5143\u8C0B\u53BF" },
          { value: "532329", label: "\u6B66\u5B9A\u53BF" },
          { value: "532331", label: "\u7984\u4E30\u53BF" }
        ]
      },
      {
        value: "532500",
        label: "\u7EA2\u6CB3\u54C8\u5C3C\u65CF\u5F5D\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "532501", label: "\u4E2A\u65E7\u5E02" },
          { value: "532502", label: "\u5F00\u8FDC\u5E02" },
          { value: "532503", label: "\u8499\u81EA\u5E02" },
          { value: "532504", label: "\u5F25\u52D2\u5E02" },
          { value: "532523", label: "\u5C4F\u8FB9\u82D7\u65CF\u81EA\u6CBB\u53BF" },
          { value: "532524", label: "\u5EFA\u6C34\u53BF" },
          { value: "532525", label: "\u77F3\u5C4F\u53BF" },
          { value: "532527", label: "\u6CF8\u897F\u53BF" },
          { value: "532528", label: "\u5143\u9633\u53BF" },
          { value: "532529", label: "\u7EA2\u6CB3\u53BF" },
          { value: "532530", label: "\u91D1\u5E73\u82D7\u65CF\u7476\u65CF\u50A3\u65CF\u81EA\u6CBB\u53BF" },
          { value: "532531", label: "\u7EFF\u6625\u53BF" },
          { value: "532532", label: "\u6CB3\u53E3\u7476\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "532600",
        label: "\u6587\u5C71\u58EE\u65CF\u82D7\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "532601", label: "\u6587\u5C71\u5E02" },
          { value: "532622", label: "\u781A\u5C71\u53BF" },
          { value: "532623", label: "\u897F\u7574\u53BF" },
          { value: "532624", label: "\u9EBB\u6817\u5761\u53BF" },
          { value: "532625", label: "\u9A6C\u5173\u53BF" },
          { value: "532626", label: "\u4E18\u5317\u53BF" },
          { value: "532627", label: "\u5E7F\u5357\u53BF" },
          { value: "532628", label: "\u5BCC\u5B81\u53BF" }
        ]
      },
      {
        value: "532800",
        label: "\u897F\u53CC\u7248\u7EB3\u50A3\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "532801", label: "\u666F\u6D2A\u5E02" },
          { value: "532822", label: "\u52D0\u6D77\u53BF" },
          { value: "532823", label: "\u52D0\u814A\u53BF" }
        ]
      },
      {
        value: "532900",
        label: "\u5927\u7406\u767D\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "532901", label: "\u5927\u7406\u5E02" },
          { value: "532922", label: "\u6F3E\u6FDE\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "532923", label: "\u7965\u4E91\u53BF" },
          { value: "532924", label: "\u5BBE\u5DDD\u53BF" },
          { value: "532925", label: "\u5F25\u6E21\u53BF" },
          { value: "532926", label: "\u5357\u6DA7\u5F5D\u65CF\u81EA\u6CBB\u53BF" },
          { value: "532927", label: "\u5DCD\u5C71\u5F5D\u65CF\u56DE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "532928", label: "\u6C38\u5E73\u53BF" },
          { value: "532929", label: "\u4E91\u9F99\u53BF" },
          { value: "532930", label: "\u6D31\u6E90\u53BF" },
          { value: "532931", label: "\u5251\u5DDD\u53BF" },
          { value: "532932", label: "\u9E64\u5E86\u53BF" }
        ]
      },
      {
        value: "533100",
        label: "\u5FB7\u5B8F\u50A3\u65CF\u666F\u9887\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "533102", label: "\u745E\u4E3D\u5E02" },
          { value: "533103", label: "\u8292\u5E02" },
          { value: "533122", label: "\u6881\u6CB3\u53BF" },
          { value: "533123", label: "\u76C8\u6C5F\u53BF" },
          { value: "533124", label: "\u9647\u5DDD\u53BF" }
        ]
      },
      {
        value: "533300",
        label: "\u6012\u6C5F\u5088\u50F3\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "533301", label: "\u6CF8\u6C34\u5E02" },
          { value: "533323", label: "\u798F\u8D21\u53BF" },
          { value: "533324", label: "\u8D21\u5C71\u72EC\u9F99\u65CF\u6012\u65CF\u81EA\u6CBB\u53BF" },
          { value: "533325", label: "\u5170\u576A\u767D\u65CF\u666E\u7C73\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "533400",
        label: "\u8FEA\u5E86\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "533401", label: "\u9999\u683C\u91CC\u62C9\u5E02" },
          { value: "533422", label: "\u5FB7\u94A6\u53BF" },
          { value: "533423", label: "\u7EF4\u897F\u5088\u50F3\u65CF\u81EA\u6CBB\u53BF" }
        ]
      }
    ]
  },
  {
    value: "540000",
    label: "\u897F\u85CF\u81EA\u6CBB\u533A",
    children: [
      {
        value: "540100",
        label: "\u62C9\u8428\u5E02",
        children: [
          { value: "540102", label: "\u57CE\u5173\u533A" },
          { value: "540103", label: "\u5806\u9F99\u5FB7\u5E86\u533A" },
          { value: "540104", label: "\u8FBE\u5B5C\u533A" },
          { value: "540121", label: "\u6797\u5468\u53BF" },
          { value: "540122", label: "\u5F53\u96C4\u53BF" },
          { value: "540123", label: "\u5C3C\u6728\u53BF" },
          { value: "540124", label: "\u66F2\u6C34\u53BF" },
          { value: "540127", label: "\u58A8\u7AF9\u5DE5\u5361\u53BF" },
          { value: "540171", label: "\u683C\u5C14\u6728\u85CF\u9752\u5DE5\u4E1A\u56ED\u533A" },
          { value: "540172", label: "\u62C9\u8428\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" },
          { value: "540173", label: "\u897F\u85CF\u6587\u5316\u65C5\u6E38\u521B\u610F\u56ED\u533A" },
          { value: "540174", label: "\u8FBE\u5B5C\u5DE5\u4E1A\u56ED\u533A" }
        ]
      },
      {
        value: "540200",
        label: "\u65E5\u5580\u5219\u5E02",
        children: [
          { value: "540202", label: "\u6851\u73E0\u5B5C\u533A" },
          { value: "540221", label: "\u5357\u6728\u6797\u53BF" },
          { value: "540222", label: "\u6C5F\u5B5C\u53BF" },
          { value: "540223", label: "\u5B9A\u65E5\u53BF" },
          { value: "540224", label: "\u8428\u8FE6\u53BF" },
          { value: "540225", label: "\u62C9\u5B5C\u53BF" },
          { value: "540226", label: "\u6602\u4EC1\u53BF" },
          { value: "540227", label: "\u8C22\u901A\u95E8\u53BF" },
          { value: "540228", label: "\u767D\u6717\u53BF" },
          { value: "540229", label: "\u4EC1\u5E03\u53BF" },
          { value: "540230", label: "\u5EB7\u9A6C\u53BF" },
          { value: "540231", label: "\u5B9A\u7ED3\u53BF" },
          { value: "540232", label: "\u4EF2\u5DF4\u53BF" },
          { value: "540233", label: "\u4E9A\u4E1C\u53BF" },
          { value: "540234", label: "\u5409\u9686\u53BF" },
          { value: "540235", label: "\u8042\u62C9\u6728\u53BF" },
          { value: "540236", label: "\u8428\u560E\u53BF" },
          { value: "540237", label: "\u5C97\u5DF4\u53BF" }
        ]
      },
      {
        value: "540300",
        label: "\u660C\u90FD\u5E02",
        children: [
          { value: "540302", label: "\u5361\u82E5\u533A" },
          { value: "540321", label: "\u6C5F\u8FBE\u53BF" },
          { value: "540322", label: "\u8D21\u89C9\u53BF" },
          { value: "540323", label: "\u7C7B\u4E4C\u9F50\u53BF" },
          { value: "540324", label: "\u4E01\u9752\u53BF" },
          { value: "540325", label: "\u5BDF\u96C5\u53BF" },
          { value: "540326", label: "\u516B\u5BBF\u53BF" },
          { value: "540327", label: "\u5DE6\u8D21\u53BF" },
          { value: "540328", label: "\u8292\u5EB7\u53BF" },
          { value: "540329", label: "\u6D1B\u9686\u53BF" },
          { value: "540330", label: "\u8FB9\u575D\u53BF" }
        ]
      },
      {
        value: "540400",
        label: "\u6797\u829D\u5E02",
        children: [
          { value: "540402", label: "\u5DF4\u5B9C\u533A" },
          { value: "540421", label: "\u5DE5\u5E03\u6C5F\u8FBE\u53BF" },
          { value: "540422", label: "\u7C73\u6797\u53BF" },
          { value: "540423", label: "\u58A8\u8131\u53BF" },
          { value: "540424", label: "\u6CE2\u5BC6\u53BF" },
          { value: "540425", label: "\u5BDF\u9685\u53BF" },
          { value: "540426", label: "\u6717\u53BF" }
        ]
      },
      {
        value: "540500",
        label: "\u5C71\u5357\u5E02",
        children: [
          { value: "540502", label: "\u4E43\u4E1C\u533A" },
          { value: "540521", label: "\u624E\u56CA\u53BF" },
          { value: "540522", label: "\u8D21\u560E\u53BF" },
          { value: "540523", label: "\u6851\u65E5\u53BF" },
          { value: "540524", label: "\u743C\u7ED3\u53BF" },
          { value: "540525", label: "\u66F2\u677E\u53BF" },
          { value: "540526", label: "\u63AA\u7F8E\u53BF" },
          { value: "540527", label: "\u6D1B\u624E\u53BF" },
          { value: "540528", label: "\u52A0\u67E5\u53BF" },
          { value: "540529", label: "\u9686\u5B50\u53BF" },
          { value: "540530", label: "\u9519\u90A3\u53BF" },
          { value: "540531", label: "\u6D6A\u5361\u5B50\u53BF" }
        ]
      },
      {
        value: "540600",
        label: "\u90A3\u66F2\u5E02",
        children: [
          { value: "540602", label: "\u8272\u5C3C\u533A" },
          { value: "540621", label: "\u5609\u9ECE\u53BF" },
          { value: "540622", label: "\u6BD4\u5982\u53BF" },
          { value: "540623", label: "\u8042\u8363\u53BF" },
          { value: "540624", label: "\u5B89\u591A\u53BF" },
          { value: "540625", label: "\u7533\u624E\u53BF" },
          { value: "540626", label: "\u7D22\u53BF" },
          { value: "540627", label: "\u73ED\u6208\u53BF" },
          { value: "540628", label: "\u5DF4\u9752\u53BF" },
          { value: "540629", label: "\u5C3C\u739B\u53BF" },
          { value: "540630", label: "\u53CC\u6E56\u53BF" }
        ]
      },
      {
        value: "542500",
        label: "\u963F\u91CC\u5730\u533A",
        children: [
          { value: "542521", label: "\u666E\u5170\u53BF" },
          { value: "542522", label: "\u672D\u8FBE\u53BF" },
          { value: "542523", label: "\u5676\u5C14\u53BF" },
          { value: "542524", label: "\u65E5\u571F\u53BF" },
          { value: "542525", label: "\u9769\u5409\u53BF" },
          { value: "542526", label: "\u6539\u5219\u53BF" },
          { value: "542527", label: "\u63AA\u52E4\u53BF" }
        ]
      }
    ]
  },
  {
    value: "610000",
    label: "\u9655\u897F\u7701",
    children: [
      {
        value: "610100",
        label: "\u897F\u5B89\u5E02",
        children: [
          { value: "610102", label: "\u65B0\u57CE\u533A" },
          { value: "610103", label: "\u7891\u6797\u533A" },
          { value: "610104", label: "\u83B2\u6E56\u533A" },
          { value: "610111", label: "\u705E\u6865\u533A" },
          { value: "610112", label: "\u672A\u592E\u533A" },
          { value: "610113", label: "\u96C1\u5854\u533A" },
          { value: "610114", label: "\u960E\u826F\u533A" },
          { value: "610115", label: "\u4E34\u6F7C\u533A" },
          { value: "610116", label: "\u957F\u5B89\u533A" },
          { value: "610117", label: "\u9AD8\u9675\u533A" },
          { value: "610118", label: "\u9120\u9091\u533A" },
          { value: "610122", label: "\u84DD\u7530\u53BF" },
          { value: "610124", label: "\u5468\u81F3\u53BF" }
        ]
      },
      {
        value: "610200",
        label: "\u94DC\u5DDD\u5E02",
        children: [
          { value: "610202", label: "\u738B\u76CA\u533A" },
          { value: "610203", label: "\u5370\u53F0\u533A" },
          { value: "610204", label: "\u8000\u5DDE\u533A" },
          { value: "610222", label: "\u5B9C\u541B\u53BF" }
        ]
      },
      {
        value: "610300",
        label: "\u5B9D\u9E21\u5E02",
        children: [
          { value: "610302", label: "\u6E2D\u6EE8\u533A" },
          { value: "610303", label: "\u91D1\u53F0\u533A" },
          { value: "610304", label: "\u9648\u4ED3\u533A" },
          { value: "610322", label: "\u51E4\u7FD4\u53BF" },
          { value: "610323", label: "\u5C90\u5C71\u53BF" },
          { value: "610324", label: "\u6276\u98CE\u53BF" },
          { value: "610326", label: "\u7709\u53BF" },
          { value: "610327", label: "\u9647\u53BF" },
          { value: "610328", label: "\u5343\u9633\u53BF" },
          { value: "610329", label: "\u9E9F\u6E38\u53BF" },
          { value: "610330", label: "\u51E4\u53BF" },
          { value: "610331", label: "\u592A\u767D\u53BF" }
        ]
      },
      {
        value: "610400",
        label: "\u54B8\u9633\u5E02",
        children: [
          { value: "610402", label: "\u79E6\u90FD\u533A" },
          { value: "610403", label: "\u6768\u9675\u533A" },
          { value: "610404", label: "\u6E2D\u57CE\u533A" },
          { value: "610422", label: "\u4E09\u539F\u53BF" },
          { value: "610423", label: "\u6CFE\u9633\u53BF" },
          { value: "610424", label: "\u4E7E\u53BF" },
          { value: "610425", label: "\u793C\u6CC9\u53BF" },
          { value: "610426", label: "\u6C38\u5BFF\u53BF" },
          { value: "610428", label: "\u957F\u6B66\u53BF" },
          { value: "610429", label: "\u65EC\u9091\u53BF" },
          { value: "610430", label: "\u6DF3\u5316\u53BF" },
          { value: "610431", label: "\u6B66\u529F\u53BF" },
          { value: "610481", label: "\u5174\u5E73\u5E02" },
          { value: "610482", label: "\u5F6C\u5DDE\u5E02" }
        ]
      },
      {
        value: "610500",
        label: "\u6E2D\u5357\u5E02",
        children: [
          { value: "610502", label: "\u4E34\u6E2D\u533A" },
          { value: "610503", label: "\u534E\u5DDE\u533A" },
          { value: "610522", label: "\u6F7C\u5173\u53BF" },
          { value: "610523", label: "\u5927\u8354\u53BF" },
          { value: "610524", label: "\u5408\u9633\u53BF" },
          { value: "610525", label: "\u6F84\u57CE\u53BF" },
          { value: "610526", label: "\u84B2\u57CE\u53BF" },
          { value: "610527", label: "\u767D\u6C34\u53BF" },
          { value: "610528", label: "\u5BCC\u5E73\u53BF" },
          { value: "610581", label: "\u97E9\u57CE\u5E02" },
          { value: "610582", label: "\u534E\u9634\u5E02" }
        ]
      },
      {
        value: "610600",
        label: "\u5EF6\u5B89\u5E02",
        children: [
          { value: "610602", label: "\u5B9D\u5854\u533A" },
          { value: "610603", label: "\u5B89\u585E\u533A" },
          { value: "610621", label: "\u5EF6\u957F\u53BF" },
          { value: "610622", label: "\u5EF6\u5DDD\u53BF" },
          { value: "610625", label: "\u5FD7\u4E39\u53BF" },
          { value: "610626", label: "\u5434\u8D77\u53BF" },
          { value: "610627", label: "\u7518\u6CC9\u53BF" },
          { value: "610628", label: "\u5BCC\u53BF" },
          { value: "610629", label: "\u6D1B\u5DDD\u53BF" },
          { value: "610630", label: "\u5B9C\u5DDD\u53BF" },
          { value: "610631", label: "\u9EC4\u9F99\u53BF" },
          { value: "610632", label: "\u9EC4\u9675\u53BF" },
          { value: "610681", label: "\u5B50\u957F\u5E02" }
        ]
      },
      {
        value: "610700",
        label: "\u6C49\u4E2D\u5E02",
        children: [
          { value: "610702", label: "\u6C49\u53F0\u533A" },
          { value: "610703", label: "\u5357\u90D1\u533A" },
          { value: "610722", label: "\u57CE\u56FA\u53BF" },
          { value: "610723", label: "\u6D0B\u53BF" },
          { value: "610724", label: "\u897F\u4E61\u53BF" },
          { value: "610725", label: "\u52C9\u53BF" },
          { value: "610726", label: "\u5B81\u5F3A\u53BF" },
          { value: "610727", label: "\u7565\u9633\u53BF" },
          { value: "610728", label: "\u9547\u5DF4\u53BF" },
          { value: "610729", label: "\u7559\u575D\u53BF" },
          { value: "610730", label: "\u4F5B\u576A\u53BF" }
        ]
      },
      {
        value: "610800",
        label: "\u6986\u6797\u5E02",
        children: [
          { value: "610802", label: "\u6986\u9633\u533A" },
          { value: "610803", label: "\u6A2A\u5C71\u533A" },
          { value: "610822", label: "\u5E9C\u8C37\u53BF" },
          { value: "610824", label: "\u9756\u8FB9\u53BF" },
          { value: "610825", label: "\u5B9A\u8FB9\u53BF" },
          { value: "610826", label: "\u7EE5\u5FB7\u53BF" },
          { value: "610827", label: "\u7C73\u8102\u53BF" },
          { value: "610828", label: "\u4F73\u53BF" },
          { value: "610829", label: "\u5434\u5821\u53BF" },
          { value: "610830", label: "\u6E05\u6DA7\u53BF" },
          { value: "610831", label: "\u5B50\u6D32\u53BF" },
          { value: "610881", label: "\u795E\u6728\u5E02" }
        ]
      },
      {
        value: "610900",
        label: "\u5B89\u5EB7\u5E02",
        children: [
          { value: "610902", label: "\u6C49\u6EE8\u533A" },
          { value: "610921", label: "\u6C49\u9634\u53BF" },
          { value: "610922", label: "\u77F3\u6CC9\u53BF" },
          { value: "610923", label: "\u5B81\u9655\u53BF" },
          { value: "610924", label: "\u7D2B\u9633\u53BF" },
          { value: "610925", label: "\u5C9A\u768B\u53BF" },
          { value: "610926", label: "\u5E73\u5229\u53BF" },
          { value: "610927", label: "\u9547\u576A\u53BF" },
          { value: "610928", label: "\u65EC\u9633\u53BF" },
          { value: "610929", label: "\u767D\u6CB3\u53BF" }
        ]
      },
      {
        value: "611000",
        label: "\u5546\u6D1B\u5E02",
        children: [
          { value: "611002", label: "\u5546\u5DDE\u533A" },
          { value: "611021", label: "\u6D1B\u5357\u53BF" },
          { value: "611022", label: "\u4E39\u51E4\u53BF" },
          { value: "611023", label: "\u5546\u5357\u53BF" },
          { value: "611024", label: "\u5C71\u9633\u53BF" },
          { value: "611025", label: "\u9547\u5B89\u53BF" },
          { value: "611026", label: "\u67DE\u6C34\u53BF" }
        ]
      }
    ]
  },
  {
    value: "620000",
    label: "\u7518\u8083\u7701",
    children: [
      {
        value: "620100",
        label: "\u5170\u5DDE\u5E02",
        children: [
          { value: "620102", label: "\u57CE\u5173\u533A" },
          { value: "620103", label: "\u4E03\u91CC\u6CB3\u533A" },
          { value: "620104", label: "\u897F\u56FA\u533A" },
          { value: "620105", label: "\u5B89\u5B81\u533A" },
          { value: "620111", label: "\u7EA2\u53E4\u533A" },
          { value: "620121", label: "\u6C38\u767B\u53BF" },
          { value: "620122", label: "\u768B\u5170\u53BF" },
          { value: "620123", label: "\u6986\u4E2D\u53BF" },
          { value: "620171", label: "\u5170\u5DDE\u65B0\u533A" }
        ]
      },
      { value: "620200", label: "\u5609\u5CEA\u5173\u5E02", children: [] },
      {
        value: "620300",
        label: "\u91D1\u660C\u5E02",
        children: [
          { value: "620302", label: "\u91D1\u5DDD\u533A" },
          { value: "620321", label: "\u6C38\u660C\u53BF" }
        ]
      },
      {
        value: "620400",
        label: "\u767D\u94F6\u5E02",
        children: [
          { value: "620402", label: "\u767D\u94F6\u533A" },
          { value: "620403", label: "\u5E73\u5DDD\u533A" },
          { value: "620421", label: "\u9756\u8FDC\u53BF" },
          { value: "620422", label: "\u4F1A\u5B81\u53BF" },
          { value: "620423", label: "\u666F\u6CF0\u53BF" }
        ]
      },
      {
        value: "620500",
        label: "\u5929\u6C34\u5E02",
        children: [
          { value: "620502", label: "\u79E6\u5DDE\u533A" },
          { value: "620503", label: "\u9EA6\u79EF\u533A" },
          { value: "620521", label: "\u6E05\u6C34\u53BF" },
          { value: "620522", label: "\u79E6\u5B89\u53BF" },
          { value: "620523", label: "\u7518\u8C37\u53BF" },
          { value: "620524", label: "\u6B66\u5C71\u53BF" },
          { value: "620525", label: "\u5F20\u5BB6\u5DDD\u56DE\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "620600",
        label: "\u6B66\u5A01\u5E02",
        children: [
          { value: "620602", label: "\u51C9\u5DDE\u533A" },
          { value: "620621", label: "\u6C11\u52E4\u53BF" },
          { value: "620622", label: "\u53E4\u6D6A\u53BF" },
          { value: "620623", label: "\u5929\u795D\u85CF\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "620700",
        label: "\u5F20\u6396\u5E02",
        children: [
          { value: "620702", label: "\u7518\u5DDE\u533A" },
          { value: "620721", label: "\u8083\u5357\u88D5\u56FA\u65CF\u81EA\u6CBB\u53BF" },
          { value: "620722", label: "\u6C11\u4E50\u53BF" },
          { value: "620723", label: "\u4E34\u6CFD\u53BF" },
          { value: "620724", label: "\u9AD8\u53F0\u53BF" },
          { value: "620725", label: "\u5C71\u4E39\u53BF" }
        ]
      },
      {
        value: "620800",
        label: "\u5E73\u51C9\u5E02",
        children: [
          { value: "620802", label: "\u5D06\u5CD2\u533A" },
          { value: "620821", label: "\u6CFE\u5DDD\u53BF" },
          { value: "620822", label: "\u7075\u53F0\u53BF" },
          { value: "620823", label: "\u5D07\u4FE1\u53BF" },
          { value: "620825", label: "\u5E84\u6D6A\u53BF" },
          { value: "620826", label: "\u9759\u5B81\u53BF" },
          { value: "620881", label: "\u534E\u4EAD\u5E02" }
        ]
      },
      {
        value: "620900",
        label: "\u9152\u6CC9\u5E02",
        children: [
          { value: "620902", label: "\u8083\u5DDE\u533A" },
          { value: "620921", label: "\u91D1\u5854\u53BF" },
          { value: "620922", label: "\u74DC\u5DDE\u53BF" },
          { value: "620923", label: "\u8083\u5317\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" },
          { value: "620924", label: "\u963F\u514B\u585E\u54C8\u8428\u514B\u65CF\u81EA\u6CBB\u53BF" },
          { value: "620981", label: "\u7389\u95E8\u5E02" },
          { value: "620982", label: "\u6566\u714C\u5E02" }
        ]
      },
      {
        value: "621000",
        label: "\u5E86\u9633\u5E02",
        children: [
          { value: "621002", label: "\u897F\u5CF0\u533A" },
          { value: "621021", label: "\u5E86\u57CE\u53BF" },
          { value: "621022", label: "\u73AF\u53BF" },
          { value: "621023", label: "\u534E\u6C60\u53BF" },
          { value: "621024", label: "\u5408\u6C34\u53BF" },
          { value: "621025", label: "\u6B63\u5B81\u53BF" },
          { value: "621026", label: "\u5B81\u53BF" },
          { value: "621027", label: "\u9547\u539F\u53BF" }
        ]
      },
      {
        value: "621100",
        label: "\u5B9A\u897F\u5E02",
        children: [
          { value: "621102", label: "\u5B89\u5B9A\u533A" },
          { value: "621121", label: "\u901A\u6E2D\u53BF" },
          { value: "621122", label: "\u9647\u897F\u53BF" },
          { value: "621123", label: "\u6E2D\u6E90\u53BF" },
          { value: "621124", label: "\u4E34\u6D2E\u53BF" },
          { value: "621125", label: "\u6F33\u53BF" },
          { value: "621126", label: "\u5CB7\u53BF" }
        ]
      },
      {
        value: "621200",
        label: "\u9647\u5357\u5E02",
        children: [
          { value: "621202", label: "\u6B66\u90FD\u533A" },
          { value: "621221", label: "\u6210\u53BF" },
          { value: "621222", label: "\u6587\u53BF" },
          { value: "621223", label: "\u5B95\u660C\u53BF" },
          { value: "621224", label: "\u5EB7\u53BF" },
          { value: "621225", label: "\u897F\u548C\u53BF" },
          { value: "621226", label: "\u793C\u53BF" },
          { value: "621227", label: "\u5FBD\u53BF" },
          { value: "621228", label: "\u4E24\u5F53\u53BF" }
        ]
      },
      {
        value: "622900",
        label: "\u4E34\u590F\u56DE\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "622901", label: "\u4E34\u590F\u5E02" },
          { value: "622921", label: "\u4E34\u590F\u53BF" },
          { value: "622922", label: "\u5EB7\u4E50\u53BF" },
          { value: "622923", label: "\u6C38\u9756\u53BF" },
          { value: "622924", label: "\u5E7F\u6CB3\u53BF" },
          { value: "622925", label: "\u548C\u653F\u53BF" },
          { value: "622926", label: "\u4E1C\u4E61\u65CF\u81EA\u6CBB\u53BF" },
          { value: "622927", label: "\u79EF\u77F3\u5C71\u4FDD\u5B89\u65CF\u4E1C\u4E61\u65CF\u6492\u62C9\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "623000",
        label: "\u7518\u5357\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "623001", label: "\u5408\u4F5C\u5E02" },
          { value: "623021", label: "\u4E34\u6F6D\u53BF" },
          { value: "623022", label: "\u5353\u5C3C\u53BF" },
          { value: "623023", label: "\u821F\u66F2\u53BF" },
          { value: "623024", label: "\u8FED\u90E8\u53BF" },
          { value: "623025", label: "\u739B\u66F2\u53BF" },
          { value: "623026", label: "\u788C\u66F2\u53BF" },
          { value: "623027", label: "\u590F\u6CB3\u53BF" }
        ]
      }
    ]
  },
  {
    value: "630000",
    label: "\u9752\u6D77\u7701",
    children: [
      {
        value: "630100",
        label: "\u897F\u5B81\u5E02",
        children: [
          { value: "630102", label: "\u57CE\u4E1C\u533A" },
          { value: "630103", label: "\u57CE\u4E2D\u533A" },
          { value: "630104", label: "\u57CE\u897F\u533A" },
          { value: "630105", label: "\u57CE\u5317\u533A" },
          { value: "630121", label: "\u5927\u901A\u56DE\u65CF\u571F\u65CF\u81EA\u6CBB\u53BF" },
          { value: "630122", label: "\u6E5F\u4E2D\u53BF" },
          { value: "630123", label: "\u6E5F\u6E90\u53BF" }
        ]
      },
      {
        value: "630200",
        label: "\u6D77\u4E1C\u5E02",
        children: [
          { value: "630202", label: "\u4E50\u90FD\u533A" },
          { value: "630203", label: "\u5E73\u5B89\u533A" },
          { value: "630222", label: "\u6C11\u548C\u56DE\u65CF\u571F\u65CF\u81EA\u6CBB\u53BF" },
          { value: "630223", label: "\u4E92\u52A9\u571F\u65CF\u81EA\u6CBB\u53BF" },
          { value: "630224", label: "\u5316\u9686\u56DE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "630225", label: "\u5FAA\u5316\u6492\u62C9\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "632200",
        label: "\u6D77\u5317\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "632221", label: "\u95E8\u6E90\u56DE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "632222", label: "\u7941\u8FDE\u53BF" },
          { value: "632223", label: "\u6D77\u664F\u53BF" },
          { value: "632224", label: "\u521A\u5BDF\u53BF" }
        ]
      },
      {
        value: "632300",
        label: "\u9EC4\u5357\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "632321", label: "\u540C\u4EC1\u53BF" },
          { value: "632322", label: "\u5C16\u624E\u53BF" },
          { value: "632323", label: "\u6CFD\u5E93\u53BF" },
          { value: "632324", label: "\u6CB3\u5357\u8499\u53E4\u65CF\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "632500",
        label: "\u6D77\u5357\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "632521", label: "\u5171\u548C\u53BF" },
          { value: "632522", label: "\u540C\u5FB7\u53BF" },
          { value: "632523", label: "\u8D35\u5FB7\u53BF" },
          { value: "632524", label: "\u5174\u6D77\u53BF" },
          { value: "632525", label: "\u8D35\u5357\u53BF" }
        ]
      },
      {
        value: "632600",
        label: "\u679C\u6D1B\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "632621", label: "\u739B\u6C81\u53BF" },
          { value: "632622", label: "\u73ED\u739B\u53BF" },
          { value: "632623", label: "\u7518\u5FB7\u53BF" },
          { value: "632624", label: "\u8FBE\u65E5\u53BF" },
          { value: "632625", label: "\u4E45\u6CBB\u53BF" },
          { value: "632626", label: "\u739B\u591A\u53BF" }
        ]
      },
      {
        value: "632700",
        label: "\u7389\u6811\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "632701", label: "\u7389\u6811\u5E02" },
          { value: "632722", label: "\u6742\u591A\u53BF" },
          { value: "632723", label: "\u79F0\u591A\u53BF" },
          { value: "632724", label: "\u6CBB\u591A\u53BF" },
          { value: "632725", label: "\u56CA\u8C26\u53BF" },
          { value: "632726", label: "\u66F2\u9EBB\u83B1\u53BF" }
        ]
      },
      {
        value: "632800",
        label: "\u6D77\u897F\u8499\u53E4\u65CF\u85CF\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "632801", label: "\u683C\u5C14\u6728\u5E02" },
          { value: "632802", label: "\u5FB7\u4EE4\u54C8\u5E02" },
          { value: "632803", label: "\u832B\u5D16\u5E02" },
          { value: "632821", label: "\u4E4C\u5170\u53BF" },
          { value: "632822", label: "\u90FD\u5170\u53BF" },
          { value: "632823", label: "\u5929\u5CFB\u53BF" },
          { value: "632857", label: "\u5927\u67F4\u65E6\u884C\u653F\u59D4\u5458\u4F1A" }
        ]
      }
    ]
  },
  {
    value: "640000",
    label: "\u5B81\u590F\u56DE\u65CF\u81EA\u6CBB\u533A",
    children: [
      {
        value: "640100",
        label: "\u94F6\u5DDD\u5E02",
        children: [
          { value: "640104", label: "\u5174\u5E86\u533A" },
          { value: "640105", label: "\u897F\u590F\u533A" },
          { value: "640106", label: "\u91D1\u51E4\u533A" },
          { value: "640121", label: "\u6C38\u5B81\u53BF" },
          { value: "640122", label: "\u8D3A\u5170\u53BF" },
          { value: "640181", label: "\u7075\u6B66\u5E02" }
        ]
      },
      {
        value: "640200",
        label: "\u77F3\u5634\u5C71\u5E02",
        children: [
          { value: "640202", label: "\u5927\u6B66\u53E3\u533A" },
          { value: "640205", label: "\u60E0\u519C\u533A" },
          { value: "640221", label: "\u5E73\u7F57\u53BF" }
        ]
      },
      {
        value: "640300",
        label: "\u5434\u5FE0\u5E02",
        children: [
          { value: "640302", label: "\u5229\u901A\u533A" },
          { value: "640303", label: "\u7EA2\u5BFA\u5821\u533A" },
          { value: "640323", label: "\u76D0\u6C60\u53BF" },
          { value: "640324", label: "\u540C\u5FC3\u53BF" },
          { value: "640381", label: "\u9752\u94DC\u5CE1\u5E02" }
        ]
      },
      {
        value: "640400",
        label: "\u56FA\u539F\u5E02",
        children: [
          { value: "640402", label: "\u539F\u5DDE\u533A" },
          { value: "640422", label: "\u897F\u5409\u53BF" },
          { value: "640423", label: "\u9686\u5FB7\u53BF" },
          { value: "640424", label: "\u6CFE\u6E90\u53BF" },
          { value: "640425", label: "\u5F6D\u9633\u53BF" }
        ]
      },
      {
        value: "640500",
        label: "\u4E2D\u536B\u5E02",
        children: [
          { value: "640502", label: "\u6C99\u5761\u5934\u533A" },
          { value: "640521", label: "\u4E2D\u5B81\u53BF" },
          { value: "640522", label: "\u6D77\u539F\u53BF" }
        ]
      }
    ]
  },
  {
    value: "650000",
    label: "\u65B0\u7586\u7EF4\u543E\u5C14\u81EA\u6CBB\u533A",
    children: [
      {
        value: "650100",
        label: "\u4E4C\u9C81\u6728\u9F50\u5E02",
        children: [
          { value: "650102", label: "\u5929\u5C71\u533A" },
          { value: "650103", label: "\u6C99\u4F9D\u5DF4\u514B\u533A" },
          { value: "650104", label: "\u65B0\u5E02\u533A" },
          { value: "650105", label: "\u6C34\u78E8\u6C9F\u533A" },
          { value: "650106", label: "\u5934\u5C6F\u6CB3\u533A" },
          { value: "650107", label: "\u8FBE\u5742\u57CE\u533A" },
          { value: "650109", label: "\u7C73\u4E1C\u533A" },
          { value: "650121", label: "\u4E4C\u9C81\u6728\u9F50\u53BF" }
        ]
      },
      {
        value: "650200",
        label: "\u514B\u62C9\u739B\u4F9D\u5E02",
        children: [
          { value: "650202", label: "\u72EC\u5C71\u5B50\u533A" },
          { value: "650203", label: "\u514B\u62C9\u739B\u4F9D\u533A" },
          { value: "650204", label: "\u767D\u78B1\u6EE9\u533A" },
          { value: "650205", label: "\u4E4C\u5C14\u79BE\u533A" }
        ]
      },
      {
        value: "650400",
        label: "\u5410\u9C81\u756A\u5E02",
        children: [
          { value: "650402", label: "\u9AD8\u660C\u533A" },
          { value: "650421", label: "\u912F\u5584\u53BF" },
          { value: "650422", label: "\u6258\u514B\u900A\u53BF" }
        ]
      },
      {
        value: "650500",
        label: "\u54C8\u5BC6\u5E02",
        children: [
          { value: "650502", label: "\u4F0A\u5DDE\u533A" },
          { value: "650521", label: "\u5DF4\u91CC\u5764\u54C8\u8428\u514B\u81EA\u6CBB\u53BF" },
          { value: "650522", label: "\u4F0A\u543E\u53BF" }
        ]
      },
      {
        value: "652300",
        label: "\u660C\u5409\u56DE\u65CF\u81EA\u6CBB\u5DDE",
        children: [
          { value: "652301", label: "\u660C\u5409\u5E02" },
          { value: "652302", label: "\u961C\u5EB7\u5E02" },
          { value: "652323", label: "\u547C\u56FE\u58C1\u53BF" },
          { value: "652324", label: "\u739B\u7EB3\u65AF\u53BF" },
          { value: "652325", label: "\u5947\u53F0\u53BF" },
          { value: "652327", label: "\u5409\u6728\u8428\u5C14\u53BF" },
          { value: "652328", label: "\u6728\u5792\u54C8\u8428\u514B\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "652700",
        label: "\u535A\u5C14\u5854\u62C9\u8499\u53E4\u81EA\u6CBB\u5DDE",
        children: [
          { value: "652701", label: "\u535A\u4E50\u5E02" },
          { value: "652702", label: "\u963F\u62C9\u5C71\u53E3\u5E02" },
          { value: "652722", label: "\u7CBE\u6CB3\u53BF" },
          { value: "652723", label: "\u6E29\u6CC9\u53BF" }
        ]
      },
      {
        value: "652800",
        label: "\u5DF4\u97F3\u90ED\u695E\u8499\u53E4\u81EA\u6CBB\u5DDE",
        children: [
          { value: "652801", label: "\u5E93\u5C14\u52D2\u5E02" },
          { value: "652822", label: "\u8F6E\u53F0\u53BF" },
          { value: "652823", label: "\u5C09\u7281\u53BF" },
          { value: "652824", label: "\u82E5\u7F8C\u53BF" },
          { value: "652825", label: "\u4E14\u672B\u53BF" },
          { value: "652826", label: "\u7109\u8006\u56DE\u65CF\u81EA\u6CBB\u53BF" },
          { value: "652827", label: "\u548C\u9759\u53BF" },
          { value: "652828", label: "\u548C\u7855\u53BF" },
          { value: "652829", label: "\u535A\u6E56\u53BF" },
          { value: "652871", label: "\u5E93\u5C14\u52D2\u7ECF\u6D4E\u6280\u672F\u5F00\u53D1\u533A" }
        ]
      },
      {
        value: "652900",
        label: "\u963F\u514B\u82CF\u5730\u533A",
        children: [
          { value: "652901", label: "\u963F\u514B\u82CF\u5E02" },
          { value: "652922", label: "\u6E29\u5BBF\u53BF" },
          { value: "652923", label: "\u5E93\u8F66\u53BF" },
          { value: "652924", label: "\u6C99\u96C5\u53BF" },
          { value: "652925", label: "\u65B0\u548C\u53BF" },
          { value: "652926", label: "\u62DC\u57CE\u53BF" },
          { value: "652927", label: "\u4E4C\u4EC0\u53BF" },
          { value: "652928", label: "\u963F\u74E6\u63D0\u53BF" },
          { value: "652929", label: "\u67EF\u576A\u53BF" }
        ]
      },
      {
        value: "653000",
        label: "\u514B\u5B5C\u52D2\u82CF\u67EF\u5C14\u514B\u5B5C\u81EA\u6CBB\u5DDE",
        children: [
          { value: "653001", label: "\u963F\u56FE\u4EC0\u5E02" },
          { value: "653022", label: "\u963F\u514B\u9676\u53BF" },
          { value: "653023", label: "\u963F\u5408\u5947\u53BF" },
          { value: "653024", label: "\u4E4C\u6070\u53BF" }
        ]
      },
      {
        value: "653100",
        label: "\u5580\u4EC0\u5730\u533A",
        children: [
          { value: "653101", label: "\u5580\u4EC0\u5E02" },
          { value: "653121", label: "\u758F\u9644\u53BF" },
          { value: "653122", label: "\u758F\u52D2\u53BF" },
          { value: "653123", label: "\u82F1\u5409\u6C99\u53BF" },
          { value: "653124", label: "\u6CFD\u666E\u53BF" },
          { value: "653125", label: "\u838E\u8F66\u53BF" },
          { value: "653126", label: "\u53F6\u57CE\u53BF" },
          { value: "653127", label: "\u9EA6\u76D6\u63D0\u53BF" },
          { value: "653128", label: "\u5CB3\u666E\u6E56\u53BF" },
          { value: "653129", label: "\u4F3D\u5E08\u53BF" },
          { value: "653130", label: "\u5DF4\u695A\u53BF" },
          { value: "653131", label: "\u5854\u4EC0\u5E93\u5C14\u5E72\u5854\u5409\u514B\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "653200",
        label: "\u548C\u7530\u5730\u533A",
        children: [
          { value: "653201", label: "\u548C\u7530\u5E02" },
          { value: "653221", label: "\u548C\u7530\u53BF" },
          { value: "653222", label: "\u58A8\u7389\u53BF" },
          { value: "653223", label: "\u76AE\u5C71\u53BF" },
          { value: "653224", label: "\u6D1B\u6D66\u53BF" },
          { value: "653225", label: "\u7B56\u52D2\u53BF" },
          { value: "653226", label: "\u4E8E\u7530\u53BF" },
          { value: "653227", label: "\u6C11\u4E30\u53BF" }
        ]
      },
      {
        value: "654000",
        label: "\u4F0A\u7281\u54C8\u8428\u514B\u81EA\u6CBB\u5DDE",
        children: [
          { value: "654002", label: "\u4F0A\u5B81\u5E02" },
          { value: "654003", label: "\u594E\u5C6F\u5E02" },
          { value: "654004", label: "\u970D\u5C14\u679C\u65AF\u5E02" },
          { value: "654021", label: "\u4F0A\u5B81\u53BF" },
          { value: "654022", label: "\u5BDF\u5E03\u67E5\u5C14\u9521\u4F2F\u81EA\u6CBB\u53BF" },
          { value: "654023", label: "\u970D\u57CE\u53BF" },
          { value: "654024", label: "\u5DE9\u7559\u53BF" },
          { value: "654025", label: "\u65B0\u6E90\u53BF" },
          { value: "654026", label: "\u662D\u82CF\u53BF" },
          { value: "654027", label: "\u7279\u514B\u65AF\u53BF" },
          { value: "654028", label: "\u5C3C\u52D2\u514B\u53BF" }
        ]
      },
      {
        value: "654200",
        label: "\u5854\u57CE\u5730\u533A",
        children: [
          { value: "654201", label: "\u5854\u57CE\u5E02" },
          { value: "654202", label: "\u4E4C\u82CF\u5E02" },
          { value: "654221", label: "\u989D\u654F\u53BF" },
          { value: "654223", label: "\u6C99\u6E7E\u53BF" },
          { value: "654224", label: "\u6258\u91CC\u53BF" },
          { value: "654225", label: "\u88D5\u6C11\u53BF" },
          { value: "654226", label: "\u548C\u5E03\u514B\u8D5B\u5C14\u8499\u53E4\u81EA\u6CBB\u53BF" }
        ]
      },
      {
        value: "654300",
        label: "\u963F\u52D2\u6CF0\u5730\u533A",
        children: [
          { value: "654301", label: "\u963F\u52D2\u6CF0\u5E02" },
          { value: "654321", label: "\u5E03\u5C14\u6D25\u53BF" },
          { value: "654322", label: "\u5BCC\u8574\u53BF" },
          { value: "654323", label: "\u798F\u6D77\u53BF" },
          { value: "654324", label: "\u54C8\u5DF4\u6CB3\u53BF" },
          { value: "654325", label: "\u9752\u6CB3\u53BF" },
          { value: "654326", label: "\u5409\u6728\u4E43\u53BF" }
        ]
      },
      {
        value: "659000",
        label: "\u81EA\u6CBB\u533A\u76F4\u8F96\u53BF\u7EA7\u884C\u653F\u533A\u5212",
        children: [
          { value: "659001", label: "\u77F3\u6CB3\u5B50\u5E02" },
          { value: "659002", label: "\u963F\u62C9\u5C14\u5E02" },
          { value: "659003", label: "\u56FE\u6728\u8212\u514B\u5E02" },
          { value: "659004", label: "\u4E94\u5BB6\u6E20\u5E02" },
          { value: "659006", label: "\u94C1\u95E8\u5173\u5E02" }
        ]
      }
    ]
  },
  {
    value: "710000",
    label: "\u53F0\u6E7E\u7701",
    children: [
      {
        value: "710100",
        label: "\u53F0\u5317\u5E02",
        children: [
          { value: "710101", label: "\u5185\u6E56\u533A" },
          { value: "710102", label: "\u5357\u6E2F\u533A" },
          { value: "710103", label: "\u4E2D\u6B63\u533A" },
          { value: "710104", label: "\u677E\u5C71\u533A" },
          { value: "710105", label: "\u4FE1\u4E49\u533A" },
          { value: "710106", label: "\u5927\u5B89\u533A" },
          { value: "710107", label: "\u4E2D\u5C71\u533A" },
          { value: "710108", label: "\u6587\u5C71\u533A" },
          { value: "710109", label: "\u5927\u540C\u533A" },
          { value: "710110", label: "\u4E07\u534E\u533A" },
          { value: "710111", label: "\u58EB\u6797\u533A" },
          { value: "710112", label: "\u5317\u6295\u533A" }
        ]
      },
      {
        value: "710200",
        label: "\u9AD8\u96C4\u5E02",
        children: [
          { value: "710201", label: "\u65B0\u5174\u533A" },
          { value: "710202", label: "\u524D\u91D1\u533A" },
          { value: "710203", label: "\u82A9\u96C5\u533A" },
          { value: "710204", label: "\u76D0\u57D5\u533A" },
          { value: "710205", label: "\u9F13\u5C71\u533A" },
          { value: "710206", label: "\u65D7\u6D25\u533A" },
          { value: "710207", label: "\u524D\u9547\u533A" },
          { value: "710208", label: "\u4E09\u6C11\u533A" },
          { value: "710209", label: "\u5DE6\u8425\u533A" },
          { value: "710210", label: "\u6960\u6893\u533A" },
          { value: "710211", label: "\u5C0F\u6E2F\u533A" }
        ]
      },
      {
        value: "710300",
        label: "\u57FA\u9686\u5E02",
        children: [
          { value: "710301", label: "\u4EC1\u7231\u533A" },
          { value: "710302", label: "\u4FE1\u4E49\u533A" },
          { value: "710303", label: "\u4E2D\u6B63\u533A" },
          { value: "710304", label: "\u6696\u6696\u533A" },
          { value: "710305", label: "\u5B89\u4E50\u533A" },
          { value: "710307", label: "\u4E03\u5835\u533A" }
        ]
      },
      {
        value: "710400",
        label: "\u53F0\u4E2D\u5E02",
        children: [
          { value: "710301", label: "\u4E2D\u533A" },
          { value: "710302", label: "\u4E1C\u533A" },
          { value: "710303", label: "\u5357\u533A" },
          { value: "710304", label: "\u897F\u533A" },
          { value: "710305", label: "\u5317\u533A" },
          { value: "710306", label: "\u5317\u5C6F\u533A" },
          { value: "710307", label: "\u897F\u5C6F\u533A" },
          { value: "710308", label: "\u5357\u5C6F\u533A" }
        ]
      },
      {
        value: "710500",
        label: "\u53F0\u5357\u5E02",
        children: [
          { value: "710501", label: "\u4E2D\u897F\u533A" },
          { value: "710502", label: "\u4E1C\u533A" },
          { value: "710503", label: "\u5357\u533A" },
          { value: "710504", label: "\u5317\u533A" },
          { value: "710505", label: "\u5B89\u5E73\u533A" },
          { value: "710506", label: "\u5B89\u5357\u533A" }
        ]
      },
      {
        value: "710600",
        label: "\u65B0\u7AF9\u5E02",
        children: [
          { value: "710601", label: "\u4E1C\u533A" },
          { value: "710602", label: "\u5317\u533A" },
          { value: "710603", label: "\u9999\u5C71\u533A" }
        ]
      },
      {
        value: "710700",
        label: "\u5609\u4E49\u5E02",
        children: [
          { value: "710701", label: "\u4E1C\u533A" },
          { value: "710702", label: "\u897F\u533A" }
        ]
      }
    ]
  },
  {
    value: "810000",
    label: "\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A",
    children: [
      { value: "810001", label: "\u4E2D\u897F\u5340" },
      { value: "810002", label: "\u7063\u4ED4\u5340" },
      { value: "810003", label: "\u6771\u5340" },
      { value: "810004", label: "\u5357\u5340" },
      { value: "810005", label: "\u6CB9\u5C16\u65FA\u5340" },
      { value: "810006", label: "\u6DF1\u6C34\u57D7\u5340" },
      { value: "810007", label: "\u4E5D\u9F8D\u57CE\u5340" },
      { value: "810008", label: "\u9EC3\u5927\u4ED9\u5340" },
      { value: "810009", label: "\u89C0\u5858\u5340" },
      { value: "810010", label: "\u8343\u7063\u5340" },
      { value: "810011", label: "\u5C6F\u9580\u5340" },
      { value: "810012", label: "\u5143\u6717\u5340" },
      { value: "810013", label: "\u5317\u5340" },
      { value: "810014", label: "\u5927\u57D4\u5340" },
      { value: "810015", label: "\u897F\u8CA2\u5340" },
      { value: "810016", label: "\u6C99\u7530\u5340" },
      { value: "810017", label: "\u8475\u9752\u5340" },
      { value: "810018", label: "\u96E2\u5CF6\u5340" }
    ]
  },
  {
    value: "820000",
    label: "\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A",
    children: [
      { value: "820001", label: "\u82B1\u5730\u746A\u5802\u5340" },
      { value: "820002", label: "\u82B1\u738B\u5802\u5340" },
      { value: "820003", label: "\u671B\u5FB7\u5802\u5340" },
      { value: "820004", label: "\u5927\u5802\u5340" },
      { value: "820005", label: "\u98A8\u9806\u5802\u5340" },
      { value: "820006", label: "\u5609\u6A21\u5802\u5340" },
      { value: "820007", label: "\u8DEF\u6C39\u586B\u6D77\u5340" },
      { value: "820008", label: "\u8056\u65B9\u6FDF\u5404\u5802\u5340" }
    ]
  }
];
var Area = defineComponent({
  name: "YxArea",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  setup(props2, {
    emit,
    attrs
  }) {
    const selectOptions = computed({
      get: () => props2.value,
      set: (val) => emit("update:value", val)
    });
    return () => createVNode(Cascader$1, mergeProps({
      bind: attrs
    }, {
      "options": regionData,
      "value": selectOptions.value,
      "onUpdate:value": ($event) => selectOptions.value = $event
    }), null);
  }
});
Area.install = function(app) {
  app.component(Area.name, Area);
  return app;
};
function isValidKey(key2, object) {
  return key2 in object;
}
const codeToText = (code) => {
  if (!isValidKey(code, CodeToText))
    return;
  return CodeToText[code];
};
var emptyIcon = "data:image/png;base64,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";
var List = defineComponent({
  name: "YxList",
  props: {
    emptyProps: {
      type: Object,
      default: () => ({
        description: "\u6682\u65E0\u6570\u636E",
        image: emptyIcon,
        imageStyle: {
          height: "240px"
        }
      })
    },
    pagination: {
      type: Object,
      default: void 0
    },
    loading: Boolean,
    dataSource: {
      type: Array,
      required: true
    },
    listStyle: Object
  },
  setup(props2, {
    slots
  }) {
    return () => createVNode("div", {
      "class": "yx-list"
    }, [createVNode(Spin, {
      "size": "large",
      "spinning": props2.loading
    }, {
      default: () => [props2.dataSource.length === 0 ? createVNode("div", {
        "style": props2.listStyle
      }, [createVNode(Empty$1, props2.emptyProps, null)]) : createVNode(Fragment, null, [createVNode("div", {
        "style": props2.listStyle
      }, [props2.dataSource.map((item) => slots.default && slots.default(item))]), props2.pagination && createVNode("div", {
        "style": {
          textAlign: "right"
        }
      }, [createVNode(Pagination, {
        "size": "small",
        "showQuickJumper": true,
        "current": props2.pagination.current,
        "onUpdate:current": ($event) => props2.pagination.current = $event,
        "pageSize": props2.pagination.pageSize,
        "total": props2.pagination.total,
        "onChange": props2.pagination.onChange
      }, null)])])]
    })]);
  }
});
List.install = function(app) {
  app.component(List.name, List);
  return app;
};
var index$1 = "";
function _isSlot(s2) {
  return typeof s2 === "function" || Object.prototype.toString.call(s2) === "[object Object]" && !isVNode(s2);
}
var Operating = defineComponent({
  name: "YxOperating",
  props: {
    showLength: {
      type: Number,
      default: 4
    }
  },
  setup(props2, {
    slots
  }) {
    const {
      showLength
    } = toRefs(props2);
    if (!slots.default) {
      return () => null;
    }
    return () => {
      const list = slots.default();
      const itemList = [];
      if (list.length > showLength.value) {
        const items = list.splice(showLength.value - 1, list.length);
        itemList.push(...items);
      }
      if (itemList.length > 0) {
        list.push(createVNode(Dropdown$1, {
          "overlayClassName": "yx-operating-dropdown",
          "visible": true
        }, {
          default: () => [createVNode("a", {
            "class": "yx-operating-more"
          }, [createTextVNode("\xB7\xB7\xB7")])],
          overlay: () => {
            let _slot;
            return createVNode(Menu, null, _isSlot(_slot = itemList.map((node, index2) => createVNode(MenuItem, {
              "key": index2
            }, _isSlot(node) ? node : {
              default: () => [node]
            }))) ? _slot : {
              default: () => [_slot]
            });
          }
        }));
      }
      return createVNode("div", {
        "class": "yx-operating"
      }, [list.map((node, i) => {
        const domList = [createVNode("span", {
          "class": "yx-operating-item"
        }, [node]), createVNode("span", {
          "class": "yx-operating-split"
        }, null)];
        if (i + 1 === list.length) {
          domList.pop();
        }
        return domList;
      })]);
    };
  }
});
Operating.install = function(app) {
  app.component(Operating.name, Operating);
  return app;
};
var style = "";
var IResultType = /* @__PURE__ */ ((IResultType2) => {
  IResultType2["Success"] = "success";
  IResultType2["Fail"] = "fail";
  return IResultType2;
})(IResultType || {});
var Result = defineComponent({
  name: "YxResult",
  props: {
    type: {
      type: String,
      default: IResultType.Success
    },
    title: String,
    desc: String
  },
  setup(props2, {
    slots
  }) {
    return () => createVNode("div", {
      "class": "yx-result"
    }, [props2.type === IResultType.Success && createVNode("div", {
      "class": "yx-result__success yx-result__icon"
    }, null), props2.type === IResultType.Fail && createVNode("div", {
      "class": "yx-result__fail yx-result__icon"
    }, null), props2.title && createVNode("p", {
      "class": "yx-result__title"
    }, [props2.title]), props2.desc && createVNode("p", {
      "class": "yx-result__desc"
    }, [props2.desc]), slots.default && slots.default()]);
  }
});
Result.install = function(app) {
  app.component(Result.name, Result);
  return app;
};
/*!
 * qrcode.vue v3.3.3
 * A Vue.js component to generate QRCode.
 * © 2017-2021 @scopewu(https://github.com/scopewu)
 * MIT License.
 */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s2, i = 1, n2 = arguments.length; i < n2; i++) {
      s2 = arguments[i];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t2[p] = s2[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var mode$1 = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};
var mode = mode$1;
function QR8bitByte(data4) {
  this.mode = mode.MODE_8BIT_BYTE;
  this.data = data4;
}
QR8bitByte.prototype = {
  getLength: function(buffer) {
    return this.data.length;
  },
  write: function(buffer) {
    for (var i = 0; i < this.data.length; i++) {
      buffer.put(this.data.charCodeAt(i), 8);
    }
  }
};
var _8BitByte = QR8bitByte;
var ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
};
var ECL = ErrorCorrectLevel;
function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}
QRRSBlock.RS_BLOCK_TABLE = [
  [1, 26, 19],
  [1, 26, 16],
  [1, 26, 13],
  [1, 26, 9],
  [1, 44, 34],
  [1, 44, 28],
  [1, 44, 22],
  [1, 44, 16],
  [1, 70, 55],
  [1, 70, 44],
  [2, 35, 17],
  [2, 35, 13],
  [1, 100, 80],
  [2, 50, 32],
  [2, 50, 24],
  [4, 25, 9],
  [1, 134, 108],
  [2, 67, 43],
  [2, 33, 15, 2, 34, 16],
  [2, 33, 11, 2, 34, 12],
  [2, 86, 68],
  [4, 43, 27],
  [4, 43, 19],
  [4, 43, 15],
  [2, 98, 78],
  [4, 49, 31],
  [2, 32, 14, 4, 33, 15],
  [4, 39, 13, 1, 40, 14],
  [2, 121, 97],
  [2, 60, 38, 2, 61, 39],
  [4, 40, 18, 2, 41, 19],
  [4, 40, 14, 2, 41, 15],
  [2, 146, 116],
  [3, 58, 36, 2, 59, 37],
  [4, 36, 16, 4, 37, 17],
  [4, 36, 12, 4, 37, 13],
  [2, 86, 68, 2, 87, 69],
  [4, 69, 43, 1, 70, 44],
  [6, 43, 19, 2, 44, 20],
  [6, 43, 15, 2, 44, 16],
  [4, 101, 81],
  [1, 80, 50, 4, 81, 51],
  [4, 50, 22, 4, 51, 23],
  [3, 36, 12, 8, 37, 13],
  [2, 116, 92, 2, 117, 93],
  [6, 58, 36, 2, 59, 37],
  [4, 46, 20, 6, 47, 21],
  [7, 42, 14, 4, 43, 15],
  [4, 133, 107],
  [8, 59, 37, 1, 60, 38],
  [8, 44, 20, 4, 45, 21],
  [12, 33, 11, 4, 34, 12],
  [3, 145, 115, 1, 146, 116],
  [4, 64, 40, 5, 65, 41],
  [11, 36, 16, 5, 37, 17],
  [11, 36, 12, 5, 37, 13],
  [5, 109, 87, 1, 110, 88],
  [5, 65, 41, 5, 66, 42],
  [5, 54, 24, 7, 55, 25],
  [11, 36, 12],
  [5, 122, 98, 1, 123, 99],
  [7, 73, 45, 3, 74, 46],
  [15, 43, 19, 2, 44, 20],
  [3, 45, 15, 13, 46, 16],
  [1, 135, 107, 5, 136, 108],
  [10, 74, 46, 1, 75, 47],
  [1, 50, 22, 15, 51, 23],
  [2, 42, 14, 17, 43, 15],
  [5, 150, 120, 1, 151, 121],
  [9, 69, 43, 4, 70, 44],
  [17, 50, 22, 1, 51, 23],
  [2, 42, 14, 19, 43, 15],
  [3, 141, 113, 4, 142, 114],
  [3, 70, 44, 11, 71, 45],
  [17, 47, 21, 4, 48, 22],
  [9, 39, 13, 16, 40, 14],
  [3, 135, 107, 5, 136, 108],
  [3, 67, 41, 13, 68, 42],
  [15, 54, 24, 5, 55, 25],
  [15, 43, 15, 10, 44, 16],
  [4, 144, 116, 4, 145, 117],
  [17, 68, 42],
  [17, 50, 22, 6, 51, 23],
  [19, 46, 16, 6, 47, 17],
  [2, 139, 111, 7, 140, 112],
  [17, 74, 46],
  [7, 54, 24, 16, 55, 25],
  [34, 37, 13],
  [4, 151, 121, 5, 152, 122],
  [4, 75, 47, 14, 76, 48],
  [11, 54, 24, 14, 55, 25],
  [16, 45, 15, 14, 46, 16],
  [6, 147, 117, 4, 148, 118],
  [6, 73, 45, 14, 74, 46],
  [11, 54, 24, 16, 55, 25],
  [30, 46, 16, 2, 47, 17],
  [8, 132, 106, 4, 133, 107],
  [8, 75, 47, 13, 76, 48],
  [7, 54, 24, 22, 55, 25],
  [22, 45, 15, 13, 46, 16],
  [10, 142, 114, 2, 143, 115],
  [19, 74, 46, 4, 75, 47],
  [28, 50, 22, 6, 51, 23],
  [33, 46, 16, 4, 47, 17],
  [8, 152, 122, 4, 153, 123],
  [22, 73, 45, 3, 74, 46],
  [8, 53, 23, 26, 54, 24],
  [12, 45, 15, 28, 46, 16],
  [3, 147, 117, 10, 148, 118],
  [3, 73, 45, 23, 74, 46],
  [4, 54, 24, 31, 55, 25],
  [11, 45, 15, 31, 46, 16],
  [7, 146, 116, 7, 147, 117],
  [21, 73, 45, 7, 74, 46],
  [1, 53, 23, 37, 54, 24],
  [19, 45, 15, 26, 46, 16],
  [5, 145, 115, 10, 146, 116],
  [19, 75, 47, 10, 76, 48],
  [15, 54, 24, 25, 55, 25],
  [23, 45, 15, 25, 46, 16],
  [13, 145, 115, 3, 146, 116],
  [2, 74, 46, 29, 75, 47],
  [42, 54, 24, 1, 55, 25],
  [23, 45, 15, 28, 46, 16],
  [17, 145, 115],
  [10, 74, 46, 23, 75, 47],
  [10, 54, 24, 35, 55, 25],
  [19, 45, 15, 35, 46, 16],
  [17, 145, 115, 1, 146, 116],
  [14, 74, 46, 21, 75, 47],
  [29, 54, 24, 19, 55, 25],
  [11, 45, 15, 46, 46, 16],
  [13, 145, 115, 6, 146, 116],
  [14, 74, 46, 23, 75, 47],
  [44, 54, 24, 7, 55, 25],
  [59, 46, 16, 1, 47, 17],
  [12, 151, 121, 7, 152, 122],
  [12, 75, 47, 26, 76, 48],
  [39, 54, 24, 14, 55, 25],
  [22, 45, 15, 41, 46, 16],
  [6, 151, 121, 14, 152, 122],
  [6, 75, 47, 34, 76, 48],
  [46, 54, 24, 10, 55, 25],
  [2, 45, 15, 64, 46, 16],
  [17, 152, 122, 4, 153, 123],
  [29, 74, 46, 14, 75, 47],
  [49, 54, 24, 10, 55, 25],
  [24, 45, 15, 46, 46, 16],
  [4, 152, 122, 18, 153, 123],
  [13, 74, 46, 32, 75, 47],
  [48, 54, 24, 14, 55, 25],
  [42, 45, 15, 32, 46, 16],
  [20, 147, 117, 4, 148, 118],
  [40, 75, 47, 7, 76, 48],
  [43, 54, 24, 22, 55, 25],
  [10, 45, 15, 67, 46, 16],
  [19, 148, 118, 6, 149, 119],
  [18, 75, 47, 31, 76, 48],
  [34, 54, 24, 34, 55, 25],
  [20, 45, 15, 61, 46, 16]
];
QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
  if (rsBlock == void 0) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }
  var length = rsBlock.length / 3;
  var list = new Array();
  for (var i = 0; i < length; i++) {
    var count = rsBlock[i * 3 + 0];
    var totalCount = rsBlock[i * 3 + 1];
    var dataCount = rsBlock[i * 3 + 2];
    for (var j2 = 0; j2 < count; j2++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }
  return list;
};
QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case ECL.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
    case ECL.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
    case ECL.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
    case ECL.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
    default:
      return void 0;
  }
};
var RSBlock$1 = QRRSBlock;
function QRBitBuffer() {
  this.buffer = new Array();
  this.length = 0;
}
QRBitBuffer.prototype = {
  get: function(index2) {
    var bufIndex = Math.floor(index2 / 8);
    return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) == 1;
  },
  put: function(num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit((num >>> length - i - 1 & 1) == 1);
    }
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(bit) {
    var bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }
    if (bit) {
      this.buffer[bufIndex] |= 128 >>> this.length % 8;
    }
    this.length++;
  }
};
var BitBuffer$1 = QRBitBuffer;
var QRMath = {
  glog: function(n2) {
    if (n2 < 1) {
      throw new Error("glog(" + n2 + ")");
    }
    return QRMath.LOG_TABLE[n2];
  },
  gexp: function(n2) {
    while (n2 < 0) {
      n2 += 255;
    }
    while (n2 >= 256) {
      n2 -= 255;
    }
    return QRMath.EXP_TABLE[n2];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++) {
  QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}
var math$2 = QRMath;
var math$1 = math$2;
function QRPolynomial(num, shift) {
  if (num.length == void 0) {
    throw new Error(num.length + "/" + shift);
  }
  var offset3 = 0;
  while (offset3 < num.length && num[offset3] == 0) {
    offset3++;
  }
  this.num = new Array(num.length - offset3 + shift);
  for (var i = 0; i < num.length - offset3; i++) {
    this.num[i] = num[i + offset3];
  }
}
QRPolynomial.prototype = {
  get: function(index2) {
    return this.num[index2];
  },
  getLength: function() {
    return this.num.length;
  },
  multiply: function(e2) {
    var num = new Array(this.getLength() + e2.getLength() - 1);
    for (var i = 0; i < this.getLength(); i++) {
      for (var j2 = 0; j2 < e2.getLength(); j2++) {
        num[i + j2] ^= math$1.gexp(math$1.glog(this.get(i)) + math$1.glog(e2.get(j2)));
      }
    }
    return new QRPolynomial(num, 0);
  },
  mod: function(e2) {
    if (this.getLength() - e2.getLength() < 0) {
      return this;
    }
    var ratio = math$1.glog(this.get(0)) - math$1.glog(e2.get(0));
    var num = new Array(this.getLength());
    for (var i = 0; i < this.getLength(); i++) {
      num[i] = this.get(i);
    }
    for (var i = 0; i < e2.getLength(); i++) {
      num[i] ^= math$1.gexp(math$1.glog(e2.get(i)) + ratio);
    }
    return new QRPolynomial(num, 0).mod(e2);
  }
};
var Polynomial$2 = QRPolynomial;
var Mode = mode$1;
var Polynomial$1 = Polynomial$2;
var math = math$2;
var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function(data4) {
    var d2 = data4 << 10;
    while (QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d2 ^= QRUtil.G15 << QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G15);
    }
    return (data4 << 10 | d2) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function(data4) {
    var d2 = data4 << 12;
    while (QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d2 ^= QRUtil.G18 << QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G18);
    }
    return data4 << 12 | d2;
  },
  getBCHDigit: function(data4) {
    var digit = 0;
    while (data4 != 0) {
      digit++;
      data4 >>>= 1;
    }
    return digit;
  },
  getPatternPosition: function(typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function(maskPattern, i, j2) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i + j2) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return i % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return j2 % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (i + j2) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j2 / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return i * j2 % 2 + i * j2 % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (i * j2 % 2 + i * j2 % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (i * j2 % 3 + (i + j2) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function(errorCorrectLength) {
    var a2 = new Polynomial$1([1], 0);
    for (var i = 0; i < errorCorrectLength; i++) {
      a2 = a2.multiply(new Polynomial$1([1, math.gexp(i)], 0));
    }
    return a2;
  },
  getLengthInBits: function(mode2, type) {
    if (1 <= type && type < 10) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 10;
        case Mode.MODE_ALPHA_NUM:
          return 9;
        case Mode.MODE_8BIT_BYTE:
          return 8;
        case Mode.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + mode2);
      }
    } else if (type < 27) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 12;
        case Mode.MODE_ALPHA_NUM:
          return 11;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + mode2);
      }
    } else if (type < 41) {
      switch (mode2) {
        case Mode.MODE_NUMBER:
          return 14;
        case Mode.MODE_ALPHA_NUM:
          return 13;
        case Mode.MODE_8BIT_BYTE:
          return 16;
        case Mode.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + mode2);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function(qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0;
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark = qrCode.isDark(row, col);
        for (var r2 = -1; r2 <= 1; r2++) {
          if (row + r2 < 0 || moduleCount <= row + r2) {
            continue;
          }
          for (var c2 = -1; c2 <= 1; c2++) {
            if (col + c2 < 0 || moduleCount <= col + c2) {
              continue;
            }
            if (r2 == 0 && c2 == 0) {
              continue;
            }
            if (dark == qrCode.isDark(row + r2, col + c2)) {
              sameCount++;
            }
          }
        }
        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    }
    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count = 0;
        if (qrCode.isDark(row, col))
          count++;
        if (qrCode.isDark(row + 1, col))
          count++;
        if (qrCode.isDark(row, col + 1))
          count++;
        if (qrCode.isDark(row + 1, col + 1))
          count++;
        if (count == 0 || count == 4) {
          lostPoint += 3;
        }
      }
    }
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    }
    var darkCount = 0;
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }
    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var util$1 = QRUtil;
var BitByte = _8BitByte;
var RSBlock = RSBlock$1;
var BitBuffer = BitBuffer$1;
var util = util$1;
var Polynomial = Polynomial$2;
function QRCode$1(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
}
var proto = QRCode$1.prototype;
proto.addData = function(data4) {
  var newData = new BitByte(data4);
  this.dataList.push(newData);
  this.dataCache = null;
};
proto.isDark = function(row, col) {
  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
    throw new Error(row + "," + col);
  }
  return this.modules[row][col];
};
proto.getModuleCount = function() {
  return this.moduleCount;
};
proto.make = function() {
  if (this.typeNumber < 1) {
    var typeNumber = 1;
    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
      var buffer = new BitBuffer();
      var totalDataCount = 0;
      for (var i = 0; i < rsBlocks.length; i++) {
        totalDataCount += rsBlocks[i].dataCount;
      }
      for (var i = 0; i < this.dataList.length; i++) {
        var data4 = this.dataList[i];
        buffer.put(data4.mode, 4);
        buffer.put(data4.getLength(), util.getLengthInBits(data4.mode, typeNumber));
        data4.write(buffer);
      }
      if (buffer.getLengthInBits() <= totalDataCount * 8)
        break;
    }
    this.typeNumber = typeNumber;
  }
  this.makeImpl(false, this.getBestMaskPattern());
};
proto.makeImpl = function(test, maskPattern) {
  this.moduleCount = this.typeNumber * 4 + 17;
  this.modules = new Array(this.moduleCount);
  for (var row = 0; row < this.moduleCount; row++) {
    this.modules[row] = new Array(this.moduleCount);
    for (var col = 0; col < this.moduleCount; col++) {
      this.modules[row][col] = null;
    }
  }
  this.setupPositionProbePattern(0, 0);
  this.setupPositionProbePattern(this.moduleCount - 7, 0);
  this.setupPositionProbePattern(0, this.moduleCount - 7);
  this.setupPositionAdjustPattern();
  this.setupTimingPattern();
  this.setupTypeInfo(test, maskPattern);
  if (this.typeNumber >= 7) {
    this.setupTypeNumber(test);
  }
  if (this.dataCache == null) {
    this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  }
  this.mapData(this.dataCache, maskPattern);
};
proto.setupPositionProbePattern = function(row, col) {
  for (var r2 = -1; r2 <= 7; r2++) {
    if (row + r2 <= -1 || this.moduleCount <= row + r2)
      continue;
    for (var c2 = -1; c2 <= 7; c2++) {
      if (col + c2 <= -1 || this.moduleCount <= col + c2)
        continue;
      if (0 <= r2 && r2 <= 6 && (c2 == 0 || c2 == 6) || 0 <= c2 && c2 <= 6 && (r2 == 0 || r2 == 6) || 2 <= r2 && r2 <= 4 && 2 <= c2 && c2 <= 4) {
        this.modules[row + r2][col + c2] = true;
      } else {
        this.modules[row + r2][col + c2] = false;
      }
    }
  }
};
proto.getBestMaskPattern = function() {
  var minLostPoint = 0;
  var pattern = 0;
  for (var i = 0; i < 8; i++) {
    this.makeImpl(true, i);
    var lostPoint = util.getLostPoint(this);
    if (i == 0 || minLostPoint > lostPoint) {
      minLostPoint = lostPoint;
      pattern = i;
    }
  }
  return pattern;
};
proto.createMovieClip = function(target_mc, instance_name, depth) {
  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  var cs = 1;
  this.make();
  for (var row = 0; row < this.modules.length; row++) {
    var y2 = row * cs;
    for (var col = 0; col < this.modules[row].length; col++) {
      var x2 = col * cs;
      var dark = this.modules[row][col];
      if (dark) {
        qr_mc.beginFill(0, 100);
        qr_mc.moveTo(x2, y2);
        qr_mc.lineTo(x2 + cs, y2);
        qr_mc.lineTo(x2 + cs, y2 + cs);
        qr_mc.lineTo(x2, y2 + cs);
        qr_mc.endFill();
      }
    }
  }
  return qr_mc;
};
proto.setupTimingPattern = function() {
  for (var r2 = 8; r2 < this.moduleCount - 8; r2++) {
    if (this.modules[r2][6] != null) {
      continue;
    }
    this.modules[r2][6] = r2 % 2 == 0;
  }
  for (var c2 = 8; c2 < this.moduleCount - 8; c2++) {
    if (this.modules[6][c2] != null) {
      continue;
    }
    this.modules[6][c2] = c2 % 2 == 0;
  }
};
proto.setupPositionAdjustPattern = function() {
  var pos = util.getPatternPosition(this.typeNumber);
  for (var i = 0; i < pos.length; i++) {
    for (var j2 = 0; j2 < pos.length; j2++) {
      var row = pos[i];
      var col = pos[j2];
      if (this.modules[row][col] != null) {
        continue;
      }
      for (var r2 = -2; r2 <= 2; r2++) {
        for (var c2 = -2; c2 <= 2; c2++) {
          if (r2 == -2 || r2 == 2 || c2 == -2 || c2 == 2 || r2 == 0 && c2 == 0) {
            this.modules[row + r2][col + c2] = true;
          } else {
            this.modules[row + r2][col + c2] = false;
          }
        }
      }
    }
  }
};
proto.setupTypeNumber = function(test) {
  var bits = util.getBCHTypeNumber(this.typeNumber);
  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  }
  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
  }
};
proto.setupTypeInfo = function(test, maskPattern) {
  var data4 = this.errorCorrectLevel << 3 | maskPattern;
  var bits = util.getBCHTypeInfo(data4);
  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    if (i < 6) {
      this.modules[i][8] = mod;
    } else if (i < 8) {
      this.modules[i + 1][8] = mod;
    } else {
      this.modules[this.moduleCount - 15 + i][8] = mod;
    }
  }
  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    if (i < 8) {
      this.modules[8][this.moduleCount - i - 1] = mod;
    } else if (i < 9) {
      this.modules[8][15 - i - 1 + 1] = mod;
    } else {
      this.modules[8][15 - i - 1] = mod;
    }
  }
  this.modules[this.moduleCount - 8][8] = !test;
};
proto.mapData = function(data4, maskPattern) {
  var inc = -1;
  var row = this.moduleCount - 1;
  var bitIndex = 7;
  var byteIndex = 0;
  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
    if (col == 6)
      col--;
    while (true) {
      for (var c2 = 0; c2 < 2; c2++) {
        if (this.modules[row][col - c2] == null) {
          var dark = false;
          if (byteIndex < data4.length) {
            dark = (data4[byteIndex] >>> bitIndex & 1) == 1;
          }
          var mask = util.getMask(maskPattern, row, col - c2);
          if (mask) {
            dark = !dark;
          }
          this.modules[row][col - c2] = dark;
          bitIndex--;
          if (bitIndex == -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || this.moduleCount <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};
QRCode$1.PAD0 = 236;
QRCode$1.PAD1 = 17;
QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer = new BitBuffer();
  for (var i = 0; i < dataList.length; i++) {
    var data4 = dataList[i];
    buffer.put(data4.mode, 4);
    buffer.put(data4.getLength(), util.getLengthInBits(data4.mode, typeNumber));
    data4.write(buffer);
  }
  var totalDataCount = 0;
  for (var i = 0; i < rsBlocks.length; i++) {
    totalDataCount += rsBlocks[i].dataCount;
  }
  if (buffer.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  }
  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer.put(0, 4);
  }
  while (buffer.getLengthInBits() % 8 != 0) {
    buffer.putBit(false);
  }
  while (true) {
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer.put(QRCode$1.PAD0, 8);
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer.put(QRCode$1.PAD1, 8);
  }
  return QRCode$1.createBytes(buffer, rsBlocks);
};
QRCode$1.createBytes = function(buffer, rsBlocks) {
  var offset3 = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);
  for (var r2 = 0; r2 < rsBlocks.length; r2++) {
    var dcCount = rsBlocks[r2].dataCount;
    var ecCount = rsBlocks[r2].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r2] = new Array(dcCount);
    for (var i = 0; i < dcdata[r2].length; i++) {
      dcdata[r2][i] = 255 & buffer.buffer[i + offset3];
    }
    offset3 += dcCount;
    var rsPoly = util.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new Polynomial(dcdata[r2], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r2] = new Array(rsPoly.getLength() - 1);
    for (var i = 0; i < ecdata[r2].length; i++) {
      var modIndex = i + modPoly.getLength() - ecdata[r2].length;
      ecdata[r2][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }
  var totalCodeCount = 0;
  for (var i = 0; i < rsBlocks.length; i++) {
    totalCodeCount += rsBlocks[i].totalCount;
  }
  var data4 = new Array(totalCodeCount);
  var index2 = 0;
  for (var i = 0; i < maxDcCount; i++) {
    for (var r2 = 0; r2 < rsBlocks.length; r2++) {
      if (i < dcdata[r2].length) {
        data4[index2++] = dcdata[r2][i];
      }
    }
  }
  for (var i = 0; i < maxEcCount; i++) {
    for (var r2 = 0; r2 < rsBlocks.length; r2++) {
      if (i < ecdata[r2].length) {
        data4[index2++] = ecdata[r2][i];
      }
    }
  }
  return data4;
};
var QRCode_1 = QRCode$1;
var defaultErrorCorrectLevel = "H";
var SUPPORTS_PATH2D = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e2) {
    return false;
  }
  return true;
}();
function QRCode(data4, level) {
  var errorCorrectLevel = ErrorCorrectLevel[level];
  var qrcode = new QRCode_1(-1, errorCorrectLevel);
  qrcode.addData(toUTF8String(data4));
  qrcode.make();
  return qrcode;
}
function validErrorCorrectLevel(level) {
  return level in ErrorCorrectLevel;
}
function toUTF8String(str) {
  var utf8Str = "";
  for (var i = 0; i < str.length; i++) {
    var charCode = str.charCodeAt(i);
    if (charCode < 128) {
      utf8Str += String.fromCharCode(charCode);
    } else if (charCode < 2048) {
      utf8Str += String.fromCharCode(192 | charCode >> 6);
      utf8Str += String.fromCharCode(128 | charCode & 63);
    } else if (charCode < 55296 || charCode >= 57344) {
      utf8Str += String.fromCharCode(224 | charCode >> 12);
      utf8Str += String.fromCharCode(128 | charCode >> 6 & 63);
      utf8Str += String.fromCharCode(128 | charCode & 63);
    } else {
      i++;
      charCode = 65536 + ((charCode & 1023) << 10 | str.charCodeAt(i) & 1023);
      utf8Str += String.fromCharCode(240 | charCode >> 18);
      utf8Str += String.fromCharCode(128 | charCode >> 12 & 63);
      utf8Str += String.fromCharCode(128 | charCode >> 6 & 63);
      utf8Str += String.fromCharCode(128 | charCode & 63);
    }
  }
  return utf8Str;
}
function generatePath(modules, margin) {
  if (margin === void 0) {
    margin = 0;
  }
  var ops = [];
  modules.forEach(function(row, y2) {
    var start = null;
    row.forEach(function(cell, x2) {
      if (!cell && start !== null) {
        ops.push("M" + (start + margin) + " " + (y2 + margin) + "h" + (x2 - start) + "v1H" + (start + margin) + "z");
        start = null;
        return;
      }
      if (x2 === row.length - 1) {
        if (!cell) {
          return;
        }
        if (start === null) {
          ops.push("M" + (x2 + margin) + "," + (y2 + margin) + " h1v1H" + (x2 + margin) + "z");
        } else {
          ops.push("M" + (start + margin) + "," + (y2 + margin) + " h" + (x2 + 1 - start) + "v1H" + (start + margin) + "z");
        }
        return;
      }
      if (cell && start === null) {
        start = x2;
      }
    });
  });
  return ops.join("");
}
var QRCodeProps = {
  value: {
    type: String,
    required: true,
    "default": ""
  },
  size: {
    type: Number,
    "default": 100
  },
  level: {
    type: String,
    "default": defaultErrorCorrectLevel,
    validator: function(l2) {
      return validErrorCorrectLevel(l2);
    }
  },
  background: {
    type: String,
    "default": "#fff"
  },
  foreground: {
    type: String,
    "default": "#000"
  },
  margin: {
    type: Number,
    required: false,
    "default": 0
  }
};
var QRCodeVueProps = __assign(__assign({}, QRCodeProps), { renderAs: {
  type: String,
  required: false,
  "default": "canvas",
  validator: function(as) {
    return ["canvas", "svg"].indexOf(as) > -1;
  }
} });
var QRCodeSvg = defineComponent({
  name: "QRCodeSvg",
  props: QRCodeProps,
  setup: function(props2) {
    var numCells = ref(0);
    var fgPath = ref("");
    var generate2 = function() {
      var value = props2.value, level = props2.level, margin = props2.margin;
      var cells = QRCode(value, level).modules;
      numCells.value = cells.length + margin * 2;
      fgPath.value = generatePath(cells, margin);
    };
    generate2();
    onUpdated(generate2);
    return function() {
      return h$1("svg", {
        width: props2.size,
        height: props2.size,
        "shape-rendering": "crispEdges",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 " + numCells.value + " " + numCells.value
      }, [
        h$1("path", {
          fill: props2.background,
          d: "M0,0 h" + numCells.value + "v" + numCells.value + "H0z"
        }),
        h$1("path", { fill: props2.foreground, d: fgPath.value })
      ]);
    };
  }
});
var QRCodeCanvas = defineComponent({
  name: "QRCodeCanvas",
  props: QRCodeProps,
  setup: function(props2) {
    var canvasEl = ref(null);
    var generate2 = function() {
      var value = props2.value, level = props2.level, size = props2.size, margin = props2.margin, background = props2.background, foreground = props2.foreground;
      var cells = QRCode(value, level).modules;
      var numCells = cells.length + margin * 2;
      var canvas = canvasEl.value;
      if (!canvas) {
        return;
      }
      var ctx = canvas.getContext("2d");
      if (!ctx) {
        return;
      }
      var devicePixelRatio = window.devicePixelRatio || 1;
      var scale = size / numCells * devicePixelRatio;
      canvas.height = canvas.width = size * devicePixelRatio;
      ctx.scale(scale, scale);
      ctx.fillStyle = background;
      ctx.fillRect(0, 0, numCells, numCells);
      ctx.fillStyle = foreground;
      if (SUPPORTS_PATH2D) {
        ctx.fill(new Path2D(generatePath(cells, margin)));
      } else {
        cells.forEach(function(row, rdx) {
          row.forEach(function(cell, cdx) {
            if (cell) {
              ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
            }
          });
        });
      }
    };
    onMounted(generate2);
    onUpdated(generate2);
    return function() {
      return h$1("canvas", {
        ref: canvasEl,
        style: { width: props2.size + "px", height: props2.size + "px" }
      });
    };
  }
});
var QrcodeVue = defineComponent({
  name: "Qrcode",
  render: function() {
    var _a = this.$props, renderAs = _a.renderAs, value = _a.value, _size = _a.size, _margin = _a.margin, _level = _a.level, background = _a.background, foreground = _a.foreground;
    var size = _size >>> 0;
    var margin = _margin >>> 0;
    var level = validErrorCorrectLevel(_level) ? _level : defaultErrorCorrectLevel;
    return h$1(renderAs === "svg" ? QRCodeSvg : QRCodeCanvas, { value, size, margin, level, background, foreground });
  },
  props: QRCodeVueProps
});
var main_vue_vue_type_style_index_0_lang$2 = "";
const _hoisted_1$1 = /* @__PURE__ */ createTextVNode("\u590D\u5236");
const _hoisted_2$1 = { key: 1 };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "text" };
const _hoisted_5 = {
  key: 2,
  class: "no-img"
};
const _hoisted_6 = {
  key: 0,
  class: "top-desc"
};
const _hoisted_7 = /* @__PURE__ */ createTextVNode("\u590D\u5236");
const _hoisted_8 = { key: 2 };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "text" };
const _hoisted_11 = {
  key: 3,
  class: "no-img"
};
const _sfc_main$2 = /* @__PURE__ */ defineComponent({
  props: {
    visible: Boolean,
    title: {
      type: String,
      default: "\u5206\u4EAB"
    },
    dataList: {
      type: Array,
      required: true
    }
  },
  emits: ["update:visible"],
  setup(__props, { emit }) {
    const props2 = __props;
    const innerVisible = computed({
      get: () => props2.visible,
      set: (val) => emit("update:visible", val)
    });
    const activeKey = ref("");
    watch(() => props2.visible, (val) => {
      var _a;
      if (val) {
        activeKey.value = (_a = props2.dataList[0]) == null ? void 0 : _a.name;
      }
    });
    const handleCopy = (val) => {
      navigator.clipboard.writeText(val).then(function() {
        message.success("\u590D\u5236\u6210\u529F");
      }, function() {
        message.error("API \u4E0D\u652F\u6301");
      });
    };
    const isImage = (url) => {
      const list = [".jpg", ".png", "jpeg"];
      if (list.includes(filenameSuffix(url)))
        return true;
      return false;
    };
    return (_ctx, _cache) => {
      const _component_a_input = resolveComponent("a-input");
      const _component_a_button = resolveComponent("a-button");
      const _component_a_input_group = resolveComponent("a-input-group");
      const _component_a_tab_pane = resolveComponent("a-tab-pane");
      const _component_a_tabs = resolveComponent("a-tabs");
      const _component_a_modal = resolveComponent("a-modal");
      return openBlock(), createBlock(_component_a_modal, {
        visible: unref(innerVisible),
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event) => isRef(innerVisible) ? innerVisible.value = $event : null),
        title: __props.title,
        width: "504px",
        class: "yx-share-modal",
        "body-style": {
          height: "383px",
          padding: "16px 24px"
        },
        footer: null
      }, {
        default: withCtx(() => {
          var _a, _b, _c, _d, _e, _f, _g, _h;
          return [
            __props.dataList.length > 1 ? (openBlock(), createBlock(_component_a_tabs, {
              key: 0,
              activeKey: activeKey.value,
              "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event) => activeKey.value = $event),
              type: "card"
            }, {
              default: withCtx(() => [
                (openBlock(true), createElementBlock(Fragment, null, renderList(__props.dataList, (item) => {
                  return openBlock(), createBlock(_component_a_tab_pane, {
                    key: item.name,
                    tab: item.name
                  }, {
                    default: withCtx(() => [
                      item.link ? (openBlock(), createBlock(_component_a_input_group, {
                        key: 0,
                        compact: ""
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_a_input, {
                            value: item.link,
                            prefix: "\u94FE\u63A5",
                            readonly: "",
                            style: { "width": "392px" }
                          }, null, 8, ["value"]),
                          createVNode(_component_a_button, {
                            type: "primary",
                            onClick: ($event) => handleCopy(item.link)
                          }, {
                            default: withCtx(() => [
                              _hoisted_1$1
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)) : createCommentVNode("", true),
                      item.code ? (openBlock(), createElementBlock("div", _hoisted_2$1, [
                        isImage(item.code) ? (openBlock(), createElementBlock("img", {
                          key: 0,
                          src: item.code,
                          class: "code",
                          alt: "code"
                        }, null, 8, _hoisted_3)) : (openBlock(), createBlock(QrcodeVue, {
                          key: 1,
                          class: "code",
                          value: item.link,
                          size: 176,
                          level: "H"
                        }, null, 8, ["value"])),
                        createElementVNode("p", _hoisted_4, toDisplayString(item.desc), 1)
                      ])) : (openBlock(), createElementBlock("div", _hoisted_5, toDisplayString(item.tips), 1))
                    ]),
                    _: 2
                  }, 1032, ["tab"]);
                }), 128))
              ]),
              _: 1
            }, 8, ["activeKey"])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              ((_a = __props.dataList[0]) == null ? void 0 : _a.topDesc) ? (openBlock(), createElementBlock("p", _hoisted_6, toDisplayString(__props.dataList[0].topDesc), 1)) : createCommentVNode("", true),
              ((_b = __props.dataList[0]) == null ? void 0 : _b.link) ? (openBlock(), createBlock(_component_a_input_group, {
                key: 1,
                compact: ""
              }, {
                default: withCtx(() => {
                  var _a2;
                  return [
                    createVNode(_component_a_input, {
                      value: (_a2 = __props.dataList[0]) == null ? void 0 : _a2.link,
                      prefix: "\u94FE\u63A5",
                      readonly: "",
                      style: { "width": "392px" }
                    }, null, 8, ["value"]),
                    createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event) => {
                        var _a3;
                        return handleCopy((_a3 = __props.dataList[0]) == null ? void 0 : _a3.link);
                      })
                    }, {
                      default: withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ];
                }),
                _: 1
              })) : createCommentVNode("", true),
              ((_c = __props.dataList[0]) == null ? void 0 : _c.code) ? (openBlock(), createElementBlock("div", _hoisted_8, [
                isImage((_d = __props.dataList[0]) == null ? void 0 : _d.code) ? (openBlock(), createElementBlock("img", {
                  key: 0,
                  src: (_e = __props.dataList[0]) == null ? void 0 : _e.code,
                  class: "code",
                  alt: "code"
                }, null, 8, _hoisted_9)) : (openBlock(), createBlock(QrcodeVue, {
                  key: 1,
                  class: "code",
                  value: (_f = __props.dataList[0]) == null ? void 0 : _f.link,
                  size: 176,
                  level: "H"
                }, null, 8, ["value"])),
                createElementVNode("p", _hoisted_10, toDisplayString((_g = __props.dataList[0]) == null ? void 0 : _g.desc), 1)
              ])) : (openBlock(), createElementBlock("div", _hoisted_11, toDisplayString((_h = __props.dataList[0]) == null ? void 0 : _h.tips), 1))
            ], 64))
          ];
        }),
        _: 1
      }, 8, ["visible", "title"]);
    };
  }
});
_sfc_main$2.install = function(app) {
  app.component("YxShare", _sfc_main$2);
  return app;
};
var main_vue_vue_type_style_index_0_lang$1 = "";
var _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key2, val] of props2) {
    target[key2] = val;
  }
  return target;
};
const _sfc_main$1 = defineComponent({
  name: "YxVideoPreview",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    src: {
      type: String,
      required: true
    },
    onCancel: Function,
    onConfirm: Function
  },
  setup(props2, { emit }) {
    let player;
    const { src } = toRefs(props2);
    const innerVisible = computed({
      get: () => props2.visible,
      set: (val) => emit("update:visible", val)
    });
    watch(() => props2.visible, (val) => {
      nextTick(() => {
        if (player) {
          player == null ? void 0 : player.destroy();
          player = null;
        }
        if (val)
          init();
      });
    });
    const init = () => {
      if (!src.value)
        return;
      player = new TcPlayer("J_videoPreview", {
        m3u8: src.value,
        width: 768,
        height: 432,
        autoplay: true,
        wording: {
          2032: "\u8BF7\u6C42\u89C6\u9891\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u7F51\u7EDC",
          2048: "\u8BF7\u6C42m3u8\u6587\u4EF6\u5931\u8D25\uFF0C\u53EF\u80FD\u662F\u7F51\u7EDC\u9519\u8BEF\u6216\u8005\u8DE8\u57DF\u95EE\u9898"
        }
      });
    };
    onMounted(() => {
      const videoEl = document.createElement("div");
      videoEl.setAttribute("id", "J_videoPreview");
      document.getElementById("J_video").appendChild(videoEl);
      nextTick(() => {
        init();
      });
    });
    onUnmounted(() => {
      player.destroy();
    });
    return {
      innerVisible
    };
  }
});
const _hoisted_1 = { class: "yx-video-preview" };
const _hoisted_2 = /* @__PURE__ */ createElementVNode("div", {
  id: "J_video",
  class: "yx-video-preview__container"
}, null, -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return withDirectives((openBlock(), createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    createElementVNode("div", {
      class: "close-video",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onCancel && _ctx.onCancel(...args))
    }),
    renderSlot(_ctx.$slots, "default")
  ], 512)), [
    [vShow, _ctx.innerVisible]
  ]);
}
var Preview = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render]]);
Preview.install = function(app) {
  app.component("YxVideoPreview", Preview);
  return app;
};
var components = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  [Symbol.toStringTag]: "Module",
  codeToText,
  regionData,
  YxArea: Area,
  YxList: List,
  YxOperating: Operating,
  YxResult: Result,
  YxShare: _sfc_main$2,
  YxVideoPreview: Preview
});
var main_vue_vue_type_style_index_0_lang = "";
const _sfc_main = /* @__PURE__ */ defineComponent({
  props: {
    title: String,
    content: String,
    cancelText: String,
    okText: String,
    onConfirm: Function,
    onCancel: Function,
    closable: Boolean
  },
  setup(__props, { expose }) {
    expose({
      Modal,
      Button
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Modal), {
        visible: true,
        width: "456px",
        wrapClassName: "yx-dialog-modal",
        keyboard: __props.closable,
        maskClosable: __props.closable,
        closable: __props.closable,
        title: __props.title,
        onCancel: __props.onCancel,
        onOk: __props.onConfirm
      }, {
        footer: withCtx(() => [
          __props.cancelText ? (openBlock(), createBlock(unref(Button), {
            key: 0,
            onClick: __props.onCancel
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.cancelText), 1)
            ]),
            _: 1
          }, 8, ["onClick"])) : createCommentVNode("", true),
          __props.okText ? (openBlock(), createBlock(unref(Button), {
            key: 1,
            type: "primary",
            onClick: __props.onConfirm
          }, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(__props.okText), 1)
            ]),
            _: 1
          }, 8, ["onClick"])) : createCommentVNode("", true)
        ]),
        default: withCtx(() => [
          createTextVNode(toDisplayString(__props.content) + " ", 1)
        ]),
        _: 1
      }, 8, ["keyboard", "maskClosable", "closable", "title", "onCancel", "onOk"]);
    };
  }
});
const _DialogService = class {
  init({ title = "", content = "", cancelText = "", okText = "", closable = true }) {
    const parentNode = document.createElement("div");
    return new Promise((resolve, reject) => {
      _DialogService.instance = createApp(_sfc_main, {
        title,
        content,
        cancelText,
        okText,
        closable,
        onConfirm: () => {
          resolve(true);
          this.destroy(parentNode);
        },
        onCancel: () => {
          reject(false);
          this.destroy(parentNode);
        }
      });
      document.body.appendChild(parentNode);
      _DialogService.instance.mount(parentNode);
    });
  }
  destroy(parentNode) {
    _DialogService.instance.unmount();
    _DialogService.instance = null;
    document.body.removeChild(parentNode);
  }
};
let DialogService = _DialogService;
__publicField(DialogService, "instance");
var showDialog = new DialogService();
const _PreviewService = class {
  init({ src }) {
    if (!src)
      return console.error("\u8BF7\u914D\u7F6E\u9884\u89C8\u5730\u5740\uFF01");
    const parentNode = document.createElement("div");
    const mountNode = document.createElement("div");
    parentNode.appendChild(mountNode);
    _PreviewService.instance = createApp(Preview, {
      src,
      onCancel: () => {
        this.destroy(parentNode);
      }
    });
    document.body.appendChild(parentNode);
    _PreviewService.instance.mount(mountNode);
  }
  destroy(parentNode) {
    _PreviewService.instance.unmount();
    document.body.removeChild(parentNode);
  }
};
let PreviewService = _PreviewService;
__publicField(PreviewService, "instance");
var VideoPreviewService = new PreviewService();
const install = function(app) {
  Object.keys(components).forEach((key2) => {
    const component = components[key2];
    if (component.install) {
      app.use(component);
    }
  });
  app.config.globalProperties.$previewVideo = VideoPreviewService;
  app.config.globalProperties.$showDialog = showDialog;
  return app;
};
var index = {
  install
};
export { Area as YxArea, List as YxList, Operating as YxOperating, Result as YxResult, _sfc_main$2 as YxShare, Preview as YxVideoPreview, codeToText, index as default, install, regionData };
